var product_list = [
  {
    "Ma": "Alfa Romeo",
    "Y": 2020,
    "Mo": "Giulia (4-Türer) Stufenheck | 2020-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2021,
    "Mo": "Giulia (4-Türer) Stufenheck | 2020-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2022,
    "Mo": "Giulia (4-Türer) Stufenheck | 2020-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2016,
    "Mo": "Giulia (4-Türer) Stufenheck | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2017,
    "Mo": "Giulia (4-Türer) Stufenheck | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2018,
    "Mo": "Giulia (4-Türer) Stufenheck | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2019,
    "Mo": "Giulia (4-Türer) Stufenheck | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2023,
    "Mo": "Giulia (4-Türer) Stufenheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2024,
    "Mo": "Giulia (4-Türer) Stufenheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2025,
    "Mo": "Giulia (4-Türer) Stufenheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2026,
    "Mo": "Giulia (4-Türer) Stufenheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2024,
    "Mo": "Junior (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2025,
    "Mo": "Junior (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2026,
    "Mo": "Junior (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2017,
    "Mo": "Stelvio (5-Türer) Crossover | 2017-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2018,
    "Mo": "Stelvio (5-Türer) Crossover | 2017-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2019,
    "Mo": "Stelvio (5-Türer) Crossover | 2017-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2020,
    "Mo": "Stelvio (5-Türer) Crossover | 2020-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2021,
    "Mo": "Stelvio (5-Türer) Crossover | 2020-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2022,
    "Mo": "Stelvio (5-Türer) Crossover | 2020-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2023,
    "Mo": "Stelvio (5-Türer) Crossover | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2024,
    "Mo": "Stelvio (5-Türer) Crossover | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2025,
    "Mo": "Stelvio (5-Türer) Crossover | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2026,
    "Mo": "Stelvio (5-Türer) Crossover | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2022,
    "Mo": "Tonale (5-Türer) SUV | 2022-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2023,
    "Mo": "Tonale (5-Türer) SUV | 2022-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2024,
    "Mo": "Tonale (5-Türer) SUV | 2022-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2025,
    "Mo": "Tonale (5-Türer) SUV | 2022-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2026,
    "Mo": "Tonale (5-Türer) SUV | 2026-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2012,
    "Mo": "A1 Sportback (5-Türer) Schrägheck | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2013,
    "Mo": "A1 Sportback (5-Türer) Schrägheck | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2014,
    "Mo": "A1 Sportback (5-Türer) Schrägheck | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2015,
    "Mo": "A1 Sportback (5-Türer) Schrägheck 8X | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2015,
    "Mo": "A1 Sportback (5-Türer) Schrägheck 8X Facelift | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2016,
    "Mo": "A1 Sportback (5-Türer) Schrägheck | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2017,
    "Mo": "A1 Sportback (5-Türer) Schrägheck | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2018,
    "Mo": "A1 Sportback (5-Türer) Schrägheck | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "A1 Sportback (5-Türer) Schrägheck 8X Facelift | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "A1 Sportback (5-Türer) Schrägheck GB | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "A1 Sportback (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "A1 Sportback (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "A1 Sportback (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "A1 Sportback (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "A1 Sportback (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "A1 Sportback (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2026,
    "Mo": "A1 Sportback (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2008,
    "Mo": "A3 (3-Türer) Schrägheck 8P Facelift | 2008-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2009,
    "Mo": "A3 (3-Türer) Schrägheck | 2008-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2010,
    "Mo": "A3 (3-Türer) Schrägheck | 2008-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2011,
    "Mo": "A3 (3-Türer) Schrägheck | 2008-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2012,
    "Mo": "A3 (3-Türer) Schrägheck | 2008-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2013,
    "Mo": "A3 (3-Türer) Schrägheck | 2008-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2003,
    "Mo": "A3 (3-Türer) Schrägheck | 2003-2008",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2004,
    "Mo": "A3 (3-Türer) Schrägheck | 2003-2008",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2005,
    "Mo": "A3 (3-Türer) Schrägheck | 2003-2008",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2006,
    "Mo": "A3 (3-Türer) Schrägheck | 2003-2008",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2007,
    "Mo": "A3 (3-Türer) Schrägheck | 2003-2008",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2008,
    "Mo": "A3 (3-Türer) Schrägheck 8P | 2003-2008",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2008,
    "Mo": "A3 (5-Türer) Schrägheck 8P Facelift | 2008-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2009,
    "Mo": "A3 (5-Türer) Schrägheck | 2008-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2010,
    "Mo": "A3 (5-Türer) Schrägheck | 2008-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2011,
    "Mo": "A3 (5-Türer) Schrägheck | 2008-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2012,
    "Mo": "A3 (5-Türer) Schrägheck | 2008-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2013,
    "Mo": "A3 (5-Türer) Schrägheck 8P Facelift | 2008-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2004,
    "Mo": "A3 (5-Türer) Schrägheck | 2004-2008",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2005,
    "Mo": "A3 (5-Türer) Schrägheck | 2004-2008",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2006,
    "Mo": "A3 (5-Türer) Schrägheck | 2004-2008",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2007,
    "Mo": "A3 (5-Türer) Schrägheck | 2004-2008",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2008,
    "Mo": "A3 (5-Türer) Schrägheck 8P | 2004-2008",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2016,
    "Mo": "A3 (5-Türer) Schrägheck 8V Facelift | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2017,
    "Mo": "A3 (5-Türer) Schrägheck | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2018,
    "Mo": "A3 (5-Türer) Schrägheck | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "A3 (5-Türer) Schrägheck | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "A3 (5-Türer) Schrägheck 8V Facelift | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2013,
    "Mo": "A3 (5-Türer) Schrägheck 8V | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2014,
    "Mo": "A3 (5-Türer) Schrägheck | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2015,
    "Mo": "A3 (5-Türer) Schrägheck | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2016,
    "Mo": "A3 (5-Türer) Schrägheck 8V | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "A3 (5-Türer) Schrägheck 8Y Facelift | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "A3 (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2026,
    "Mo": "A3 (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "A3 (5-Türer) Schrägheck 8Y | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "A3 (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "A3 (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "A3 (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "A3 (5-Türer) Schrägheck 8Y | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2016,
    "Mo": "A3 Sedan (4-Türer) Stufenheck 8V Facelift | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2017,
    "Mo": "A3 Sedan (4-Türer) Stufenheck | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2018,
    "Mo": "A3 Sedan (4-Türer) Stufenheck | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "A3 Sedan (4-Türer) Stufenheck | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "A3 Sedan (4-Türer) Stufenheck 8V Facelift | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2013,
    "Mo": "A3 Sedan (4-Türer) Stufenheck | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2014,
    "Mo": "A3 Sedan (4-Türer) Stufenheck | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2015,
    "Mo": "A3 Sedan (4-Türer) Stufenheck | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2016,
    "Mo": "A3 Sedan (4-Türer) Stufenheck 8V | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "A3 Sedan (4-Türer) Stufenheck 8Y Facelift | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "A3 Sedan (4-Türer) Stufenheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2026,
    "Mo": "A3 Sedan (4-Türer) Stufenheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "A3 Sedan (4-Türer) Stufenheck 8Y | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "A3 Sedan (4-Türer) Stufenheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "A3 Sedan (4-Türer) Stufenheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "A3 Sedan (4-Türer) Stufenheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "A3 Sedan (4-Türer) Stufenheck 8Y | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2008,
    "Mo": "A4 Sedan (4-Türer) Stufenheck | 2008-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2009,
    "Mo": "A4 Sedan (4-Türer) Stufenheck | 2008-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2010,
    "Mo": "A4 Sedan (4-Türer) Stufenheck | 2008-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2011,
    "Mo": "A4 Sedan (4-Türer) Stufenheck | 2008-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2012,
    "Mo": "A4 Sedan (4-Türer) Stufenheck B8 | 2008-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2012,
    "Mo": "A4 Sedan (4-Türer) Stufenheck B8 Facelift | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2013,
    "Mo": "A4 Sedan (4-Türer) Stufenheck | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2014,
    "Mo": "A4 Sedan (4-Türer) Stufenheck | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2015,
    "Mo": "A4 Sedan (4-Türer) Stufenheck | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "A4 Sedan (4-Türer) Stufenheck B9 Facelift | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "A4 Sedan (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "A4 Sedan (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "A4 Sedan (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "A4 Sedan (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "A4 Sedan (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "A4 Sedan (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2026,
    "Mo": "A4 Sedan (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2016,
    "Mo": "A4 Sedan (4-Türer) Stufenheck | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2017,
    "Mo": "A4 Sedan (4-Türer) Stufenheck | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2018,
    "Mo": "A4 Sedan (4-Türer) Stufenheck | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "A4 Sedan (4-Türer) Stufenheck B9 | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2010,
    "Mo": "A5 Sportback (8T) (5-Türer) Schrägheck | 2010-2011",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2011,
    "Mo": "A5 Sportback (8T) (5-Türer) Schrägheck | 2010-2011",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2012,
    "Mo": "A5 Sportback (8T) (5-Türer) Schrägheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2013,
    "Mo": "A5 Sportback (8T) (5-Türer) Schrägheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2014,
    "Mo": "A5 Sportback (8T) (5-Türer) Schrägheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2015,
    "Mo": "A5 Sportback (8T) (5-Türer) Schrägheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2016,
    "Mo": "A5 Sportback (8T) (5-Türer) Schrägheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2017,
    "Mo": "A5 Sportback (8T) (5-Türer) Schrägheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2017,
    "Mo": "A5 Sportback (5-Türer) Schrägheck | 2017-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2018,
    "Mo": "A5 Sportback (5-Türer) Schrägheck | 2017-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "A5 Sportback (5-Türer) Schrägheck F5 | 2017-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "A5 Sportback (5-Türer) Schrägheck F5 Facelift | 2019-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "A5 Sportback (5-Türer) Schrägheck | 2019-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "A5 Sportback (5-Türer) Schrägheck | 2019-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "A5 Sportback (5-Türer) Schrägheck | 2019-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "A5 Sportback (5-Türer) Schrägheck | 2019-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "A5 Sportback (5-Türer) Schrägheck | 2019-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "A5 Sportback (5-Türer) Schrägheck F5 Facelift | 2019-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "A5 Sportback (5-Türer) Schrägheck FU | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2026,
    "Mo": "A5 Sportback (5-Türer) Schrägheck | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2011,
    "Mo": "A6 Sedan (4-Türer) Stufenheck | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2012,
    "Mo": "A6 Sedan (4-Türer) Stufenheck | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2013,
    "Mo": "A6 Sedan (4-Türer) Stufenheck | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2014,
    "Mo": "A6 Sedan (4-Türer) Stufenheck | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2015,
    "Mo": "A6 Sedan (4-Türer) Stufenheck C7 | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2015,
    "Mo": "A6 Sedan (4-Türer) Stufenheck C7 Facelift | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2016,
    "Mo": "A6 Sedan (4-Türer) Stufenheck | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2017,
    "Mo": "A6 Sedan (4-Türer) Stufenheck | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2018,
    "Mo": "A6 Sedan (4-Türer) Stufenheck C7 Facelift | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2018,
    "Mo": "A6 Sedan (4-Türer) Stufenheck C8 | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "A6 Sedan (4-Türer) Stufenheck | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "A6 Sedan (4-Türer) Stufenheck | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "A6 Sedan (4-Türer) Stufenheck | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "A6 Sedan (4-Türer) Stufenheck | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "A6 Sedan (4-Türer) Stufenheck | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "A6 Sedan (4-Türer) Stufenheck | 2024-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "A6 Sedan (4-Türer) Stufenheck C8 Facelift | 2024-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "A6 Sedan (4-Türer) Stufenheck C9 | 2025-",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2026,
    "Mo": "A6 Sedan (4-Türer) Stufenheck | 2025-",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "A6 e-tron Avant (5-Türer) Kombi | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2026,
    "Mo": "A6 e-tron Avant (5-Türer) Kombi | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "A6 e-tron Sportback (5-Türer) Schrägheck | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2026,
    "Mo": "A6 e-tron Sportback (5-Türer) Schrägheck | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2015,
    "Mo": "A7 Sportback (5-Türer) Schrägheck | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2016,
    "Mo": "A7 Sportback (5-Türer) Schrägheck | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2017,
    "Mo": "A7 Sportback (5-Türer) Schrägheck | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2018,
    "Mo": "A7 Sportback (5-Türer) Schrägheck C7 Facelift | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2011,
    "Mo": "A7 Sportback (5-Türer) Schrägheck | 2011-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2012,
    "Mo": "A7 Sportback (5-Türer) Schrägheck | 2011-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2013,
    "Mo": "A7 Sportback (5-Türer) Schrägheck | 2011-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2014,
    "Mo": "A7 Sportback (5-Türer) Schrägheck | 2011-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "A7 Sportback (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "A7 Sportback (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2026,
    "Mo": "A7 Sportback (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2018,
    "Mo": "A7 Sportback (5-Türer) Schrägheck C8 | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "A7 Sportback (5-Türer) Schrägheck | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "A7 Sportback (5-Türer) Schrägheck | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "A7 Sportback (5-Türer) Schrägheck | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "A7 Sportback (5-Türer) Schrägheck | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "A7 Sportback (5-Türer) Schrägheck | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "e-tron (5-Türer) SUV | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "e-tron (5-Türer) SUV | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "e-tron (5-Türer) SUV | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "e-tron (5-Türer) SUV | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "e-tron (5-Türer) SUV | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "e-tron Sportback (5-Türer) SUV | 2019-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "e-tron Sportback (5-Türer) SUV | 2019-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "e-tron Sportback (5-Türer) SUV | 2019-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "e-tron Sportback (5-Türer) SUV | 2019-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "e-tron Sportback (5-Türer) SUV | 2019-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "e-tron Sportback (5-Türer) SUV | 2019-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "Q2 (5-Türer) Crossover | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "Q2 (5-Türer) Crossover | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "Q2 (5-Türer) Crossover | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "Q2 (5-Türer) Crossover | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q2 (5-Türer) Crossover | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2026,
    "Mo": "Q2 (5-Türer) Crossover | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2017,
    "Mo": "Q2 (5-Türer) Crossover | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2018,
    "Mo": "Q2 (5-Türer) Crossover | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "Q2 (5-Türer) Crossover | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "Q2 (5-Türer) Crossover | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "Q3 Sportback (5-Türer) SUV | 2020-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "Q3 Sportback (5-Türer) SUV | 2020-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "Q3 Sportback (5-Türer) SUV | 2020-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "Q3 Sportback (5-Türer) SUV | 2020-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "Q3 Sportback (5-Türer) SUV | 2020-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q3 Sportback (5-Türer) SUV | 2020-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2026,
    "Mo": "Q3 Sportback (5-Türer) SUV F3 | 2020-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2026,
    "Mo": "Q3 Sportback (5-Türer) SUV FJ | 2026-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "Q4 Sportback e-tron (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "Q4 Sportback e-tron (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "Q4 Sportback e-tron (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "Q4 Sportback e-tron (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q4 Sportback e-tron (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2026,
    "Mo": "Q4 Sportback e-tron (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "Q5 Sportback (5-Türer) SUV | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "Q5 Sportback (5-Türer) SUV | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "Q5 Sportback (5-Türer) SUV | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "Q5 Sportback (5-Türer) SUV | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q5 Sportback (5-Türer) SUV FY Facelift | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q5 Sportback (5-Türer) SUV GU | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2026,
    "Mo": "Q5 Sportback (5-Türer) SUV | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q6 Sportback e-tron (5-Türer) SUV | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2026,
    "Mo": "Q6 Sportback e-tron (5-Türer) SUV | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "Q8 e-tron (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "Q8 e-tron (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q8 e-tron (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2026,
    "Mo": "Q8 e-tron (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "Q8 Sportback e-tron (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "Q8 Sportback e-tron (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q8 Sportback e-tron (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2026,
    "Mo": "Q8 Sportback e-tron (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "2 Series Active Tourer (F45) (5-Türer) MPV | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "2 Series Active Tourer (F45) (5-Türer) MPV | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "2 Series Active Tourer (F45) (5-Türer) MPV | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "2 Series Active Tourer (F45) (5-Türer) MPV | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "2 Series Active Tourer (F45 LCI) (5-Türer) MPV | 2019-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "2 Series Active Tourer (F45 LCI) (5-Türer) MPV | 2019-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "2 Series Active Tourer (F45 LCI) (5-Türer) MPV | 2019-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "2 Series Active Tourer (F45 LCI) (5-Türer) MPV | 2019-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "2 Series Active Tourer (U06) (5-Türer) MPV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "2 Series Active Tourer (U06) (5-Türer) MPV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "2 Series Active Tourer (U06) (5-Türer) MPV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "2 Series Active Tourer (U06) (5-Türer) MPV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2026,
    "Mo": "2 Series Active Tourer (U06) (5-Türer) MPV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "2 Series Gran Tourer (F46) (5-Türer) MPV | 2016-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "2 Series Gran Tourer (F46) (5-Türer) MPV | 2016-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "2 Series Gran Tourer (F46) (5-Türer) MPV | 2016-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "2 Series Gran Tourer (F46 LCI) (5-Türer) MPV | 2019-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "2 Series Gran Tourer (F46 LCI) (5-Türer) MPV | 2019-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "2 Series Gran Tourer (F46 LCI) (5-Türer) MPV | 2019-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "2 Series Gran Tourer (F46 LCI) (5-Türer) MPV | 2019-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "X1 (F48) (5-Türer) SUV | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "X1 (F48) (5-Türer) SUV | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "X1 (F48) (5-Türer) SUV | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "X1 (F48) (5-Türer) SUV | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "X1 (F48 LCI) (5-Türer) SUV | 2020-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "X1 (F48 LCI) (5-Türer) SUV | 2020-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "X1 (F48 LCI) (5-Türer) SUV | 2020-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "X1 (U11) (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "X1 (U11) (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "X1 (U11) (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2026,
    "Mo": "X1 (U11) (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "X2 (F39) (5-Türer) SUV | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "X2 (F39) (5-Türer) SUV | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "X2 (F39) (5-Türer) SUV | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "X2 (F39) (5-Türer) SUV | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "X2 (F39) (5-Türer) SUV | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "X2 (F39) (5-Türer) SUV | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "X2 (U10) (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "X2 (U10) (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2026,
    "Mo": "X2 (U10) (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "X4 (F26) (5-Türer) SUV | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "X4 (F26) (5-Türer) SUV | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "X4 (F26) (5-Türer) SUV | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "X4 (F26) (5-Türer) SUV | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "X6 (F16) (5-Türer) SUV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "X6 (F16) (5-Türer) SUV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "X6 (F16) (5-Türer) SUV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "X6 (F16) (5-Türer) SUV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "X6 (F16) (5-Türer) SUV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Y": 2021,
    "Mo": "Dolphin (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Y": 2022,
    "Mo": "Dolphin (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Y": 2023,
    "Mo": "Dolphin (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Y": 2024,
    "Mo": "Dolphin (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Y": 2025,
    "Mo": "Dolphin (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Y": 2026,
    "Mo": "Dolphin (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Y": 2022,
    "Mo": "Han (4-Türer) Stufenheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Y": 2023,
    "Mo": "Han (4-Türer) Stufenheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Y": 2024,
    "Mo": "Han (4-Türer) Stufenheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Y": 2025,
    "Mo": "Han (4-Türer) Stufenheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Y": 2026,
    "Mo": "Han (4-Türer) Stufenheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Y": 2022,
    "Mo": "Seal (4-Türer) Stufenheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Y": 2023,
    "Mo": "Seal (4-Türer) Stufenheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Y": 2024,
    "Mo": "Seal (4-Türer) Stufenheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Y": 2025,
    "Mo": "Seal (4-Türer) Stufenheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Y": 2026,
    "Mo": "Seal (4-Türer) Stufenheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Y": 2024,
    "Mo": "Sealion 7 (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Y": 2025,
    "Mo": "Sealion 7 (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Y": 2026,
    "Mo": "Sealion 7 (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2018,
    "Mo": "C1 (5-Türer) Schrägheck 2nd Generation Facelift | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2019,
    "Mo": "C1 (5-Türer) Schrägheck | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2020,
    "Mo": "C1 (5-Türer) Schrägheck | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2021,
    "Mo": "C1 (5-Türer) Schrägheck | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2022,
    "Mo": "C1 (5-Türer) Schrägheck | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "C1 (5-Türer) Schrägheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2015,
    "Mo": "C1 (5-Türer) Schrägheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "C1 (5-Türer) Schrägheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2017,
    "Mo": "C1 (5-Türer) Schrägheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2018,
    "Mo": "C1 (5-Türer) Schrägheck 2nd Generation | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "C3 (5-Türer) Schrägheck 4th Generation | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2025,
    "Mo": "C3 (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2026,
    "Mo": "C3 (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "C3 (5-Türer) Schrägheck | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2017,
    "Mo": "C3 (5-Türer) Schrägheck | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2018,
    "Mo": "C3 (5-Türer) Schrägheck | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2019,
    "Mo": "C3 (5-Türer) Schrägheck | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2020,
    "Mo": "C3 (5-Türer) Schrägheck SX/SY | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2020,
    "Mo": "C3 (5-Türer) Schrägheck SX/SY Facelift | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2021,
    "Mo": "C3 (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2022,
    "Mo": "C3 (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2023,
    "Mo": "C3 (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "C3 (5-Türer) Schrägheck SX/SY Facelift | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "С3 Van (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2025,
    "Mo": "С3 Van (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2026,
    "Mo": "С3 Van (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "C3 Aircross (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2025,
    "Mo": "C3 Aircross (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2026,
    "Mo": "C3 Aircross (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2020,
    "Mo": "C4 (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2021,
    "Mo": "C4 (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2022,
    "Mo": "C4 (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2023,
    "Mo": "C4 (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "C4 (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2025,
    "Mo": "C4 (5-Türer) Schrägheck | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2026,
    "Mo": "C4 (5-Türer) Schrägheck | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2015,
    "Mo": "C4 (5-Türer) Schrägheck Typ N Facelift | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "C4 (5-Türer) Schrägheck | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2017,
    "Mo": "C4 (5-Türer) Schrägheck | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2018,
    "Mo": "C4 (5-Türer) Schrägheck | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "C4 (5-Türer) Schrägheck Typ N | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2011,
    "Mo": "C4 (5-Türer) Schrägheck | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "C4 (5-Türer) Schrägheck | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "C4 (5-Türer) Schrägheck | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "C4 (5-Türer) Schrägheck | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2015,
    "Mo": "C4 (5-Türer) Schrägheck Typ N | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2022,
    "Mo": "C4 Sedan (4-Türer) Stufenheck | 2022-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2023,
    "Mo": "C4 Sedan (4-Türer) Stufenheck | 2022-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "C4 Sedan (4-Türer) Stufenheck | 2022-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2025,
    "Mo": "C4 Sedan (4-Türer) Stufenheck | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2026,
    "Mo": "C4 Sedan (4-Türer) Stufenheck | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "C4 Picasso (5-Türer) MPV 2nd Generation Facelift | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2017,
    "Mo": "C4 Picasso (5-Türer) MPV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2018,
    "Mo": "C4 Picasso (5-Türer) MPV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2019,
    "Mo": "C4 Picasso (5-Türer) MPV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2020,
    "Mo": "C4 Picasso (5-Türer) MPV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2021,
    "Mo": "C4 Picasso (5-Türer) MPV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2022,
    "Mo": "C4 Picasso (5-Türer) MPV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2023,
    "Mo": "C4 Picasso (5-Türer) MPV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "C4 Picasso (5-Türer) MPV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2025,
    "Mo": "C4 Picasso (5-Türer) MPV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2026,
    "Mo": "C4 Picasso (5-Türer) MPV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "C4 Picasso (5-Türer) MPV 2nd Generation | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "C4 Picasso (5-Türer) MPV | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2015,
    "Mo": "C4 Picasso (5-Türer) MPV | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "C4 Picasso (5-Türer) MPV 2nd Generation | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "Grand C4 Picasso (5-Türer) MPV 2nd Generation Facelift | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2017,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2018,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2019,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2020,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2021,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2022,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2023,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2025,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2026,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "Grand C4 Picasso (5-Türer) MPV 2nd Generation | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2015,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "Grand C4 Picasso (5-Türer) MPV 2nd Generation | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "Grand C4 Picasso (5-Türer) MPV 2nd Generation Facelift | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2017,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2018,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2019,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2020,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2021,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2022,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2023,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2025,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2026,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "Grand C4 Picasso (5-Türer) MPV 2nd Generation | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2015,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "Grand C4 Picasso (5-Türer) MPV 2nd Generation | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2021,
    "Mo": "C5 X (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2022,
    "Mo": "C5 X (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2023,
    "Mo": "C5 X (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "C5 X (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2025,
    "Mo": "C5 X (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2026,
    "Mo": "C5 X (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2025,
    "Mo": "C5 Aircross (5-Türer) SUV | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2026,
    "Mo": "C5 Aircross (5-Türer) SUV | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2013,
    "Mo": "Cruze Hatchback (J305) (5-Türer) Schrägheck J300 1st Facelift | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2014,
    "Mo": "Cruze Hatchback (J305) (5-Türer) Schrägheck J300 1st Facelift | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2015,
    "Mo": "Cruze Hatchback (J305) (5-Türer) Schrägheck J300 1st Facelift | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2016,
    "Mo": "Cruze Hatchback (J305) (5-Türer) Schrägheck J300 1st Facelift | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2015,
    "Mo": "Cruze Hatchback (J305) (5-Türer) Schrägheck J300 2nd Facelift | 2015-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2016,
    "Mo": "Cruze Hatchback (J305) (5-Türer) Schrägheck J300 2nd Facelift | 2015-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2017,
    "Mo": "Cruze Hatchback (J305) (5-Türer) Schrägheck | 2015-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2011,
    "Mo": "Cruze Hatchback (J305) (5-Türer) Schrägheck | 2011-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2012,
    "Mo": "Cruze Hatchback (J305) (5-Türer) Schrägheck | 2011-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2013,
    "Mo": "Cruze Hatchback (J305) (5-Türer) Schrägheck J300 | 2011-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2014,
    "Mo": "Cruze Hatchback (J305) (5-Türer) Schrägheck J300 | 2011-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2013,
    "Mo": "Cruze Sedan (J300) (4-Türer) Stufenheck J300 1st Facelift | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2014,
    "Mo": "Cruze Sedan (J300) (4-Türer) Stufenheck J300 1st Facelift | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2015,
    "Mo": "Cruze Sedan (J300) (4-Türer) Stufenheck | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2016,
    "Mo": "Cruze Sedan (J300) (4-Türer) Stufenheck | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2009,
    "Mo": "Cruze Sedan (J300) (4-Türer) Stufenheck | 2009-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2010,
    "Mo": "Cruze Sedan (J300) (4-Türer) Stufenheck | 2009-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2011,
    "Mo": "Cruze Sedan (J300) (4-Türer) Stufenheck | 2009-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2012,
    "Mo": "Cruze Sedan (J300) (4-Türer) Stufenheck | 2009-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2013,
    "Mo": "Cruze Sedan (J300) (4-Türer) Stufenheck J300 | 2009-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2014,
    "Mo": "Cruze Sedan (J300) (4-Türer) Stufenheck J300 | 2009-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2016,
    "Mo": "Malibu (4-Türer) Stufenheck | 2016-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2017,
    "Mo": "Malibu (4-Türer) Stufenheck | 2016-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2018,
    "Mo": "Malibu (4-Türer) Stufenheck | 2016-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2019,
    "Mo": "Malibu (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2020,
    "Mo": "Malibu (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2021,
    "Mo": "Malibu (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2022,
    "Mo": "Malibu (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2023,
    "Mo": "Malibu (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2024,
    "Mo": "Malibu (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2025,
    "Mo": "Malibu (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2026,
    "Mo": "Malibu (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2014,
    "Mo": "Silverado 1500 Crew Cab (4-Türer) Pickup | 2014-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2015,
    "Mo": "Silverado 1500 Crew Cab (4-Türer) Pickup | 2014-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2016,
    "Mo": "Silverado 1500 Crew Cab (4-Türer) Pickup | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2017,
    "Mo": "Silverado 1500 Crew Cab (4-Türer) Pickup | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2018,
    "Mo": "Silverado 1500 Crew Cab (4-Türer) Pickup | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2019,
    "Mo": "Silverado 1500 Crew Cab (4-Türer) Pickup | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2014,
    "Mo": "Silverado 1500 Double Cab (4-Türer) Pickup | 2014-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2015,
    "Mo": "Silverado 1500 Double Cab (4-Türer) Pickup | 2014-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2016,
    "Mo": "Silverado 1500 Double Cab (4-Türer) Pickup | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2017,
    "Mo": "Silverado 1500 Double Cab (4-Türer) Pickup | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2018,
    "Mo": "Silverado 1500 Double Cab (4-Türer) Pickup | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2019,
    "Mo": "Silverado 1500 Double Cab (4-Türer) Pickup | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2020,
    "Mo": "Silverado 2500 HD Crew Cab (4-Türer) Pickup | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2021,
    "Mo": "Silverado 2500 HD Crew Cab (4-Türer) Pickup | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2022,
    "Mo": "Silverado 2500 HD Crew Cab (4-Türer) Pickup | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2023,
    "Mo": "Silverado 2500 HD Crew Cab (4-Türer) Pickup | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2024,
    "Mo": "Silverado 2500 HD Crew Cab (4-Türer) Pickup | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2025,
    "Mo": "Silverado 2500 HD Crew Cab (4-Türer) Pickup | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2026,
    "Mo": "Silverado 2500 HD Crew Cab (4-Türer) Pickup | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2020,
    "Mo": "Silverado 2500 HD Double Cab (4-Türer) Pickup | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2021,
    "Mo": "Silverado 2500 HD Double Cab (4-Türer) Pickup | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2022,
    "Mo": "Silverado 2500 HD Double Cab (4-Türer) Pickup | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2023,
    "Mo": "Silverado 2500 HD Double Cab (4-Türer) Pickup | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CUPRA",
    "Y": 2024,
    "Mo": "Leon (5-Türer) Schrägheck 1st Generation Facelift | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CUPRA",
    "Y": 2025,
    "Mo": "Leon (5-Türer) Schrägheck 1st Generation Facelift | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CUPRA",
    "Y": 2026,
    "Mo": "Leon (5-Türer) Schrägheck 1st Generation Facelift | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CUPRA",
    "Y": 2020,
    "Mo": "Leon (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CUPRA",
    "Y": 2021,
    "Mo": "Leon (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CUPRA",
    "Y": 2022,
    "Mo": "Leon (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CUPRA",
    "Y": 2023,
    "Mo": "Leon (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CUPRA",
    "Y": 2024,
    "Mo": "Leon (5-Türer) Schrägheck 1st Generation | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CUPRA",
    "Y": 2025,
    "Mo": "Leon (5-Türer) Schrägheck 1st Generation | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CUPRA",
    "Y": 2026,
    "Mo": "Leon (5-Türer) Schrägheck 1st Generation | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CUPRA",
    "Y": 2024,
    "Mo": "Tavascan (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CUPRA",
    "Y": 2025,
    "Mo": "Tavascan (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CUPRA",
    "Y": 2026,
    "Mo": "Tavascan (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Cadillac",
    "Y": 2023,
    "Mo": "LYRIQ (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Cadillac",
    "Y": 2024,
    "Mo": "LYRIQ (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Cadillac",
    "Y": 2025,
    "Mo": "LYRIQ (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Cadillac",
    "Y": 2026,
    "Mo": "LYRIQ (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Cadillac",
    "Y": 2025,
    "Mo": "OPTIQ (5-Türer) SUV | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Cadillac",
    "Y": 2026,
    "Mo": "OPTIQ (5-Türer) SUV | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2026,
    "Mo": "Logan (4-Türer) Stufenheck 3rd Generation Facelift | 2026-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2021,
    "Mo": "Logan (4-Türer) Stufenheck | 2021-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2022,
    "Mo": "Logan (4-Türer) Stufenheck | 2021-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2023,
    "Mo": "Logan (4-Türer) Stufenheck | 2021-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2024,
    "Mo": "Logan (4-Türer) Stufenheck | 2021-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2025,
    "Mo": "Logan (4-Türer) Stufenheck | 2021-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2026,
    "Mo": "Logan (4-Türer) Stufenheck 3rd Generation | 2021-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2021,
    "Mo": "Sandero (5-Türer) Schrägheck 3rd Generation | 2021-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2022,
    "Mo": "Sandero (5-Türer) Schrägheck | 2021-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2023,
    "Mo": "Sandero (5-Türer) Schrägheck | 2021-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2024,
    "Mo": "Sandero (5-Türer) Schrägheck | 2021-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2025,
    "Mo": "Sandero (5-Türer) Schrägheck | 2021-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2026,
    "Mo": "Sandero (5-Türer) Schrägheck 3rd Generation | 2021-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2026,
    "Mo": "Sandero (5-Türer) Schrägheck 3rd Generation Facelift | 2026-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Arteon (3H8) (5-Türer) Schrägheck | 2021-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Arteon (3H8) (5-Türer) Schrägheck | 2021-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Arteon (3H8) (5-Türer) Schrägheck | 2021-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Arteon (3H7) (5-Türer) Schrägheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Arteon (3H7) (5-Türer) Schrägheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Arteon (3H7) (5-Türer) Schrägheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Arteon (3H7) (5-Türer) Schrägheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Arteon Shooting Brake (3H9) (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "CC 4-seater (358) (4-Türer) Coupe | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "CC 4-seater (358) (4-Türer) Coupe | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "CC 4-seater (358) (4-Türer) Coupe | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "CC 4-seater (358) (4-Türer) Coupe | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "CC 4-seater (358) (4-Türer) Coupe | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "CC 4-seater (357) (4-Türer) Coupe | 2008-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "CC 4-seater (357) (4-Türer) Coupe | 2008-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "CC 4-seater (357) (4-Türer) Coupe | 2008-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "CC 4-seater (357) (4-Türer) Coupe | 2008-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "CC 4-seater (357) (4-Türer) Coupe | 2008-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "CC 5-seater (357) (4-Türer) Coupe | 2010-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "CC 5-seater (357) (4-Türer) Coupe | 2010-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "CC 5-seater (357) (4-Türer) Coupe | 2010-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "CC 5-seater (358) (4-Türer) Coupe | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "CC 5-seater (358) (4-Türer) Coupe | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "CC 5-seater (358) (4-Türer) Coupe | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "CC 5-seater (358) (4-Türer) Coupe | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "CC 5-seater (358) (4-Türer) Coupe | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Gol (5-Türer) Schrägheck | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Gol (5-Türer) Schrägheck | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Gol (5-Türer) Schrägheck | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Gol (5-Türer) Schrägheck | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Gol (5-Türer) Schrägheck | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Gol (5-Türer) Schrägheck | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Gol (5-Türer) Schrägheck | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Gol (5-Türer) Schrägheck | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Gol (5-Türer) Schrägheck | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Gol (5-Türer) Schrägheck | 2009-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Gol (5-Türer) Schrägheck | 2009-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Gol (5-Türer) Schrägheck | 2009-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Gol (5-Türer) Schrägheck | 2009-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Golf (5G1) (3-Türer) Schrägheck | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Golf (5G1) (3-Türer) Schrägheck | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Golf (5G1) (3-Türer) Schrägheck | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Golf (5G1) (3-Türer) Schrägheck | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Golf (5G1) (3-Türer) Schrägheck | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Golf (BQ1) (3-Türer) Schrägheck | 2017-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Golf (BQ1) (3-Türer) Schrägheck | 2017-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Golf (BQ1) (3-Türer) Schrägheck | 2017-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Golf (5K1) (3-Türer) Schrägheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Golf (5K1) (3-Türer) Schrägheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Golf (5K1) (3-Türer) Schrägheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Golf (5K1) (3-Türer) Schrägheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Golf (5K1) (3-Türer) Schrägheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Golf (5G1) (5-Türer) Schrägheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Golf (5G1) (5-Türer) Schrägheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Golf (5G1) (5-Türer) Schrägheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Golf (5G1) (5-Türer) Schrägheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Golf (5G1) (5-Türer) Schrägheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Golf (5G1) (5-Türer) Schrägheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Golf (BQ1) (5-Türer) Schrägheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Golf (BQ1) (5-Türer) Schrägheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Golf (BQ1) (5-Türer) Schrägheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Golf (BQ1) (5-Türer) Schrägheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Golf (5K1) (5-Türer) Schrägheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Golf (5K1) (5-Türer) Schrägheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Golf (5K1) (5-Türer) Schrägheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Golf (5K1) (5-Türer) Schrägheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Golf (5K1) (5-Türer) Schrägheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Golf (CD1) (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Golf (CD1) (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Golf (CD1) (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Golf (CD1) (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Golf (CD1) (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Golf (DA1) (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Golf (DA1) (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Golf (DA1) (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Golf Sportsvan (AN1) (5-Türer) Schrägheck | 2018-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Golf Sportsvan (AN1) (5-Türer) Schrägheck | 2018-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Golf Sportsvan (AN1) (5-Türer) Schrägheck | 2018-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Golf Sportsvan (AM1) (5-Türer) Schrägheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Golf Sportsvan (AM1) (5-Türer) Schrägheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Golf Sportsvan (AM1) (5-Türer) Schrägheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Golf Sportsvan (AM1) (5-Türer) Schrägheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Golf Sportsvan (AM1) (5-Türer) Schrägheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "ID.7 (ED2) (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "ID.7 (ED2) (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "ID.7 (ED2) (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Jetta (163) (4-Türer) Stufenheck | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Jetta (163) (4-Türer) Stufenheck | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Jetta (163) (4-Türer) Stufenheck | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Jetta (163) (4-Türer) Stufenheck | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Jetta (162) (4-Türer) Stufenheck | 2011-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Jetta (162) (4-Türer) Stufenheck | 2011-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Jetta (162) (4-Türer) Stufenheck | 2011-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Jetta (162) (4-Türer) Stufenheck | 2011-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Passat (362) (4-Türer) Stufenheck | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Passat (362) (4-Türer) Stufenheck | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Passat (362) (4-Türer) Stufenheck | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Passat (362) (4-Türer) Stufenheck | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Passat (362) (4-Türer) Stufenheck | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Passat (3C2) (4-Türer) Stufenheck | 2006-2010",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Passat (3C2) (4-Türer) Stufenheck | 2006-2010",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Passat (3C2) (4-Türer) Stufenheck | 2006-2010",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Passat (3C2) (4-Türer) Stufenheck | 2006-2010",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Passat (3C2) (4-Türer) Stufenheck | 2006-2010",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Passat (CB2) (4-Türer) Stufenheck | 2020-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Passat (CB2) (4-Türer) Stufenheck | 2020-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Passat (CB2) (4-Türer) Stufenheck | 2020-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Passat (3G2) (4-Türer) Stufenheck | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Passat (3G2) (4-Türer) Stufenheck | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Passat (3G2) (4-Türer) Stufenheck | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Passat (3G2) (4-Türer) Stufenheck | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Passat (3G2) (4-Türer) Stufenheck | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Polo (6C1) (5-Türer) Schrägheck | 2015-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Polo (6C1) (5-Türer) Schrägheck | 2015-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Polo (6C1) (5-Türer) Schrägheck | 2015-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Polo (5-Türer) Schrägheck | 2010-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Polo (5-Türer) Schrägheck | 2010-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Polo (5-Türer) Schrägheck | 2010-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Polo (5-Türer) Schrägheck | 2010-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Polo (5-Türer) Schrägheck | 2010-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Polo (9N3) (5-Türer) Schrägheck | 2006-2010",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Polo (9N3) (5-Türer) Schrägheck | 2006-2010",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Polo (9N3) (5-Türer) Schrägheck | 2006-2010",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Polo (9N3) (5-Türer) Schrägheck | 2006-2010",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Polo (9N3) (5-Türer) Schrägheck | 2006-2010",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2002,
    "Mo": "Polo (5-Türer) Schrägheck | 2002-2005",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Polo (5-Türer) Schrägheck | 2002-2005",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Polo (5-Türer) Schrägheck | 2002-2005",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Polo (5-Türer) Schrägheck | 2002-2005",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Polo (5-Türer) Schrägheck | 2018-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Polo (5-Türer) Schrägheck | 2018-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Polo (5-Türer) Schrägheck | 2018-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Polo (5-Türer) Schrägheck | 2018-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Polo (AE1) (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Polo (AE1) (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Polo (AE1) (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Polo (AE1) (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Polo (AE1) (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "T-Cross (C11) (5-Türer) SUV | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "T-Cross (C11) (5-Türer) SUV | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "T-Cross (C11) (5-Türer) SUV | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "T-Cross (C11) (5-Türer) SUV | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "T-Cross (C11) (5-Türer) SUV | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "T-Cross (D31) (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "T-Cross (D31) (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "T-Cross (D31) (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "T-Roc (D11) (5-Türer) SUV | 2022-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "T-Roc (D11) (5-Türer) SUV | 2022-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "T-Roc (D11) (5-Türer) SUV | 2022-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "T-Roc (D11) (5-Türer) SUV | 2022-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "T-Roc (D11) (5-Türer) SUV | 2022-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "T-Roc (A11) (5-Türer) SUV | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "T-Roc (A11) (5-Türer) SUV | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "T-Roc (A11) (5-Türer) SUV | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "T-Roc (A11) (5-Türer) SUV | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "T-Roc (A11) (5-Türer) SUV | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Taigo (CS1) (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Taigo (CS1) (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Taigo (CS1) (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Taigo (CS1) (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Taigo (CS1) (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "up! (122) (3-Türer) Schrägheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "up! (122) (3-Türer) Schrägheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "up! (122) (3-Türer) Schrägheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "up! (122) (3-Türer) Schrägheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "up! (123) (3-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "up! (123) (3-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "up! (123) (3-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "up! (123) (3-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "up! (123) (3-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "up! (121) (3-Türer) Schrägheck | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "up! (121) (3-Türer) Schrägheck | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "up! (121) (3-Türer) Schrägheck | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "up! (121) (3-Türer) Schrägheck | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "up! (121) (3-Türer) Schrägheck | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "up! (122/BL2) (5-Türer) Schrägheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "up! (122/BL2) (5-Türer) Schrägheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "up! (122/BL2) (5-Türer) Schrägheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "up! (122/BL2) (5-Türer) Schrägheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "up! (123/BL3) (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "up! (123/BL3) (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "up! (123/BL3) (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "up! (123/BL3) (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "up! (123/BL3) (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "up! (121/BL1) (5-Türer) Schrägheck | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "up! (121/BL1) (5-Türer) Schrägheck | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "up! (121/BL1) (5-Türer) Schrägheck | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "up! (121/BL1) (5-Türer) Schrägheck | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "up! (121/BL1) (5-Türer) Schrägheck | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Virtus (BZ1) (4-Türer) Stufenheck | 2020-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Virtus (BZ1) (4-Türer) Stufenheck | 2020-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Virtus (BZ1) (4-Türer) Stufenheck | 2020-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Virtus (D22) (4-Türer) Stufenheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Virtus (D22) (4-Türer) Stufenheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Virtus (D22) (4-Türer) Stufenheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Virtus (D22) (4-Türer) Stufenheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2022,
    "Mo": "C40 (539) (5-Türer) SUV | 2022-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2023,
    "Mo": "C40 (539) (5-Türer) SUV | 2022-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2024,
    "Mo": "C40 (539) (5-Türer) SUV | 2022-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2024,
    "Mo": "EX30 (416) (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2025,
    "Mo": "EX30 (416) (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2026,
    "Mo": "EX30 (416) (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2014,
    "Mo": "S60 (134) (4-Türer) Stufenheck | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2015,
    "Mo": "S60 (134) (4-Türer) Stufenheck | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2016,
    "Mo": "S60 (134) (4-Türer) Stufenheck | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2017,
    "Mo": "S60 (134) (4-Türer) Stufenheck | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2018,
    "Mo": "S60 (134) (4-Türer) Stufenheck | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2019,
    "Mo": "S60 (134) (4-Türer) Stufenheck | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2010,
    "Mo": "S60 (134) (4-Türer) Stufenheck | 2010-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2011,
    "Mo": "S60 (134) (4-Türer) Stufenheck | 2010-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2012,
    "Mo": "S60 (134) (4-Türer) Stufenheck | 2010-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2013,
    "Mo": "S60 (134) (4-Türer) Stufenheck | 2010-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2019,
    "Mo": "S60 (224) (4-Türer) Stufenheck | 2019-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2020,
    "Mo": "S60 (224) (4-Türer) Stufenheck | 2019-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2021,
    "Mo": "S60 (224) (4-Türer) Stufenheck | 2019-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2022,
    "Mo": "S60 (224) (4-Türer) Stufenheck | 2019-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2023,
    "Mo": "S60 (224) (4-Türer) Stufenheck | 2019-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2024,
    "Mo": "S60 (224) (4-Türer) Stufenheck | 2019-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2015,
    "Mo": "S60 Cross Country (134) (4-Türer) Stufenheck | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2016,
    "Mo": "S60 Cross Country (134) (4-Türer) Stufenheck | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2017,
    "Mo": "S60 Cross Country (134) (4-Türer) Stufenheck | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2018,
    "Mo": "S60 Cross Country (134) (4-Türer) Stufenheck | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2019,
    "Mo": "S60 Cross Country (134) (4-Türer) Stufenheck | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2017,
    "Mo": "S90 (234) (4-Türer) Stufenheck | 2017-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2018,
    "Mo": "S90 (234) (4-Türer) Stufenheck | 2017-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2019,
    "Mo": "S90 (234) (4-Türer) Stufenheck | 2017-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2020,
    "Mo": "S90 (234) (4-Türer) Stufenheck | 2017-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2021,
    "Mo": "S90 (234) (4-Türer) Stufenheck PS | 2017-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2021,
    "Mo": "S90 (234) (4-Türer) Stufenheck PS Facelift | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2022,
    "Mo": "S90 (234) (4-Türer) Stufenheck | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2023,
    "Mo": "S90 (234) (4-Türer) Stufenheck | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2024,
    "Mo": "S90 (234) (4-Türer) Stufenheck | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2025,
    "Mo": "S90 (234) (4-Türer) Stufenheck | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2013,
    "Mo": "V40 (525) (5-Türer) Schrägheck | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2014,
    "Mo": "V40 (525) (5-Türer) Schrägheck | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2015,
    "Mo": "V40 (525) (5-Türer) Schrägheck | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2016,
    "Mo": "V40 (525) (5-Türer) Schrägheck | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2017,
    "Mo": "V40 (525) (5-Türer) Schrägheck | 2017-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2018,
    "Mo": "V40 (525) (5-Türer) Schrägheck | 2017-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2019,
    "Mo": "V40 (525) (5-Türer) Schrägheck | 2017-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2014,
    "Mo": "V60 (155) (5-Türer) Kombi | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2015,
    "Mo": "V60 (155) (5-Türer) Kombi | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2016,
    "Mo": "V60 (155) (5-Türer) Kombi | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2017,
    "Mo": "V60 (155) (5-Türer) Kombi | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2018,
    "Mo": "V60 (155) (5-Türer) Kombi | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2011,
    "Mo": "V60 (155) (5-Türer) Kombi | 2011-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2012,
    "Mo": "V60 (155) (5-Türer) Kombi | 2011-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2013,
    "Mo": "V60 (155) (5-Türer) Kombi | 2011-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Auris (5-Türer) Schrägheck E150 Facelift | 2010-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Auris (5-Türer) Schrägheck | 2010-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Auris (5-Türer) Schrägheck E150 Facelift | 2010-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Auris (5-Türer) Schrägheck | 2006-2010",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Auris (5-Türer) Schrägheck | 2006-2010",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Auris (5-Türer) Schrägheck | 2006-2010",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Auris (5-Türer) Schrägheck | 2006-2010",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Auris (5-Türer) Schrägheck E150 | 2006-2010",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Auris (5-Türer) Schrägheck E180 | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Auris (5-Türer) Schrägheck | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Auris (5-Türer) Schrägheck | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Auris (5-Türer) Schrägheck E180 | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Auris (5-Türer) Schrägheck E180 Facelift | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Auris (5-Türer) Schrägheck | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Auris (5-Türer) Schrägheck | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Auris (5-Türer) Schrägheck | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Auris (5-Türer) Schrägheck | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Aygo (5-Türer) Schrägheck AB40 Facelift | 2018-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Aygo (5-Türer) Schrägheck | 2018-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Aygo (5-Türer) Schrägheck | 2018-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Aygo (5-Türer) Schrägheck | 2018-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Aygo (5-Türer) Schrägheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Aygo (5-Türer) Schrägheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Aygo (5-Türer) Schrägheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Aygo (5-Türer) Schrägheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Aygo (5-Türer) Schrägheck AB40 | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "bZ4X (5-Türer) SUV EA10 Facelift | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "bZ4X (5-Türer) SUV | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "bZ4X (5-Türer) SUV | 2022-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "bZ4X (5-Türer) SUV | 2022-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "bZ4X (5-Türer) SUV | 2022-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "bZ4X (5-Türer) SUV EA10 | 2022-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "C-HR (5-Türer) SUV | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "C-HR (5-Türer) SUV | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "C-HR (5-Türer) SUV | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "C-HR (5-Türer) SUV 1st Generation | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "C-HR (5-Türer) SUV 1st Generation Facelift | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "C-HR (5-Türer) SUV | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "C-HR (5-Türer) SUV | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "C-HR (5-Türer) SUV | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "C-HR (5-Türer) SUV 1st Generation Facelift | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "C-HR (5-Türer) SUV 2nd Generation | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "C-HR (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "C-HR (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "C-HR (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Camry (4-Türer) Stufenheck XV50 Facelift | 2015-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Camry (4-Türer) Stufenheck | 2015-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Camry (4-Türer) Stufenheck | 2015-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Camry (4-Türer) Stufenheck | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Camry (4-Türer) Stufenheck | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Camry (4-Türer) Stufenheck | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Camry (4-Türer) Stufenheck XV50 | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Camry (4-Türer) Stufenheck | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "Camry (4-Türer) Stufenheck | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Corolla Sedan (4-Türer) Stufenheck E170 Facelift | 2016-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Corolla Sedan (4-Türer) Stufenheck | 2016-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Corolla Sedan (4-Türer) Stufenheck | 2016-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Corolla Sedan (4-Türer) Stufenheck | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Corolla Sedan (4-Türer) Stufenheck | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Corolla Sedan (4-Türer) Stufenheck | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Corolla Sedan (4-Türer) Stufenheck E170 | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Corolla Sedan (4-Türer) Stufenheck E210 Facelift | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Corolla Sedan (4-Türer) Stufenheck E210 Facelift | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Corolla Sedan (4-Türer) Stufenheck E210 Facelift | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Corolla Sedan (4-Türer) Stufenheck E210 Facelift | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "Corolla Sedan (4-Türer) Stufenheck E210 Facelift | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Corolla Sedan (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Corolla Sedan (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Corolla Sedan (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Corolla Sedan (4-Türer) Stufenheck E210 | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Corolla Sedan (4-Türer) Stufenheck E210 | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Corolla Sedan (4-Türer) Stufenheck E210 | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Corolla Sedan (4-Türer) Stufenheck E210 | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "Corolla Sedan (4-Türer) Stufenheck E210 | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2001,
    "Mo": "Corolla Hatchback (5-Türer) Schrägheck | 2001-2004",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "Corolla Hatchback (5-Türer) Schrägheck | 2001-2004",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Corolla Hatchback (5-Türer) Schrägheck | 2001-2004",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Corolla Hatchback (5-Türer) Schrägheck E120 | 2001-2004",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Corolla Hatchback (5-Türer) Schrägheck E120 Facelift | 2004-2007",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Corolla Hatchback (5-Türer) Schrägheck | 2004-2007",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Corolla Hatchback (5-Türer) Schrägheck | 2004-2007",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Corolla Hatchback (5-Türer) Schrägheck | 2004-2007",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Corolla Hatchback (5-Türer) Schrägheck E210 Facelift | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Corolla Hatchback (5-Türer) Schrägheck E210 Facelift | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Corolla Hatchback (5-Türer) Schrägheck E210 Facelift | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Corolla Hatchback (5-Türer) Schrägheck E210 Facelift | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "Corolla Hatchback (5-Türer) Schrägheck E210 Facelift | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Corolla Hatchback (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Corolla Hatchback (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Corolla Hatchback (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Corolla Hatchback (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Corolla Hatchback (5-Türer) Schrägheck E210 | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Corolla Hatchback (5-Türer) Schrägheck E210 | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Corolla Hatchback (5-Türer) Schrägheck E210 | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Corolla Hatchback (5-Türer) Schrägheck E210 | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "Corolla Hatchback (5-Türer) Schrägheck E210 | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Corolla Station Wagon (5-Türer) Kombi E210 Facelift | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Corolla Station Wagon (5-Türer) Kombi E210 Facelift | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Corolla Station Wagon (5-Türer) Kombi E210 Facelift | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Corolla Station Wagon (5-Türer) Kombi E210 Facelift | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "Corolla Station Wagon (5-Türer) Kombi E210 Facelift | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Corolla Station Wagon (5-Türer) Kombi | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Corolla Station Wagon (5-Türer) Kombi | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Corolla Station Wagon (5-Türer) Kombi | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Corolla Station Wagon (5-Türer) Kombi | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Corolla Station Wagon (5-Türer) Kombi E210 | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Corolla Station Wagon (5-Türer) Kombi E210 | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Corolla Station Wagon (5-Türer) Kombi E210 | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Corolla Station Wagon (5-Türer) Kombi E210 | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "Corolla Station Wagon (5-Türer) Kombi E210 | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Corolla Cross (5-Türer) SUV | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Corolla Cross (5-Türer) SUV | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Corolla Cross (5-Türer) SUV | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Corolla Cross (5-Türer) SUV | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Corolla Cross (5-Türer) SUV XG10 | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Corolla Cross (5-Türer) SUV XG10 Facelift | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "Corolla Cross (5-Türer) SUV | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Corolla Verso (5-Türer) MPV | 2004-2007",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Corolla Verso (5-Türer) MPV | 2004-2007",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Corolla Verso (5-Türer) MPV | 2004-2007",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Corolla Verso (5-Türer) MPV AR10 | 2004-2007",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Corolla Verso (5-Türer) MPV AR10 Facelift | 2007-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Corolla Verso (5-Türer) MPV | 2007-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Corolla Verso (5-Türer) MPV | 2007-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Highlander (5-Türer) Crossover XU70 | 2020-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Highlander (5-Türer) Crossover | 2020-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Highlander (5-Türer) Crossover | 2020-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Highlander (5-Türer) Crossover | 2020-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Highlander (5-Türer) Crossover | 2020-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Highlander (5-Türer) Crossover | 2020-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "Highlander (5-Türer) Crossover | 2020-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Hilux Double Cab (4-Türer) Pickup | 2009-2011",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Hilux Double Cab (4-Türer) Pickup | 2009-2011",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Hilux Double Cab (4-Türer) Pickup | 2009-2011",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Hilux Double Cab (4-Türer) Pickup | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Hilux Double Cab (4-Türer) Pickup | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Hilux Double Cab (4-Türer) Pickup | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Hilux Double Cab (4-Türer) Pickup | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Hilux Double Cab (4-Türer) Pickup AN10/AN20/AN30 2nd Facelift | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Hilux Double Cab (4-Türer) Pickup | 2006-2008",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Hilux Double Cab (4-Türer) Pickup | 2006-2008",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Hilux Double Cab (4-Türer) Pickup | 2006-2008",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Hilux Double Cab (4-Türer) Pickup AN120/AN130 | 2016-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Hilux Double Cab (4-Türer) Pickup | 2016-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Hilux Double Cab (4-Türer) Pickup | 2016-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Hilux Double Cab (4-Türer) Pickup | 2016-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Hilux Double Cab (4-Türer) Pickup AN120/AN130 | 2016-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Hilux Double Cab (4-Türer) Pickup AN120/AN130 | 2016-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Hilux Double Cab (4-Türer) Pickup AN120/AN130 2nd Facelift | 2024-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Hilux Double Cab (4-Türer) Pickup | 2024-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "Hilux Double Cab (4-Türer) Pickup | 2024-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Hilux Double Cab (4-Türer) Pickup AN120/AN130 1st Facelift | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Hilux Double Cab (4-Türer) Pickup AN120/AN130 1st Facelift | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Hilux Double Cab (4-Türer) Pickup | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Hilux Double Cab (4-Türer) Pickup | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Hilux Double Cab (4-Türer) Pickup AN120/AN130 1st Facelift | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Hilux Extra Cab (2-Türer) Pickup | 2016-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Hilux Extra Cab (2-Türer) Pickup | 2016-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Hilux Extra Cab (2-Türer) Pickup | 2016-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Hilux Extra Cab (2-Türer) Pickup | 2016-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Hilux Extra Cab (2-Türer) Pickup AN120/AN130 | 2016-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Hilux Extra Cab (2-Türer) Pickup AN120/AN130 | 2016-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Hilux Extra Cab (2-Türer) Pickup AN120/AN130 2nd Facelift | 2024-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Hilux Extra Cab (2-Türer) Pickup | 2024-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "Hilux Extra Cab (2-Türer) Pickup | 2024-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Hilux Extra Cab (2-Türer) Pickup AN120/AN130 1st Facelift | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Hilux Extra Cab (2-Türer) Pickup AN120/AN130 1st Facelift | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Hilux Extra Cab (2-Türer) Pickup | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Hilux Extra Cab (2-Türer) Pickup | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Hilux Extra Cab (2-Türer) Pickup AN120/AN130 1st Facelift | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Land Cruiser (5-Türer) SUV J30 | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Land Cruiser (5-Türer) SUV J30 | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Land Cruiser (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Land Cruiser (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Land Cruiser (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "Land Cruiser (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Land Cruiser Prado (5-Türer) SUV J150 1st Facelift | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Land Cruiser Prado (5-Türer) SUV J150 | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Land Cruiser Prado (5-Türer) SUV J150 | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Prius (5-Türer) Schrägheck | 2003-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Prius (5-Türer) Schrägheck | 2003-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Prius (5-Türer) Schrägheck | 2003-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Prius (5-Türer) Schrägheck | 2003-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Prius (5-Türer) Schrägheck | 2003-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Prius (5-Türer) Schrägheck | 2003-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Prius (5-Türer) Schrägheck XW20 | 2003-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Prius (5-Türer) Schrägheck | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Prius (5-Türer) Schrägheck | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Prius (5-Türer) Schrägheck | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Prius (5-Türer) Schrägheck | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Prius (5-Türer) Schrägheck XW30 Facelift | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Prius (5-Türer) Schrägheck XW30 | 2009-2011",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Prius (5-Türer) Schrägheck | 2009-2011",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Prius (5-Türer) Schrägheck | 2009-2011",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Prius (5-Türer) Schrägheck XW50 | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Prius (5-Türer) Schrägheck | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Prius (5-Türer) Schrägheck | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Prius (5-Türer) Schrägheck XW50 | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Prius (5-Türer) Schrägheck XW50 Facelift | 2019-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Prius (5-Türer) Schrägheck | 2019-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Prius (5-Türer) Schrägheck | 2019-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Prius (5-Türer) Schrägheck | 2019-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Prius (5-Türer) Schrägheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Prius (5-Türer) Schrägheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Prius (5-Türer) Schrägheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "Prius (5-Türer) Schrägheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Prius+ (5-Türer) Kombi | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Prius+ (5-Türer) Kombi | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Prius+ (5-Türer) Kombi | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Prius+ (5-Türer) Kombi | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Prius+ (5-Türer) Kombi XW30 Facelift | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Prius+ (5-Türer) Kombi XW50 | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Prius+ (5-Türer) Kombi | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Prius+ (5-Türer) Kombi | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Prius+ (5-Türer) Kombi XW50 | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Prius+ (5-Türer) Kombi XW50 Facelift | 2019-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Prius+ (5-Türer) Kombi | 2019-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Prius+ (5-Türer) Kombi | 2019-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Prius+ (5-Türer) Kombi | 2019-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "RAV4 (5-Türer) SUV | 2005-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "RAV4 (5-Türer) SUV | 2005-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "RAV4 (5-Türer) SUV | 2005-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "RAV4 (5-Türer) SUV XA30 | 2005-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "RAV4 (5-Türer) SUV XA30 | 2005-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "RAV4 (5-Türer) SUV XA30 1st Facelift | 2008-2010",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "RAV4 (5-Türer) SUV XA30 1st Facelift | 2008-2010",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "RAV4 (5-Türer) SUV XA30 1st Facelift | 2008-2010",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "RAV4 (5-Türer) SUV XA30 2nd Facelift | 2010-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "RAV4 (5-Türer) SUV | 2010-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "RAV4 (5-Türer) SUV XA30 2nd Facelift | 2010-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "RAV4 (5-Türer) SUV XA30 2nd Facelift | 2010-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "RAV4 (5-Türer) SUV | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "RAV4 (5-Türer) SUV | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "RAV4 (5-Türer) SUV | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "RAV4 (5-Türer) SUV XA40 Facelift | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "RAV4 (5-Türer) SUV XA40 | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "RAV4 (5-Türer) SUV XA40 | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "RAV4 (5-Türer) SUV | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "RAV4 (5-Türer) SUV | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "RAV4 (5-Türer) SUV XA50 | 2019-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "RAV4 (5-Türer) SUV | 2019-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "RAV4 (5-Türer) SUV | 2019-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "RAV4 (5-Türer) SUV | 2022-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "RAV4 (5-Türer) SUV | 2022-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "RAV4 (5-Türer) SUV | 2022-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "RAV4 (5-Türer) SUV | 2022-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Tundra CrewMax (4-Türer) Pickup | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Tundra CrewMax (4-Türer) Pickup | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Tundra CrewMax (4-Türer) Pickup | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Tundra CrewMax (4-Türer) Pickup | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Tundra CrewMax (4-Türer) Pickup | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Tundra CrewMax (4-Türer) Pickup | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Tundra CrewMax (4-Türer) Pickup | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Tundra CrewMax (4-Türer) Pickup | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Tundra CrewMax (4-Türer) Pickup | 2007-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Tundra CrewMax (4-Türer) Pickup | 2007-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Tundra CrewMax (4-Türer) Pickup | 2007-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Tundra CrewMax (4-Türer) Pickup | 2007-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Tundra CrewMax (4-Türer) Pickup | 2007-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Tundra CrewMax (4-Türer) Pickup | 2007-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Tundra CrewMax (4-Türer) Pickup | 2007-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Tundra CrewMax (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Tundra CrewMax (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Tundra CrewMax (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Tundra CrewMax (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "Tundra CrewMax (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Tundra Double Cab (4-Türer) Pickup | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Tundra Double Cab (4-Türer) Pickup | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Tundra Double Cab (4-Türer) Pickup | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Tundra Double Cab (4-Türer) Pickup | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Tundra Double Cab (4-Türer) Pickup | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Tundra Double Cab (4-Türer) Pickup | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Tundra Double Cab (4-Türer) Pickup | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Tundra Double Cab (4-Türer) Pickup | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Tundra Double Cab (4-Türer) Pickup | 2007-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Tundra Double Cab (4-Türer) Pickup | 2007-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Tundra Double Cab (4-Türer) Pickup | 2007-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Tundra Double Cab (4-Türer) Pickup | 2007-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Tundra Double Cab (4-Türer) Pickup | 2007-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Tundra Double Cab (4-Türer) Pickup | 2007-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Tundra Double Cab (4-Türer) Pickup | 2007-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Tundra Double Cab (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Tundra Double Cab (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Tundra Double Cab (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Tundra Double Cab (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "Tundra Double Cab (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Vellfire (5-Türer) MPV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Vellfire (5-Türer) MPV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Vellfire (5-Türer) MPV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Vellfire (5-Türer) MPV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Vellfire (5-Türer) MPV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Vellfire (5-Türer) MPV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Vellfire (5-Türer) MPV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Vellfire (5-Türer) MPV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "Vellfire (5-Türer) MPV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Yaris (5-Türer) Schrägheck XP130 2nd Facelift | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Yaris (5-Türer) Schrägheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Yaris (5-Türer) Schrägheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Yaris (5-Türer) Schrägheck XP130 2nd Facelift | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Yaris (5-Türer) Schrägheck XP130 1st Facelift | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Yaris (5-Türer) Schrägheck | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Yaris (5-Türer) Schrägheck | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Yaris (5-Türer) Schrägheck XP130 1st Facelift | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Yaris (5-Türer) Schrägheck | 2011-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Yaris (5-Türer) Schrägheck | 2011-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Yaris (5-Türer) Schrägheck | 2011-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Yaris (5-Türer) Schrägheck XP130 | 2011-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Yaris (5-Türer) Schrägheck XP210 Facelift | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Yaris (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "Yaris (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Yaris (5-Türer) Schrägheck XP210 | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Yaris (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Yaris (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Yaris (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Yaris (5-Türer) Schrägheck XP210 | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "C-Max (5-Türer) MPV DXA Facelift | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "C-Max (5-Türer) MPV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "C-Max (5-Türer) MPV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "C-Max (5-Türer) MPV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "C-Max (5-Türer) MPV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "C-Max (5-Türer) MPV | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "C-Max (5-Türer) MPV | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "C-Max (5-Türer) MPV | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "C-Max (5-Türer) MPV | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "C-Max (5-Türer) MPV | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "C-Max (5-Türer) MPV DXA | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "C-Max (5-Türer) MPV DXA Facelift | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "C-Max (5-Türer) MPV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "C-Max (5-Türer) MPV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "C-Max (5-Türer) MPV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "C-Max (5-Türer) MPV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "C-Max (5-Türer) MPV | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "C-Max (5-Türer) MPV | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "C-Max (5-Türer) MPV | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "C-Max (5-Türer) MPV | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "C-Max (5-Türer) MPV | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "C-Max (5-Türer) MPV DXA | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Grand C-Max (5-Türer) MPV DXA Facelift | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Grand C-Max (5-Türer) MPV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Grand C-Max (5-Türer) MPV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Grand C-Max (5-Türer) MPV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Grand C-Max (5-Türer) MPV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Grand C-Max (5-Türer) MPV DXA | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Capri EV (5-Türer) SUV | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Capri EV (5-Türer) SUV | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Edge (5-Türer) SUV | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Edge (5-Türer) SUV | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Edge (5-Türer) SUV | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Edge (5-Türer) SUV | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Edge (5-Türer) SUV | 2019-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Edge (5-Türer) SUV | 2019-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Edge (5-Türer) SUV | 2019-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Edge (5-Türer) SUV | 2019-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Edge (5-Türer) SUV | 2019-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Edge (5-Türer) SUV | 2019-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Escape (5-Türer) SUV | 2020-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Escape (5-Türer) SUV | 2020-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Escape (5-Türer) SUV | 2020-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Escape (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Escape (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Escape (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Escape (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Explorer EV (CX740) (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Explorer EV (CX740) (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Explorer EV (CX740) (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Fiesta (HJ) (5-Türer) Schrägheck | 2017-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Fiesta (HJ) (5-Türer) Schrägheck | 2017-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Fiesta (HJ) (5-Türer) Schrägheck | 2017-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Fiesta (HJ) (5-Türer) Schrägheck | 2017-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Fiesta (HJ) (5-Türer) Schrägheck | 2017-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Fiesta (HJ) (5-Türer) Schrägheck HF/HG/HJ | 2017-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Fiesta (HJ) (5-Türer) Schrägheck HF/HG/HJ Facelift | 2022-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Fiesta (HJ) (5-Türer) Schrägheck | 2022-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Fiesta (5-Türer) Schrägheck JA8 Facelift | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Fiesta (5-Türer) Schrägheck | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Fiesta (5-Türer) Schrägheck | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Fiesta (5-Türer) Schrägheck | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Fiesta (5-Türer) Schrägheck | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "Fiesta (5-Türer) Schrägheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "Fiesta (5-Türer) Schrägheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Fiesta (5-Türer) Schrägheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Fiesta (5-Türer) Schrägheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Fiesta (5-Türer) Schrägheck JA8 | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Focus Hatchback (C5) (5-Türer) Schrägheck | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Focus Hatchback (C5) (5-Türer) Schrägheck | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Focus Hatchback (C5) (5-Türer) Schrägheck | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Focus Hatchback (C5) (5-Türer) Schrägheck | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Focus Hatchback (BK) (5-Türer) Schrägheck | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Focus Hatchback (BK) (5-Türer) Schrägheck | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Focus Hatchback (BK) (5-Türer) Schrägheck | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Focus Hatchback (BK) (5-Türer) Schrägheck | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Focus Hatchback (BK) (5-Türer) Schrägheck | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Focus Hatchback (HN) (5-Türer) Schrägheck HM/HN/HP Facelift | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Focus Hatchback (HN) (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Focus Hatchback (HN) (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Focus Hatchback (HN) (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Focus Hatchback (HN) (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Focus Hatchback (HN) (5-Türer) Schrägheck | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Focus Hatchback (HN) (5-Türer) Schrägheck | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Focus Hatchback (HN) (5-Türer) Schrägheck | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Focus Hatchback (HN) (5-Türer) Schrägheck | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Focus Hatchback (HN) (5-Türer) Schrägheck HM/HN/HP | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Focus Combi (C6) (5-Türer) Kombi | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Focus Combi (C6) (5-Türer) Kombi | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Focus Combi (C6) (5-Türer) Kombi | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Focus Combi (C6) (5-Türer) Kombi | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Focus Combi (BL) (5-Türer) Kombi | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Focus Combi (BL) (5-Türer) Kombi | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Focus Combi (BL) (5-Türer) Kombi | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Focus Combi (BL) (5-Türer) Kombi | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Focus Combi (BL) (5-Türer) Kombi | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Focus Sedan (C4) (4-Türer) Stufenheck | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Focus Sedan (C4) (4-Türer) Stufenheck | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Focus Sedan (C4) (4-Türer) Stufenheck | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Focus Sedan (C4) (4-Türer) Stufenheck | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Focus Sedan (BM) (4-Türer) Stufenheck | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Focus Sedan (BM) (4-Türer) Stufenheck | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Focus Sedan (BM) (4-Türer) Stufenheck | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Focus Sedan (BM) (4-Türer) Stufenheck | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Focus Sedan (BM) (4-Türer) Stufenheck | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Ka (5-Türer) Schrägheck | 2017-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Ka (5-Türer) Schrägheck UK | 2017-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Ka (5-Türer) Schrägheck UK Facelift | 2018-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Ka (5-Türer) Schrägheck | 2018-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Ka (5-Türer) Schrägheck | 2018-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Kuga (5-Türer) SUV MA Facelift | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Kuga (5-Türer) SUV | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Kuga (5-Türer) SUV | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Kuga (5-Türer) SUV MA Facelift | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Kuga (5-Türer) SUV MA | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Kuga (5-Türer) SUV | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Kuga (5-Türer) SUV | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Kuga (5-Türer) SUV | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Kuga (5-Türer) SUV MA | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Kuga (5-Türer) SUV MF Facelift | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Kuga (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Kuga (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Kuga (5-Türer) SUV MF | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Kuga (5-Türer) SUV | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Kuga (5-Türer) SUV | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Kuga (5-Türer) SUV | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Kuga (5-Türer) SUV MF | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Mondeo Combi (BG) (5-Türer) Kombi BD/BE/BG Facelift | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Mondeo Combi (BG) (5-Türer) Kombi | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Mondeo Combi (BG) (5-Türer) Kombi | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Mondeo Combi (BG) (5-Türer) Kombi | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Mondeo Combi (BG) (5-Türer) Kombi | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "Mondeo Combi (BG) (5-Türer) Kombi | 2007-2011",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2008,
    "Mo": "Mondeo Combi (BG) (5-Türer) Kombi | 2007-2011",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "Mondeo Combi (BG) (5-Türer) Kombi | 2007-2011",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "Mondeo Combi (BG) (5-Türer) Kombi | 2007-2011",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Mondeo Combi (BG) (5-Türer) Kombi BD/BE/BG | 2007-2011",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Mondeo Combi (CF) (5-Türer) Kombi | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Mondeo Combi (CF) (5-Türer) Kombi | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Mondeo Combi (CF) (5-Türer) Kombi | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Mondeo Combi (CF) (5-Türer) Kombi | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Mondeo Combi (CF) (5-Türer) Kombi | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Mondeo Combi (CF) (5-Türer) Kombi CD/CE/CF | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Mondeo Combi (CF) (5-Türer) Kombi CD/CE/CF Facelift | 2019-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Mondeo Combi (CF) (5-Türer) Kombi | 2019-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Mondeo Combi (CF) (5-Türer) Kombi | 2019-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Mondeo Combi (CF) (5-Türer) Kombi | 2019-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Mondeo Hatchback (CE) (5-Türer) Schrägheck | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Mondeo Hatchback (CE) (5-Türer) Schrägheck | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Mondeo Hatchback (CE) (5-Türer) Schrägheck | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Mondeo Hatchback (CE) (5-Türer) Schrägheck | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Mondeo Hatchback (CE) (5-Türer) Schrägheck | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Mondeo Hatchback (CE) (5-Türer) Schrägheck CD/CE/CF | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Mondeo Hatchback (CE) (5-Türer) Schrägheck CD/CE/CF Facelift | 2019-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Mondeo Hatchback (CE) (5-Türer) Schrägheck | 2019-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Mondeo Hatchback (CE) (5-Türer) Schrägheck | 2019-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Mondeo Hatchback (CE) (5-Türer) Schrägheck | 2019-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Mondeo Sedan (CD) (4-Türer) Stufenheck | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Mondeo Sedan (CD) (4-Türer) Stufenheck | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Mondeo Sedan (CD) (4-Türer) Stufenheck | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Mondeo Sedan (CD) (4-Türer) Stufenheck | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Mondeo Sedan (CD) (4-Türer) Stufenheck | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Mondeo Sedan (CD) (4-Türer) Stufenheck | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Mondeo Sedan (CE) (4-Türer) Stufenheck | 2019-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Mondeo Sedan (CE) (4-Türer) Stufenheck | 2019-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Mondeo Sedan (CE) (4-Türer) Stufenheck | 2019-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Mondeo Sedan (CE) (4-Türer) Stufenheck | 2019-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Mustang Mach-E (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Mustang Mach-E (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Mustang Mach-E (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Mustang Mach-E (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Mustang Mach-E (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Mustang Mach-E (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Puma (5-Türer) SUV K2 Facelift | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Puma (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Puma (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Puma (5-Türer) SUV | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Puma (5-Türer) SUV | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Puma (5-Türer) SUV | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Puma (5-Türer) SUV | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Puma (5-Türer) SUV K2 | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Ranger Double Cab (4-Türer) Pickup RA | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Ranger Double Cab (4-Türer) Pickup RA | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Ranger Double Cab (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Ranger Double Cab (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Ranger Double Cab (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Ranger Double Cab (4-Türer) Pickup PX 2nd Facelift | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Ranger Double Cab (4-Türer) Pickup | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Ranger Double Cab (4-Türer) Pickup | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Ranger Double Cab (4-Türer) Pickup PX 2nd Facelift | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Ranger Double Cab (4-Türer) Pickup PX 2nd Facelift | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Ranger Double Cab (4-Türer) Pickup | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Ranger Double Cab (4-Türer) Pickup | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Ranger Double Cab (4-Türer) Pickup | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Ranger Double Cab (4-Türer) Pickup | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Ranger Double Cab (4-Türer) Pickup PX | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Ranger Double Cab (4-Türer) Pickup PX 1st Facelift | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Ranger Double Cab (4-Türer) Pickup | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Ranger Double Cab (4-Türer) Pickup | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Ranger Double Cab (4-Türer) Pickup PX 1st Facelift | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Ranger Double Cab (4-Türer) Pickup RA | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Ranger Double Cab (4-Türer) Pickup RA | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Ranger Double Cab (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Ranger Double Cab (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Ranger Double Cab (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Ranger Regular Cab (2-Türer) Pickup | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Ranger Regular Cab (2-Türer) Pickup | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Ranger Regular Cab (2-Türer) Pickup | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Ranger Regular Cab (2-Türer) Pickup | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Ranger Regular Cab (2-Türer) Pickup PX | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Ranger Regular Cab (2-Türer) Pickup PX 1st Facelift | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Ranger Regular Cab (2-Türer) Pickup | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Ranger Regular Cab (2-Türer) Pickup | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Ranger Regular Cab (2-Türer) Pickup PX 1st Facelift | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Ranger Regular Cab (2-Türer) Pickup PX 2nd Facelift | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Ranger Regular Cab (2-Türer) Pickup | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Ranger Regular Cab (2-Türer) Pickup | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Ranger Regular Cab (2-Türer) Pickup | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Ranger Regular Cab (2-Türer) Pickup | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Ranger SuperCab (2-Türer) Pickup PX 2nd Facelift | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Ranger SuperCab (2-Türer) Pickup | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Ranger SuperCab (2-Türer) Pickup | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Ranger SuperCab (2-Türer) Pickup | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Ranger SuperCab (2-Türer) Pickup | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Ranger SuperCab (2-Türer) Pickup | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Ranger SuperCab (2-Türer) Pickup | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Ranger SuperCab (2-Türer) Pickup | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Ranger SuperCab (2-Türer) Pickup | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Ranger SuperCab (2-Türer) Pickup PX | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Ranger SuperCab (2-Türer) Pickup PX 1st Facelift | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Ranger SuperCab (2-Türer) Pickup | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Ranger SuperCab (2-Türer) Pickup | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Ranger SuperCab (2-Türer) Pickup PX 1st Facelift | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "S-Max (5-Türer) MPV CJ | 2015-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "S-Max (5-Türer) MPV | 2015-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "S-Max (5-Türer) MPV | 2015-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "S-Max (5-Türer) MPV | 2015-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "S-Max (5-Türer) MPV | 2015-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "S-Max (5-Türer) MPV CJ | 2015-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "S-Max (5-Türer) MPV CJ Facelift | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "S-Max (5-Türer) MPV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "S-Max (5-Türer) MPV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "S-Max (5-Türer) MPV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "S-Max (5-Türer) MPV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "S-Max (5-Türer) MPV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "S-Max (5-Türer) MPV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "S-Max (5-Türer) MPV WS Facelift | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "S-Max (5-Türer) MPV | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "S-Max (5-Türer) MPV | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "S-Max (5-Türer) MPV | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "S-Max (5-Türer) MPV | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "S-Max (5-Türer) MPV WS Facelift | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2006,
    "Mo": "S-Max (5-Türer) MPV | 2006-2010",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "S-Max (5-Türer) MPV | 2006-2010",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2008,
    "Mo": "S-Max (5-Türer) MPV | 2006-2010",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "S-Max (5-Türer) MPV | 2006-2010",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "S-Max (5-Türer) MPV WS | 2006-2010",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "S-Max (5-Türer) MPV WS Facelift | 2010-2015",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "S-Max (5-Türer) MPV | 2010-2015",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "S-Max (5-Türer) MPV | 2010-2015",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "S-Max (5-Türer) MPV | 2010-2015",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "S-Max (5-Türer) MPV | 2010-2015",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "S-Max (5-Türer) MPV WS Facelift | 2010-2015",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2006,
    "Mo": "S-Max (5-Türer) MPV | 2006-2010",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "S-Max (5-Türer) MPV | 2006-2010",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2008,
    "Mo": "S-Max (5-Türer) MPV | 2006-2010",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "S-Max (5-Türer) MPV | 2006-2010",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "S-Max (5-Türer) MPV WS | 2006-2010",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "X-Class (W470) (4-Türer) Pickup | 2018-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "X-Class (W470) (4-Türer) Pickup | 2018-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "X-Class (W470) (4-Türer) Pickup | 2018-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2013,
    "Mo": "Astra (5-Türer) Schrägheck | 2013-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2014,
    "Mo": "Astra (5-Türer) Schrägheck | 2013-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2015,
    "Mo": "Astra (5-Türer) Schrägheck | 2013-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2010,
    "Mo": "Astra (5-Türer) Schrägheck J | 2010-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2011,
    "Mo": "Astra (5-Türer) Schrägheck J | 2010-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2012,
    "Mo": "Astra (5-Türer) Schrägheck J | 2010-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2013,
    "Mo": "Astra (5-Türer) Schrägheck | 2013-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2014,
    "Mo": "Astra (5-Türer) Schrägheck | 2013-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2015,
    "Mo": "Astra (5-Türer) Schrägheck | 2013-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2010,
    "Mo": "Astra (5-Türer) Schrägheck J | 2010-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2011,
    "Mo": "Astra (5-Türer) Schrägheck J | 2010-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2012,
    "Mo": "Astra (5-Türer) Schrägheck J | 2010-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Astra (5-Türer) Schrägheck | 2020-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Astra (5-Türer) Schrägheck | 2020-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Astra (5-Türer) Schrägheck K Facelift | 2020-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2016,
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Astra (5-Türer) Schrägheck L | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Astra (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Astra (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Astra (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2026,
    "Mo": "Astra (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Astra Wagon (5-Türer) Kombi | 2020-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Astra Wagon (5-Türer) Kombi | 2020-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Astra Wagon (5-Türer) Kombi K Facelift | 2020-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2016,
    "Mo": "Astra Wagon (5-Türer) Kombi K | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Astra Wagon (5-Türer) Kombi | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Astra Wagon (5-Türer) Kombi | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Astra Wagon (5-Türer) Kombi | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Astra Wagon (5-Türer) Kombi L | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Astra Wagon (5-Türer) Kombi | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Astra Wagon (5-Türer) Kombi | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Astra Wagon (5-Türer) Kombi | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2026,
    "Mo": "Astra Wagon (5-Türer) Kombi | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Corsa (5-Türer) Schrägheck F Facelift | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Corsa (5-Türer) Schrägheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Corsa (5-Türer) Schrägheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2026,
    "Mo": "Corsa (5-Türer) Schrägheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Corsa (5-Türer) Schrägheck | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Corsa (5-Türer) Schrägheck | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Corsa (5-Türer) Schrägheck | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Corsa (5-Türer) Schrägheck F | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Crossland (5-Türer) Crossover | 2017-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Crossland (5-Türer) Crossover | 2017-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Crossland (5-Türer) Crossover | 2017-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Crossland (5-Türer) Crossover | 2017-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Crossland (5-Türer) Crossover 1st Generation | 2017-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Crossland (5-Türer) Crossover 1st Generation | 2017-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Crossland (5-Türer) Crossover 1st Generation Facelift | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Crossland (5-Türer) Crossover 1st Generation Facelift | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Crossland (5-Türer) Crossover | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Crossland (5-Türer) Crossover | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Crossland (5-Türer) Crossover | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2026,
    "Mo": "Crossland (5-Türer) Crossover | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Grandland X (5-Türer) Crossover | 2022-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Grandland X (5-Türer) Crossover | 2022-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Grandland X (5-Türer) Crossover 1st Generation Facelift | 2022-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Grandland X (5-Türer) Crossover | 2018-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Grandland X (5-Türer) Crossover | 2018-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Grandland X (5-Türer) Crossover | 2018-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Grandland X (5-Türer) Crossover | 2018-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Grandland X (5-Türer) Crossover 2nd Generation | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Grandland X (5-Türer) Crossover | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2026,
    "Mo": "Grandland X (5-Türer) Crossover | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2009,
    "Mo": "Insignia (5-Türer) Schrägheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2010,
    "Mo": "Insignia (5-Türer) Schrägheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2011,
    "Mo": "Insignia (5-Türer) Schrägheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2012,
    "Mo": "Insignia (5-Türer) Schrägheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2013,
    "Mo": "Insignia (5-Türer) Schrägheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2014,
    "Mo": "Insignia (5-Türer) Schrägheck | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2015,
    "Mo": "Insignia (5-Türer) Schrägheck | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2016,
    "Mo": "Insignia (5-Türer) Schrägheck | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Insignia (5-Türer) Schrägheck A Facelift | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Insignia (5-Türer) Schrägheck B | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Insignia (5-Türer) Schrägheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Insignia (5-Türer) Schrägheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Insignia (5-Türer) Schrägheck B | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Insignia (5-Türer) Schrägheck B Facelift | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Insignia (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Insignia (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Insignia (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Insignia (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Insignia (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2026,
    "Mo": "Insignia (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2009,
    "Mo": "Insignia Sedan (4-Türer) Stufenheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2010,
    "Mo": "Insignia Sedan (4-Türer) Stufenheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2011,
    "Mo": "Insignia Sedan (4-Türer) Stufenheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2012,
    "Mo": "Insignia Sedan (4-Türer) Stufenheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2013,
    "Mo": "Insignia Sedan (4-Türer) Stufenheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2014,
    "Mo": "Insignia Sedan (4-Türer) Stufenheck | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2015,
    "Mo": "Insignia Sedan (4-Türer) Stufenheck | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2016,
    "Mo": "Insignia Sedan (4-Türer) Stufenheck | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Insignia Sedan (4-Türer) Stufenheck | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Karl (5-Türer) Schrägheck 1st Generation Facelift | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Karl (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Karl (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Karl (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Karl (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Karl (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Karl (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Karl (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2026,
    "Mo": "Karl (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2015,
    "Mo": "Karl (5-Türer) Schrägheck | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2016,
    "Mo": "Karl (5-Türer) Schrägheck | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Karl (5-Türer) Schrägheck | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Karl (5-Türer) Schrägheck 1st Generation | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Mokka (5-Türer) SUV | 2021-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Mokka (5-Türer) SUV | 2021-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Mokka (5-Türer) SUV | 2021-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Mokka (5-Türer) SUV B | 2021-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Mokka (5-Türer) SUV B Facelift | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Mokka (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2026,
    "Mo": "Mokka (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "108 (5-Türer) Schrägheck 1st Generation Facelift | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "108 (5-Türer) Schrägheck | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "108 (5-Türer) Schrägheck | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "108 (5-Türer) Schrägheck | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "108 (5-Türer) Schrägheck | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "108 (5-Türer) Schrägheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "108 (5-Türer) Schrägheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "108 (5-Türer) Schrägheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "108 (5-Türer) Schrägheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "108 (5-Türer) Schrägheck 1st Generation | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "2008 (5-Türer) Kombi P24 Facelift | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "2008 (5-Türer) Kombi | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "2008 (5-Türer) Kombi | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2026,
    "Mo": "2008 (5-Türer) Kombi | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "2008 (5-Türer) Kombi P24 | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "2008 (5-Türer) Kombi P24 | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "2008 (5-Türer) Kombi | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "2008 (5-Türer) Kombi | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "2008 (5-Türer) Kombi P24 | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "208 (CC Facelift) (5-Türer) Schrägheck | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "208 (CC Facelift) (5-Türer) Schrägheck | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "208 (CC Facelift) (5-Türer) Schrägheck | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "208 (CC Facelift) (5-Türer) Schrägheck | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "208 (CC Facelift) (5-Türer) Schrägheck | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "208 (CC) (5-Türer) Schrägheck | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "208 (CC) (5-Türer) Schrägheck | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "208 (CC) (5-Türer) Schrägheck | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "208 (CC) (5-Türer) Schrägheck | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "208 (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "208 (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2026,
    "Mo": "208 (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "208 (5-Türer) Schrägheck | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "208 (5-Türer) Schrägheck | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "208 (5-Türer) Schrägheck | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "208 (5-Türer) Schrägheck | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "208 (5-Türer) Schrägheck | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "3008 (5-Türer) Kombi T8 Facelift | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "3008 (5-Türer) Kombi | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "3008 (5-Türer) Kombi | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "3008 (5-Türer) Kombi | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2009,
    "Mo": "3008 (5-Türer) Kombi | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2010,
    "Mo": "3008 (5-Türer) Kombi | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "3008 (5-Türer) Kombi | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "3008 (5-Türer) Kombi | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "3008 (5-Türer) Kombi T8 | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "3008 SUV (5-Türer) SUV P64 | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "3008 SUV (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2026,
    "Mo": "3008 SUV (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "3008 SUV (5-Türer) SUV P84 Facelift | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "3008 SUV (5-Türer) SUV | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "3008 SUV (5-Türer) SUV | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "3008 SUV (5-Türer) SUV | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "3008 SUV (5-Türer) SUV P84 Facelift | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "3008 SUV (5-Türer) SUV | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "3008 SUV (5-Türer) SUV | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "3008 SUV (5-Türer) SUV | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "3008 SUV (5-Türer) SUV | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "3008 SUV (5-Türer) SUV P84 | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "308 (5-Türer) Schrägheck P5 | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "308 (5-Türer) Schrägheck P5 | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "308 (5-Türer) Schrägheck | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "308 (5-Türer) Schrägheck | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "308 (5-Türer) Schrägheck P5 | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "308 (5-Türer) Schrägheck P5 Facelift | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2026,
    "Mo": "308 (5-Türer) Schrägheck | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "308 (5-Türer) Schrägheck T9 Facelift | 2017-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "308 (5-Türer) Schrägheck T9 Facelift | 2017-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "308 (5-Türer) Schrägheck | 2017-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "308 (5-Türer) Schrägheck | 2017-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "308 (5-Türer) Schrägheck T9 Facelift | 2017-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "308 (5-Türer) Schrägheck T9 Facelift | 2017-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "308 (5-Türer) Schrägheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "308 (5-Türer) Schrägheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "308 (5-Türer) Schrägheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "308 (5-Türer) Schrägheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "308 (5-Türer) Schrägheck T9 | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "308 (5-Türer) Schrägheck T9 | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "308 SW (5-Türer) Kombi P5 | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "308 SW (5-Türer) Kombi P5 | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "308 SW (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "308 SW (5-Türer) Kombi | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "308 SW (5-Türer) Kombi P5 | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "308 SW (5-Türer) Kombi P5 Facelift | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2026,
    "Mo": "308 SW (5-Türer) Kombi | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "308 SW (5-Türer) Kombi T9 Facelift | 2017-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "308 SW (5-Türer) Kombi T9 Facelift | 2017-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "308 SW (5-Türer) Kombi | 2017-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "308 SW (5-Türer) Kombi | 2017-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "308 SW (5-Türer) Kombi T9 Facelift | 2017-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "308 SW (5-Türer) Kombi T9 Facelift | 2017-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "308 SW (5-Türer) Kombi | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "308 SW (5-Türer) Kombi | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "308 SW (5-Türer) Kombi | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "308 SW (5-Türer) Kombi T9 | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "308 SW (5-Türer) Kombi T9 | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "408 SUV (5-Türer) Schrägheck | 2022-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "408 SUV (5-Türer) Schrägheck | 2022-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "408 SUV (5-Türer) Schrägheck | 2022-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "408 SUV (5-Türer) Schrägheck | 2022-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2026,
    "Mo": "408 SUV (5-Türer) Schrägheck P54 | 2022-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2026,
    "Mo": "408 SUV (5-Türer) Schrägheck P54 Facelift | 2026-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "5008 SUV (5-Türer) SUV T87 Facelift | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "5008 SUV (5-Türer) SUV | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "5008 SUV (5-Türer) SUV | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "5008 SUV (5-Türer) SUV | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "5008 SUV (5-Türer) SUV T87 Facelift | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "5008 SUV (5-Türer) SUV | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "5008 SUV (5-Türer) SUV | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "5008 SUV (5-Türer) SUV | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "5008 SUV (5-Türer) SUV | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "5008 SUV (5-Türer) SUV T87 | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "5008 SUV 7-Seater (5-Türer) SUV | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "5008 SUV 7-Seater (5-Türer) SUV | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "5008 SUV 7-Seater (5-Türer) SUV | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "5008 SUV 7-Seater (5-Türer) SUV | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "508 (8D Phase I) (4-Türer) Stufenheck 1st Generation Facelift | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "508 (8D Phase I) (4-Türer) Stufenheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "508 (8D Phase I) (4-Türer) Stufenheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "508 (8D Phase I) (4-Türer) Stufenheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "508 (8D Phase I) (4-Türer) Stufenheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2010,
    "Mo": "508 (8D Phase I) (4-Türer) Stufenheck | 2010-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "508 (8D Phase I) (4-Türer) Stufenheck | 2010-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "508 (8D Phase I) (4-Türer) Stufenheck | 2010-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "508 (8D Phase I) (4-Türer) Stufenheck | 2010-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "508 (8D Phase I) (4-Türer) Stufenheck 1st Generation | 2010-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "Altima (4-Türer) Stufenheck | 2013-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "Altima (4-Türer) Stufenheck | 2013-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "Altima (4-Türer) Stufenheck | 2013-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "Altima (4-Türer) Stufenheck | 2016-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "Altima (4-Türer) Stufenheck | 2016-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "Altima (4-Türer) Stufenheck | 2016-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "Ariya (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Ariya (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Ariya (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Ariya (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Ariya (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2026,
    "Mo": "Ariya (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Frontier Crew Cab (4-Türer) Pickup | 2022-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Frontier Crew Cab (4-Türer) Pickup | 2022-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Frontier Crew Cab (4-Türer) Pickup | 2022-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Frontier King Cab (2-Türer) Pickup | 2022-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Frontier King Cab (2-Türer) Pickup | 2022-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Frontier King Cab (2-Türer) Pickup | 2022-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "Juke (5-Türer) SUV F15 1st Facelift | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "Juke (5-Türer) SUV | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "Juke (5-Türer) SUV | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "Juke (5-Türer) SUV | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "Juke (5-Türer) SUV F15 1st Facelift | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "Juke (5-Türer) SUV F15 2nd Facelift | 2018-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "Juke (5-Türer) SUV | 2018-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "Juke (5-Türer) SUV F15 2nd Facelift | 2018-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2010,
    "Mo": "Juke (5-Türer) SUV | 2010-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2011,
    "Mo": "Juke (5-Türer) SUV | 2010-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2012,
    "Mo": "Juke (5-Türer) SUV | 2010-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "Juke (5-Türer) SUV | 2010-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "Juke (5-Türer) SUV F15 | 2010-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Juke (5-Türer) SUV F16 Facelift | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Juke (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2026,
    "Mo": "Juke (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "Juke (5-Türer) SUV F16 | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "Juke (5-Türer) SUV | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Juke (5-Türer) SUV | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Juke (5-Türer) SUV | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Juke (5-Türer) SUV F16 | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "Leaf (5-Türer) Schrägheck ZE0 1st Facelift | 2013-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "Leaf (5-Türer) Schrägheck | 2013-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "Leaf (5-Türer) Schrägheck | 2013-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "Leaf (5-Türer) Schrägheck | 2016-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "Leaf (5-Türer) Schrägheck | 2016-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "Leaf (5-Türer) Schrägheck | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "Leaf (5-Türer) Schrägheck | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "Leaf (5-Türer) Schrägheck | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "Leaf (5-Türer) Schrägheck | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Leaf (5-Türer) Schrägheck ZE1 | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Leaf (5-Türer) Schrägheck ZE1 Facelift | 2022-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Leaf (5-Türer) Schrägheck | 2022-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Leaf (5-Türer) Schrägheck | 2022-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Leaf (5-Türer) Schrägheck | 2022-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2011,
    "Mo": "Leaf (5-Türer) Schrägheck | 2011-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2012,
    "Mo": "Leaf (5-Türer) Schrägheck | 2011-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "Leaf (5-Türer) Schrägheck ZE0 | 2011-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "Micra (5-Türer) Schrägheck | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "Micra (5-Türer) Schrägheck | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "Micra (5-Türer) Schrägheck | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "Micra (5-Türer) Schrägheck K13 Facelift | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2010,
    "Mo": "Micra (5-Türer) Schrägheck | 2010-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2011,
    "Mo": "Micra (5-Türer) Schrägheck | 2010-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2012,
    "Mo": "Micra (5-Türer) Schrägheck | 2010-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "Micra (5-Türer) Schrägheck | 2010-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "Micra (5-Türer) Schrägheck K14 | 2017-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "Micra (5-Türer) Schrägheck | 2017-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "Micra (5-Türer) Schrägheck K14 | 2017-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "Micra (5-Türer) Schrägheck K14 Facelift | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "Micra (5-Türer) Schrägheck | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "Micra (5-Türer) Schrägheck | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Micra (5-Türer) Schrägheck | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Micra (5-Türer) Schrägheck | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "Navara Double Cab (4-Türer) Pickup D23 | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "Navara Double Cab (4-Türer) Pickup D23 | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "Navara Double Cab (4-Türer) Pickup | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "Navara Double Cab (4-Türer) Pickup | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "Navara Double Cab (4-Türer) Pickup | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "Navara Double Cab (4-Türer) Pickup | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "Navara Double Cab (4-Türer) Pickup | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Navara Double Cab (4-Türer) Pickup | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Navara Double Cab (4-Türer) Pickup | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Navara Double Cab (4-Türer) Pickup | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Navara Double Cab (4-Türer) Pickup | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2026,
    "Mo": "Navara Double Cab (4-Türer) Pickup | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2005,
    "Mo": "Navara Double Cab (4-Türer) Pickup | 2005-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2006,
    "Mo": "Navara Double Cab (4-Türer) Pickup | 2005-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2007,
    "Mo": "Navara Double Cab (4-Türer) Pickup | 2005-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2008,
    "Mo": "Navara Double Cab (4-Türer) Pickup | 2005-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2009,
    "Mo": "Navara Double Cab (4-Türer) Pickup | 2005-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2010,
    "Mo": "Navara Double Cab (4-Türer) Pickup | 2010-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2011,
    "Mo": "Navara Double Cab (4-Türer) Pickup | 2010-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2012,
    "Mo": "Navara Double Cab (4-Türer) Pickup | 2010-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "Navara Double Cab (4-Türer) Pickup | 2010-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "Navara Double Cab (4-Türer) Pickup | 2010-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "Navara Double Cab (4-Türer) Pickup D40 Facelift | 2010-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "Navara Double Cab (4-Türer) Pickup D40 Facelift | 2010-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "Note (5-Türer) Schrägheck E12 Facelift | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "Note (5-Türer) Schrägheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "Note (5-Türer) Schrägheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "Note (5-Türer) Schrägheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "Note (5-Türer) Schrägheck | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "Note (5-Türer) Schrägheck | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "Note (5-Türer) Schrägheck | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "Note (5-Türer) Schrägheck | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "Note (5-Türer) Schrägheck E12 | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Note (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Note (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2026,
    "Mo": "Note (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "Note (5-Türer) Schrägheck | 2021-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Note (5-Türer) Schrägheck | 2021-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Note (5-Türer) Schrägheck | 2021-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "Qashqai (5-Türer) SUV J11 | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "Qashqai (5-Türer) SUV | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "Qashqai (5-Türer) SUV | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "Qashqai (5-Türer) SUV J11 | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "Qashqai (5-Türer) SUV J11 Facelift | 2017-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "Qashqai (5-Türer) SUV | 2017-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "Qashqai (5-Türer) SUV | 2017-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "Qashqai (5-Türer) SUV | 2017-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "Qashqai (5-Türer) SUV J11 Facelift | 2017-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "Qashqai (5-Türer) SUV J12 | 2021-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Qashqai (5-Türer) SUV | 2021-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Qashqai (5-Türer) SUV | 2021-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Qashqai (5-Türer) SUV J12 | 2021-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Qashqai (5-Türer) SUV J12 Facelift | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Qashqai (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2026,
    "Mo": "Qashqai (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2026,
    "Mo": "X-Trail (5-Türer) SUV T33 Facelift | 2026-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "X-Trail (5-Türer) SUV T33 | 2021-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "X-Trail (5-Türer) SUV | 2021-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "X-Trail (5-Türer) SUV | 2021-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "X-Trail (5-Türer) SUV | 2021-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "X-Trail (5-Türer) SUV | 2021-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2026,
    "Mo": "X-Trail (5-Türer) SUV T33 | 2021-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2012,
    "Mo": "Citigo (3-Türer) Schrägheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2013,
    "Mo": "Citigo (3-Türer) Schrägheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2014,
    "Mo": "Citigo (3-Türer) Schrägheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2015,
    "Mo": "Citigo (3-Türer) Schrägheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2016,
    "Mo": "Citigo (3-Türer) Schrägheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2017,
    "Mo": "Citigo (3-Türer) Schrägheck 1st Generation | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2017,
    "Mo": "Citigo (3-Türer) Schrägheck 1st Generation Facelift | 2017-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2018,
    "Mo": "Citigo (3-Türer) Schrägheck | 2017-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2019,
    "Mo": "Citigo (3-Türer) Schrägheck | 2017-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2012,
    "Mo": "Citigo (5-Türer) Schrägheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2013,
    "Mo": "Citigo (5-Türer) Schrägheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2014,
    "Mo": "Citigo (5-Türer) Schrägheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2015,
    "Mo": "Citigo (5-Türer) Schrägheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2016,
    "Mo": "Citigo (5-Türer) Schrägheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2017,
    "Mo": "Citigo (5-Türer) Schrägheck 1st Generation | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2017,
    "Mo": "Citigo (5-Türer) Schrägheck 1st Generation Facelift | 2017-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2018,
    "Mo": "Citigo (5-Türer) Schrägheck | 2017-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2019,
    "Mo": "Citigo (5-Türer) Schrägheck | 2017-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2020,
    "Mo": "Citigo (5-Türer) Schrägheck | 2020-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2021,
    "Mo": "Citigo (5-Türer) Schrägheck | 2020-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2022,
    "Mo": "Citigo (5-Türer) Schrägheck | 2020-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2021,
    "Mo": "Enyaq Coupé iV (5-Türer) SUV | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2022,
    "Mo": "Enyaq Coupé iV (5-Türer) SUV | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2023,
    "Mo": "Enyaq Coupé iV (5-Türer) SUV | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2024,
    "Mo": "Enyaq Coupé iV (5-Türer) SUV | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2025,
    "Mo": "Enyaq Coupé iV (5-Türer) SUV 1st Generation | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2025,
    "Mo": "Enyaq Coupé iV (5-Türer) SUV 1st Generation Facelift | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2026,
    "Mo": "Enyaq Coupé iV (5-Türer) SUV | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2010,
    "Mo": "Fabia (3T4 Facelift) (5-Türer) Schrägheck | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2011,
    "Mo": "Fabia (3T4 Facelift) (5-Türer) Schrägheck | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2012,
    "Mo": "Fabia (3T4 Facelift) (5-Türer) Schrägheck | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2013,
    "Mo": "Fabia (3T4 Facelift) (5-Türer) Schrägheck | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2014,
    "Mo": "Fabia (3T4 Facelift) (5-Türer) Schrägheck | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2015,
    "Mo": "Fabia (3T4 Facelift) (5-Türer) Schrägheck | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2007,
    "Mo": "Fabia (5-Türer) Schrägheck | 2007-2010",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2008,
    "Mo": "Fabia (5-Türer) Schrägheck | 2007-2010",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2009,
    "Mo": "Fabia (5-Türer) Schrägheck | 2007-2010",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2010,
    "Mo": "Fabia (5-Türer) Schrägheck | 2007-2010",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2018,
    "Mo": "Fabia (5-Türer) Schrägheck NJ Facelift | 2018-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2019,
    "Mo": "Fabia (5-Türer) Schrägheck | 2018-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2020,
    "Mo": "Fabia (5-Türer) Schrägheck | 2018-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2021,
    "Mo": "Fabia (5-Türer) Schrägheck NJ Facelift | 2018-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2015,
    "Mo": "Fabia (5-Türer) Schrägheck | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2016,
    "Mo": "Fabia (5-Türer) Schrägheck | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2017,
    "Mo": "Fabia (5-Türer) Schrägheck | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2018,
    "Mo": "Fabia (5-Türer) Schrägheck NJ | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2021,
    "Mo": "Fabia (5-Türer) Schrägheck PJ | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2022,
    "Mo": "Fabia (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2023,
    "Mo": "Fabia (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2024,
    "Mo": "Fabia (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2025,
    "Mo": "Fabia (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2026,
    "Mo": "Fabia (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2009,
    "Mo": "Octavia (1Z3 Facelift) (5-Türer) Schrägheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2010,
    "Mo": "Octavia (1Z3 Facelift) (5-Türer) Schrägheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2011,
    "Mo": "Octavia (1Z3 Facelift) (5-Türer) Schrägheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2012,
    "Mo": "Octavia (1Z3 Facelift) (5-Türer) Schrägheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2013,
    "Mo": "Octavia (1Z3 Facelift) (5-Türer) Schrägheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2004,
    "Mo": "Octavia (1Z3) (5-Türer) Schrägheck | 2004-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2005,
    "Mo": "Octavia (1Z3) (5-Türer) Schrägheck | 2004-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2006,
    "Mo": "Octavia (1Z3) (5-Türer) Schrägheck | 2004-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2007,
    "Mo": "Octavia (1Z3) (5-Türer) Schrägheck | 2004-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2008,
    "Mo": "Octavia (1Z3) (5-Türer) Schrägheck | 2004-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2009,
    "Mo": "Octavia (1Z3) (5-Türer) Schrägheck | 2004-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2017,
    "Mo": "Octavia (5E3 Facelift) (5-Türer) Schrägheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2018,
    "Mo": "Octavia (5E3 Facelift) (5-Türer) Schrägheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2019,
    "Mo": "Octavia (5E3 Facelift) (5-Türer) Schrägheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2020,
    "Mo": "Octavia (5E3 Facelift) (5-Türer) Schrägheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2013,
    "Mo": "Octavia (5E3) (5-Türer) Schrägheck | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2014,
    "Mo": "Octavia (5E3) (5-Türer) Schrägheck | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2015,
    "Mo": "Octavia (5E3) (5-Türer) Schrägheck | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2016,
    "Mo": "Octavia (5E3) (5-Türer) Schrägheck | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2017,
    "Mo": "Octavia (5E3) (5-Türer) Schrägheck | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2024,
    "Mo": "Octavia (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2025,
    "Mo": "Octavia (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2026,
    "Mo": "Octavia (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2020,
    "Mo": "Octavia (NX3) (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2021,
    "Mo": "Octavia (NX3) (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2022,
    "Mo": "Octavia (NX3) (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2023,
    "Mo": "Octavia (NX3) (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2024,
    "Mo": "Octavia (NX3) (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2017,
    "Mo": "Rapid (NH3 Facelift) (5-Türer) Schrägheck | 2017-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2018,
    "Mo": "Rapid (NH3 Facelift) (5-Türer) Schrägheck | 2017-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2019,
    "Mo": "Rapid (NH3 Facelift) (5-Türer) Schrägheck | 2017-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2013,
    "Mo": "Rapid (NH3) (5-Türer) Schrägheck | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2014,
    "Mo": "Rapid (NH3) (5-Türer) Schrägheck | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2015,
    "Mo": "Rapid (NH3) (5-Türer) Schrägheck | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2016,
    "Mo": "Rapid (NH3) (5-Türer) Schrägheck | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2017,
    "Mo": "Rapid (NH3) (5-Türer) Schrägheck | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2017,
    "Mo": "Rapid Spaceback (NH1 Facelift) (5-Türer) Schrägheck | 2017-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2018,
    "Mo": "Rapid Spaceback (NH1 Facelift) (5-Türer) Schrägheck | 2017-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2019,
    "Mo": "Rapid Spaceback (NH1 Facelift) (5-Türer) Schrägheck | 2017-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2013,
    "Mo": "Rapid Spaceback (NH1) (5-Türer) Schrägheck | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2014,
    "Mo": "Rapid Spaceback (NH1) (5-Türer) Schrägheck | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2015,
    "Mo": "Rapid Spaceback (NH1) (5-Türer) Schrägheck | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2016,
    "Mo": "Rapid Spaceback (NH1) (5-Türer) Schrägheck | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2017,
    "Mo": "Rapid Spaceback (NH1) (5-Türer) Schrägheck | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2019,
    "Mo": "Scala (5-Türer) Schrägheck | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2020,
    "Mo": "Scala (5-Türer) Schrägheck | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2021,
    "Mo": "Scala (5-Türer) Schrägheck | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2022,
    "Mo": "Scala (5-Türer) Schrägheck | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2023,
    "Mo": "Scala (5-Türer) Schrägheck | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2024,
    "Mo": "Scala (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2025,
    "Mo": "Scala (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2026,
    "Mo": "Scala (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2020,
    "Mo": "Superb (3V3 Facelift) (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2021,
    "Mo": "Superb (3V3 Facelift) (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2022,
    "Mo": "Superb (3V3 Facelift) (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2023,
    "Mo": "Superb (3V3 Facelift) (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2024,
    "Mo": "Superb (3V3 Facelift) (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2015,
    "Mo": "Superb (3V3) (5-Türer) Schrägheck | 2015-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2016,
    "Mo": "Superb (3V3) (5-Türer) Schrägheck | 2015-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2017,
    "Mo": "Superb (3V3) (5-Türer) Schrägheck | 2015-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2018,
    "Mo": "Superb (3V3) (5-Türer) Schrägheck | 2015-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2019,
    "Mo": "Superb (3V3) (5-Türer) Schrägheck | 2015-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2020,
    "Mo": "Superb (3V3) (5-Türer) Schrägheck | 2015-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2024,
    "Mo": "Superb (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2025,
    "Mo": "Superb (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2026,
    "Mo": "Superb (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Alaskan (4-Türer) Pickup | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Alaskan (4-Türer) Pickup | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Alaskan (4-Türer) Pickup | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Alaskan (4-Türer) Pickup | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Alaskan (4-Türer) Pickup | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Alaskan (4-Türer) Pickup | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Alaskan (4-Türer) Pickup | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Alaskan (4-Türer) Pickup | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Alaskan (4-Türer) Pickup | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2026,
    "Mo": "Alaskan (4-Türer) Pickup | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Arkana (5-Türer) SUV | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Arkana (5-Türer) SUV | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Arkana (5-Türer) SUV | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Arkana (5-Türer) SUV | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Arkana (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Arkana (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2026,
    "Mo": "Arkana (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Austral (5-Türer) SUV 1st Generation Facelift | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2026,
    "Mo": "Austral (5-Türer) SUV | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Austral (5-Türer) SUV | 2023-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Austral (5-Türer) SUV | 2023-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Austral (5-Türer) SUV 1st Generation | 2023-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Captur (5-Türer) SUV 1st Generation Facelift | 2017-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Captur (5-Türer) SUV | 2017-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Captur (5-Türer) SUV | 2017-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Captur (5-Türer) SUV 1st Generation Facelift | 2017-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Captur (5-Türer) SUV 1st Generation Facelift | 2017-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Captur (5-Türer) SUV | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Captur (5-Türer) SUV | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Captur (5-Türer) SUV | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Captur (5-Türer) SUV | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Captur (5-Türer) SUV 1st Generation | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Captur (5-Türer) SUV 2nd Generation | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Captur (5-Türer) SUV 2nd Generation | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Captur (5-Türer) SUV | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Captur (5-Türer) SUV | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Captur (5-Türer) SUV 2nd Generation | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Captur (5-Türer) SUV 2nd Generation Facelift | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Captur (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2026,
    "Mo": "Captur (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Clio Hatchback (5-Türer) Schrägheck B7 Phase II | 2023-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Clio Hatchback (5-Türer) Schrägheck | 2023-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Clio Hatchback (5-Türer) Schrägheck | 2023-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2026,
    "Mo": "Clio Hatchback (5-Türer) Schrägheck B7 Phase II | 2023-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Clio Hatchback (5-Türer) Schrägheck | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Clio Hatchback (5-Türer) Schrägheck | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Clio Hatchback (5-Türer) Schrägheck | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Clio Hatchback (5-Türer) Schrägheck | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Clio Hatchback (5-Türer) Schrägheck B7 Phase I | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Clio Hatchback (BH) (5-Türer) Schrägheck | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Clio Hatchback (BH) (5-Türer) Schrägheck | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Clio Hatchback (BH) (5-Türer) Schrägheck | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Clio Hatchback (BH) (5-Türer) Schrägheck | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Clio Hatchback (BH Phase II) (5-Türer) Schrägheck | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Clio Hatchback (BH Phase II) (5-Türer) Schrägheck | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Clio Hatchback (BH Phase II) (5-Türer) Schrägheck | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Clio Hatchback (BH Phase II) (5-Türer) Schrägheck | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Espace (5-Türer) MPV JR Phase I | 2015-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Espace (5-Türer) MPV | 2015-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Espace (5-Türer) MPV | 2015-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Espace (5-Türer) MPV | 2015-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Espace (5-Türer) MPV | 2015-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Espace (5-Türer) MPV JR Phase I | 2015-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Espace (5-Türer) MPV JR Phase II | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Espace (5-Türer) MPV | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Espace (5-Türer) MPV | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Espace (5-Türer) MPV | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Kadjar (5-Türer) SUV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Kadjar (5-Türer) SUV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Kadjar (5-Türer) SUV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Kadjar (5-Türer) SUV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Kadjar (5-Türer) SUV 1st Generation | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Kadjar (5-Türer) SUV 1st Generation Facelift | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Kadjar (5-Türer) SUV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Kadjar (5-Türer) SUV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Kadjar (5-Türer) SUV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Kadjar (5-Türer) SUV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Kadjar (5-Türer) SUV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Kadjar (5-Türer) SUV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2026,
    "Mo": "Kadjar (5-Türer) SUV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Mégane (B9A I) (5-Türer) Schrägheck | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Mégane (B9A I) (5-Türer) Schrägheck | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Mégane (B9A I) (5-Türer) Schrägheck | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Mégane (B9A I) (5-Türer) Schrägheck | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Mégane (B9A I) (5-Türer) Schrägheck | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Mégane (B9A II) (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Mégane (B9A II) (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Mégane (B9A II) (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Mégane (B9A II) (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Mégane (B9A II) (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Mégane (B9A II) (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2026,
    "Mo": "Mégane (B9A II) (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2009,
    "Mo": "Mégane (BZ I) (5-Türer) Schrägheck | 2009-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2010,
    "Mo": "Mégane (BZ I) (5-Türer) Schrägheck | 2009-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2011,
    "Mo": "Mégane (BZ I) (5-Türer) Schrägheck | 2009-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2012,
    "Mo": "Mégane (BZ I) (5-Türer) Schrägheck | 2009-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2012,
    "Mo": "Mégane (BZ II) (5-Türer) Schrägheck | 2012-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Mégane (BZ II) (5-Türer) Schrägheck | 2012-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Mégane (BZ II) (5-Türer) Schrägheck | 2012-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Mégane (BZ III) (5-Türer) Schrägheck | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Mégane (BZ III) (5-Türer) Schrägheck | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Mégane (BZ III) (5-Türer) Schrägheck | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Mégane (BZ III) (5-Türer) Schrägheck | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2012,
    "Mo": "Mégane Grandtour (KZ II) (5-Türer) Kombi | 2012-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Mégane Grandtour (KZ II) (5-Türer) Kombi | 2012-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Mégane Grandtour (KZ II) (5-Türer) Kombi | 2012-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Mégane Grandtour (KZ III) (5-Türer) Kombi | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Mégane Grandtour (KZ III) (5-Türer) Kombi | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Mégane Grandtour (KZ III) (5-Türer) Kombi | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Mégane Grandtour (KZ III) (5-Türer) Kombi | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2009,
    "Mo": "Mégane Grandtour (KZ I) (5-Türer) Kombi | 2009-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2010,
    "Mo": "Mégane Grandtour (KZ I) (5-Türer) Kombi | 2009-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2011,
    "Mo": "Mégane Grandtour (KZ I) (5-Türer) Kombi | 2009-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2012,
    "Mo": "Mégane Grandtour (KZ I) (5-Türer) Kombi | 2009-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Mégane E-TECH (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Mégane E-TECH (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Mégane E-TECH (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Mégane E-TECH (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2026,
    "Mo": "Mégane E-TECH (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Rafale (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Rafale (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2026,
    "Mo": "Rafale (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Grand Scénic (R9) (5-Türer) MPV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Grand Scénic (R9) (5-Türer) MPV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Grand Scénic (R9) (5-Türer) MPV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Grand Scénic (R9) (5-Türer) MPV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Grand Scénic (R9) (5-Türer) MPV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Grand Scénic (R9) (5-Türer) MPV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Grand Scénic (R9) (5-Türer) MPV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Grand Scénic (R9) (5-Türer) MPV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Grand Scénic (R9) (5-Türer) MPV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2026,
    "Mo": "Grand Scénic (R9) (5-Türer) MPV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2010,
    "Mo": "Grand Scénic (5-Türer) MPV | 2010-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2011,
    "Mo": "Grand Scénic (5-Türer) MPV | 2010-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2012,
    "Mo": "Grand Scénic (5-Türer) MPV | 2010-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Grand Scénic (5-Türer) MPV | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Grand Scénic (5-Türer) MPV | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Grand Scénic (5-Türer) MPV | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Grand Scénic (5-Türer) MPV | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Grand Scénic (5-Türer) MPV | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Scénic (J9) (5-Türer) MPV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Scénic (J9) (5-Türer) MPV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Scénic (J9) (5-Türer) MPV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Scénic (J9) (5-Türer) MPV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Scénic (J9) (5-Türer) MPV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Scénic (J9) (5-Türer) MPV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Scénic (J9) (5-Türer) MPV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Scénic (J9) (5-Türer) MPV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Scénic (J9) (5-Türer) MPV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2026,
    "Mo": "Scénic (J9) (5-Türer) MPV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Scénic (5-Türer) MPV | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Scénic (5-Türer) MPV | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Scénic (5-Türer) MPV | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Scénic (5-Türer) MPV | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Scénic (5-Türer) MPV | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2010,
    "Mo": "Scénic (5-Türer) MPV | 2010-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2011,
    "Mo": "Scénic (5-Türer) MPV | 2010-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2012,
    "Mo": "Scénic (5-Türer) MPV | 2010-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Symbioz (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Symbioz (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2026,
    "Mo": "Symbioz (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Talisman (4-Türer) Stufenheck | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Talisman (4-Türer) Stufenheck | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Talisman (4-Türer) Stufenheck | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Talisman (4-Türer) Stufenheck | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Talisman (4-Türer) Stufenheck 1st Generation | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Talisman (4-Türer) Stufenheck 1st Generation Facelift | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Talisman (4-Türer) Stufenheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Talisman (4-Türer) Stufenheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Talisman (4-Türer) Stufenheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Talisman (4-Türer) Stufenheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Talisman (4-Türer) Stufenheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2026,
    "Mo": "Talisman (4-Türer) Stufenheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Twingo (5-Türer) Schrägheck | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Twingo (5-Türer) Schrägheck | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Twingo (5-Türer) Schrägheck | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Twingo (5-Türer) Schrägheck | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Twingo (5-Türer) Schrägheck | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Twingo (5-Türer) Schrägheck III | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Twingo (5-Türer) Schrägheck III Facelift | 2019-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Twingo (5-Türer) Schrägheck | 2019-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Twingo (5-Türer) Schrägheck | 2019-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Twingo (5-Türer) Schrägheck | 2019-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Twingo (5-Türer) Schrägheck | 2019-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Twingo (5-Türer) Schrägheck | 2019-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "2 (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2023,
    "Mo": "2 (5-Türer) Schrägheck XP210 | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "2 (5-Türer) Schrägheck XP210 | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "2 (5-Türer) Schrägheck XP210 | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2026,
    "Mo": "2 (5-Türer) Schrägheck XP210 | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2023,
    "Mo": "2 (5-Türer) Schrägheck DJ 2nd Facelift | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "2 (5-Türer) Schrägheck DJ 2nd Facelift | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "2 (5-Türer) Schrägheck DJ 2nd Facelift | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2026,
    "Mo": "2 (5-Türer) Schrägheck DJ 2nd Facelift | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2016,
    "Mo": "3 Sedan (4-Türer) Stufenheck BN | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2017,
    "Mo": "3 Sedan (4-Türer) Stufenheck | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2018,
    "Mo": "3 Sedan (4-Türer) Stufenheck | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2019,
    "Mo": "3 Sedan (4-Türer) Stufenheck | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2013,
    "Mo": "3 Sedan (4-Türer) Stufenheck | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2014,
    "Mo": "3 Sedan (4-Türer) Stufenheck | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2015,
    "Mo": "3 Sedan (4-Türer) Stufenheck | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2016,
    "Mo": "3 Sedan (4-Türer) Stufenheck BM | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2016,
    "Mo": "3 Sport (5-Türer) Schrägheck BN | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2017,
    "Mo": "3 Sport (5-Türer) Schrägheck | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2018,
    "Mo": "3 Sport (5-Türer) Schrägheck | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2019,
    "Mo": "3 Sport (5-Türer) Schrägheck | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2013,
    "Mo": "3 Sport (5-Türer) Schrägheck | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2014,
    "Mo": "3 Sport (5-Türer) Schrägheck | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2015,
    "Mo": "3 Sport (5-Türer) Schrägheck | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2016,
    "Mo": "3 Sport (5-Türer) Schrägheck BM | 2013-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2015,
    "Mo": "6 Sedan (4-Türer) Stufenheck GJ Facelift | 2015-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2016,
    "Mo": "6 Sedan (4-Türer) Stufenheck | 2015-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2013,
    "Mo": "6 Sedan (4-Türer) Stufenheck | 2013-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2014,
    "Mo": "6 Sedan (4-Türer) Stufenheck | 2013-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2015,
    "Mo": "6 Sedan (4-Türer) Stufenheck GJ | 2013-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2015,
    "Mo": "CX-3 (5-Türer) Schrägheck | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2016,
    "Mo": "CX-3 (5-Türer) Schrägheck | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2017,
    "Mo": "CX-3 (5-Türer) Schrägheck | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2018,
    "Mo": "CX-3 (5-Türer) Schrägheck DK | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2018,
    "Mo": "CX-3 (5-Türer) Schrägheck DK Facelift | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2019,
    "Mo": "CX-3 (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2020,
    "Mo": "CX-3 (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2021,
    "Mo": "CX-3 (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "CX-3 (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2023,
    "Mo": "CX-3 (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "CX-3 (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "CX-3 (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2026,
    "Mo": "CX-3 (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2019,
    "Mo": "CX-30 (5-Türer) Crossover | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2020,
    "Mo": "CX-30 (5-Türer) Crossover | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2021,
    "Mo": "CX-30 (5-Türer) Crossover | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "CX-30 (5-Türer) Crossover | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2023,
    "Mo": "CX-30 (5-Türer) Crossover | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "CX-30 (5-Türer) Crossover | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "CX-30 (5-Türer) Crossover | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2026,
    "Mo": "CX-30 (5-Türer) Crossover | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2017,
    "Mo": "CX-5 (5-Türer) SUV KF | 2017-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2018,
    "Mo": "CX-5 (5-Türer) SUV | 2017-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2019,
    "Mo": "CX-5 (5-Türer) SUV | 2017-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2020,
    "Mo": "CX-5 (5-Türer) SUV | 2017-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2021,
    "Mo": "CX-5 (5-Türer) SUV KF | 2017-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2021,
    "Mo": "CX-5 (5-Türer) SUV KF Facelift | 2021-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "CX-5 (5-Türer) SUV KF Facelift | 2021-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "CX-5 (5-Türer) SUV KF 2nd Facelift | 2022-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2023,
    "Mo": "CX-5 (5-Türer) SUV | 2022-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "CX-5 (5-Türer) SUV | 2022-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "CX-5 (5-Türer) SUV | 2022-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "CX-60 (5-Türer) SUV 1st Generation Facelift | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2026,
    "Mo": "CX-60 (5-Türer) SUV | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "CX-60 (5-Türer) SUV | 2022-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2023,
    "Mo": "CX-60 (5-Türer) SUV | 2022-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "CX-60 (5-Türer) SUV | 2022-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "CX-60 (5-Türer) SUV 1st Generation | 2022-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2016,
    "Mo": "CX-9 (5-Türer) SUV 2nd Generation | 2016-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2017,
    "Mo": "CX-9 (5-Türer) SUV | 2016-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2018,
    "Mo": "CX-9 (5-Türer) SUV | 2016-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2019,
    "Mo": "CX-9 (5-Türer) SUV | 2016-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2020,
    "Mo": "CX-9 (5-Türer) SUV | 2016-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2021,
    "Mo": "CX-9 (5-Türer) SUV | 2016-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "CX-9 (5-Türer) SUV | 2016-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2023,
    "Mo": "CX-9 (5-Türer) SUV | 2016-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "EV4 Sedan (4-Türer) Stufenheck | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2026,
    "Mo": "EV4 Sedan (4-Türer) Stufenheck | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "EV6 (5-Türer) SUV | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2026,
    "Mo": "EV6 (5-Türer) SUV | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "EV6 (5-Türer) SUV | 2022-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "EV6 (5-Türer) SUV | 2022-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "EV6 (5-Türer) SUV | 2022-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "EV9 (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "EV9 (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2026,
    "Mo": "EV9 (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2026,
    "Mo": "K4 (5-Türer) Schrägheck | 2026-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "Niro (5-Türer) SUV | 2023-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "Niro (5-Türer) SUV | 2023-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Niro (5-Türer) SUV | 2023-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2026,
    "Mo": "Niro (5-Türer) SUV | 2023-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2016,
    "Mo": "Optima (4-Türer) Stufenheck | 2016-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2017,
    "Mo": "Optima (4-Türer) Stufenheck | 2016-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Optima (4-Türer) Stufenheck JF | 2016-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Optima (4-Türer) Stufenheck JF Facelift | 2018-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Optima (4-Türer) Stufenheck | 2018-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Optima (4-Türer) Stufenheck | 2018-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Picanto (5-Türer) Schrägheck | 2018-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Picanto (5-Türer) Schrägheck | 2018-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Picanto (5-Türer) Schrägheck | 2018-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "Picanto (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Picanto (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2026,
    "Mo": "Picanto (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Picanto (5-Türer) Schrägheck | 2021-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "Picanto (5-Türer) Schrägheck | 2021-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "Picanto (5-Türer) Schrägheck | 2021-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2012,
    "Mo": "Rio (5-Türer) Schrägheck | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2013,
    "Mo": "Rio (5-Türer) Schrägheck | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2014,
    "Mo": "Rio (5-Türer) Schrägheck | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2015,
    "Mo": "Rio (5-Türer) Schrägheck UB | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2015,
    "Mo": "Rio (5-Türer) Schrägheck UB Facelift | 2015-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2016,
    "Mo": "Rio (5-Türer) Schrägheck | 2015-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2017,
    "Mo": "Rio (5-Türer) Schrägheck UB Facelift | 2015-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2017,
    "Mo": "Rio (5-Türer) Schrägheck YB | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Rio (5-Türer) Schrägheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Rio (5-Türer) Schrägheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Rio (5-Türer) Schrägheck YB | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Rio (5-Türer) Schrägheck YB Facelift | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Rio (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "Rio (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "Rio (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "Rio (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Rio (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2026,
    "Mo": "Rio (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2014,
    "Mo": "Soul (5-Türer) Crossover | 2014-2016",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2015,
    "Mo": "Soul (5-Türer) Crossover | 2014-2016",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2016,
    "Mo": "Soul (5-Türer) Crossover | 2014-2016",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2017,
    "Mo": "Soul (5-Türer) Crossover | 2017-2019",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Soul (5-Türer) Crossover | 2017-2019",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Soul (5-Türer) Crossover PS Facelift | 2017-2019",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Soul (5-Türer) Crossover SK3 | 2019-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Soul (5-Türer) Crossover | 2019-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Soul (5-Türer) Crossover | 2019-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "Soul (5-Türer) Crossover | 2019-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "Soul (5-Türer) Crossover SK3 | 2019-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "Soul (5-Türer) Crossover SK3 | 2019-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "Soul (5-Türer) Crossover SK3 Facelift | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "Soul (5-Türer) Crossover SK3 Facelift | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Soul (5-Türer) Crossover | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2026,
    "Mo": "Soul (5-Türer) Crossover | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2016,
    "Mo": "Sportage (5-Türer) Crossover | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2017,
    "Mo": "Sportage (5-Türer) Crossover | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Sportage (5-Türer) Crossover | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Sportage (5-Türer) Crossover QL | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Sportage (5-Türer) Crossover QL Facelift | 2019-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Sportage (5-Türer) Crossover | 2019-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Sportage (5-Türer) Crossover | 2019-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2010,
    "Mo": "Venga (5-Türer) MPV | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2011,
    "Mo": "Venga (5-Türer) MPV | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2012,
    "Mo": "Venga (5-Türer) MPV | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2013,
    "Mo": "Venga (5-Türer) MPV | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2014,
    "Mo": "Venga (5-Türer) MPV | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2015,
    "Mo": "Venga (5-Türer) MPV YN | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2015,
    "Mo": "Venga (5-Türer) MPV YN Facelift | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2016,
    "Mo": "Venga (5-Türer) MPV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2017,
    "Mo": "Venga (5-Türer) MPV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Venga (5-Türer) MPV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Venga (5-Türer) MPV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "Elantra Sedan (4-Türer) Stufenheck | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "Elantra Sedan (4-Türer) Stufenheck | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "Elantra Sedan (4-Türer) Stufenheck | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "Elantra Sedan (4-Türer) Stufenheck AD | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "Elantra Sedan (4-Türer) Stufenheck AD Facelift | 2019-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "Elantra Sedan (4-Türer) Stufenheck | 2019-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "Elantra Sedan (4-Türer) Stufenheck AD Facelift | 2019-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "Elantra Sedan (4-Türer) Stufenheck CN7 | 2021-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "Elantra Sedan (4-Türer) Stufenheck | 2021-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "Elantra Sedan (4-Türer) Stufenheck | 2021-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "i10 (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "i10 (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2026,
    "Mo": "i10 (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "i10 (5-Türer) Schrägheck | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "i10 (5-Türer) Schrägheck | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "i10 (5-Türer) Schrägheck | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "i10 (5-Türer) Schrägheck | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "i20 (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "i20 (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2026,
    "Mo": "i20 (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "i20 (5-Türer) Schrägheck BC3 | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "i20 (5-Türer) Schrägheck | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "i20 (5-Türer) Schrägheck | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "i20 (5-Türer) Schrägheck | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "i30 (5-Türer) Schrägheck PD | 2017-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "i30 (5-Türer) Schrägheck | 2017-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "i30 (5-Türer) Schrägheck PD | 2017-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "i30 (5-Türer) Schrägheck PD 2nd Facelift | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "i30 (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "i30 (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "i30 (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "i30 (5-Türer) Schrägheck PD 2nd Facelift | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "i30 (5-Türer) Schrägheck PD 3rd Facelift | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "i30 (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2026,
    "Mo": "i30 (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "i30 (5-Türer) Schrägheck PD 1st Facelift | 2019-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "i30 (5-Türer) Schrägheck PD 1st Facelift | 2019-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2021-2023",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2021-2023",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2021-2023",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2024-",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2024-",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2026,
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2024-",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2019-2020",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2019-2020",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "Ioniq 5 (5-Türer) SUV NE Facelift | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "Ioniq 5 (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2026,
    "Mo": "Ioniq 5 (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "Ioniq 5 (5-Türer) SUV | 2022-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "Ioniq 5 (5-Türer) SUV | 2022-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "Ioniq 5 (5-Türer) SUV NE | 2022-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2011,
    "Mo": "ix20 (5-Türer) MPV | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2012,
    "Mo": "ix20 (5-Türer) MPV | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2013,
    "Mo": "ix20 (5-Türer) MPV | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2014,
    "Mo": "ix20 (5-Türer) MPV | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "ix20 (5-Türer) MPV JC | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "ix20 (5-Türer) MPV JC Facelift | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "ix20 (5-Türer) MPV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "ix20 (5-Türer) MPV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "ix20 (5-Türer) MPV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "ix20 (5-Türer) MPV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2010,
    "Mo": "ix35 (5-Türer) SUV | 2010-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2011,
    "Mo": "ix35 (5-Türer) SUV | 2010-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2012,
    "Mo": "ix35 (5-Türer) SUV | 2010-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2013,
    "Mo": "ix35 (5-Türer) SUV | 2010-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2014,
    "Mo": "ix35 (5-Türer) SUV | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "ix35 (5-Türer) SUV | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "ix35 (5-Türer) SUV | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "ix35 (5-Türer) SUV | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "Kona (5-Türer) SUV | 2018-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "Kona (5-Türer) SUV | 2018-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "Kona (5-Türer) SUV | 2018-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "Kona (5-Türer) SUV OS | 2018-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "Kona (5-Türer) SUV OS Facelift | 2021-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "Kona (5-Türer) SUV | 2021-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "Kona (5-Türer) SUV OS Facelift | 2021-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "Kona (5-Türer) SUV SX2 | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "Kona (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "Kona (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2026,
    "Mo": "Kona (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "Santa Fe (5-Türer) SUV | 2016-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "Santa Fe (5-Türer) SUV | 2016-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "Santa Fe (5-Türer) SUV | 2016-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2013,
    "Mo": "Santa Fe (5-Türer) SUV | 2013-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2014,
    "Mo": "Santa Fe (5-Türer) SUV | 2013-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "Santa Fe (5-Türer) SUV | 2013-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "Sonata (4-Türer) Stufenheck DN8 | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "Sonata (4-Türer) Stufenheck | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "Sonata (4-Türer) Stufenheck | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "Sonata (4-Türer) Stufenheck | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "Sonata (4-Türer) Stufenheck | 2015-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "Sonata (4-Türer) Stufenheck | 2015-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "Sonata (4-Türer) Stufenheck LF | 2015-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "Sonata (4-Türer) Stufenheck LF Facelift | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "Sonata (4-Türer) Stufenheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "Sonata (4-Türer) Stufenheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "Sonata (4-Türer) Stufenheck LF Facelift | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "Tucson (5-Türer) Kombi NX Facelift | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "Tucson (5-Türer) Kombi | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2026,
    "Mo": "Tucson (5-Türer) Kombi | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "Tucson (5-Türer) Kombi | 2021-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "Tucson (5-Türer) Kombi | 2021-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "Tucson (5-Türer) Kombi | 2021-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "Tucson (5-Türer) Kombi NX | 2021-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "Tucson (5-Türer) Kombi | 2019-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "Tucson (5-Türer) Kombi | 2019-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "Tucson (5-Türer) Kombi | 2016-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "Tucson (5-Türer) Kombi | 2016-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "Tucson (5-Türer) Kombi | 2016-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Suzuki",
    "Y": 2025,
    "Mo": "e Vitara (5-Türer) SUV | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Suzuki",
    "Y": 2026,
    "Mo": "e Vitara (5-Türer) SUV | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2024,
    "Mo": "ASX (5-Türer) SUV 2nd Generation Facelift | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2025,
    "Mo": "ASX (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2026,
    "Mo": "ASX (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2023,
    "Mo": "ASX (5-Türer) SUV | 2023-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2024,
    "Mo": "ASX (5-Türer) SUV 2nd Generation | 2023-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2024,
    "Mo": "Colt (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2025,
    "Mo": "Colt (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2026,
    "Mo": "Colt (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2007,
    "Mo": "Delica D:5 (CV0W) (5-Türer) MPV | 2007-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2008,
    "Mo": "Delica D:5 (CV0W) (5-Türer) MPV | 2007-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2009,
    "Mo": "Delica D:5 (CV0W) (5-Türer) MPV | 2007-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2010,
    "Mo": "Delica D:5 (CV0W) (5-Türer) MPV | 2007-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2011,
    "Mo": "Delica D:5 (CV0W) (5-Türer) MPV | 2007-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2012,
    "Mo": "Delica D:5 (CV0W) (5-Türer) MPV | 2007-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2013,
    "Mo": "Delica D:5 (CV0W) (5-Türer) MPV | 2007-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2014,
    "Mo": "Delica D:5 (CV0W) (5-Türer) MPV | 2007-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2015,
    "Mo": "Delica D:5 (CV0W) (5-Türer) MPV | 2007-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2016,
    "Mo": "Delica D:5 (CV0W) (5-Türer) MPV | 2007-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2017,
    "Mo": "Delica D:5 (CV0W) (5-Türer) MPV | 2007-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2018,
    "Mo": "Delica D:5 (CV0W) (5-Türer) MPV | 2007-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2019,
    "Mo": "Delica D:5 (CV0W) (5-Türer) MPV CV0 | 2007-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2019,
    "Mo": "Delica D:5 (CV0W) (5-Türer) MPV CV0 1st Facelift | 2019-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2020,
    "Mo": "Delica D:5 (CV0W) (5-Türer) MPV | 2019-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2021,
    "Mo": "Delica D:5 (CV0W) (5-Türer) MPV | 2019-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2022,
    "Mo": "Delica D:5 (CV0W) (5-Türer) MPV | 2019-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2023,
    "Mo": "Delica D:5 (CV0W) (5-Türer) MPV | 2019-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2024,
    "Mo": "Delica D:5 (CV0W) (5-Türer) MPV | 2019-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2025,
    "Mo": "Delica D:5 (CV0W) (5-Türer) MPV | 2019-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2006,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2006-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2007,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2006-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2008,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2006-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2009,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2006-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2010,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2006-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2011,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2006-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2012,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2006-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2013,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2006-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2014,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2006-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2015,
    "Mo": "L200 Double Cab (4-Türer) Pickup 4th Generation | 2006-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2022,
    "Mo": "Outlander 5-seater (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2023,
    "Mo": "Outlander 5-seater (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2024,
    "Mo": "Outlander 5-seater (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2025,
    "Mo": "Outlander 5-seater (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2026,
    "Mo": "Outlander 5-seater (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2015,
    "Mo": "Pajero (5-Türer) SUV | 2015-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2016,
    "Mo": "Pajero (5-Türer) SUV | 2015-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2017,
    "Mo": "Pajero (5-Türer) SUV | 2015-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2018,
    "Mo": "Pajero (5-Türer) SUV | 2015-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2019,
    "Mo": "Pajero (5-Türer) SUV | 2015-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2020,
    "Mo": "Pajero (5-Türer) SUV | 2015-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2021,
    "Mo": "Pajero (5-Türer) SUV | 2015-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2012,
    "Mo": "Pajero (5-Türer) SUV V80 1st Facelift | 2012-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2013,
    "Mo": "Pajero (5-Türer) SUV | 2012-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2014,
    "Mo": "Pajero (5-Türer) SUV | 2012-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2016,
    "Mo": "Civic Sedan (4-Türer) Stufenheck | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2017,
    "Mo": "Civic Sedan (4-Türer) Stufenheck | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2018,
    "Mo": "Civic Sedan (4-Türer) Stufenheck | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2019,
    "Mo": "Civic Sedan (4-Türer) Stufenheck 10th Generation | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2019,
    "Mo": "Civic Sedan (4-Türer) Stufenheck 10th Generation Facelift | 2019-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2020,
    "Mo": "Civic Sedan (4-Türer) Stufenheck | 2019-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2021,
    "Mo": "Civic Sedan (4-Türer) Stufenheck | 2019-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2022,
    "Mo": "Civic Sedan (4-Türer) Stufenheck | 2022-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2023,
    "Mo": "Civic Sedan (4-Türer) Stufenheck | 2022-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2024,
    "Mo": "Civic Sedan (4-Türer) Stufenheck | 2022-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2025,
    "Mo": "Civic Sedan (4-Türer) Stufenheck | 2022-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2009,
    "Mo": "Civic Sedan (4-Türer) Stufenheck 8th Generation Facelift | 2009-2011",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2010,
    "Mo": "Civic Sedan (4-Türer) Stufenheck | 2009-2011",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2011,
    "Mo": "Civic Sedan (4-Türer) Stufenheck | 2009-2011",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2006,
    "Mo": "Civic Sedan (4-Türer) Stufenheck | 2006-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2007,
    "Mo": "Civic Sedan (4-Türer) Stufenheck | 2006-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2008,
    "Mo": "Civic Sedan (4-Türer) Stufenheck | 2006-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2009,
    "Mo": "Civic Sedan (4-Türer) Stufenheck 8th Generation | 2006-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2026,
    "Mo": "Civic (5-Türer) Schrägheck | 2026-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2022,
    "Mo": "Civic (5-Türer) Schrägheck | 2022-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2023,
    "Mo": "Civic (5-Türer) Schrägheck | 2022-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2024,
    "Mo": "Civic (5-Türer) Schrägheck | 2022-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2025,
    "Mo": "Civic (5-Türer) Schrägheck | 2022-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2016,
    "Mo": "Civic (5-Türer) Schrägheck 10th Generation | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2017,
    "Mo": "Civic (5-Türer) Schrägheck 10th Generation | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2018,
    "Mo": "Civic (5-Türer) Schrägheck | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2019,
    "Mo": "Civic (5-Türer) Schrägheck 10th Generation | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2019,
    "Mo": "Civic (5-Türer) Schrägheck 10th Generation Facelift | 2019-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2020,
    "Mo": "Civic (5-Türer) Schrägheck | 2019-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2021,
    "Mo": "Civic (5-Türer) Schrägheck | 2019-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2012,
    "Mo": "Civic (5-Türer) Schrägheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2013,
    "Mo": "Civic (5-Türer) Schrägheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2014,
    "Mo": "Civic (5-Türer) Schrägheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2015,
    "Mo": "Civic (5-Türer) Schrägheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2016,
    "Mo": "Civic (5-Türer) Schrägheck 9th Generation | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2017,
    "Mo": "Civic (5-Türer) Schrägheck 9th Generation | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2015,
    "Mo": "CR-V (5-Türer) SUV RM Facelift | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2016,
    "Mo": "CR-V (5-Türer) SUV | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2017,
    "Mo": "CR-V (5-Türer) SUV RM Facelift | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2018,
    "Mo": "CR-V (5-Türer) SUV RM Facelift | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2012,
    "Mo": "CR-V (5-Türer) SUV RM | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2013,
    "Mo": "CR-V (5-Türer) SUV | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2014,
    "Mo": "CR-V (5-Türer) SUV | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2015,
    "Mo": "CR-V (5-Türer) SUV RM | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2017,
    "Mo": "CR-V (5-Türer) SUV RW/RT | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2018,
    "Mo": "CR-V (5-Türer) SUV RW/RT | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2019,
    "Mo": "CR-V (5-Türer) SUV | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2020,
    "Mo": "CR-V (5-Türer) SUV RW/RT | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2020,
    "Mo": "CR-V (5-Türer) SUV RW/RT Facelift | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2021,
    "Mo": "CR-V (5-Türer) SUV | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2022,
    "Mo": "CR-V (5-Türer) SUV | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2023,
    "Mo": "CR-V (5-Türer) SUV | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2019,
    "Mo": "HR-V (5-Türer) SUV RU Facelift | 2019-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2020,
    "Mo": "HR-V (5-Türer) SUV | 2019-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2021,
    "Mo": "HR-V (5-Türer) SUV RU Facelift | 2019-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2022,
    "Mo": "HR-V (5-Türer) SUV RU Facelift | 2019-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2016,
    "Mo": "HR-V (5-Türer) SUV | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2017,
    "Mo": "HR-V (5-Türer) SUV | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2018,
    "Mo": "HR-V (5-Türer) SUV | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2019,
    "Mo": "HR-V (5-Türer) SUV RU | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2009,
    "Mo": "Jazz (5-Türer) Schrägheck | 2009-2011",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2010,
    "Mo": "Jazz (5-Türer) Schrägheck | 2009-2011",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2011,
    "Mo": "Jazz (5-Türer) Schrägheck GE | 2009-2011",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2011,
    "Mo": "Jazz (5-Türer) Schrägheck GE Facelift | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2012,
    "Mo": "Jazz (5-Türer) Schrägheck | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2013,
    "Mo": "Jazz (5-Türer) Schrägheck | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2014,
    "Mo": "Jazz (5-Türer) Schrägheck GE Facelift | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2015,
    "Mo": "Jazz (5-Türer) Schrägheck GE Facelift | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2014,
    "Mo": "Jazz (5-Türer) Schrägheck GK | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2015,
    "Mo": "Jazz (5-Türer) Schrägheck GK | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2016,
    "Mo": "Jazz (5-Türer) Schrägheck | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2017,
    "Mo": "Jazz (5-Türer) Schrägheck | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2018,
    "Mo": "Jazz (5-Türer) Schrägheck | 2018-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2019,
    "Mo": "Jazz (5-Türer) Schrägheck | 2018-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2020,
    "Mo": "Jazz (5-Türer) Schrägheck GK Facelift | 2018-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2020,
    "Mo": "Jazz (5-Türer) Schrägheck GR/GS | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2021,
    "Mo": "Jazz (5-Türer) Schrägheck | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2022,
    "Mo": "Jazz (5-Türer) Schrägheck | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2023,
    "Mo": "Jazz (5-Türer) Schrägheck GR/GS | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2023,
    "Mo": "Jazz (5-Türer) Schrägheck GR/GS Facelift | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2024,
    "Mo": "Jazz (5-Türer) Schrägheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2025,
    "Mo": "Jazz (5-Türer) Schrägheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2026,
    "Mo": "Jazz (5-Türer) Schrägheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "500L (5-Türer) Schrägheck 351/352 Facelift | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "500L (5-Türer) Schrägheck | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "500L (5-Türer) Schrägheck | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "500L (5-Türer) Schrägheck | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "500L (5-Türer) Schrägheck | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "500L (5-Türer) Schrägheck | 2012-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "500L (5-Türer) Schrägheck | 2012-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "500L (5-Türer) Schrägheck | 2012-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "500L (5-Türer) Schrägheck | 2012-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "500L (5-Türer) Schrägheck | 2012-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "500L (5-Türer) Schrägheck | 2012-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "500L (5-Türer) Schrägheck 351/352 | 2012-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "500X (5-Türer) Crossover | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "500X (5-Türer) Crossover | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "500X (5-Türer) Crossover | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "500X (5-Türer) Crossover | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "500X (5-Türer) Crossover 334 | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "500X (5-Türer) Crossover 334 1st Facelift | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "500X (5-Türer) Crossover | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "500X (5-Türer) Crossover | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "500X (5-Türer) Crossover 334 1st Facelift | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "500X (5-Türer) Crossover 334 1st Facelift | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "500X (5-Türer) Crossover 334 1st Facelift | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "500X (5-Türer) Crossover 334 1st Facelift | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2026,
    "Mo": "500X (5-Türer) Crossover 334 1st Facelift | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "500X (5-Türer) Crossover 334 2nd Facelift | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "500X (5-Türer) Crossover 334 2nd Facelift | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "500X (5-Türer) Crossover 334 2nd Facelift | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "500X (5-Türer) Crossover 334 2nd Facelift | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2026,
    "Mo": "500X (5-Türer) Crossover 334 2nd Facelift | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "600 SUV (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "600 SUV (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "600 SUV (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2026,
    "Mo": "600 SUV (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Punto (5-Türer) Schrägheck 199 2nd Facelift | 2012-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Punto (5-Türer) Schrägheck | 2012-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Punto (5-Türer) Schrägheck | 2012-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Punto (5-Türer) Schrägheck | 2012-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Punto (5-Türer) Schrägheck | 2012-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Punto (5-Türer) Schrägheck | 2012-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Punto (5-Türer) Schrägheck | 2012-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2006,
    "Mo": "Punto (5-Türer) Schrägheck | 2006-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2007,
    "Mo": "Punto (5-Türer) Schrägheck | 2006-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2008,
    "Mo": "Punto (5-Türer) Schrägheck | 2006-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2009,
    "Mo": "Punto (5-Türer) Schrägheck | 2006-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Punto (5-Türer) Schrägheck | 2010-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Punto (5-Türer) Schrägheck | 2010-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Punto (5-Türer) Schrägheck 199 1st Facelift | 2010-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2021,
    "Mo": "Ateca (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2022,
    "Mo": "Ateca (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2023,
    "Mo": "Ateca (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2024,
    "Mo": "Ateca (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2025,
    "Mo": "Ateca (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2026,
    "Mo": "Ateca (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2016,
    "Mo": "Ateca (5-Türer) SUV | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2017,
    "Mo": "Ateca (5-Türer) SUV | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2018,
    "Mo": "Ateca (5-Türer) SUV | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2019,
    "Mo": "Ateca (5-Türer) SUV | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2020,
    "Mo": "Ateca (5-Türer) SUV | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2016,
    "Mo": "Ibiza (5-Türer) Schrägheck | 2016-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2017,
    "Mo": "Ibiza (5-Türer) Schrägheck | 2016-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2012,
    "Mo": "Ibiza (5-Türer) Schrägheck 6J 1st Facelift | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2013,
    "Mo": "Ibiza (5-Türer) Schrägheck | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2014,
    "Mo": "Ibiza (5-Türer) Schrägheck | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2015,
    "Mo": "Ibiza (5-Türer) Schrägheck | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2009,
    "Mo": "Ibiza (5-Türer) Schrägheck | 2009-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2010,
    "Mo": "Ibiza (5-Türer) Schrägheck | 2009-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2011,
    "Mo": "Ibiza (5-Türer) Schrägheck | 2009-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2012,
    "Mo": "Ibiza (5-Türer) Schrägheck 6J | 2009-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2021,
    "Mo": "Ibiza (5-Türer) Schrägheck 6F 1st Facelift | 2021-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2022,
    "Mo": "Ibiza (5-Türer) Schrägheck | 2021-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2023,
    "Mo": "Ibiza (5-Türer) Schrägheck | 2021-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2024,
    "Mo": "Ibiza (5-Türer) Schrägheck | 2021-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2025,
    "Mo": "Ibiza (5-Türer) Schrägheck | 2021-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2026,
    "Mo": "Ibiza (5-Türer) Schrägheck 6F 1st Facelift | 2021-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2018,
    "Mo": "Ibiza (5-Türer) Schrägheck | 2018-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2019,
    "Mo": "Ibiza (5-Türer) Schrägheck | 2018-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2020,
    "Mo": "Ibiza (5-Türer) Schrägheck | 2018-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2021,
    "Mo": "Ibiza (5-Türer) Schrägheck 6F | 2018-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2026,
    "Mo": "Ibiza (5-Türer) Schrägheck 6F 2nd Facelift | 2026-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2006,
    "Mo": "León (5-Türer) Schrägheck | 2006-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2007,
    "Mo": "León (5-Türer) Schrägheck | 2006-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2008,
    "Mo": "León (5-Türer) Schrägheck | 2006-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2009,
    "Mo": "León (5-Türer) Schrägheck 1P | 2006-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2009,
    "Mo": "León (5-Türer) Schrägheck 1P Facelift | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2010,
    "Mo": "León (5-Türer) Schrägheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2011,
    "Mo": "León (5-Türer) Schrägheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2012,
    "Mo": "León (5-Türer) Schrägheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2013,
    "Mo": "León (5-Türer) Schrägheck 1P Facelift | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2013,
    "Mo": "León (5-Türer) Schrägheck 5F | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2014,
    "Mo": "León (5-Türer) Schrägheck | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2015,
    "Mo": "León (5-Türer) Schrägheck | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2016,
    "Mo": "León (5-Türer) Schrägheck | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2017,
    "Mo": "León (5-Türer) Schrägheck 5F | 2013-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2017,
    "Mo": "León (5-Türer) Schrägheck 5F Facelift | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2018,
    "Mo": "León (5-Türer) Schrägheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2019,
    "Mo": "León (5-Türer) Schrägheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2020,
    "Mo": "León (5-Türer) Schrägheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2020,
    "Mo": "León (KL1) (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2021,
    "Mo": "León (KL1) (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2022,
    "Mo": "León (KL1) (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2023,
    "Mo": "León (KL1) (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2024,
    "Mo": "León (KL1) (5-Türer) Schrägheck | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2024,
    "Mo": "León (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2025,
    "Mo": "León (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2026,
    "Mo": "León (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2012,
    "Mo": "Mii (3-Türer) Schrägheck | 2012-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2013,
    "Mo": "Mii (3-Türer) Schrägheck | 2012-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2014,
    "Mo": "Mii (3-Türer) Schrägheck | 2012-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2015,
    "Mo": "Mii (3-Türer) Schrägheck | 2012-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2016,
    "Mo": "Mii (3-Türer) Schrägheck | 2012-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2017,
    "Mo": "Mii (3-Türer) Schrägheck | 2012-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2018,
    "Mo": "Mii (3-Türer) Schrägheck | 2012-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2019,
    "Mo": "Mii (3-Türer) Schrägheck | 2012-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2020,
    "Mo": "Mii (3-Türer) Schrägheck | 2012-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2021,
    "Mo": "Mii (3-Türer) Schrägheck | 2012-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2012,
    "Mo": "Mii (5-Türer) Schrägheck | 2012-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2013,
    "Mo": "Mii (5-Türer) Schrägheck | 2012-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2014,
    "Mo": "Mii (5-Türer) Schrägheck | 2012-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2015,
    "Mo": "Mii (5-Türer) Schrägheck | 2012-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2016,
    "Mo": "Mii (5-Türer) Schrägheck | 2012-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2017,
    "Mo": "Mii (5-Türer) Schrägheck | 2012-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2018,
    "Mo": "Mii (5-Türer) Schrägheck | 2012-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2019,
    "Mo": "Mii (5-Türer) Schrägheck | 2012-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2020,
    "Mo": "Mii (5-Türer) Schrägheck | 2012-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2021,
    "Mo": "Mii (5-Türer) Schrägheck | 2012-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2013,
    "Mo": "Toledo (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2014,
    "Mo": "Toledo (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2015,
    "Mo": "Toledo (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2016,
    "Mo": "Toledo (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2017,
    "Mo": "Toledo (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2018,
    "Mo": "Toledo (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Y": 2019,
    "Mo": "Toledo (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2012,
    "Mo": "Impreza Sedan (4-Türer) Stufenheck | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2013,
    "Mo": "Impreza Sedan (4-Türer) Stufenheck | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2014,
    "Mo": "Impreza Sedan (4-Türer) Stufenheck | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2015,
    "Mo": "Impreza Sedan (4-Türer) Stufenheck | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2016,
    "Mo": "Impreza Sedan (4-Türer) Stufenheck | 2012-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2015,
    "Mo": "Legacy (BN) (4-Türer) Stufenheck | 2015-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2016,
    "Mo": "Legacy (BN) (4-Türer) Stufenheck | 2015-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2017,
    "Mo": "Legacy (BN) (4-Türer) Stufenheck | 2015-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2018,
    "Mo": "Legacy (4-Türer) Stufenheck | 2018-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2019,
    "Mo": "Legacy (4-Türer) Stufenheck | 2018-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2020,
    "Mo": "Legacy (4-Türer) Stufenheck | 2018-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2026,
    "Mo": "Solterra (5-Türer) SUV | 2026-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2023,
    "Mo": "Solterra (5-Türer) SUV | 2023-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2024,
    "Mo": "Solterra (5-Türer) SUV | 2023-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2025,
    "Mo": "Solterra (5-Türer) SUV | 2023-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2014,
    "Mo": "WRX (4-Türer) Stufenheck | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2015,
    "Mo": "WRX (4-Türer) Stufenheck | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2016,
    "Mo": "WRX (4-Türer) Stufenheck | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2017,
    "Mo": "WRX (4-Türer) Stufenheck | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2018,
    "Mo": "WRX (4-Türer) Stufenheck | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2019,
    "Mo": "WRX (4-Türer) Stufenheck | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2020,
    "Mo": "WRX (4-Türer) Stufenheck | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2021,
    "Mo": "WRX (4-Türer) Stufenheck | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2024,
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2025,
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2026,
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2018,
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2019,
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2020,
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2021,
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2022,
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2023,
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2011,
    "Mo": "Cayenne (92A) (5-Türer) SUV | 2011-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2012,
    "Mo": "Cayenne (92A) (5-Türer) SUV | 2011-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2013,
    "Mo": "Cayenne (92A) (5-Türer) SUV | 2011-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2014,
    "Mo": "Cayenne (92A) (5-Türer) SUV | 2011-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2015,
    "Mo": "Cayenne (92A) (5-Türer) SUV | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2016,
    "Mo": "Cayenne (92A) (5-Türer) SUV | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2017,
    "Mo": "Cayenne (92A) (5-Türer) SUV | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2018,
    "Mo": "Cayenne (92A) (5-Türer) SUV | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2024,
    "Mo": "Cayenne Coupe (9YB) (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2025,
    "Mo": "Cayenne Coupe (9YB) (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2026,
    "Mo": "Cayenne Coupe (9YB) (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2020,
    "Mo": "Cayenne Coupe (9YB) (5-Türer) SUV | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2021,
    "Mo": "Cayenne Coupe (9YB) (5-Türer) SUV | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2022,
    "Mo": "Cayenne Coupe (9YB) (5-Türer) SUV | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2023,
    "Mo": "Cayenne Coupe (9YB) (5-Türer) SUV | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2014,
    "Mo": "Macan (5-Türer) SUV | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2015,
    "Mo": "Macan (5-Türer) SUV | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2016,
    "Mo": "Macan (5-Türer) SUV | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2017,
    "Mo": "Macan (5-Türer) SUV | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2018,
    "Mo": "Macan (5-Türer) SUV | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2022,
    "Mo": "Macan (5-Türer) SUV | 2022-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2023,
    "Mo": "Macan (5-Türer) SUV | 2022-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2024,
    "Mo": "Macan (5-Türer) SUV 95B.3 | 2022-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2019,
    "Mo": "Macan (5-Türer) SUV | 2019-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2020,
    "Mo": "Macan (5-Türer) SUV | 2019-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2021,
    "Mo": "Macan (5-Türer) SUV | 2019-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2017,
    "Mo": "Panamera (97A) (5-Türer) Schrägheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2018,
    "Mo": "Panamera (97A) (5-Türer) Schrägheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2019,
    "Mo": "Panamera (97A) (5-Türer) Schrägheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2020,
    "Mo": "Panamera (97A) (5-Türer) Schrägheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2021,
    "Mo": "Panamera (97A) (5-Türer) Schrägheck | 2021-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2022,
    "Mo": "Panamera (97A) (5-Türer) Schrägheck | 2021-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2023,
    "Mo": "Panamera (97A) (5-Türer) Schrägheck | 2021-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2024,
    "Mo": "Panamera (97A) (5-Türer) Schrägheck | 2021-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2018,
    "Mo": "Panamera Sport Turismo (97C) (5-Türer) Kombi | 2018-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2019,
    "Mo": "Panamera Sport Turismo (97C) (5-Türer) Kombi | 2018-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2020,
    "Mo": "Panamera Sport Turismo (97C) (5-Türer) Kombi | 2018-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2021,
    "Mo": "Panamera Sport Turismo (97C) (5-Türer) Kombi | 2021-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2022,
    "Mo": "Panamera Sport Turismo (97C) (5-Türer) Kombi | 2021-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2023,
    "Mo": "Panamera Sport Turismo (97C) (5-Türer) Kombi | 2021-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2024,
    "Mo": "Panamera Sport Turismo (97C) (5-Türer) Kombi | 2021-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Y": 2016,
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Y": 2017,
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Y": 2018,
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Y": 2019,
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Y": 2019,
    "Mo": "Clubman (F54 LCI) (5-Türer) Kombi | 2019-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Y": 2020,
    "Mo": "Clubman (F54 LCI) (5-Türer) Kombi | 2019-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Y": 2021,
    "Mo": "Clubman (F54 LCI) (5-Türer) Kombi F54 1st LCI | 2019-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Y": 2021,
    "Mo": "Clubman (F54 LCI) (5-Türer) Kombi F54 2nd LCI | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Y": 2022,
    "Mo": "Clubman (F54 LCI) (5-Türer) Kombi | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Y": 2023,
    "Mo": "Clubman (F54 LCI) (5-Türer) Kombi | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Y": 2024,
    "Mo": "Clubman (F54 LCI) (5-Türer) Kombi | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Y": 2025,
    "Mo": "Clubman (F54 LCI) (5-Türer) Kombi | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Y": 2026,
    "Mo": "Clubman (F54 LCI) (5-Türer) Kombi | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Y": 2019,
    "Mo": "5-door (F55 LCI) (5-Türer) Schrägheck | 2019-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Y": 2020,
    "Mo": "5-door (F55 LCI) (5-Türer) Schrägheck | 2019-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Y": 2021,
    "Mo": "5-door (F55 LCI) (5-Türer) Schrägheck F56 1st LCI | 2019-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Y": 2021,
    "Mo": "5-door (F55 LCI) (5-Türer) Schrägheck F56 2nd LCI | 2021-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Y": 2022,
    "Mo": "5-door (F55 LCI) (5-Türer) Schrägheck | 2021-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Y": 2023,
    "Mo": "5-door (F55 LCI) (5-Türer) Schrägheck | 2021-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Y": 2024,
    "Mo": "5-door (F55 LCI) (5-Türer) Schrägheck | 2021-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Y": 2014,
    "Mo": "5-door (F55) (5-Türer) Schrägheck | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Y": 2015,
    "Mo": "5-door (F55) (5-Türer) Schrägheck | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Y": 2016,
    "Mo": "5-door (F55) (5-Türer) Schrägheck | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Y": 2017,
    "Mo": "5-door (F55) (5-Türer) Schrägheck | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Y": 2018,
    "Mo": "5-door (F55) (5-Türer) Schrägheck | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Y": 2019,
    "Mo": "5-door (F55) (5-Türer) Schrägheck | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2015,
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2016,
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2017,
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2018,
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2019,
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2024,
    "Mo": "Discovery Sport (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2025,
    "Mo": "Discovery Sport (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2026,
    "Mo": "Discovery Sport (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2020,
    "Mo": "Discovery Sport (5-Türer) SUV | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2021,
    "Mo": "Discovery Sport (5-Türer) SUV | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2022,
    "Mo": "Discovery Sport (5-Türer) SUV | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2023,
    "Mo": "Discovery Sport (5-Türer) SUV | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2013,
    "Mo": "Freelander (5-Türer) SUV L359 (Type LF) 2nd Facelift | 2013-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2014,
    "Mo": "Freelander (5-Türer) SUV | 2013-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2015,
    "Mo": "Freelander (5-Türer) SUV | 2013-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2007,
    "Mo": "Freelander (5-Türer) SUV | 2007-2010",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2008,
    "Mo": "Freelander (5-Türer) SUV | 2007-2010",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2009,
    "Mo": "Freelander (5-Türer) SUV | 2007-2010",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2010,
    "Mo": "Freelander (5-Türer) SUV | 2007-2010",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2011,
    "Mo": "Freelander (5-Türer) SUV | 2011-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2012,
    "Mo": "Freelander (5-Türer) SUV | 2011-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2013,
    "Mo": "Freelander (5-Türer) SUV L359 (Type LF) 1st Facelift | 2011-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2016,
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2017,
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2018,
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2019,
    "Mo": "Range Rover Evoque (5-Türer) SUV L538 (Type LV) Facelift | 2016-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2012,
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2013,
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2014,
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2015,
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2024,
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2025,
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2026,
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2019,
    "Mo": "Range Rover Evoque (5-Türer) SUV L551 (Type LZ) | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2020,
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2021,
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2022,
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2023,
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2010,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2010-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2011,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2010-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2012,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2010-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2013,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2010-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2005,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2005-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2006,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2005-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2007,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2005-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2008,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2005-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2009,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2005-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2023,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2024,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2025,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2026,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2014,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2015,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2016,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2017,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2018,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2019,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2020,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2021,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2022,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MG",
    "Y": 2024,
    "Mo": "3 (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MG",
    "Y": 2025,
    "Mo": "3 (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MG",
    "Y": 2026,
    "Mo": "3 (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MG",
    "Y": 2022,
    "Mo": "4 (EH32) (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MG",
    "Y": 2023,
    "Mo": "4 (EH32) (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MG",
    "Y": 2024,
    "Mo": "4 (EH32) (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MG",
    "Y": 2025,
    "Mo": "4 (EH32) (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MG",
    "Y": 2026,
    "Mo": "4 (EH32) (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Polestar",
    "Y": 2024,
    "Mo": "2 (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Polestar",
    "Y": 2025,
    "Mo": "2 (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Polestar",
    "Y": 2026,
    "Mo": "2 (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Polestar",
    "Y": 2020,
    "Mo": "2 (5-Türer) Schrägheck | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Polestar",
    "Y": 2021,
    "Mo": "2 (5-Türer) Schrägheck | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Polestar",
    "Y": 2022,
    "Mo": "2 (5-Türer) Schrägheck | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Polestar",
    "Y": 2023,
    "Mo": "2 (5-Türer) Schrägheck | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Polestar",
    "Y": 2023,
    "Mo": "3 (5-Türer) SUV | 2023-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Polestar",
    "Y": 2024,
    "Mo": "3 (5-Türer) SUV | 2023-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Polestar",
    "Y": 2025,
    "Mo": "3 (5-Türer) SUV | 2023-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Polestar",
    "Y": 2026,
    "Mo": "3 (5-Türer) SUV | 2023-2026",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Polestar",
    "Y": 2024,
    "Mo": "4 (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Polestar",
    "Y": 2025,
    "Mo": "4 (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Polestar",
    "Y": 2026,
    "Mo": "4 (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Lexus",
    "Y": 2021,
    "Mo": "ES (4-Türer) Stufenheck XZ10 1st Facelift | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Lexus",
    "Y": 2022,
    "Mo": "ES (4-Türer) Stufenheck | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Lexus",
    "Y": 2023,
    "Mo": "ES (4-Türer) Stufenheck | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Lexus",
    "Y": 2024,
    "Mo": "ES (4-Türer) Stufenheck | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Lexus",
    "Y": 2025,
    "Mo": "ES (4-Türer) Stufenheck XZ10 1st Facelift | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Lexus",
    "Y": 2025,
    "Mo": "ES (4-Türer) Stufenheck XZ10 2nd Facelift | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Lexus",
    "Y": 2026,
    "Mo": "ES (4-Türer) Stufenheck | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Lexus",
    "Y": 2018,
    "Mo": "ES (4-Türer) Stufenheck | 2018-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Lexus",
    "Y": 2019,
    "Mo": "ES (4-Türer) Stufenheck | 2018-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Lexus",
    "Y": 2020,
    "Mo": "ES (4-Türer) Stufenheck | 2018-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Lexus",
    "Y": 2021,
    "Mo": "ES (4-Türer) Stufenheck XZ10 | 2018-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Lexus",
    "Y": 2023,
    "Mo": "LBX (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Lexus",
    "Y": 2024,
    "Mo": "LBX (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Lexus",
    "Y": 2025,
    "Mo": "LBX (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Lexus",
    "Y": 2026,
    "Mo": "LBX (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jeep",
    "Y": 2023,
    "Mo": "Avenger (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jeep",
    "Y": 2024,
    "Mo": "Avenger (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jeep",
    "Y": 2025,
    "Mo": "Avenger (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jeep",
    "Y": 2026,
    "Mo": "Avenger (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jeep",
    "Y": 2011,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jeep",
    "Y": 2012,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jeep",
    "Y": 2013,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jeep",
    "Y": 2017,
    "Mo": "Grand Cherokee (5-Türer) SUV WK2 2nd Facelift | 2017-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jeep",
    "Y": 2018,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2017-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jeep",
    "Y": 2019,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2017-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jeep",
    "Y": 2020,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2017-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jeep",
    "Y": 2021,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2017-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jeep",
    "Y": 2014,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jeep",
    "Y": 2015,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jeep",
    "Y": 2016,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jeep",
    "Y": 2017,
    "Mo": "Grand Cherokee (5-Türer) SUV WK2 1st Facelift | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jaguar",
    "Y": 2018,
    "Mo": "E-Pace (5-Türer) SUV | 2018-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jaguar",
    "Y": 2019,
    "Mo": "E-Pace (5-Türer) SUV | 2018-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jaguar",
    "Y": 2020,
    "Mo": "E-Pace (5-Türer) SUV | 2018-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jaguar",
    "Y": 2021,
    "Mo": "E-Pace (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jaguar",
    "Y": 2022,
    "Mo": "E-Pace (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jaguar",
    "Y": 2023,
    "Mo": "E-Pace (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jaguar",
    "Y": 2024,
    "Mo": "E-Pace (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jaguar",
    "Y": 2025,
    "Mo": "E-Pace (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jaguar",
    "Y": 2026,
    "Mo": "E-Pace (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jaguar",
    "Y": 2018,
    "Mo": "I-Pace (5-Türer) SUV | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jaguar",
    "Y": 2019,
    "Mo": "I-Pace (5-Türer) SUV | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jaguar",
    "Y": 2020,
    "Mo": "I-Pace (5-Türer) SUV | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jaguar",
    "Y": 2021,
    "Mo": "I-Pace (5-Türer) SUV | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jaguar",
    "Y": 2022,
    "Mo": "I-Pace (5-Türer) SUV | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jaguar",
    "Y": 2023,
    "Mo": "I-Pace (5-Türer) SUV 1st Generation | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jaguar",
    "Y": 2023,
    "Mo": "I-Pace (5-Türer) SUV 1st Generation Facelift | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jaguar",
    "Y": 2024,
    "Mo": "I-Pace (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jaguar",
    "Y": 2025,
    "Mo": "I-Pace (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jaguar",
    "Y": 2026,
    "Mo": "I-Pace (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2009,
    "Mo": "Ram 1500 Quad Cab (4-Türer) Pickup | 2009-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2024,
    "Mo": "D-Max Crew Cab (4-Türer) Pickup RG01 Facelift | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2025,
    "Mo": "D-Max Crew Cab (4-Türer) Pickup | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2026,
    "Mo": "D-Max Crew Cab (4-Türer) Pickup | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2020,
    "Mo": "D-Max Crew Cab (4-Türer) Pickup RG01 | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2021,
    "Mo": "D-Max Crew Cab (4-Türer) Pickup | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2022,
    "Mo": "D-Max Crew Cab (4-Türer) Pickup | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2023,
    "Mo": "D-Max Crew Cab (4-Türer) Pickup | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2024,
    "Mo": "D-Max Crew Cab (4-Türer) Pickup RG01 | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2012,
    "Mo": "D-Max Crew Cab (4-Türer) Pickup | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2013,
    "Mo": "D-Max Crew Cab (4-Türer) Pickup | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2014,
    "Mo": "D-Max Crew Cab (4-Türer) Pickup | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2015,
    "Mo": "D-Max Crew Cab (4-Türer) Pickup RT | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2015,
    "Mo": "D-Max Crew Cab (4-Türer) Pickup RT 1st Facelift | 2015-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2016,
    "Mo": "D-Max Crew Cab (4-Türer) Pickup | 2015-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2017,
    "Mo": "D-Max Crew Cab (4-Türer) Pickup RT 1st Facelift | 2015-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2017,
    "Mo": "D-Max Crew Cab (4-Türer) Pickup RT 2nd Facelift | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2018,
    "Mo": "D-Max Crew Cab (4-Türer) Pickup | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2019,
    "Mo": "D-Max Crew Cab (4-Türer) Pickup | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2020,
    "Mo": "D-Max Crew Cab (4-Türer) Pickup RT 2nd Facelift | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2024,
    "Mo": "D-Max Space Cab (4-Türer) Pickup RG01 Facelift | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2025,
    "Mo": "D-Max Space Cab (4-Türer) Pickup | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2026,
    "Mo": "D-Max Space Cab (4-Türer) Pickup | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2020,
    "Mo": "D-Max Space Cab (4-Türer) Pickup | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2021,
    "Mo": "D-Max Space Cab (4-Türer) Pickup | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2022,
    "Mo": "D-Max Space Cab (4-Türer) Pickup | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2023,
    "Mo": "D-Max Space Cab (4-Türer) Pickup | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2024,
    "Mo": "D-Max Space Cab (4-Türer) Pickup RG01 | 2020-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Maxus",
    "Y": 2022,
    "Mo": "T90 (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Maxus",
    "Y": 2023,
    "Mo": "T90 (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Maxus",
    "Y": 2024,
    "Mo": "T90 (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Maxus",
    "Y": 2025,
    "Mo": "T90 (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Maxus",
    "Y": 2026,
    "Mo": "T90 (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Y": 2013,
    "Mo": "1500 Quad Cab (4-Türer) Pickup | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Y": 2014,
    "Mo": "1500 Quad Cab (4-Türer) Pickup | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Y": 2015,
    "Mo": "1500 Quad Cab (4-Türer) Pickup | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Y": 2016,
    "Mo": "1500 Quad Cab (4-Türer) Pickup | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Y": 2017,
    "Mo": "1500 Quad Cab (4-Türer) Pickup | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Y": 2018,
    "Mo": "1500 Quad Cab (4-Türer) Pickup | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Y": 2019,
    "Mo": "1500 Quad Cab (4-Türer) Pickup DS Facelift | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Y": 2010,
    "Mo": "1500 Quad Cab (4-Türer) Pickup | 2010-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Y": 2011,
    "Mo": "1500 Quad Cab (4-Türer) Pickup | 2010-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Y": 2012,
    "Mo": "1500 Quad Cab (4-Türer) Pickup | 2010-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Y": 2019,
    "Mo": "1500 Quad Cab (4-Türer) Pickup DT | 2019-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Y": 2020,
    "Mo": "1500 Quad Cab (4-Türer) Pickup | 2019-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Y": 2021,
    "Mo": "1500 Quad Cab (4-Türer) Pickup | 2019-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Y": 2022,
    "Mo": "1500 Quad Cab (4-Türer) Pickup | 2019-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Y": 2023,
    "Mo": "1500 Quad Cab (4-Türer) Pickup | 2019-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Y": 2024,
    "Mo": "1500 Quad Cab (4-Türer) Pickup | 2019-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Y": 2024,
    "Mo": "Rampage (4-Türer) Pickup | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Y": 2025,
    "Mo": "Rampage (4-Türer) Pickup | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Y": 2026,
    "Mo": "Rampage (4-Türer) Pickup | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2018,
    "Mo": "Grandland X (5-Türer) SUV | 2018-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2019,
    "Mo": "Grandland X (5-Türer) SUV | 2018-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2020,
    "Mo": "Grandland X (5-Türer) SUV | 2018-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2021,
    "Mo": "Grandland X (5-Türer) SUV | 2018-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2009,
    "Mo": "Insignia (5-Türer) Schrägheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2010,
    "Mo": "Insignia (5-Türer) Schrägheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2011,
    "Mo": "Insignia (5-Türer) Schrägheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2012,
    "Mo": "Insignia (5-Türer) Schrägheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2013,
    "Mo": "Insignia (5-Türer) Schrägheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2009,
    "Mo": "Insignia Sedan (4-Türer) Stufenheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2010,
    "Mo": "Insignia Sedan (4-Türer) Stufenheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2011,
    "Mo": "Insignia Sedan (4-Türer) Stufenheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2012,
    "Mo": "Insignia Sedan (4-Türer) Stufenheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2013,
    "Mo": "Insignia Sedan (4-Türer) Stufenheck | 2009-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ORA",
    "Y": 2022,
    "Mo": "Funky Cat (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ORA",
    "Y": 2023,
    "Mo": "Funky Cat (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ORA",
    "Y": 2024,
    "Mo": "Funky Cat (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ORA",
    "Y": 2025,
    "Mo": "Funky Cat (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ORA",
    "Y": 2026,
    "Mo": "Funky Cat (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ORA",
    "Y": 2021,
    "Mo": "Good Cat (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ORA",
    "Y": 2022,
    "Mo": "Good Cat (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ORA",
    "Y": 2023,
    "Mo": "Good Cat (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ORA",
    "Y": 2024,
    "Mo": "Good Cat (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ORA",
    "Y": 2025,
    "Mo": "Good Cat (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ORA",
    "Y": 2026,
    "Mo": "Good Cat (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2015,
    "Mo": "Canyon Crew Cab (4-Türer) Pickup | 2015-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2016,
    "Mo": "Canyon Crew Cab (4-Türer) Pickup | 2015-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2017,
    "Mo": "Canyon Crew Cab (4-Türer) Pickup | 2015-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2018,
    "Mo": "Canyon Crew Cab (4-Türer) Pickup | 2015-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2019,
    "Mo": "Canyon Crew Cab (4-Türer) Pickup | 2015-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2020,
    "Mo": "Canyon Crew Cab (4-Türer) Pickup | 2015-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2023,
    "Mo": "Canyon Crew Cab (4-Türer) Pickup | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2024,
    "Mo": "Canyon Crew Cab (4-Türer) Pickup | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2025,
    "Mo": "Canyon Crew Cab (4-Türer) Pickup | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2026,
    "Mo": "Canyon Crew Cab (4-Türer) Pickup | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2014,
    "Mo": "Sierra Crew Cab (4-Türer) Pickup | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2015,
    "Mo": "Sierra Crew Cab (4-Türer) Pickup | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2016,
    "Mo": "Sierra Crew Cab (4-Türer) Pickup | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2017,
    "Mo": "Sierra Crew Cab (4-Türer) Pickup | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2018,
    "Mo": "Sierra Crew Cab (4-Türer) Pickup | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2019,
    "Mo": "Sierra Crew Cab (4-Türer) Pickup | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2014,
    "Mo": "Sierra Double Cab (4-Türer) Pickup | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2015,
    "Mo": "Sierra Double Cab (4-Türer) Pickup | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2016,
    "Mo": "Sierra Double Cab (4-Türer) Pickup | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2017,
    "Mo": "Sierra Double Cab (4-Türer) Pickup | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2018,
    "Mo": "Sierra Double Cab (4-Türer) Pickup | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2019,
    "Mo": "Sierra Double Cab (4-Türer) Pickup | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DFSK",
    "Y": 2023,
    "Mo": "Seres 5 (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DFSK",
    "Y": 2024,
    "Mo": "Seres 5 (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DFSK",
    "Y": 2025,
    "Mo": "Seres 5 (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DFSK",
    "Y": 2026,
    "Mo": "Seres 5 (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fisker",
    "Y": 2022,
    "Mo": "Ocean (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fisker",
    "Y": 2023,
    "Mo": "Ocean (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fisker",
    "Y": 2024,
    "Mo": "Ocean (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fisker",
    "Y": 2025,
    "Mo": "Ocean (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fisker",
    "Y": 2026,
    "Mo": "Ocean (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Leapmotor",
    "Y": 2024,
    "Mo": "C10 (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Leapmotor",
    "Y": 2025,
    "Mo": "C10 (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Leapmotor",
    "Y": 2026,
    "Mo": "C10 (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Amarok DoubleCab 3.3t (4-Türer) Pickup | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Amarok DoubleCab 3.3t (4-Türer) Pickup | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Amarok DoubleCab 3.3t (4-Türer) Pickup | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Amarok DoubleCab 3.3t (4-Türer) Pickup | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Y": 2013,
    "Mo": "2500 Mega Cab (4-Türer) Pickup | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Y": 2014,
    "Mo": "2500 Mega Cab (4-Türer) Pickup | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Y": 2015,
    "Mo": "2500 Mega Cab (4-Türer) Pickup | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Y": 2016,
    "Mo": "2500 Mega Cab (4-Türer) Pickup | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Y": 2017,
    "Mo": "2500 Mega Cab (4-Türer) Pickup | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Y": 2018,
    "Mo": "2500 Mega Cab (4-Türer) Pickup | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Y": 2010,
    "Mo": "2500 Mega Cab (4-Türer) Pickup | 2010-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Y": 2011,
    "Mo": "2500 Mega Cab (4-Türer) Pickup | 2010-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Y": 2012,
    "Mo": "2500 Mega Cab (4-Türer) Pickup | 2010-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Y": 2010,
    "Mo": "3500 Crew Cab (4-Türer) Pickup | 2010-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Y": 2011,
    "Mo": "3500 Crew Cab (4-Türer) Pickup | 2010-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Y": 2012,
    "Mo": "3500 Crew Cab (4-Türer) Pickup | 2010-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Y": 2013,
    "Mo": "3500 Crew Cab (4-Türer) Pickup | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Y": 2014,
    "Mo": "3500 Crew Cab (4-Türer) Pickup | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Y": 2015,
    "Mo": "3500 Crew Cab (4-Türer) Pickup | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Y": 2016,
    "Mo": "3500 Crew Cab (4-Türer) Pickup | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Y": 2017,
    "Mo": "3500 Crew Cab (4-Türer) Pickup | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Y": 2018,
    "Mo": "3500 Crew Cab (4-Türer) Pickup | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2012,
    "Mo": "D-Max Crew Cab (4-Türer) Pickup | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2013,
    "Mo": "D-Max Crew Cab (4-Türer) Pickup | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2014,
    "Mo": "D-Max Crew Cab (4-Türer) Pickup | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2015,
    "Mo": "D-Max Crew Cab (4-Türer) Pickup RT | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2017,
    "Mo": "D-Max Crew Cab (4-Türer) Pickup RT 2nd Facelift | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2018,
    "Mo": "D-Max Crew Cab (4-Türer) Pickup | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2019,
    "Mo": "D-Max Crew Cab (4-Türer) Pickup | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2020,
    "Mo": "D-Max Crew Cab (4-Türer) Pickup RT 2nd Facelift | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2015,
    "Mo": "D-Max Crew Cab (4-Türer) Pickup RT 1st Facelift | 2015-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2016,
    "Mo": "D-Max Crew Cab (4-Türer) Pickup | 2015-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2017,
    "Mo": "D-Max Crew Cab (4-Türer) Pickup RT 1st Facelift | 2015-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2019,
    "Mo": "Sierra 1500 Crew Cab (4-Türer) Pickup | 2019-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2020,
    "Mo": "Sierra 1500 Crew Cab (4-Türer) Pickup | 2019-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2021,
    "Mo": "Sierra 1500 Crew Cab (4-Türer) Pickup | 2019-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2022,
    "Mo": "Sierra 1500 Crew Cab (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2023,
    "Mo": "Sierra 1500 Crew Cab (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2024,
    "Mo": "Sierra 1500 Crew Cab (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2025,
    "Mo": "Sierra 1500 Crew Cab (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2026,
    "Mo": "Sierra 1500 Crew Cab (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2019,
    "Mo": "Sierra 1500 Double Cab (4-Türer) Pickup | 2019-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2020,
    "Mo": "Sierra 1500 Double Cab (4-Türer) Pickup | 2019-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2021,
    "Mo": "Sierra 1500 Double Cab (4-Türer) Pickup | 2019-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2022,
    "Mo": "Sierra 1500 Double Cab (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2023,
    "Mo": "Sierra 1500 Double Cab (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2024,
    "Mo": "Sierra 1500 Double Cab (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2025,
    "Mo": "Sierra 1500 Double Cab (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2026,
    "Mo": "Sierra 1500 Double Cab (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2005,
    "Mo": "Frontier Crew Cab (4-Türer) Pickup | 2005-2008",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2006,
    "Mo": "Frontier Crew Cab (4-Türer) Pickup | 2005-2008",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2007,
    "Mo": "Frontier Crew Cab (4-Türer) Pickup | 2005-2008",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2008,
    "Mo": "Frontier Crew Cab (4-Türer) Pickup | 2005-2008",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Tacoma Crew Cab (4-Türer) Pickup | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Tacoma Crew Cab (4-Türer) Pickup | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Tacoma Crew Cab (4-Türer) Pickup | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Tacoma Crew Cab (4-Türer) Pickup | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Tacoma Crew Cab (4-Türer) Pickup 3rd Generation | 2016-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Tacoma Crew Cab (4-Türer) Pickup 3rd Generation Facelift | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Tacoma Crew Cab (4-Türer) Pickup | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Tacoma Crew Cab (4-Türer) Pickup | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Tacoma Crew Cab (4-Türer) Pickup | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Golf (1K1) (3-Türer) Schrägheck | 2004-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Golf (1K1) (3-Türer) Schrägheck | 2004-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Golf (1K1) (3-Türer) Schrägheck | 2004-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Golf (1K1) (3-Türer) Schrägheck | 2004-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Golf (1K1) (3-Türer) Schrägheck | 2004-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Golf (1K1) (3-Türer) Schrägheck | 2004-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Golf (1K1) (5-Türer) Schrägheck | 2004-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Golf (1K1) (5-Türer) Schrägheck | 2004-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Golf (1K1) (5-Türer) Schrägheck | 2004-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Golf (1K1) (5-Türer) Schrägheck | 2004-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Golf (1K1) (5-Türer) Schrägheck | 2004-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Golf (1K1) (5-Türer) Schrägheck | 2004-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "A6 Sedan (4-Türer) Stufenheck C9 | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2026,
    "Mo": "A6 Sedan (4-Türer) Stufenheck | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Urban Cruiser SUV (5-Türer) SUV | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "Urban Cruiser SUV (5-Türer) SUV | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Zeekr",
    "Y": 2023,
    "Mo": "009 6-seater (5-Türer) MPV | 2023-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Zeekr",
    "Y": 2024,
    "Mo": "009 6-seater (5-Türer) MPV | 2023-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2026,
    "Mo": "ES90 (334) (5-Türer) Schrägheck | 2026-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2020,
    "Mo": "Sierra 2500 HD Crew Cab (4-Türer) Pickup | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2021,
    "Mo": "Sierra 2500 HD Crew Cab (4-Türer) Pickup | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2022,
    "Mo": "Sierra 2500 HD Crew Cab (4-Türer) Pickup | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2023,
    "Mo": "Sierra 2500 HD Crew Cab (4-Türer) Pickup | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2024,
    "Mo": "Sierra 2500 HD Crew Cab (4-Türer) Pickup | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2025,
    "Mo": "Sierra 2500 HD Crew Cab (4-Türer) Pickup | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2026,
    "Mo": "Sierra 2500 HD Crew Cab (4-Türer) Pickup | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2020,
    "Mo": "Sierra 2500 HD Double Cab (4-Türer) Pickup | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2021,
    "Mo": "Sierra 2500 HD Double Cab (4-Türer) Pickup | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2022,
    "Mo": "Sierra 2500 HD Double Cab (4-Türer) Pickup | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2023,
    "Mo": "Sierra 2500 HD Double Cab (4-Türer) Pickup | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2001,
    "Mo": "Sierra 2500 HD Double Cab (4-Türer) Pickup | 2001-2002",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2002,
    "Mo": "Sierra 2500 HD Double Cab (4-Türer) Pickup | 2001-2002",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2025,
    "Mo": "EC40 (539) (5-Türer) SUV | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2026,
    "Mo": "EC40 (539) (5-Türer) SUV | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2023,
    "Mo": "ZR-V (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2024,
    "Mo": "ZR-V (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2025,
    "Mo": "ZR-V (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2026,
    "Mo": "ZR-V (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "EV4 Hatchback (5-Türer) Schrägheck | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2026,
    "Mo": "EV4 Hatchback (5-Türer) Schrägheck | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2024,
    "Mo": "Panamera (YAA) (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2025,
    "Mo": "Panamera (YAA) (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2026,
    "Mo": "Panamera (YAA) (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hongqi",
    "Y": 2025,
    "Mo": "EHS7 (5-Türer) SUV | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hongqi",
    "Y": 2026,
    "Mo": "EHS7 (5-Türer) SUV | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2026,
    "Mo": "Clio Hatchback (5-Türer) Schrägheck 6th Generation | 2026-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "e-tron GT (4-Türer) Stufenheck | 2025-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2026,
    "Mo": "e-tron GT (4-Türer) Stufenheck | 2025-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "e-tron GT (4-Türer) Stufenheck | 2021-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "e-tron GT (4-Türer) Stufenheck | 2021-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "e-tron GT (4-Türer) Stufenheck | 2021-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "e-tron GT (4-Türer) Stufenheck | 2021-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2015,
    "Mo": "Q7 (5-Türer) SUV 4M | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2016,
    "Mo": "Q7 (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2017,
    "Mo": "Q7 (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2018,
    "Mo": "Q7 (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "Q7 (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "Q7 (5-Türer) SUV 4M | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "Q7 (5-Türer) SUV 4M 2nd Facelift | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q7 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2026,
    "Mo": "Q7 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "Q7 (5-Türer) SUV 4M 1st Facelift | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "Q7 (5-Türer) SUV | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "Q7 (5-Türer) SUV | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "Q7 (5-Türer) SUV | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "Q7 (5-Türer) SUV 4M 1st Facelift | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "Q7 7-Seater (5-Türer) SUV 4M 2nd Facelift | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q7 7-Seater (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2026,
    "Mo": "Q7 7-Seater (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "Q7 7-Seater (5-Türer) SUV | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "Q7 7-Seater (5-Türer) SUV | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "Q7 7-Seater (5-Türer) SUV | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "Q7 7-Seater (5-Türer) SUV | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "Q7 7-Seater (5-Türer) SUV 4M 1st Facelift | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "1 Series (F21 LCI) (3-Türer) Schrägheck | 2015-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "1 Series (F21 LCI) (3-Türer) Schrägheck | 2015-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "1 Series (F21 LCI) (3-Türer) Schrägheck | 2015-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2007,
    "Mo": "1 Series (E81) (3-Türer) Schrägheck | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2008,
    "Mo": "1 Series (E81) (3-Türer) Schrägheck | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2009,
    "Mo": "1 Series (E81) (3-Türer) Schrägheck | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2010,
    "Mo": "1 Series (E81) (3-Türer) Schrägheck | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2011,
    "Mo": "1 Series (E81) (3-Türer) Schrägheck | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2013,
    "Mo": "1 Series (F21) (3-Türer) Schrägheck | 2013-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2014,
    "Mo": "1 Series (F21) (3-Türer) Schrägheck | 2013-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "1 Series (F21) (3-Türer) Schrägheck | 2013-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "1 Series (F21 LCI) (3-Türer) Schrägheck | 2018-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "1 Series (F21 LCI) (3-Türer) Schrägheck | 2018-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "1 Series (F20 LCI) (5-Türer) Schrägheck | 2015-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "1 Series (F20 LCI) (5-Türer) Schrägheck | 2015-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "1 Series (F20 LCI) (5-Türer) Schrägheck | 2015-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2007,
    "Mo": "1 Series (E87 LCI) (5-Türer) Schrägheck | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2008,
    "Mo": "1 Series (E87 LCI) (5-Türer) Schrägheck | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2009,
    "Mo": "1 Series (E87 LCI) (5-Türer) Schrägheck | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2010,
    "Mo": "1 Series (E87 LCI) (5-Türer) Schrägheck | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2011,
    "Mo": "1 Series (E87 LCI) (5-Türer) Schrägheck | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2012,
    "Mo": "1 Series (F20) (5-Türer) Schrägheck | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2013,
    "Mo": "1 Series (F20) (5-Türer) Schrägheck | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2014,
    "Mo": "1 Series (F20) (5-Türer) Schrägheck | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "1 Series (F20) (5-Türer) Schrägheck | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "1 Series (F20 LCI) (5-Türer) Schrägheck | 2018-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "1 Series (F20 LCI) (5-Türer) Schrägheck | 2018-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2004,
    "Mo": "1 Series (E87) (5-Türer) Schrägheck | 2004-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2005,
    "Mo": "1 Series (E87) (5-Türer) Schrägheck | 2004-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2006,
    "Mo": "1 Series (E87) (5-Türer) Schrägheck | 2004-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2007,
    "Mo": "1 Series (E87) (5-Türer) Schrägheck | 2004-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "1 Series (F70) (5-Türer) Schrägheck | 2025-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2026,
    "Mo": "1 Series (F70) (5-Türer) Schrägheck | 2025-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "1 Series (F40) (5-Türer) Schrägheck | 2020-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "1 Series (F40) (5-Türer) Schrägheck | 2020-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "1 Series (F40) (5-Türer) Schrägheck | 2020-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "1 Series (F40) (5-Türer) Schrägheck | 2020-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "1 Series (F40) (5-Türer) Schrägheck | 2020-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "2 Series Coupé (G42) (2-Türer) Coupe | 2022-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "2 Series Coupé (G42) (2-Türer) Coupe | 2022-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "2 Series Coupé (G42) (2-Türer) Coupe | 2022-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "2 Series Coupé (G42 LCI) (2-Türer) Coupe | 2025-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2026,
    "Mo": "2 Series Coupé (G42 LCI) (2-Türer) Coupe | 2025-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "2 Series Gran Coupé (F44) (4-Türer) Stufenheck | 2020-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "2 Series Gran Coupé (F44) (4-Türer) Stufenheck | 2020-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "2 Series Gran Coupé (F44) (4-Türer) Stufenheck | 2020-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "2 Series Gran Coupé (F44) (4-Türer) Stufenheck | 2020-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "2 Series Gran Coupé (F44) (4-Türer) Stufenheck | 2020-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2005,
    "Mo": "3 Series Sedan (E90) (4-Türer) Stufenheck | 2005-2010",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2006,
    "Mo": "3 Series Sedan (E90) (4-Türer) Stufenheck | 2005-2010",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2007,
    "Mo": "3 Series Sedan (E90) (4-Türer) Stufenheck | 2005-2010",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2008,
    "Mo": "3 Series Sedan (E90) (4-Türer) Stufenheck | 2005-2010",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2009,
    "Mo": "3 Series Sedan (E90) (4-Türer) Stufenheck | 2005-2010",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2010,
    "Mo": "3 Series Sedan (E90) (4-Türer) Stufenheck | 2005-2010",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2012,
    "Mo": "3 Series Sedan (F30) (4-Türer) Stufenheck | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2013,
    "Mo": "3 Series Sedan (F30) (4-Türer) Stufenheck | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2014,
    "Mo": "3 Series Sedan (F30) (4-Türer) Stufenheck | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "3 Series Sedan (F30) (4-Türer) Stufenheck | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2009,
    "Mo": "3 Series Sedan (E90 LCI) (4-Türer) Stufenheck | 2009-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2010,
    "Mo": "3 Series Sedan (E90 LCI) (4-Türer) Stufenheck | 2009-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2011,
    "Mo": "3 Series Sedan (E90 LCI) (4-Türer) Stufenheck | 2009-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2012,
    "Mo": "3 Series Sedan (E90 LCI) (4-Türer) Stufenheck | 2009-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "3 Series Sedan (F30 LCI) (4-Türer) Stufenheck | 2015-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "3 Series Sedan (F30 LCI) (4-Türer) Stufenheck | 2015-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "3 Series Sedan (F30 LCI) (4-Türer) Stufenheck | 2015-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "3 Series Sedan (F30 LCI) (4-Türer) Stufenheck | 2015-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "3 Series Sedan (G20 2nd LCI) (4-Türer) Stufenheck | 2025-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2026,
    "Mo": "3 Series Sedan (G20 2nd LCI) (4-Türer) Stufenheck | 2025-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "3 Series Sedan (G20) (4-Türer) Stufenheck | 2019-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "3 Series Sedan (G20) (4-Türer) Stufenheck | 2019-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "3 Series Sedan (G20) (4-Türer) Stufenheck | 2019-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "3 Series Sedan (G20) (4-Türer) Stufenheck | 2019-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "3 Series Sedan (G20 LCI) (4-Türer) Stufenheck | 2022-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "3 Series Sedan (G20 LCI) (4-Türer) Stufenheck | 2022-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "3 Series Sedan (G20 LCI) (4-Türer) Stufenheck | 2022-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "3 Series Sedan (G20 LCI) (4-Türer) Stufenheck | 2022-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2014,
    "Mo": "3 Series Gran Turismo (F34) (5-Türer) Schrägheck | 2014-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "3 Series Gran Turismo (F34) (5-Türer) Schrägheck | 2014-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "3 Series Gran Turismo (F34) (5-Türer) Schrägheck | 2014-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "3 Series Gran Turismo (F34 LCI) (5-Türer) Schrägheck | 2016-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "3 Series Gran Turismo (F34 LCI) (5-Türer) Schrägheck | 2016-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "3 Series Gran Turismo (F34 LCI) (5-Türer) Schrägheck | 2016-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "3 Series Gran Turismo (F34 LCI) (5-Türer) Schrägheck | 2016-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "3 Series Gran Turismo (F34 LCI) (5-Türer) Schrägheck | 2016-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "3 Series Gran Turismo (F34 LCI) (5-Türer) Schrägheck | 2016-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "4 Series Coupé (G22 LCI) (2-Türer) Coupe | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "4 Series Coupé (G22 LCI) (2-Türer) Coupe | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2026,
    "Mo": "4 Series Coupé (G22 LCI) (2-Türer) Coupe | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "4 Series Coupé (G22) (2-Türer) Coupe | 2021-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "4 Series Coupé (G22) (2-Türer) Coupe | 2021-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "4 Series Coupé (G22) (2-Türer) Coupe | 2021-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "4 Series Coupé (G22) (2-Türer) Coupe | 2021-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "4 Series Gran Coupé (F36) (5-Türer) Schrägheck | 2015-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "4 Series Gran Coupé (F36) (5-Türer) Schrägheck | 2015-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "4 Series Gran Coupé (F36) (5-Türer) Schrägheck | 2015-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "4 Series Gran Coupé (F36 LCI) (5-Türer) Schrägheck | 2018-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "4 Series Gran Coupé (F36 LCI) (5-Türer) Schrägheck | 2018-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "4 Series Gran Coupé (F36 LCI) (5-Türer) Schrägheck | 2018-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "4 Series Gran Coupé (G26 LCI) (5-Türer) Schrägheck | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "4 Series Gran Coupé (G26 LCI) (5-Türer) Schrägheck | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2026,
    "Mo": "4 Series Gran Coupé (G26 LCI) (5-Türer) Schrägheck | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "4 Series Gran Coupé (G26) (5-Türer) Schrägheck | 2022-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "4 Series Gran Coupé (G26) (5-Türer) Schrägheck | 2022-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "4 Series Gran Coupé (G26) (5-Türer) Schrägheck | 2022-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2010,
    "Mo": "5 Series Gran Turismo (F07) (5-Türer) Schrägheck | 2010-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2011,
    "Mo": "5 Series Gran Turismo (F07) (5-Türer) Schrägheck | 2010-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2012,
    "Mo": "5 Series Gran Turismo (F07) (5-Türer) Schrägheck | 2010-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2013,
    "Mo": "5 Series Gran Turismo (F07) (5-Türer) Schrägheck | 2010-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2014,
    "Mo": "5 Series Gran Turismo (F07 LCI) (5-Türer) Schrägheck | 2014-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "5 Series Gran Turismo (F07 LCI) (5-Türer) Schrägheck | 2014-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "5 Series Gran Turismo (F07 LCI) (5-Türer) Schrägheck | 2014-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "5 Series Gran Turismo (F07 LCI) (5-Türer) Schrägheck | 2014-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2014,
    "Mo": "5 Series Sedan (F10 LCI) (4-Türer) Stufenheck | 2014-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "5 Series Sedan (F10 LCI) (4-Türer) Stufenheck | 2014-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "5 Series Sedan (F10 LCI) (4-Türer) Stufenheck | 2014-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2010,
    "Mo": "5 Series Sedan (F10) (4-Türer) Stufenheck | 2010-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2011,
    "Mo": "5 Series Sedan (F10) (4-Türer) Stufenheck | 2010-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2012,
    "Mo": "5 Series Sedan (F10) (4-Türer) Stufenheck | 2010-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2013,
    "Mo": "5 Series Sedan (F10) (4-Türer) Stufenheck | 2010-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "5 Series Sedan (G30) (4-Türer) Stufenheck | 2017-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "5 Series Sedan (G30) (4-Türer) Stufenheck | 2017-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "5 Series Sedan (G30) (4-Türer) Stufenheck | 2017-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "5 Series Sedan (G30) (4-Türer) Stufenheck | 2017-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "5 Series Sedan (G30 LCI) (4-Türer) Stufenheck | 2021-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "5 Series Sedan (G30 LCI) (4-Türer) Stufenheck | 2021-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "5 Series Sedan (G30 LCI) (4-Türer) Stufenheck | 2021-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "5 Series Sedan (G30 LCI) (4-Türer) Stufenheck | 2021-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "5 Series Sedan (G60) (4-Türer) Stufenheck | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "5 Series Sedan (G60) (4-Türer) Stufenheck | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2026,
    "Mo": "5 Series Sedan (G60) (4-Türer) Stufenheck | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "6 Series Gran Turismo (G32 LCI) (5-Türer) Schrägheck | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "6 Series Gran Turismo (G32 LCI) (5-Türer) Schrägheck | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "6 Series Gran Turismo (G32 LCI) (5-Türer) Schrägheck | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "6 Series Gran Turismo (G32 LCI) (5-Türer) Schrägheck | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "6 Series Gran Turismo (G32 LCI) (5-Türer) Schrägheck | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2026,
    "Mo": "6 Series Gran Turismo (G32 LCI) (5-Türer) Schrägheck | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "iX (I20 LCI) (5-Türer) SUV | 2025-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2026,
    "Mo": "iX (I20 LCI) (5-Türer) SUV | 2025-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "iX (I20) (5-Türer) SUV | 2022-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "iX (I20) (5-Türer) SUV | 2022-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "iX (I20) (5-Türer) SUV | 2022-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "iX (I20) (5-Türer) SUV | 2022-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2009,
    "Mo": "C4 (5-Türer) Schrägheck | 2009-2010",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "C4 (5-Türer) Schrägheck Typ L Facelift | 2009-2010",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2004,
    "Mo": "C4 (5-Türer) Schrägheck | 2004-2008",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2005,
    "Mo": "C4 (5-Türer) Schrägheck | 2004-2008",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2006,
    "Mo": "C4 (5-Türer) Schrägheck | 2004-2008",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2007,
    "Mo": "C4 (5-Türer) Schrägheck | 2004-2008",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2008,
    "Mo": "C4 (5-Türer) Schrägheck | 2004-2008",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2004,
    "Mo": "C4 Coupe (3-Türer) Coupe | 2004-2008",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2005,
    "Mo": "C4 Coupe (3-Türer) Coupe | 2004-2008",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2006,
    "Mo": "C4 Coupe (3-Türer) Coupe | 2004-2008",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2007,
    "Mo": "C4 Coupe (3-Türer) Coupe | 2004-2008",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2008,
    "Mo": "C4 Coupe (3-Türer) Coupe | 2004-2008",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2015,
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2017,
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2018,
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2007,
    "Mo": "Nemo Combi (4-Türer) LCV | 2007-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2008,
    "Mo": "Nemo Combi (4-Türer) LCV | 2007-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2009,
    "Mo": "Nemo Combi (4-Türer) LCV | 2007-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "Nemo Combi (4-Türer) LCV | 2007-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2011,
    "Mo": "Nemo Combi (4-Türer) LCV | 2007-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "Nemo Combi (4-Türer) LCV | 2007-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "Nemo Combi (4-Türer) LCV | 2007-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "Nemo Combi (4-Türer) LCV | 2007-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2009,
    "Mo": "Nemo Multispace (5-Türer) LCV | 2009-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "Nemo Multispace (5-Türer) LCV | 2009-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2011,
    "Mo": "Nemo Multispace (5-Türer) LCV | 2009-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "Nemo Multispace (5-Türer) LCV | 2009-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "Nemo Multispace (5-Türer) LCV | 2009-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "Nemo Multispace (5-Türer) LCV | 2009-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2007,
    "Mo": "Nemo Van (2-Türer) LCV | 2007-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2008,
    "Mo": "Nemo Van (2-Türer) LCV | 2007-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2009,
    "Mo": "Nemo Van (2-Türer) LCV | 2007-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "Nemo Van (2-Türer) LCV | 2007-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2011,
    "Mo": "Nemo Van (2-Türer) LCV | 2007-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "Nemo Van (2-Türer) LCV | 2007-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "Nemo Van (2-Türer) LCV | 2007-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "Nemo Van (2-Türer) LCV | 2007-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "Spacetourer (4-Türer) MPV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2017,
    "Mo": "Spacetourer (4-Türer) MPV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2018,
    "Mo": "Spacetourer (4-Türer) MPV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2019,
    "Mo": "Spacetourer (4-Türer) MPV 1st Generation | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2019,
    "Mo": "Spacetourer (4-Türer) MPV 1st Generation 1st Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2020,
    "Mo": "Spacetourer (4-Türer) MPV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2021,
    "Mo": "Spacetourer (4-Türer) MPV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2022,
    "Mo": "Spacetourer (4-Türer) MPV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2023,
    "Mo": "Spacetourer (4-Türer) MPV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "Spacetourer (4-Türer) MPV 1st Generation 1st Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "Spacetourer (4-Türer) MPV 1st Generation 2nd Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2025,
    "Mo": "Spacetourer (4-Türer) MPV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2026,
    "Mo": "Spacetourer (4-Türer) MPV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2006,
    "Mo": "TrailBlazer (5-Türer) SUV | 2006-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2007,
    "Mo": "TrailBlazer (5-Türer) SUV | 2006-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2008,
    "Mo": "TrailBlazer (5-Türer) SUV | 2006-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2009,
    "Mo": "TrailBlazer (5-Türer) SUV | 2006-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2002,
    "Mo": "TrailBlazer (5-Türer) SUV | 2002-2005",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2003,
    "Mo": "TrailBlazer (5-Türer) SUV | 2002-2005",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2004,
    "Mo": "TrailBlazer (5-Türer) SUV | 2002-2005",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2005,
    "Mo": "TrailBlazer (5-Türer) SUV | 2002-2005",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2017,
    "Mo": "Dokker (5-Türer) LCV 1st Generation Facelift | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2018,
    "Mo": "Dokker (5-Türer) LCV | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2019,
    "Mo": "Dokker (5-Türer) LCV | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2020,
    "Mo": "Dokker (5-Türer) LCV | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2021,
    "Mo": "Dokker (5-Türer) LCV | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2022,
    "Mo": "Dokker (5-Türer) LCV | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2023,
    "Mo": "Dokker (5-Türer) LCV | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2024,
    "Mo": "Dokker (5-Türer) LCV | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2025,
    "Mo": "Dokker (5-Türer) LCV | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2026,
    "Mo": "Dokker (5-Türer) LCV | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2013,
    "Mo": "Dokker (5-Türer) LCV | 2013-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2014,
    "Mo": "Dokker (5-Türer) LCV | 2013-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2015,
    "Mo": "Dokker (5-Türer) LCV | 2013-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2016,
    "Mo": "Dokker (5-Türer) LCV | 2013-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2017,
    "Mo": "Dokker (5-Türer) LCV 1st Generation | 2013-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2017,
    "Mo": "Dokker Express (4-Türer) LCV 1st Generation Facelift | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2018,
    "Mo": "Dokker Express (4-Türer) LCV | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2019,
    "Mo": "Dokker Express (4-Türer) LCV | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2020,
    "Mo": "Dokker Express (4-Türer) LCV | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2021,
    "Mo": "Dokker Express (4-Türer) LCV | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2022,
    "Mo": "Dokker Express (4-Türer) LCV | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2023,
    "Mo": "Dokker Express (4-Türer) LCV | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2024,
    "Mo": "Dokker Express (4-Türer) LCV | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2025,
    "Mo": "Dokker Express (4-Türer) LCV | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2026,
    "Mo": "Dokker Express (4-Türer) LCV | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2013,
    "Mo": "Dokker Express (4-Türer) LCV | 2013-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2014,
    "Mo": "Dokker Express (4-Türer) LCV | 2013-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2015,
    "Mo": "Dokker Express (4-Türer) LCV | 2013-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2016,
    "Mo": "Dokker Express (4-Türer) LCV | 2013-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2017,
    "Mo": "Dokker Express (4-Türer) LCV 1st Generation | 2013-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Caddy Life (4-Türer) LCV | 2016-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Caddy Life (4-Türer) LCV | 2016-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Caddy Life (4-Türer) LCV | 2016-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Caddy Life (4-Türer) LCV | 2016-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Caddy Life (4-Türer) LCV Typ 2K 2nd Facelift | 2016-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Caddy Life (4-Türer) LCV Typ 2K 1st Facelift | 2011-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Caddy Life (4-Türer) LCV | 2011-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Caddy Life (4-Türer) LCV | 2011-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Caddy Life (4-Türer) LCV | 2011-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Caddy Life (4-Türer) LCV | 2011-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Caddy Life (4-Türer) LCV | 2004-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Caddy Life (4-Türer) LCV | 2004-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Caddy Life (4-Türer) LCV | 2004-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Caddy Life (4-Türer) LCV | 2004-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Caddy Life (4-Türer) LCV | 2004-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Caddy Life (4-Türer) LCV | 2004-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Caddy Life (4-Türer) LCV | 2004-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Caddy Life (4-Türer) LCV Typ 2K | 2004-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Caddy Life (4-Türer) LCV Typ SB | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Caddy Life (4-Türer) LCV | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Caddy Life (4-Türer) LCV | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Caddy Life (4-Türer) LCV | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Caddy Life (4-Türer) LCV | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Caddy Life (4-Türer) LCV | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Caddy Life (4-Türer) LCV | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Caddy Maxi (3-Türer) LCV | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Caddy Maxi (3-Türer) LCV | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Caddy Maxi (3-Türer) LCV | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Caddy Maxi (3-Türer) LCV | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Caddy Maxi (3-Türer) LCV | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Caddy Maxi (3-Türer) LCV | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Caddy Maxi (3-Türer) LCV | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Caddy Maxi Life (4-Türer) LCV | 2016-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Caddy Maxi Life (4-Türer) LCV | 2016-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Caddy Maxi Life (4-Türer) LCV | 2016-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Caddy Maxi Life (4-Türer) LCV | 2016-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Caddy Maxi Life (4-Türer) LCV Typ 2K 2nd Facelift | 2016-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Caddy Maxi Life (4-Türer) LCV Typ 2K 1st Facelift | 2011-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Caddy Maxi Life (4-Türer) LCV | 2011-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Caddy Maxi Life (4-Türer) LCV | 2011-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Caddy Maxi Life (4-Türer) LCV | 2011-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Caddy Maxi Life (4-Türer) LCV | 2011-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Caddy Maxi Life (4-Türer) LCV | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Caddy Maxi Life (4-Türer) LCV | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Caddy Maxi Life (4-Türer) LCV | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Caddy Maxi Life (4-Türer) LCV | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Caddy Maxi Life (4-Türer) LCV Typ 2K | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "ID. Buzz (5-Türer) MPV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "ID. Buzz (5-Türer) MPV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "ID. Buzz (5-Türer) MPV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "ID. Buzz (5-Türer) MPV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "ID. Buzz Cargo (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "ID. Buzz Cargo (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "ID. Buzz Cargo (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "ID. Buzz Cargo (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "ID. Buzz LWB (5-Türer) MPV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "ID. Buzz LWB (5-Türer) MPV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "ID. Buzz LWB (5-Türer) MPV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Touareg (7LA) (5-Türer) SUV | 2003-2007",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Touareg (7LA) (5-Türer) SUV | 2003-2007",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Touareg (7LA) (5-Türer) SUV | 2003-2007",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Touareg (7LA) (5-Türer) SUV | 2003-2007",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Touareg (7LA) (5-Türer) SUV | 2003-2007",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Touareg (7L6) (5-Türer) SUV | 2007-2010",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Touareg (7L6) (5-Türer) SUV | 2007-2010",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Touareg (7L6) (5-Türer) SUV | 2007-2010",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Touareg (7L6) (5-Türer) SUV | 2007-2010",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Touareg (RC8) (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Touareg (RC8) (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Touareg (RC8) (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "California (4-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "California (4-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "California (4-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "California (4-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "California (4-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "California (4-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "California (4-Türer) LCV T7 | 2022-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "California (4-Türer) LCV T7 | 2022-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "California (4-Türer) LCV T7 | 2022-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "California (4-Türer) LCV | 2022-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "California (4-Türer) LCV | 2022-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Multivan (5-Türer) MPV T6.1 | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Multivan (5-Türer) MPV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Multivan (5-Türer) MPV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Multivan (5-Türer) MPV T6.1 | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Multivan (5-Türer) MPV T6.1 | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Multivan (5-Türer) MPV T6.1 | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Multivan (5-Türer) MPV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Multivan (5-Türer) MPV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Multivan (5-Türer) MPV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Multivan (5-Türer) MPV T6 | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Multivan (5-Türer) MPV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Multivan (5-Türer) MPV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Multivan (5-Türer) MPV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Multivan (5-Türer) MPV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Multivan (5-Türer) MPV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Multivan (5-Türer) MPV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Multivan (5-Türer) MPV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Multivan (5-Türer) MPV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Multivan (5-Türer) MPV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Multivan (5-Türer) MPV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Multivan (5-Türer) MPV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Multivan (5-Türer) MPV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Multivan (5-Türer) MPV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Multivan (5-Türer) MPV T7 | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Multivan (5-Türer) MPV T7 | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Multivan (5-Türer) MPV T7 | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Multivan (5-Türer) MPV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Multivan (5-Türer) MPV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Multivan (5-Türer) MPV T6.1 | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Multivan (5-Türer) MPV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Multivan (5-Türer) MPV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Multivan (5-Türer) MPV T6.1 | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Multivan (5-Türer) MPV T6.1 | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Multivan (5-Türer) MPV T6.1 | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Multivan (5-Türer) MPV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Multivan (5-Türer) MPV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Multivan (5-Türer) MPV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Multivan (5-Türer) MPV T6 | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Multivan (5-Türer) MPV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Multivan (5-Türer) MPV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Multivan (5-Türer) MPV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Multivan (5-Türer) MPV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Multivan (5-Türer) MPV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Multivan (5-Türer) MPV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Multivan (5-Türer) MPV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Multivan (5-Türer) MPV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Multivan (5-Türer) MPV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Multivan (5-Türer) MPV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Multivan (5-Türer) MPV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Multivan (5-Türer) MPV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Multivan (5-Türer) MPV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Avensis Combi (5-Türer) Kombi T27 | 2008-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Avensis Combi (5-Türer) Kombi T27 | 2008-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Avensis Combi (5-Türer) Kombi | 2008-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Avensis Combi (5-Türer) Kombi | 2008-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Avensis Combi (5-Türer) Kombi T27 | 2008-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Avensis Combi (5-Türer) Kombi T27 1st Facelift | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Avensis Combi (5-Türer) Kombi | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Avensis Combi (5-Türer) Kombi | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Avensis Combi (5-Türer) Kombi T27 1st Facelift | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Avensis Combi (5-Türer) Kombi T27 2nd Facelift | 2015-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Avensis Combi (5-Türer) Kombi | 2015-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Avensis Combi (5-Türer) Kombi | 2015-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Avensis Combi (5-Türer) Kombi | 2015-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "bZ4X (5-Türer) SUV EA10 Facelift | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "bZ4X (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "bZ4X (5-Türer) SUV | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "bZ4X (5-Türer) SUV | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "bZ4X (5-Türer) SUV | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "bZ4X (5-Türer) SUV EA10 | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Corolla Cross (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Corolla Cross (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Corolla Cross (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Corolla Cross (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Corolla Cross (5-Türer) SUV XG10 | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Corolla Cross (5-Türer) SUV XG10 Facelift | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "Corolla Cross (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Highlander (5-Türer) Crossover | 2014-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Highlander (5-Türer) Crossover | 2014-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Highlander (5-Türer) Crossover | 2014-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Highlander (5-Türer) Crossover | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Highlander (5-Türer) Crossover | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Highlander (5-Türer) Crossover | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Highlander (5-Türer) Crossover XU50 Facelift | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Highlander (5-Türer) Crossover XU70 | 2020-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Highlander (5-Türer) Crossover | 2020-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Highlander (5-Türer) Crossover | 2020-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Highlander (5-Türer) Crossover | 2020-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Highlander (5-Türer) Crossover | 2020-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Highlander (5-Türer) Crossover | 2020-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "Highlander (5-Türer) Crossover | 2020-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "ProAce Combi (4-Türer) LCV | 2016-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "ProAce Combi (4-Türer) LCV | 2016-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "ProAce Combi (4-Türer) LCV | 2016-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "ProAce Combi (4-Türer) LCV | 2016-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "ProAce Combi (4-Türer) LCV | 2016-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "ProAce Combi (4-Türer) LCV | 2016-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "ProAce Combi (4-Türer) LCV | 2016-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "ProAce Combi (4-Türer) LCV | 2016-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "ProAce Combi (4-Türer) LCV | 2016-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "ProAce Combi (4-Türer) LCV | 2016-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "ProAce Crew Van L1 (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "ProAce Crew Van L1 (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "ProAce Crew Van L1 (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "ProAce Crew Van L2 (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "ProAce Crew Van L2 (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "ProAce Crew Van L2 (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "ProAce Panel Van L1 (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "ProAce Panel Van L1 (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "ProAce Panel Van L1 (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "ProAce Panel Van L1 IP (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "ProAce Panel Van L1 IP (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "ProAce Panel Van L1 IP (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "ProAce Panel Van L2 (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "ProAce Panel Van L2 (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "ProAce Panel Van L2 (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "ProAce Panel Van L2 IP (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "ProAce Panel Van L2 IP (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "ProAce Panel Van L2 IP (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "ProAce Verso (4-Türer) LCV | 2016-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "ProAce Verso (4-Türer) LCV | 2016-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "ProAce Verso (4-Türer) LCV | 2016-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "ProAce Verso (4-Türer) LCV | 2016-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "ProAce Verso (4-Türer) LCV | 2016-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "ProAce Verso (4-Türer) LCV | 2016-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "ProAce Verso (4-Türer) LCV | 2016-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "ProAce Verso (4-Türer) LCV | 2016-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "ProAce Verso (4-Türer) LCV | 2016-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "ProAce Verso (4-Türer) LCV | 2016-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "ProAce Verso L1 (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "ProAce Verso L1 (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "ProAce Verso L1 (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "ProAce Verso L2 (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "ProAce Verso L2 (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "ProAce Verso L2 (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "ProAce City (5-Türer) LCV 1st Generation Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "ProAce City (5-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "ProAce City (5-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "ProAce City (5-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "ProAce City (5-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "ProAce City (5-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "ProAce City (5-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "ProAce City (5-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "ProAce City (5-Türer) LCV 1st Generation | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "ProAce City Verso (5-Türer) LCV 1st Generation Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "ProAce City Verso (5-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "ProAce City Verso (5-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "ProAce City Verso (5-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "ProAce City Verso (5-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "ProAce City Verso (5-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "ProAce City Verso (5-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "ProAce City Verso (5-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "ProAce City Verso (5-Türer) LCV 1st Generation | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "RAV4 (5-Türer) SUV XA50 | 2019-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "RAV4 (5-Türer) SUV | 2019-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "RAV4 (5-Türer) SUV | 2019-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "RAV4 (5-Türer) SUV | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "RAV4 (5-Türer) SUV | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "RAV4 (5-Türer) SUV | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "RAV4 (5-Türer) SUV | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2008,
    "Mo": "Focus Hatchback (DA3) (5-Türer) Schrägheck DA3/DB3 Facelift | 2008-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "Focus Hatchback (DA3) (5-Türer) Schrägheck | 2008-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "Focus Hatchback (DA3) (5-Türer) Schrägheck | 2008-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Focus Hatchback (DA3) (5-Türer) Schrägheck | 2008-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2005,
    "Mo": "Focus Hatchback (DA3) (5-Türer) Schrägheck | 2005-2008",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2006,
    "Mo": "Focus Hatchback (DA3) (5-Türer) Schrägheck | 2005-2008",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "Focus Hatchback (DA3) (5-Türer) Schrägheck | 2005-2008",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2008,
    "Mo": "Focus Hatchback (DA3) (5-Türer) Schrägheck DA3/DB3 | 2005-2008",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2008,
    "Mo": "Focus Combi (DA3) (5-Türer) Kombi DA3/DB3 Facelift | 2008-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "Focus Combi (DA3) (5-Türer) Kombi | 2008-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "Focus Combi (DA3) (5-Türer) Kombi | 2008-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Focus Combi (DA3) (5-Türer) Kombi | 2008-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2005,
    "Mo": "Focus Combi (DA3) (5-Türer) Kombi | 2005-2008",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2006,
    "Mo": "Focus Combi (DA3) (5-Türer) Kombi | 2005-2008",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "Focus Combi (DA3) (5-Türer) Kombi | 2005-2008",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2008,
    "Mo": "Focus Combi (DA3) (5-Türer) Kombi DA3/DB3 | 2005-2008",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2005,
    "Mo": "Focus Combi (DA3) (5-Türer) Kombi | 2005-2008",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2006,
    "Mo": "Focus Combi (DA3) (5-Türer) Kombi | 2005-2008",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "Focus Combi (DA3) (5-Türer) Kombi | 2005-2008",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2008,
    "Mo": "Focus Combi (DA3) (5-Türer) Kombi DA3/DB3 | 2005-2008",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2006,
    "Mo": "Galaxy (5-Türer) MPV WA6 | 2006-2010",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "Galaxy (5-Türer) MPV | 2006-2010",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2008,
    "Mo": "Galaxy (5-Türer) MPV | 2006-2010",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "Galaxy (5-Türer) MPV | 2006-2010",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "Galaxy (5-Türer) MPV WA6 | 2006-2010",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2002,
    "Mo": "Tourneo Connect (5-Türer) LCV | 2002-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2003,
    "Mo": "Tourneo Connect (5-Türer) LCV | 2002-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2004,
    "Mo": "Tourneo Connect (5-Türer) LCV | 2002-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2005,
    "Mo": "Tourneo Connect (5-Türer) LCV | 2002-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2006,
    "Mo": "Tourneo Connect (5-Türer) LCV | 2002-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "Tourneo Connect (5-Türer) LCV 1st Generation | 2002-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "Tourneo Connect (5-Türer) LCV 1st Generation 1st Facelift | 2007-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2008,
    "Mo": "Tourneo Connect (5-Türer) LCV | 2007-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "Tourneo Connect (5-Türer) LCV 1st Generation 1st Facelift | 2007-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "Tourneo Connect (5-Türer) LCV 1st Generation 2nd Facelift | 2009-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "Tourneo Connect (5-Türer) LCV | 2009-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Tourneo Connect (5-Türer) LCV | 2009-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Tourneo Connect (5-Türer) LCV | 2009-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Tourneo Connect (5-Türer) LCV 1st Generation 2nd Facelift | 2009-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Tourneo Courier (5-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Tourneo Courier (5-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Tourneo Courier (5-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Tourneo Courier (5-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Courier (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Courier (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Courier (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Courier (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2005,
    "Mo": "A-Class (W169) (3-Türer) Schrägheck | 2005-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "A-Class (W169) (3-Türer) Schrägheck | 2005-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "A-Class (W169) (3-Türer) Schrägheck | 2005-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "A-Class (W169) (3-Türer) Schrägheck | 2005-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "A-Class (W169) (3-Türer) Schrägheck W169 | 2005-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "A-Class (W169) (3-Türer) Schrägheck W169 Facelift | 2009-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "A-Class (W169) (3-Türer) Schrägheck | 2009-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "A-Class (W169) (3-Türer) Schrägheck | 2009-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "A-Class (W169) (3-Türer) Schrägheck | 2009-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2005,
    "Mo": "A-Class (W169) (5-Türer) Schrägheck | 2005-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "A-Class (W169) (5-Türer) Schrägheck | 2005-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "A-Class (W169) (5-Türer) Schrägheck | 2005-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "A-Class (W169) (5-Türer) Schrägheck | 2005-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "A-Class (W169) (5-Türer) Schrägheck W169 | 2005-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "A-Class (W169) (5-Türer) Schrägheck W169 Facelift | 2009-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "A-Class (W169) (5-Türer) Schrägheck | 2009-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "A-Class (W169) (5-Türer) Schrägheck | 2009-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "A-Class (W169) (5-Türer) Schrägheck | 2009-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "A-Class (W176) (5-Türer) Schrägheck | 2013-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "A-Class (W176) (5-Türer) Schrägheck | 2013-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "A-Class (W176) (5-Türer) Schrägheck | 2013-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "A-Class (W176) (5-Türer) Schrägheck | 2016-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "A-Class (W176) (5-Türer) Schrägheck | 2016-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "A-Class (W176) (5-Türer) Schrägheck | 2016-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "A-Class (W177) (5-Türer) Schrägheck | 2018-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "A-Class (W177) (5-Türer) Schrägheck | 2018-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "A-Class (W177) (5-Türer) Schrägheck | 2018-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "A-Class (W177) (5-Türer) Schrägheck | 2018-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "A-Class (W177) (5-Türer) Schrägheck | 2018-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "A-Class (W177) (5-Türer) Schrägheck W177 | 2018-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "A-Class (W177) (5-Türer) Schrägheck W177 Facelift | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "A-Class (W177) (5-Türer) Schrägheck | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "A-Class (W177) (5-Türer) Schrägheck | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "A-Class (W177) (5-Türer) Schrägheck | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "A-Class Sedan (V177) (4-Türer) Stufenheck | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "A-Class Sedan (V177) (4-Türer) Stufenheck | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "A-Class Sedan (V177) (4-Türer) Stufenheck | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "A-Class Sedan (V177) (4-Türer) Stufenheck | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "A-Class Sedan (V177) (4-Türer) Stufenheck W177 | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "A-Class Sedan (V177) (4-Türer) Stufenheck W177 Facelift | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "A-Class Sedan (V177) (4-Türer) Stufenheck | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "A-Class Sedan (V177) (4-Türer) Stufenheck | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "A-Class Sedan (V177) (4-Türer) Stufenheck | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "B-Class Sports Tourer (W245) (5-Türer) Schrägheck W245 Facelift | 2009-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "B-Class Sports Tourer (W245) (5-Türer) Schrägheck | 2009-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "B-Class Sports Tourer (W245) (5-Türer) Schrägheck | 2009-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "B-Class Sports Tourer (W245) (5-Türer) Schrägheck | 2006-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "B-Class Sports Tourer (W245) (5-Türer) Schrägheck | 2006-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "B-Class Sports Tourer (W245) (5-Türer) Schrägheck | 2006-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "B-Class Sports Tourer (W245) (5-Türer) Schrägheck W245 | 2006-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "B-Class Sports Tourer (W246) (5-Türer) Schrägheck | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "B-Class Sports Tourer (W246) (5-Türer) Schrägheck | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "B-Class Sports Tourer (W246) (5-Türer) Schrägheck | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "B-Class Sports Tourer (W246) (5-Türer) Schrägheck W246 | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "B-Class Sports Tourer (W246) (5-Türer) Schrägheck W246 Facelift | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "B-Class Sports Tourer (W246) (5-Türer) Schrägheck | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "B-Class Sports Tourer (W246) (5-Türer) Schrägheck | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "B-Class Sports Tourer (W246) (5-Türer) Schrägheck | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "B-Class Sports Tourer (W246) (5-Türer) Schrägheck | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "B-Class Sports Tourer (W247) (5-Türer) Schrägheck | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "B-Class Sports Tourer (W247) (5-Türer) Schrägheck | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "B-Class Sports Tourer (W247) (5-Türer) Schrägheck | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "B-Class Sports Tourer (W247) (5-Türer) Schrägheck | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "B-Class Sports Tourer (W247) (5-Türer) Schrägheck W247 | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "B-Class Sports Tourer (W247) (5-Türer) Schrägheck W247 Facelift | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "B-Class Sports Tourer (W247) (5-Türer) Schrägheck | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "B-Class Sports Tourer (W247) (5-Türer) Schrägheck | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "B-Class Sports Tourer (W247) (5-Türer) Schrägheck | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "C-Class Sedan (W204) (4-Türer) Stufenheck | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "C-Class Sedan (W204) (4-Türer) Stufenheck | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "C-Class Sedan (W204) (4-Türer) Stufenheck | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "C-Class Sedan (W204) (4-Türer) Stufenheck | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "C-Class Sedan (W204) (4-Türer) Stufenheck W204 | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "C-Class Sedan (W204) (4-Türer) Stufenheck W204 Facelift | 2011-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "C-Class Sedan (W204) (4-Türer) Stufenheck | 2011-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "C-Class Sedan (W204) (4-Türer) Stufenheck | 2011-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "C-Class Sedan (W204) (4-Türer) Stufenheck | 2011-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "C-Class Sedan (W204) (4-Türer) Stufenheck | 2007-2011",
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "C-Class Sedan (W204) (4-Türer) Stufenheck | 2007-2011",
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "C-Class Sedan (W204) (4-Türer) Stufenheck | 2007-2011",
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "C-Class Sedan (W204) (4-Türer) Stufenheck | 2007-2011",
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "C-Class Sedan (W204) (4-Türer) Stufenheck W204 | 2007-2011",
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "C-Class Sedan (W204) (4-Türer) Stufenheck W204 Facelift | 2011-2014",
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "C-Class Sedan (W204) (4-Türer) Stufenheck | 2011-2014",
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "C-Class Sedan (W204) (4-Türer) Stufenheck | 2011-2014",
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "C-Class Sedan (W204) (4-Türer) Stufenheck | 2011-2014",
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "C-Class Sedan (W205) (4-Türer) Stufenheck | 2015-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "C-Class Sedan (W205) (4-Türer) Stufenheck | 2015-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "C-Class Sedan (W205) (4-Türer) Stufenheck | 2015-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "C-Class Sedan (W205) (4-Türer) Stufenheck | 2015-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "C-Class Sedan (W205) (4-Türer) Stufenheck | 2019-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "C-Class Sedan (W205) (4-Türer) Stufenheck | 2019-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "C-Class Sedan (W205) (4-Türer) Stufenheck | 2019-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "C-Class Sedan (W206) (4-Türer) Stufenheck | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "C-Class Sedan (W206) (4-Türer) Stufenheck | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "C-Class Sedan (W206) (4-Türer) Stufenheck | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "C-Class Sedan (W206) (4-Türer) Stufenheck | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "C-Class Sedan (W206) (4-Türer) Stufenheck | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "C-Class Sedan (W206) (4-Türer) Stufenheck | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "Citan (5-Türer) LCV | 2013-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Citan (5-Türer) LCV | 2013-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "Citan (5-Türer) LCV | 2013-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "Citan (5-Türer) LCV | 2013-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "Citan (5-Türer) LCV | 2013-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Citan (5-Türer) LCV | 2013-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Citan (5-Türer) LCV | 2013-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Citan (5-Türer) LCV | 2013-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "Citan (5-Türer) LCV | 2013-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "Citan (5-Türer) LCV W415 | 2013-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "Citan (5-Türer) LCV W415 | 2013-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Citan (5-Türer) LCV W415 | 2013-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "Citan (5-Türer) LCV W415 | 2013-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "Citan (5-Türer) LCV W415 | 2013-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "Citan (5-Türer) LCV W420 | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "Citan (5-Türer) LCV W420 | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Citan (5-Türer) LCV W420 | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "Citan (5-Türer) LCV W420 | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "Citan (5-Türer) LCV W420 | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "CLA Coupé (C118) (4-Türer) Coupe | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "CLA Coupé (C118) (4-Türer) Coupe | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "CLA Coupé (C118) (4-Türer) Coupe | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "CLA Coupé (C118) (4-Türer) Coupe | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "CLA Coupé (C118) (4-Türer) Coupe | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "CLA Coupé (C118 Facelift) (4-Türer) Coupe | 2023-2026",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "CLA Coupé (C118 Facelift) (4-Türer) Coupe | 2023-2026",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "CLA Coupé (C118 Facelift) (4-Türer) Coupe | 2023-2026",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "CLA Coupé (C118 Facelift) (4-Türer) Coupe | 2023-2026",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "CLA Coupé (C117) (4-Türer) Coupe C117 Facelift | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "CLA Coupé (C117) (4-Türer) Coupe | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "CLA Coupé (C117) (4-Türer) Coupe | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "CLA Coupé (C117) (4-Türer) Coupe | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "CLA Coupé (C117) (4-Türer) Coupe | 2013-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "CLA Coupé (C117) (4-Türer) Coupe | 2013-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "CLA Coupé (C117) (4-Türer) Coupe | 2013-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "CLA Coupé (C117) (4-Türer) Coupe C117 | 2013-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "CLA Shooting Brake (X118) (5-Türer) Kombi | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "CLA Shooting Brake (X118) (5-Türer) Kombi | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "CLA Shooting Brake (X118) (5-Türer) Kombi | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "CLA Shooting Brake (X118) (5-Türer) Kombi | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "CLA Shooting Brake (X118) (5-Türer) Kombi | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "CLA Shooting Brake (X118 Facelift) (5-Türer) Kombi | 2023-2026",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "CLA Shooting Brake (X118 Facelift) (5-Türer) Kombi | 2023-2026",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "CLA Shooting Brake (X118 Facelift) (5-Türer) Kombi | 2023-2026",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "CLA Shooting Brake (X118 Facelift) (5-Türer) Kombi | 2023-2026",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "CLA Shooting Brake (X117) (5-Türer) Kombi C117 Facelift | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "CLA Shooting Brake (X117) (5-Türer) Kombi | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "CLA Shooting Brake (X117) (5-Türer) Kombi | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "CLA Shooting Brake (X117) (5-Türer) Kombi | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "CLA Shooting Brake (X117) (5-Türer) Kombi | 2015-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "CLA Shooting Brake (X117) (5-Türer) Kombi C117 | 2015-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "CLS Coupé (4-Türer) Coupe | 2019-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "CLS Coupé (4-Türer) Coupe | 2019-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "CLS Coupé (4-Türer) Coupe C257 | 2019-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "CLS Coupé (4-Türer) Coupe C257 Facelift | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "CLS Coupé (4-Türer) Coupe | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "CLS Coupé (4-Türer) Coupe | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "CLS Coupé (4-Türer) Coupe | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "CLS Coupé (4-Türer) Coupe | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "CLS Coupé (4-Türer) Coupe | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "E-Class Sedan (W213) (4-Türer) Stufenheck W213 Facelift | 2020-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "E-Class Sedan (W213) (4-Türer) Stufenheck | 2020-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "E-Class Sedan (W213) (4-Türer) Stufenheck | 2020-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "E-Class Sedan (W213) (4-Türer) Stufenheck | 2020-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "E-Class Sedan (W213) (4-Türer) Stufenheck | 2017-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "E-Class Sedan (W213) (4-Türer) Stufenheck | 2017-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "E-Class Sedan (W213) (4-Türer) Stufenheck | 2017-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "E-Class Sedan (W213) (4-Türer) Stufenheck W213 | 2017-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "E-Class Sedan (W214) (4-Türer) Stufenheck | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "E-Class Sedan (W214) (4-Türer) Stufenheck | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "E-Class Sedan (W214) (4-Türer) Stufenheck | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "E-Class Sedan (W212) (4-Türer) Stufenheck | 2009-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "E-Class Sedan (W212) (4-Türer) Stufenheck | 2009-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "E-Class Sedan (W212) (4-Türer) Stufenheck | 2009-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "E-Class Sedan (W212) (4-Türer) Stufenheck | 2009-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "E-Class Sedan (W212) (4-Türer) Stufenheck | 2009-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "E-Class Sedan (W212) (4-Türer) Stufenheck W212 | 2009-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "E-Class Sedan (W212) (4-Türer) Stufenheck W212 Facelift | 2014-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "E-Class Sedan (W212) (4-Türer) Stufenheck | 2014-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "E-Class Sedan (W212) (4-Türer) Stufenheck | 2014-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "E-Class Sedan (W213) (4-Türer) Stufenheck W213 Facelift | 2020-2023",
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "E-Class Sedan (W213) (4-Türer) Stufenheck | 2020-2023",
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "E-Class Sedan (W213) (4-Türer) Stufenheck | 2020-2023",
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "E-Class Sedan (W213) (4-Türer) Stufenheck | 2020-2023",
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "E-Class Sedan (W213) (4-Türer) Stufenheck | 2017-2020",
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "E-Class Sedan (W213) (4-Türer) Stufenheck | 2017-2020",
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "E-Class Sedan (W213) (4-Türer) Stufenheck | 2017-2020",
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "E-Class Sedan (W213) (4-Türer) Stufenheck W213 | 2017-2020",
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "EQC (5-Türer) SUV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "EQC (5-Türer) SUV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "EQC (5-Türer) SUV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "EQC (5-Türer) SUV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "EQC (5-Türer) SUV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "EQC (5-Türer) SUV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "EQE SUV (5-Türer) SUV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "EQE SUV (5-Türer) SUV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "EQE SUV (5-Türer) SUV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "EQE SUV (5-Türer) SUV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "EQS (5-Türer) Schrägheck V297 1st Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "EQS (5-Türer) Schrägheck | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "EQS (5-Türer) Schrägheck | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "EQS (5-Türer) Schrägheck | 2021-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "EQS (5-Türer) Schrägheck | 2021-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "EQS (5-Türer) Schrägheck | 2021-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "EQS (5-Türer) Schrägheck V297 | 2021-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "EQS SUV (5-Türer) SUV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "EQS SUV (5-Türer) SUV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "EQS SUV (5-Türer) SUV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "EQS SUV (5-Türer) SUV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "EQS SUV (5-Türer) SUV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "G-Class LWB (5-Türer) SUV W463 2nd Generation Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "G-Class LWB (5-Türer) SUV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "G-Class LWB (5-Türer) SUV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "G-Class LWB (5-Türer) SUV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "G-Class LWB (5-Türer) SUV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "G-Class LWB (5-Türer) SUV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "G-Class LWB (5-Türer) SUV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "G-Class LWB (5-Türer) SUV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "G-Class LWB (5-Türer) SUV W463 2nd Generation | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "GLC Coupé (C253) (5-Türer) SUV | 2017-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "GLC Coupé (C253) (5-Türer) SUV | 2017-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "GLC Coupé (C253) (5-Türer) SUV X253 | 2017-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "GLC Coupé (C253) (5-Türer) SUV X253 Facelift | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "GLC Coupé (C253) (5-Türer) SUV | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "GLC Coupé (C253) (5-Türer) SUV | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "GLC Coupé (C253) (5-Türer) SUV | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "GLC Coupé (C253) (5-Türer) SUV | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "GLC Coupé (C254) (5-Türer) SUV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "GLC Coupé (C254) (5-Türer) SUV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "GLC Coupé (C254) (5-Türer) SUV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "GLC Coupé (C254) (5-Türer) SUV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "GLE Coupé (C167) (5-Türer) SUV V167 1st Facelift | 2023-2026",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "GLE Coupé (C167) (5-Türer) SUV | 2023-2026",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "GLE Coupé (C167) (5-Türer) SUV | 2023-2026",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "GLE Coupé (C167) (5-Türer) SUV | 2023-2026",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "GLE Coupé (C167) (5-Türer) SUV | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "GLE Coupé (C167) (5-Türer) SUV | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "GLE Coupé (C167) (5-Türer) SUV | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "GLE Coupé (C167) (5-Türer) SUV | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "GLE Coupé (C167) (5-Türer) SUV V167 | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "GLE Coupé (C292) (5-Türer) SUV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "GLE Coupé (C292) (5-Türer) SUV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "GLE Coupé (C292) (5-Türer) SUV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "GLE Coupé (C292) (5-Türer) SUV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "GLE Coupé (C292) (5-Türer) SUV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "R-Class (W251) (5-Türer) MPV | 2011-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "R-Class (W251) (5-Türer) MPV | 2011-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "R-Class (W251) (5-Türer) MPV | 2011-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "R-Class (W251) (5-Türer) MPV | 2011-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "S-Class Sedan (W222) (4-Türer) Stufenheck | 2018-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "S-Class Sedan (W222) (4-Türer) Stufenheck | 2018-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "S-Class Sedan (W222) (4-Türer) Stufenheck | 2018-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "S-Class Sedan (W222) (4-Türer) Stufenheck | 2018-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "S-Class Sedan (W222) (4-Türer) Stufenheck | 2014-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "S-Class Sedan (W222) (4-Türer) Stufenheck | 2014-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "S-Class Sedan (W222) (4-Türer) Stufenheck | 2014-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "S-Class Sedan (W222) (4-Türer) Stufenheck | 2014-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "S-Class Sedan (W223) (4-Türer) Stufenheck | 2021-2026",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "S-Class Sedan (W223) (4-Türer) Stufenheck | 2021-2026",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "S-Class Sedan (W223) (4-Türer) Stufenheck | 2021-2026",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "S-Class Sedan (W223) (4-Türer) Stufenheck | 2021-2026",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "S-Class Sedan (W223) (4-Türer) Stufenheck | 2021-2026",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "S-Class Sedan (W223) (4-Türer) Stufenheck | 2021-2026",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "Sprinter Panel Van 3000 (4-Türer) LCV | 2006-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "Sprinter Panel Van 3000 (4-Türer) LCV | 2006-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "Sprinter Panel Van 3000 (4-Türer) LCV | 2006-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "Sprinter Panel Van 3000 (4-Türer) LCV | 2006-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Sprinter Panel Van 3000 (4-Türer) LCV | 2006-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Sprinter Panel Van 3000 (4-Türer) LCV | 2006-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "Sprinter Panel Van 3000 (4-Türer) LCV | 2006-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "Sprinter Panel Van 3000 (4-Türer) LCV | 2006-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Sprinter Panel Van 3000 (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "Sprinter Panel Van 3000 (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "Sprinter Panel Van 3000 (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "Sprinter Panel Van 3000 (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Sprinter Panel Van 3000 (4-Türer) LCV 906 Update | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Sprinter Panel Van 3000 (4-Türer) LCV 906 Update | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Sprinter Panel Van 3000 (4-Türer) LCV 907 | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Sprinter Panel Van 3000 (4-Türer) LCV 907 | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Sprinter Panel Van 3000 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "Sprinter Panel Van 3000 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "Sprinter Panel Van 3000 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "Sprinter Panel Van 3000 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Sprinter Panel Van 3000 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "Sprinter Panel Van 3000 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "Sprinter Panel Van 3000 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "Sprinter Panel Van 3000 (4-Türer) LCV | 2006-2013",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "Sprinter Panel Van 3000 (4-Türer) LCV | 2006-2013",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "Sprinter Panel Van 3000 (4-Türer) LCV | 2006-2013",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "Sprinter Panel Van 3000 (4-Türer) LCV | 2006-2013",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Sprinter Panel Van 3000 (4-Türer) LCV | 2006-2013",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Sprinter Panel Van 3000 (4-Türer) LCV | 2006-2013",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "Sprinter Panel Van 3000 (4-Türer) LCV | 2006-2013",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "Sprinter Panel Van 3000 (4-Türer) LCV | 2006-2013",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Sprinter Panel Van 3000 (4-Türer) LCV | 2014-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "Sprinter Panel Van 3000 (4-Türer) LCV | 2014-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "Sprinter Panel Van 3000 (4-Türer) LCV | 2014-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "Sprinter Panel Van 3000 (4-Türer) LCV | 2014-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Sprinter Panel Van 3000 (4-Türer) LCV 906 Update | 2014-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Sprinter Panel Van 3000 (4-Türer) LCV 906 Update | 2014-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Sprinter Panel Van 3190 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Sprinter Panel Van 3190 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Sprinter Panel Van 3190 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "Sprinter Panel Van 3190 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "Sprinter Panel Van 3190 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "Sprinter Panel Van 3190 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Sprinter Panel Van 3190 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "Sprinter Panel Van 3190 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "Sprinter Panel Van 3190 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "Sprinter Panel Van 3500 (4-Türer) LCV | 2006-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "Sprinter Panel Van 3500 (4-Türer) LCV | 2006-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "Sprinter Panel Van 3500 (4-Türer) LCV | 2006-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "Sprinter Panel Van 3500 (4-Türer) LCV | 2006-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Sprinter Panel Van 3500 (4-Türer) LCV | 2006-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Sprinter Panel Van 3500 (4-Türer) LCV | 2006-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "Sprinter Panel Van 3500 (4-Türer) LCV | 2006-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "Sprinter Panel Van 3500 (4-Türer) LCV | 2006-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Sprinter Panel Van 3500 (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "Sprinter Panel Van 3500 (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "Sprinter Panel Van 3500 (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "Sprinter Panel Van 3500 (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Sprinter Panel Van 3500 (4-Türer) LCV 906 Update | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Sprinter Panel Van 3500 (4-Türer) LCV 906 Update | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "Sprinter Panel Van 3500 (4-Türer) LCV | 2006-2013",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "Sprinter Panel Van 3500 (4-Türer) LCV | 2006-2013",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "Sprinter Panel Van 3500 (4-Türer) LCV | 2006-2013",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "Sprinter Panel Van 3500 (4-Türer) LCV | 2006-2013",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Sprinter Panel Van 3500 (4-Türer) LCV | 2006-2013",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Sprinter Panel Van 3500 (4-Türer) LCV | 2006-2013",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "Sprinter Panel Van 3500 (4-Türer) LCV | 2006-2013",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "Sprinter Panel Van 3500 (4-Türer) LCV | 2006-2013",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Sprinter Panel Van 3500 (4-Türer) LCV 907 | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Sprinter Panel Van 3500 (4-Türer) LCV 907 | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Sprinter Panel Van 3500 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "Sprinter Panel Van 3500 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "Sprinter Panel Van 3500 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "Sprinter Panel Van 3500 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Sprinter Panel Van 3500 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "Sprinter Panel Van 3500 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "Sprinter Panel Van 3500 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Sprinter Panel Van 3500 (4-Türer) LCV | 2014-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "Sprinter Panel Van 3500 (4-Türer) LCV | 2014-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "Sprinter Panel Van 3500 (4-Türer) LCV | 2014-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "Sprinter Panel Van 3500 (4-Türer) LCV | 2014-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Sprinter Panel Van 3500 (4-Türer) LCV 906 Update | 2014-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Sprinter Panel Van 3500 (4-Türer) LCV 906 Update | 2014-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Sprinter Panel Van 4100 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Sprinter Panel Van 4100 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Sprinter Panel Van 4100 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "Sprinter Panel Van 4100 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "Sprinter Panel Van 4100 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "Sprinter Panel Van 4100 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Sprinter Panel Van 4100 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "Sprinter Panel Van 4100 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "Sprinter Panel Van 4100 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "Sprinter Panel Van 4600 (4-Türer) LCV | 2006-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "Sprinter Panel Van 4600 (4-Türer) LCV | 2006-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "Sprinter Panel Van 4600 (4-Türer) LCV | 2006-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "Sprinter Panel Van 4600 (4-Türer) LCV | 2006-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Sprinter Panel Van 4600 (4-Türer) LCV | 2006-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Sprinter Panel Van 4600 (4-Türer) LCV | 2006-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "Sprinter Panel Van 4600 (4-Türer) LCV | 2006-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "Sprinter Panel Van 4600 (4-Türer) LCV | 2006-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Sprinter Panel Van 4600 (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "Sprinter Panel Van 4600 (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "Sprinter Panel Van 4600 (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "Sprinter Panel Van 4600 (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Sprinter Panel Van 4600 (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Sprinter Panel Van 4600 (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "Sprinter Panel Van 4600 (4-Türer) LCV | 2006-2013",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "Sprinter Panel Van 4600 (4-Türer) LCV | 2006-2013",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "Sprinter Panel Van 4600 (4-Türer) LCV | 2006-2013",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "Sprinter Panel Van 4600 (4-Türer) LCV | 2006-2013",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Sprinter Panel Van 4600 (4-Türer) LCV | 2006-2013",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Sprinter Panel Van 4600 (4-Türer) LCV | 2006-2013",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "Sprinter Panel Van 4600 (4-Türer) LCV | 2006-2013",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "Sprinter Panel Van 4600 (4-Türer) LCV | 2006-2013",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Sprinter Panel Van 4600 (4-Türer) LCV | 2014-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "Sprinter Panel Van 4600 (4-Türer) LCV | 2014-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "Sprinter Panel Van 4600 (4-Türer) LCV | 2014-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "Sprinter Panel Van 4600 (4-Türer) LCV | 2014-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Sprinter Panel Van 4600 (4-Türer) LCV | 2014-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Sprinter Panel Van 4600 (4-Türer) LCV | 2014-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "Sprinter Panel Van 5000 (4-Türer) LCV | 2006-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "Sprinter Panel Van 5000 (4-Türer) LCV | 2006-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "Sprinter Panel Van 5000 (4-Türer) LCV | 2006-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "Sprinter Panel Van 5000 (4-Türer) LCV | 2006-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Sprinter Panel Van 5000 (4-Türer) LCV | 2006-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Sprinter Panel Van 5000 (4-Türer) LCV | 2006-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "Sprinter Panel Van 5000 (4-Türer) LCV | 2006-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "Sprinter Panel Van 5000 (4-Türer) LCV | 2006-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Sprinter Panel Van 5000 (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "Sprinter Panel Van 5000 (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "Sprinter Panel Van 5000 (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "Sprinter Panel Van 5000 (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Sprinter Panel Van 5000 (4-Türer) LCV 906 Update | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Sprinter Panel Van 5000 (4-Türer) LCV 906 Update | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "Sprinter Panel Van 5000 (4-Türer) LCV | 2006-2013",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "Sprinter Panel Van 5000 (4-Türer) LCV | 2006-2013",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "Sprinter Panel Van 5000 (4-Türer) LCV | 2006-2013",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "Sprinter Panel Van 5000 (4-Türer) LCV | 2006-2013",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Sprinter Panel Van 5000 (4-Türer) LCV | 2006-2013",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Sprinter Panel Van 5000 (4-Türer) LCV | 2006-2013",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "Sprinter Panel Van 5000 (4-Türer) LCV | 2006-2013",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "Sprinter Panel Van 5000 (4-Türer) LCV | 2006-2013",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Sprinter Panel Van 5000 (4-Türer) LCV 907 | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Sprinter Panel Van 5000 (4-Türer) LCV 907 | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Sprinter Panel Van 5000 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "Sprinter Panel Van 5000 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "Sprinter Panel Van 5000 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "Sprinter Panel Van 5000 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Sprinter Panel Van 5000 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "Sprinter Panel Van 5000 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "Sprinter Panel Van 5000 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Sprinter Panel Van 5000 (4-Türer) LCV | 2014-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "Sprinter Panel Van 5000 (4-Türer) LCV | 2014-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "Sprinter Panel Van 5000 (4-Türer) LCV | 2014-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "Sprinter Panel Van 5000 (4-Türer) LCV | 2014-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Sprinter Panel Van 5000 (4-Türer) LCV 906 Update | 2014-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Sprinter Panel Van 5000 (4-Türer) LCV 906 Update | 2014-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Sprinter Panel Van 5500 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Sprinter Panel Van 5500 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Sprinter Panel Van 5500 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "Sprinter Panel Van 5500 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "Sprinter Panel Van 5500 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "Sprinter Panel Van 5500 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Sprinter Panel Van 5500 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "Sprinter Panel Van 5500 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "Sprinter Panel Van 5500 (4-Türer) LCV | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "V-Class 2.8t (5-Türer) MPV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "V-Class 2.8t (5-Türer) MPV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "V-Class 2.8t (5-Türer) MPV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "V-Class 2.8t (5-Türer) MPV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "V-Class 2.8t (5-Türer) MPV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "V-Class 2.8t (5-Türer) MPV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "V-Class 3.1t (5-Türer) MPV W447 1st Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "V-Class 3.1t (5-Türer) MPV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "V-Class 3.1t (5-Türer) MPV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "V-Class 3.1t (5-Türer) MPV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "V-Class 3.1t (5-Türer) MPV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "V-Class 3.1t (5-Türer) MPV W447 1st Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "V-Class 3.1t (5-Türer) MPV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "V-Class 3.1t (5-Türer) MPV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "V-Class 3.1t (5-Türer) MPV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "V-Class 3.1t (5-Türer) MPV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "V-Class 3.1t (5-Türer) MPV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "V-Class 3.1t (5-Türer) MPV W447 | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "V-Class 3.1t (5-Türer) MPV W447 2nd Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "V-Class 3.1t (5-Türer) MPV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "V-Class 3.1t (5-Türer) MPV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "V-Class 3.2t (5-Türer) MPV W447 1st Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "V-Class 3.2t (5-Türer) MPV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "V-Class 3.2t (5-Türer) MPV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "V-Class 3.2t (5-Türer) MPV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "V-Class 3.2t (5-Türer) MPV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "V-Class 3.2t (5-Türer) MPV W447 1st Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "V-Class 3.2t (5-Türer) MPV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "V-Class 3.2t (5-Türer) MPV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "V-Class 3.2t (5-Türer) MPV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "V-Class 3.2t (5-Türer) MPV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "V-Class 3.2t (5-Türer) MPV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "V-Class 3.2t (5-Türer) MPV W447 | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "V-Class 3.2t (5-Türer) MPV W447 2nd Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "V-Class 3.2t (5-Türer) MPV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "V-Class 3.2t (5-Türer) MPV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2003,
    "Mo": "Viano (W639) (5-Türer) LCV | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2004,
    "Mo": "Viano (W639) (5-Türer) LCV | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2005,
    "Mo": "Viano (W639) (5-Türer) LCV | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "Viano (W639) (5-Türer) LCV | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "Viano (W639) (5-Türer) LCV | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "Viano (W639) (5-Türer) LCV | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "Viano (W639) (5-Türer) LCV | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Viano (W639) (5-Türer) LCV | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Viano (W639) (5-Türer) LCV | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito 2.8t (5-Türer) LCV W447 2nd Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "Vito 2.8t (5-Türer) LCV W447 2nd Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "Vito 2.8t (5-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Vito 2.8t (5-Türer) LCV W447 | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "Vito 2.8t (5-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "Vito 2.8t (5-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "Vito 2.8t (5-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Vito 2.8t (5-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito 2.8t (5-Türer) LCV W447 | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito 2.8t (5-Türer) LCV W447 | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito 2.8t (5-Türer) LCV W447 1st Facelift | 2019-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito 2.8t (5-Türer) LCV W447 1st Facelift | 2019-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "Vito 2.8t (5-Türer) LCV | 2019-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "Vito 2.8t (5-Türer) LCV | 2019-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "Vito 2.8t (5-Türer) LCV | 2019-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito 2.8t (5-Türer) LCV W447 1st Facelift | 2019-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "Vito 2.8t (5-Türer) LCV W447 1st Facelift | 2019-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Vito 2.8t (5-Türer) LCV W639 Facelift | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Vito 2.8t (5-Türer) LCV W639 Facelift | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "Vito 2.8t (5-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "Vito 2.8t (5-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Vito 2.8t (5-Türer) LCV W639 Facelift | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2003,
    "Mo": "Vito 2.8t (5-Türer) LCV | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2004,
    "Mo": "Vito 2.8t (5-Türer) LCV | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2005,
    "Mo": "Vito 2.8t (5-Türer) LCV | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "Vito 2.8t (5-Türer) LCV | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "Vito 2.8t (5-Türer) LCV | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "Vito 2.8t (5-Türer) LCV | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "Vito 2.8t (5-Türer) LCV | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Vito 2.8t (5-Türer) LCV W639 | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Vito 2.8t (5-Türer) LCV W639 | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Vito 2.8t (5-Türer) LCV W639 Facelift | 2010-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Vito 2.8t (5-Türer) LCV W639 Facelift | 2010-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "Vito 2.8t (5-Türer) LCV | 2010-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "Vito 2.8t (5-Türer) LCV | 2010-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Vito 2.8t (5-Türer) LCV W639 Facelift | 2010-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2003,
    "Mo": "Vito 2.8t (5-Türer) LCV | 2003-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2004,
    "Mo": "Vito 2.8t (5-Türer) LCV | 2003-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2005,
    "Mo": "Vito 2.8t (5-Türer) LCV | 2003-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "Vito 2.8t (5-Türer) LCV | 2003-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "Vito 2.8t (5-Türer) LCV | 2003-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "Vito 2.8t (5-Türer) LCV | 2003-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "Vito 2.8t (5-Türer) LCV | 2003-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Vito 2.8t (5-Türer) LCV W639 | 2003-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Vito 2.8t (5-Türer) LCV W639 | 2003-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito 3.0t (5-Türer) LCV W447 2nd Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "Vito 3.0t (5-Türer) LCV W447 2nd Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "Vito 3.0t (5-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Vito 3.0t (5-Türer) LCV W447 | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "Vito 3.0t (5-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "Vito 3.0t (5-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "Vito 3.0t (5-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Vito 3.0t (5-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito 3.0t (5-Türer) LCV W447 | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito 3.0t (5-Türer) LCV W447 | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito 3.0t (5-Türer) LCV W447 1st Facelift | 2019-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito 3.0t (5-Türer) LCV W447 1st Facelift | 2019-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "Vito 3.0t (5-Türer) LCV | 2019-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "Vito 3.0t (5-Türer) LCV | 2019-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "Vito 3.0t (5-Türer) LCV | 2019-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito 3.0t (5-Türer) LCV W447 1st Facelift | 2019-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "Vito 3.0t (5-Türer) LCV W447 1st Facelift | 2019-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Vito 3.0t (5-Türer) LCV W639 Facelift | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Vito 3.0t (5-Türer) LCV W639 Facelift | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "Vito 3.0t (5-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "Vito 3.0t (5-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Vito 3.0t (5-Türer) LCV W639 Facelift | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2003,
    "Mo": "Vito 3.0t (5-Türer) LCV | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2004,
    "Mo": "Vito 3.0t (5-Türer) LCV | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2005,
    "Mo": "Vito 3.0t (5-Türer) LCV | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "Vito 3.0t (5-Türer) LCV | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "Vito 3.0t (5-Türer) LCV | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "Vito 3.0t (5-Türer) LCV | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "Vito 3.0t (5-Türer) LCV | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Vito 3.0t (5-Türer) LCV W639 | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Vito 3.0t (5-Türer) LCV W639 | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Vito 3.0t (5-Türer) LCV W639 Facelift | 2010-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Vito 3.0t (5-Türer) LCV W639 Facelift | 2010-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "Vito 3.0t (5-Türer) LCV | 2010-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "Vito 3.0t (5-Türer) LCV | 2010-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Vito 3.0t (5-Türer) LCV W639 Facelift | 2010-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2003,
    "Mo": "Vito 3.0t (5-Türer) LCV | 2003-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2004,
    "Mo": "Vito 3.0t (5-Türer) LCV | 2003-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2005,
    "Mo": "Vito 3.0t (5-Türer) LCV | 2003-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "Vito 3.0t (5-Türer) LCV | 2003-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "Vito 3.0t (5-Türer) LCV | 2003-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "Vito 3.0t (5-Türer) LCV | 2003-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "Vito 3.0t (5-Türer) LCV | 2003-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Vito 3.0t (5-Türer) LCV W639 | 2003-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Vito 3.0t (5-Türer) LCV W639 | 2003-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito 3.2t (5-Türer) LCV W447 2nd Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "Vito 3.2t (5-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "Vito 3.2t (5-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Vito 3.2t (5-Türer) LCV W447 | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "Vito 3.2t (5-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "Vito 3.2t (5-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "Vito 3.2t (5-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Vito 3.2t (5-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito 3.2t (5-Türer) LCV W447 | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito 3.2t (5-Türer) LCV W447 | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito 3.2t (5-Türer) LCV W447 1st Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito 3.2t (5-Türer) LCV W447 1st Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "Vito 3.2t (5-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "Vito 3.2t (5-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "Vito 3.2t (5-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito 3.2t (5-Türer) LCV W447 1st Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Vito 3.2t (5-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Vito 3.2t (5-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "Vito 3.2t (5-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "Vito 3.2t (5-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Vito 3.2t (5-Türer) LCV W639 Facelift | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Vito 3.2t (5-Türer) LCV | 2010-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Vito 3.2t (5-Türer) LCV | 2010-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "Vito 3.2t (5-Türer) LCV | 2010-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "Vito 3.2t (5-Türer) LCV | 2010-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Vito 3.2t (5-Türer) LCV W639 Facelift | 2010-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV W447 2nd Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV W447 | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV W447 | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV W447 | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV W447 1st Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV W447 1st Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV W447 1st Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV W639 Facelift | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV W639 Facelift | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV W639 Facelift | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2003,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2004,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2005,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV W639 | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV W639 | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV W639 Facelift | 2010-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV W639 Facelift | 2010-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV | 2010-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV | 2010-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV W639 Facelift | 2010-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2003,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV | 2003-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2004,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV | 2003-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2005,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV | 2003-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV | 2003-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV | 2003-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV | 2003-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV | 2003-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV W639 | 2003-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV W639 | 2003-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV W447 2nd Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV W447 | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV W447 | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV W447 | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV W447 1st Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV W447 1st Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV W447 1st Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV W639 Facelift | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV W639 Facelift | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV W639 Facelift | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2003,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2004,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2005,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV W639 | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV W639 | 2003-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV W639 Facelift | 2010-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV W639 Facelift | 2010-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV | 2010-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV | 2010-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV W639 Facelift | 2010-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2003,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV | 2003-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2004,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV | 2003-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2005,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV | 2003-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV | 2003-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV | 2003-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV | 2003-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV | 2003-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV W639 | 2003-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV W639 | 2003-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV W447 | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV W447 | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV W447 | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV W447 2nd Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV W447 1st Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV W447 1st Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV W447 1st Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV W639 Facelift | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV | 2010-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV | 2010-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV | 2010-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV | 2010-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV W639 Facelift | 2010-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV W447 2nd Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV W447 | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV W447 | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV W447 | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV W447 1st Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV W447 1st Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV W447 1st Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito MPV 3.2t (5-Türer) LCV W447 2nd Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "Vito MPV 3.2t (5-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "Vito MPV 3.2t (5-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Vito MPV 3.2t (5-Türer) LCV W447 | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "Vito MPV 3.2t (5-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "Vito MPV 3.2t (5-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "Vito MPV 3.2t (5-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Vito MPV 3.2t (5-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito MPV 3.2t (5-Türer) LCV W447 | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito MPV 3.2t (5-Türer) LCV W447 | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito MPV 3.2t (5-Türer) LCV W447 1st Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito MPV 3.2t (5-Türer) LCV W447 1st Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "Vito MPV 3.2t (5-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "Vito MPV 3.2t (5-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "Vito MPV 3.2t (5-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito MPV 3.2t (5-Türer) LCV W447 1st Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito MPV 3.5t (5-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito MPV 3.5t (5-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "Vito MPV 3.5t (5-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "Vito MPV 3.5t (5-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "Vito MPV 3.5t (5-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito MPV 3.5t (5-Türer) LCV W447 1st Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito MPV 3.5t (5-Türer) LCV W447 2nd Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "Vito MPV 3.5t (5-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "Vito MPV 3.5t (5-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2005,
    "Mo": "Astra (3-Türer) Schrägheck | 2005-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2006,
    "Mo": "Astra (3-Türer) Schrägheck | 2005-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2007,
    "Mo": "Astra (3-Türer) Schrägheck H | 2005-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2007,
    "Mo": "Astra (3-Türer) Schrägheck H Facelift | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2008,
    "Mo": "Astra (3-Türer) Schrägheck | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2009,
    "Mo": "Astra (3-Türer) Schrägheck | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2010,
    "Mo": "Astra (3-Türer) Schrägheck | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2011,
    "Mo": "Astra (3-Türer) Schrägheck | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2004,
    "Mo": "Astra (5-Türer) Schrägheck | 2004-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2005,
    "Mo": "Astra (5-Türer) Schrägheck | 2004-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2006,
    "Mo": "Astra (5-Türer) Schrägheck | 2004-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2007,
    "Mo": "Astra (5-Türer) Schrägheck H | 2004-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2007,
    "Mo": "Astra (5-Türer) Schrägheck H Facelift | 2007-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2008,
    "Mo": "Astra (5-Türer) Schrägheck | 2007-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2009,
    "Mo": "Astra (5-Türer) Schrägheck | 2007-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2010,
    "Mo": "Astra (5-Türer) Schrägheck H Facelift | 2007-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2011,
    "Mo": "Astra (5-Türer) Schrägheck H Facelift | 2007-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2012,
    "Mo": "Astra (5-Türer) Schrägheck H Facelift | 2007-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2010,
    "Mo": "Astra (5-Türer) Schrägheck J | 2010-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2011,
    "Mo": "Astra (5-Türer) Schrägheck J | 2010-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2012,
    "Mo": "Astra (5-Türer) Schrägheck J | 2010-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2012,
    "Mo": "Combo (5-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2013,
    "Mo": "Combo (5-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2014,
    "Mo": "Combo (5-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2015,
    "Mo": "Combo (5-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2016,
    "Mo": "Combo (5-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Combo (5-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Combo (5-Türer) LCV D | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Combo (5-Türer) LCV E | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Combo (5-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Combo (5-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Combo (5-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Combo (5-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Combo (5-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Combo (5-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Combo Crew Van (4-Türer) LCV E Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Combo Crew Van (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2026,
    "Mo": "Combo Crew Van (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Combo Crew Van (4-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Combo Crew Van (4-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Combo Crew Van (4-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Combo Crew Van (4-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Combo Crew Van (4-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Combo Crew Van (4-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Combo Crew Van (4-Türer) LCV E | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Zafira Life (4-Türer) LCV 1st Generation Facelift | 2025-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2026,
    "Mo": "Zafira Life (4-Türer) LCV 1st Generation Facelift | 2025-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Zafira Life (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Zafira Life (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Zafira Life (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Zafira Life (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Zafira Life (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Zafira Life (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Zafira Life (4-Türer) LCV 1st Generation | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2026,
    "Mo": "Zafira Life (4-Türer) LCV 1st Generation | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2002,
    "Mo": "307 (3C) (5-Türer) Schrägheck | 2002-2005",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2003,
    "Mo": "307 (3C) (5-Türer) Schrägheck | 2002-2005",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2004,
    "Mo": "307 (3C) (5-Türer) Schrägheck | 2002-2005",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2005,
    "Mo": "307 (3C) (5-Türer) Schrägheck | 2002-2005",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2005,
    "Mo": "307 (3C Facelif) (5-Türer) Schrägheck | 2005-2008",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2006,
    "Mo": "307 (3C Facelif) (5-Türer) Schrägheck | 2005-2008",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2007,
    "Mo": "307 (3C Facelif) (5-Türer) Schrägheck | 2005-2008",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "307 (3C Facelif) (5-Türer) Schrägheck | 2005-2008",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "5008 (5-Türer) MPV T8 Facelift | 2013-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "5008 (5-Türer) MPV | 2013-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "5008 (5-Türer) MPV | 2013-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "5008 (5-Türer) MPV | 2013-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2009,
    "Mo": "5008 (5-Türer) MPV | 2009-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2010,
    "Mo": "5008 (5-Türer) MPV | 2009-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "5008 (5-Türer) MPV | 2009-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "5008 (5-Türer) MPV | 2009-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "5008 (5-Türer) MPV T8 | 2009-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "5008 7-Seater (5-Türer) MPV | 2013-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "5008 7-Seater (5-Türer) MPV | 2013-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "5008 7-Seater (5-Türer) MPV | 2013-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "5008 7-Seater (5-Türer) MPV | 2013-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "Bipper (3-Türer) LCV | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2009,
    "Mo": "Bipper (3-Türer) LCV | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2010,
    "Mo": "Bipper (3-Türer) LCV | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "Bipper (3-Türer) LCV | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "Bipper (3-Türer) LCV | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "Bipper (3-Türer) LCV | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "Bipper (3-Türer) LCV | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "Bipper (3-Türer) LCV | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "Bipper (3-Türer) LCV | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "Expert Crew Cab (4-Türer) LCV 3rd Generation 2nd Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "Expert Crew Cab (4-Türer) LCV 3rd Generation 2nd Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2026,
    "Mo": "Expert Crew Cab (4-Türer) LCV 3rd Generation 2nd Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "Expert Crew Cab (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "Expert Crew Cab (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "Expert Crew Cab (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "Expert Crew Cab (4-Türer) LCV 3rd Generation | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "Expert Crew Cab (4-Türer) LCV 3rd Generation | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "Expert Crew Cab (4-Türer) LCV 3rd Generation | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "Expert Crew Cab (4-Türer) LCV 3rd Generation | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "Expert Crew Cab (4-Türer) LCV 3rd Generation | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "Expert Crew Cab (4-Türer) LCV 3rd Generation | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "Expert Crew Cab (4-Türer) LCV 3rd Generation | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2026,
    "Mo": "Expert Crew Cab (4-Türer) LCV 3rd Generation | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "Expert Crew Cab (4-Türer) LCV 3rd Generation Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "Expert Crew Cab (4-Türer) LCV 3rd Generation Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "Expert Crew Cab (4-Türer) LCV 3rd Generation Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "Expert Crew Cab (4-Türer) LCV 3rd Generation Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "Expert Crew Cab (4-Türer) LCV 3rd Generation Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "Expert Crew Cab (4-Türer) LCV 3rd Generation Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "Expert Crew Cab Increased Payload (4-Türer) LCV 3rd Generation 2nd Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "Expert Crew Cab Increased Payload (4-Türer) LCV 3rd Generation 2nd Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2026,
    "Mo": "Expert Crew Cab Increased Payload (4-Türer) LCV 3rd Generation 2nd Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "Expert Crew Cab Increased Payload (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "Expert Crew Cab Increased Payload (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "Expert Crew Cab Increased Payload (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "Expert Crew Cab Increased Payload (4-Türer) LCV 3rd Generation | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "Expert Crew Cab Increased Payload (4-Türer) LCV 3rd Generation | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "Expert Crew Cab Increased Payload (4-Türer) LCV 3rd Generation | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "Expert Crew Cab Increased Payload (4-Türer) LCV 3rd Generation | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "Expert Crew Cab Increased Payload (4-Türer) LCV 3rd Generation | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "Expert Crew Cab Increased Payload (4-Türer) LCV 3rd Generation | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "Expert Crew Cab Increased Payload (4-Türer) LCV 3rd Generation | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2026,
    "Mo": "Expert Crew Cab Increased Payload (4-Türer) LCV 3rd Generation | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "Expert Crew Cab Increased Payload (4-Türer) LCV 3rd Generation Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "Expert Crew Cab Increased Payload (4-Türer) LCV 3rd Generation Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "Expert Crew Cab Increased Payload (4-Türer) LCV 3rd Generation Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "Expert Crew Cab Increased Payload (4-Türer) LCV 3rd Generation Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "Expert Crew Cab Increased Payload (4-Türer) LCV 3rd Generation Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "Expert Crew Cab Increased Payload (4-Türer) LCV 3rd Generation Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "Partner Crew Van (4-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "Partner Crew Van (4-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "Partner Crew Van (4-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "Partner Crew Van (4-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "Partner Crew Van (4-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "Partner Crew Van (4-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "Partner Crew Van (4-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "Partner Van L2 (4-Türer) LCV K9 Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "Partner Van L2 (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2026,
    "Mo": "Partner Van L2 (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "Partner Van L2 (4-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "Partner Van L2 (4-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "Partner Van L2 (4-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "Partner Van L2 (4-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "Partner Van L2 (4-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "Partner Van L2 (4-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "Partner Van L2 (4-Türer) LCV K9 | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "Partner Van L2 Increased Payload (4-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "Partner Van L2 Increased Payload (4-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "Partner Van L2 Increased Payload (4-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "Partner Van L2 Increased Payload (4-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "Partner Van L2 Increased Payload (4-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "Partner Van L2 Increased Payload (4-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "Partner Van L2 Increased Payload (4-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "Rifter (5-Türer) MPV 1st Generation Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "Rifter (5-Türer) MPV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2026,
    "Mo": "Rifter (5-Türer) MPV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "Rifter (5-Türer) MPV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "Rifter (5-Türer) MPV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "Rifter (5-Türer) MPV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "Rifter (5-Türer) MPV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "Rifter (5-Türer) MPV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "Rifter (5-Türer) MPV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "Rifter (5-Türer) MPV 1st Generation | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "Traveller (4-Türer) MPV | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "Traveller (4-Türer) MPV | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "Traveller (4-Türer) MPV | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "Traveller (4-Türer) MPV | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "Traveller (4-Türer) MPV | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "Traveller (4-Türer) MPV | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "Traveller (4-Türer) MPV | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "Traveller (4-Türer) MPV | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "Traveller (4-Türer) MPV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "Traveller (4-Türer) MPV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2026,
    "Mo": "Traveller (4-Türer) MPV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Interstar Van 4.0 t (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Interstar Van 4.0 t (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2026,
    "Mo": "Interstar Van 4.0 t (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2010,
    "Mo": "NV200 Combi (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2011,
    "Mo": "NV200 Combi (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2012,
    "Mo": "NV200 Combi (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "NV200 Combi (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "NV200 Combi (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "NV200 Combi (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "NV200 Combi (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "NV200 Combi (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "NV200 Combi (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "NV200 Combi (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "NV200 Combi (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "NV200 Combi (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "NV200 Combi (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "NV200 Combi (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "NV200 Combi (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "NV200 Combi (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2026,
    "Mo": "NV200 Combi (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2010,
    "Mo": "NV200 Crew Van (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2011,
    "Mo": "NV200 Crew Van (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2012,
    "Mo": "NV200 Crew Van (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "NV200 Crew Van (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "NV200 Crew Van (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "NV200 Crew Van (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "NV200 Crew Van (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "NV200 Crew Van (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "NV200 Crew Van (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "NV200 Crew Van (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "NV200 Crew Van (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "NV200 Crew Van (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "NV200 Crew Van (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "NV200 Crew Van (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "NV200 Crew Van (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "NV200 Crew Van (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2026,
    "Mo": "NV200 Crew Van (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "NV250 2.0t (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "NV250 2.0t (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "NV250 2.0t (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "NV250 2.0t (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "NV250 2.0t (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "NV250 2.0t (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "NV250 2.0t (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2026,
    "Mo": "NV250 2.0t (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "NV250 2.1t (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "NV250 2.1t (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "NV250 2.1t (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "NV250 2.1t (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "NV250 2.1t (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "NV250 2.1t (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "NV250 2.1t (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2026,
    "Mo": "NV250 2.1t (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "NV250 2.2t (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "NV250 2.2t (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "NV250 2.2t (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "NV250 2.2t (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "NV250 2.2t (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "NV250 2.2t (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "NV250 2.2t (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2026,
    "Mo": "NV250 2.2t (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2010,
    "Mo": "NV400 (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2011,
    "Mo": "NV400 (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2012,
    "Mo": "NV400 (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "NV400 (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "NV400 (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "NV400 (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "NV400 (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "NV400 (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "NV400 (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "NV400 (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "NV400 (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "NV400 (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "NV400 (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "NV400 (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "NV400 (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "NV400 (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2026,
    "Mo": "NV400 (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2010,
    "Mo": "NV400 Crew Van (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2011,
    "Mo": "NV400 Crew Van (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2012,
    "Mo": "NV400 Crew Van (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "NV400 Crew Van (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "NV400 Crew Van (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "NV400 Crew Van (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "NV400 Crew Van (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "NV400 Crew Van (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "NV400 Crew Van (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "NV400 Crew Van (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "NV400 Crew Van (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "NV400 Crew Van (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "NV400 Crew Van (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "NV400 Crew Van (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "NV400 Crew Van (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "NV400 Crew Van (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2026,
    "Mo": "NV400 Crew Van (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2010,
    "Mo": "NV400 Minibus (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2011,
    "Mo": "NV400 Minibus (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2012,
    "Mo": "NV400 Minibus (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "NV400 Minibus (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "NV400 Minibus (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "NV400 Minibus (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "NV400 Minibus (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "NV400 Minibus (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "NV400 Minibus (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "NV400 Minibus (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "NV400 Minibus (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "NV400 Minibus (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "NV400 Minibus (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "NV400 Minibus (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "NV400 Minibus (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "NV400 Minibus (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2026,
    "Mo": "NV400 Minibus (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2010,
    "Mo": "NV400 Panel Van 2.8t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2011,
    "Mo": "NV400 Panel Van 2.8t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2012,
    "Mo": "NV400 Panel Van 2.8t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "NV400 Panel Van 2.8t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "NV400 Panel Van 2.8t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "NV400 Panel Van 2.8t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "NV400 Panel Van 2.8t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "NV400 Panel Van 2.8t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "NV400 Panel Van 2.8t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "NV400 Panel Van 2.8t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "NV400 Panel Van 2.8t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "NV400 Panel Van 2.8t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "NV400 Panel Van 2.8t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "NV400 Panel Van 2.8t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "NV400 Panel Van 2.8t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "NV400 Panel Van 2.8t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2026,
    "Mo": "NV400 Panel Van 2.8t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2010,
    "Mo": "NV400 Panel Van 3.3t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2011,
    "Mo": "NV400 Panel Van 3.3t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2012,
    "Mo": "NV400 Panel Van 3.3t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "NV400 Panel Van 3.3t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "NV400 Panel Van 3.3t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "NV400 Panel Van 3.3t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "NV400 Panel Van 3.3t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "NV400 Panel Van 3.3t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "NV400 Panel Van 3.3t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "NV400 Panel Van 3.3t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "NV400 Panel Van 3.3t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "NV400 Panel Van 3.3t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "NV400 Panel Van 3.3t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "NV400 Panel Van 3.3t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "NV400 Panel Van 3.3t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "NV400 Panel Van 3.3t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2026,
    "Mo": "NV400 Panel Van 3.3t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2010,
    "Mo": "NV400 Panel Van 3.5t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2011,
    "Mo": "NV400 Panel Van 3.5t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2012,
    "Mo": "NV400 Panel Van 3.5t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "NV400 Panel Van 3.5t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "NV400 Panel Van 3.5t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "NV400 Panel Van 3.5t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "NV400 Panel Van 3.5t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "NV400 Panel Van 3.5t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "NV400 Panel Van 3.5t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "NV400 Panel Van 3.5t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "NV400 Panel Van 3.5t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "NV400 Panel Van 3.5t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "NV400 Panel Van 3.5t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "NV400 Panel Van 3.5t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "NV400 Panel Van 3.5t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "NV400 Panel Van 3.5t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2026,
    "Mo": "NV400 Panel Van 3.5t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2010,
    "Mo": "NV400 Panel Van 4.5t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2011,
    "Mo": "NV400 Panel Van 4.5t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2012,
    "Mo": "NV400 Panel Van 4.5t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "NV400 Panel Van 4.5t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "NV400 Panel Van 4.5t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "NV400 Panel Van 4.5t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "NV400 Panel Van 4.5t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "NV400 Panel Van 4.5t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "NV400 Panel Van 4.5t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "NV400 Panel Van 4.5t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "NV400 Panel Van 4.5t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "NV400 Panel Van 4.5t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "NV400 Panel Van 4.5t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "NV400 Panel Van 4.5t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "NV400 Panel Van 4.5t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "NV400 Panel Van 4.5t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2026,
    "Mo": "NV400 Panel Van 4.5t (4-Türer) LCV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Townstar 2.0t (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Townstar 2.0t (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Townstar 2.0t (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Townstar 2.0t (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2026,
    "Mo": "Townstar 2.0t (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Townstar 2.2t (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Townstar 2.2t (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Townstar 2.2t (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Townstar 2.2t (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2026,
    "Mo": "Townstar 2.2t (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Townstar 2.5t (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Townstar 2.5t (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Townstar 2.5t (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Townstar 2.5t (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2026,
    "Mo": "Townstar 2.5t (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "X-Trail (5-Türer) SUV T32 Facelift | 2017-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "X-Trail (5-Türer) SUV | 2017-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "X-Trail (5-Türer) SUV | 2017-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "X-Trail (5-Türer) SUV | 2017-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "X-Trail (5-Türer) SUV T32 Facelift | 2017-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "X-Trail (5-Türer) SUV | 2014-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "X-Trail (5-Türer) SUV | 2014-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "X-Trail (5-Türer) SUV | 2014-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "X-Trail (5-Türer) SUV T32 | 2014-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2003,
    "Mo": "Espace (5-Türer) MPV | 2003-2006",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2004,
    "Mo": "Espace (5-Türer) MPV | 2003-2006",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2005,
    "Mo": "Espace (5-Türer) MPV | 2003-2006",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2006,
    "Mo": "Espace (5-Türer) MPV JK Phase I | 2003-2006",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Espace (5-Türer) MPV | 2013-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Espace (5-Türer) MPV | 2013-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Espace (5-Türer) MPV JK Phase IV | 2013-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2006,
    "Mo": "Espace (5-Türer) MPV JK Phase II | 2006-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2007,
    "Mo": "Espace (5-Türer) MPV | 2006-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2008,
    "Mo": "Espace (5-Türer) MPV | 2006-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2009,
    "Mo": "Espace (5-Türer) MPV | 2006-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2010,
    "Mo": "Espace (5-Türer) MPV | 2006-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2011,
    "Mo": "Espace (5-Türer) MPV JK Phase II | 2006-2011",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2011,
    "Mo": "Espace (5-Türer) MPV JK Phase III | 2011-2012",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2012,
    "Mo": "Espace (5-Türer) MPV | 2011-2012",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Kangoo Express Maxi Passenger (5-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Kangoo Express Maxi Passenger (5-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Kangoo Express Maxi Passenger (5-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2026,
    "Mo": "Kangoo Express Maxi Passenger (5-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2008,
    "Mo": "Kangoo Express Maxi Passenger (5-Türer) LCV | 2008-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2009,
    "Mo": "Kangoo Express Maxi Passenger (5-Türer) LCV | 2008-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2010,
    "Mo": "Kangoo Express Maxi Passenger (5-Türer) LCV | 2008-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2011,
    "Mo": "Kangoo Express Maxi Passenger (5-Türer) LCV | 2008-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2012,
    "Mo": "Kangoo Express Maxi Passenger (5-Türer) LCV | 2008-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Kangoo Express Maxi Passenger (5-Türer) LCV KW | 2008-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Kangoo Express Maxi Passenger (5-Türer) LCV KW Facelift | 2013-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Kangoo Express Maxi Passenger (5-Türer) LCV | 2013-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Kangoo Express Maxi Passenger (5-Türer) LCV | 2013-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Kangoo Express Maxi Passenger (5-Türer) LCV | 2013-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Kangoo Express Maxi Passenger (5-Türer) LCV | 2013-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Kangoo Express Maxi Passenger (5-Türer) LCV | 2013-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Kangoo Express Maxi Passenger (5-Türer) LCV | 2013-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Kangoo Express Maxi Passenger (5-Türer) LCV | 2013-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Kangoo Express Maxi Passenger (5-Türer) LCV | 2013-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Master Crew Van 3.5 T (4-Türer) LCV III 1st Facelift | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Master Crew Van 3.5 T (4-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Master Crew Van 3.5 T (4-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Master Crew Van 3.5 T (4-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Master Crew Van 3.5 T (4-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Master Crew Van 3.5 T (4-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Master Crew Van 3.5 T (4-Türer) LCV III 1st Facelift | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Master Crew Van 3.5 T (4-Türer) LCV III 2nd Facelift | 2020-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Master Crew Van 3.5 T (4-Türer) LCV | 2020-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Master Crew Van 3.5 T (4-Türer) LCV | 2020-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Master Crew Van 3.5 T (4-Türer) LCV | 2020-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Master Crew Van 3.5 T (4-Türer) LCV III 2nd Facelift | 2020-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Master Crew Van 3.5 T (4-Türer) LCV III 2nd Facelift | 2020-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2010,
    "Mo": "Master Crew Van 3.5 T (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2011,
    "Mo": "Master Crew Van 3.5 T (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2012,
    "Mo": "Master Crew Van 3.5 T (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Master Crew Van 3.5 T (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Master Crew Van 3.5 T (4-Türer) LCV III | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2006,
    "Mo": "Mégane (BM II) (5-Türer) Schrägheck | 2006-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2007,
    "Mo": "Mégane (BM II) (5-Türer) Schrägheck | 2006-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2008,
    "Mo": "Mégane (BM II) (5-Türer) Schrägheck | 2006-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2009,
    "Mo": "Mégane (BM II) (5-Türer) Schrägheck | 2006-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2003,
    "Mo": "Mégane (BM I) (5-Türer) Schrägheck | 2003-2006",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2004,
    "Mo": "Mégane (BM I) (5-Türer) Schrägheck | 2003-2006",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2005,
    "Mo": "Mégane (BM I) (5-Türer) Schrägheck | 2003-2006",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2006,
    "Mo": "Mégane (BM I) (5-Türer) Schrägheck | 2003-2006",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2019,
    "Mo": "3 Sedan (BP) (4-Türer) Stufenheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2020,
    "Mo": "3 Sedan (BP) (4-Türer) Stufenheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2021,
    "Mo": "3 Sedan (BP) (4-Türer) Stufenheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "3 Sedan (BP) (4-Türer) Stufenheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2023,
    "Mo": "3 Sedan (BP) (4-Türer) Stufenheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "3 Sedan (BP) (4-Türer) Stufenheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "3 Sedan (BP) (4-Türer) Stufenheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2026,
    "Mo": "3 Sedan (BP) (4-Türer) Stufenheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2019,
    "Mo": "3 Sport (BP) (5-Türer) Schrägheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2020,
    "Mo": "3 Sport (BP) (5-Türer) Schrägheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2021,
    "Mo": "3 Sport (BP) (5-Türer) Schrägheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "3 Sport (BP) (5-Türer) Schrägheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2023,
    "Mo": "3 Sport (BP) (5-Türer) Schrägheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "3 Sport (BP) (5-Türer) Schrägheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "3 Sport (BP) (5-Türer) Schrägheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2026,
    "Mo": "3 Sport (BP) (5-Türer) Schrägheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2005,
    "Mo": "5 (5-Türer) MPV | 2005-2008",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2006,
    "Mo": "5 (5-Türer) MPV | 2005-2008",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2007,
    "Mo": "5 (5-Türer) MPV | 2005-2008",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2008,
    "Mo": "5 (5-Türer) MPV CR | 2005-2008",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2008,
    "Mo": "5 (5-Türer) MPV CR Facelift | 2008-2010",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2009,
    "Mo": "5 (5-Türer) MPV | 2008-2010",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2010,
    "Mo": "5 (5-Türer) MPV | 2008-2010",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2011,
    "Mo": "5 (5-Türer) MPV | 2011-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2012,
    "Mo": "5 (5-Türer) MPV | 2011-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2013,
    "Mo": "5 (5-Türer) MPV | 2011-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2014,
    "Mo": "5 (5-Türer) MPV | 2011-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2015,
    "Mo": "5 (5-Türer) MPV | 2011-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2016,
    "Mo": "5 (5-Türer) MPV | 2011-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2017,
    "Mo": "5 (5-Türer) MPV | 2011-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2018,
    "Mo": "5 (5-Türer) MPV | 2011-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2012,
    "Mo": "CX-5 (5-Türer) SUV | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2013,
    "Mo": "CX-5 (5-Türer) SUV | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2014,
    "Mo": "CX-5 (5-Türer) SUV | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2015,
    "Mo": "CX-5 (5-Türer) SUV KE | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2015,
    "Mo": "CX-5 (5-Türer) SUV KE Facelift | 2015-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2016,
    "Mo": "CX-5 (5-Türer) SUV | 2015-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2017,
    "Mo": "CX-5 (5-Türer) SUV KE Facelift | 2015-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2017,
    "Mo": "CX-5 (5-Türer) SUV KF | 2017-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2018,
    "Mo": "CX-5 (5-Türer) SUV | 2017-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2019,
    "Mo": "CX-5 (5-Türer) SUV | 2017-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2020,
    "Mo": "CX-5 (5-Türer) SUV | 2017-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2021,
    "Mo": "CX-5 (5-Türer) SUV KF | 2017-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2021,
    "Mo": "CX-5 (5-Türer) SUV KF Facelift | 2021-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "CX-5 (5-Türer) SUV KF Facelift | 2021-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "CX-5 (5-Türer) SUV KF 2nd Facelift | 2022-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2023,
    "Mo": "CX-5 (5-Türer) SUV | 2022-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "CX-5 (5-Türer) SUV | 2022-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "CX-5 (5-Türer) SUV | 2022-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "CX-60 (5-Türer) SUV 1st Generation Facelift | 2025-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2026,
    "Mo": "CX-60 (5-Türer) SUV | 2025-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "CX-60 (5-Türer) SUV | 2022-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2023,
    "Mo": "CX-60 (5-Türer) SUV | 2022-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "CX-60 (5-Türer) SUV | 2022-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "CX-60 (5-Türer) SUV 1st Generation | 2022-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2013,
    "Mo": "CX-9 (5-Türer) SUV | 2013-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2014,
    "Mo": "CX-9 (5-Türer) SUV | 2013-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2015,
    "Mo": "CX-9 (5-Türer) SUV | 2013-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2016,
    "Mo": "CX-9 (5-Türer) SUV 1st Generation 2nd Facelift | 2013-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2010,
    "Mo": "CX-9 (5-Türer) SUV | 2010-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2011,
    "Mo": "CX-9 (5-Türer) SUV | 2010-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2012,
    "Mo": "CX-9 (5-Türer) SUV | 2010-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2007,
    "Mo": "CX-9 (5-Türer) SUV | 2007-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2008,
    "Mo": "CX-9 (5-Türer) SUV | 2007-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2009,
    "Mo": "CX-9 (5-Türer) SUV | 2007-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2020,
    "Mo": "MX-30 (5-Türer) SUV | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2021,
    "Mo": "MX-30 (5-Türer) SUV | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "MX-30 (5-Türer) SUV | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2023,
    "Mo": "MX-30 (5-Türer) SUV | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "MX-30 (5-Türer) SUV | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "MX-30 (5-Türer) SUV | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2026,
    "Mo": "MX-30 (5-Türer) SUV | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Ceed (5-Türer) Schrägheck | 2019-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Ceed (5-Türer) Schrägheck | 2019-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Ceed (5-Türer) Schrägheck CD | 2019-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "Ceed (5-Türer) Schrägheck CD | 2019-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Ceed (5-Türer) Schrägheck CD Facelift | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "Ceed (5-Türer) Schrägheck CD Facelift | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "Ceed (5-Türer) Schrägheck | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "Ceed (5-Türer) Schrägheck | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Ceed (5-Türer) Schrägheck | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2026,
    "Mo": "Ceed (5-Türer) Schrägheck | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2016,
    "Mo": "Ceed (5-Türer) Schrägheck | 2016-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2017,
    "Mo": "Ceed (5-Türer) Schrägheck | 2016-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Ceed (5-Türer) Schrägheck | 2016-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2012,
    "Mo": "Ceed (5-Türer) Schrägheck | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2013,
    "Mo": "Ceed (5-Türer) Schrägheck | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2014,
    "Mo": "Ceed (5-Türer) Schrägheck | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2015,
    "Mo": "Ceed (5-Türer) Schrägheck | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "ProCeed (5-Türer) Kombi | 2019-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "ProCeed (5-Türer) Kombi | 2019-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "ProCeed (5-Türer) Kombi CD | 2019-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "ProCeed (5-Türer) Kombi CD | 2019-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "ProCeed (5-Türer) Kombi CD Facelift | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "ProCeed (5-Türer) Kombi CD Facelift | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "ProCeed (5-Türer) Kombi | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "ProCeed (5-Türer) Kombi | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "ProCeed (5-Türer) Kombi | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2026,
    "Mo": "ProCeed (5-Türer) Kombi | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "Niro (5-Türer) SUV | 2023-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "Niro (5-Türer) SUV | 2023-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Niro (5-Türer) SUV | 2023-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2026,
    "Mo": "Niro (5-Türer) SUV | 2023-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "PV5 Cargo (5-Türer) LCV | 2025-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2026,
    "Mo": "PV5 Cargo (5-Türer) LCV | 2025-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "PV5 Passenger (5-Türer) MPV | 2025-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2026,
    "Mo": "PV5 Passenger (5-Türer) MPV | 2025-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Seltos (5-Türer) Crossover | 2020-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Seltos (5-Türer) Crossover | 2020-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "Seltos (5-Türer) Crossover | 2020-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "Seltos (5-Türer) Crossover | 2020-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "Seltos (5-Türer) Crossover | 2020-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Seltos (5-Türer) Crossover | 2020-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Soul (5-Türer) Crossover SK3 | 2019-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Soul (5-Türer) Crossover | 2019-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Soul (5-Türer) Crossover | 2019-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "Soul (5-Türer) Crossover | 2019-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "Soul (5-Türer) Crossover SK3 | 2019-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "Soul (5-Türer) Crossover SK3 | 2019-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "Soul (5-Türer) Crossover SK3 Facelift | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "Soul (5-Türer) Crossover SK3 Facelift | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Soul (5-Türer) Crossover | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2026,
    "Mo": "Soul (5-Türer) Crossover | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "i20 (5-Türer) Schrägheck | 2015-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "i20 (5-Türer) Schrägheck | 2015-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "i20 (5-Türer) Schrägheck | 2015-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "i20 (5-Türer) Schrägheck GB | 2015-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "i20 (5-Türer) Schrägheck GB Facelift | 2018-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "i20 (5-Türer) Schrägheck | 2018-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "i20 (5-Türer) Schrägheck GB Facelift | 2018-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "i30 (5-Türer) Schrägheck GD Facelift | 2015-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "i30 (5-Türer) Schrägheck | 2015-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "i30 (5-Türer) Schrägheck GD Facelift | 2015-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2012,
    "Mo": "i30 (5-Türer) Schrägheck | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2013,
    "Mo": "i30 (5-Türer) Schrägheck | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2014,
    "Mo": "i30 (5-Türer) Schrägheck | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "i30 (5-Türer) Schrägheck GD | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "i30 (5-Türer) Schrägheck PD | 2017-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "i30 (5-Türer) Schrägheck | 2017-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "i30 (5-Türer) Schrägheck PD | 2017-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "i30 (5-Türer) Schrägheck PD 2nd Facelift | 2020-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "i30 (5-Türer) Schrägheck | 2020-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "i30 (5-Türer) Schrägheck | 2020-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "i30 (5-Türer) Schrägheck | 2020-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "i30 (5-Türer) Schrägheck PD 2nd Facelift | 2020-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "i30 (5-Türer) Schrägheck PD 3rd Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "i30 (5-Türer) Schrägheck | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2026,
    "Mo": "i30 (5-Türer) Schrägheck | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "i30 (5-Türer) Schrägheck PD 1st Facelift | 2019-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "i30 (5-Türer) Schrägheck PD 1st Facelift | 2019-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2021-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2021-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2021-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2026,
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2019-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2019-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "i30 Kombi (5-Türer) Kombi GD Facelift | 2015-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "i30 Kombi (5-Türer) Kombi | 2015-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "i30 Kombi (5-Türer) Kombi GD Facelift | 2015-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2012,
    "Mo": "i30 Kombi (5-Türer) Kombi GD | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2013,
    "Mo": "i30 Kombi (5-Türer) Kombi | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2014,
    "Mo": "i30 Kombi (5-Türer) Kombi | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "i30 Kombi (5-Türer) Kombi GD | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "i40cw (5-Türer) Kombi VF 2nd Facelift | 2018-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "i40cw (5-Türer) Kombi | 2018-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2012,
    "Mo": "i40cw (5-Türer) Kombi | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2013,
    "Mo": "i40cw (5-Türer) Kombi | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2014,
    "Mo": "i40cw (5-Türer) Kombi | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "i40cw (5-Türer) Kombi VF | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "i40cw (5-Türer) Kombi VF 1st Facelift | 2015-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "i40cw (5-Türer) Kombi | 2015-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "i40cw (5-Türer) Kombi | 2015-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "i40cw (5-Türer) Kombi VF 1st Facelift | 2015-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2020,
    "Mo": "Across (A5Z) (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2021,
    "Mo": "Across (A5Z) (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2022,
    "Mo": "Across (A5Z) (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2023,
    "Mo": "Across (A5Z) (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2024,
    "Mo": "Across (A5Z) (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2025,
    "Mo": "Across (A5Z) (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2026,
    "Mo": "Across (A5Z) (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2013,
    "Mo": "ASX (5-Türer) SUV GA 1st Facelift | 2013-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2014,
    "Mo": "ASX (5-Türer) SUV | 2013-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2015,
    "Mo": "ASX (5-Türer) SUV | 2013-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2016,
    "Mo": "ASX (5-Türer) SUV | 2013-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2010,
    "Mo": "ASX (5-Türer) SUV | 2010-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2011,
    "Mo": "ASX (5-Türer) SUV | 2010-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2012,
    "Mo": "ASX (5-Türer) SUV | 2010-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2013,
    "Mo": "ASX (5-Türer) SUV GA | 2010-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2017,
    "Mo": "ASX (GAW) (5-Türer) SUV | 2017-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2018,
    "Mo": "ASX (GAW) (5-Türer) SUV | 2017-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2019,
    "Mo": "ASX (GAW) (5-Türer) SUV | 2017-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2020,
    "Mo": "ASX (GAW) (5-Türer) SUV | 2017-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2020,
    "Mo": "ASX (5-Türer) SUV | 2020-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2021,
    "Mo": "ASX (5-Türer) SUV | 2020-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2022,
    "Mo": "ASX (5-Türer) SUV | 2020-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2015,
    "Mo": "L200 Double Cab (4-Türer) Pickup 5th Generation | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2016,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2017,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2018,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2019,
    "Mo": "L200 Double Cab (4-Türer) Pickup 5th Generation | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2019,
    "Mo": "L200 Double Cab (4-Türer) Pickup 5th Generation Facelift | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2020,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2021,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2022,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2023,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2002,
    "Mo": "CR-V (5-Türer) SUV | 2002-2006",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2003,
    "Mo": "CR-V (5-Türer) SUV | 2002-2006",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2004,
    "Mo": "CR-V (5-Türer) SUV | 2002-2006",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2005,
    "Mo": "CR-V (5-Türer) SUV | 2002-2006",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2006,
    "Mo": "CR-V (5-Türer) SUV | 2002-2006",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2007,
    "Mo": "CR-V (5-Türer) SUV | 2007-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2008,
    "Mo": "CR-V (5-Türer) SUV | 2007-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2009,
    "Mo": "CR-V (5-Türer) SUV | 2007-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2010,
    "Mo": "CR-V (5-Türer) SUV | 2010-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2011,
    "Mo": "CR-V (5-Türer) SUV | 2010-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2012,
    "Mo": "CR-V (5-Türer) SUV RE Facelift | 2010-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Doblò Combi (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Doblò Combi (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Doblò Combi (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Doblò Combi (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Doblò Combi (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Doblò Combi (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Doblò Combi (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Doblò Combi (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Doblò Combi (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Doblò Combi (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Doblò Combi (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Doblò Combi (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Doblò Combi (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Doblò Combi (4-Türer) LCV Typ K9 Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Doblò Combi (4-Türer) LCV Typ K9 Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2026,
    "Mo": "Doblò Combi (4-Türer) LCV Typ K9 Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "Doblò Combi (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Doblò Combi (4-Türer) LCV Typ K9 | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Doblò Combi (4-Türer) LCV Typ K9 | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2026,
    "Mo": "Doblò Combi (4-Türer) LCV Typ K9 | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Doblò Combi Maxi (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Doblò Combi Maxi (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Doblò Combi Maxi (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Doblò Combi Maxi (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Doblò Combi Maxi (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Doblò Combi Maxi (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Doblò Combi Maxi (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Doblò Combi Maxi (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Doblò Multicab (4-Türer) LCV Typ K9 Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Doblò Multicab (4-Türer) LCV Typ K9 Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2026,
    "Mo": "Doblò Multicab (4-Türer) LCV Typ K9 Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Doblò Multicab (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "Doblò Multicab (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Doblò Multicab (4-Türer) LCV Typ K9 | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Doblò Multicab (4-Türer) LCV Typ K9 | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2026,
    "Mo": "Doblò Multicab (4-Türer) LCV Typ K9 | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV Typ 263 Facelift | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV Typ K9 Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV Typ K9 Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2026,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV Typ K9 Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV Typ K9 | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV Typ K9 | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV Typ K9 | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2026,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV Typ K9 | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV Typ K9 Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV Typ K9 Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2026,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV Typ K9 Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV Typ K9 | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV Typ K9 | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2026,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV Typ K9 | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Doblò Van Maxi (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Doblò Van Maxi (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Doblò Van Maxi (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Doblò Van Maxi (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Doblò Van Maxi (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Doblò Van Maxi (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Doblò Van Maxi (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Doblò Van Maxi (4-Türer) LCV | 2015-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Doblò Van Maxi (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Doblò Van Maxi (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Doblò Van Maxi (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Doblò Van Maxi (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Doblò Van Maxi (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2008,
    "Mo": "Fiorino (3-Türer) LCV | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2009,
    "Mo": "Fiorino (3-Türer) LCV | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Fiorino (3-Türer) LCV | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Fiorino (3-Türer) LCV | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Fiorino (3-Türer) LCV | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Fiorino (3-Türer) LCV | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Fiorino (3-Türer) LCV | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Fiorino (3-Türer) LCV | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Fiorino (3-Türer) LCV | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Fiorino (3-Türer) LCV | 2017-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Fiorino (3-Türer) LCV | 2017-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Fiorino (3-Türer) LCV | 2017-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Fiorino (3-Türer) LCV | 2017-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Fiorino (3-Türer) LCV | 2017-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Fiorino (3-Türer) LCV | 2017-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "Fiorino (3-Türer) LCV | 2017-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Fiorino (3-Türer) LCV | 2017-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2008,
    "Mo": "Qubo (5-Türer) LCV | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2009,
    "Mo": "Qubo (5-Türer) LCV | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Qubo (5-Türer) LCV | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Qubo (5-Türer) LCV | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Qubo (5-Türer) LCV | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Qubo (5-Türer) LCV | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Qubo (5-Türer) LCV | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Qubo (5-Türer) LCV | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Qubo (5-Türer) LCV | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Fullback Double Cab (4-Türer) Pickup | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Fullback Double Cab (4-Türer) Pickup | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Fullback Double Cab (4-Türer) Pickup | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Fullback Double Cab (4-Türer) Pickup | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Fullback Double Cab (4-Türer) Pickup | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Fullback Double Cab (4-Türer) Pickup | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Fullback Double Cab (4-Türer) Pickup | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Fullback Double Cab (4-Türer) Pickup | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "Fullback Double Cab (4-Türer) Pickup | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Fullback Double Cab (4-Türer) Pickup | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Fullback Double Cab (4-Türer) Pickup | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2026,
    "Mo": "Fullback Double Cab (4-Türer) Pickup | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Fullback Extended Cab (4-Türer) Pickup | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Fullback Extended Cab (4-Türer) Pickup | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Fullback Extended Cab (4-Türer) Pickup | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Fullback Extended Cab (4-Türer) Pickup | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Fullback Extended Cab (4-Türer) Pickup | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Fullback Extended Cab (4-Türer) Pickup | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Fullback Extended Cab (4-Türer) Pickup | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Fullback Extended Cab (4-Türer) Pickup | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "Fullback Extended Cab (4-Türer) Pickup | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Fullback Extended Cab (4-Türer) Pickup | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Fullback Extended Cab (4-Türer) Pickup | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2026,
    "Mo": "Fullback Extended Cab (4-Türer) Pickup | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Scudo Combi (4-Türer) LCV | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Scudo Combi (4-Türer) LCV | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Scudo Combi (4-Türer) LCV | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Scudo Combi (4-Türer) LCV | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Scudo Combi (4-Türer) LCV | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2006,
    "Mo": "Scudo Combi (4-Türer) LCV | 2006-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2007,
    "Mo": "Scudo Combi (4-Türer) LCV | 2006-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2008,
    "Mo": "Scudo Combi (4-Türer) LCV | 2006-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2009,
    "Mo": "Scudo Combi (4-Türer) LCV | 2006-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Scudo Combi (4-Türer) LCV | 2006-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Scudo Combi (4-Türer) LCV | 2006-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Scudo Combi (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "Scudo Combi (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Scudo Combi (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Scudo Combi (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2026,
    "Mo": "Scudo Combi (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Scudo Multicab (4-Türer) LCV | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Scudo Multicab (4-Türer) LCV | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Scudo Multicab (4-Türer) LCV | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Scudo Multicab (4-Türer) LCV | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Scudo Multicab (4-Türer) LCV | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Scudo Multicab (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "Scudo Multicab (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Scudo Multicab (4-Türer) LCV 3rd Generation | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Scudo Multicab (4-Türer) LCV 3rd Generation | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2026,
    "Mo": "Scudo Multicab (4-Türer) LCV 3rd Generation | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Scudo Multicab (4-Türer) LCV 3rd Generation Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Scudo Multicab (4-Türer) LCV 3rd Generation Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2026,
    "Mo": "Scudo Multicab (4-Türer) LCV 3rd Generation Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Scudo Multicab IP (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "Scudo Multicab IP (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Scudo Multicab IP (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Scudo Multicab IP (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2026,
    "Mo": "Scudo Multicab IP (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Scudo Multicab Maxi (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "Scudo Multicab Maxi (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Scudo Multicab Maxi (4-Türer) LCV 3rd Generation | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Scudo Multicab Maxi (4-Türer) LCV 3rd Generation | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2026,
    "Mo": "Scudo Multicab Maxi (4-Türer) LCV 3rd Generation | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Scudo Multicab Maxi (4-Türer) LCV 3rd Generation Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Scudo Multicab Maxi (4-Türer) LCV 3rd Generation Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2026,
    "Mo": "Scudo Multicab Maxi (4-Türer) LCV 3rd Generation Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Scudo Panel Van (4-Türer) LCV | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Scudo Panel Van (4-Türer) LCV | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Scudo Panel Van (4-Türer) LCV | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Scudo Panel Van (4-Türer) LCV | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Scudo Panel Van (4-Türer) LCV | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2006,
    "Mo": "Scudo Panel Van (4-Türer) LCV | 2006-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2007,
    "Mo": "Scudo Panel Van (4-Türer) LCV | 2006-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2008,
    "Mo": "Scudo Panel Van (4-Türer) LCV | 2006-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2009,
    "Mo": "Scudo Panel Van (4-Türer) LCV | 2006-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Scudo Panel Van (4-Türer) LCV | 2006-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Scudo Panel Van (4-Türer) LCV | 2006-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Scudo Panel Van (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "Scudo Panel Van (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Scudo Panel Van (4-Türer) LCV 3rd Generation | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Scudo Panel Van (4-Türer) LCV 3rd Generation | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2026,
    "Mo": "Scudo Panel Van (4-Türer) LCV 3rd Generation | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Scudo Panel Van (4-Türer) LCV 3rd Generation Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Scudo Panel Van (4-Türer) LCV 3rd Generation Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2026,
    "Mo": "Scudo Panel Van (4-Türer) LCV 3rd Generation Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Scudo Panel Van IP (4-Türer) LCV | 2012-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Scudo Panel Van IP (4-Türer) LCV | 2012-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Scudo Panel Van IP (4-Türer) LCV | 2012-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Scudo Panel Van IP (4-Türer) LCV | 2012-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Scudo Panel Van IP (4-Türer) LCV | 2012-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Scudo Panel Van IP (4-Türer) LCV | 2012-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2006,
    "Mo": "Scudo Panel Van IP (4-Türer) LCV | 2006-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2007,
    "Mo": "Scudo Panel Van IP (4-Türer) LCV | 2006-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2008,
    "Mo": "Scudo Panel Van IP (4-Türer) LCV | 2006-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2009,
    "Mo": "Scudo Panel Van IP (4-Türer) LCV | 2006-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Scudo Panel Van IP (4-Türer) LCV | 2006-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Scudo Panel Van IP (4-Türer) LCV | 2006-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Scudo Panel Van IP (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "Scudo Panel Van IP (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Scudo Panel Van IP (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Scudo Panel Van IP (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2026,
    "Mo": "Scudo Panel Van IP (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Scudo Panel Van Maxi (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "Scudo Panel Van Maxi (4-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Scudo Panel Van Maxi (4-Türer) LCV 3rd Generation | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Scudo Panel Van Maxi (4-Türer) LCV 3rd Generation | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2026,
    "Mo": "Scudo Panel Van Maxi (4-Türer) LCV 3rd Generation | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Scudo Panel Van Maxi (4-Türer) LCV 3rd Generation Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Scudo Panel Van Maxi (4-Türer) LCV 3rd Generation Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2026,
    "Mo": "Scudo Panel Van Maxi (4-Türer) LCV 3rd Generation Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Ulysse (5-Türer) MPV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "Ulysse (5-Türer) MPV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Ulysse (5-Türer) MPV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Ulysse (5-Türer) MPV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2026,
    "Mo": "Ulysse (5-Türer) MPV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Tesla",
    "Y": 2016,
    "Mo": "Model S (5-Türer) Schrägheck | 2016-2021",
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "Tesla",
    "Y": 2017,
    "Mo": "Model S (5-Türer) Schrägheck | 2016-2021",
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "Tesla",
    "Y": 2018,
    "Mo": "Model S (5-Türer) Schrägheck | 2016-2021",
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "Tesla",
    "Y": 2019,
    "Mo": "Model S (5-Türer) Schrägheck | 2016-2021",
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "Tesla",
    "Y": 2020,
    "Mo": "Model S (5-Türer) Schrägheck | 2016-2021",
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "Tesla",
    "Y": 2021,
    "Mo": "Model S (5-Türer) Schrägheck | 2016-2021",
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2024,
    "Mo": "Crosstrek (5-Türer) Crossover | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2025,
    "Mo": "Crosstrek (5-Türer) Crossover | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2026,
    "Mo": "Crosstrek (5-Türer) Crossover | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2011,
    "Mo": "Forester (5-Türer) SUV | 2011-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2012,
    "Mo": "Forester (5-Türer) SUV | 2011-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2013,
    "Mo": "Forester (5-Türer) SUV SH Facelift | 2011-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2008,
    "Mo": "Forester (5-Türer) SUV SH | 2008-2010",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2009,
    "Mo": "Forester (5-Türer) SUV | 2008-2010",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2010,
    "Mo": "Forester (5-Türer) SUV | 2008-2010",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2016,
    "Mo": "Forester (5-Türer) SUV SJ Facelift | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2017,
    "Mo": "Forester (5-Türer) SUV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2018,
    "Mo": "Forester (5-Türer) SUV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2019,
    "Mo": "Forester (5-Türer) SUV SJ Facelift | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2013,
    "Mo": "Forester (5-Türer) SUV SJ | 2013-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2014,
    "Mo": "Forester (5-Türer) SUV | 2013-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2015,
    "Mo": "Forester (5-Türer) SUV | 2013-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2016,
    "Mo": "Forester (5-Türer) SUV SJ | 2013-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2019,
    "Mo": "Forester (5-Türer) SUV SK | 2019-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2020,
    "Mo": "Forester (5-Türer) SUV | 2019-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2021,
    "Mo": "Forester (5-Türer) SUV | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2022,
    "Mo": "Forester (5-Türer) SUV | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2023,
    "Mo": "Forester (5-Türer) SUV | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2024,
    "Mo": "Forester (5-Türer) SUV | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2025,
    "Mo": "Forester (5-Türer) SUV SK Facelift | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2024,
    "Mo": "Impreza (5-Türer) Schrägheck | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2025,
    "Mo": "Impreza (5-Türer) Schrägheck | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2026,
    "Mo": "Impreza (5-Türer) Schrägheck | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2012,
    "Mo": "Impreza (5-Türer) Schrägheck | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2013,
    "Mo": "Impreza (5-Türer) Schrägheck | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2014,
    "Mo": "Impreza (5-Türer) Schrägheck | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2015,
    "Mo": "Impreza (5-Türer) Schrägheck | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2016,
    "Mo": "Impreza (5-Türer) Schrägheck | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2016,
    "Mo": "Impreza (GT) (5-Türer) Schrägheck | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2017,
    "Mo": "Impreza (GT) (5-Türer) Schrägheck | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2018,
    "Mo": "Impreza (GT) (5-Türer) Schrägheck | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2019,
    "Mo": "Impreza (GT) (5-Türer) Schrägheck | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2020,
    "Mo": "Impreza (GT) (5-Türer) Schrägheck | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2021,
    "Mo": "Impreza (GT) (5-Türer) Schrägheck | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2022,
    "Mo": "Impreza (GT) (5-Türer) Schrägheck | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2023,
    "Mo": "Impreza (GT) (5-Türer) Schrägheck | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2008,
    "Mo": "Legacy Wagon (5-Türer) Kombi BL/BP Facelift | 2008-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2009,
    "Mo": "Legacy Wagon (5-Türer) Kombi | 2008-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2004,
    "Mo": "Legacy Wagon (5-Türer) Kombi | 2004-2008",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2005,
    "Mo": "Legacy Wagon (5-Türer) Kombi | 2004-2008",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2006,
    "Mo": "Legacy Wagon (5-Türer) Kombi | 2004-2008",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2007,
    "Mo": "Legacy Wagon (5-Türer) Kombi | 2004-2008",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2008,
    "Mo": "Legacy Wagon (5-Türer) Kombi BL/BP | 2004-2008",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2010,
    "Mo": "Legacy Wagon (5-Türer) Kombi | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2011,
    "Mo": "Legacy Wagon (5-Türer) Kombi | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2012,
    "Mo": "Legacy Wagon (5-Türer) Kombi | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2013,
    "Mo": "Legacy Wagon (5-Türer) Kombi | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2014,
    "Mo": "Legacy Wagon (5-Türer) Kombi | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2015,
    "Mo": "Levorg (5-Türer) Kombi | 2015-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2016,
    "Mo": "Levorg (5-Türer) Kombi | 2015-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2017,
    "Mo": "Levorg (5-Türer) Kombi | 2015-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2018,
    "Mo": "Levorg (5-Türer) Kombi | 2018-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2019,
    "Mo": "Levorg (5-Türer) Kombi | 2018-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2020,
    "Mo": "Levorg (5-Türer) Kombi | 2018-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2026,
    "Mo": "Solterra (5-Türer) SUV | 2026-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2023,
    "Mo": "Solterra (5-Türer) SUV | 2023-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2024,
    "Mo": "Solterra (5-Türer) SUV | 2023-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2025,
    "Mo": "Solterra (5-Türer) SUV | 2023-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2014,
    "Mo": "WRX (4-Türer) Stufenheck | 2014-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2015,
    "Mo": "WRX (4-Türer) Stufenheck | 2014-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2016,
    "Mo": "WRX (4-Türer) Stufenheck | 2014-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2017,
    "Mo": "WRX (4-Türer) Stufenheck | 2014-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2018,
    "Mo": "WRX (4-Türer) Stufenheck | 2014-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2019,
    "Mo": "WRX (4-Türer) Stufenheck | 2014-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2020,
    "Mo": "WRX (4-Türer) Stufenheck | 2014-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2021,
    "Mo": "WRX (4-Türer) Stufenheck | 2014-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2022,
    "Mo": "WRX (4-Türer) Stufenheck | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2023,
    "Mo": "WRX (4-Türer) Stufenheck | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2024,
    "Mo": "WRX (4-Türer) Stufenheck | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2025,
    "Mo": "WRX (4-Türer) Stufenheck | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2026,
    "Mo": "WRX (4-Türer) Stufenheck | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2012,
    "Mo": "XV (5-Türer) Kombi | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2013,
    "Mo": "XV (5-Türer) Kombi | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2014,
    "Mo": "XV (5-Türer) Kombi | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2015,
    "Mo": "XV (5-Türer) Kombi | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2018,
    "Mo": "XV (5-Türer) Kombi | 2018-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2019,
    "Mo": "XV (5-Türer) Kombi | 2018-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2020,
    "Mo": "XV (5-Türer) Kombi | 2018-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2021,
    "Mo": "XV (5-Türer) Kombi | 2021-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2022,
    "Mo": "XV (5-Türer) Kombi | 2021-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2023,
    "Mo": "XV (5-Türer) Kombi | 2021-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2024,
    "Mo": "XV (5-Türer) Kombi | 2021-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2008,
    "Mo": "Cayenne (9PA) (5-Türer) SUV | 2008-2010",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2009,
    "Mo": "Cayenne (9PA) (5-Türer) SUV | 2008-2010",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2010,
    "Mo": "Cayenne (9PA) (5-Türer) SUV | 2008-2010",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2003,
    "Mo": "Cayenne (9PA) (5-Türer) SUV | 2003-2007",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2004,
    "Mo": "Cayenne (9PA) (5-Türer) SUV | 2003-2007",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2005,
    "Mo": "Cayenne (9PA) (5-Türer) SUV | 2003-2007",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2006,
    "Mo": "Cayenne (9PA) (5-Türer) SUV | 2003-2007",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2007,
    "Mo": "Cayenne (9PA) (5-Türer) SUV | 2003-2007",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2025,
    "Mo": "Taycan (Y1A) (4-Türer) Coupe | 2025-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2026,
    "Mo": "Taycan (Y1A) (4-Türer) Coupe | 2025-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2020,
    "Mo": "Taycan (Y1A) (4-Türer) Coupe | 2020-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2021,
    "Mo": "Taycan (Y1A) (4-Türer) Coupe | 2020-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2022,
    "Mo": "Taycan (Y1A) (4-Türer) Coupe | 2020-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2023,
    "Mo": "Taycan (Y1A) (4-Türer) Coupe | 2020-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2024,
    "Mo": "Taycan (Y1A) (4-Türer) Coupe | 2020-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2020,
    "Mo": "Defender 110 Station Wagon (5-Türer) SUV | 2020-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2021,
    "Mo": "Defender 110 Station Wagon (5-Türer) SUV | 2020-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2022,
    "Mo": "Defender 110 Station Wagon (5-Türer) SUV | 2020-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2023,
    "Mo": "Defender 110 Station Wagon (5-Türer) SUV | 2020-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2024,
    "Mo": "Defender 110 Station Wagon (5-Türer) SUV | 2020-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2025,
    "Mo": "Defender 110 Station Wagon (5-Türer) SUV | 2020-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2026,
    "Mo": "Defender 110 Station Wagon (5-Türer) SUV | 2020-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2023,
    "Mo": "Defender 130 Station Wagon (5-Türer) SUV | 2023-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2024,
    "Mo": "Defender 130 Station Wagon (5-Türer) SUV | 2023-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2025,
    "Mo": "Defender 130 Station Wagon (5-Türer) SUV | 2023-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2026,
    "Mo": "Defender 130 Station Wagon (5-Türer) SUV | 2023-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2020,
    "Mo": "Defender 90 Station Wagon (3-Türer) SUV | 2020-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2021,
    "Mo": "Defender 90 Station Wagon (3-Türer) SUV | 2020-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2022,
    "Mo": "Defender 90 Station Wagon (3-Türer) SUV | 2020-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2023,
    "Mo": "Defender 90 Station Wagon (3-Türer) SUV | 2020-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2024,
    "Mo": "Defender 90 Station Wagon (3-Türer) SUV | 2020-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2025,
    "Mo": "Defender 90 Station Wagon (3-Türer) SUV | 2020-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2026,
    "Mo": "Defender 90 Station Wagon (3-Türer) SUV | 2020-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2005,
    "Mo": "Discovery (5-Türer) SUV L319 (Type LA) | 2005-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2006,
    "Mo": "Discovery (5-Türer) SUV | 2005-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2007,
    "Mo": "Discovery (5-Türer) SUV | 2005-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2008,
    "Mo": "Discovery (5-Türer) SUV | 2005-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2009,
    "Mo": "Discovery (5-Türer) SUV | 2005-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2010,
    "Mo": "Discovery (5-Türer) SUV | 2010-2013",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2011,
    "Mo": "Discovery (5-Türer) SUV | 2010-2013",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2012,
    "Mo": "Discovery (5-Türer) SUV | 2010-2013",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2013,
    "Mo": "Discovery (5-Türer) SUV | 2010-2013",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2014,
    "Mo": "Discovery (5-Türer) SUV | 2014-2016",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2015,
    "Mo": "Discovery (5-Türer) SUV | 2014-2016",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2016,
    "Mo": "Discovery (5-Türer) SUV | 2014-2016",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2016,
    "Mo": "TGE Minibus (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2017,
    "Mo": "TGE Minibus (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2018,
    "Mo": "TGE Minibus (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2019,
    "Mo": "TGE Minibus (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2020,
    "Mo": "TGE Minibus (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2021,
    "Mo": "TGE Minibus (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2022,
    "Mo": "TGE Minibus (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2023,
    "Mo": "TGE Minibus (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2024,
    "Mo": "TGE Minibus (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2025,
    "Mo": "TGE Minibus (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2026,
    "Mo": "TGE Minibus (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2016,
    "Mo": "TGE Panel Van 3.0t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2017,
    "Mo": "TGE Panel Van 3.0t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2018,
    "Mo": "TGE Panel Van 3.0t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2019,
    "Mo": "TGE Panel Van 3.0t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2020,
    "Mo": "TGE Panel Van 3.0t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2021,
    "Mo": "TGE Panel Van 3.0t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2022,
    "Mo": "TGE Panel Van 3.0t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2023,
    "Mo": "TGE Panel Van 3.0t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2024,
    "Mo": "TGE Panel Van 3.0t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2025,
    "Mo": "TGE Panel Van 3.0t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2026,
    "Mo": "TGE Panel Van 3.0t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2016,
    "Mo": "TGE Panel Van 3.5t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2017,
    "Mo": "TGE Panel Van 3.5t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2018,
    "Mo": "TGE Panel Van 3.5t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2019,
    "Mo": "TGE Panel Van 3.5t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2020,
    "Mo": "TGE Panel Van 3.5t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2021,
    "Mo": "TGE Panel Van 3.5t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2022,
    "Mo": "TGE Panel Van 3.5t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2023,
    "Mo": "TGE Panel Van 3.5t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2024,
    "Mo": "TGE Panel Van 3.5t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2025,
    "Mo": "TGE Panel Van 3.5t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2026,
    "Mo": "TGE Panel Van 3.5t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2016,
    "Mo": "TGE Panel Van 3.88t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2017,
    "Mo": "TGE Panel Van 3.88t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2018,
    "Mo": "TGE Panel Van 3.88t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2019,
    "Mo": "TGE Panel Van 3.88t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2020,
    "Mo": "TGE Panel Van 3.88t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2021,
    "Mo": "TGE Panel Van 3.88t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2022,
    "Mo": "TGE Panel Van 3.88t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2023,
    "Mo": "TGE Panel Van 3.88t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2024,
    "Mo": "TGE Panel Van 3.88t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2025,
    "Mo": "TGE Panel Van 3.88t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2026,
    "Mo": "TGE Panel Van 3.88t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2016,
    "Mo": "TGE Panel Van 4.0t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2017,
    "Mo": "TGE Panel Van 4.0t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2018,
    "Mo": "TGE Panel Van 4.0t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2019,
    "Mo": "TGE Panel Van 4.0t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2020,
    "Mo": "TGE Panel Van 4.0t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2021,
    "Mo": "TGE Panel Van 4.0t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2022,
    "Mo": "TGE Panel Van 4.0t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2023,
    "Mo": "TGE Panel Van 4.0t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2024,
    "Mo": "TGE Panel Van 4.0t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2025,
    "Mo": "TGE Panel Van 4.0t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2026,
    "Mo": "TGE Panel Van 4.0t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2016,
    "Mo": "TGE Panel Van 5.0t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2017,
    "Mo": "TGE Panel Van 5.0t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2018,
    "Mo": "TGE Panel Van 5.0t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2019,
    "Mo": "TGE Panel Van 5.0t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2020,
    "Mo": "TGE Panel Van 5.0t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2021,
    "Mo": "TGE Panel Van 5.0t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2022,
    "Mo": "TGE Panel Van 5.0t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2023,
    "Mo": "TGE Panel Van 5.0t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2024,
    "Mo": "TGE Panel Van 5.0t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2025,
    "Mo": "TGE Panel Van 5.0t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2026,
    "Mo": "TGE Panel Van 5.0t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2016,
    "Mo": "TGE Panel Van 5.5t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2017,
    "Mo": "TGE Panel Van 5.5t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2018,
    "Mo": "TGE Panel Van 5.5t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2019,
    "Mo": "TGE Panel Van 5.5t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2020,
    "Mo": "TGE Panel Van 5.5t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2021,
    "Mo": "TGE Panel Van 5.5t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2022,
    "Mo": "TGE Panel Van 5.5t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2023,
    "Mo": "TGE Panel Van 5.5t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2024,
    "Mo": "TGE Panel Van 5.5t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2025,
    "Mo": "TGE Panel Van 5.5t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2026,
    "Mo": "TGE Panel Van 5.5t (4-Türer) LCV | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2021,
    "Mo": "NX (5-Türer) SUV AZ20 | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2022,
    "Mo": "NX (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2023,
    "Mo": "NX (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2024,
    "Mo": "NX (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2025,
    "Mo": "NX (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2026,
    "Mo": "NX (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2023,
    "Mo": "RX (5-Türer) SUV AL30 | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2024,
    "Mo": "RX (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2025,
    "Mo": "RX (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2026,
    "Mo": "RX (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2022,
    "Mo": "RZ (5-Türer) SUV | 2022-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2023,
    "Mo": "RZ (5-Türer) SUV | 2022-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2024,
    "Mo": "RZ (5-Türer) SUV | 2022-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2025,
    "Mo": "RZ (5-Türer) SUV 1st Generation | 2022-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2025,
    "Mo": "RZ (5-Türer) SUV 1st Generation Facelift | 2025-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2026,
    "Mo": "RZ (5-Türer) SUV | 2025-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2011,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2012,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2013,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2017,
    "Mo": "Grand Cherokee (5-Türer) SUV WK2 2nd Facelift | 2017-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2018,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2017-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2019,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2017-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2020,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2017-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2021,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2017-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2014,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2014-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2015,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2014-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2016,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2014-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2017,
    "Mo": "Grand Cherokee (5-Türer) SUV WK2 1st Facelift | 2014-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2011,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2012,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2013,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2017,
    "Mo": "Grand Cherokee (5-Türer) SUV WK2 2nd Facelift | 2017-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2018,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2017-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2019,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2017-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2020,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2017-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2021,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2017-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2014,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2014-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2015,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2014-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2016,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2014-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2017,
    "Mo": "Grand Cherokee (5-Türer) SUV WK2 1st Facelift | 2014-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2004,
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2005,
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2006,
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2007,
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2008,
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2009,
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2010,
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2011,
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2012,
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2004,
    "Mo": "Astra (5-Türer) Schrägheck | 2004-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2005,
    "Mo": "Astra (5-Türer) Schrägheck | 2004-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2006,
    "Mo": "Astra (5-Türer) Schrägheck | 2004-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2007,
    "Mo": "Astra (5-Türer) Schrägheck | 2004-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2008,
    "Mo": "Astra (5-Türer) Schrägheck | 2004-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2009,
    "Mo": "Astra (5-Türer) Schrägheck | 2004-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2010,
    "Mo": "Astra (5-Türer) Schrägheck | 2004-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2011,
    "Mo": "Astra (5-Türer) Schrägheck | 2004-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2012,
    "Mo": "Astra (5-Türer) Schrägheck | 2004-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "KGM",
    "Y": 2025,
    "Mo": "Musso EV (4-Türer) Pickup | 2025-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "KGM",
    "Y": 2026,
    "Mo": "Musso EV (4-Türer) Pickup | 2025-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "KGM",
    "Y": 2023,
    "Mo": "Torres (5-Türer) SUV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "KGM",
    "Y": 2024,
    "Mo": "Torres (5-Türer) SUV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "KGM",
    "Y": 2025,
    "Mo": "Torres (5-Türer) SUV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "KGM",
    "Y": 2026,
    "Mo": "Torres (5-Türer) SUV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2016,
    "Mo": "Q30 (5-Türer) Schrägheck | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2017,
    "Mo": "Q30 (5-Türer) Schrägheck | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2018,
    "Mo": "Q30 (5-Türer) Schrägheck | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2019,
    "Mo": "Q30 (5-Türer) Schrägheck | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Caravelle (3-Türer) MPV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Caravelle (3-Türer) MPV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Caravelle (3-Türer) MPV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Caravelle (3-Türer) MPV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Caravelle (3-Türer) MPV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Caravelle (3-Türer) MPV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Caravelle (3-Türer) MPV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Caravelle (3-Türer) MPV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Caravelle (3-Türer) MPV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Caravelle (3-Türer) MPV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Caravelle (3-Türer) MPV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Caravelle (3-Türer) MPV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Caravelle (3-Türer) MPV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Caravelle (3-Türer) MPV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Caravelle (3-Türer) MPV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Caravelle (3-Türer) MPV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Caravelle (3-Türer) MPV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Caravelle (3-Türer) MPV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Caravelle (3-Türer) MPV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2007,
    "Mo": "Jumpy (4-Türer) LCV | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2008,
    "Mo": "Jumpy (4-Türer) LCV | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2009,
    "Mo": "Jumpy (4-Türer) LCV | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "Jumpy (4-Türer) LCV | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2011,
    "Mo": "Jumpy (4-Türer) LCV | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "Jumpy (4-Türer) LCV | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "Jumpy (4-Türer) LCV | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "Jumpy (4-Türer) LCV | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2015,
    "Mo": "Jumpy (4-Türer) LCV | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "Jumpy (4-Türer) LCV 2nd Generation Facelift | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "Jumpy (4-Türer) LCV 3rd Generation | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2017,
    "Mo": "Jumpy (4-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2018,
    "Mo": "Jumpy (4-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2019,
    "Mo": "Jumpy (4-Türer) LCV 3rd Generation | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2019,
    "Mo": "Jumpy (4-Türer) LCV 3rd Generation 1st Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2020,
    "Mo": "Jumpy (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2021,
    "Mo": "Jumpy (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2022,
    "Mo": "Jumpy (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2023,
    "Mo": "Jumpy (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "Jumpy (4-Türer) LCV 3rd Generation 1st Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "Jumpy (4-Türer) LCV 3rd Generation 2nd Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2025,
    "Mo": "Jumpy (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2026,
    "Mo": "Jumpy (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit 290 (3-Türer) LCV 4th Generation Facelift (V363) | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit 290 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit 290 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit 290 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit 290 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit 290 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit 290 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit 290 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit 290 (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit 290 (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit 290 (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit 290 (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit 290 (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit 290 (3-Türer) LCV 4th Generation (V363) | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit 310 (3-Türer) LCV 4th Generation Facelift (V363) | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit 310 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit 310 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit 310 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit 310 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit 310 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit 310 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit 310 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit 310 (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit 310 (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit 310 (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit 310 (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit 310 (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit 310 (3-Türer) LCV 4th Generation (V363) | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit 330 Combi (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit 330 Combi (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit 330 Combi (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit 330 Combi (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit 330 Combi (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit 330 Combi (4-Türer) LCV 4th Generation (V363) | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit 350 (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit 350 (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit 350 (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit 350 (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit 350 (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit 350 (3-Türer) LCV 4th Generation (V363) | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit 350 (3-Türer) LCV 4th Generation Facelift (V363) | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit 350 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit 350 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit 350 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit 350 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit 350 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit 350 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit 350 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit 330 Combi (4-Türer) LCV 4th Generation Facelift (V363) | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit 330 Combi (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit 330 Combi (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit 330 Combi (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit 330 Combi (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit 330 Combi (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit 330 Combi (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit 330 Combi (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit 350 Combi (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit 350 Combi (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit 350 Combi (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit 350 Combi (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit 350 Combi (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit 350 Combi (4-Türer) LCV 4th Generation (V363) | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit 350 Crew Van (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit 350 Crew Van (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit 350 Crew Van (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit 350 Crew Van (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit 350 Crew Van (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit 350 Crew Van (4-Türer) LCV 4th Generation (V363) | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit 350 Crew Van (4-Türer) LCV 4th Generation Facelift (V363) | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit 350 Crew Van (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit 350 Crew Van (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit 350 Crew Van (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit 350 Crew Van (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit 350 Crew Van (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit 350 Crew Van (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit 350 Crew Van (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit 350 Combi (4-Türer) LCV 4th Generation Facelift (V363) | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit 350 Combi (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit 350 Combi (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit 350 Combi (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit 350 Combi (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit 350 Combi (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit 350 Combi (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit 350 Combi (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit 410 Minibus (4-Türer) LCV 4th Generation Facelift (V363) | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit 410 Minibus (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit 410 Minibus (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit 410 Minibus (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit 410 Minibus (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit 410 Minibus (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit 410 Minibus (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit 410 Minibus (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit 410 Minibus (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit 410 Minibus (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit 410 Minibus (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit 410 Minibus (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit 410 Minibus (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit 410 Minibus (4-Türer) LCV 4th Generation (V363) | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit 350 Minibus (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit 350 Minibus (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit 350 Minibus (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit 350 Minibus (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit 350 Minibus (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit 350 Minibus (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit 370 Minibus (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit 370 Minibus (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit 370 Minibus (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit 370 Minibus (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit 370 Minibus (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit 370 Minibus (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit 390 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit 390 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit 390 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit 390 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit 390 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit 390 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit 390 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit 390 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit 390 Crew Van (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit 390 Crew Van (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit 390 Crew Van (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit 390 Crew Van (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit 390 Crew Van (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit 390 Crew Van (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit 390 Crew Van (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit 390 Crew Van (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit 425 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit 425 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit 425 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit 425 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit 425 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit 425 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit 425 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit 425 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit 500 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit 500 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit 500 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit 500 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit 500 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit 500 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit 500 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit 500 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit 430 (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit 430 (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit 430 (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit 430 (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit 430 (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit 430 (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit 330 (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit 330 (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit 330 (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit 330 (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit 330 (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit 330 (3-Türer) LCV 4th Generation (V363) | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit 330 (3-Türer) LCV 4th Generation Facelift (V363) | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit 330 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit 330 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit 330 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit 330 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit 330 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit 330 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit 330 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit 330 Crew Van (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit 330 Crew Van (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit 330 Crew Van (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit 330 Crew Van (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit 330 Crew Van (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit 330 Crew Van (3-Türer) LCV 4th Generation (V363) | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit 330 Crew Van (3-Türer) LCV 4th Generation Facelift (V363) | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit 330 Crew Van (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit 330 Crew Van (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit 330 Crew Van (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit 330 Crew Van (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit 330 Crew Van (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit 330 Crew Van (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit 330 Crew Van (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit 470 (3-Türer) LCV 4th Generation Facelift (V363) | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit 470 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit 470 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit 470 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit 470 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit 470 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit 470 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit 470 (3-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit 470 (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit 470 (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit 470 (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit 470 (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit 470 (3-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit 470 (3-Türer) LCV 4th Generation (V363) | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit 460 Minibus (4-Türer) LCV 4th Generation Facelift (V363) | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit 460 Minibus (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit 460 Minibus (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit 460 Minibus (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit 460 Minibus (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit 460 Minibus (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit 460 Minibus (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit 460 Minibus (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit 460 Minibus (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit 460 Minibus (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit 460 Minibus (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit 460 Minibus (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit 460 Minibus (4-Türer) LCV | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit 460 Minibus (4-Türer) LCV 4th Generation (V363) | 2014-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2002,
    "Mo": "Transit Connect 200 (4-Türer) LCV | 2002-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2003,
    "Mo": "Transit Connect 200 (4-Türer) LCV | 2002-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2004,
    "Mo": "Transit Connect 200 (4-Türer) LCV | 2002-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2005,
    "Mo": "Transit Connect 200 (4-Türer) LCV | 2002-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2006,
    "Mo": "Transit Connect 200 (4-Türer) LCV | 2002-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "Transit Connect 200 (4-Türer) LCV 1st Generation | 2002-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "Transit Connect 200 (4-Türer) LCV 1st Generation 1st Facelift | 2007-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2008,
    "Mo": "Transit Connect 200 (4-Türer) LCV | 2007-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "Transit Connect 200 (4-Türer) LCV 1st Generation 1st Facelift | 2007-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2002,
    "Mo": "Transit Connect 210 LWB (4-Türer) LCV | 2002-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2003,
    "Mo": "Transit Connect 210 LWB (4-Türer) LCV | 2002-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2004,
    "Mo": "Transit Connect 210 LWB (4-Türer) LCV | 2002-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2005,
    "Mo": "Transit Connect 210 LWB (4-Türer) LCV | 2002-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2006,
    "Mo": "Transit Connect 210 LWB (4-Türer) LCV | 2002-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "Transit Connect 210 LWB (4-Türer) LCV | 2002-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "Transit Connect 220 (4-Türer) LCV 1st Generation 1st Facelift | 2007-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2008,
    "Mo": "Transit Connect 220 (4-Türer) LCV | 2007-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "Transit Connect 220 (4-Türer) LCV 1st Generation 1st Facelift | 2007-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "Transit Connect 200 (4-Türer) LCV 1st Generation 2nd Facelift | 2009-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "Transit Connect 200 (4-Türer) LCV | 2009-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Transit Connect 200 (4-Türer) LCV | 2009-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Transit Connect 200 (4-Türer) LCV | 2009-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Transit Connect 200 (4-Türer) LCV 1st Generation 2nd Facelift | 2009-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2002,
    "Mo": "Transit Connect 220 (4-Türer) LCV | 2002-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2003,
    "Mo": "Transit Connect 220 (4-Türer) LCV | 2002-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2004,
    "Mo": "Transit Connect 220 (4-Türer) LCV | 2002-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2005,
    "Mo": "Transit Connect 220 (4-Türer) LCV | 2002-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2006,
    "Mo": "Transit Connect 220 (4-Türer) LCV | 2002-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "Transit Connect 220 (4-Türer) LCV 1st Generation | 2002-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "Transit Connect 220 (4-Türer) LCV 1st Generation 2nd Facelift | 2009-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "Transit Connect 220 (4-Türer) LCV | 2009-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Transit Connect 220 (4-Türer) LCV | 2009-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Transit Connect 220 (4-Türer) LCV | 2009-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Transit Connect 220 (4-Türer) LCV 1st Generation 2nd Facelift | 2009-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2002,
    "Mo": "Transit Connect 220 LWB (4-Türer) LCV | 2002-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2003,
    "Mo": "Transit Connect 220 LWB (4-Türer) LCV | 2002-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2004,
    "Mo": "Transit Connect 220 LWB (4-Türer) LCV | 2002-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2005,
    "Mo": "Transit Connect 220 LWB (4-Türer) LCV | 2002-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2006,
    "Mo": "Transit Connect 220 LWB (4-Türer) LCV | 2002-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "Transit Connect 220 LWB (4-Türer) LCV 1st Generation | 2002-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "Transit Connect 220 LWB (4-Türer) LCV 1st Generation 1st Facelift | 2007-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2008,
    "Mo": "Transit Connect 220 LWB (4-Türer) LCV | 2007-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "Transit Connect 220 LWB (4-Türer) LCV 1st Generation 1st Facelift | 2007-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "Transit Connect 220 LWB (4-Türer) LCV 1st Generation 2nd Facelift | 2009-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "Transit Connect 220 LWB (4-Türer) LCV | 2009-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Transit Connect 220 LWB (4-Türer) LCV | 2009-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Transit Connect 220 LWB (4-Türer) LCV | 2009-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Transit Connect 220 LWB (4-Türer) LCV | 2009-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2002,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV | 2002-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2003,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV | 2002-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2004,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV | 2002-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2005,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV | 2002-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2006,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV | 2002-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV 1st Generation | 2002-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV 1st Generation 2nd Facelift | 2009-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV | 2009-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV | 2009-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV | 2009-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV 1st Generation 2nd Facelift | 2009-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV 1st Generation 1st Facelift | 2007-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2008,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV | 2007-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV 1st Generation 1st Facelift | 2007-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Transit Connect 200 (4-Türer) LCV 2nd Generation | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit Connect 200 (4-Türer) LCV | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit Connect 200 (4-Türer) LCV | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit Connect 200 (4-Türer) LCV | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit Connect 200 (4-Türer) LCV | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 200 (4-Türer) LCV 2nd Generation | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 200 (4-Türer) LCV 2nd Generation Facelift | 2018-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Connect 200 (4-Türer) LCV | 2018-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Connect 200 (4-Türer) LCV | 2018-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Connect 200 (4-Türer) LCV | 2018-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Connect 200 (4-Türer) LCV | 2018-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 210 (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Connect 210 (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Connect 210 (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Connect 210 (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Connect 210 (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Connect 210 (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Connect 210 (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Connect 210 (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Connect 210 (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Transit Connect 220 (4-Türer) LCV 2nd Generation | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit Connect 220 (4-Türer) LCV | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit Connect 220 (4-Türer) LCV | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit Connect 220 (4-Türer) LCV | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit Connect 220 (4-Türer) LCV | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 220 (4-Türer) LCV 2nd Generation | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 220 (4-Türer) LCV 2nd Generation Facelift | 2018-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Connect 220 (4-Türer) LCV | 2018-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Connect 220 (4-Türer) LCV | 2018-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Connect 220 (4-Türer) LCV | 2018-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Connect 220 (4-Türer) LCV | 2018-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 220 Combi (5-Türer) LCV 2nd Generation Facelift | 2018-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Connect 220 Combi (5-Türer) LCV | 2018-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Connect 220 Combi (5-Türer) LCV | 2018-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Connect 220 Combi (5-Türer) LCV | 2018-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Connect 220 Combi (5-Türer) LCV | 2018-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Transit Connect 220 Combi (5-Türer) LCV | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit Connect 220 Combi (5-Türer) LCV | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit Connect 220 Combi (5-Türer) LCV | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit Connect 220 Combi (5-Türer) LCV | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit Connect 220 Combi (5-Türer) LCV | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 220 Combi (5-Türer) LCV 2nd Generation | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 220 LWB (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Connect 220 LWB (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Connect 220 LWB (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Connect 220 LWB (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Connect 220 LWB (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Connect 220 LWB (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Connect 220 LWB (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Connect 220 LWB (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Connect 220 LWB (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 230 (4-Türer) LCV | 2018-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Connect 230 (4-Türer) LCV | 2018-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Connect 230 (4-Türer) LCV | 2018-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Connect 230 (4-Türer) LCV | 2018-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Connect 230 (4-Türer) LCV | 2018-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Connect 230 (4-Türer) LCV | 2018-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 230 Combi (5-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Connect 230 Combi (5-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Connect 230 Combi (5-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Connect 230 Combi (5-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Connect 230 Combi (5-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Connect 230 Combi (5-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Connect 230 Combi (5-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Connect 230 Combi (5-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Connect 230 Combi (5-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 230 Combi LWB (5-Türer) LCV 2nd Generation Facelift | 2018-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Connect 230 Combi LWB (5-Türer) LCV | 2018-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Connect 230 Combi LWB (5-Türer) LCV | 2018-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Connect 230 Combi LWB (5-Türer) LCV | 2018-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Connect 230 Combi LWB (5-Türer) LCV | 2018-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Transit Connect 230 Combi LWB (5-Türer) LCV | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit Connect 230 Combi LWB (5-Türer) LCV | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit Connect 230 Combi LWB (5-Türer) LCV | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit Connect 230 Combi LWB (5-Türer) LCV | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit Connect 230 Combi LWB (5-Türer) LCV | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 230 Combi LWB (5-Türer) LCV 2nd Generation | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV 2nd Generation | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV 2nd Generation | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV 2nd Generation Facelift | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 240 (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Connect 240 (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Connect 240 (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Connect 240 (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Connect 240 (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Connect 240 (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Connect 240 (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Connect 240 (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Connect 240 (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 240 Combi LWB (5-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Connect 240 Combi LWB (5-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Connect 240 Combi LWB (5-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Connect 240 Combi LWB (5-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Connect 240 Combi LWB (5-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Connect 240 Combi LWB (5-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Connect 240 Combi LWB (5-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Connect 240 Combi LWB (5-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Connect 240 Combi LWB (5-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 240 Crew Van LWB (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Connect 240 Crew Van LWB (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Connect 240 Crew Van LWB (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Connect 240 Crew Van LWB (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Connect 240 Crew Van LWB (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Connect 240 Crew Van LWB (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Connect 240 Crew Van LWB (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Connect 240 Crew Van LWB (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Connect 240 Crew Van LWB (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 250 LWB (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Connect 250 LWB (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Connect 250 LWB (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Connect 250 LWB (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Connect 250 LWB (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Connect 250 LWB (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Connect 250 LWB (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Connect 250 LWB (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Connect 250 LWB (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 240 LWB (4-Türer) LCV 2nd Generation Facelift | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Connect 240 LWB (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Connect 240 LWB (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Connect 240 LWB (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Connect 240 LWB (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Connect 240 LWB (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Connect 240 LWB (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Connect 240 LWB (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Connect 240 LWB (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Transit Connect 240 LWB (4-Türer) LCV | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit Connect 240 LWB (4-Türer) LCV | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit Connect 240 LWB (4-Türer) LCV | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit Connect 240 LWB (4-Türer) LCV | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit Connect 240 LWB (4-Türer) LCV | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 240 LWB (4-Türer) LCV 2nd Generation | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 250 (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Connect 250 (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Connect 250 (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Connect 250 (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Connect 250 (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Connect 250 (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Connect 250 (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Connect 250 (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Connect 250 (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Connect L1 FlexCab (2-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Connect L1 FlexCab (2-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Connect L1 FlexCab (2-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Connect L2 (2-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Connect L2 (2-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Connect L2 (2-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Connect L2 FlexCab (2-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Connect L2 FlexCab (2-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Connect L2 FlexCab (2-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Connect L1 (2-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Connect L1 (2-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Connect L1 (2-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Custom 280 (F3) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Custom 280 (F3) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Custom 280 (F3) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Custom 280 (F3) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Custom 280 (F3) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Custom 280 (F3) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Custom 280 (F3) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Custom 280 (F3) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Custom 280 (F3) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Transit Custom 270 (FY) (3-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Transit Custom 270 (FY) (3-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit Custom 270 (FY) (3-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit Custom 270 (FY) (3-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit Custom 270 (FY) (3-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit Custom 270 (FY) (3-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Custom 270 (FY) (3-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Custom 300 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Custom 300 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Custom 300 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Custom 300 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Custom 300 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Custom 300 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Custom 300 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Custom 300 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Custom 300 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Transit Custom 270 Crew Van (FZ) (3-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Transit Custom 270 Crew Van (FZ) (3-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit Custom 270 Crew Van (FZ) (3-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit Custom 270 Crew Van (FZ) (3-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit Custom 270 Crew Van (FZ) (3-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit Custom 270 Crew Van (FZ) (3-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Custom 270 Crew Van (FZ) (3-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Custom 280 Crew Van (FZ) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Custom 280 Crew Van (FZ) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Custom 280 Crew Van (FZ) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Custom 280 Crew Van (FZ) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Custom 280 Crew Van (FZ) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Custom 280 Crew Van (FZ) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Custom 280 Crew Van (FZ) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Custom 280 Crew Van (FZ) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Custom 280 Crew Van (FZ) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Custom 290 (FY) (4-Türer) LCV 1st Generation Facelift | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Custom 290 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Custom 290 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Custom 290 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Custom 290 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Custom 290 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Custom 290 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Custom 290 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Custom 290 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Transit Custom 290 (FY) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Transit Custom 290 (FY) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit Custom 290 (FY) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit Custom 290 (FY) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit Custom 290 (FY) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit Custom 290 (FY) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Custom 290 (FY) (4-Türer) LCV 1st Generation | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Transit Custom 290 Crew Van (FZ) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Transit Custom 290 Crew Van (FZ) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit Custom 290 Crew Van (FZ) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit Custom 290 Crew Van (FZ) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit Custom 290 Crew Van (FZ) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit Custom 290 Crew Van (FZ) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Custom 290 Crew Van (FZ) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Transit Custom 300 Combi (F1) (3-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Transit Custom 300 Combi (F1) (3-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit Custom 300 Combi (F1) (3-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit Custom 300 Combi (F1) (3-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit Custom 300 Combi (F1) (3-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit Custom 300 Combi (F1) (3-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Custom 300 Combi (F1) (3-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Custom 300 Crew Van (FZ) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Custom 300 Crew Van (FZ) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Custom 300 Crew Van (FZ) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Custom 300 Crew Van (FZ) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Custom 300 Crew Van (FZ) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Custom 300 Crew Van (FZ) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Custom 300 Crew Van (FZ) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Custom 300 Crew Van (FZ) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Custom 300 Crew Van (FZ) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Transit Custom 310 Combi (F1) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Transit Custom 310 Combi (F1) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit Custom 310 Combi (F1) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit Custom 310 Combi (F1) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit Custom 310 Combi (F1) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit Custom 310 Combi (F1) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Custom 310 Combi (F1) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Custom 310 (FY) (4-Türer) LCV 1st Generation Facelift | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Custom 310 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Custom 310 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Custom 310 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Custom 310 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Custom 310 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Custom 310 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Custom 310 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Custom 310 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Transit Custom 310 (FY) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Transit Custom 310 (FY) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit Custom 310 (FY) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit Custom 310 (FY) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit Custom 310 (FY) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit Custom 310 (FY) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Custom 310 (FY) (4-Türer) LCV 1st Generation | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Transit Custom 310 Crew Van (FZ) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Transit Custom 310 Crew Van (FZ) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit Custom 310 Crew Van (FZ) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit Custom 310 Crew Van (FZ) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit Custom 310 Crew Van (FZ) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit Custom 310 Crew Van (FZ) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Custom 310 Crew Van (FZ) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Custom 320 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Custom 320 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Custom 320 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Custom 320 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Custom 320 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Custom 320 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Custom 320 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Custom 320 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Custom 320 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Transit Custom 330 (FY) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Transit Custom 330 (FY) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit Custom 330 (FY) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit Custom 330 (FY) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit Custom 330 (FY) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit Custom 330 (FY) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Custom 330 (FY) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Custom 320 Combi (F1) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Custom 320 Combi (F1) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Custom 320 Combi (F1) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Custom 320 Combi (F1) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Custom 320 Combi (F1) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Custom 320 Combi (F1) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Custom 320 Combi (F1) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Custom 320 Combi (F1) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Custom 320 Combi (F1) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Custom 320 Crew Van (FZ) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Custom 320 Crew Van (FZ) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Custom 320 Crew Van (FZ) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Custom 320 Crew Van (FZ) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Custom 320 Crew Van (FZ) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Custom 320 Crew Van (FZ) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Custom 320 Crew Van (FZ) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Custom 320 Crew Van (FZ) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Custom 320 Crew Van (FZ) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Transit Custom 330 Combi (F1) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Transit Custom 330 Combi (F1) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit Custom 330 Combi (F1) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit Custom 330 Combi (F1) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit Custom 330 Combi (F1) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit Custom 330 Combi (F1) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Custom 330 Combi (F1) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Transit Custom 330 Crew Van (FZ) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Transit Custom 330 Crew Van (FZ) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit Custom 330 Crew Van (FZ) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit Custom 330 Crew Van (FZ) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit Custom 330 Crew Van (FZ) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit Custom 330 Crew Van (FZ) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Custom 330 Crew Van (FZ) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Transit Custom 340 (FY) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Transit Custom 340 (FY) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit Custom 340 (FY) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit Custom 340 (FY) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit Custom 340 (FY) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit Custom 340 (FY) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Custom 340 (FY) (4-Türer) LCV 1st Generation | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Custom 340 (FY) (4-Türer) LCV 1st Generation Facelift | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Custom 340 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Custom 340 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Custom 340 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Custom 340 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Custom 340 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Custom 340 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Custom 340 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Custom 340 (FY) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Transit Custom 340 Combi (F1) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Transit Custom 340 Combi (F1) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit Custom 340 Combi (F1) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit Custom 340 Combi (F1) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit Custom 340 Combi (F1) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit Custom 340 Combi (F1) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Custom 340 Combi (F1) (4-Türer) LCV 1st Generation | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Custom 340 Combi (F1) (4-Türer) LCV 1st Generation Facelift | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Custom 340 Combi (F1) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Custom 340 Combi (F1) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Custom 340 Combi (F1) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Custom 340 Combi (F1) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Custom 340 Combi (F1) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Custom 340 Combi (F1) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Custom 340 Combi (F1) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Custom 340 Combi (F1) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Transit Custom 340 Crew Van (FZ) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Transit Custom 340 Crew Van (FZ) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit Custom 340 Crew Van (FZ) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit Custom 340 Crew Van (FZ) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit Custom 340 Crew Van (FZ) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit Custom 340 Crew Van (FZ) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Custom 340 Crew Van (FZ) (4-Türer) LCV 1st Generation | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Custom 340 Crew Van (FZ) (4-Türer) LCV 1st Generation Facelift | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Custom 340 Crew Van (FZ) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Custom 340 Crew Van (FZ) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Custom 340 Crew Van (FZ) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Custom 340 Crew Van (FZ) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Custom 340 Crew Van (FZ) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Custom 340 Crew Van (FZ) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Custom 340 Crew Van (FZ) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Custom 340 Crew Van (FZ) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Custom 280 (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Custom 280 (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Custom 280 (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Custom 280 (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Custom 300 (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Custom 300 (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Custom 300 (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Custom 300 (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Custom 300 Crew Van (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Custom 300 Crew Van (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Custom 300 Crew Van (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Custom 300 Crew Van (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Custom 320 (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Custom 320 (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Custom 320 (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Custom 320 (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Custom 320 Combi (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Custom 320 Combi (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Custom 320 Combi (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Custom 320 Combi (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Custom 320 Crew Van (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Custom 320 Crew Van (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Custom 320 Crew Van (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Custom 320 Crew Van (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Custom 340 (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Custom 340 (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Custom 340 (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Custom 340 (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Custom 340 Combi (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Custom 340 Combi (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Custom 340 Combi (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Custom 340 Combi (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Custom 340 Crew Van (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Custom 340 Crew Van (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Custom 340 Crew Van (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Custom 340 Crew Van (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Tourneo Custom 290 (F3) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Tourneo Custom 290 (F3) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Tourneo Custom 290 (F3) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Tourneo Custom 290 (F3) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Tourneo Custom 290 (F3) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Tourneo Custom 290 (F3) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Tourneo Custom 290 (F3) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Tourneo Custom 300 (F3) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Tourneo Custom 300 (F3) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Tourneo Custom 300 (F3) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Tourneo Custom 300 (F3) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Tourneo Custom 300 (F3) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Tourneo Custom 300 (F3) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Tourneo Custom 300 (F3) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Tourneo Custom 310 (F3) (4-Türer) LCV 1st Generation Facelift | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Tourneo Custom 310 (F3) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Tourneo Custom 310 (F3) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Tourneo Custom 310 (F3) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Tourneo Custom 310 (F3) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Tourneo Custom 310 (F3) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Tourneo Custom 310 (F3) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Tourneo Custom 310 (F3) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Tourneo Custom 310 (F3) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Tourneo Custom 310 (F3) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Tourneo Custom 310 (F3) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Tourneo Custom 310 (F3) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Tourneo Custom 310 (F3) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Tourneo Custom 310 (F3) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Tourneo Custom 310 (F3) (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Tourneo Custom 310 (F3) (4-Türer) LCV 1st Generation | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Tourneo Custom 320 (F3) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Tourneo Custom 320 (F3) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Tourneo Custom 320 (F3) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Tourneo Custom 320 (F3) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Tourneo Custom 320 (F3) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Tourneo Custom 320 (F3) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Tourneo Custom 320 (F3) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Tourneo Custom 320 (F3) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Tourneo Custom 320 (F3) (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Tourneo Custom 340 (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Tourneo Custom 340 (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Tourneo Custom 340 (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Tourneo Custom 340 (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Tourneo Custom 320 (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Tourneo Custom 320 (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Tourneo Custom 320 (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Tourneo Custom 320 (4-Türer) LCV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "California (4-Türer) LCV T6.1 | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "California (4-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "California (4-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "California (4-Türer) LCV T6.1 | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "California (4-Türer) LCV T6.1 | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "California (4-Türer) LCV T6.1 | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "California (4-Türer) LCV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "California (4-Türer) LCV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "California (4-Türer) LCV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "California (4-Türer) LCV T6 | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Caravelle T30 (3-Türer) MPV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Caravelle T30 (3-Türer) MPV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Caravelle T30 (3-Türer) MPV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Caravelle T32 (3-Türer) MPV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Caravelle T32 (3-Türer) MPV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Caravelle T32 (3-Türer) MPV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Caravelle T32 (3-Türer) MPV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Caravelle T32 (3-Türer) MPV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Crafter 28 (4-Türer) LCV | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Crafter 28 (4-Türer) LCV | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Crafter 28 (4-Türer) LCV | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Crafter 28 (4-Türer) LCV | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Crafter 28 (4-Türer) LCV | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Crafter 28 (4-Türer) LCV Typ 2E | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Crafter 28 (4-Türer) LCV Typ 2E | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Crafter 28 (4-Türer) LCV Typ 2E Facelift | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Crafter 28 (4-Türer) LCV Typ 2E Facelift | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Crafter 28 (4-Türer) LCV | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Crafter 28 (4-Türer) LCV | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Crafter 28 (4-Türer) LCV | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Crafter 28 (4-Türer) LCV | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Crafter 30 (4-Türer) LCV | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Crafter 30 (4-Türer) LCV | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Crafter 30 (4-Türer) LCV | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Crafter 30 (4-Türer) LCV | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Crafter 30 (4-Türer) LCV | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Crafter 30 (4-Türer) LCV Typ 2E | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Crafter 30 (4-Türer) LCV Typ 2E | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Crafter 32 (4-Türer) LCV | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Crafter 32 (4-Türer) LCV | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Crafter 32 (4-Türer) LCV | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Crafter 32 (4-Türer) LCV | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Crafter 32 (4-Türer) LCV | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Crafter 32 (4-Türer) LCV | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Crafter 30 (4-Türer) LCV Typ 2E Facelift | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Crafter 30 (4-Türer) LCV Typ 2E Facelift | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Crafter 30 (4-Türer) LCV | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Crafter 30 (4-Türer) LCV | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Crafter 30 (4-Türer) LCV | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Crafter 30 (4-Türer) LCV | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Crafter 35 (4-Türer) LCV | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Crafter 35 (4-Türer) LCV | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Crafter 35 (4-Türer) LCV | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Crafter 35 (4-Türer) LCV | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Crafter 35 (4-Türer) LCV | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Crafter 35 (4-Türer) LCV Typ 2E | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Crafter 35 (4-Türer) LCV Typ 2E | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Crafter 35 (4-Türer) LCV Typ 2E Facelift | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Crafter 35 (4-Türer) LCV Typ 2E Facelift | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Crafter 35 (4-Türer) LCV | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Crafter 35 (4-Türer) LCV | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Crafter 35 (4-Türer) LCV | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Crafter 35 (4-Türer) LCV | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Crafter 46 (4-Türer) LCV | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Crafter 46 (4-Türer) LCV | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Crafter 46 (4-Türer) LCV | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Crafter 46 (4-Türer) LCV | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Crafter 46 (4-Türer) LCV | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Crafter 46 (4-Türer) LCV | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Crafter 50 (4-Türer) LCV | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Crafter 50 (4-Türer) LCV | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Crafter 50 (4-Türer) LCV | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Crafter 50 (4-Türer) LCV | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Crafter 50 (4-Türer) LCV | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Crafter 50 (4-Türer) LCV Typ 2E | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Crafter 50 (4-Türer) LCV Typ 2E | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Crafter 50 (4-Türer) LCV Typ 2E Facelift | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Crafter 50 (4-Türer) LCV Typ 2E Facelift | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Crafter 50 (4-Türer) LCV | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Crafter 50 (4-Türer) LCV | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Crafter 50 (4-Türer) LCV | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Crafter 50 (4-Türer) LCV | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Crafter Combi 30 (4-Türer) LCV | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Crafter Combi 30 (4-Türer) LCV | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Crafter Combi 30 (4-Türer) LCV | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Crafter Combi 30 (4-Türer) LCV | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Crafter Combi 30 (4-Türer) LCV | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Crafter Combi 30 (4-Türer) LCV Typ 2E | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Crafter Combi 30 (4-Türer) LCV Typ 2E | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Crafter Combi 30 (4-Türer) LCV Typ 2E Facelift | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Crafter Combi 30 (4-Türer) LCV Typ 2E Facelift | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Crafter Combi 30 (4-Türer) LCV | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Crafter Combi 30 (4-Türer) LCV | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Crafter Combi 30 (4-Türer) LCV | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Crafter Combi 30 (4-Türer) LCV | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Crafter Combi 35 (4-Türer) LCV | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Crafter Combi 35 (4-Türer) LCV | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Crafter Combi 35 (4-Türer) LCV | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Crafter Combi 35 (4-Türer) LCV | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Crafter Combi 35 (4-Türer) LCV | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Crafter Combi 35 (4-Türer) LCV Typ 2E | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Crafter Combi 35 (4-Türer) LCV Typ 2E | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Crafter Combi 35 (4-Türer) LCV Typ 2E Facelift | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Crafter Combi 35 (4-Türer) LCV Typ 2E Facelift | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Crafter Combi 35 (4-Türer) LCV | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Crafter Combi 35 (4-Türer) LCV | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Crafter Combi 35 (4-Türer) LCV | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Crafter Combi 35 (4-Türer) LCV | 2011-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Crafter 30 (4-Türer) LCV | 2017-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Crafter 30 (4-Türer) LCV | 2017-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Crafter 30 (4-Türer) LCV | 2017-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Crafter 30 (4-Türer) LCV | 2017-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Crafter 30 (4-Türer) LCV Typ SY/SZ | 2017-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Crafter 30 (4-Türer) LCV Typ SY/SZ | 2017-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Crafter 30 (4-Türer) LCV Typ SY/SZ Facelift | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Crafter 30 (4-Türer) LCV Typ SY/SZ Facelift | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Crafter 30 (4-Türer) LCV | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Crafter 30 (4-Türer) LCV | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Crafter 30 (4-Türer) LCV | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Crafter 35 (4-Türer) LCV | 2017-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Crafter 35 (4-Türer) LCV | 2017-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Crafter 35 (4-Türer) LCV | 2017-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Crafter 35 (4-Türer) LCV | 2017-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Crafter 35 (4-Türer) LCV Typ SY/SZ | 2017-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Crafter 35 (4-Türer) LCV Typ SY/SZ | 2017-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Crafter 35 (4-Türer) LCV Typ SY/SZ Facelift | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Crafter 35 (4-Türer) LCV Typ SY/SZ Facelift | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Crafter 35 (4-Türer) LCV | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Crafter 35 (4-Türer) LCV | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Crafter 35 (4-Türer) LCV Typ SY/SZ Facelift | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Crafter 35 (4-Türer) LCV Typ SY/SZ 2nd Facelift | 2025-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Crafter 35 (4-Türer) LCV | 2025-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Crafter 50 (4-Türer) LCV | 2017-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Crafter 50 (4-Türer) LCV | 2017-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Crafter 50 (4-Türer) LCV | 2017-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Crafter 50 (4-Türer) LCV | 2017-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Crafter 50 (4-Türer) LCV Typ SY/SZ | 2017-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Crafter 50 (4-Türer) LCV Typ SY/SZ | 2017-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Crafter 50 (4-Türer) LCV Typ SY/SZ Facelift | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Crafter 50 (4-Türer) LCV Typ SY/SZ Facelift | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Crafter 50 (4-Türer) LCV | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Crafter 50 (4-Türer) LCV | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Crafter 50 (4-Türer) LCV Typ SY/SZ Facelift | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Crafter 50 (4-Türer) LCV Typ SY/SZ 2nd Facelift | 2025-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Crafter 50 (4-Türer) LCV | 2025-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Crafter 55 (4-Türer) LCV | 2017-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Crafter 55 (4-Türer) LCV | 2017-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Crafter 55 (4-Türer) LCV | 2017-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Crafter 55 (4-Türer) LCV | 2017-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Crafter 55 (4-Türer) LCV Typ SY/SZ | 2017-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Crafter 55 (4-Türer) LCV Typ SY/SZ | 2017-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Crafter 55 (4-Türer) LCV Typ SY/SZ Facelift | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Crafter 55 (4-Türer) LCV Typ SY/SZ Facelift | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Crafter 55 (4-Türer) LCV | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Crafter 55 (4-Türer) LCV | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Crafter 55 (4-Türer) LCV Typ SY/SZ Facelift | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Crafter 55 (4-Türer) LCV Typ SY/SZ 2nd Facelift | 2025-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Crafter 55 (4-Türer) LCV | 2025-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Crafter Combi 35 (4-Türer) LCV | 2025-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Crafter Combi 35 (4-Türer) LCV | 2025-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Crafter Crew Van 35 (4-Türer) LCV | 2017-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Crafter Crew Van 35 (4-Türer) LCV | 2017-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Crafter Crew Van 35 (4-Türer) LCV | 2017-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Crafter Crew Van 35 (4-Türer) LCV | 2017-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Crafter Crew Van 35 (4-Türer) LCV Typ SY/SZ | 2017-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Crafter Crew Van 35 (4-Türer) LCV Typ SY/SZ | 2017-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Crafter Crew Van 35 (4-Türer) LCV Typ SY/SZ Facelift | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Crafter Crew Van 35 (4-Türer) LCV Typ SY/SZ Facelift | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Crafter Crew Van 35 (4-Türer) LCV | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Crafter Crew Van 35 (4-Türer) LCV | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Crafter Crew Van 35 (4-Türer) LCV | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Shuttle T28 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Shuttle T28 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Shuttle T28 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Shuttle T28 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Shuttle T28 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Shuttle T28 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Shuttle T28 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Shuttle T30 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Shuttle T30 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Shuttle T30 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Shuttle T30 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Shuttle T30 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Shuttle T30 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Shuttle T30 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Shuttle T32 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Shuttle T32 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Shuttle T32 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Shuttle T32 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Shuttle T32 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Shuttle T32 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Shuttle T32 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Transporter Chassi Double Cab T30 (4-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Transporter Chassi Double Cab T30 (4-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Transporter Chassi Double Cab T30 (4-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter Chassi Double Cab T30 (4-Türer) LCV T6 | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Transporter Chassi Double Cab T28 (4-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Transporter Chassi Double Cab T28 (4-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Transporter Chassi Double Cab T28 (4-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter Chassi Double Cab T28 (4-Türer) LCV T6 | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Transporter Chassi Double Cab T32 (4-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Transporter Chassi Double Cab T32 (4-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Transporter Chassi Double Cab T32 (4-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter Chassi Double Cab T32 (4-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter Chassi Double Cab T28 (4-Türer) LCV T6.1 | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Transporter Chassi Double Cab T28 (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Transporter Chassi Double Cab T28 (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Transporter Chassi Double Cab T28 (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Transporter Chassi Double Cab T28 (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter Chassi Double Cab T28 (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter Chassi Double Cab T30 (4-Türer) LCV T6.1 | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Transporter Chassi Double Cab T30 (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Transporter Chassi Double Cab T30 (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Transporter Chassi Double Cab T30 (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Transporter Chassi Double Cab T30 (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter Chassi Double Cab T30 (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Transporter Chassi Cab T30 (2-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Transporter Chassi Cab T30 (2-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Transporter Chassi Cab T30 (2-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter Chassi Cab T30 (2-Türer) LCV T6 | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Transporter Chassi Cab T28 (2-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Transporter Chassi Cab T28 (2-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Transporter Chassi Cab T28 (2-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter Chassi Cab T28 (2-Türer) LCV T6 | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Transporter Chassi Cab T32 (2-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Transporter Chassi Cab T32 (2-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Transporter Chassi Cab T32 (2-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter Chassi Cab T32 (2-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter Chassi Cab T28 (2-Türer) LCV T6.1 | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Transporter Chassi Cab T28 (2-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Transporter Chassi Cab T28 (2-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Transporter Chassi Cab T28 (2-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Transporter Chassi Cab T28 (2-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter Chassi Cab T28 (2-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter Chassi Cab T30 (2-Türer) LCV T6.1 | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Transporter Chassi Cab T30 (2-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Transporter Chassi Cab T30 (2-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Transporter Chassi Cab T30 (2-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Transporter Chassi Cab T30 (2-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter Chassi Cab T30 (2-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Transporter Chassi Cab T32 (2-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Transporter Chassi Cab T32 (2-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Transporter Chassi Cab T32 (2-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Transporter Chassi Cab T32 (2-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Transporter Chassi Cab T32 (2-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Transporter Chassi Cab T32 (2-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Transporter Chassi Cab T28 (2-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Transporter Chassi Cab T28 (2-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Transporter Chassi Cab T28 (2-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Transporter Chassi Cab T28 (2-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Transporter Chassi Cab T28 (2-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Transporter Chassi Cab T28 (2-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Transporter Chassi Cab T30 (2-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Transporter Chassi Cab T30 (2-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Transporter Chassi Cab T30 (2-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Transporter Chassi Cab T30 (2-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Transporter Chassi Cab T30 (2-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Transporter Chassi Cab T30 (2-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Transporter Chassi Cab T28 (2-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Transporter Chassi Cab T28 (2-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Transporter Chassi Cab T28 (2-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Transporter Chassi Cab T28 (2-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Transporter Chassi Cab T28 (2-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Transporter Chassi Cab T28 (2-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Transporter Chassi Cab T28 (2-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Transporter Chassi Cab T30 (2-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Transporter Chassi Cab T30 (2-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Transporter Chassi Cab T30 (2-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Transporter Chassi Cab T30 (2-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Transporter Chassi Cab T30 (2-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Transporter Chassi Cab T30 (2-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Transporter Chassi Cab T30 (2-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Transporter Chassi Double Cab T28 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Transporter Chassi Double Cab T28 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Transporter Chassi Double Cab T28 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Transporter Chassi Double Cab T28 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Transporter Chassi Double Cab T28 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Transporter Chassi Double Cab T28 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Transporter Chassi Double Cab T28 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Transporter Chassi Double Cab T30 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Transporter Chassi Double Cab T30 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Transporter Chassi Double Cab T30 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Transporter Chassi Double Cab T30 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Transporter Chassi Double Cab T30 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Transporter Chassi Double Cab T30 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Transporter Chassi Double Cab T30 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Transporter Chassi Double Cab T32 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Transporter Chassi Double Cab T32 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Transporter Chassi Double Cab T32 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Transporter Chassi Double Cab T32 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Transporter Chassi Double Cab T32 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Transporter Chassi Double Cab T32 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Transporter Chassi Double Cab T28 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Transporter Chassi Double Cab T28 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Transporter Chassi Double Cab T28 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Transporter Chassi Double Cab T28 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Transporter Chassi Double Cab T28 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Transporter Chassi Double Cab T28 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Transporter Chassi Double Cab T30 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Transporter Chassi Double Cab T30 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Transporter Chassi Double Cab T30 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Transporter Chassi Double Cab T30 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Transporter Chassi Double Cab T30 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Transporter Chassi Double Cab T30 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter Combi T32 (4-Türer) LCV T7 | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter Plus T28 (4-Türer) LCV T7 | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Transporter Plus T28 (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Transporter Plus T28 (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter Plus T30 (4-Türer) LCV T7 | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Transporter Plus T30 (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Transporter Plus T30 (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter T28 (3-Türer) LCV T7 | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Transporter T28 (3-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Transporter T28 (3-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter T30 (3-Türer) LCV T7 | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Transporter T30 (3-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Transporter T30 (3-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Transporter T32 (3-Türer) LCV T7 | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Transporter T32 (3-Türer) LCV T7 | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter T32 (3-Türer) LCV T7 | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Transporter T32 (3-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Transporter T32 (3-Türer) LCV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Transporter Combi T26 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Transporter Combi T26 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Transporter Combi T26 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Transporter Combi T26 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Transporter Combi T26 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Transporter Combi T26 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Transporter Combi T26 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Transporter Combi T26 (4-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Transporter Combi T26 (4-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Transporter Combi T26 (4-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Transporter Combi T26 (4-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Transporter Combi T26 (4-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Transporter Combi T26 (4-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Transporter Combi T26 (4-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Transporter Combi T26 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Transporter Combi T26 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Transporter Combi T26 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Transporter Combi T26 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Transporter Combi T26 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Transporter Combi T26 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Transporter T28 (3-Türer) LCV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Transporter T28 (3-Türer) LCV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Transporter T28 (3-Türer) LCV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter T28 (3-Türer) LCV T6 | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter Combi T28 (4-Türer) LCV T6 | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Transporter Combi T26 (4-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Transporter Combi T26 (4-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Transporter Combi T26 (4-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Transporter Combi T26 (4-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Transporter Combi T26 (4-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Transporter Combi T26 (4-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter Combi T28 (4-Türer) LCV T6.1 | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter Combi T28 (4-Türer) LCV T6 | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter Combi T30 (4-Türer) LCV T6 | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Transporter T28 (3-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Transporter T28 (3-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Transporter T28 (3-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Transporter T28 (3-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Transporter T28 (3-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Transporter T28 (3-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter Combi T30 (4-Türer) LCV T6 | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Transporter Combi T26 (4-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Transporter Combi T26 (4-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Transporter Combi T26 (4-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter Combi T26 (4-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Transporter Combi T26 (4-Türer) LCV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Transporter Combi T26 (4-Türer) LCV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Transporter Combi T26 (4-Türer) LCV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter Combi T26 (4-Türer) LCV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter Combi T28 (4-Türer) LCV T6.1 | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter Combi T28 (4-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter Combi T30 (4-Türer) LCV T6.1 | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter Combi T30 (4-Türer) LCV T6.1 | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter Combi T30 (4-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter Combi T32 (4-Türer) LCV T6 | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter Combi T32 (4-Türer) LCV T6 | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter Combi T32 (4-Türer) LCV T6.1 | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter Combi T32 (4-Türer) LCV T6.1 | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter Combi T32 (4-Türer) LCV T6.1 | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter Combi T32 (4-Türer) LCV T6.1 | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Transporter Plus T28 (4-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Transporter Plus T28 (4-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Transporter Plus T28 (4-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter Plus T28 (4-Türer) LCV T6 | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Transporter Plus T28 (4-Türer) LCV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Transporter Plus T28 (4-Türer) LCV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Transporter Plus T28 (4-Türer) LCV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter Plus T28 (4-Türer) LCV T6 | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter Plus T28 (4-Türer) LCV T6.1 | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Transporter Plus T28 (4-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Transporter Plus T28 (4-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Transporter Plus T28 (4-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Transporter Plus T28 (4-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter Plus T28 (4-Türer) LCV T6.1 | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter Plus T28 (4-Türer) LCV T6.1 | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Transporter Plus T28 (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Transporter Plus T28 (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Transporter Plus T28 (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Transporter Plus T28 (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter Plus T28 (4-Türer) LCV T6.1 | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Transporter Plus T30 (4-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Transporter Plus T30 (4-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Transporter Plus T30 (4-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter Plus T30 (4-Türer) LCV T6 | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Transporter Plus T30 (4-Türer) LCV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Transporter Plus T30 (4-Türer) LCV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Transporter Plus T30 (4-Türer) LCV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter Plus T30 (4-Türer) LCV T6 | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter Plus T30 (4-Türer) LCV T6.1 | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Transporter Plus T30 (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Transporter Plus T30 (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Transporter Plus T30 (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Transporter Plus T30 (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter Plus T30 (4-Türer) LCV T6.1 | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter Plus T30 (4-Türer) LCV T6.1 | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Transporter Plus T30 (4-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Transporter Plus T30 (4-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Transporter Plus T30 (4-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Transporter Plus T30 (4-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter Plus T30 (4-Türer) LCV T6.1 | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter Plus T32 (4-Türer) LCV T6.1 | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Transporter Plus T32 (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Transporter Plus T32 (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Transporter Plus T32 (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Transporter Plus T32 (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter Plus T32 (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Transporter Plus T32 (4-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Transporter Plus T32 (4-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Transporter Plus T32 (4-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter Plus T32 (4-Türer) LCV T6 | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter Plus T32 (4-Türer) LCV T6.1 | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Transporter Plus T32 (4-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Transporter Plus T32 (4-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Transporter Plus T32 (4-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Transporter Plus T32 (4-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter Plus T32 (4-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Transporter Plus T32 (4-Türer) LCV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Transporter Plus T32 (4-Türer) LCV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Transporter Plus T32 (4-Türer) LCV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter Plus T32 (4-Türer) LCV T6 | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Transporter T26 (3-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Transporter T26 (3-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Transporter T26 (3-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Transporter T26 (3-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Transporter T26 (3-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Transporter T26 (3-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Transporter T26 (3-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Transporter T26 (3-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Transporter T26 (3-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Transporter T26 (3-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Transporter T26 (3-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Transporter T26 (3-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Transporter T26 (3-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Transporter T26 (3-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Transporter T26 (3-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Transporter T26 (3-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Transporter T26 (3-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Transporter T26 (3-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Transporter T26 (3-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Transporter T26 (3-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Transporter T26 (3-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Transporter T26 (3-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Transporter T26 (3-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Transporter T26 (3-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Transporter T26 (3-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Transporter T26 (3-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Transporter T26 (3-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Transporter T26 (3-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Transporter T26 (3-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter T26 (3-Türer) LCV T6 | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Transporter T26 (3-Türer) LCV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Transporter T26 (3-Türer) LCV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Transporter T26 (3-Türer) LCV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter T26 (3-Türer) LCV T6 | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter T26 (3-Türer) LCV T6.1 | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Transporter T26 (3-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Transporter T26 (3-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Transporter T26 (3-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Transporter T26 (3-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter T26 (3-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter T26 (3-Türer) LCV T6.1 | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Transporter T26 (3-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Transporter T26 (3-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Transporter T26 (3-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Transporter T26 (3-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter T26 (3-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Transporter T28 (3-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Transporter T28 (3-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Transporter T28 (3-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Transporter T28 (3-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Transporter T28 (3-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Transporter T28 (3-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Transporter T28 (3-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Transporter T28 (3-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Transporter T28 (3-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Transporter T28 (3-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Transporter T28 (3-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Transporter T28 (3-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Transporter T28 (3-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Transporter T28 (3-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter T28 (3-Türer) LCV T6.1 | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Transporter T28 (3-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Transporter T28 (3-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Transporter T28 (3-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Transporter T28 (3-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter T28 (3-Türer) LCV T6.1 | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Transporter T28 (3-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Transporter T28 (3-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Transporter T28 (3-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Transporter T28 (3-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Transporter T28 (3-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Transporter T28 (3-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Transporter T28 (3-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Transporter T28 (3-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Transporter T28 (3-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter T28 (3-Türer) LCV T6 | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter T32 (3-Türer) LCV T6.1 | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Transporter T32 (3-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Transporter T32 (3-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Transporter T32 (3-Türer) LCV T6.1 | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Transporter T32 (3-Türer) LCV T6.1 | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter T32 (3-Türer) LCV T6.1 | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Transporter T30 (3-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Transporter T30 (3-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Transporter T30 (3-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Transporter T30 (3-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Transporter T30 (3-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Transporter T30 (3-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Transporter T30 (3-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter T28 (3-Türer) LCV T6.1 | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Transporter T28 (3-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Transporter T28 (3-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Transporter T28 (3-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Transporter T28 (3-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter T28 (3-Türer) LCV T6.1 | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Transporter T30 (3-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Transporter T30 (3-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Transporter T30 (3-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Transporter T30 (3-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Transporter T30 (3-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Transporter T30 (3-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Transporter T30 (3-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Transporter T30 (3-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Transporter T30 (3-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Transporter T30 (3-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Transporter T30 (3-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Transporter T30 (3-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Transporter T30 (3-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter T32 (3-Türer) LCV T6.1 | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Transporter T32 (3-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Transporter T32 (3-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Transporter T32 (3-Türer) LCV T6.1 | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Transporter T32 (3-Türer) LCV T6.1 | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter T32 (3-Türer) LCV T6.1 | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Transporter T30 (3-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Transporter T30 (3-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Transporter T30 (3-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Transporter T30 (3-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Transporter T30 (3-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Transporter T30 (3-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Transporter T30 (3-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Transporter T30 (3-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Transporter T30 (3-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter T30 (3-Türer) LCV T6 | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Transporter T30 (3-Türer) LCV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Transporter T30 (3-Türer) LCV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Transporter T30 (3-Türer) LCV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter T30 (3-Türer) LCV T6 | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter T30 (3-Türer) LCV T6.1 | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Transporter T30 (3-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Transporter T30 (3-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Transporter T30 (3-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Transporter T30 (3-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter T30 (3-Türer) LCV T6.1 | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter T30 (3-Türer) LCV T6.1 | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Transporter T30 (3-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Transporter T30 (3-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Transporter T30 (3-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Transporter T30 (3-Türer) LCV | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter T30 (3-Türer) LCV T6.1 | 2019-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Transporter T32 (3-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Transporter T32 (3-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Transporter T32 (3-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Transporter T32 (3-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Transporter T32 (3-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Transporter T32 (3-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Transporter T32 (3-Türer) LCV | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Transporter T32 (3-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Transporter T32 (3-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Transporter T32 (3-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Transporter T32 (3-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Transporter T32 (3-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Transporter T32 (3-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Transporter T32 (3-Türer) LCV | 2003-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Transporter T32 (3-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Transporter T32 (3-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Transporter T32 (3-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Transporter T32 (3-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Transporter T32 (3-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Transporter T32 (3-Türer) LCV | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Transporter T32 (3-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Transporter T32 (3-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Transporter T32 (3-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Transporter T32 (3-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Transporter T32 (3-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Transporter T32 (3-Türer) LCV | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Transporter T32 (3-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Transporter T32 (3-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Transporter T32 (3-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter T32 (3-Türer) LCV T6 | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Transporter T32 (3-Türer) LCV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Transporter T32 (3-Türer) LCV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Transporter T32 (3-Türer) LCV | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter T32 (3-Türer) LCV T6 | 2016-2019",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Kangoo Passenger (5-Türer) LCV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Kangoo Passenger (5-Türer) LCV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Kangoo Passenger (5-Türer) LCV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Kangoo Passenger (5-Türer) LCV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Kangoo Passenger (5-Türer) LCV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2026,
    "Mo": "Kangoo Passenger (5-Türer) LCV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Kangoo Crew Van (4-Türer) LCV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Kangoo Crew Van (4-Türer) LCV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Kangoo Crew Van (4-Türer) LCV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Kangoo Crew Van (4-Türer) LCV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Kangoo Crew Van (4-Türer) LCV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2026,
    "Mo": "Kangoo Crew Van (4-Türer) LCV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Kangoo Compact (3-Türer) LCV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Kangoo Compact (3-Türer) LCV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Kangoo Compact (3-Türer) LCV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Kangoo Compact (3-Türer) LCV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Kangoo Compact (3-Türer) LCV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2026,
    "Mo": "Kangoo Compact (3-Türer) LCV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Kangoo Express (3-Türer) LCV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Kangoo Express (3-Türer) LCV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Kangoo Express (3-Türer) LCV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Kangoo Express (3-Türer) LCV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Kangoo Express (3-Türer) LCV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2026,
    "Mo": "Kangoo Express (3-Türer) LCV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2015,
    "Mo": "L200 Club Cab (2-Türer) Pickup | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2016,
    "Mo": "L200 Club Cab (2-Türer) Pickup | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2017,
    "Mo": "L200 Club Cab (2-Türer) Pickup | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2018,
    "Mo": "L200 Club Cab (2-Türer) Pickup | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2019,
    "Mo": "L200 Club Cab (2-Türer) Pickup 5th Generation | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2019,
    "Mo": "L200 Club Cab (2-Türer) Pickup 5th Generation Facelift | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2020,
    "Mo": "L200 Club Cab (2-Türer) Pickup | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2021,
    "Mo": "L200 Club Cab (2-Türer) Pickup | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2022,
    "Mo": "L200 Club Cab (2-Türer) Pickup | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2023,
    "Mo": "L200 Club Cab (2-Türer) Pickup | 2019-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Vivaro Combi 2.7t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Vivaro Combi 2.7t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Vivaro Combi 2.7t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Vivaro Combi 2.7t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Vivaro Combi 2.7t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Vivaro Combi 2.7t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Vivaro Crew Van 2.7t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Vivaro Crew Van 2.7t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Vivaro Crew Van 2.7t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Vivaro Crew Van 2.7t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Vivaro Crew Van 2.7t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Vivaro Crew Van 2.7t (4-Türer) LCV C | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Vivaro Crew Van 2.7t (4-Türer) LCV C Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Vivaro Crew Van 2.7t (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2026,
    "Mo": "Vivaro Crew Van 2.7t (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Vivaro Crew Van 2.9t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Vivaro Crew Van 2.9t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Vivaro Crew Van 2.9t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Vivaro Crew Van 2.9t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Vivaro Crew Van 2.9t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Vivaro Crew Van 2.9t (4-Türer) LCV C | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Vivaro Crew Van 2.9t (4-Türer) LCV C Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Vivaro Crew Van 2.9t (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2026,
    "Mo": "Vivaro Crew Van 2.9t (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Vivaro Panel Van 2.7t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Vivaro Panel Van 2.7t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Vivaro Panel Van 2.7t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Vivaro Panel Van 2.7t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Vivaro Panel Van 2.7t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Vivaro Panel Van 2.7t (4-Türer) LCV C | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Vivaro Panel Van 2.7t (4-Türer) LCV C Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Vivaro Panel Van 2.7t (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2026,
    "Mo": "Vivaro Panel Van 2.7t (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Vivaro Panel Van 2.9t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Vivaro Panel Van 2.9t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Vivaro Panel Van 2.9t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Vivaro Panel Van 2.9t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Vivaro Panel Van 2.9t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Vivaro Panel Van 2.9t (4-Türer) LCV C | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Vivaro Panel Van 2.9t (4-Türer) LCV C Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Vivaro Panel Van 2.9t (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2026,
    "Mo": "Vivaro Panel Van 2.9t (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "EQE (4-Türer) Stufenheck | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "EQE (4-Türer) Stufenheck | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "EQE (4-Türer) Stufenheck | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "EQE (4-Türer) Stufenheck | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "EQE (4-Türer) Stufenheck | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2012,
    "Mo": "Combo Van L2 (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2013,
    "Mo": "Combo Van L2 (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2014,
    "Mo": "Combo Van L2 (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2015,
    "Mo": "Combo Van L2 (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2016,
    "Mo": "Combo Van L2 (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Combo Van L2 (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Combo Van L2 (4-Türer) LCV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "Partner Van (4-Türer) LCV K9 Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "Partner Van (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2026,
    "Mo": "Partner Van (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "Partner Van (4-Türer) LCV K9 | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "Partner Van (4-Türer) LCV K9 | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "Partner Van (4-Türer) LCV K9 | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "Partner Van (4-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "Partner Van (4-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "Partner Van (4-Türer) LCV | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "Partner Van (4-Türer) LCV K9 | 2018-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "Partner (5-Türer) LCV S2 2nd Facelift | 2015-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "Partner (5-Türer) LCV | 2015-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "Partner (5-Türer) LCV | 2015-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "Partner (5-Türer) LCV | 2015-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "Partner (5-Türer) LCV | 2015-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "Partner (5-Türer) LCV | 2015-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "Partner (5-Türer) LCV | 2008-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2009,
    "Mo": "Partner (5-Türer) LCV | 2008-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2010,
    "Mo": "Partner (5-Türer) LCV | 2008-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "Partner (5-Türer) LCV | 2008-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "Partner (5-Türer) LCV S2 | 2008-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "Partner (5-Türer) LCV S2 1st Facelift | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "Partner (5-Türer) LCV | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "Partner (5-Türer) LCV | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "Partner (5-Türer) LCV S2 1st Facelift | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "Partner Van (4-Türer) LCV S2 1st Facelift | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "Partner Van (4-Türer) LCV | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "Partner Van (4-Türer) LCV | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "Partner Van (4-Türer) LCV S2 1st Facelift | 2012-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "Partner Van (4-Türer) LCV S2 2nd Facelift | 2015-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "Partner Van (4-Türer) LCV | 2015-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "Partner Van (4-Türer) LCV | 2015-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "Partner Van (4-Türer) LCV S2 2nd Facelift | 2015-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "Partner Van (4-Türer) LCV S2 2nd Facelift | 2015-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "Partner Van (4-Türer) LCV S2 2nd Facelift | 2015-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "Partner Van (4-Türer) LCV | 2008-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2009,
    "Mo": "Partner Van (4-Türer) LCV | 2008-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2010,
    "Mo": "Partner Van (4-Türer) LCV | 2008-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "Partner Van (4-Türer) LCV | 2008-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "Partner Van (4-Türer) LCV S2 | 2008-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Sprinter Panel Van 4100 (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Sprinter Panel Van 4100 (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Sprinter Panel Van 4100 (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "Sprinter Panel Van 4100 (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "Sprinter Panel Van 4100 (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "Sprinter Panel Van 4100 (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Sprinter Panel Van 4100 (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "Sprinter Panel Van 4100 (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "Sprinter Panel Van 4100 (4-Türer) LCV | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Interstar Van 3.3 t (4-Türer) LCV XDD | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Interstar Van 3.3 t (4-Türer) LCV XDD | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2026,
    "Mo": "Interstar Van 3.3 t (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "Interstar Van 2.8 t (4-Türer) LCV | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Interstar Van 2.8 t (4-Türer) LCV | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Interstar Van 2.8 t (4-Türer) LCV | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Interstar Van 2.8 t (4-Türer) LCV | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Interstar Van 2.8 t (4-Türer) LCV | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "Interstar Van 3.3 t (4-Türer) LCV | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Interstar Van 3.3 t (4-Türer) LCV | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Interstar Van 3.3 t (4-Türer) LCV | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Interstar Van 3.3 t (4-Türer) LCV X62B | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Interstar Van 3.3 t (4-Türer) LCV X62B | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "Interstar Van 3.5 t (4-Türer) LCV | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Interstar Van 3.5 t (4-Türer) LCV | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Interstar Van 3.5 t (4-Türer) LCV | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Interstar Van 3.5 t (4-Türer) LCV X62B | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Interstar Van 3.5 t (4-Türer) LCV X62B | 2021-2025",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Interstar Van 3.5 t (4-Türer) LCV XDD | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Interstar Van 3.5 t (4-Türer) LCV XDD | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2026,
    "Mo": "Interstar Van 3.5 t (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2010,
    "Mo": "Movano Combi 2.8t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2011,
    "Mo": "Movano Combi 2.8t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2012,
    "Mo": "Movano Combi 2.8t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2013,
    "Mo": "Movano Combi 2.8t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2014,
    "Mo": "Movano Combi 2.8t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2015,
    "Mo": "Movano Combi 3.0t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2016,
    "Mo": "Movano Combi 3.0t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Movano Combi 3.0t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Movano Combi 3.0t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Movano Combi 3.0t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2015,
    "Mo": "Movano Combi 3.3t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2016,
    "Mo": "Movano Combi 3.3t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Movano Combi 3.3t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Movano Combi 3.3t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Movano Combi 3.3t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2010,
    "Mo": "Movano Combi 3.5t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2011,
    "Mo": "Movano Combi 3.5t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2012,
    "Mo": "Movano Combi 3.5t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2013,
    "Mo": "Movano Combi 3.5t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2014,
    "Mo": "Movano Combi 3.5t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2015,
    "Mo": "Movano Combi 3.5t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2016,
    "Mo": "Movano Combi 3.5t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Movano Combi 3.5t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Movano Combi 3.5t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Movano Combi 3.5t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2015,
    "Mo": "Movano Crew Van 3.3t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2016,
    "Mo": "Movano Crew Van 3.3t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Movano Crew Van 3.3t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Movano Crew Van 3.3t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Movano Crew Van 3.3t (4-Türer) LCV B Facelift | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Movano Crew Van 3.3t (4-Türer) LCV B 2nd Facelift | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Movano Crew Van 3.3t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Movano Crew Van 3.3t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Movano Crew Van 3.3t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Movano Crew Van 3.3t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Movano Crew Van 3.3t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Movano Crew Van 3.3t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2026,
    "Mo": "Movano Crew Van 3.3t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2010,
    "Mo": "Movano Crew Van 3.5t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2011,
    "Mo": "Movano Crew Van 3.5t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2012,
    "Mo": "Movano Crew Van 3.5t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2013,
    "Mo": "Movano Crew Van 3.5t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2014,
    "Mo": "Movano Crew Van 3.5t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2015,
    "Mo": "Movano Crew Van 3.5t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2016,
    "Mo": "Movano Crew Van 3.5t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Movano Crew Van 3.5t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Movano Crew Van 3.5t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Movano Crew Van 3.5t (4-Türer) LCV B Facelift | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Movano Crew Van 3.5t (4-Türer) LCV B 2nd Facelift | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Movano Crew Van 3.5t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Movano Crew Van 3.5t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Movano Crew Van 3.5t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Movano Crew Van 3.5t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Movano Crew Van 3.5t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Movano Crew Van 3.5t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2026,
    "Mo": "Movano Crew Van 3.5t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2010,
    "Mo": "Movano Van 2.8t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2011,
    "Mo": "Movano Van 2.8t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2012,
    "Mo": "Movano Van 2.8t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2013,
    "Mo": "Movano Van 2.8t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2014,
    "Mo": "Movano Van 2.8t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2015,
    "Mo": "Movano Van 2.8t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2016,
    "Mo": "Movano Van 2.8t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Movano Van 2.8t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Movano Van 2.8t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Movano Van 2.8t (4-Türer) LCV B Facelift | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Movano Van 2.8t (4-Türer) LCV B 2nd Facelift | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Movano Van 2.8t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Movano Van 2.8t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Movano Van 2.8t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Movano Van 2.8t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Movano Van 2.8t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Movano Van 2.8t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2026,
    "Mo": "Movano Van 2.8t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2010,
    "Mo": "Movano Van 3.3t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2011,
    "Mo": "Movano Van 3.3t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2012,
    "Mo": "Movano Van 3.3t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2013,
    "Mo": "Movano Van 3.3t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2014,
    "Mo": "Movano Van 3.3t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2015,
    "Mo": "Movano Van 3.3t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2016,
    "Mo": "Movano Van 3.3t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Movano Van 3.3t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Movano Van 3.3t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Movano Van 3.3t (4-Türer) LCV B Facelift | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2015,
    "Mo": "Movano Van 3.5t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2016,
    "Mo": "Movano Van 3.5t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Movano Van 3.5t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Movano Van 3.5t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Movano Van 3.5t (4-Türer) LCV B Facelift | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2010,
    "Mo": "Movano Van 3.5t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2011,
    "Mo": "Movano Van 3.5t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2012,
    "Mo": "Movano Van 3.5t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2013,
    "Mo": "Movano Van 3.5t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2014,
    "Mo": "Movano Van 3.5t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Movano Van 3.5t (4-Türer) LCV B 2nd Facelift | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Movano Van 3.5t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Movano Van 3.5t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Movano Van 3.5t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Movano Van 3.5t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Movano Van 3.5t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Movano Van 3.5t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2026,
    "Mo": "Movano Van 3.5t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Movano Van 3.3t (4-Türer) LCV B 2nd Facelift | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Movano Van 3.3t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Movano Van 3.3t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Movano Van 3.3t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Movano Van 3.3t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Movano Van 3.3t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Movano Van 3.3t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2026,
    "Mo": "Movano Van 3.3t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2015,
    "Mo": "Movano Van 4.5t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2016,
    "Mo": "Movano Van 4.5t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Movano Van 4.5t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Movano Van 4.5t (4-Türer) LCV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Movano Van 4.5t (4-Türer) LCV B Facelift | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2010,
    "Mo": "Movano Van 4.5t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2011,
    "Mo": "Movano Van 4.5t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2012,
    "Mo": "Movano Van 4.5t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2013,
    "Mo": "Movano Van 4.5t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2014,
    "Mo": "Movano Van 4.5t (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Movano Van 4.5t (4-Türer) LCV B 2nd Facelift | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Movano Van 4.5t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Movano Van 4.5t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Movano Van 4.5t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Movano Van 4.5t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Movano Van 4.5t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Movano Van 4.5t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2026,
    "Mo": "Movano Van 4.5t (4-Türer) LCV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "Expert Panel Van 1.0t (4-Türer) LCV | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "Expert Panel Van 1.0t (4-Türer) LCV | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "Expert Panel Van 1.0t (4-Türer) LCV | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "Expert Panel Van 1.0t (4-Türer) LCV | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "Expert Panel Van 1.0t (4-Türer) LCV 2nd Generation Facelift | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2007,
    "Mo": "Expert Panel Van 1.0t (4-Türer) LCV | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "Expert Panel Van 1.0t (4-Türer) LCV | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2009,
    "Mo": "Expert Panel Van 1.0t (4-Türer) LCV | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2010,
    "Mo": "Expert Panel Van 1.0t (4-Türer) LCV | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "Expert Panel Van 1.0t (4-Türer) LCV | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "Expert Panel Van 1.0t (4-Türer) LCV 3rd Generation 2nd Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "Expert Panel Van 1.0t (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2026,
    "Mo": "Expert Panel Van 1.0t (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "Expert Panel Van 1.0t (4-Türer) LCV 3rd Generation | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "Expert Panel Van 1.0t (4-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "Expert Panel Van 1.0t (4-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "Expert Panel Van 1.0t (4-Türer) LCV 3rd Generation | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "Expert Panel Van 1.0t (4-Türer) LCV 3rd Generation Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "Expert Panel Van 1.0t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "Expert Panel Van 1.0t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "Expert Panel Van 1.0t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "Expert Panel Van 1.0t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "Expert Panel Van 1.0t (4-Türer) LCV 3rd Generation Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "Expert Panel Van 1.2t (4-Türer) LCV | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "Expert Panel Van 1.2t (4-Türer) LCV | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "Expert Panel Van 1.2t (4-Türer) LCV | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "Expert Panel Van 1.2t (4-Türer) LCV | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "Expert Panel Van 1.2t (4-Türer) LCV 2nd Generation Facelift | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2007,
    "Mo": "Expert Panel Van 1.2t (4-Türer) LCV | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "Expert Panel Van 1.2t (4-Türer) LCV | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2009,
    "Mo": "Expert Panel Van 1.2t (4-Türer) LCV | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2010,
    "Mo": "Expert Panel Van 1.2t (4-Türer) LCV | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "Expert Panel Van 1.2t (4-Türer) LCV | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "Expert Panel Van 1.2t (4-Türer) LCV 3rd Generation 2nd Facelift | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "Expert Panel Van 1.2t (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2026,
    "Mo": "Expert Panel Van 1.2t (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "Expert Panel Van 1.2t (4-Türer) LCV 3rd Generation | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "Expert Panel Van 1.2t (4-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "Expert Panel Van 1.2t (4-Türer) LCV | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "Expert Panel Van 1.2t (4-Türer) LCV 3rd Generation | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "Expert Panel Van 1.2t (4-Türer) LCV 3rd Generation Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "Expert Panel Van 1.2t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "Expert Panel Van 1.2t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "Expert Panel Van 1.2t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "Expert Panel Van 1.2t (4-Türer) LCV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "Expert Panel Van 1.2t (4-Türer) LCV 3rd Generation Facelift | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Master Crew Van 3.5 T (4-Türer) LCV XDD | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Master Crew Van 3.5 T (4-Türer) LCV XDD | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2026,
    "Mo": "Master Crew Van 3.5 T (4-Türer) LCV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Master Crew Van 3.3 T (4-Türer) LCV III 1st Facelift | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Master Crew Van 3.3 T (4-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Master Crew Van 3.3 T (4-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Master Crew Van 3.3 T (4-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Master Crew Van 3.3 T (4-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Master Crew Van 3.3 T (4-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Master Crew Van 3.3 T (4-Türer) LCV | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2010,
    "Mo": "Master Crew Van 3.3 T (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2011,
    "Mo": "Master Crew Van 3.3 T (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2012,
    "Mo": "Master Crew Van 3.3 T (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Master Crew Van 3.3 T (4-Türer) LCV | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Master Crew Van 3.3 T (4-Türer) LCV III | 2010-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1995,
    "Mo": "HiAce Van (3-Türer) LCV | 1995-2006",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1996,
    "Mo": "HiAce Van (3-Türer) LCV | 1995-2006",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1997,
    "Mo": "HiAce Van (3-Türer) LCV | 1995-2006",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1998,
    "Mo": "HiAce Van (3-Türer) LCV | 1995-2006",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1999,
    "Mo": "HiAce Van (3-Türer) LCV | 1995-2006",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2000,
    "Mo": "HiAce Van (3-Türer) LCV | 1995-2006",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2001,
    "Mo": "HiAce Van (3-Türer) LCV | 1995-2006",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "HiAce Van (3-Türer) LCV | 1995-2006",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "HiAce Van (3-Türer) LCV | 1995-2006",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "HiAce Van (3-Türer) LCV | 1995-2006",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "HiAce Van (3-Türer) LCV | 1995-2006",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "HiAce Van (3-Türer) LCV XH10 | 1995-2006",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "HiAce Van (3-Türer) LCV XH10 Facelift | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "HiAce Van (3-Türer) LCV | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "HiAce Van (3-Türer) LCV | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "HiAce Van (3-Türer) LCV | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "HiAce Van (3-Türer) LCV | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "HiAce Van (3-Türer) LCV | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "HiAce Van (3-Türer) LCV | 2006-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Acura",
    "Y": 2022,
    "Mo": "MDX (YD8-9/YE1) (5-Türer) SUV | 2022-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Acura",
    "Y": 2023,
    "Mo": "MDX (YD8-9/YE1) (5-Türer) SUV | 2022-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Acura",
    "Y": 2024,
    "Mo": "MDX (YD8-9/YE1) (5-Türer) SUV | 2022-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Acura",
    "Y": 2024,
    "Mo": "ZDX (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Acura",
    "Y": 2025,
    "Mo": "ZDX (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Acura",
    "Y": 2026,
    "Mo": "ZDX (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AITO",
    "Y": 2022,
    "Mo": "M7 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AITO",
    "Y": 2023,
    "Mo": "M7 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AITO",
    "Y": 2024,
    "Mo": "M7 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AITO",
    "Y": 2025,
    "Mo": "M7 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AITO",
    "Y": 2026,
    "Mo": "M7 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AIWAYS",
    "Y": 2019,
    "Mo": "U5 (5-Türer) Crossover | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AIWAYS",
    "Y": 2020,
    "Mo": "U5 (5-Türer) Crossover | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AIWAYS",
    "Y": 2021,
    "Mo": "U5 (5-Türer) Crossover | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AIWAYS",
    "Y": 2022,
    "Mo": "U5 (5-Türer) Crossover | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AIWAYS",
    "Y": 2023,
    "Mo": "U5 (5-Türer) Crossover | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AIWAYS",
    "Y": 2024,
    "Mo": "U5 (5-Türer) Crossover | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AIWAYS",
    "Y": 2025,
    "Mo": "U5 (5-Türer) Crossover | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AIWAYS",
    "Y": 2026,
    "Mo": "U5 (5-Türer) Crossover | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2017,
    "Mo": "Stelvio (5-Türer) Crossover | 2017-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2018,
    "Mo": "Stelvio (5-Türer) Crossover | 2017-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2019,
    "Mo": "Stelvio (5-Türer) Crossover | 2017-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2020,
    "Mo": "Stelvio (5-Türer) Crossover | 2020-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2021,
    "Mo": "Stelvio (5-Türer) Crossover | 2020-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2022,
    "Mo": "Stelvio (5-Türer) Crossover | 2020-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2023,
    "Mo": "Stelvio (5-Türer) Crossover | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2024,
    "Mo": "Stelvio (5-Türer) Crossover | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2025,
    "Mo": "Stelvio (5-Türer) Crossover | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2026,
    "Mo": "Stelvio (5-Türer) Crossover | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2016,
    "Mo": "A3 (5-Türer) Schrägheck 8V Facelift | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2017,
    "Mo": "A3 (5-Türer) Schrägheck | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2018,
    "Mo": "A3 (5-Türer) Schrägheck | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "A3 (5-Türer) Schrägheck | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "A3 (5-Türer) Schrägheck 8V Facelift | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2013,
    "Mo": "A3 (5-Türer) Schrägheck 8V | 2013-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2014,
    "Mo": "A3 (5-Türer) Schrägheck | 2013-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2015,
    "Mo": "A3 (5-Türer) Schrägheck | 2013-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2016,
    "Mo": "A3 (5-Türer) Schrägheck 8V | 2013-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "A3 (5-Türer) Schrägheck 8Y Facelift | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "A3 (5-Türer) Schrägheck | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2026,
    "Mo": "A3 (5-Türer) Schrägheck | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "A3 (5-Türer) Schrägheck 8Y | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "A3 (5-Türer) Schrägheck | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "A3 (5-Türer) Schrägheck | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "A3 (5-Türer) Schrägheck | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "A3 (5-Türer) Schrägheck 8Y | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "A4 Avant (5-Türer) Kombi B9 Facelift | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "A4 Avant (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "A4 Avant (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "A4 Avant (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "A4 Avant (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "A4 Avant (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "A4 Avant (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2026,
    "Mo": "A4 Avant (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2016,
    "Mo": "A4 Avant (5-Türer) Kombi | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2017,
    "Mo": "A4 Avant (5-Türer) Kombi | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2018,
    "Mo": "A4 Avant (5-Türer) Kombi | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "A4 Avant (5-Türer) Kombi B9 | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2008,
    "Mo": "A4 Avant (5-Türer) Kombi B8 | 2008-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2009,
    "Mo": "A4 Avant (5-Türer) Kombi | 2008-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2010,
    "Mo": "A4 Avant (5-Türer) Kombi | 2008-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2011,
    "Mo": "A4 Avant (5-Türer) Kombi | 2008-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2012,
    "Mo": "A4 Avant (5-Türer) Kombi B8 | 2008-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2012,
    "Mo": "A4 Avant (5-Türer) Kombi B8 Facelift | 2012-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2013,
    "Mo": "A4 Avant (5-Türer) Kombi | 2012-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2014,
    "Mo": "A4 Avant (5-Türer) Kombi | 2012-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2015,
    "Mo": "A4 Avant (5-Türer) Kombi | 2012-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "A5 Avant (5-Türer) Kombi | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2026,
    "Mo": "A5 Avant (5-Türer) Kombi | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2011,
    "Mo": "A6 Avant (5-Türer) Kombi C7 | 2011-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2012,
    "Mo": "A6 Avant (5-Türer) Kombi | 2011-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2013,
    "Mo": "A6 Avant (5-Türer) Kombi | 2011-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2014,
    "Mo": "A6 Avant (5-Türer) Kombi | 2011-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2015,
    "Mo": "A6 Avant (5-Türer) Kombi C7 | 2011-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2009,
    "Mo": "A6 Avant (5-Türer) Kombi C6 Facelift | 2009-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2010,
    "Mo": "A6 Avant (5-Türer) Kombi | 2009-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2011,
    "Mo": "A6 Avant (5-Türer) Kombi C6 Facelift | 2009-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2015,
    "Mo": "A6 Avant (5-Türer) Kombi C7 Facelift | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2016,
    "Mo": "A6 Avant (5-Türer) Kombi | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2017,
    "Mo": "A6 Avant (5-Türer) Kombi | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2018,
    "Mo": "A6 Avant (5-Türer) Kombi C7 Facelift | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2005,
    "Mo": "A6 Avant (5-Türer) Kombi C6 | 2005-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2006,
    "Mo": "A6 Avant (5-Türer) Kombi C6 | 2005-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2007,
    "Mo": "A6 Avant (5-Türer) Kombi | 2005-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2008,
    "Mo": "A6 Avant (5-Türer) Kombi | 2005-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2009,
    "Mo": "A6 Avant (5-Türer) Kombi C6 | 2005-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2018,
    "Mo": "A6 Avant (5-Türer) Kombi C8 | 2018-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "A6 Avant (5-Türer) Kombi | 2018-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "A6 Avant (5-Türer) Kombi | 2018-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "A6 Avant (5-Türer) Kombi | 2018-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "A6 Avant (5-Türer) Kombi | 2018-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "A6 Avant (5-Türer) Kombi | 2018-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "A6 Avant (5-Türer) Kombi C8 | 2018-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "A6 Avant (5-Türer) Kombi C8 | 2018-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2026,
    "Mo": "A6 Avant (5-Türer) Kombi C8 | 2018-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "A6 Avant (5-Türer) Kombi C8 Facelift | 2024-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "A6 Avant (5-Türer) Kombi C8 Facelift | 2024-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "A6 Avant (5-Türer) Kombi C9 | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2026,
    "Mo": "A6 Avant (5-Türer) Kombi C9 | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "e-tron (5-Türer) SUV | 2019-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "e-tron (5-Türer) SUV | 2019-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "e-tron (5-Türer) SUV | 2019-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "e-tron (5-Türer) SUV | 2019-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "e-tron (5-Türer) SUV | 2019-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "e-tron Sportback (5-Türer) SUV | 2019-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "e-tron Sportback (5-Türer) SUV | 2019-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "e-tron Sportback (5-Türer) SUV | 2019-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "e-tron Sportback (5-Türer) SUV | 2019-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "e-tron Sportback (5-Türer) SUV | 2019-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "e-tron Sportback (5-Türer) SUV | 2019-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2015,
    "Mo": "Q3 (5-Türer) SUV 8U Facelift | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2016,
    "Mo": "Q3 (5-Türer) SUV | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2017,
    "Mo": "Q3 (5-Türer) SUV | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2018,
    "Mo": "Q3 (5-Türer) SUV | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2012,
    "Mo": "Q3 (5-Türer) SUV | 2012-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2013,
    "Mo": "Q3 (5-Türer) SUV | 2012-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2014,
    "Mo": "Q3 (5-Türer) SUV | 2012-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2015,
    "Mo": "Q3 (5-Türer) SUV 8U | 2012-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "Q3 (5-Türer) SUV | 2019-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "Q3 (5-Türer) SUV | 2019-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "Q3 (5-Türer) SUV | 2019-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "Q3 (5-Türer) SUV | 2019-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "Q3 (5-Türer) SUV | 2019-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "Q3 (5-Türer) SUV | 2019-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q3 (5-Türer) SUV | 2019-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2026,
    "Mo": "Q3 (5-Türer) SUV F3 | 2019-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2026,
    "Mo": "Q3 (5-Türer) SUV FJ | 2026-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "Q4 e-tron (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "Q4 e-tron (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "Q4 e-tron (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "Q4 e-tron (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q4 e-tron (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2026,
    "Mo": "Q4 e-tron (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2009,
    "Mo": "Q5 (5-Türer) SUV | 2009-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2010,
    "Mo": "Q5 (5-Türer) SUV | 2009-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2011,
    "Mo": "Q5 (5-Türer) SUV | 2009-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2012,
    "Mo": "Q5 (5-Türer) SUV | 2009-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2013,
    "Mo": "Q5 (5-Türer) SUV 8R | 2009-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2013,
    "Mo": "Q5 (5-Türer) SUV 8R Facelift | 2013-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2014,
    "Mo": "Q5 (5-Türer) SUV | 2013-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2015,
    "Mo": "Q5 (5-Türer) SUV | 2013-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2016,
    "Mo": "Q5 (5-Türer) SUV | 2013-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2017,
    "Mo": "Q5 (5-Türer) SUV 8R Facelift | 2013-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2017,
    "Mo": "Q5 (5-Türer) SUV FY | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2018,
    "Mo": "Q5 (5-Türer) SUV | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "Q5 (5-Türer) SUV | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "Q5 (5-Türer) SUV | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q5 (5-Türer) SUV GU | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2026,
    "Mo": "Q5 (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "Q5 (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "Q5 (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "Q5 (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "Q5 (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q5 (5-Türer) SUV FY Facelift | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "Q5 Sportback (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "Q5 Sportback (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "Q5 Sportback (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "Q5 Sportback (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q5 Sportback (5-Türer) SUV FY Facelift | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q5 Sportback (5-Türer) SUV GU | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2026,
    "Mo": "Q5 Sportback (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2018,
    "Mo": "Q5L (5-Türer) SUV | 2018-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "Q5L (5-Türer) SUV | 2018-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "Q5L (5-Türer) SUV | 2018-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "Q6 e-tron (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q6 e-tron (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2026,
    "Mo": "Q6 e-tron (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q6 Sportback e-tron (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2026,
    "Mo": "Q6 Sportback e-tron (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2009,
    "Mo": "Q7 (5-Türer) SUV 4L Facelift | 2009-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2010,
    "Mo": "Q7 (5-Türer) SUV | 2009-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2011,
    "Mo": "Q7 (5-Türer) SUV | 2009-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2012,
    "Mo": "Q7 (5-Türer) SUV | 2009-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2013,
    "Mo": "Q7 (5-Türer) SUV | 2009-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2014,
    "Mo": "Q7 (5-Türer) SUV | 2009-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2015,
    "Mo": "Q7 (5-Türer) SUV 4L Facelift | 2009-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2006,
    "Mo": "Q7 (5-Türer) SUV | 2006-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2007,
    "Mo": "Q7 (5-Türer) SUV | 2006-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2008,
    "Mo": "Q7 (5-Türer) SUV | 2006-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2009,
    "Mo": "Q7 (5-Türer) SUV 4L | 2006-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "Q8 (5-Türer) SUV 4M Facelift | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q8 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2026,
    "Mo": "Q8 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "Q8 (5-Türer) SUV | 2019-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "Q8 (5-Türer) SUV | 2019-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "Q8 (5-Türer) SUV | 2019-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "Q8 (5-Türer) SUV | 2019-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "Q8 (5-Türer) SUV | 2019-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "Q8 (5-Türer) SUV 4M | 2019-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "Q8 e-tron (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "Q8 e-tron (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q8 e-tron (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2026,
    "Mo": "Q8 e-tron (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "Q8 Sportback e-tron (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "Q8 Sportback e-tron (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q8 Sportback e-tron (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2026,
    "Mo": "Q8 Sportback e-tron (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "2 Series Active Tourer (F45) (5-Türer) MPV | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "2 Series Active Tourer (F45) (5-Türer) MPV | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "2 Series Active Tourer (F45) (5-Türer) MPV | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "2 Series Active Tourer (F45) (5-Türer) MPV | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "2 Series Active Tourer (U06) (5-Türer) MPV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "2 Series Active Tourer (U06) (5-Türer) MPV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "2 Series Active Tourer (U06) (5-Türer) MPV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "2 Series Active Tourer (U06) (5-Türer) MPV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2026,
    "Mo": "2 Series Active Tourer (U06) (5-Türer) MPV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "2 Series Active Tourer (F45 LCI) (5-Türer) MPV | 2019-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "2 Series Active Tourer (F45 LCI) (5-Türer) MPV | 2019-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "2 Series Active Tourer (F45 LCI) (5-Türer) MPV | 2019-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "2 Series Active Tourer (F45 LCI) (5-Türer) MPV | 2019-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "2 Series Gran Tourer (F46) (5-Türer) MPV | 2016-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "2 Series Gran Tourer (F46) (5-Türer) MPV | 2016-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "2 Series Gran Tourer (F46) (5-Türer) MPV | 2016-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "2 Series Gran Tourer (F46 LCI) (5-Türer) MPV | 2019-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "2 Series Gran Tourer (F46 LCI) (5-Türer) MPV | 2019-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "2 Series Gran Tourer (F46 LCI) (5-Türer) MPV | 2019-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "2 Series Gran Tourer (F46 LCI) (5-Türer) MPV | 2019-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2006,
    "Mo": "3 Series Touring (E91) (5-Türer) Kombi | 2006-2008",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2007,
    "Mo": "3 Series Touring (E91) (5-Türer) Kombi | 2006-2008",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2008,
    "Mo": "3 Series Touring (E91) (5-Türer) Kombi | 2006-2008",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2009,
    "Mo": "3 Series Touring (E91 LCI) (5-Türer) Kombi | 2009-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2010,
    "Mo": "3 Series Touring (E91 LCI) (5-Türer) Kombi | 2009-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2011,
    "Mo": "3 Series Touring (E91 LCI) (5-Türer) Kombi | 2009-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2012,
    "Mo": "3 Series Touring (E91 LCI) (5-Türer) Kombi | 2009-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2013,
    "Mo": "3 Series Touring (F31) (5-Türer) Kombi | 2013-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2014,
    "Mo": "3 Series Touring (F31) (5-Türer) Kombi | 2013-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "3 Series Touring (F31) (5-Türer) Kombi | 2013-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "3 Series Touring (F31 LCI) (5-Türer) Kombi | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "3 Series Touring (F31 LCI) (5-Türer) Kombi | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "3 Series Touring (F31 LCI) (5-Türer) Kombi | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "3 Series Touring (F31 LCI) (5-Türer) Kombi | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "3 Series Touring (G21 2nd LCI) (5-Türer) Kombi | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2026,
    "Mo": "3 Series Touring (G21 2nd LCI) (5-Türer) Kombi | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "3 Series Touring (G21) (5-Türer) Kombi | 2020-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "3 Series Touring (G21) (5-Türer) Kombi | 2020-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "3 Series Touring (G21) (5-Türer) Kombi | 2020-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "3 Series Touring (G21 LCI) (5-Türer) Kombi | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "3 Series Touring (G21 LCI) (5-Türer) Kombi | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "3 Series Touring (G21 LCI) (5-Türer) Kombi | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "3 Series Touring (G21 LCI) (5-Türer) Kombi | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2014,
    "Mo": "5 Series Touring (F11 LCI) (5-Türer) Kombi | 2014-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "5 Series Touring (F11 LCI) (5-Türer) Kombi | 2014-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "5 Series Touring (F11 LCI) (5-Türer) Kombi | 2014-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "5 Series Touring (F11 LCI) (5-Türer) Kombi | 2014-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2010,
    "Mo": "5 Series Touring (F11) (5-Türer) Kombi | 2010-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2011,
    "Mo": "5 Series Touring (F11) (5-Türer) Kombi | 2010-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2012,
    "Mo": "5 Series Touring (F11) (5-Türer) Kombi | 2010-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2013,
    "Mo": "5 Series Touring (F11) (5-Türer) Kombi | 2010-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "5 Series Touring (G31) (5-Türer) Kombi | 2018-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "5 Series Touring (G31) (5-Türer) Kombi | 2018-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "5 Series Touring (G31) (5-Türer) Kombi | 2018-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "5 Series Touring (G31 LCI) (5-Türer) Kombi | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "5 Series Touring (G31 LCI) (5-Türer) Kombi | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "5 Series Touring (G31 LCI) (5-Türer) Kombi | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "5 Series Touring (G31 LCI) (5-Türer) Kombi | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "5 Series Touring (G61) (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "5 Series Touring (G61) (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2026,
    "Mo": "5 Series Touring (G61) (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2010,
    "Mo": "X1 (E84) (5-Türer) SUV | 2010-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2011,
    "Mo": "X1 (E84) (5-Türer) SUV | 2010-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2012,
    "Mo": "X1 (E84) (5-Türer) SUV | 2010-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2013,
    "Mo": "X1 (E84 LCI) (5-Türer) SUV | 2013-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2014,
    "Mo": "X1 (E84 LCI) (5-Türer) SUV | 2013-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "X1 (E84 LCI) (5-Türer) SUV | 2013-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "X1 (U11) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "X1 (U11) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "X1 (U11) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2026,
    "Mo": "X1 (U11) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "X1 (F48) (5-Türer) SUV | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "X1 (F48) (5-Türer) SUV | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "X1 (F48) (5-Türer) SUV | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "X1 (F48) (5-Türer) SUV | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "X1 (F48 LCI) (5-Türer) SUV | 2020-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "X1 (F48 LCI) (5-Türer) SUV | 2020-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "X1 (F48 LCI) (5-Türer) SUV | 2020-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "X2 (F39) (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "X2 (F39) (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "X2 (F39) (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "X2 (F39) (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "X2 (F39) (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "X2 (F39) (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "X2 (U10) (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "X2 (U10) (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2026,
    "Mo": "X2 (U10) (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2011,
    "Mo": "X3 (F25) (5-Türer) SUV | 2011-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2012,
    "Mo": "X3 (F25) (5-Türer) SUV | 2011-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2013,
    "Mo": "X3 (F25) (5-Türer) SUV | 2011-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2014,
    "Mo": "X3 (F25) (5-Türer) SUV | 2011-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "X3 (F25 LCI) (5-Türer) SUV | 2015-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "X3 (F25 LCI) (5-Türer) SUV | 2015-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "X3 (F25 LCI) (5-Türer) SUV | 2015-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "X3 (G01) (5-Türer) SUV | 2018-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "X3 (G01) (5-Türer) SUV | 2018-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "X3 (G01) (5-Türer) SUV | 2018-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "X3 (G01) (5-Türer) SUV | 2018-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "X3 (G01 LCI) (5-Türer) SUV | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "X3 (G01 LCI) (5-Türer) SUV | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "X3 (G01 LCI) (5-Türer) SUV | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "X3 (G01 LCI) (5-Türer) SUV | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "X3 (G45) (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2026,
    "Mo": "X3 (G45) (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "X4 (F26) (5-Türer) SUV | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "X4 (F26) (5-Türer) SUV | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "X4 (F26) (5-Türer) SUV | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "X4 (F26) (5-Türer) SUV | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "X4 (G02 LCI) (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "X4 (G02 LCI) (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "X4 (G02 LCI) (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "X4 (G02 LCI) (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2026,
    "Mo": "X4 (G02 LCI) (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "X4 (G02) (5-Türer) SUV | 2019-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "X4 (G02) (5-Türer) SUV | 2019-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "X4 (G02) (5-Türer) SUV | 2019-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2011,
    "Mo": "X5 (E70 LCI) (5-Türer) SUV | 2011-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2012,
    "Mo": "X5 (E70 LCI) (5-Türer) SUV | 2011-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2013,
    "Mo": "X5 (E70 LCI) (5-Türer) SUV | 2011-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2007,
    "Mo": "X5 (E70) (5-Türer) SUV | 2007-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2008,
    "Mo": "X5 (E70) (5-Türer) SUV | 2007-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2009,
    "Mo": "X5 (E70) (5-Türer) SUV | 2007-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2010,
    "Mo": "X5 (E70) (5-Türer) SUV | 2007-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2011,
    "Mo": "X5 (E70) (5-Türer) SUV | 2007-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2014,
    "Mo": "X5 (F15) (5-Türer) SUV | 2014-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "X5 (F15) (5-Türer) SUV | 2014-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "X5 (F15) (5-Türer) SUV | 2014-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "X5 (F15) (5-Türer) SUV | 2014-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "X5 (F15) (5-Türer) SUV | 2014-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "X5 (G05 LCI) (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "X5 (G05 LCI) (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2026,
    "Mo": "X5 (G05 LCI) (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "X5 (G05) (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "X5 (G05) (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "X5 (G05) (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "X5 (G05) (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "X5 (G05) (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "X5 (G05) (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2007,
    "Mo": "X5 7-Seater (5-Türer) SUV | 2007-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2008,
    "Mo": "X5 7-Seater (5-Türer) SUV | 2007-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2009,
    "Mo": "X5 7-Seater (5-Türer) SUV | 2007-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2010,
    "Mo": "X5 7-Seater (5-Türer) SUV | 2007-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2011,
    "Mo": "X5 7-Seater (5-Türer) SUV E70 | 2007-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2011,
    "Mo": "X5 7-Seater (5-Türer) SUV E70 Facelift | 2011-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2012,
    "Mo": "X5 7-Seater (5-Türer) SUV | 2011-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2013,
    "Mo": "X5 7-Seater (5-Türer) SUV | 2011-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2014,
    "Mo": "X5 7-Seater (5-Türer) SUV | 2014-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "X5 7-Seater (5-Türer) SUV | 2014-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "X5 7-Seater (5-Türer) SUV | 2014-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "X5 7-Seater (5-Türer) SUV | 2014-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "X5 7-Seater (5-Türer) SUV F15 | 2014-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "X5 7-Seater (5-Türer) SUV G05 | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "X5 7-Seater (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "X5 7-Seater (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "X5 7-Seater (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "X5 7-Seater (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "X5 7-Seater (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "X5 7-Seater (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "X5 7-Seater (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2026,
    "Mo": "X5 7-Seater (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "X6 (F16) (5-Türer) SUV | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "X6 (F16) (5-Türer) SUV | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "X6 (F16) (5-Türer) SUV | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "X6 (F16) (5-Türer) SUV | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "X6 (F16) (5-Türer) SUV | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "X6 (G06 LCI) (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "X6 (G06 LCI) (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2026,
    "Mo": "X6 (G06 LCI) (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "X6 (G06) (5-Türer) SUV | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "X6 (G06) (5-Türer) SUV | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "X6 (G06) (5-Türer) SUV | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "X6 (G06) (5-Türer) SUV | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "X7 (G07) (5-Türer) SUV | 2019-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "X7 (G07) (5-Türer) SUV | 2019-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "X7 (G07) (5-Türer) SUV | 2019-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "X7 (G07) (5-Türer) SUV | 2019-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "X7 (G07 LCI) (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "X7 (G07 LCI) (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "X7 (G07 LCI) (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "X7 (G07 LCI) (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2026,
    "Mo": "X7 (G07 LCI) (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2022,
    "Mo": "Atto 3 (5-Türer) SUV | 2022-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2023,
    "Mo": "Atto 3 (5-Türer) SUV | 2022-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2024,
    "Mo": "Atto 3 (5-Türer) SUV | 2022-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2025,
    "Mo": "Atto 3 (5-Türer) SUV | 2022-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2026,
    "Mo": "Atto 3 (5-Türer) SUV | 2022-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2023,
    "Mo": "Seal U (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2024,
    "Mo": "Seal U (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2025,
    "Mo": "Seal U (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2026,
    "Mo": "Seal U (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2024,
    "Mo": "Sealion 6 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2025,
    "Mo": "Sealion 6 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2026,
    "Mo": "Sealion 6 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2021,
    "Mo": "Tang (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2022,
    "Mo": "Tang (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2023,
    "Mo": "Tang (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2024,
    "Mo": "Tang (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2025,
    "Mo": "Tang (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2026,
    "Mo": "Tang (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2018,
    "Mo": "Tang (5-Türer) SUV | 2018-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2019,
    "Mo": "Tang (5-Türer) SUV | 2018-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2020,
    "Mo": "Tang (5-Türer) SUV | 2018-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2015,
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2017,
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2018,
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "Grand C4 Picasso (5-Türer) MPV 2nd Generation Facelift | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2017,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2018,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2019,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2020,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2021,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2022,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2023,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2025,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2026,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "Grand C4 Picasso (5-Türer) MPV 2nd Generation | 2013-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2013-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2015,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2013-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "Grand C4 Picasso (5-Türer) MPV 2nd Generation | 2013-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2021,
    "Mo": "C5 X (5-Türer) Schrägheck | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2022,
    "Mo": "C5 X (5-Türer) Schrägheck | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2023,
    "Mo": "C5 X (5-Türer) Schrägheck | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "C5 X (5-Türer) Schrägheck | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2025,
    "Mo": "C5 X (5-Türer) Schrägheck | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2026,
    "Mo": "C5 X (5-Türer) Schrägheck | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2017,
    "Mo": "Bolt EV (5-Türer) Crossover | 2017-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2018,
    "Mo": "Bolt EV (5-Türer) Crossover | 2017-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2019,
    "Mo": "Bolt EV (5-Türer) Crossover | 2017-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2020,
    "Mo": "Bolt EV (5-Türer) Crossover | 2017-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2021,
    "Mo": "Bolt EV (5-Türer) Crossover | 2017-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2015,
    "Mo": "Suburban 1500 (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2016,
    "Mo": "Suburban 1500 (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2017,
    "Mo": "Suburban 1500 (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2018,
    "Mo": "Suburban 1500 (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2019,
    "Mo": "Suburban 1500 (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2020,
    "Mo": "Suburban 1500 (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2025,
    "Mo": "Suburban 1500 (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2026,
    "Mo": "Suburban 1500 (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2021,
    "Mo": "Suburban 1500 (5-Türer) SUV | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2022,
    "Mo": "Suburban 1500 (5-Türer) SUV | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2023,
    "Mo": "Suburban 1500 (5-Türer) SUV | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2024,
    "Mo": "Suburban 1500 (5-Türer) SUV | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2015,
    "Mo": "Tahoe (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2016,
    "Mo": "Tahoe (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2017,
    "Mo": "Tahoe (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2018,
    "Mo": "Tahoe (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2019,
    "Mo": "Tahoe (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2020,
    "Mo": "Tahoe (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2025,
    "Mo": "Tahoe (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2026,
    "Mo": "Tahoe (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2021,
    "Mo": "Tahoe (5-Türer) SUV | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2022,
    "Mo": "Tahoe (5-Türer) SUV | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2023,
    "Mo": "Tahoe (5-Türer) SUV | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2024,
    "Mo": "Tahoe (5-Türer) SUV | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2024,
    "Mo": "Formentor (5-Türer) Crossover 1st Generation Facelift | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2025,
    "Mo": "Formentor (5-Türer) Crossover | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2026,
    "Mo": "Formentor (5-Türer) Crossover | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2021,
    "Mo": "Formentor (5-Türer) Crossover | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2022,
    "Mo": "Formentor (5-Türer) Crossover | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2023,
    "Mo": "Formentor (5-Türer) Crossover | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2024,
    "Mo": "Formentor (5-Türer) Crossover 1st Generation | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2024,
    "Mo": "Leon Sportstourer (5-Türer) Kombi 1st Generation Facelift | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2025,
    "Mo": "Leon Sportstourer (5-Türer) Kombi 1st Generation Facelift | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2026,
    "Mo": "Leon Sportstourer (5-Türer) Kombi 1st Generation Facelift | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2020,
    "Mo": "Leon Sportstourer (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2021,
    "Mo": "Leon Sportstourer (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2022,
    "Mo": "Leon Sportstourer (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2023,
    "Mo": "Leon Sportstourer (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2024,
    "Mo": "Leon Sportstourer (5-Türer) Kombi 1st Generation | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2025,
    "Mo": "Leon Sportstourer (5-Türer) Kombi 1st Generation | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2026,
    "Mo": "Leon Sportstourer (5-Türer) Kombi 1st Generation | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2025,
    "Mo": "Terramar (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2026,
    "Mo": "Terramar (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2025,
    "Mo": "Escalade (GMT1UL) (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2026,
    "Mo": "Escalade (GMT1UL) (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2021,
    "Mo": "Escalade (GMT1UL) (5-Türer) SUV | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2022,
    "Mo": "Escalade (GMT1UL) (5-Türer) SUV | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2023,
    "Mo": "Escalade (GMT1UL) (5-Türer) SUV | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2024,
    "Mo": "Escalade (GMT1UL) (5-Türer) SUV | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2015,
    "Mo": "Escalade (GMTK2UL) (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2016,
    "Mo": "Escalade (GMTK2UL) (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2017,
    "Mo": "Escalade (GMTK2UL) (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2018,
    "Mo": "Escalade (GMTK2UL) (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2019,
    "Mo": "Escalade (GMTK2UL) (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2020,
    "Mo": "Escalade (GMTK2UL) (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2025,
    "Mo": "Escalade ESV (GMT1YL) (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2026,
    "Mo": "Escalade ESV (GMT1YL) (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2021,
    "Mo": "Escalade ESV (GMT1YL) (5-Türer) SUV | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2022,
    "Mo": "Escalade ESV (GMT1YL) (5-Türer) SUV | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2023,
    "Mo": "Escalade ESV (GMT1YL) (5-Türer) SUV | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2024,
    "Mo": "Escalade ESV (GMT1YL) (5-Türer) SUV | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2020,
    "Mo": "XT6 (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2021,
    "Mo": "XT6 (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2022,
    "Mo": "XT6 (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2023,
    "Mo": "XT6 (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2024,
    "Mo": "XT6 (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2025,
    "Mo": "XT6 (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2026,
    "Mo": "XT6 (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2014,
    "Mo": "Duster (5-Türer) SUV | 2014-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2015,
    "Mo": "Duster (5-Türer) SUV | 2014-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2016,
    "Mo": "Duster (5-Türer) SUV | 2014-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2017,
    "Mo": "Duster (5-Türer) SUV | 2014-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2018,
    "Mo": "Duster (5-Türer) SUV HS Facelift | 2014-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2022,
    "Mo": "Duster (5-Türer) SUV | 2022-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2023,
    "Mo": "Duster (5-Türer) SUV | 2022-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2024,
    "Mo": "Duster (5-Türer) SUV HM Facelift | 2022-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2018,
    "Mo": "Duster (5-Türer) SUV HM | 2018-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2019,
    "Mo": "Duster (5-Türer) SUV | 2018-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2020,
    "Mo": "Duster (5-Türer) SUV | 2018-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2021,
    "Mo": "Duster (5-Türer) SUV | 2018-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2017,
    "Mo": "Lodgy (5-Türer) MPV JS Facelift | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2018,
    "Mo": "Lodgy (5-Türer) MPV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2019,
    "Mo": "Lodgy (5-Türer) MPV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2020,
    "Mo": "Lodgy (5-Türer) MPV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2021,
    "Mo": "Lodgy (5-Türer) MPV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2022,
    "Mo": "Lodgy (5-Türer) MPV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2023,
    "Mo": "Lodgy (5-Türer) MPV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2024,
    "Mo": "Lodgy (5-Türer) MPV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2025,
    "Mo": "Lodgy (5-Türer) MPV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2026,
    "Mo": "Lodgy (5-Türer) MPV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2012,
    "Mo": "Lodgy (5-Türer) MPV | 2012-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2013,
    "Mo": "Lodgy (5-Türer) MPV | 2012-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2014,
    "Mo": "Lodgy (5-Türer) MPV | 2012-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2015,
    "Mo": "Lodgy (5-Türer) MPV | 2012-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2016,
    "Mo": "Lodgy (5-Türer) MPV | 2012-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2017,
    "Mo": "Lodgy (5-Türer) MPV JS | 2012-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2012,
    "Mo": "Sandero (5-Türer) Schrägheck 2nd Generation | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2013,
    "Mo": "Sandero (5-Türer) Schrägheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2014,
    "Mo": "Sandero (5-Türer) Schrägheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2015,
    "Mo": "Sandero (5-Türer) Schrägheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2016,
    "Mo": "Sandero (5-Türer) Schrägheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2017,
    "Mo": "Sandero (5-Türer) Schrägheck 2nd Generation | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2017,
    "Mo": "Sandero (5-Türer) Schrägheck 2nd Generation Facelift | 2017-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2018,
    "Mo": "Sandero (5-Türer) Schrägheck | 2017-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2019,
    "Mo": "Sandero (5-Türer) Schrägheck | 2017-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2020,
    "Mo": "Sandero (5-Türer) Schrägheck | 2017-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2021,
    "Mo": "Sandero (5-Türer) Schrägheck 2nd Generation Facelift | 2017-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2008,
    "Mo": "Sandero (5-Türer) Schrägheck | 2008-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2009,
    "Mo": "Sandero (5-Türer) Schrägheck | 2008-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2010,
    "Mo": "Sandero (5-Türer) Schrägheck | 2008-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2011,
    "Mo": "Sandero (5-Türer) Schrägheck | 2008-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2012,
    "Mo": "Sandero (5-Türer) Schrägheck 1st Generation | 2008-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Atlas Cross Sport (CMC) (5-Türer) SUV | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Atlas Cross Sport (CMC) (5-Türer) SUV | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Atlas Cross Sport (CMC) (5-Türer) SUV | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Atlas Cross Sport (CMC) (5-Türer) SUV | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Atlas Cross Sport (CMD) (5-Türer) SUV | 2024-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Atlas Cross Sport (CMD) (5-Türer) SUV | 2024-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Atlas Cross Sport (CMD) (5-Türer) SUV | 2024-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "ID.4 (E21) (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "ID.4 (E21) (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "ID.4 (E21) (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "ID.4 (E21) (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "ID.4 (E21) (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "ID.4 (E21) (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "ID.7 Tourer (ED5) (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "ID.7 Tourer (ED5) (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "ID.7 Tourer (ED5) (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Passat Alltrack (CB5) (5-Türer) Crossover | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Passat Alltrack (CB5) (5-Türer) Crossover | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Passat Alltrack (CB5) (5-Türer) Crossover | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Passat Alltrack (CB5) (5-Türer) Crossover | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Passat Alltrack (CB5) (5-Türer) Crossover | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Passat Alltrack (3G5) (5-Türer) Crossover | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Passat Alltrack (3G5) (5-Türer) Crossover | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Passat Alltrack (3G5) (5-Türer) Crossover | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Passat Alltrack (3G5) (5-Türer) Crossover | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Passat Variant (3G5) (5-Türer) Kombi | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Passat Variant (3G5) (5-Türer) Kombi | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Passat Variant (3G5) (5-Türer) Kombi | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Passat Variant (3G5) (5-Türer) Kombi | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Passat Variant (3G5) (5-Türer) Kombi | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Passat Variant (CB5) (5-Türer) Kombi | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Passat Variant (CB5) (5-Türer) Kombi | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Passat Variant (CB5) (5-Türer) Kombi | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Passat Variant (CB5) (5-Türer) Kombi | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Passat Variant (CB5) (5-Türer) Kombi | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Passat Variant (CJ5) (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Passat Variant (CJ5) (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Passat Variant (CJ5) (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "T-Roc (5-Türer) SUV | 2026-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Tayron 5-seater (R41) (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Tayron 5-seater (R41) (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Tayron 7-seater (R41) (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Tayron 7-seater (R41) (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Touareg (CR7) (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Touareg (CR7) (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Touareg (CR7) (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Touareg (CR7) (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Touareg (CR7) (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Touareg (CR7) (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2025,
    "Mo": "EX40 (536) (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2026,
    "Mo": "EX40 (536) (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2025,
    "Mo": "EX90 7-seater (356) (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2026,
    "Mo": "EX90 7-seater (356) (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2013,
    "Mo": "V40 Cross Country (526) (5-Türer) Schrägheck | 2013-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2014,
    "Mo": "V40 Cross Country (526) (5-Türer) Schrägheck | 2013-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2015,
    "Mo": "V40 Cross Country (526) (5-Türer) Schrägheck | 2013-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2016,
    "Mo": "V40 Cross Country (526) (5-Türer) Schrägheck | 2013-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2017,
    "Mo": "V40 Cross Country (526) (5-Türer) Schrägheck | 2017-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2018,
    "Mo": "V40 Cross Country (526) (5-Türer) Schrägheck | 2017-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2019,
    "Mo": "V40 Cross Country (526) (5-Türer) Schrägheck | 2017-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2014,
    "Mo": "V60 (155) (5-Türer) Kombi | 2014-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2015,
    "Mo": "V60 (155) (5-Türer) Kombi | 2014-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2016,
    "Mo": "V60 (155) (5-Türer) Kombi | 2014-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2017,
    "Mo": "V60 (155) (5-Türer) Kombi | 2014-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2018,
    "Mo": "V60 (155) (5-Türer) Kombi | 2014-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2011,
    "Mo": "V60 (155) (5-Türer) Kombi | 2011-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2012,
    "Mo": "V60 (155) (5-Türer) Kombi | 2011-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2013,
    "Mo": "V60 (155) (5-Türer) Kombi | 2011-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2019,
    "Mo": "V60 (225) (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2020,
    "Mo": "V60 (225) (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2021,
    "Mo": "V60 (225) (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2022,
    "Mo": "V60 (225) (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2023,
    "Mo": "V60 (225) (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2024,
    "Mo": "V60 (225) (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2025,
    "Mo": "V60 (225) (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2026,
    "Mo": "V60 (225) (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2015,
    "Mo": "V60 Cross Country (155) (5-Türer) Kombi | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2016,
    "Mo": "V60 Cross Country (155) (5-Türer) Kombi | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2017,
    "Mo": "V60 Cross Country (155) (5-Türer) Kombi | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2018,
    "Mo": "V60 Cross Country (155) (5-Türer) Kombi | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2019,
    "Mo": "V60 Cross Country (225) (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2020,
    "Mo": "V60 Cross Country (225) (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2021,
    "Mo": "V60 Cross Country (225) (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2022,
    "Mo": "V60 Cross Country (225) (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2023,
    "Mo": "V60 Cross Country (225) (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2024,
    "Mo": "V60 Cross Country (225) (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2025,
    "Mo": "V60 Cross Country (225) (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2026,
    "Mo": "V60 Cross Country (225) (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2017,
    "Mo": "V90 (235) (5-Türer) Kombi | 2017-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2018,
    "Mo": "V90 (235) (5-Türer) Kombi | 2017-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2019,
    "Mo": "V90 (235) (5-Türer) Kombi | 2017-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2020,
    "Mo": "V90 (235) (5-Türer) Kombi | 2017-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2021,
    "Mo": "V90 (235) (5-Türer) Kombi PW/PZ | 2017-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2021,
    "Mo": "V90 (235) (5-Türer) Kombi PW/PZ Facelift | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2022,
    "Mo": "V90 (235) (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2023,
    "Mo": "V90 (235) (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2024,
    "Mo": "V90 (235) (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2025,
    "Mo": "V90 (235) (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2026,
    "Mo": "V90 (235) (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2017,
    "Mo": "V90 Cross Country (236) (5-Türer) Crossover | 2017-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2018,
    "Mo": "V90 Cross Country (236) (5-Türer) Crossover | 2017-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2019,
    "Mo": "V90 Cross Country (236) (5-Türer) Crossover | 2017-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2020,
    "Mo": "V90 Cross Country (236) (5-Türer) Crossover | 2017-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2021,
    "Mo": "V90 Cross Country (236) (5-Türer) Crossover PW/PZ | 2017-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2021,
    "Mo": "V90 Cross Country (236) (5-Türer) Crossover PW/PZ Facelift | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2022,
    "Mo": "V90 Cross Country (236) (5-Türer) Crossover | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2023,
    "Mo": "V90 Cross Country (236) (5-Türer) Crossover | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2024,
    "Mo": "V90 Cross Country (236) (5-Türer) Crossover | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2025,
    "Mo": "V90 Cross Country (236) (5-Türer) Crossover | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2026,
    "Mo": "V90 Cross Country (236) (5-Türer) Crossover | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2018,
    "Mo": "XC40 (536) (5-Türer) SUV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2019,
    "Mo": "XC40 (536) (5-Türer) SUV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2020,
    "Mo": "XC40 (536) (5-Türer) SUV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2021,
    "Mo": "XC40 (536) (5-Türer) SUV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2022,
    "Mo": "XC40 (536) (5-Türer) SUV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2023,
    "Mo": "XC40 (536) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2024,
    "Mo": "XC40 (536) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2025,
    "Mo": "XC40 (536) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2026,
    "Mo": "XC40 (536) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2009,
    "Mo": "XC60 (156) (5-Türer) SUV | 2009-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2010,
    "Mo": "XC60 (156) (5-Türer) SUV | 2009-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2011,
    "Mo": "XC60 (156) (5-Türer) SUV | 2009-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2012,
    "Mo": "XC60 (156) (5-Türer) SUV | 2009-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2013,
    "Mo": "XC60 (156) (5-Türer) SUV | 2009-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2014,
    "Mo": "XC60 (156) (5-Türer) SUV | 2014-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2015,
    "Mo": "XC60 (156) (5-Türer) SUV | 2014-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2016,
    "Mo": "XC60 (156) (5-Türer) SUV | 2014-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2017,
    "Mo": "XC60 (156) (5-Türer) SUV | 2014-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2017,
    "Mo": "XC60 (246) (5-Türer) SUV | 2017-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2018,
    "Mo": "XC60 (246) (5-Türer) SUV | 2017-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2019,
    "Mo": "XC60 (246) (5-Türer) SUV | 2017-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2020,
    "Mo": "XC60 (246) (5-Türer) SUV | 2017-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2021,
    "Mo": "XC60 (246) (5-Türer) SUV | 2017-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2022,
    "Mo": "XC60 (246) (5-Türer) SUV | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2023,
    "Mo": "XC60 (246) (5-Türer) SUV | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2024,
    "Mo": "XC60 (246) (5-Türer) SUV | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2025,
    "Mo": "XC60 (246) (5-Türer) SUV | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2026,
    "Mo": "XC60 (5-Türer) SUV | 2026-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2016,
    "Mo": "XC90 5-seater (256LC) (5-Türer) SUV | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2017,
    "Mo": "XC90 5-seater (256LC) (5-Türer) SUV | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2018,
    "Mo": "XC90 5-seater (256LC) (5-Türer) SUV | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2019,
    "Mo": "XC90 5-seater (256LC) (5-Türer) SUV | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2020,
    "Mo": "XC90 5-seater (256LC) (5-Türer) SUV | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2020,
    "Mo": "XC90 5-seater (256) (5-Türer) SUV | 2020-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2021,
    "Mo": "XC90 5-seater (256) (5-Türer) SUV | 2020-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2022,
    "Mo": "XC90 5-seater (256) (5-Türer) SUV | 2020-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2023,
    "Mo": "XC90 5-seater (256) (5-Türer) SUV | 2020-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2024,
    "Mo": "XC90 5-seater (256) (5-Türer) SUV | 2020-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2025,
    "Mo": "XC90 5-seater (256) (5-Türer) SUV | 2020-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2020,
    "Mo": "XC90 7-seater (5-Türer) SUV | 2020-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2021,
    "Mo": "XC90 7-seater (5-Türer) SUV | 2020-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2022,
    "Mo": "XC90 7-seater (5-Türer) SUV | 2020-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2023,
    "Mo": "XC90 7-seater (5-Türer) SUV | 2020-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2024,
    "Mo": "XC90 7-seater (5-Türer) SUV | 2020-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2025,
    "Mo": "XC90 7-seater (5-Türer) SUV | 2020-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2025,
    "Mo": "XC90 7-seater (256) (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2026,
    "Mo": "XC90 7-seater (256) (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Auris Touring Sports (5-Türer) Kombi | 2013-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Auris Touring Sports (5-Türer) Kombi | 2013-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Auris Touring Sports (5-Türer) Kombi E180 | 2013-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Auris Touring Sports (5-Türer) Kombi E180 Facelift | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Auris Touring Sports (5-Türer) Kombi | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Auris Touring Sports (5-Türer) Kombi | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Auris Touring Sports (5-Türer) Kombi | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Auris Touring Sports (5-Türer) Kombi | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Corolla Station Wagon (5-Türer) Kombi E210 Facelift | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Corolla Station Wagon (5-Türer) Kombi E210 Facelift | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Corolla Station Wagon (5-Türer) Kombi E210 Facelift | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Corolla Station Wagon (5-Türer) Kombi E210 Facelift | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "Corolla Station Wagon (5-Türer) Kombi E210 Facelift | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Corolla Station Wagon (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Corolla Station Wagon (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Corolla Station Wagon (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Corolla Station Wagon (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Corolla Station Wagon (5-Türer) Kombi E210 | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Corolla Station Wagon (5-Türer) Kombi E210 | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Corolla Station Wagon (5-Türer) Kombi E210 | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Corolla Station Wagon (5-Türer) Kombi E210 | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "Corolla Station Wagon (5-Türer) Kombi E210 | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "ProAce City Verso (5-Türer) LCV 1st Generation Facelift | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "ProAce City Verso (5-Türer) LCV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "ProAce City Verso (5-Türer) LCV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "ProAce City Verso (5-Türer) LCV | 2019-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "ProAce City Verso (5-Türer) LCV | 2019-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "ProAce City Verso (5-Türer) LCV | 2019-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "ProAce City Verso (5-Türer) LCV | 2019-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "ProAce City Verso (5-Türer) LCV | 2019-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "ProAce City Verso (5-Türer) LCV 1st Generation | 2019-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Yaris Cross (5-Türer) SUV | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Yaris Cross (5-Türer) SUV | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Yaris Cross (5-Türer) SUV | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Yaris Cross (5-Türer) SUV XP210 | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Yaris Cross (5-Türer) SUV XP210 1st Facelift | 2024-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Yaris Cross (5-Türer) SUV | 2024-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "Yaris Cross (5-Türer) SUV | 2024-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Edge (5-Türer) SUV | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Edge (5-Türer) SUV | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Edge (5-Türer) SUV | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Edge (5-Türer) SUV | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Edge (5-Türer) SUV | 2019-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Edge (5-Türer) SUV | 2019-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Edge (5-Türer) SUV | 2019-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Edge (5-Türer) SUV | 2019-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Edge (5-Türer) SUV | 2019-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Edge (5-Türer) SUV | 2019-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Escape (5-Türer) SUV | 2020-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Escape (5-Türer) SUV | 2020-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Escape (5-Türer) SUV | 2020-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Escape (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Escape (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Escape (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Escape (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Explorer (5-Türer) SUV | 2016-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Explorer (5-Türer) SUV | 2016-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Explorer (5-Türer) SUV | 2018-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Explorer (5-Türer) SUV | 2018-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Fiesta Active (HJ) (5-Türer) Crossover | 2017-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Fiesta Active (HJ) (5-Türer) Crossover | 2017-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Fiesta Active (HJ) (5-Türer) Crossover | 2017-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Fiesta Active (HJ) (5-Türer) Crossover | 2017-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Fiesta Active (HJ) (5-Türer) Crossover | 2017-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Fiesta Active (HJ) (5-Türer) Crossover HF/HG/HJ | 2017-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Fiesta Active (HJ) (5-Türer) Crossover HF/HG/HJ Facelift | 2022-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Fiesta Active (HJ) (5-Türer) Crossover | 2022-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Focus Active (HP) (5-Türer) Schrägheck | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Focus Active (HP) (5-Türer) Schrägheck | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Focus Active (HP) (5-Türer) Schrägheck | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Focus Active (HP) (5-Türer) Schrägheck | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Focus Active (HP) (5-Türer) Schrägheck | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Focus Active (HN) (5-Türer) Schrägheck | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Focus Active (HN) (5-Türer) Schrägheck | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Focus Active (HN) (5-Türer) Schrägheck | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Focus Active (HN) (5-Türer) Schrägheck | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Focus Active (HN) (5-Türer) Schrägheck | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Focus Active Combi (HP) (5-Türer) Kombi HM/HN/HP Facelift | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Focus Active Combi (HP) (5-Türer) Kombi | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Focus Active Combi (HP) (5-Türer) Kombi | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Focus Active Combi (HP) (5-Türer) Kombi | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Focus Active Combi (HP) (5-Türer) Kombi | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Focus Active Combi (HP) (5-Türer) Kombi | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Focus Active Combi (HP) (5-Türer) Kombi | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Focus Active Combi (HP) (5-Türer) Kombi | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Focus Active Combi (HP) (5-Türer) Kombi | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Focus Active Combi (HP) (5-Türer) Kombi HM/HN/HP | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Focus Combi (C6) (5-Türer) Kombi | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Focus Combi (C6) (5-Türer) Kombi | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Focus Combi (C6) (5-Türer) Kombi | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Focus Combi (C6) (5-Türer) Kombi | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Focus Combi (BL) (5-Türer) Kombi | 2011-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Focus Combi (BL) (5-Türer) Kombi | 2011-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Focus Combi (BL) (5-Türer) Kombi | 2011-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Focus Combi (BL) (5-Türer) Kombi | 2011-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Focus Combi (BL) (5-Türer) Kombi | 2011-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Focus Combi (HN) (5-Türer) Kombi | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Focus Combi (HN) (5-Türer) Kombi | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Focus Combi (HN) (5-Türer) Kombi | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Focus Combi (HN) (5-Türer) Kombi | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Focus Combi (HN) (5-Türer) Kombi | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Focus Combi (HP) (5-Türer) Kombi | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Focus Combi (HP) (5-Türer) Kombi | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Focus Combi (HP) (5-Türer) Kombi | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Focus Combi (HP) (5-Türer) Kombi | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Focus Combi (HP) (5-Türer) Kombi | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Galaxy (5-Türer) MPV CK | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Galaxy (5-Türer) MPV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Galaxy (5-Türer) MPV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Galaxy (5-Türer) MPV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Galaxy (5-Türer) MPV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Galaxy (5-Türer) MPV CK | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Galaxy (5-Türer) MPV CK Facelift | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Galaxy (5-Türer) MPV | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Galaxy (5-Türer) MPV | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Galaxy (5-Türer) MPV | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "Galaxy (5-Türer) MPV WA6 Facelift | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Galaxy (5-Türer) MPV | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Galaxy (5-Türer) MPV | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Galaxy (5-Türer) MPV | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Galaxy (5-Türer) MPV | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Galaxy (5-Türer) MPV WA6 Facelift | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Kuga (5-Türer) SUV MF Facelift | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Kuga (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Kuga (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Kuga (5-Türer) SUV MF | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Kuga (5-Türer) SUV | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Kuga (5-Türer) SUV | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Kuga (5-Türer) SUV | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Kuga (5-Türer) SUV MF | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Mondeo Combi (BG) (5-Türer) Kombi BD/BE/BG Facelift | 2011-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Mondeo Combi (BG) (5-Türer) Kombi | 2011-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Mondeo Combi (BG) (5-Türer) Kombi | 2011-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Mondeo Combi (BG) (5-Türer) Kombi | 2011-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Mondeo Combi (BG) (5-Türer) Kombi | 2011-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "Mondeo Combi (BG) (5-Türer) Kombi | 2007-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2008,
    "Mo": "Mondeo Combi (BG) (5-Türer) Kombi | 2007-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "Mondeo Combi (BG) (5-Türer) Kombi | 2007-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "Mondeo Combi (BG) (5-Türer) Kombi | 2007-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Mondeo Combi (BG) (5-Türer) Kombi BD/BE/BG | 2007-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Mondeo Combi (CF) (5-Türer) Kombi | 2014-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Mondeo Combi (CF) (5-Türer) Kombi | 2014-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Mondeo Combi (CF) (5-Türer) Kombi | 2014-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Mondeo Combi (CF) (5-Türer) Kombi | 2014-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Mondeo Combi (CF) (5-Türer) Kombi | 2014-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Mondeo Combi (CF) (5-Türer) Kombi CD/CE/CF | 2014-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Mondeo Combi (CF) (5-Türer) Kombi CD/CE/CF Facelift | 2019-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Mondeo Combi (CF) (5-Türer) Kombi | 2019-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Mondeo Combi (CF) (5-Türer) Kombi | 2019-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Mondeo Combi (CF) (5-Türer) Kombi | 2019-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Puma (5-Türer) SUV K2 Facelift | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Puma (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Puma (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Puma (5-Türer) SUV | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Puma (5-Türer) SUV | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Puma (5-Türer) SUV | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Puma (5-Türer) SUV | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Puma (5-Türer) SUV K2 | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "S-Max (5-Türer) MPV CJ | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "S-Max (5-Türer) MPV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "S-Max (5-Türer) MPV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "S-Max (5-Türer) MPV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "S-Max (5-Türer) MPV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "S-Max (5-Türer) MPV CJ | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "S-Max (5-Türer) MPV CJ Facelift | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "S-Max (5-Türer) MPV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "S-Max (5-Türer) MPV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "S-Max (5-Türer) MPV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "S-Max (5-Türer) MPV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "S-Max (5-Türer) MPV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "S-Max (5-Türer) MPV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Grand Tourneo Connect (5-Türer) LCV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Grand Tourneo Connect (5-Türer) LCV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Grand Tourneo Connect (5-Türer) LCV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Grand Tourneo Connect (5-Türer) LCV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Grand Tourneo Connect (5-Türer) LCV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Grand Tourneo Connect (5-Türer) LCV 2nd Generation | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Grand Tourneo Connect (5-Türer) LCV 2nd Generation Facelift | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Grand Tourneo Connect (5-Türer) LCV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Grand Tourneo Connect (5-Türer) LCV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Grand Tourneo Connect (5-Türer) LCV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Grand Tourneo Connect (5-Türer) LCV 2nd Generation Facelift | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Tourneo Connect (5-Türer) LCV 2nd Generation Facelift | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Tourneo Connect (5-Türer) LCV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Tourneo Connect (5-Türer) LCV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Tourneo Connect (5-Türer) LCV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Tourneo Connect (5-Türer) LCV 2nd Generation Facelift | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Tourneo Connect (5-Türer) LCV 2nd Generation | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Tourneo Connect (5-Türer) LCV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Tourneo Connect (5-Türer) LCV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Tourneo Connect (5-Türer) LCV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Tourneo Connect (5-Türer) LCV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Tourneo Connect (5-Türer) LCV 2nd Generation | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "C-Class All-Terrain (5-Türer) Crossover | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "C-Class All-Terrain (5-Türer) Crossover | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "C-Class All-Terrain (5-Türer) Crossover | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "C-Class All-Terrain (5-Türer) Crossover | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "C-Class All-Terrain (5-Türer) Crossover | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "C-Class All-Terrain (5-Türer) Crossover | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "C-Class T-Modell (S205) (5-Türer) Kombi | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "C-Class T-Modell (S205) (5-Türer) Kombi | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "C-Class T-Modell (S205) (5-Türer) Kombi | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "C-Class T-Modell (S205) (5-Türer) Kombi | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "C-Class T-Modell (S205) (5-Türer) Kombi W205 | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "C-Class T-Modell (S205) (5-Türer) Kombi W205 Facelift | 2019-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "C-Class T-Modell (S205) (5-Türer) Kombi | 2019-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "C-Class T-Modell (S205) (5-Türer) Kombi | 2019-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "C-Class T-Modell (S206) (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "C-Class T-Modell (S206) (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "C-Class T-Modell (S206) (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "C-Class T-Modell (S206) (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "C-Class T-Modell (S206) (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "C-Class T-Modell (S206) (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "E-Class All-Terrain (S214) (5-Türer) Crossover | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "E-Class All-Terrain (S214) (5-Türer) Crossover | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "E-Class All-Terrain (S214) (5-Türer) Crossover | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "E-Class All-Terrain (X213) (5-Türer) Crossover W213 Facelift | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "E-Class All-Terrain (X213) (5-Türer) Crossover | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "E-Class All-Terrain (X213) (5-Türer) Crossover | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "E-Class All-Terrain (X213) (5-Türer) Crossover | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "E-Class All-Terrain (X213) (5-Türer) Crossover | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "E-Class All-Terrain (X213) (5-Türer) Crossover | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "E-Class All-Terrain (X213) (5-Türer) Crossover | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "E-Class All-Terrain (X213) (5-Türer) Crossover W213 | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "E-Class T-Modell (S213) (5-Türer) Kombi W213 Facelift | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "E-Class T-Modell (S213) (5-Türer) Kombi | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "E-Class T-Modell (S213) (5-Türer) Kombi | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "E-Class T-Modell (S213) (5-Türer) Kombi | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "E-Class T-Modell (S213) (5-Türer) Kombi | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "E-Class T-Modell (S213) (5-Türer) Kombi | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "E-Class T-Modell (S213) (5-Türer) Kombi | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "E-Class T-Modell (S213) (5-Türer) Kombi W213 | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "E-Class T-Modell (S214) (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "E-Class T-Modell (S214) (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "E-Class T-Modell (S214) (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "EQA (5-Türer) SUV H243 Facelift | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "EQA (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "EQA (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "EQA (5-Türer) SUV | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "EQA (5-Türer) SUV | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "EQA (5-Türer) SUV | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "EQA (5-Türer) SUV H243 | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "GLA (H247) (5-Türer) SUV H247 Facelift | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "GLA (H247) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "GLA (H247) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "GLA (H247) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "GLA (H247) (5-Türer) SUV | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "GLA (H247) (5-Türer) SUV | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "GLA (H247) (5-Türer) SUV | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "GLA (H247) (5-Türer) SUV H247 | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "GLA (X156) (5-Türer) SUV | 2014-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "GLA (X156) (5-Türer) SUV | 2014-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "GLA (X156) (5-Türer) SUV | 2014-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "GLA (X156) (5-Türer) SUV | 2014-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "GLA (5-Türer) SUV | 2018-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "GLA (5-Türer) SUV | 2018-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "GLA (5-Türer) SUV | 2018-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "GLC (X253) (5-Türer) SUV X253 Facelift | 2019-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "GLC (X253) (5-Türer) SUV | 2019-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "GLC (X253) (5-Türer) SUV | 2019-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "GLC (X253) (5-Türer) SUV | 2019-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "GLC (X253) (5-Türer) SUV | 2019-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "GLC (X253) (5-Türer) SUV | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "GLC (X253) (5-Türer) SUV | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "GLC (X253) (5-Türer) SUV | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "GLC (X253) (5-Türer) SUV X253 | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "GLC (X254) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "GLC (X254) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "GLC (X254) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "GLC (X254) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Ampera-e (5-Türer) Schrägheck | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Ampera-e (5-Türer) Schrägheck | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Ampera-e (5-Türer) Schrägheck | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Ampera-e (5-Türer) Schrägheck | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Ampera-e (5-Türer) Schrägheck | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Ampera-e (5-Türer) Schrägheck | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Ampera-e (5-Türer) Schrägheck | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Ampera-e (5-Türer) Schrägheck | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Ampera-e (5-Türer) Schrägheck | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2026,
    "Mo": "Ampera-e (5-Türer) Schrägheck | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2004,
    "Mo": "Astra Wagon (5-Türer) Kombi | 2004-2007",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2005,
    "Mo": "Astra Wagon (5-Türer) Kombi | 2004-2007",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2006,
    "Mo": "Astra Wagon (5-Türer) Kombi | 2004-2007",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2007,
    "Mo": "Astra Wagon (5-Türer) Kombi H | 2004-2007",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2007,
    "Mo": "Astra Wagon (5-Türer) Kombi H Facelift | 2007-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2008,
    "Mo": "Astra Wagon (5-Türer) Kombi | 2007-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2009,
    "Mo": "Astra Wagon (5-Türer) Kombi | 2007-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2010,
    "Mo": "Astra Wagon (5-Türer) Kombi | 2007-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2011,
    "Mo": "Astra Wagon (5-Türer) Kombi H Facelift | 2007-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2012,
    "Mo": "Astra Wagon (5-Türer) Kombi H Facelift | 2007-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2011,
    "Mo": "Astra Wagon (5-Türer) Kombi J | 2011-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2012,
    "Mo": "Astra Wagon (5-Türer) Kombi J | 2011-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2013,
    "Mo": "Astra Wagon (5-Türer) Kombi | 2013-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2014,
    "Mo": "Astra Wagon (5-Türer) Kombi | 2013-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2015,
    "Mo": "Astra Wagon (5-Türer) Kombi | 2013-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2016,
    "Mo": "Astra Wagon (5-Türer) Kombi J Facelift | 2013-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2011,
    "Mo": "Astra Wagon (5-Türer) Kombi J | 2011-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2012,
    "Mo": "Astra Wagon (5-Türer) Kombi J | 2011-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Astra Wagon (5-Türer) Kombi L | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Astra Wagon (5-Türer) Kombi | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Astra Wagon (5-Türer) Kombi | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Astra Wagon (5-Türer) Kombi | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2026,
    "Mo": "Astra Wagon (5-Türer) Kombi | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Combo (5-Türer) LCV E | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Combo (5-Türer) LCV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Combo (5-Türer) LCV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Combo (5-Türer) LCV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Combo (5-Türer) LCV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Combo (5-Türer) LCV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Combo (5-Türer) LCV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Crossland (5-Türer) Crossover | 2017-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Crossland (5-Türer) Crossover | 2017-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Crossland (5-Türer) Crossover | 2017-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Crossland (5-Türer) Crossover | 2017-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Crossland (5-Türer) Crossover 1st Generation | 2017-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Crossland (5-Türer) Crossover 1st Generation | 2017-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Crossland (5-Türer) Crossover 1st Generation Facelift | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Crossland (5-Türer) Crossover 1st Generation Facelift | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Crossland (5-Türer) Crossover | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Crossland (5-Türer) Crossover | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Crossland (5-Türer) Crossover | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2026,
    "Mo": "Crossland (5-Türer) Crossover | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Frontera (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2026,
    "Mo": "Frontera (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Grandland X (5-Türer) Crossover | 2022-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Grandland X (5-Türer) Crossover | 2022-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Grandland X (5-Türer) Crossover 1st Generation Facelift | 2022-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Grandland X (5-Türer) Crossover | 2018-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Grandland X (5-Türer) Crossover | 2018-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Grandland X (5-Türer) Crossover | 2018-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Grandland X (5-Türer) Crossover | 2018-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2009,
    "Mo": "Insignia Sports Tourer (5-Türer) Kombi | 2009-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2010,
    "Mo": "Insignia Sports Tourer (5-Türer) Kombi | 2009-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2011,
    "Mo": "Insignia Sports Tourer (5-Türer) Kombi | 2009-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2012,
    "Mo": "Insignia Sports Tourer (5-Türer) Kombi | 2009-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2013,
    "Mo": "Insignia Sports Tourer (5-Türer) Kombi | 2009-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Insignia Sports Tourer (5-Türer) Kombi B | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Insignia Sports Tourer (5-Türer) Kombi | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Insignia Sports Tourer (5-Türer) Kombi | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Insignia Sports Tourer (5-Türer) Kombi B | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Insignia Sports Tourer (5-Türer) Kombi B Facelift | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Insignia Sports Tourer (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Insignia Sports Tourer (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Insignia Sports Tourer (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Insignia Sports Tourer (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Insignia Sports Tourer (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2026,
    "Mo": "Insignia Sports Tourer (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2014,
    "Mo": "Insignia Sports Tourer (5-Türer) Kombi | 2014-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2015,
    "Mo": "Insignia Sports Tourer (5-Türer) Kombi | 2014-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2016,
    "Mo": "Insignia Sports Tourer (5-Türer) Kombi | 2014-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Insignia Sports Tourer (5-Türer) Kombi A Facelift | 2014-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Mokka (5-Türer) SUV | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Mokka (5-Türer) SUV | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Mokka (5-Türer) SUV | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Mokka (5-Türer) SUV | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2013,
    "Mo": "Mokka (5-Türer) SUV | 2013-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2014,
    "Mo": "Mokka (5-Türer) SUV | 2013-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2015,
    "Mo": "Mokka (5-Türer) SUV | 2013-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2016,
    "Mo": "Mokka (5-Türer) SUV | 2013-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2003,
    "Mo": "Vectra Caravan (5-Türer) Kombi | 2003-2005",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2004,
    "Mo": "Vectra Caravan (5-Türer) Kombi | 2003-2005",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2005,
    "Mo": "Vectra Caravan (5-Türer) Kombi | 2003-2005",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2006,
    "Mo": "Vectra Caravan (5-Türer) Kombi | 2006-2008",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2007,
    "Mo": "Vectra Caravan (5-Türer) Kombi | 2006-2008",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2008,
    "Mo": "Vectra Caravan (5-Türer) Kombi | 2006-2008",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2006,
    "Mo": "Zafira (5-Türer) MPV | 2006-2008",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2007,
    "Mo": "Zafira (5-Türer) MPV | 2006-2008",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2008,
    "Mo": "Zafira (5-Türer) MPV B | 2006-2008",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2008,
    "Mo": "Zafira (5-Türer) MPV B Facelift | 2008-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2009,
    "Mo": "Zafira (5-Türer) MPV | 2008-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2010,
    "Mo": "Zafira (5-Türer) MPV | 2008-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2011,
    "Mo": "Zafira (5-Türer) MPV | 2008-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2012,
    "Mo": "Zafira (5-Türer) MPV B Facelift | 2008-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2013,
    "Mo": "Zafira (5-Türer) MPV B Facelift | 2008-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2014,
    "Mo": "Zafira (5-Türer) MPV B Facelift | 2008-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2012,
    "Mo": "Zafira (5-Türer) MPV C | 2012-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2013,
    "Mo": "Zafira (5-Türer) MPV C | 2012-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2014,
    "Mo": "Zafira (5-Türer) MPV C | 2012-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2015,
    "Mo": "Zafira (5-Türer) MPV | 2012-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2016,
    "Mo": "Zafira (5-Türer) MPV | 2012-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Zafira (5-Türer) MPV | 2017-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Zafira (5-Türer) MPV | 2017-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Zafira (5-Türer) MPV | 2017-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2012,
    "Mo": "Zafira (5-Türer) MPV C | 2012-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2013,
    "Mo": "Zafira (5-Türer) MPV C | 2012-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2014,
    "Mo": "Zafira (5-Türer) MPV C | 2012-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2015,
    "Mo": "Zafira (5-Türer) MPV | 2012-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2016,
    "Mo": "Zafira (5-Türer) MPV | 2012-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "2008 (5-Türer) Kombi P24 Facelift | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "2008 (5-Türer) Kombi | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "2008 (5-Türer) Kombi | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2026,
    "Mo": "2008 (5-Türer) Kombi | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "2008 (5-Türer) Kombi P24 | 2019-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "2008 (5-Türer) Kombi P24 | 2019-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "2008 (5-Türer) Kombi | 2019-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "2008 (5-Türer) Kombi | 2019-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "2008 (5-Türer) Kombi P24 | 2019-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "3008 SUV (5-Türer) SUV P84 Facelift | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "3008 SUV (5-Türer) SUV | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "3008 SUV (5-Türer) SUV | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "3008 SUV (5-Türer) SUV | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "3008 SUV (5-Türer) SUV P84 Facelift | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "3008 SUV (5-Türer) SUV | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "3008 SUV (5-Türer) SUV | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "3008 SUV (5-Türer) SUV | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "3008 SUV (5-Türer) SUV | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "3008 SUV (5-Türer) SUV P84 | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "308 SW (5-Türer) Kombi P5 | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "308 SW (5-Türer) Kombi P5 | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "308 SW (5-Türer) Kombi | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "308 SW (5-Türer) Kombi | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "308 SW (5-Türer) Kombi P5 | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "308 SW (5-Türer) Kombi P5 Facelift | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2026,
    "Mo": "308 SW (5-Türer) Kombi | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "308 SW (5-Türer) Kombi T9 Facelift | 2017-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "308 SW (5-Türer) Kombi T9 Facelift | 2017-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "308 SW (5-Türer) Kombi | 2017-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "308 SW (5-Türer) Kombi | 2017-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "308 SW (5-Türer) Kombi T9 Facelift | 2017-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "308 SW (5-Türer) Kombi T9 Facelift | 2017-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "308 SW (5-Türer) Kombi | 2014-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "308 SW (5-Türer) Kombi | 2014-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "308 SW (5-Türer) Kombi | 2014-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "308 SW (5-Türer) Kombi T9 | 2014-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "308 SW (5-Türer) Kombi T9 | 2014-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "4008 (5-Türer) SUV | 2012-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "4008 (5-Türer) SUV | 2012-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "4008 (5-Türer) SUV | 2012-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "4008 (5-Türer) SUV | 2012-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "4008 (5-Türer) SUV | 2012-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "4008 (5-Türer) SUV | 2012-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "5008 SUV (5-Türer) SUV 3rd Generation | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "5008 SUV (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2026,
    "Mo": "5008 SUV (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "5008 SUV (5-Türer) SUV T87 Facelift | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "5008 SUV (5-Türer) SUV | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "5008 SUV (5-Türer) SUV | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "5008 SUV (5-Türer) SUV | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "5008 SUV (5-Türer) SUV T87 Facelift | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "5008 SUV (5-Türer) SUV | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "5008 SUV (5-Türer) SUV | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "5008 SUV (5-Türer) SUV | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "5008 SUV (5-Türer) SUV | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "5008 SUV (5-Türer) SUV T87 | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "5008 SUV 7-Seater (5-Türer) SUV | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "5008 SUV 7-Seater (5-Türer) SUV | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "5008 SUV 7-Seater (5-Türer) SUV | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "5008 SUV 7-Seater (5-Türer) SUV | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "508 SW (5-Türer) Kombi 2nd Generation Facelift | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "508 SW (5-Türer) Kombi | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "508 SW (5-Türer) Kombi | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2026,
    "Mo": "508 SW (5-Türer) Kombi | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "508 SW (5-Türer) Kombi | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "508 SW (5-Türer) Kombi | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "508 SW (5-Türer) Kombi | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "508 SW (5-Türer) Kombi | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "508 SW (5-Türer) Kombi | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "508 SW (5-Türer) Kombi 2nd Generation | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "508 SW (8E Phase I) (5-Türer) Kombi 1st Generation Facelift | 2014-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "508 SW (8E Phase I) (5-Türer) Kombi | 2014-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "508 SW (8E Phase I) (5-Türer) Kombi | 2014-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "508 SW (8E Phase I) (5-Türer) Kombi | 2014-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "508 SW (8E Phase I) (5-Türer) Kombi | 2014-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2010,
    "Mo": "508 SW (8E Phase I) (5-Türer) Kombi | 2010-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "508 SW (8E Phase I) (5-Türer) Kombi | 2010-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "508 SW (8E Phase I) (5-Türer) Kombi | 2010-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "508 SW (8E Phase I) (5-Türer) Kombi | 2010-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "508 SW (8E Phase I) (5-Türer) Kombi 1st Generation | 2010-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "Rifter (5-Türer) MPV 1st Generation Facelift | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "Rifter (5-Türer) MPV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2026,
    "Mo": "Rifter (5-Türer) MPV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "Rifter (5-Türer) MPV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "Rifter (5-Türer) MPV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "Rifter (5-Türer) MPV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "Rifter (5-Türer) MPV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "Rifter (5-Türer) MPV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "Rifter (5-Türer) MPV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "Rifter (5-Türer) MPV 1st Generation | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "Ariya (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Ariya (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Ariya (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Ariya (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Ariya (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2026,
    "Mo": "Ariya (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2026,
    "Mo": "Leaf SUV (5-Türer) SUV | 2026-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "Qashqai (5-Türer) SUV J12 | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Qashqai (5-Türer) SUV | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Qashqai (5-Türer) SUV | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Qashqai (5-Türer) SUV J12 | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Qashqai (5-Türer) SUV J12 Facelift | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Qashqai (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2026,
    "Mo": "Qashqai (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2026,
    "Mo": "X-Trail (5-Türer) SUV T33 Facelift | 2026-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "X-Trail (5-Türer) SUV T33 | 2021-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "X-Trail (5-Türer) SUV | 2021-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "X-Trail (5-Türer) SUV | 2021-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "X-Trail (5-Türer) SUV | 2021-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "X-Trail (5-Türer) SUV | 2021-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2026,
    "Mo": "X-Trail (5-Türer) SUV T33 | 2021-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2025,
    "Mo": "Elroq (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2026,
    "Mo": "Elroq (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2021,
    "Mo": "Enyaq iV (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2022,
    "Mo": "Enyaq iV (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2023,
    "Mo": "Enyaq iV (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2024,
    "Mo": "Enyaq iV (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2025,
    "Mo": "Enyaq iV (5-Türer) SUV 1st Generation | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2025,
    "Mo": "Enyaq iV (5-Türer) SUV 1st Generation Facelift | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2026,
    "Mo": "Enyaq iV (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2024,
    "Mo": "Kodiaq (5-Türer) SUV 2nd Generation | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2025,
    "Mo": "Kodiaq (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2026,
    "Mo": "Kodiaq (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2024,
    "Mo": "Kodiaq 7-Seater (5-Türer) SUV 2nd Generation | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2025,
    "Mo": "Kodiaq 7-Seater (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2026,
    "Mo": "Kodiaq 7-Seater (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2024,
    "Mo": "Octavia Combi (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2025,
    "Mo": "Octavia Combi (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2026,
    "Mo": "Octavia Combi (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2020,
    "Mo": "Octavia Combi (NX5) (5-Türer) Kombi | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2021,
    "Mo": "Octavia Combi (NX5) (5-Türer) Kombi | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2022,
    "Mo": "Octavia Combi (NX5) (5-Türer) Kombi | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2023,
    "Mo": "Octavia Combi (NX5) (5-Türer) Kombi | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2024,
    "Mo": "Octavia Combi (NX5) (5-Türer) Kombi | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2024,
    "Mo": "Superb Combi (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2025,
    "Mo": "Superb Combi (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2026,
    "Mo": "Superb Combi (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Austral (5-Türer) SUV 1st Generation Facelift | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2026,
    "Mo": "Austral (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Austral (5-Türer) SUV | 2023-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Austral (5-Türer) SUV | 2023-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Austral (5-Türer) SUV 1st Generation | 2023-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Captur (5-Türer) SUV 2nd Generation | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Captur (5-Türer) SUV 2nd Generation | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Captur (5-Türer) SUV | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Captur (5-Türer) SUV | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Captur (5-Türer) SUV 2nd Generation | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Captur (5-Türer) SUV 2nd Generation Facelift | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Captur (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2026,
    "Mo": "Captur (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2010,
    "Mo": "Clio Hatchback (BR Phase II) (5-Türer) Schrägheck | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2011,
    "Mo": "Clio Hatchback (BR Phase II) (5-Türer) Schrägheck | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2012,
    "Mo": "Clio Hatchback (BR Phase II) (5-Türer) Schrägheck | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Clio Hatchback (BR Phase II) (5-Türer) Schrägheck | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Clio Hatchback (BR Phase II) (5-Türer) Schrägheck | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Clio Hatchback (BR Phase II) (5-Türer) Schrägheck | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2006,
    "Mo": "Clio Hatchback (BB Phase IV) (5-Türer) Schrägheck | 2006-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2007,
    "Mo": "Clio Hatchback (BB Phase IV) (5-Türer) Schrägheck | 2006-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2008,
    "Mo": "Clio Hatchback (BB Phase IV) (5-Türer) Schrägheck | 2006-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2009,
    "Mo": "Clio Hatchback (BB Phase IV) (5-Türer) Schrägheck | 2006-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2009,
    "Mo": "Clio Hatchback (BB Phase V) (5-Türer) Schrägheck | 2009-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2010,
    "Mo": "Clio Hatchback (BB Phase V) (5-Türer) Schrägheck | 2009-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2011,
    "Mo": "Clio Hatchback (BB Phase V) (5-Türer) Schrägheck | 2009-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2012,
    "Mo": "Clio Hatchback (BB Phase V) (5-Türer) Schrägheck | 2009-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2006,
    "Mo": "Clio Hatchback (BR Phase I) (5-Türer) Schrägheck | 2006-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2007,
    "Mo": "Clio Hatchback (BR Phase I) (5-Türer) Schrägheck | 2006-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2008,
    "Mo": "Clio Hatchback (BR Phase I) (5-Türer) Schrägheck | 2006-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2009,
    "Mo": "Clio Hatchback (BR Phase I) (5-Türer) Schrägheck | 2006-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Duster (5-Türer) SUV | 2018-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Duster (5-Türer) SUV | 2018-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Duster (5-Türer) SUV | 2018-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Duster (5-Türer) SUV | 2018-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Duster (5-Türer) SUV | 2018-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Duster (5-Türer) SUV | 2018-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Duster (5-Türer) SUV | 2018-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Duster (5-Türer) SUV | 2018-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Espace SUV (5-Türer) SUV 6th Generation Facelift | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2026,
    "Mo": "Espace SUV (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Espace SUV (5-Türer) SUV | 2023-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Espace SUV (5-Türer) SUV | 2023-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Espace SUV (5-Türer) SUV 6th Generation | 2023-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Kadjar (5-Türer) SUV | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Kadjar (5-Türer) SUV | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Kadjar (5-Türer) SUV | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Kadjar (5-Türer) SUV | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Kadjar (5-Türer) SUV 1st Generation | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Kadjar (5-Türer) SUV 1st Generation Facelift | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Kadjar (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Kadjar (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Kadjar (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Kadjar (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Kadjar (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Kadjar (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2026,
    "Mo": "Kadjar (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Koleos (5-Türer) SUV | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Koleos (5-Türer) SUV | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Koleos (5-Türer) SUV | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Koleos (5-Türer) SUV 2nd Generation | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Koleos (5-Türer) SUV 2nd Generation Facelift | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Koleos (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Koleos (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Koleos (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Koleos (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Koleos (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Koleos (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2026,
    "Mo": "Koleos (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Mégane Grandtour (K9A I) (5-Türer) Kombi | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Mégane Grandtour (K9A I) (5-Türer) Kombi | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Mégane Grandtour (K9A I) (5-Türer) Kombi | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Mégane Grandtour (K9A I) (5-Türer) Kombi | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Mégane Grandtour (K9A I) (5-Türer) Kombi | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Mégane Grandtour (K9A II) (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Mégane Grandtour (K9A II) (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Mégane Grandtour (K9A II) (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Mégane Grandtour (K9A II) (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Mégane Grandtour (K9A II) (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Mégane Grandtour (K9A II) (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2026,
    "Mo": "Mégane Grandtour (K9A II) (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Grand Scénic (R9) (5-Türer) MPV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Grand Scénic (R9) (5-Türer) MPV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Grand Scénic (R9) (5-Türer) MPV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Grand Scénic (R9) (5-Türer) MPV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Grand Scénic (R9) (5-Türer) MPV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Grand Scénic (R9) (5-Türer) MPV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Grand Scénic (R9) (5-Türer) MPV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Grand Scénic (R9) (5-Türer) MPV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Grand Scénic (R9) (5-Türer) MPV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2026,
    "Mo": "Grand Scénic (R9) (5-Türer) MPV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Scenic E-Tech (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Scenic E-Tech (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2026,
    "Mo": "Scenic E-Tech (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Talisman Grandtour (5-Türer) Kombi | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Talisman Grandtour (5-Türer) Kombi | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Talisman Grandtour (5-Türer) Kombi | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Talisman Grandtour (5-Türer) Kombi | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Talisman Grandtour (5-Türer) Kombi 1st Generation | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Talisman Grandtour (5-Türer) Kombi 1st Generation Facelift | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Talisman Grandtour (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Talisman Grandtour (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Talisman Grandtour (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Talisman Grandtour (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Talisman Grandtour (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2026,
    "Mo": "Talisman Grandtour (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2019,
    "Mo": "CX-30 (5-Türer) Crossover | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2020,
    "Mo": "CX-30 (5-Türer) Crossover | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2021,
    "Mo": "CX-30 (5-Türer) Crossover | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "CX-30 (5-Türer) Crossover | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2023,
    "Mo": "CX-30 (5-Türer) Crossover | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "CX-30 (5-Türer) Crossover | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "CX-30 (5-Türer) Crossover | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2026,
    "Mo": "CX-30 (5-Türer) Crossover | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2017,
    "Mo": "CX-5 (5-Türer) SUV KF | 2017-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2018,
    "Mo": "CX-5 (5-Türer) SUV | 2017-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2019,
    "Mo": "CX-5 (5-Türer) SUV | 2017-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2020,
    "Mo": "CX-5 (5-Türer) SUV | 2017-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2021,
    "Mo": "CX-5 (5-Türer) SUV KF | 2017-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2021,
    "Mo": "CX-5 (5-Türer) SUV KF Facelift | 2021-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "CX-5 (5-Türer) SUV KF Facelift | 2021-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "CX-5 (5-Türer) SUV KF 2nd Facelift | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2023,
    "Mo": "CX-5 (5-Türer) SUV | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "CX-5 (5-Türer) SUV | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "CX-5 (5-Türer) SUV | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "CX-80 (5-Türer) SUV | 2024-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "CX-80 (5-Türer) SUV | 2024-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2026,
    "Mo": "CX-80 (5-Türer) SUV | 2026-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2016,
    "Mo": "CX-9 (5-Türer) SUV 2nd Generation | 2016-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2017,
    "Mo": "CX-9 (5-Türer) SUV | 2016-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2018,
    "Mo": "CX-9 (5-Türer) SUV | 2016-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2019,
    "Mo": "CX-9 (5-Türer) SUV | 2016-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2020,
    "Mo": "CX-9 (5-Türer) SUV | 2016-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2021,
    "Mo": "CX-9 (5-Türer) SUV | 2016-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "CX-9 (5-Türer) SUV | 2016-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2023,
    "Mo": "CX-9 (5-Türer) SUV | 2016-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2017,
    "Mo": "Carens (5-Türer) MPV | 2017-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Carens (5-Türer) MPV | 2017-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Carens (5-Türer) MPV | 2017-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2013,
    "Mo": "Carens (5-Türer) MPV | 2013-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2014,
    "Mo": "Carens (5-Türer) MPV | 2013-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2015,
    "Mo": "Carens (5-Türer) MPV | 2013-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2016,
    "Mo": "Carens (5-Türer) MPV | 2013-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Carnival (5-Türer) MPV | 2019-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Carnival (5-Türer) MPV | 2019-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Carnival (5-Türer) MPV | 2019-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2015,
    "Mo": "Carnival (5-Türer) MPV | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2016,
    "Mo": "Carnival (5-Türer) MPV | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2017,
    "Mo": "Carnival (5-Türer) MPV | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Carnival (5-Türer) MPV | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2012,
    "Mo": "Ceed Sportswagon (5-Türer) Kombi JD | 2012-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2013,
    "Mo": "Ceed Sportswagon (5-Türer) Kombi | 2012-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2014,
    "Mo": "Ceed Sportswagon (5-Türer) Kombi | 2012-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2015,
    "Mo": "Ceed Sportswagon (5-Türer) Kombi | 2012-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2016,
    "Mo": "Ceed Sportswagon (5-Türer) Kombi | 2016-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2017,
    "Mo": "Ceed Sportswagon (5-Türer) Kombi | 2016-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Ceed Sportswagon (5-Türer) Kombi | 2016-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Ceed Sportswagon (5-Türer) Kombi | 2019-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Ceed Sportswagon (5-Türer) Kombi | 2019-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Ceed Sportswagon (5-Türer) Kombi CD | 2019-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "Ceed Sportswagon (5-Türer) Kombi CD | 2019-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Ceed Sportswagon (5-Türer) Kombi CD Facelift | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "Ceed Sportswagon (5-Türer) Kombi CD Facelift | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "Ceed Sportswagon (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "Ceed Sportswagon (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Ceed Sportswagon (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2026,
    "Mo": "Ceed Sportswagon (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "XCeed (5-Türer) SUV CD Facelift | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "XCeed (5-Türer) SUV CD Facelift | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "XCeed (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "XCeed (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "XCeed (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2026,
    "Mo": "XCeed (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "XCeed (5-Türer) SUV | 2019-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "XCeed (5-Türer) SUV | 2019-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "XCeed (5-Türer) SUV CD | 2019-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "XCeed (5-Türer) SUV CD | 2019-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "EV3 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "EV3 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2026,
    "Mo": "EV3 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "EV5 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "EV5 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2026,
    "Mo": "EV5 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "EV9 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "EV9 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2026,
    "Mo": "EV9 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2017,
    "Mo": "Niro (5-Türer) SUV | 2017-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Niro (5-Türer) SUV | 2017-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Niro (5-Türer) SUV DE | 2017-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Niro (5-Türer) SUV DE Facelift | 2019-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Niro (5-Türer) SUV | 2019-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Niro (5-Türer) SUV | 2019-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "Niro (5-Türer) SUV | 2019-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2017,
    "Mo": "Optima Sport Wagon (5-Türer) Kombi | 2017-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Optima Sport Wagon (5-Türer) Kombi JF | 2017-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Optima Sport Wagon (5-Türer) Kombi JF Facelift | 2018-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Optima Sport Wagon (5-Türer) Kombi | 2018-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Optima Sport Wagon (5-Türer) Kombi | 2018-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Sorento (5-Türer) SUV MQ4 | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Sorento (5-Türer) SUV | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "Sorento (5-Türer) SUV | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "Sorento (5-Türer) SUV | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "Sorento (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Sorento (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2026,
    "Mo": "Sorento (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2015,
    "Mo": "Sorento (5-Türer) SUV UM | 2015-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2016,
    "Mo": "Sorento (5-Türer) SUV | 2015-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2017,
    "Mo": "Sorento (5-Türer) SUV | 2015-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Sorento (5-Türer) SUV | 2018-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Sorento (5-Türer) SUV | 2018-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Sorento (5-Türer) SUV UM Facelift | 2018-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "Sportage (5-Türer) Crossover | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "Sportage (5-Türer) Crossover | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "Sportage (5-Türer) Crossover | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Sportage (5-Türer) Crossover NQ5 | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Sportage (5-Türer) Crossover NQ5 Facelift | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2026,
    "Mo": "Sportage (5-Türer) Crossover | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2016,
    "Mo": "Sportage (5-Türer) Crossover | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2017,
    "Mo": "Sportage (5-Türer) Crossover | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Sportage (5-Türer) Crossover | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Sportage (5-Türer) Crossover QL | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Sportage (5-Türer) Crossover QL Facelift | 2019-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Sportage (5-Türer) Crossover | 2019-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Sportage (5-Türer) Crossover | 2019-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2014,
    "Mo": "Sportage (5-Türer) Crossover SL Facelift | 2014-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2015,
    "Mo": "Sportage (5-Türer) Crossover | 2014-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2011,
    "Mo": "Sportage (5-Türer) Crossover | 2011-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2012,
    "Mo": "Sportage (5-Türer) Crossover | 2011-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2013,
    "Mo": "Sportage (5-Türer) Crossover | 2011-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2014,
    "Mo": "Sportage (5-Türer) Crossover SL | 2011-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "Creta (5-Türer) SUV | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "Creta (5-Türer) SUV | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "Creta (5-Türer) SUV 1st Generation | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "Creta (5-Türer) SUV 1st Generation | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "Creta (5-Türer) SUV 1st Generation | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "Creta (5-Türer) SUV 1st Generation Facelift | 2018-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "Creta (5-Türer) SUV 1st Generation Facelift | 2018-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "Creta (5-Türer) SUV 1st Generation Facelift | 2018-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "Creta (5-Türer) SUV | 2018-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "i30 Kombi (5-Türer) Kombi PD | 2017-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "i30 Kombi (5-Türer) Kombi | 2017-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "i30 Kombi (5-Türer) Kombi PD | 2017-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "i30 Kombi (5-Türer) Kombi PD 2nd Facelift | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "i30 Kombi (5-Türer) Kombi | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "i30 Kombi (5-Türer) Kombi | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "i30 Kombi (5-Türer) Kombi | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "i30 Kombi (5-Türer) Kombi PD 2nd Facelift | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "i30 Kombi (5-Türer) Kombi PD 3rd Facelift | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "i30 Kombi (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2026,
    "Mo": "i30 Kombi (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "i30 Kombi (5-Türer) Kombi PD 1st Facelift | 2019-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "i30 Kombi (5-Türer) Kombi PD 1st Facelift | 2019-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "Ioniq 9 (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2026,
    "Mo": "Ioniq 9 (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2010,
    "Mo": "ix35 (5-Türer) SUV | 2010-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2011,
    "Mo": "ix35 (5-Türer) SUV | 2010-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2012,
    "Mo": "ix35 (5-Türer) SUV | 2010-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2013,
    "Mo": "ix35 (5-Türer) SUV | 2010-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "Kona (5-Türer) SUV | 2018-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "Kona (5-Türer) SUV | 2018-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "Kona (5-Türer) SUV | 2018-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "Kona (5-Türer) SUV OS | 2018-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "Kona (5-Türer) SUV OS Facelift | 2021-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "Kona (5-Türer) SUV | 2021-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "Kona (5-Türer) SUV OS Facelift | 2021-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2013,
    "Mo": "Grand Santa Fe (5-Türer) SUV | 2013-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2014,
    "Mo": "Grand Santa Fe (5-Türer) SUV | 2013-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "Grand Santa Fe (5-Türer) SUV | 2013-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "Grand Santa Fe (5-Türer) SUV | 2016-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "Grand Santa Fe (5-Türer) SUV | 2016-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "Grand Santa Fe (5-Türer) SUV | 2016-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "Santa Fe (5-Türer) SUV | 2016-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "Santa Fe (5-Türer) SUV | 2016-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "Santa Fe (5-Türer) SUV | 2016-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2013,
    "Mo": "Santa Fe (5-Türer) SUV | 2013-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2014,
    "Mo": "Santa Fe (5-Türer) SUV | 2013-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "Santa Fe (5-Türer) SUV | 2013-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "Santa Fe (5-Türer) SUV | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "Santa Fe (5-Türer) SUV | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "Santa Fe (5-Türer) SUV | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "Santa Fe (5-Türer) SUV TM Facelift | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "Santa Fe (5-Türer) SUV | 2019-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "Santa Fe (5-Türer) SUV | 2019-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "Tucson (5-Türer) Kombi NX Facelift | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "Tucson (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2026,
    "Mo": "Tucson (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "Tucson (5-Türer) Kombi | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "Tucson (5-Türer) Kombi | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "Tucson (5-Türer) Kombi | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "Tucson (5-Türer) Kombi NX | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "Tucson (5-Türer) Kombi | 2019-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "Tucson (5-Türer) Kombi | 2019-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "Tucson (5-Türer) Kombi | 2016-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "Tucson (5-Türer) Kombi | 2016-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "Tucson (5-Türer) Kombi | 2016-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2005,
    "Mo": "Grand Vitara (3-Türer) SUV | 2005-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2006,
    "Mo": "Grand Vitara (3-Türer) SUV | 2005-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2007,
    "Mo": "Grand Vitara (3-Türer) SUV | 2005-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2008,
    "Mo": "Grand Vitara (3-Türer) SUV | 2005-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2009,
    "Mo": "Grand Vitara (3-Türer) SUV JT | 2005-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2009,
    "Mo": "Grand Vitara (3-Türer) SUV JT 1st Facelift | 2009-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2010,
    "Mo": "Grand Vitara (3-Türer) SUV | 2009-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2011,
    "Mo": "Grand Vitara (3-Türer) SUV | 2009-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2012,
    "Mo": "Grand Vitara (3-Türer) SUV JT 1st Facelift | 2009-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2012,
    "Mo": "Grand Vitara (3-Türer) SUV JT 2nd Facelift | 2012-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2013,
    "Mo": "Grand Vitara (3-Türer) SUV | 2012-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2014,
    "Mo": "Grand Vitara (3-Türer) SUV | 2012-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2015,
    "Mo": "Grand Vitara (3-Türer) SUV | 2012-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2009,
    "Mo": "Grand Vitara (5-Türer) SUV JT 1st Facelift | 2009-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2010,
    "Mo": "Grand Vitara (5-Türer) SUV | 2009-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2011,
    "Mo": "Grand Vitara (5-Türer) SUV | 2009-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2012,
    "Mo": "Grand Vitara (5-Türer) SUV JT 1st Facelift | 2009-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2012,
    "Mo": "Grand Vitara (5-Türer) SUV JT 2nd Facelift | 2012-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2013,
    "Mo": "Grand Vitara (5-Türer) SUV | 2012-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2014,
    "Mo": "Grand Vitara (5-Türer) SUV | 2012-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2015,
    "Mo": "Grand Vitara (5-Türer) SUV | 2012-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2005,
    "Mo": "Grand Vitara (5-Türer) SUV JT | 2005-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2006,
    "Mo": "Grand Vitara (5-Türer) SUV | 2005-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2007,
    "Mo": "Grand Vitara (5-Türer) SUV | 2005-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2008,
    "Mo": "Grand Vitara (5-Türer) SUV | 2005-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2009,
    "Mo": "Grand Vitara (5-Türer) SUV JT | 2005-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2013,
    "Mo": "S-Cross (5-Türer) Crossover | 2013-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2014,
    "Mo": "S-Cross (5-Türer) Crossover | 2013-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2015,
    "Mo": "S-Cross (5-Türer) Crossover | 2013-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2016,
    "Mo": "S-Cross (5-Türer) Crossover JY | 2013-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2016,
    "Mo": "S-Cross (5-Türer) Crossover JY Facelift | 2016-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2017,
    "Mo": "S-Cross (5-Türer) Crossover | 2016-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2018,
    "Mo": "S-Cross (5-Türer) Crossover | 2016-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2019,
    "Mo": "S-Cross (5-Türer) Crossover | 2016-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2020,
    "Mo": "S-Cross (5-Türer) Crossover | 2016-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2021,
    "Mo": "S-Cross (5-Türer) Crossover | 2016-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2021,
    "Mo": "S-Cross (JYB) (5-Türer) Crossover | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2022,
    "Mo": "S-Cross (JYB) (5-Türer) Crossover | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2023,
    "Mo": "S-Cross (JYB) (5-Türer) Crossover | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2024,
    "Mo": "S-Cross (JYB) (5-Türer) Crossover | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2025,
    "Mo": "S-Cross (JYB) (5-Türer) Crossover | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2026,
    "Mo": "S-Cross (JYB) (5-Türer) Crossover | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2023,
    "Mo": "Swace (AMZ) (5-Türer) Kombi AMZ Facelift | 2023-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2024,
    "Mo": "Swace (AMZ) (5-Türer) Kombi | 2023-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2025,
    "Mo": "Swace (AMZ) (5-Türer) Kombi | 2023-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2020,
    "Mo": "Swace (AMZ) (5-Türer) Kombi | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2021,
    "Mo": "Swace (AMZ) (5-Türer) Kombi | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2022,
    "Mo": "Swace (AMZ) (5-Türer) Kombi | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2023,
    "Mo": "Swace (AMZ) (5-Türer) Kombi AMZ | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2015,
    "Mo": "Vitara (5-Türer) SUV | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2016,
    "Mo": "Vitara (5-Türer) SUV | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2017,
    "Mo": "Vitara (5-Türer) SUV | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2018,
    "Mo": "Vitara (5-Türer) SUV LY | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2024,
    "Mo": "Vitara (5-Türer) SUV LY 2nd Facelift | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2025,
    "Mo": "Vitara (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2026,
    "Mo": "Vitara (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2018,
    "Mo": "Vitara (5-Türer) SUV LY 1st Facelift | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2019,
    "Mo": "Vitara (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2020,
    "Mo": "Vitara (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2021,
    "Mo": "Vitara (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2022,
    "Mo": "Vitara (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2023,
    "Mo": "Vitara (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2024,
    "Mo": "Vitara (5-Türer) SUV LY 1st Facelift | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2024,
    "Mo": "ASX (5-Türer) SUV 2nd Generation Facelift | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2025,
    "Mo": "ASX (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2026,
    "Mo": "ASX (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2023,
    "Mo": "ASX (5-Türer) SUV | 2023-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2024,
    "Mo": "ASX (5-Türer) SUV 2nd Generation | 2023-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2013,
    "Mo": "ASX (5-Türer) SUV GA 1st Facelift | 2013-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2014,
    "Mo": "ASX (5-Türer) SUV | 2013-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2015,
    "Mo": "ASX (5-Türer) SUV | 2013-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2016,
    "Mo": "ASX (5-Türer) SUV | 2013-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2010,
    "Mo": "ASX (5-Türer) SUV | 2010-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2011,
    "Mo": "ASX (5-Türer) SUV | 2010-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2012,
    "Mo": "ASX (5-Türer) SUV | 2010-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2013,
    "Mo": "ASX (5-Türer) SUV GA | 2010-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2017,
    "Mo": "ASX (GAW) (5-Türer) SUV | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2018,
    "Mo": "ASX (GAW) (5-Türer) SUV | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2019,
    "Mo": "ASX (GAW) (5-Türer) SUV | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2020,
    "Mo": "ASX (GAW) (5-Türer) SUV | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2020,
    "Mo": "ASX (5-Türer) SUV | 2020-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2021,
    "Mo": "ASX (5-Türer) SUV | 2020-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2022,
    "Mo": "ASX (5-Türer) SUV | 2020-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2018,
    "Mo": "Eclipse Cross (GK0W) (5-Türer) Crossover | 2018-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2019,
    "Mo": "Eclipse Cross (GK0W) (5-Türer) Crossover | 2018-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2020,
    "Mo": "Eclipse Cross (GK0W) (5-Türer) Crossover | 2018-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2021,
    "Mo": "Eclipse Cross (5-Türer) Crossover | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2022,
    "Mo": "Eclipse Cross (5-Türer) Crossover | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2023,
    "Mo": "Eclipse Cross (5-Türer) Crossover | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2024,
    "Mo": "Eclipse Cross (5-Türer) Crossover | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2025,
    "Mo": "Eclipse Cross (5-Türer) Crossover | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2015,
    "Mo": "L200 Double Cab (4-Türer) Pickup 5th Generation | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2016,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2017,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2018,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2019,
    "Mo": "L200 Double Cab (4-Türer) Pickup 5th Generation | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2019,
    "Mo": "L200 Double Cab (4-Türer) Pickup 5th Generation Facelift | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2020,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2021,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2022,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2023,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2015,
    "Mo": "Outlander 5-seater (5-Türer) SUV GF0 1st Facelift | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2016,
    "Mo": "Outlander 5-seater (5-Türer) SUV | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2017,
    "Mo": "Outlander 5-seater (5-Türer) SUV | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2018,
    "Mo": "Outlander 5-seater (5-Türer) SUV | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2019,
    "Mo": "Outlander 5-seater (5-Türer) SUV GF0 1st Facelift | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2013,
    "Mo": "Outlander 5-seater (5-Türer) SUV | 2013-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2014,
    "Mo": "Outlander 5-seater (5-Türer) SUV | 2013-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2015,
    "Mo": "Outlander 5-seater (5-Türer) SUV GF0 | 2013-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2019,
    "Mo": "Outlander 5-seater (5-Türer) SUV GF0 2nd Facelift | 2019-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2020,
    "Mo": "Outlander 5-seater (5-Türer) SUV | 2019-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2021,
    "Mo": "Outlander 5-seater (5-Türer) SUV | 2019-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2022,
    "Mo": "Outlander 5-seater (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2023,
    "Mo": "Outlander 5-seater (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2024,
    "Mo": "Outlander 5-seater (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2025,
    "Mo": "Outlander 5-seater (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2026,
    "Mo": "Outlander 5-seater (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2024,
    "Mo": "Pajero Sport (KS0W) (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2025,
    "Mo": "Pajero Sport (KS0W) (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2026,
    "Mo": "Pajero Sport (KS0W) (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2020,
    "Mo": "Pajero Sport (KS0W) (5-Türer) SUV | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2021,
    "Mo": "Pajero Sport (KS0W) (5-Türer) SUV | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2022,
    "Mo": "Pajero Sport (KS0W) (5-Türer) SUV | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2023,
    "Mo": "Pajero Sport (KS0W) (5-Türer) SUV | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2016,
    "Mo": "Pajero Sport (KS0W) (5-Türer) SUV | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2017,
    "Mo": "Pajero Sport (KS0W) (5-Türer) SUV | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2018,
    "Mo": "Pajero Sport (KS0W) (5-Türer) SUV | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2019,
    "Mo": "Pajero Sport (KS0W) (5-Türer) SUV | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2015,
    "Mo": "CR-V (5-Türer) SUV RM Facelift | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2016,
    "Mo": "CR-V (5-Türer) SUV | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2017,
    "Mo": "CR-V (5-Türer) SUV RM Facelift | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2018,
    "Mo": "CR-V (5-Türer) SUV RM Facelift | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2012,
    "Mo": "CR-V (5-Türer) SUV RM | 2012-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2013,
    "Mo": "CR-V (5-Türer) SUV | 2012-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2014,
    "Mo": "CR-V (5-Türer) SUV | 2012-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2015,
    "Mo": "CR-V (5-Türer) SUV RM | 2012-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2023,
    "Mo": "CR-V (RS) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2024,
    "Mo": "CR-V (RS) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2025,
    "Mo": "CR-V (RS) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2026,
    "Mo": "CR-V (RS) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2017,
    "Mo": "CR-V (5-Türer) SUV RW/RT | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2018,
    "Mo": "CR-V (5-Türer) SUV RW/RT | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2019,
    "Mo": "CR-V (5-Türer) SUV | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2020,
    "Mo": "CR-V (5-Türer) SUV RW/RT | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2020,
    "Mo": "CR-V (5-Türer) SUV RW/RT Facelift | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2021,
    "Mo": "CR-V (5-Türer) SUV | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2022,
    "Mo": "CR-V (5-Türer) SUV | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2023,
    "Mo": "CR-V (5-Türer) SUV | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2019,
    "Mo": "HR-V (5-Türer) SUV RU Facelift | 2019-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2020,
    "Mo": "HR-V (5-Türer) SUV | 2019-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2021,
    "Mo": "HR-V (5-Türer) SUV RU Facelift | 2019-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2022,
    "Mo": "HR-V (5-Türer) SUV RU Facelift | 2019-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2016,
    "Mo": "HR-V (5-Türer) SUV | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2017,
    "Mo": "HR-V (5-Türer) SUV | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2018,
    "Mo": "HR-V (5-Türer) SUV | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2019,
    "Mo": "HR-V (5-Türer) SUV RU | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "500X (5-Türer) Crossover | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "500X (5-Türer) Crossover | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "500X (5-Türer) Crossover | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "500X (5-Türer) Crossover | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "500X (5-Türer) Crossover 334 | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "500X (5-Türer) Crossover 334 1st Facelift | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "500X (5-Türer) Crossover | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "500X (5-Türer) Crossover | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "500X (5-Türer) Crossover 334 1st Facelift | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "500X (5-Türer) Crossover 334 1st Facelift | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "500X (5-Türer) Crossover 334 1st Facelift | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "500X (5-Türer) Crossover 334 1st Facelift | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2026,
    "Mo": "500X (5-Türer) Crossover 334 1st Facelift | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "500X (5-Türer) Crossover 334 2nd Facelift | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "500X (5-Türer) Crossover 334 2nd Facelift | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "500X (5-Türer) Crossover 334 2nd Facelift | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "500X (5-Türer) Crossover 334 2nd Facelift | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2026,
    "Mo": "500X (5-Türer) Crossover 334 2nd Facelift | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Panda 4x4 (5-Türer) Crossover | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Panda 4x4 (5-Türer) Crossover | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Panda 4x4 (5-Türer) Crossover | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Panda 4x4 (5-Türer) Crossover | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Panda 4x4 (5-Türer) Crossover | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Panda 4x4 (5-Türer) Crossover | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Panda 4x4 (5-Türer) Crossover | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Panda 4x4 (5-Türer) Crossover | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Panda 4x4 (5-Türer) Crossover | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Panda 4x4 (5-Türer) Crossover | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Panda 4x4 (5-Türer) Crossover | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "Panda 4x4 (5-Türer) Crossover | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Panda 4x4 (5-Türer) Crossover | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Panda 4x4 (5-Türer) Crossover | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2026,
    "Mo": "Panda 4x4 (5-Türer) Crossover | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Panda (5-Türer) Schrägheck 319 | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2026,
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Tipo Station Wagon (5-Türer) Kombi | 2016-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Tipo Station Wagon (5-Türer) Kombi | 2016-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Tipo Station Wagon (5-Türer) Kombi | 2016-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Tipo Station Wagon (5-Türer) Kombi | 2016-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Tipo Station Wagon (5-Türer) Kombi | 2016-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Tipo Station Wagon (5-Türer) Kombi Type 356 | 2016-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Tipo Station Wagon (5-Türer) Kombi Type 356 Facelift | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Tipo Station Wagon (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "Tipo Station Wagon (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Tipo Station Wagon (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Tipo Station Wagon (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2026,
    "Mo": "Tipo Station Wagon (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2009,
    "Mo": "Altea Freetrack (5-Türer) SUV | 2009-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2010,
    "Mo": "Altea Freetrack (5-Türer) SUV | 2009-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2011,
    "Mo": "Altea Freetrack (5-Türer) SUV | 2009-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2012,
    "Mo": "Altea Freetrack (5-Türer) SUV | 2009-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2013,
    "Mo": "Altea Freetrack (5-Türer) SUV | 2009-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2014,
    "Mo": "Altea Freetrack (5-Türer) SUV | 2009-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2015,
    "Mo": "Altea Freetrack (5-Türer) SUV | 2009-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2008,
    "Mo": "Altea Freetrack (5P8) (5-Türer) SUV | 2008-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2009,
    "Mo": "Altea Freetrack (5P8) (5-Türer) SUV | 2008-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2009,
    "Mo": "Altea XL (5-Türer) MPV | 2009-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2010,
    "Mo": "Altea XL (5-Türer) MPV | 2009-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2011,
    "Mo": "Altea XL (5-Türer) MPV | 2009-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2012,
    "Mo": "Altea XL (5-Türer) MPV | 2009-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2013,
    "Mo": "Altea XL (5-Türer) MPV | 2009-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2014,
    "Mo": "Altea XL (5-Türer) MPV | 2009-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2015,
    "Mo": "Altea XL (5-Türer) MPV | 2009-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2007,
    "Mo": "Altea XL (5P5) (5-Türer) MPV | 2007-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2008,
    "Mo": "Altea XL (5P5) (5-Türer) MPV | 2007-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2009,
    "Mo": "Altea XL (5P5) (5-Türer) MPV | 2007-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2021,
    "Mo": "Arona (5-Türer) Crossover KJ 1st Facelift | 2021-2026",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2022,
    "Mo": "Arona (5-Türer) Crossover | 2021-2026",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2023,
    "Mo": "Arona (5-Türer) Crossover | 2021-2026",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2024,
    "Mo": "Arona (5-Türer) Crossover | 2021-2026",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2025,
    "Mo": "Arona (5-Türer) Crossover | 2021-2026",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2026,
    "Mo": "Arona (5-Türer) Crossover KJ 1st Facelift | 2021-2026",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2018,
    "Mo": "Arona (5-Türer) Crossover | 2018-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2019,
    "Mo": "Arona (5-Türer) Crossover | 2018-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2020,
    "Mo": "Arona (5-Türer) Crossover | 2018-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2021,
    "Mo": "Arona (5-Türer) Crossover KJ | 2018-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2026,
    "Mo": "Arona (5-Türer) Crossover KJ 2nd Facelift | 2026-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2016,
    "Mo": "Ibiza ST (5-Türer) Kombi | 2016-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2017,
    "Mo": "Ibiza ST (5-Türer) Kombi | 2016-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2012,
    "Mo": "Ibiza ST (5-Türer) Kombi 6J 1st Facelift | 2012-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2013,
    "Mo": "Ibiza ST (5-Türer) Kombi | 2012-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2014,
    "Mo": "Ibiza ST (5-Türer) Kombi | 2012-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2015,
    "Mo": "Ibiza ST (5-Türer) Kombi | 2012-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2011,
    "Mo": "Ibiza ST (5-Türer) Kombi | 2011-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2012,
    "Mo": "Ibiza ST (5-Türer) Kombi 6J | 2011-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2020,
    "Mo": "León ST (KL8) (5-Türer) Kombi | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2021,
    "Mo": "León ST (KL8) (5-Türer) Kombi | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2022,
    "Mo": "León ST (KL8) (5-Türer) Kombi | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2023,
    "Mo": "León ST (KL8) (5-Türer) Kombi | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2024,
    "Mo": "León ST (KL8) (5-Türer) Kombi | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2024,
    "Mo": "León ST (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2025,
    "Mo": "León ST (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2026,
    "Mo": "León ST (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2013,
    "Mo": "León ST (5-Türer) Kombi | 2013-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2014,
    "Mo": "León ST (5-Türer) Kombi | 2013-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2015,
    "Mo": "León ST (5-Türer) Kombi | 2013-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2016,
    "Mo": "León ST (5-Türer) Kombi | 2013-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2017,
    "Mo": "León ST (5-Türer) Kombi 5F | 2013-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2017,
    "Mo": "León ST (5-Türer) Kombi 5F Facelift | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2018,
    "Mo": "León ST (5-Türer) Kombi | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2019,
    "Mo": "León ST (5-Türer) Kombi | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2020,
    "Mo": "León ST (5-Türer) Kombi | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2015,
    "Mo": "León X-Perience (5-Türer) Kombi | 2015-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2016,
    "Mo": "León X-Perience (5-Türer) Kombi | 2015-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2017,
    "Mo": "León X-Perience (5-Türer) Kombi 5F | 2015-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2017,
    "Mo": "León X-Perience (5-Türer) Kombi 5F Facelift | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2018,
    "Mo": "León X-Perience (5-Türer) Kombi | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2019,
    "Mo": "León X-Perience (5-Türer) Kombi | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2020,
    "Mo": "León X-Perience (5-Türer) Kombi | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2018,
    "Mo": "Crosstrek (5-Türer) Crossover | 2018-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2019,
    "Mo": "Crosstrek (5-Türer) Crossover | 2018-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2020,
    "Mo": "Crosstrek (5-Türer) Crossover | 2018-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2021,
    "Mo": "Crosstrek (5-Türer) Crossover | 2021-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2022,
    "Mo": "Crosstrek (5-Türer) Crossover | 2021-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2023,
    "Mo": "Crosstrek (5-Türer) Crossover | 2021-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2006,
    "Mo": "Forester (5-Türer) SUV | 2006-2008",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2007,
    "Mo": "Forester (5-Türer) SUV | 2006-2008",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2008,
    "Mo": "Forester (5-Türer) SUV SG Facelift | 2006-2008",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2003,
    "Mo": "Forester (5-Türer) SUV | 2003-2005",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2004,
    "Mo": "Forester (5-Türer) SUV | 2003-2005",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2005,
    "Mo": "Forester (5-Türer) SUV | 2003-2005",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2025,
    "Mo": "Forester (5-Türer) SUV SL | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2026,
    "Mo": "Forester (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2015,
    "Mo": "Outback (5-Türer) Kombi | 2015-2018",
    "c": "h",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2016,
    "Mo": "Outback (5-Türer) Kombi | 2015-2018",
    "c": "h",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2017,
    "Mo": "Outback (5-Türer) Kombi | 2015-2018",
    "c": "h",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2018,
    "Mo": "Outback (5-Türer) Kombi BS | 2015-2018",
    "c": "h",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2018,
    "Mo": "Outback (5-Türer) Kombi BS Facelift | 2018-2020",
    "c": "h",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2019,
    "Mo": "Outback (5-Türer) Kombi | 2018-2020",
    "c": "h",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2020,
    "Mo": "Outback (5-Türer) Kombi BS Facelift | 2018-2020",
    "c": "h",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2004,
    "Mo": "Outback (5-Türer) Kombi BP | 2004-2008",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2005,
    "Mo": "Outback (5-Türer) Kombi | 2004-2008",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2006,
    "Mo": "Outback (5-Türer) Kombi | 2004-2008",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2007,
    "Mo": "Outback (5-Türer) Kombi | 2004-2008",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2008,
    "Mo": "Outback (5-Türer) Kombi BP | 2004-2008",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2008,
    "Mo": "Outback (5-Türer) Kombi BP Facelift | 2008-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2009,
    "Mo": "Outback (5-Türer) Kombi | 2008-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2010,
    "Mo": "Outback (5-Türer) Kombi | 2010-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2011,
    "Mo": "Outback (5-Türer) Kombi | 2010-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2012,
    "Mo": "Outback (5-Türer) Kombi | 2010-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2013,
    "Mo": "Outback (5-Türer) Kombi | 2010-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2014,
    "Mo": "Outback (5-Türer) Kombi | 2010-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2015,
    "Mo": "Outback (5-Türer) Kombi | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2016,
    "Mo": "Outback (5-Türer) Kombi | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2017,
    "Mo": "Outback (5-Türer) Kombi | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2018,
    "Mo": "Outback (5-Türer) Kombi BS | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2018,
    "Mo": "Outback (5-Türer) Kombi BS Facelift | 2018-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2019,
    "Mo": "Outback (5-Türer) Kombi | 2018-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2020,
    "Mo": "Outback (5-Türer) Kombi BS Facelift | 2018-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2018,
    "Mo": "XV (5-Türer) Kombi | 2018-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2019,
    "Mo": "XV (5-Türer) Kombi | 2018-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2020,
    "Mo": "XV (5-Türer) Kombi | 2018-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2021,
    "Mo": "XV (5-Türer) Kombi | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2022,
    "Mo": "XV (5-Türer) Kombi | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2023,
    "Mo": "XV (5-Türer) Kombi | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2024,
    "Mo": "XV (5-Türer) Kombi | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2024,
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2025,
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2026,
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2018,
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2019,
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2020,
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2021,
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2022,
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2023,
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2014,
    "Mo": "Macan (5-Türer) SUV | 2014-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2015,
    "Mo": "Macan (5-Türer) SUV | 2014-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2016,
    "Mo": "Macan (5-Türer) SUV | 2014-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2017,
    "Mo": "Macan (5-Türer) SUV | 2014-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2018,
    "Mo": "Macan (5-Türer) SUV | 2014-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2022,
    "Mo": "Macan (5-Türer) SUV | 2022-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2023,
    "Mo": "Macan (5-Türer) SUV | 2022-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2024,
    "Mo": "Macan (5-Türer) SUV 95B.3 | 2022-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2019,
    "Mo": "Macan (5-Türer) SUV | 2019-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2020,
    "Mo": "Macan (5-Türer) SUV | 2019-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2021,
    "Mo": "Macan (5-Türer) SUV | 2019-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2024,
    "Mo": "Macan (5-Türer) SUV XAB | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2025,
    "Mo": "Macan (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2026,
    "Mo": "Macan (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2025,
    "Mo": "Taycan Cross Turismo (Y1B) (5-Türer) Kombi | 2025-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2026,
    "Mo": "Taycan Cross Turismo (Y1B) (5-Türer) Kombi | 2025-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2021,
    "Mo": "Taycan Cross Turismo (Y1B) (5-Türer) Kombi | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2022,
    "Mo": "Taycan Cross Turismo (Y1B) (5-Türer) Kombi | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2023,
    "Mo": "Taycan Cross Turismo (Y1B) (5-Türer) Kombi | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2024,
    "Mo": "Taycan Cross Turismo (Y1B) (5-Türer) Kombi | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2024,
    "Mo": "Aceman (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2025,
    "Mo": "Aceman (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2026,
    "Mo": "Aceman (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2016,
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2017,
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2018,
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2019,
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2019,
    "Mo": "Clubman (F54 LCI) (5-Türer) Kombi | 2019-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2020,
    "Mo": "Clubman (F54 LCI) (5-Türer) Kombi | 2019-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2021,
    "Mo": "Clubman (F54 LCI) (5-Türer) Kombi F54 1st LCI | 2019-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2021,
    "Mo": "Clubman (F54 LCI) (5-Türer) Kombi F54 2nd LCI | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2022,
    "Mo": "Clubman (F54 LCI) (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2023,
    "Mo": "Clubman (F54 LCI) (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2024,
    "Mo": "Clubman (F54 LCI) (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2025,
    "Mo": "Clubman (F54 LCI) (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2026,
    "Mo": "Clubman (F54 LCI) (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2019,
    "Mo": "3-door (F56 LCI) (3-Türer) Schrägheck | 2019-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2020,
    "Mo": "3-door (F56 LCI) (3-Türer) Schrägheck | 2019-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2021,
    "Mo": "3-door (F56 LCI) (3-Türer) Schrägheck F56 1st LCI | 2019-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2021,
    "Mo": "3-door (F56 LCI) (3-Türer) Schrägheck F56 2nd LCI | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2022,
    "Mo": "3-door (F56 LCI) (3-Türer) Schrägheck | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2023,
    "Mo": "3-door (F56 LCI) (3-Türer) Schrägheck | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2024,
    "Mo": "3-door (F56 LCI) (3-Türer) Schrägheck | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2014,
    "Mo": "3-door (F56) (3-Türer) Schrägheck | 2014-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2015,
    "Mo": "3-door (F56) (3-Türer) Schrägheck | 2014-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2016,
    "Mo": "3-door (F56) (3-Türer) Schrägheck | 2014-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2017,
    "Mo": "3-door (F56) (3-Türer) Schrägheck | 2014-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2018,
    "Mo": "3-door (F56) (3-Türer) Schrägheck | 2014-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2019,
    "Mo": "3-door (F56) (3-Türer) Schrägheck | 2014-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2019,
    "Mo": "5-door (F55 LCI) (5-Türer) Schrägheck | 2019-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2020,
    "Mo": "5-door (F55 LCI) (5-Türer) Schrägheck | 2019-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2021,
    "Mo": "5-door (F55 LCI) (5-Türer) Schrägheck F56 1st LCI | 2019-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2021,
    "Mo": "5-door (F55 LCI) (5-Türer) Schrägheck F56 2nd LCI | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2022,
    "Mo": "5-door (F55 LCI) (5-Türer) Schrägheck | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2023,
    "Mo": "5-door (F55 LCI) (5-Türer) Schrägheck | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2024,
    "Mo": "5-door (F55 LCI) (5-Türer) Schrägheck | 2021-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2014,
    "Mo": "5-door (F55) (5-Türer) Schrägheck | 2014-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2015,
    "Mo": "5-door (F55) (5-Türer) Schrägheck | 2014-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2016,
    "Mo": "5-door (F55) (5-Türer) Schrägheck | 2014-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2017,
    "Mo": "5-door (F55) (5-Türer) Schrägheck | 2014-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2018,
    "Mo": "5-door (F55) (5-Türer) Schrägheck | 2014-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2019,
    "Mo": "5-door (F55) (5-Türer) Schrägheck | 2014-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2024,
    "Mo": "Countryman (5-Türer) Crossover U25 | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2025,
    "Mo": "Countryman (5-Türer) Crossover | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2026,
    "Mo": "Countryman (5-Türer) Crossover | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2010,
    "Mo": "Countryman (R60) (5-Türer) Crossover | 2010-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2011,
    "Mo": "Countryman (R60) (5-Türer) Crossover | 2010-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2012,
    "Mo": "Countryman (R60) (5-Türer) Crossover | 2010-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2013,
    "Mo": "Countryman (R60) (5-Türer) Crossover | 2010-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2014,
    "Mo": "Countryman (R60) (5-Türer) Crossover | 2010-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2015,
    "Mo": "Countryman (R60 LCI) (5-Türer) Crossover | 2015-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2016,
    "Mo": "Countryman (R60 LCI) (5-Türer) Crossover | 2015-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2017,
    "Mo": "Discovery (5-Türer) SUV | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2018,
    "Mo": "Discovery (5-Türer) SUV | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2019,
    "Mo": "Discovery (5-Türer) SUV | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2020,
    "Mo": "Discovery (5-Türer) SUV | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2021,
    "Mo": "Discovery (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2022,
    "Mo": "Discovery (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2023,
    "Mo": "Discovery (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2024,
    "Mo": "Discovery (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2025,
    "Mo": "Discovery (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2026,
    "Mo": "Discovery (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2014,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2014-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2015,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2014-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2016,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2014-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2017,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2014-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2018,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2019,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2020,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2021,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2022,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2018,
    "Mo": "Range Rover Velar (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2019,
    "Mo": "Range Rover Velar (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2020,
    "Mo": "Range Rover Velar (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2021,
    "Mo": "Range Rover Velar (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2022,
    "Mo": "Range Rover Velar (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2023,
    "Mo": "Range Rover Velar (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2024,
    "Mo": "Range Rover Velar (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2025,
    "Mo": "Range Rover Velar (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2026,
    "Mo": "Range Rover Velar (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2023,
    "Mo": "HS (5-Türer) SUV | 2023-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2024,
    "Mo": "HS (5-Türer) SUV 1st Generation Facelift | 2023-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2019,
    "Mo": "HS (AS23) (5-Türer) SUV | 2019-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2020,
    "Mo": "HS (AS23) (5-Türer) SUV | 2019-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2021,
    "Mo": "HS (AS23) (5-Türer) SUV | 2019-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2022,
    "Mo": "HS (AS23) (5-Türer) SUV | 2019-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2024,
    "Mo": "HS (5-Türer) SUV 2nd Generation | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2025,
    "Mo": "HS (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2026,
    "Mo": "HS (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2024,
    "Mo": "Maxus 7 (5-Türer) MPV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2025,
    "Mo": "Maxus 7 (5-Türer) MPV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2026,
    "Mo": "Maxus 7 (5-Türer) MPV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2025,
    "Mo": "S5 EV (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2026,
    "Mo": "S5 EV (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2016,
    "Mo": "LX (4-Türer) SUV | 2016-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2017,
    "Mo": "LX (4-Türer) SUV | 2016-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2018,
    "Mo": "LX (4-Türer) SUV | 2016-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2019,
    "Mo": "LX (4-Türer) SUV | 2016-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2020,
    "Mo": "LX (4-Türer) SUV | 2016-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2021,
    "Mo": "LX (4-Türer) SUV | 2016-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2018,
    "Mo": "NX (5-Türer) SUV | 2018-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2019,
    "Mo": "NX (5-Türer) SUV | 2018-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2020,
    "Mo": "NX (5-Türer) SUV | 2018-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2021,
    "Mo": "NX (5-Türer) SUV AZ10 Facelift | 2018-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2015,
    "Mo": "NX (5-Türer) SUV | 2015-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2016,
    "Mo": "NX (5-Türer) SUV | 2015-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2017,
    "Mo": "NX (5-Türer) SUV | 2015-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2016,
    "Mo": "RX (5-Türer) SUV | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2017,
    "Mo": "RX (5-Türer) SUV | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2018,
    "Mo": "RX (5-Türer) SUV | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2019,
    "Mo": "RX (5-Türer) SUV | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2020,
    "Mo": "RX (5-Türer) SUV AL20 | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2020,
    "Mo": "RX (5-Türer) SUV AL20 Facelift | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2021,
    "Mo": "RX (5-Türer) SUV | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2022,
    "Mo": "RX (5-Türer) SUV | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2023,
    "Mo": "RX (5-Türer) SUV AL20 Facelift | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2018,
    "Mo": "RX L (5-Türer) SUV | 2018-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2019,
    "Mo": "RX L (5-Türer) SUV | 2018-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2020,
    "Mo": "RX L (5-Türer) SUV AL20 | 2018-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2020,
    "Mo": "RX L (5-Türer) SUV AL20 Facelift | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2021,
    "Mo": "RX L (5-Türer) SUV | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2022,
    "Mo": "RX L (5-Türer) SUV | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2023,
    "Mo": "RX L (5-Türer) SUV | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2018,
    "Mo": "UX (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2019,
    "Mo": "UX (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2020,
    "Mo": "UX (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2021,
    "Mo": "UX (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2022,
    "Mo": "UX (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2023,
    "Mo": "UX (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2024,
    "Mo": "UX (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2025,
    "Mo": "UX (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2026,
    "Mo": "UX (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2017,
    "Mo": "Compass (5-Türer) SUV MP | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2018,
    "Mo": "Compass (5-Türer) SUV | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2019,
    "Mo": "Compass (5-Türer) SUV | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2020,
    "Mo": "Compass (5-Türer) SUV | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2021,
    "Mo": "Compass (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2022,
    "Mo": "Compass (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2023,
    "Mo": "Compass (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2024,
    "Mo": "Compass (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2025,
    "Mo": "Compass (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2011,
    "Mo": "Compass (5-Türer) SUV | 2011-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2012,
    "Mo": "Compass (5-Türer) SUV | 2011-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2013,
    "Mo": "Compass (5-Türer) SUV | 2011-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2014,
    "Mo": "Compass (5-Türer) SUV | 2011-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2015,
    "Mo": "Compass (5-Türer) SUV | 2011-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2016,
    "Mo": "Compass (5-Türer) SUV | 2011-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2017,
    "Mo": "Compass (5-Türer) SUV MK Facelift | 2011-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2022,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2023,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2024,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2025,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2026,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2026-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2021,
    "Mo": "Grand Cherokee L (4-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2022,
    "Mo": "Grand Cherokee L (4-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2023,
    "Mo": "Grand Cherokee L (4-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2024,
    "Mo": "Grand Cherokee L (4-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2025,
    "Mo": "Grand Cherokee L (4-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2022,
    "Mo": "Wagoneer (4-Türer) SUV | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2023,
    "Mo": "Wagoneer (4-Türer) SUV | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2024,
    "Mo": "Wagoneer (4-Türer) SUV | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2025,
    "Mo": "Wagoneer (4-Türer) SUV | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2018,
    "Mo": "E-Pace (5-Türer) SUV | 2018-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2019,
    "Mo": "E-Pace (5-Türer) SUV | 2018-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2020,
    "Mo": "E-Pace (5-Türer) SUV | 2018-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2021,
    "Mo": "E-Pace (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2022,
    "Mo": "E-Pace (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2023,
    "Mo": "E-Pace (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2024,
    "Mo": "E-Pace (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2025,
    "Mo": "E-Pace (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2026,
    "Mo": "E-Pace (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2016,
    "Mo": "F-Pace (5-Türer) SUV | 2016-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2017,
    "Mo": "F-Pace (5-Türer) SUV | 2016-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2018,
    "Mo": "F-Pace (5-Türer) SUV | 2016-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2019,
    "Mo": "F-Pace (5-Türer) SUV | 2016-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2020,
    "Mo": "F-Pace (5-Türer) SUV | 2016-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2021,
    "Mo": "F-Pace (5-Türer) SUV X761 | 2016-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2021,
    "Mo": "F-Pace (5-Türer) SUV X761 Facelift | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2022,
    "Mo": "F-Pace (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2023,
    "Mo": "F-Pace (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2024,
    "Mo": "F-Pace (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2025,
    "Mo": "F-Pace (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2017,
    "Mo": "XF Sportbrake (5-Türer) Kombi | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2018,
    "Mo": "XF Sportbrake (5-Türer) Kombi | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2019,
    "Mo": "XF Sportbrake (5-Türer) Kombi | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2020,
    "Mo": "XF Sportbrake (5-Türer) Kombi | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2021,
    "Mo": "XF Sportbrake (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2022,
    "Mo": "XF Sportbrake (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2023,
    "Mo": "XF Sportbrake (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2024,
    "Mo": "XF Sportbrake (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2025,
    "Mo": "XF Sportbrake (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2026,
    "Mo": "XF Sportbrake (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2024,
    "Mo": "D-Max Crew Cab (4-Türer) Pickup RG01 Facelift | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2025,
    "Mo": "D-Max Crew Cab (4-Türer) Pickup | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2026,
    "Mo": "D-Max Crew Cab (4-Türer) Pickup | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2020,
    "Mo": "D-Max Crew Cab (4-Türer) Pickup RG01 | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2021,
    "Mo": "D-Max Crew Cab (4-Türer) Pickup | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2022,
    "Mo": "D-Max Crew Cab (4-Türer) Pickup | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2023,
    "Mo": "D-Max Crew Cab (4-Türer) Pickup | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2024,
    "Mo": "D-Max Crew Cab (4-Türer) Pickup RG01 | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2024,
    "Mo": "D-Max Space Cab (4-Türer) Pickup RG01 Facelift | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2025,
    "Mo": "D-Max Space Cab (4-Türer) Pickup | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2026,
    "Mo": "D-Max Space Cab (4-Türer) Pickup | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2020,
    "Mo": "D-Max Space Cab (4-Türer) Pickup | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2021,
    "Mo": "D-Max Space Cab (4-Türer) Pickup | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2022,
    "Mo": "D-Max Space Cab (4-Türer) Pickup | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2023,
    "Mo": "D-Max Space Cab (4-Türer) Pickup | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2024,
    "Mo": "D-Max Space Cab (4-Türer) Pickup RG01 | 2020-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Smart",
    "Y": 2025,
    "Mo": "#5 (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Smart",
    "Y": 2026,
    "Mo": "#5 (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "XPENG",
    "Y": 2025,
    "Mo": "G9 (5-Türer) SUV 1st Generation Facelift | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "XPENG",
    "Y": 2026,
    "Mo": "G9 (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "XPENG",
    "Y": 2022,
    "Mo": "G9 (5-Türer) SUV | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "XPENG",
    "Y": 2023,
    "Mo": "G9 (5-Türer) SUV | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "XPENG",
    "Y": 2024,
    "Mo": "G9 (5-Türer) SUV | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "XPENG",
    "Y": 2025,
    "Mo": "G9 (5-Türer) SUV 1st Generation | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lotus",
    "Y": 2023,
    "Mo": "Eletre (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lotus",
    "Y": 2024,
    "Mo": "Eletre (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lotus",
    "Y": 2025,
    "Mo": "Eletre (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lotus",
    "Y": 2026,
    "Mo": "Eletre (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2004,
    "Mo": "Astra Caravan (5-Türer) Kombi H | 2004-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2005,
    "Mo": "Astra Caravan (5-Türer) Kombi H | 2004-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2006,
    "Mo": "Astra Caravan (5-Türer) Kombi H | 2004-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2007,
    "Mo": "Astra Caravan (5-Türer) Kombi | 2004-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2008,
    "Mo": "Astra Caravan (5-Türer) Kombi | 2004-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2009,
    "Mo": "Astra Caravan (5-Türer) Kombi | 2004-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2010,
    "Mo": "Astra Caravan (5-Türer) Kombi | 2004-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2011,
    "Mo": "Astra Caravan (5-Türer) Kombi | 2004-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2012,
    "Mo": "Astra Caravan (5-Türer) Kombi | 2004-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2004,
    "Mo": "Astra Caravan (5-Türer) Kombi H | 2004-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2005,
    "Mo": "Astra Caravan (5-Türer) Kombi H | 2004-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2006,
    "Mo": "Astra Caravan (5-Türer) Kombi H | 2004-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2007,
    "Mo": "Astra Caravan (5-Türer) Kombi | 2004-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2008,
    "Mo": "Astra Caravan (5-Türer) Kombi | 2004-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2009,
    "Mo": "Astra Caravan (5-Türer) Kombi | 2004-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2010,
    "Mo": "Astra Caravan (5-Türer) Kombi | 2004-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2011,
    "Mo": "Astra Caravan (5-Türer) Kombi | 2004-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2012,
    "Mo": "Astra Caravan (5-Türer) Kombi | 2004-2012",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2018,
    "Mo": "Grandland X (5-Türer) SUV | 2018-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2019,
    "Mo": "Grandland X (5-Türer) SUV | 2018-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2020,
    "Mo": "Grandland X (5-Türer) SUV | 2018-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2021,
    "Mo": "Grandland X (5-Türer) SUV | 2018-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2009,
    "Mo": "Insignia Sports Tourer (5-Türer) Kombi | 2009-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2010,
    "Mo": "Insignia Sports Tourer (5-Türer) Kombi | 2009-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2011,
    "Mo": "Insignia Sports Tourer (5-Türer) Kombi | 2009-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2012,
    "Mo": "Insignia Sports Tourer (5-Türer) Kombi | 2009-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2013,
    "Mo": "Insignia Sports Tourer (5-Türer) Kombi | 2009-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2006,
    "Mo": "Vectra Caravan (5-Türer) Kombi | 2006-2008",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2007,
    "Mo": "Vectra Caravan (5-Türer) Kombi | 2006-2008",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2008,
    "Mo": "Vectra Caravan (5-Türer) Kombi | 2006-2008",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2002,
    "Mo": "Vectra Caravan (5-Türer) Kombi | 2002-2005",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2003,
    "Mo": "Vectra Caravan (5-Türer) Kombi | 2002-2005",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2004,
    "Mo": "Vectra Caravan (5-Türer) Kombi | 2002-2005",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2005,
    "Mo": "Vectra Caravan (5-Türer) Kombi | 2002-2005",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2008,
    "Mo": "Zafira (5-Türer) MPV | 2008-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2009,
    "Mo": "Zafira (5-Türer) MPV | 2008-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2010,
    "Mo": "Zafira (5-Türer) MPV | 2008-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2011,
    "Mo": "Zafira (5-Türer) MPV B Facelift | 2008-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2012,
    "Mo": "Zafira (5-Türer) MPV B Facelift | 2008-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2013,
    "Mo": "Zafira (5-Türer) MPV B Facelift | 2008-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2014,
    "Mo": "Zafira (5-Türer) MPV B Facelift | 2008-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2011,
    "Mo": "Zafira (5-Türer) MPV C | 2011-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2012,
    "Mo": "Zafira (5-Türer) MPV C | 2011-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2013,
    "Mo": "Zafira (5-Türer) MPV C | 2011-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2014,
    "Mo": "Zafira (5-Türer) MPV C | 2011-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2015,
    "Mo": "Zafira (5-Türer) MPV | 2011-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2016,
    "Mo": "Zafira (5-Türer) MPV | 2011-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2017,
    "Mo": "Zafira (5-Türer) MPV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2018,
    "Mo": "Zafira (5-Türer) MPV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2019,
    "Mo": "Zafira (5-Türer) MPV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2020,
    "Mo": "Zafira (5-Türer) MPV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2021,
    "Mo": "Zafira (5-Türer) MPV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2022,
    "Mo": "Zafira (5-Türer) MPV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2023,
    "Mo": "Zafira (5-Türer) MPV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2024,
    "Mo": "Zafira (5-Türer) MPV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2025,
    "Mo": "Zafira (5-Türer) MPV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2026,
    "Mo": "Zafira (5-Türer) MPV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DS",
    "Y": 2017,
    "Mo": "7 Crossback (5-Türer) SUV | 2017-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DS",
    "Y": 2018,
    "Mo": "7 Crossback (5-Türer) SUV | 2017-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DS",
    "Y": 2019,
    "Mo": "7 Crossback (5-Türer) SUV | 2017-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DS",
    "Y": 2020,
    "Mo": "7 Crossback (5-Türer) SUV | 2017-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DS",
    "Y": 2021,
    "Mo": "7 Crossback (5-Türer) SUV | 2017-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DS",
    "Y": 2022,
    "Mo": "7 Crossback (5-Türer) SUV 1st Generation | 2017-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DS",
    "Y": 2022,
    "Mo": "7 Crossback (5-Türer) SUV 1st Generation Facelift | 2022-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DS",
    "Y": 2023,
    "Mo": "7 Crossback (5-Türer) SUV | 2022-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DS",
    "Y": 2024,
    "Mo": "7 Crossback (5-Türer) SUV | 2022-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DS",
    "Y": 2025,
    "Mo": "7 Crossback (5-Türer) SUV | 2022-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DS",
    "Y": 2026,
    "Mo": "7 Crossback (5-Türer) SUV | 2022-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "GMC",
    "Y": 2015,
    "Mo": "Yukon (4-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "GMC",
    "Y": 2016,
    "Mo": "Yukon (4-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "GMC",
    "Y": 2017,
    "Mo": "Yukon (4-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "GMC",
    "Y": 2018,
    "Mo": "Yukon (4-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "GMC",
    "Y": 2019,
    "Mo": "Yukon (4-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "GMC",
    "Y": 2020,
    "Mo": "Yukon (4-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lynk & Co",
    "Y": 2024,
    "Mo": "01 (5-Türer) Crossover 1st Generation 2nd Facelift | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lynk & Co",
    "Y": 2025,
    "Mo": "01 (5-Türer) Crossover | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lynk & Co",
    "Y": 2026,
    "Mo": "01 (5-Türer) Crossover | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lynk & Co",
    "Y": 2019,
    "Mo": "01 (5-Türer) Crossover | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lynk & Co",
    "Y": 2020,
    "Mo": "01 (5-Türer) Crossover | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lynk & Co",
    "Y": 2021,
    "Mo": "01 (5-Türer) Crossover | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lynk & Co",
    "Y": 2022,
    "Mo": "01 (5-Türer) Crossover | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lynk & Co",
    "Y": 2023,
    "Mo": "01 (5-Türer) Crossover | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lynk & Co",
    "Y": 2024,
    "Mo": "01 (5-Türer) Crossover 1st Generation Facelift | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lynk & Co",
    "Y": 2025,
    "Mo": "08 (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lynk & Co",
    "Y": 2026,
    "Mo": "08 (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Zeekr",
    "Y": 2025,
    "Mo": "7X (5-Türer) SUV | 2025-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Zeekr",
    "Y": 2026,
    "Mo": "7X (5-Türer) SUV 1st Generation | 2025-2026",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Zeekr",
    "Y": 2026,
    "Mo": "7X (5-Türer) SUV 1st Generation Facelift | 2026-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2025,
    "Mo": "EL6 (5-Türer) SUV 1st Generation Facelift | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2026,
    "Mo": "EL6 (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2023,
    "Mo": "EL6 (5-Türer) SUV | 2023-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2024,
    "Mo": "EL6 (5-Türer) SUV | 2023-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2025,
    "Mo": "EL6 (5-Türer) SUV 1st Generation | 2023-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2022,
    "Mo": "EL7 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2023,
    "Mo": "EL7 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2024,
    "Mo": "EL7 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2025,
    "Mo": "EL7 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2026,
    "Mo": "EL7 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2024,
    "Mo": "EL8 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2025,
    "Mo": "EL8 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2026,
    "Mo": "EL8 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2023,
    "Mo": "ES6 (5-Türer) SUV | 2023-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2024,
    "Mo": "ES6 (5-Türer) SUV | 2023-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2025,
    "Mo": "ES6 (5-Türer) SUV | 2023-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2018,
    "Mo": "ES8 (5-Türer) SUV | 2018-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2019,
    "Mo": "ES8 (5-Türer) SUV | 2018-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2020,
    "Mo": "ES8 (5-Türer) SUV 1st Generation | 2018-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2020,
    "Mo": "ES8 (5-Türer) SUV 1st Generation Facelift | 2020-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2021,
    "Mo": "ES8 (5-Türer) SUV | 2020-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2022,
    "Mo": "ES8 (5-Türer) SUV | 2020-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2023,
    "Mo": "ES8 (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2024,
    "Mo": "ES8 (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2025,
    "Mo": "ES8 (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2026,
    "Mo": "ES8 (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2025,
    "Mo": "ET5 Touring (5-Türer) Kombi 1st Generation Facelift | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2026,
    "Mo": "ET5 Touring (5-Türer) Kombi | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2022,
    "Mo": "ET5 Touring (5-Türer) Kombi | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2023,
    "Mo": "ET5 Touring (5-Türer) Kombi | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2024,
    "Mo": "ET5 Touring (5-Türer) Kombi | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2025,
    "Mo": "ET5 Touring (5-Türer) Kombi 1st Generation | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KGM",
    "Y": 2024,
    "Mo": "Actyon (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KGM",
    "Y": 2025,
    "Mo": "Actyon (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KGM",
    "Y": 2026,
    "Mo": "Actyon (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2016,
    "Mo": "QX30 (5-Türer) SUV | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2017,
    "Mo": "QX30 (5-Türer) SUV | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2018,
    "Mo": "QX30 (5-Türer) SUV | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2019,
    "Mo": "QX30 (5-Türer) SUV | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Wey",
    "Y": 2022,
    "Mo": "Coffee 01 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Wey",
    "Y": 2023,
    "Mo": "Coffee 01 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Wey",
    "Y": 2024,
    "Mo": "Coffee 01 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Wey",
    "Y": 2025,
    "Mo": "Coffee 01 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Wey",
    "Y": 2026,
    "Mo": "Coffee 01 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Genesis",
    "Y": 2022,
    "Mo": "GV60 (5-Türer) SUV | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Genesis",
    "Y": 2023,
    "Mo": "GV60 (5-Türer) SUV | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Genesis",
    "Y": 2024,
    "Mo": "GV60 (5-Türer) SUV | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Genesis",
    "Y": 2025,
    "Mo": "GV60 (5-Türer) SUV 1st Generation | 2022-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Genesis",
    "Y": 2025,
    "Mo": "GV60 (5-Türer) SUV 1st Generation Facelift | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Genesis",
    "Y": 2026,
    "Mo": "GV60 (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Genesis",
    "Y": 2022,
    "Mo": "GV70 (5-Türer) SUV | 2022-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Genesis",
    "Y": 2023,
    "Mo": "GV70 (5-Türer) SUV | 2022-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Genesis",
    "Y": 2024,
    "Mo": "GV70 (5-Türer) SUV 1st Generation | 2022-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Genesis",
    "Y": 2024,
    "Mo": "GV70 (5-Türer) SUV 1st Generation Facelift | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Genesis",
    "Y": 2025,
    "Mo": "GV70 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Genesis",
    "Y": 2026,
    "Mo": "GV70 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Genesis",
    "Y": 2024,
    "Mo": "GV80 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Genesis",
    "Y": 2025,
    "Mo": "GV80 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Genesis",
    "Y": 2026,
    "Mo": "GV80 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Genesis",
    "Y": 2021,
    "Mo": "GV80 (5-Türer) SUV | 2021-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Genesis",
    "Y": 2022,
    "Mo": "GV80 (5-Türer) SUV | 2021-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Genesis",
    "Y": 2023,
    "Mo": "GV80 (5-Türer) SUV | 2021-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2018,
    "Mo": "Berlingo Combi (4-Türer) LCV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2019,
    "Mo": "Berlingo Combi (4-Türer) LCV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2020,
    "Mo": "Berlingo Combi (4-Türer) LCV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2021,
    "Mo": "Berlingo Combi (4-Türer) LCV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2022,
    "Mo": "Berlingo Combi (4-Türer) LCV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2023,
    "Mo": "Berlingo Combi (4-Türer) LCV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "Berlingo Combi (4-Türer) LCV K9 | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "Berlingo Combi (4-Türer) LCV K9 Facelift | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2025,
    "Mo": "Berlingo Combi (4-Türer) LCV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2026,
    "Mo": "Berlingo Combi (4-Türer) LCV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 250 LWB (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Connect 250 LWB (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Connect 250 LWB (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Connect 250 LWB (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Connect 250 LWB (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Connect 250 LWB (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Connect 250 LWB (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Connect 250 LWB (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Connect 250 LWB (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Transit Connect 200 (4-Türer) LCV 2nd Generation | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit Connect 200 (4-Türer) LCV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit Connect 200 (4-Türer) LCV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit Connect 200 (4-Türer) LCV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit Connect 200 (4-Türer) LCV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 200 (4-Türer) LCV 2nd Generation | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 200 (4-Türer) LCV 2nd Generation Facelift | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Connect 200 (4-Türer) LCV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Connect 200 (4-Türer) LCV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Connect 200 (4-Türer) LCV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Connect 200 (4-Türer) LCV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Transit Connect 220 (4-Türer) LCV 2nd Generation | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit Connect 220 (4-Türer) LCV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit Connect 220 (4-Türer) LCV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit Connect 220 (4-Türer) LCV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit Connect 220 (4-Türer) LCV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 220 (4-Türer) LCV 2nd Generation | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 210 (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Connect 210 (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Connect 210 (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Connect 210 (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Connect 210 (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Connect 210 (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Connect 210 (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Connect 210 (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Connect 210 (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 220 (4-Türer) LCV 2nd Generation Facelift | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Connect 220 (4-Türer) LCV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Connect 220 (4-Türer) LCV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Connect 220 (4-Türer) LCV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Connect 220 (4-Türer) LCV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 220 Combi (5-Türer) LCV 2nd Generation Facelift | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Connect 220 Combi (5-Türer) LCV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Connect 220 Combi (5-Türer) LCV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Connect 220 Combi (5-Türer) LCV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Connect 220 Combi (5-Türer) LCV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Transit Connect 220 Combi (5-Türer) LCV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit Connect 220 Combi (5-Türer) LCV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit Connect 220 Combi (5-Türer) LCV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit Connect 220 Combi (5-Türer) LCV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit Connect 220 Combi (5-Türer) LCV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 220 Combi (5-Türer) LCV 2nd Generation | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 220 LWB (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Connect 220 LWB (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Connect 220 LWB (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Connect 220 LWB (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Connect 220 LWB (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Connect 220 LWB (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Connect 220 LWB (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Connect 220 LWB (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Connect 220 LWB (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 230 (4-Türer) LCV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Connect 230 (4-Türer) LCV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Connect 230 (4-Türer) LCV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Connect 230 (4-Türer) LCV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Connect 230 (4-Türer) LCV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Connect 230 (4-Türer) LCV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 230 Combi (5-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Connect 230 Combi (5-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Connect 230 Combi (5-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Connect 230 Combi (5-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Connect 230 Combi (5-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Connect 230 Combi (5-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Connect 230 Combi (5-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Connect 230 Combi (5-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Connect 230 Combi (5-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV 2nd Generation | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV 2nd Generation | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 230 Combi LWB (5-Türer) LCV 2nd Generation Facelift | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Connect 230 Combi LWB (5-Türer) LCV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Connect 230 Combi LWB (5-Türer) LCV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Connect 230 Combi LWB (5-Türer) LCV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Connect 230 Combi LWB (5-Türer) LCV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Transit Connect 230 Combi LWB (5-Türer) LCV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit Connect 230 Combi LWB (5-Türer) LCV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit Connect 230 Combi LWB (5-Türer) LCV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit Connect 230 Combi LWB (5-Türer) LCV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit Connect 230 Combi LWB (5-Türer) LCV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 230 Combi LWB (5-Türer) LCV 2nd Generation | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV 2nd Generation Facelift | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Connect 230 LWB (4-Türer) LCV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 240 (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Connect 240 (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Connect 240 (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Connect 240 (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Connect 240 (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Connect 240 (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Connect 240 (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Connect 240 (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Connect 240 (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 240 Combi LWB (5-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Connect 240 Combi LWB (5-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Connect 240 Combi LWB (5-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Connect 240 Combi LWB (5-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Connect 240 Combi LWB (5-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Connect 240 Combi LWB (5-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Connect 240 Combi LWB (5-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Connect 240 Combi LWB (5-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Connect 240 Combi LWB (5-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 240 Crew Van LWB (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Connect 240 Crew Van LWB (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Connect 240 Crew Van LWB (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Connect 240 Crew Van LWB (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Connect 240 Crew Van LWB (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Connect 240 Crew Van LWB (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Connect 240 Crew Van LWB (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Connect 240 Crew Van LWB (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Connect 240 Crew Van LWB (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 240 LWB (4-Türer) LCV 2nd Generation Facelift | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Connect 240 LWB (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Connect 240 LWB (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Connect 240 LWB (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Connect 240 LWB (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Connect 240 LWB (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Connect 240 LWB (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Connect 240 LWB (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Connect 240 LWB (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Transit Connect 240 LWB (4-Türer) LCV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit Connect 240 LWB (4-Türer) LCV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit Connect 240 LWB (4-Türer) LCV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit Connect 240 LWB (4-Türer) LCV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit Connect 240 LWB (4-Türer) LCV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 240 LWB (4-Türer) LCV 2nd Generation | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect 250 (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Connect 250 (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Connect 250 (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Connect 250 (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Connect 250 (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Connect 250 (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Connect 250 (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Connect 250 (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Connect 250 (4-Türer) LCV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Custom 340 Crew Van (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Custom 340 Crew Van (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Custom 340 Crew Van (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Custom 340 Crew Van (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Custom 280 (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Custom 280 (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Custom 280 (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Custom 280 (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Custom 300 (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Custom 300 (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Custom 300 (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Custom 300 (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Custom 300 Crew Van (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Custom 300 Crew Van (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Custom 300 Crew Van (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Custom 300 Crew Van (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Custom 320 (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Custom 320 (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Custom 320 (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Custom 320 (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Custom 320 Combi (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Custom 320 Combi (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Custom 320 Combi (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Custom 320 Combi (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Custom 320 Crew Van (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Custom 320 Crew Van (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Custom 320 Crew Van (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Custom 320 Crew Van (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Custom 340 (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Custom 340 (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Custom 340 (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Custom 340 (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Custom 340 Combi (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Custom 340 Combi (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Custom 340 Combi (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Custom 340 Combi (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Tourneo Custom 340 (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Tourneo Custom 340 (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Tourneo Custom 340 (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Tourneo Custom 340 (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Tourneo Custom 320 (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Tourneo Custom 320 (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Tourneo Custom 320 (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Tourneo Custom 320 (4-Türer) LCV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Caravelle T32 (3-Türer) MPV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Caravelle T32 (3-Türer) MPV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Caravelle T32 (3-Türer) MPV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Caravelle T32 (3-Türer) MPV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Caravelle T32 (3-Türer) MPV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Caravelle T30 (3-Türer) MPV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Caravelle T30 (3-Türer) MPV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Caravelle T30 (3-Türer) MPV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Transporter T32 (3-Türer) LCV T7 | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Transporter T32 (3-Türer) LCV T7 | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter T32 (3-Türer) LCV T7 | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Transporter T32 (3-Türer) LCV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Transporter T32 (3-Türer) LCV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter Combi T32 (4-Türer) LCV T7 | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Transporter Combi T32 (4-Türer) LCV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter Plus T28 (4-Türer) LCV T7 | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Transporter Plus T28 (4-Türer) LCV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Transporter Plus T28 (4-Türer) LCV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter Plus T30 (4-Türer) LCV T7 | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Transporter Plus T30 (4-Türer) LCV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Transporter Plus T30 (4-Türer) LCV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter T28 (3-Türer) LCV T7 | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Transporter T28 (3-Türer) LCV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Transporter T28 (3-Türer) LCV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter T30 (3-Türer) LCV T7 | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Transporter T30 (3-Türer) LCV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Transporter T30 (3-Türer) LCV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2024,
    "Mo": "Seal 6 Touring (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2025,
    "Mo": "Seal 6 Touring (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2026,
    "Mo": "Seal 6 Touring (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Maxus",
    "Y": 2025,
    "Mo": "e-Terron 9 (4-Türer) Pickup | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Maxus",
    "Y": 2026,
    "Mo": "e-Terron 9 (4-Türer) Pickup | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2024,
    "Mo": "ZS SUV (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2025,
    "Mo": "ZS SUV (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2026,
    "Mo": "ZS SUV (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2025,
    "Mo": "Atto 2 (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2026,
    "Mo": "Atto 2 (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Leapmotor",
    "Y": 2024,
    "Mo": "C10 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Leapmotor",
    "Y": 2025,
    "Mo": "C10 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Leapmotor",
    "Y": 2026,
    "Mo": "C10 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2026,
    "Mo": "CX-5 (5-Türer) SUV | 2026-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2004,
    "Mo": "156 Crosswagon (932B Series 3) (5-Türer) Crossover | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2005,
    "Mo": "156 Crosswagon (932B Series 3) (5-Türer) Crossover | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2006,
    "Mo": "156 Crosswagon (932B Series 3) (5-Türer) Crossover | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2007,
    "Mo": "156 Crosswagon (932B Series 3) (5-Türer) Crossover | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2003,
    "Mo": "156 Sportwagon (932B Series 3) (5-Türer) Kombi | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2004,
    "Mo": "156 Sportwagon (932B Series 3) (5-Türer) Kombi | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2005,
    "Mo": "156 Sportwagon (932B Series 3) (5-Türer) Kombi | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2006,
    "Mo": "156 Sportwagon (932B Series 3) (5-Türer) Kombi | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2007,
    "Mo": "156 Sportwagon (932B Series 3) (5-Türer) Kombi | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2000,
    "Mo": "156 Sportwagon (932B Series 1) (5-Türer) Kombi | 2000-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2001,
    "Mo": "156 Sportwagon (932B Series 1) (5-Türer) Kombi | 2000-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2002,
    "Mo": "156 Sportwagon (932B Series 1) (5-Türer) Kombi | 2000-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2002,
    "Mo": "156 Sportwagon (932B Series 2) (5-Türer) Kombi | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2003,
    "Mo": "156 Sportwagon (932B Series 2) (5-Türer) Kombi | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2004,
    "Mo": "156 Sportwagon (932B Series 2) (5-Türer) Kombi | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2005,
    "Mo": "156 Sportwagon (932B Series 2) (5-Türer) Kombi | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2008,
    "Mo": "159 Sportwagon (939B Facelift) (5-Türer) Kombi | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2009,
    "Mo": "159 Sportwagon (939B Facelift) (5-Türer) Kombi | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2010,
    "Mo": "159 Sportwagon (939B Facelift) (5-Türer) Kombi | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2011,
    "Mo": "159 Sportwagon (939B Facelift) (5-Türer) Kombi | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2012,
    "Mo": "159 Sportwagon (939B Facelift) (5-Türer) Kombi | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2005,
    "Mo": "159 Sportwagon (939B) (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2006,
    "Mo": "159 Sportwagon (939B) (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2007,
    "Mo": "159 Sportwagon (939B) (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2008,
    "Mo": "159 Sportwagon (939B) (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1991,
    "Mo": "100 Avant (5-Türer) Kombi C4 | 1991-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1992,
    "Mo": "100 Avant (5-Türer) Kombi | 1991-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1993,
    "Mo": "100 Avant (5-Türer) Kombi | 1991-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1994,
    "Mo": "100 Avant (5-Türer) Kombi | 1991-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1988,
    "Mo": "100 Avant (5-Türer) Kombi C3 Facelift | 1988-1991",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1989,
    "Mo": "100 Avant (5-Türer) Kombi | 1988-1991",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1990,
    "Mo": "100 Avant (5-Türer) Kombi | 1988-1991",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1991,
    "Mo": "100 Avant (5-Türer) Kombi C3 Facelift | 1988-1991",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1983,
    "Mo": "100 Avant (5-Türer) Kombi | 1983-1988",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1984,
    "Mo": "100 Avant (5-Türer) Kombi | 1983-1988",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1985,
    "Mo": "100 Avant (5-Türer) Kombi | 1983-1988",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1986,
    "Mo": "100 Avant (5-Türer) Kombi | 1983-1988",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1987,
    "Mo": "100 Avant (5-Türer) Kombi | 1983-1988",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1988,
    "Mo": "100 Avant (5-Türer) Kombi C3 | 1983-1988",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1992,
    "Mo": "80 Avant (5-Türer) Kombi | 1992-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1993,
    "Mo": "80 Avant (5-Türer) Kombi | 1992-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1994,
    "Mo": "80 Avant (5-Türer) Kombi | 1992-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1995,
    "Mo": "80 Avant (5-Türer) Kombi | 1992-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1996,
    "Mo": "80 Avant (5-Türer) Kombi | 1992-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2009,
    "Mo": "A4 allroad quattro (5-Türer) Crossover | 2009-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2010,
    "Mo": "A4 allroad quattro (5-Türer) Crossover | 2009-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2011,
    "Mo": "A4 allroad quattro (5-Türer) Crossover | 2009-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2012,
    "Mo": "A4 allroad quattro (5-Türer) Crossover B8 | 2009-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "A4 allroad quattro (5-Türer) Crossover B9 Facelift | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "A4 allroad quattro (5-Türer) Crossover | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "A4 allroad quattro (5-Türer) Crossover | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "A4 allroad quattro (5-Türer) Crossover | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "A4 allroad quattro (5-Türer) Crossover | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "A4 allroad quattro (5-Türer) Crossover | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "A4 allroad quattro (5-Türer) Crossover | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2026,
    "Mo": "A4 allroad quattro (5-Türer) Crossover | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2016,
    "Mo": "A4 allroad quattro (5-Türer) Crossover B9 | 2016-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2017,
    "Mo": "A4 allroad quattro (5-Türer) Crossover | 2016-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2018,
    "Mo": "A4 allroad quattro (5-Türer) Crossover | 2016-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "A4 allroad quattro (5-Türer) Crossover B9 | 2016-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2012,
    "Mo": "A4 allroad quattro (5-Türer) Crossover B8 Facelift | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2013,
    "Mo": "A4 allroad quattro (5-Türer) Crossover | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2014,
    "Mo": "A4 allroad quattro (5-Türer) Crossover | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2015,
    "Mo": "A4 allroad quattro (5-Türer) Crossover | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2016,
    "Mo": "A4 allroad quattro (5-Türer) Crossover B8 Facelift | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1995,
    "Mo": "A4 Avant (5-Türer) Kombi | 1995-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1996,
    "Mo": "A4 Avant (5-Türer) Kombi | 1995-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1997,
    "Mo": "A4 Avant (5-Türer) Kombi | 1995-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1998,
    "Mo": "A4 Avant (5-Türer) Kombi | 1995-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1999,
    "Mo": "A4 Avant (5-Türer) Kombi B5 | 1995-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1999,
    "Mo": "A4 Avant (5-Türer) Kombi B5 Facelift | 1999-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2000,
    "Mo": "A4 Avant (5-Türer) Kombi | 1999-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2001,
    "Mo": "A4 Avant (5-Türer) Kombi | 1999-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2002,
    "Mo": "A4 Avant (5-Türer) Kombi | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2003,
    "Mo": "A4 Avant (5-Türer) Kombi | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2004,
    "Mo": "A4 Avant (5-Türer) Kombi | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2005,
    "Mo": "A4 Avant (5-Türer) Kombi B6 | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2005,
    "Mo": "A4 Avant (5-Türer) Kombi B7 | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2006,
    "Mo": "A4 Avant (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2007,
    "Mo": "A4 Avant (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2008,
    "Mo": "A4 Avant (5-Türer) Kombi B7 | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1999,
    "Mo": "A6 allroad quattro (5-Türer) Crossover | 1999-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2000,
    "Mo": "A6 allroad quattro (5-Türer) Crossover | 1999-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2001,
    "Mo": "A6 allroad quattro (5-Türer) Crossover | 1999-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2002,
    "Mo": "A6 allroad quattro (5-Türer) Crossover | 2002-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2003,
    "Mo": "A6 allroad quattro (5-Türer) Crossover | 2002-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2004,
    "Mo": "A6 allroad quattro (5-Türer) Crossover | 2002-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2005,
    "Mo": "A6 allroad quattro (5-Türer) Crossover | 2002-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2006,
    "Mo": "A6 allroad quattro (5-Türer) Crossover | 2002-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2015,
    "Mo": "A6 allroad quattro (5-Türer) Crossover C7 Facelift | 2015-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2016,
    "Mo": "A6 allroad quattro (5-Türer) Crossover | 2015-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2017,
    "Mo": "A6 allroad quattro (5-Türer) Crossover | 2015-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2018,
    "Mo": "A6 allroad quattro (5-Türer) Crossover | 2015-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2012,
    "Mo": "A6 allroad quattro (5-Türer) Crossover | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2013,
    "Mo": "A6 allroad quattro (5-Türer) Crossover | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2014,
    "Mo": "A6 allroad quattro (5-Türer) Crossover | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2015,
    "Mo": "A6 allroad quattro (5-Türer) Crossover C7 | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2007,
    "Mo": "A6 allroad quattro (5-Türer) Crossover | 2007-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2008,
    "Mo": "A6 allroad quattro (5-Türer) Crossover | 2007-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2009,
    "Mo": "A6 allroad quattro (5-Türer) Crossover C6 | 2007-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "A6 allroad quattro (5-Türer) Crossover | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "A6 allroad quattro (5-Türer) Crossover | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "A6 allroad quattro (5-Türer) Crossover | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "A6 allroad quattro (5-Türer) Crossover | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "A6 allroad quattro (5-Türer) Crossover | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "A6 allroad quattro (5-Türer) Crossover | 2024-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "A6 allroad quattro (5-Türer) Crossover | 2024-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2009,
    "Mo": "A6 allroad quattro (5-Türer) Crossover C6 Facelift | 2009-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2010,
    "Mo": "A6 allroad quattro (5-Türer) Crossover | 2009-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2011,
    "Mo": "A6 allroad quattro (5-Türer) Crossover | 2009-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1998,
    "Mo": "A6 Avant (5-Türer) Kombi C5 | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1999,
    "Mo": "A6 Avant (5-Türer) Kombi | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2000,
    "Mo": "A6 Avant (5-Türer) Kombi | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2001,
    "Mo": "A6 Avant (5-Türer) Kombi | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1995,
    "Mo": "A6 Avant (5-Türer) Kombi | 1995-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1996,
    "Mo": "A6 Avant (5-Türer) Kombi | 1995-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1997,
    "Mo": "A6 Avant (5-Türer) Kombi | 1995-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1998,
    "Mo": "A6 Avant (5-Türer) Kombi C4 | 1995-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2002,
    "Mo": "A6 Avant (5-Türer) Kombi | 2002-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2003,
    "Mo": "A6 Avant (5-Türer) Kombi | 2002-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2004,
    "Mo": "A6 Avant (5-Türer) Kombi | 2002-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2005,
    "Mo": "A6 Avant (5-Türer) Kombi C5 Facelift | 2002-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2006,
    "Mo": "A6 Avant (5-Türer) Kombi C5 Facelift | 2002-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2006,
    "Mo": "3 Series Touring (E91) (5-Türer) Kombi | 2006-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2007,
    "Mo": "3 Series Touring (E91) (5-Türer) Kombi | 2006-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2008,
    "Mo": "3 Series Touring (E91) (5-Türer) Kombi | 2006-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2009,
    "Mo": "3 Series Touring (E91 LCI) (5-Türer) Kombi | 2009-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2010,
    "Mo": "3 Series Touring (E91 LCI) (5-Türer) Kombi | 2009-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2011,
    "Mo": "3 Series Touring (E91 LCI) (5-Türer) Kombi | 2009-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2012,
    "Mo": "3 Series Touring (E91 LCI) (5-Türer) Kombi | 2009-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2000,
    "Mo": "3 Series Touring (E46/3) (5-Türer) Kombi | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2001,
    "Mo": "3 Series Touring (E46/3) (5-Türer) Kombi | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2002,
    "Mo": "3 Series Touring (E46/3) (5-Türer) Kombi E46 | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2003,
    "Mo": "3 Series Touring (E46/3) (5-Türer) Kombi E46 | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2004,
    "Mo": "3 Series Touring (E46/3) (5-Türer) Kombi E46 | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2005,
    "Mo": "3 Series Touring (E46/3) (5-Türer) Kombi E46 | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2002,
    "Mo": "3 Series Touring (E46/3) (5-Türer) Kombi E46 Facelift | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2003,
    "Mo": "3 Series Touring (E46/3) (5-Türer) Kombi E46 Facelift | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2004,
    "Mo": "3 Series Touring (E46/3) (5-Türer) Kombi E46 Facelift | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2005,
    "Mo": "3 Series Touring (E46/3) (5-Türer) Kombi E46 Facelift | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2007,
    "Mo": "5 Series Touring (E61) (5-Türer) Kombi E60 Facelift | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2008,
    "Mo": "5 Series Touring (E61) (5-Türer) Kombi | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2009,
    "Mo": "5 Series Touring (E61) (5-Türer) Kombi | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2010,
    "Mo": "5 Series Touring (E61) (5-Türer) Kombi | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2004,
    "Mo": "5 Series Touring (E61) (5-Türer) Kombi | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2005,
    "Mo": "5 Series Touring (E61) (5-Türer) Kombi | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2006,
    "Mo": "5 Series Touring (E61) (5-Türer) Kombi | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2007,
    "Mo": "5 Series Touring (E61) (5-Türer) Kombi E60 | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 1997,
    "Mo": "5 Series Touring (E39/5) (5-Türer) Kombi | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 1998,
    "Mo": "5 Series Touring (E39/5) (5-Türer) Kombi | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 1999,
    "Mo": "5 Series Touring (E39/5) (5-Türer) Kombi | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2000,
    "Mo": "5 Series Touring (E39/5) (5-Türer) Kombi | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2001,
    "Mo": "5 Series Touring (E39/5) (5-Türer) Kombi | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2001,
    "Mo": "5 Series Touring (E39/5 LCI) (5-Türer) Kombi | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2002,
    "Mo": "5 Series Touring (E39/5 LCI) (5-Türer) Kombi | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2003,
    "Mo": "5 Series Touring (E39/5 LCI) (5-Türer) Kombi | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2004,
    "Mo": "5 Series Touring (E39/5 LCI) (5-Türer) Kombi | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2007,
    "Mo": "X3 (E83 LCI) (5-Türer) SUV | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2008,
    "Mo": "X3 (E83 LCI) (5-Türer) SUV | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2009,
    "Mo": "X3 (E83 LCI) (5-Türer) SUV | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2010,
    "Mo": "X3 (E83 LCI) (5-Türer) SUV | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2011,
    "Mo": "X3 (E83 LCI) (5-Türer) SUV | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2004,
    "Mo": "X3 (E83) (5-Türer) SUV | 2004-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2005,
    "Mo": "X3 (E83) (5-Türer) SUV | 2004-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2006,
    "Mo": "X3 (E83) (5-Türer) SUV | 2004-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2000,
    "Mo": "X5 (E53) (5-Türer) SUV | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2001,
    "Mo": "X5 (E53) (5-Türer) SUV | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2002,
    "Mo": "X5 (E53) (5-Türer) SUV | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2003,
    "Mo": "X5 (E53) (5-Türer) SUV | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2004,
    "Mo": "X5 (E53) (5-Türer) SUV | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2004,
    "Mo": "X5 (E53 LCI) (5-Türer) SUV | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2005,
    "Mo": "X5 (E53 LCI) (5-Türer) SUV | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2006,
    "Mo": "X5 (E53 LCI) (5-Türer) SUV | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2007,
    "Mo": "X5 (E53 LCI) (5-Türer) SUV | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2011,
    "Mo": "X5 (E70 LCI) (5-Türer) SUV | 2011-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2012,
    "Mo": "X5 (E70 LCI) (5-Türer) SUV | 2011-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2013,
    "Mo": "X5 (E70 LCI) (5-Türer) SUV | 2011-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2007,
    "Mo": "X5 (E70) (5-Türer) SUV | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2008,
    "Mo": "X5 (E70) (5-Türer) SUV | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2009,
    "Mo": "X5 (E70) (5-Türer) SUV | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2010,
    "Mo": "X5 (E70) (5-Türer) SUV | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2011,
    "Mo": "X5 (E70) (5-Türer) SUV | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2007,
    "Mo": "X5 7-Seater (5-Türer) SUV | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2008,
    "Mo": "X5 7-Seater (5-Türer) SUV | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2009,
    "Mo": "X5 7-Seater (5-Türer) SUV | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2010,
    "Mo": "X5 7-Seater (5-Türer) SUV | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2011,
    "Mo": "X5 7-Seater (5-Türer) SUV E70 | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2011,
    "Mo": "X5 7-Seater (5-Türer) SUV E70 Facelift | 2011-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2012,
    "Mo": "X5 7-Seater (5-Türer) SUV | 2011-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2013,
    "Mo": "X5 7-Seater (5-Türer) SUV | 2011-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2008,
    "Mo": "C-Crosser (5-Türer) SUV | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2009,
    "Mo": "C-Crosser (5-Türer) SUV | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "C-Crosser (5-Türer) SUV | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2011,
    "Mo": "C-Crosser (5-Türer) SUV | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "C-Crosser (5-Türer) SUV | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "C-Crosser (5-Türer) SUV | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2009,
    "Mo": "C3 Picasso (5-Türer) Kombi | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "C3 Picasso (5-Türer) Kombi | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2011,
    "Mo": "C3 Picasso (5-Türer) Kombi | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "C3 Picasso (5-Türer) Kombi SH | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "C3 Picasso (5-Türer) Kombi SH | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "C3 Picasso (5-Türer) Kombi SH Facelift | 2012-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "C3 Picasso (5-Türer) Kombi SH Facelift | 2012-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "C3 Picasso (5-Türer) Kombi | 2012-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2015,
    "Mo": "C3 Picasso (5-Türer) Kombi | 2012-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "C3 Picasso (5-Türer) Kombi | 2012-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2017,
    "Mo": "C3 Picasso (5-Türer) Kombi | 2012-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2006,
    "Mo": "C4 Picasso (5-Türer) MPV | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2007,
    "Mo": "C4 Picasso (5-Türer) MPV | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2008,
    "Mo": "C4 Picasso (5-Türer) MPV | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2009,
    "Mo": "C4 Picasso (5-Türer) MPV | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "C4 Picasso (5-Türer) MPV UD | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "C4 Picasso (5-Türer) MPV UD Facelift | 2010-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2011,
    "Mo": "C4 Picasso (5-Türer) MPV | 2010-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "C4 Picasso (5-Türer) MPV | 2010-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "C4 Picasso (5-Türer) MPV UD Facelift | 2010-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2007,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2008,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2009,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "Grand C4 Picasso (5-Türer) MPV UD | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "Grand C4 Picasso (5-Türer) MPV UD Facelift | 2010-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2011,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2010-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "Grand C4 Picasso (5-Türer) MPV | 2010-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "Grand C4 Picasso (5-Türer) MPV UD Facelift | 2010-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2008,
    "Mo": "C5 Wagon (5-Türer) Kombi RD/TD | 2008-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2009,
    "Mo": "C5 Wagon (5-Türer) Kombi | 2008-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "C5 Wagon (5-Türer) Kombi RD/TD | 2008-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "C5 Wagon (5-Türer) Kombi RD/TD Facelift | 2010-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2011,
    "Mo": "C5 Wagon (5-Türer) Kombi | 2010-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "C5 Wagon (5-Türer) Kombi | 2010-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "C5 Wagon (5-Türer) Kombi | 2010-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "C5 Wagon (5-Türer) Kombi | 2010-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2015,
    "Mo": "C5 Wagon (5-Türer) Kombi | 2010-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "C5 Wagon (5-Türer) Kombi | 2010-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2017,
    "Mo": "C5 Wagon (5-Türer) Kombi | 2010-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2005,
    "Mo": "C5 Wagon (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2006,
    "Mo": "C5 Wagon (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2007,
    "Mo": "C5 Wagon (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2008,
    "Mo": "C5 Wagon (5-Türer) Kombi DC/DE Facelift | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2001,
    "Mo": "C5 Wagon (5-Türer) Kombi | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2002,
    "Mo": "C5 Wagon (5-Türer) Kombi | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2003,
    "Mo": "C5 Wagon (5-Türer) Kombi | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2004,
    "Mo": "C5 Wagon (5-Türer) Kombi | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2007,
    "Mo": "Nemo Combi (4-Türer) LCV | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2008,
    "Mo": "Nemo Combi (4-Türer) LCV | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2009,
    "Mo": "Nemo Combi (4-Türer) LCV | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "Nemo Combi (4-Türer) LCV | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2011,
    "Mo": "Nemo Combi (4-Türer) LCV | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "Nemo Combi (4-Türer) LCV | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "Nemo Combi (4-Türer) LCV | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "Nemo Combi (4-Türer) LCV | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2009,
    "Mo": "Nemo Multispace (5-Türer) LCV | 2009-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "Nemo Multispace (5-Türer) LCV | 2009-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2011,
    "Mo": "Nemo Multispace (5-Türer) LCV | 2009-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "Nemo Multispace (5-Türer) LCV | 2009-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "Nemo Multispace (5-Türer) LCV | 2009-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "Nemo Multispace (5-Türer) LCV | 2009-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2007,
    "Mo": "Nemo Van (2-Türer) LCV | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2008,
    "Mo": "Nemo Van (2-Türer) LCV | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2009,
    "Mo": "Nemo Van (2-Türer) LCV | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "Nemo Van (2-Türer) LCV | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2011,
    "Mo": "Nemo Van (2-Türer) LCV | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "Nemo Van (2-Türer) LCV | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "Nemo Van (2-Türer) LCV | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "Nemo Van (2-Türer) LCV | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 1992,
    "Mo": "XM Break (5-Türer) Kombi | 1992-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 1993,
    "Mo": "XM Break (5-Türer) Kombi | 1992-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 1994,
    "Mo": "XM Break (5-Türer) Kombi | 1992-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 1995,
    "Mo": "XM Break (5-Türer) Kombi | 1995-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 1996,
    "Mo": "XM Break (5-Türer) Kombi | 1995-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 1997,
    "Mo": "XM Break (5-Türer) Kombi | 1995-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 1998,
    "Mo": "XM Break (5-Türer) Kombi | 1995-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 1999,
    "Mo": "XM Break (5-Türer) Kombi | 1995-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2000,
    "Mo": "XM Break (5-Türer) Kombi | 1995-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2001,
    "Mo": "XM Break (5-Türer) Kombi | 1995-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 1995,
    "Mo": "ZX Break (5-Türer) Kombi | 1995-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 1996,
    "Mo": "ZX Break (5-Türer) Kombi | 1995-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 1997,
    "Mo": "ZX Break (5-Türer) Kombi | 1995-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 1998,
    "Mo": "ZX Break (5-Türer) Kombi | 1995-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 1994,
    "Mo": "ZX Break (5-Türer) Kombi | 1994-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2011,
    "Mo": "Captiva (5-Türer) SUV C100 1st Facelift | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2012,
    "Mo": "Captiva (5-Türer) SUV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2013,
    "Mo": "Captiva (5-Türer) SUV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2014,
    "Mo": "Captiva (5-Türer) SUV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2015,
    "Mo": "Captiva (5-Türer) SUV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2007,
    "Mo": "Captiva (5-Türer) SUV | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2008,
    "Mo": "Captiva (5-Türer) SUV | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2009,
    "Mo": "Captiva (5-Türer) SUV | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2010,
    "Mo": "Captiva (5-Türer) SUV | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2011,
    "Mo": "Captiva (5-Türer) SUV C100 | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1998,
    "Mo": "Corsa Wagon (5-Türer) Kombi | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1999,
    "Mo": "Corsa Wagon (5-Türer) Kombi | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2000,
    "Mo": "Corsa Wagon (5-Türer) Kombi | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2001,
    "Mo": "Corsa Wagon (5-Türer) Kombi | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2002,
    "Mo": "Corsa Wagon (5-Türer) Kombi | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2003,
    "Mo": "Corsa Wagon (5-Türer) Kombi | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2004,
    "Mo": "Corsa Wagon (5-Türer) Kombi | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2005,
    "Mo": "Corsa Wagon (5-Türer) Kombi | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2006,
    "Mo": "Corsa Wagon (5-Türer) Kombi | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2007,
    "Mo": "Corsa Wagon (5-Türer) Kombi | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2013,
    "Mo": "Cruze Station Wagon (J308) (5-Türer) Kombi | 2013-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2014,
    "Mo": "Cruze Station Wagon (J308) (5-Türer) Kombi | 2013-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2015,
    "Mo": "Cruze Station Wagon (J308) (5-Türer) Kombi | 2013-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2016,
    "Mo": "Cruze Station Wagon (J308) (5-Türer) Kombi | 2013-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2007,
    "Mo": "HHR Panel (5-Türer) LCV | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2008,
    "Mo": "HHR Panel (5-Türer) LCV | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2009,
    "Mo": "HHR Panel (5-Türer) LCV | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2010,
    "Mo": "HHR Panel (5-Türer) LCV | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2011,
    "Mo": "HHR Panel (5-Türer) LCV | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2004,
    "Mo": "Lacetti Wagon (5-Türer) Kombi | 2004-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2005,
    "Mo": "Lacetti Wagon (5-Türer) Kombi | 2004-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2006,
    "Mo": "Lacetti Wagon (5-Türer) Kombi | 2004-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2007,
    "Mo": "Lacetti Wagon (5-Türer) Kombi | 2004-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2008,
    "Mo": "Lacetti Wagon (5-Türer) Kombi | 2004-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2009,
    "Mo": "Lacetti Wagon (5-Türer) Kombi | 2004-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2010,
    "Mo": "Lacetti Wagon (5-Türer) Kombi | 2004-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2011,
    "Mo": "Lacetti Wagon (5-Türer) Kombi | 2004-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2012,
    "Mo": "Lacetti Wagon (5-Türer) Kombi | 2004-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2013,
    "Mo": "Lacetti Wagon (5-Türer) Kombi | 2004-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2005,
    "Mo": "Matiz (5-Türer) Schrägheck | 2005-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2006,
    "Mo": "Matiz (5-Türer) Schrägheck | 2005-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2007,
    "Mo": "Matiz (5-Türer) Schrägheck | 2005-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2008,
    "Mo": "Matiz (5-Türer) Schrägheck | 2005-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2009,
    "Mo": "Matiz (5-Türer) Schrägheck | 2005-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2010,
    "Mo": "Matiz (5-Türer) Schrägheck | 2005-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2004,
    "Mo": "Nubira Station Wagon (5-Türer) Kombi | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2005,
    "Mo": "Nubira Station Wagon (5-Türer) Kombi | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2006,
    "Mo": "Nubira Station Wagon (5-Türer) Kombi | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2007,
    "Mo": "Nubira Station Wagon (5-Türer) Kombi | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2008,
    "Mo": "Nubira Station Wagon (5-Türer) Kombi | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2009,
    "Mo": "Nubira Station Wagon (5-Türer) Kombi | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2010,
    "Mo": "Nubira Station Wagon (5-Türer) Kombi | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2011,
    "Mo": "Nubira Station Wagon (5-Türer) Kombi | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2004,
    "Mo": "Rezzo (5-Türer) MPV | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2005,
    "Mo": "Rezzo (5-Türer) MPV | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2006,
    "Mo": "Rezzo (5-Türer) MPV | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2007,
    "Mo": "Rezzo (5-Türer) MPV | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2008,
    "Mo": "Rezzo (5-Türer) MPV | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2010,
    "Mo": "Spark (5-Türer) Schrägheck | 2010-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2011,
    "Mo": "Spark (5-Türer) Schrägheck | 2010-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2012,
    "Mo": "Spark (5-Türer) Schrägheck | 2010-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2013,
    "Mo": "Spark (5-Türer) Schrägheck M300 | 2010-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2013,
    "Mo": "Spark (5-Türer) Schrägheck M300 Facelift | 2013-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2014,
    "Mo": "Spark (5-Türer) Schrägheck | 2013-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2015,
    "Mo": "Spark (5-Türer) Schrägheck | 2013-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2016,
    "Mo": "Spark (5-Türer) Schrägheck | 2013-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2000,
    "Mo": "Tahoe (5-Türer) SUV | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2001,
    "Mo": "Tahoe (5-Türer) SUV | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2002,
    "Mo": "Tahoe (5-Türer) SUV | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2003,
    "Mo": "Tahoe (5-Türer) SUV | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2004,
    "Mo": "Tahoe (5-Türer) SUV | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2005,
    "Mo": "Tahoe (5-Türer) SUV | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2006,
    "Mo": "Tahoe (5-Türer) SUV | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1997,
    "Mo": "Trans Sport (4-Türer) MPV | 1997-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1998,
    "Mo": "Trans Sport (4-Türer) MPV | 1997-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1999,
    "Mo": "Trans Sport (4-Türer) MPV | 1997-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2000,
    "Mo": "Trans Sport (4-Türer) MPV | 1997-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2001,
    "Mo": "Trans Sport (4-Türer) MPV | 2001-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2002,
    "Mo": "Trans Sport (4-Türer) MPV | 2001-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2003,
    "Mo": "Trans Sport (4-Türer) MPV | 2001-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2004,
    "Mo": "Trans Sport (4-Türer) MPV | 2001-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2005,
    "Mo": "Trans Sport (4-Türer) MPV | 2001-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2004,
    "Mo": "Zafira (5-Türer) MPV | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2005,
    "Mo": "Zafira (5-Türer) MPV | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2006,
    "Mo": "Zafira (5-Türer) MPV | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2007,
    "Mo": "Zafira (5-Türer) MPV | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2008,
    "Mo": "Zafira (5-Türer) MPV | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2009,
    "Mo": "Zafira (5-Türer) MPV | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2010,
    "Mo": "Zafira (5-Türer) MPV | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2011,
    "Mo": "Zafira (5-Türer) MPV | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2012,
    "Mo": "Zafira (5-Türer) MPV | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 2008,
    "Mo": "300C Touring (5-Türer) Kombi | 2008-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 2009,
    "Mo": "300C Touring (5-Türer) Kombi | 2008-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 2010,
    "Mo": "300C Touring (5-Türer) Kombi | 2008-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 2005,
    "Mo": "300C Touring (5-Türer) Kombi | 2005-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 2006,
    "Mo": "300C Touring (5-Türer) Kombi | 2005-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 2007,
    "Mo": "300C Touring (5-Türer) Kombi | 2005-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 2007,
    "Mo": "Aspen (5-Türer) SUV | 2007-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 2008,
    "Mo": "Aspen (5-Türer) SUV | 2007-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 2009,
    "Mo": "Aspen (5-Türer) SUV | 2007-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 2001,
    "Mo": "Town & Country (5-Türer) MPV | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 2002,
    "Mo": "Town & Country (5-Türer) MPV | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 2003,
    "Mo": "Town & Country (5-Türer) MPV | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 2004,
    "Mo": "Town & Country (5-Türer) MPV | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 1998,
    "Mo": "Town & Country LWB (5-Türer) MPV | 1998-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 1999,
    "Mo": "Town & Country LWB (5-Türer) MPV | 1998-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 2000,
    "Mo": "Town & Country LWB (5-Türer) MPV | 1998-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2018,
    "Mo": "Ateca (5-Türer) SUV | 2018-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2019,
    "Mo": "Ateca (5-Türer) SUV | 2018-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2020,
    "Mo": "Ateca (5-Türer) SUV | 2018-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2021,
    "Mo": "Ateca (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2022,
    "Mo": "Ateca (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2023,
    "Mo": "Ateca (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2024,
    "Mo": "Ateca (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2025,
    "Mo": "Ateca (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2026,
    "Mo": "Ateca (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2008,
    "Mo": "BLS Wagon (5-Türer) Kombi | 2008-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2009,
    "Mo": "BLS Wagon (5-Türer) Kombi | 2008-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2010,
    "Mo": "BLS Wagon (5-Türer) Kombi | 2008-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2007,
    "Mo": "SRX (GMT265) (5-Türer) SUV | 2007-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2008,
    "Mo": "SRX (GMT265) (5-Türer) SUV | 2007-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2009,
    "Mo": "SRX (GMT265) (5-Türer) SUV | 2007-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2005,
    "Mo": "SRX (GMT265) (5-Türer) SUV | 2005-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2006,
    "Mo": "SRX (GMT265) (5-Türer) SUV | 2005-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2007,
    "Mo": "SRX (EU) (GMT265) (5-Türer) SUV | 2007-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2008,
    "Mo": "SRX (EU) (GMT265) (5-Türer) SUV | 2007-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2009,
    "Mo": "SRX (EU) (GMT265) (5-Türer) SUV | 2007-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2005,
    "Mo": "SRX (EU) (GMT265) (5-Türer) SUV | 2005-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2006,
    "Mo": "SRX (EU) (GMT265) (5-Türer) SUV | 2005-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2007,
    "Mo": "A1 (5-Türer) Schrägheck | 2007-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2008,
    "Mo": "A1 (5-Türer) Schrägheck | 2007-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2009,
    "Mo": "A1 (5-Türer) Schrägheck | 2007-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2010,
    "Mo": "A1 (5-Türer) Schrägheck | 2007-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2011,
    "Mo": "A1 (5-Türer) Schrägheck | 2007-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2012,
    "Mo": "A1 (5-Türer) Schrägheck | 2007-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2013,
    "Mo": "A1 (5-Türer) Schrägheck | 2007-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2014,
    "Mo": "A1 (5-Türer) Schrägheck | 2007-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2015,
    "Mo": "A1 (5-Türer) Schrägheck | 2007-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2018,
    "Mo": "Tiggo 5 (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2019,
    "Mo": "Tiggo 5 (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2020,
    "Mo": "Tiggo 5 (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2021,
    "Mo": "Tiggo 5 (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2022,
    "Mo": "Tiggo 5 (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2023,
    "Mo": "Tiggo 5 (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2024,
    "Mo": "Tiggo 5 (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2025,
    "Mo": "Tiggo 5 (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2026,
    "Mo": "Tiggo 5 (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2006,
    "Mo": "V5 (5-Türer) MPV | 2006-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2007,
    "Mo": "V5 (5-Türer) MPV | 2006-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2008,
    "Mo": "V5 (5-Türer) MPV | 2006-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2009,
    "Mo": "V5 (5-Türer) MPV | 2006-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2010,
    "Mo": "V5 (5-Türer) MPV | 2006-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2011,
    "Mo": "V5 (5-Türer) MPV | 2006-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2012,
    "Mo": "V5 (5-Türer) MPV | 2006-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2013,
    "Mo": "V5 (5-Türer) MPV | 2006-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2014,
    "Mo": "V5 (5-Türer) MPV | 2006-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2015,
    "Mo": "V5 (5-Türer) MPV | 2006-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2025,
    "Mo": "Bigster (5-Türer) SUV | 2025-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2026,
    "Mo": "Bigster (5-Türer) SUV | 2025-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2022,
    "Mo": "Duster (5-Türer) SUV | 2022-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2023,
    "Mo": "Duster (5-Türer) SUV | 2022-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2024,
    "Mo": "Duster (5-Türer) SUV HM Facelift | 2022-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2018,
    "Mo": "Duster (5-Türer) SUV HM | 2018-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2019,
    "Mo": "Duster (5-Türer) SUV | 2018-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2020,
    "Mo": "Duster (5-Türer) SUV | 2018-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2021,
    "Mo": "Duster (5-Türer) SUV | 2018-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2013,
    "Mo": "Logan MCV (5-Türer) Kombi 2nd Generation | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2014,
    "Mo": "Logan MCV (5-Türer) Kombi | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2015,
    "Mo": "Logan MCV (5-Türer) Kombi | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2016,
    "Mo": "Logan MCV (5-Türer) Kombi | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2017,
    "Mo": "Logan MCV (5-Türer) Kombi 2nd Generation | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2017,
    "Mo": "Logan MCV (5-Türer) Kombi 2nd Generation Facelift | 2017-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2018,
    "Mo": "Logan MCV (5-Türer) Kombi | 2017-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2019,
    "Mo": "Logan MCV (5-Türer) Kombi | 2017-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2020,
    "Mo": "Logan MCV (5-Türer) Kombi | 2017-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2021,
    "Mo": "Logan MCV (5-Türer) Kombi | 2017-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2008,
    "Mo": "Logan MCV (5-Türer) Kombi LS Facelift | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2009,
    "Mo": "Logan MCV (5-Türer) Kombi | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2010,
    "Mo": "Logan MCV (5-Türer) Kombi | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2011,
    "Mo": "Logan MCV (5-Türer) Kombi | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2012,
    "Mo": "Logan MCV (5-Türer) Kombi | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2013,
    "Mo": "Logan MCV (5-Türer) Kombi LS Facelift | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2007,
    "Mo": "Logan MCV (5-Türer) Kombi | 2007-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2008,
    "Mo": "Logan MCV (5-Türer) Kombi LS | 2007-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2021,
    "Mo": "Sandero Stepway (5-Türer) Crossover 3rd Generation | 2021-2026",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2022,
    "Mo": "Sandero Stepway (5-Türer) Crossover | 2021-2026",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2023,
    "Mo": "Sandero Stepway (5-Türer) Crossover | 2021-2026",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2024,
    "Mo": "Sandero Stepway (5-Türer) Crossover | 2021-2026",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2025,
    "Mo": "Sandero Stepway (5-Türer) Crossover | 2021-2026",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2026,
    "Mo": "Sandero Stepway (5-Türer) Crossover 3rd Generation | 2021-2026",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2017,
    "Mo": "Sandero Stepway (5-Türer) Crossover 2nd Generation Facelift | 2017-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2018,
    "Mo": "Sandero Stepway (5-Türer) Crossover | 2017-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2019,
    "Mo": "Sandero Stepway (5-Türer) Crossover | 2017-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2020,
    "Mo": "Sandero Stepway (5-Türer) Crossover | 2017-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2021,
    "Mo": "Sandero Stepway (5-Türer) Crossover 2nd Generation Facelift | 2017-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2026,
    "Mo": "Sandero Stepway (5-Türer) Crossover 3rd Generation Facelift | 2026-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2012,
    "Mo": "Sandero Stepway (5-Türer) Crossover 2nd Generation | 2012-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2013,
    "Mo": "Sandero Stepway (5-Türer) Crossover | 2012-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2014,
    "Mo": "Sandero Stepway (5-Türer) Crossover | 2012-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2015,
    "Mo": "Sandero Stepway (5-Türer) Crossover | 2012-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2016,
    "Mo": "Sandero Stepway (5-Türer) Crossover | 2012-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2017,
    "Mo": "Sandero Stepway (5-Türer) Crossover 2nd Generation | 2012-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2009,
    "Mo": "Sandero Stepway (5-Türer) Crossover | 2009-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2010,
    "Mo": "Sandero Stepway (5-Türer) Crossover | 2009-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2011,
    "Mo": "Sandero Stepway (5-Türer) Crossover | 2009-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2012,
    "Mo": "Sandero Stepway (5-Türer) Crossover 1st Generation | 2009-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 1998,
    "Mo": "Matiz (5-Türer) Schrägheck | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 1999,
    "Mo": "Matiz (5-Türer) Schrägheck | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2000,
    "Mo": "Matiz (5-Türer) Schrägheck | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2001,
    "Mo": "Matiz (5-Türer) Schrägheck | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 1999,
    "Mo": "Nubira Wagon (5-Türer) Kombi J150 | 1999-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2000,
    "Mo": "Nubira Wagon (5-Türer) Kombi | 1999-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2001,
    "Mo": "Nubira Wagon (5-Türer) Kombi | 1999-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2002,
    "Mo": "Nubira Wagon (5-Türer) Kombi | 1999-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 1997,
    "Mo": "Nubira Wagon (5-Türer) Kombi | 1997-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 1998,
    "Mo": "Nubira Wagon (5-Türer) Kombi | 1997-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 1999,
    "Mo": "Nubira Wagon (5-Türer) Kombi J100 | 1997-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2000,
    "Mo": "Tacuma (5-Türer) MPV | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2001,
    "Mo": "Tacuma (5-Türer) MPV | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2002,
    "Mo": "Tacuma (5-Türer) MPV | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2003,
    "Mo": "Tacuma (5-Türer) MPV | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2004,
    "Mo": "Tacuma (5-Türer) MPV 1st Generation | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2004,
    "Mo": "Tacuma (5-Türer) MPV 1st Generation Facelift | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2005,
    "Mo": "Tacuma (5-Türer) MPV | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2006,
    "Mo": "Tacuma (5-Türer) MPV | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2007,
    "Mo": "Tacuma (5-Türer) MPV | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2008,
    "Mo": "Tacuma (5-Türer) MPV | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1999,
    "Mo": "Bora Variant (1J6) (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2000,
    "Mo": "Bora Variant (1J6) (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2001,
    "Mo": "Bora Variant (1J6) (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2002,
    "Mo": "Bora Variant (1J6) (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Bora Variant (1J6) (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Bora Variant (1J6) (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Bora Variant (1J6) (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Caddy California (5-Türer) LCV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Caddy California (5-Türer) LCV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Caddy California (5-Türer) LCV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Caddy California (5-Türer) LCV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Caddy California (5-Türer) LCV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Caddy California (5-Türer) LCV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Caddy California (5-Türer) LCV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Caddy Life (4-Türer) LCV | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Caddy Life (4-Türer) LCV | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Caddy Life (4-Türer) LCV | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Caddy Life (4-Türer) LCV | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Caddy Life (4-Türer) LCV Typ 2K 2nd Facelift | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Caddy Life (4-Türer) LCV Typ 2K 1st Facelift | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Caddy Life (4-Türer) LCV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Caddy Life (4-Türer) LCV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Caddy Life (4-Türer) LCV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Caddy Life (4-Türer) LCV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Caddy Life (4-Türer) LCV | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Caddy Life (4-Türer) LCV | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Caddy Life (4-Türer) LCV | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Caddy Life (4-Türer) LCV | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Caddy Life (4-Türer) LCV | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Caddy Life (4-Türer) LCV | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Caddy Life (4-Türer) LCV | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Caddy Life (4-Türer) LCV Typ 2K | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Caddy Life (4-Türer) LCV Typ SB | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Caddy Life (4-Türer) LCV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Caddy Life (4-Türer) LCV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Caddy Life (4-Türer) LCV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Caddy Life (4-Türer) LCV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Caddy Life (4-Türer) LCV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Caddy Life (4-Türer) LCV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Caddy Maxi (3-Türer) LCV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Caddy Maxi (3-Türer) LCV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Caddy Maxi (3-Türer) LCV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Caddy Maxi (3-Türer) LCV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Caddy Maxi (3-Türer) LCV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Caddy Maxi (3-Türer) LCV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Caddy Maxi (3-Türer) LCV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Caddy Maxi California (5-Türer) LCV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Caddy Maxi California (5-Türer) LCV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Caddy Maxi California (5-Türer) LCV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Caddy Maxi California (5-Türer) LCV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Caddy Maxi California (5-Türer) LCV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Caddy Maxi California (5-Türer) LCV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Caddy Maxi California (5-Türer) LCV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Caddy Maxi Life (4-Türer) LCV | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Caddy Maxi Life (4-Türer) LCV | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Caddy Maxi Life (4-Türer) LCV | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Caddy Maxi Life (4-Türer) LCV | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Caddy Maxi Life (4-Türer) LCV Typ 2K 2nd Facelift | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Caddy Maxi Life (4-Türer) LCV Typ 2K 1st Facelift | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Caddy Maxi Life (4-Türer) LCV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Caddy Maxi Life (4-Türer) LCV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Caddy Maxi Life (4-Türer) LCV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Caddy Maxi Life (4-Türer) LCV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Caddy Maxi Life (4-Türer) LCV | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Caddy Maxi Life (4-Türer) LCV | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Caddy Maxi Life (4-Türer) LCV | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Caddy Maxi Life (4-Türer) LCV | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Caddy Maxi Life (4-Türer) LCV Typ 2K | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Caddy Maxi Life (4-Türer) LCV Typ SB | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Caddy Maxi Life (4-Türer) LCV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Caddy Maxi Life (4-Türer) LCV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Caddy Maxi Life (4-Türer) LCV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Caddy Maxi Life (4-Türer) LCV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Caddy Maxi Life (4-Türer) LCV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Caddy Maxi Life (4-Türer) LCV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Golf Alltrack (BV5) (5-Türer) Crossover | 2017-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Golf Alltrack (BV5) (5-Türer) Crossover | 2017-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Golf Alltrack (BV5) (5-Türer) Crossover | 2017-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Golf Alltrack (BV5) (5-Türer) Crossover | 2017-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Golf Alltrack (BA5) (5-Türer) Crossover | 2015-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Golf Alltrack (BA5) (5-Türer) Crossover | 2015-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Golf Alltrack (BA5) (5-Türer) Crossover | 2015-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Golf Alltrack (CG5) (5-Türer) Crossover | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Golf Alltrack (CG5) (5-Türer) Crossover | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Golf Alltrack (CG5) (5-Türer) Crossover | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Golf Alltrack (CG5) (5-Türer) Crossover | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Golf Sportsvan (AN1) (5-Türer) Schrägheck | 2018-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Golf Sportsvan (AN1) (5-Türer) Schrägheck | 2018-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Golf Sportsvan (AN1) (5-Türer) Schrägheck | 2018-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Golf Sportsvan (AM1) (5-Türer) Schrägheck | 2014-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Golf Sportsvan (AM1) (5-Türer) Schrägheck | 2014-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Golf Sportsvan (AM1) (5-Türer) Schrägheck | 2014-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Golf Sportsvan (AM1) (5-Türer) Schrägheck | 2014-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Golf Sportsvan (AM1) (5-Türer) Schrägheck | 2014-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1998,
    "Mo": "Golf Variant (5-Türer) Kombi | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1999,
    "Mo": "Golf Variant (5-Türer) Kombi | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2000,
    "Mo": "Golf Variant (5-Türer) Kombi | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2001,
    "Mo": "Golf Variant (5-Türer) Kombi | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2002,
    "Mo": "Golf Variant (5-Türer) Kombi | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Golf Variant (5-Türer) Kombi | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Golf Variant (5-Türer) Kombi | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Golf Variant (5-Türer) Kombi | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Golf Variant (5-Türer) Kombi | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1996,
    "Mo": "Golf Variant (1H5) (5-Türer) Kombi | 1996-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1997,
    "Mo": "Golf Variant (1H5) (5-Türer) Kombi | 1996-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1998,
    "Mo": "Golf Variant (1H5) (5-Türer) Kombi | 1996-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1999,
    "Mo": "Golf Variant (1H5) (5-Türer) Kombi | 1996-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Golf Variant (AJ5) (5-Türer) Kombi | 2010-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Golf Variant (AJ5) (5-Türer) Kombi | 2010-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Golf Variant (AJ5) (5-Türer) Kombi | 2010-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Golf Variant (AJ5) (5-Türer) Kombi | 2010-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Golf Variant (BV5) (5-Türer) Kombi | 2017-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Golf Variant (BV5) (5-Türer) Kombi | 2017-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Golf Variant (BV5) (5-Türer) Kombi | 2017-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Golf Variant (BV5) (5-Türer) Kombi | 2017-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Golf Variant (BA5) (5-Türer) Kombi | 2014-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Golf Variant (BA5) (5-Türer) Kombi | 2014-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Golf Variant (BA5) (5-Türer) Kombi | 2014-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Golf Variant (BA5) (5-Türer) Kombi | 2014-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Golf Variant (DB5) (5-Türer) Kombi | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Golf Variant (DB5) (5-Türer) Kombi | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Golf Variant (DB5) (5-Türer) Kombi | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Golf Variant (CG5) (5-Türer) Kombi | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Golf Variant (CG5) (5-Türer) Kombi | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Golf Variant (CG5) (5-Türer) Kombi | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Golf Variant (CG5) (5-Türer) Kombi | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Golf Variant (1K5) (5-Türer) Kombi | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Golf Variant (1K5) (5-Türer) Kombi | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Golf Variant (1K5) (5-Türer) Kombi | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Golf Variant (1K5) (5-Türer) Kombi | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Golf Variant (1K5) (5-Türer) Kombi | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "CrossGolf (521) (5-Türer) Crossover | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "CrossGolf (521) (5-Türer) Crossover | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "CrossGolf (521) (5-Türer) Crossover | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "CrossGolf (521) (5-Türer) Crossover | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "CrossGolf (521) (5-Türer) Crossover | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "CrossGolf (5-Türer) Crossover | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "CrossGolf (5-Türer) Crossover | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "CrossGolf (5-Türer) Crossover | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "CrossGolf (5-Türer) Crossover | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Golf Plus (521) (5-Türer) Schrägheck | 2009-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Golf Plus (521) (5-Türer) Schrägheck | 2009-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Golf Plus (521) (5-Türer) Schrägheck | 2009-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Golf Plus (521) (5-Türer) Schrägheck | 2009-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Golf Plus (521) (5-Türer) Schrägheck | 2009-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Golf Plus (521) (5-Türer) Schrägheck | 2009-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Golf Plus (5M1) (5-Türer) Schrägheck | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Golf Plus (5M1) (5-Türer) Schrägheck | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Golf Plus (5M1) (5-Türer) Schrägheck | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Golf Plus (5M1) (5-Türer) Schrägheck | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Golf Plus (5M1) (5-Türer) Schrägheck | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Nivus (CH1) (5-Türer) SUV | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Nivus (CH1) (5-Türer) SUV | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Nivus (CH1) (5-Türer) SUV | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Nivus (CH1) (5-Türer) SUV | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Passat Alltrack (365) (5-Türer) Crossover | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Passat Alltrack (365) (5-Türer) Crossover | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Passat Alltrack (365) (5-Türer) Crossover | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Passat Alltrack (365) (5-Türer) Crossover | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1998,
    "Mo": "Passat Variant (3B5) (5-Türer) Kombi | 1998-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1999,
    "Mo": "Passat Variant (3B5) (5-Türer) Kombi | 1998-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2000,
    "Mo": "Passat Variant (3B5) (5-Türer) Kombi | 1998-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1988,
    "Mo": "Passat Variant (315) (5-Türer) Kombi | 1988-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1989,
    "Mo": "Passat Variant (315) (5-Türer) Kombi | 1988-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1990,
    "Mo": "Passat Variant (315) (5-Türer) Kombi | 1988-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1991,
    "Mo": "Passat Variant (315) (5-Türer) Kombi | 1988-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1992,
    "Mo": "Passat Variant (315) (5-Türer) Kombi | 1988-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1993,
    "Mo": "Passat Variant (315) (5-Türer) Kombi | 1988-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1994,
    "Mo": "Passat Variant (315) (5-Türer) Kombi | 1988-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1985,
    "Mo": "Passat Variant (331) (5-Türer) Kombi | 1985-1988",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1986,
    "Mo": "Passat Variant (331) (5-Türer) Kombi | 1985-1988",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1987,
    "Mo": "Passat Variant (331) (5-Türer) Kombi | 1985-1988",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1988,
    "Mo": "Passat Variant (331) (5-Türer) Kombi | 1985-1988",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1981,
    "Mo": "Passat Variant (5-Türer) Kombi | 1981-1985",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1982,
    "Mo": "Passat Variant (5-Türer) Kombi | 1981-1985",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1983,
    "Mo": "Passat Variant (5-Türer) Kombi | 1981-1985",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1984,
    "Mo": "Passat Variant (5-Türer) Kombi | 1981-1985",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1985,
    "Mo": "Passat Variant (5-Türer) Kombi | 1981-1985",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1994,
    "Mo": "Passat Variant (3A5) (5-Türer) Kombi | 1994-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1995,
    "Mo": "Passat Variant (3A5) (5-Türer) Kombi | 1994-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1996,
    "Mo": "Passat Variant (3A5) (5-Türer) Kombi | 1994-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1997,
    "Mo": "Passat Variant (3A5) (5-Türer) Kombi | 1994-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Passat Variant (365) (5-Türer) Kombi | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Passat Variant (365) (5-Türer) Kombi | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Passat Variant (365) (5-Türer) Kombi | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Passat Variant (365) (5-Türer) Kombi | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Passat Variant (365) (5-Türer) Kombi | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1998,
    "Mo": "Passat Variant (3B5) (5-Türer) Kombi | 1998-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1999,
    "Mo": "Passat Variant (3B5) (5-Türer) Kombi | 1998-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2000,
    "Mo": "Passat Variant (3B5) (5-Türer) Kombi | 1998-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Passat Variant (3C5) (5-Türer) Kombi | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Passat Variant (3C5) (5-Türer) Kombi | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Passat Variant (3C5) (5-Türer) Kombi | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Passat Variant (3C5) (5-Türer) Kombi | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Passat Variant (3C5) (5-Türer) Kombi | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2001,
    "Mo": "Passat Variant (3B6) (5-Türer) Kombi | 2001-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2002,
    "Mo": "Passat Variant (3B6) (5-Türer) Kombi | 2001-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Passat Variant (3B6) (5-Türer) Kombi | 2001-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Passat Variant (3B6) (5-Türer) Kombi | 2001-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Passat Variant (3B6) (5-Türer) Kombi | 2001-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "CrossPolo (6C1) (5-Türer) Crossover | 2015-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "CrossPolo (6C1) (5-Türer) Crossover | 2015-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "CrossPolo (6C1) (5-Türer) Crossover | 2015-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "CrossPolo (5-Türer) Crossover | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "CrossPolo (5-Türer) Crossover | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "CrossPolo (5-Türer) Crossover | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "CrossPolo (5-Türer) Crossover | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "CrossPolo (5-Türer) Crossover | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "CrossPolo (9N3) (5-Türer) Crossover | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "CrossPolo (9N3) (5-Türer) Crossover | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "CrossPolo (9N3) (5-Türer) Crossover | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "CrossPolo (9N3) (5-Türer) Crossover | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "CrossPolo (9N3) (5-Türer) Crossover | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2000,
    "Mo": "Polo Variant (6V5) (5-Türer) Stufenheck | 2000-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2001,
    "Mo": "Polo Variant (6V5) (5-Türer) Stufenheck | 2000-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2002,
    "Mo": "Polo Variant (6V5) (5-Türer) Stufenheck | 2000-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1995,
    "Mo": "Polo Variant (6V5) (5-Türer) Stufenheck | 1995-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1996,
    "Mo": "Polo Variant (6V5) (5-Türer) Stufenheck | 1995-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1997,
    "Mo": "Polo Variant (6V5) (5-Türer) Stufenheck | 1995-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1998,
    "Mo": "Polo Variant (6V5) (5-Türer) Stufenheck | 1995-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1999,
    "Mo": "Polo Variant (6V5) (5-Türer) Stufenheck | 1995-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Sharan 5-seater (7N1) (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Sharan 5-seater (7N1) (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Sharan 5-seater (7N1) (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Sharan 5-seater (7N1) (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Sharan 5-seater (7N1) (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Sharan 5-seater (7N2) (5-Türer) MPV | 2016-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Sharan 5-seater (7N2) (5-Türer) MPV | 2016-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Sharan 5-seater (7N2) (5-Türer) MPV | 2016-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Sharan 5-seater (7N2) (5-Türer) MPV | 2016-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Sharan 5-seater (7N2) (5-Türer) MPV | 2016-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Sharan 5-seater (7N2) (5-Türer) MPV | 2016-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Sharan 5-seater (7N2) (5-Türer) MPV | 2016-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Sharan 5-seater (7N2) (5-Türer) MPV | 2016-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Sharan 6-seater (7N1) (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Sharan 6-seater (7N1) (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Sharan 6-seater (7N1) (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Sharan 6-seater (7N1) (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Sharan 6-seater (7N1) (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Sharan 6-seater (7N2) (5-Türer) MPV | 2016-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Sharan 6-seater (7N2) (5-Türer) MPV | 2016-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Sharan 6-seater (7N2) (5-Türer) MPV | 2016-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Sharan 6-seater (7N2) (5-Türer) MPV | 2016-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Sharan 6-seater (7N2) (5-Türer) MPV | 2016-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Sharan 6-seater (7N2) (5-Türer) MPV | 2016-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Sharan 6-seater (7N2) (5-Türer) MPV | 2016-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Sharan 6-seater (7N2) (5-Türer) MPV | 2016-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Sharan 6-seater (7M6) (5-Türer) MPV | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Sharan 6-seater (7M6) (5-Türer) MPV | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Sharan 6-seater (7M6) (5-Türer) MPV | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Sharan 6-seater (7M6) (5-Türer) MPV | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Sharan 6-seater (7M6) (5-Türer) MPV | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Sharan 6-seater (7M6) (5-Türer) MPV | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Sharan 6-seater (7M6) (5-Türer) MPV | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2001,
    "Mo": "Sharan 6-seater (7M6/7M9) (5-Türer) MPV | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2002,
    "Mo": "Sharan 6-seater (7M6/7M9) (5-Türer) MPV | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Sharan 6-seater (7M6/7M9) (5-Türer) MPV | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Sharan 6-seater (7M6/7M9) (5-Türer) MPV | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1996,
    "Mo": "Sharan 6-seater (7M8) (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1997,
    "Mo": "Sharan 6-seater (7M8) (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1998,
    "Mo": "Sharan 6-seater (7M8) (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1999,
    "Mo": "Sharan 6-seater (7M8) (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2000,
    "Mo": "Sharan 6-seater (7M8) (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Sharan 7-seater (7M6) (5-Türer) MPV | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Sharan 7-seater (7M6) (5-Türer) MPV | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Sharan 7-seater (7M6) (5-Türer) MPV | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Sharan 7-seater (7M6) (5-Türer) MPV | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Sharan 7-seater (7M6) (5-Türer) MPV | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Sharan 7-seater (7M6) (5-Türer) MPV | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Sharan 7-seater (7M6) (5-Türer) MPV | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Sharan 7-seater (7N1) (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Sharan 7-seater (7N1) (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Sharan 7-seater (7N1) (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Sharan 7-seater (7N1) (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Sharan 7-seater (7N1) (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Sharan 7-seater (7N2) (5-Türer) MPV | 2016-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Sharan 7-seater (7N2) (5-Türer) MPV | 2016-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Sharan 7-seater (7N2) (5-Türer) MPV | 2016-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Sharan 7-seater (7N2) (5-Türer) MPV | 2016-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Sharan 7-seater (7N2) (5-Türer) MPV | 2016-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Sharan 7-seater (7N2) (5-Türer) MPV | 2016-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Sharan 7-seater (7N2) (5-Türer) MPV | 2016-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Sharan 7-seater (7N2) (5-Türer) MPV | 2016-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2001,
    "Mo": "Sharan 7-seater (7M6/7M9) (5-Türer) MPV | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2002,
    "Mo": "Sharan 7-seater (7M6/7M9) (5-Türer) MPV | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Sharan 7-seater (7M6/7M9) (5-Türer) MPV | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Sharan 7-seater (7M6/7M9) (5-Türer) MPV | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1996,
    "Mo": "Sharan 7-seater (7M8) (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1997,
    "Mo": "Sharan 7-seater (7M8) (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1998,
    "Mo": "Sharan 7-seater (7M8) (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1999,
    "Mo": "Sharan 7-seater (7M8) (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2000,
    "Mo": "Sharan 7-seater (7M8) (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "SpaceFox (5Z6) (5-Türer) MPV | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "SpaceFox (5Z6) (5-Türer) MPV | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "SpaceFox (5Z6) (5-Türer) MPV | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "SpaceFox (5Z6) (5-Türer) MPV | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "SpaceFox (5Z6) (5-Türer) MPV | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "SpaceFox (5Z7) (5-Türer) MPV | 2011-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "SpaceFox (5Z7) (5-Türer) MPV | 2011-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "SpaceFox (5Z7) (5-Türer) MPV | 2011-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "SpaceFox (5Z7) (5-Türer) MPV | 2011-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "SpaceFox (5Z9) (5-Türer) MPV | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "SpaceFox (5Z9) (5-Türer) MPV | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "SpaceFox (5Z9) (5-Türer) MPV | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "SpaceFox (5Z9) (5-Türer) MPV | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "SpaceFox (5Z9) (5-Türer) MPV | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Suran (5Z6) (5-Türer) MPV | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Suran (5Z6) (5-Türer) MPV | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Suran (5Z6) (5-Türer) MPV | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Suran (5Z6) (5-Türer) MPV | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Suran (5Z6) (5-Türer) MPV | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Suran (5Z7) (5-Türer) MPV | 2011-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Suran (5Z7) (5-Türer) MPV | 2011-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Suran (5Z7) (5-Türer) MPV | 2011-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Suran (5Z7) (5-Türer) MPV | 2011-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Suran (5Z9) (5-Türer) MPV | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Suran (5Z9) (5-Türer) MPV | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Suran (5Z9) (5-Türer) MPV | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Suran (5Z9) (5-Türer) MPV | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Suran (5Z9) (5-Türer) MPV | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "T-Cross (C11) (5-Türer) SUV | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "T-Cross (C11) (5-Türer) SUV | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "T-Cross (C11) (5-Türer) SUV | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "T-Cross (C11) (5-Türer) SUV | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "T-Cross (C11) (5-Türer) SUV | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "T-Cross (D31) (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "T-Cross (D31) (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "T-Cross (D31) (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "T-Roc (D11) (5-Türer) SUV | 2022-2026",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "T-Roc (D11) (5-Türer) SUV | 2022-2026",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "T-Roc (D11) (5-Türer) SUV | 2022-2026",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "T-Roc (D11) (5-Türer) SUV | 2022-2026",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "T-Roc (D11) (5-Türer) SUV | 2022-2026",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "T-Roc (A11) (5-Türer) SUV | 2018-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "T-Roc (A11) (5-Türer) SUV | 2018-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "T-Roc (A11) (5-Türer) SUV | 2018-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "T-Roc (A11) (5-Türer) SUV | 2018-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "T-Roc (A11) (5-Türer) SUV | 2018-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Taigo (CS1) (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Taigo (CS1) (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Taigo (CS1) (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Taigo (CS1) (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Taigo (CS1) (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Taos (CL1) (5-Türer) SUV | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Taos (CL1) (5-Türer) SUV | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Taos (CL1) (5-Türer) SUV | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Taos (CL1) (5-Türer) SUV | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Tiguan (5N2) (5-Türer) SUV | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Tiguan (5N2) (5-Türer) SUV | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Tiguan (5N2) (5-Türer) SUV | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Tiguan (5N2) (5-Türer) SUV | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Tiguan (5N2) (5-Türer) SUV | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Tiguan (5N1) (5-Türer) SUV | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Tiguan (5N1) (5-Türer) SUV | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Tiguan (5N1) (5-Türer) SUV | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Tiguan (5N1) (5-Türer) SUV | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Tiguan (CT1) (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Tiguan (CT1) (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Tiguan (CT1) (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Tiguan (AX1) (5-Türer) SUV | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Tiguan (AX1) (5-Türer) SUV | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Tiguan (AX1) (5-Türer) SUV | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Tiguan (AX1) (5-Türer) SUV | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Tiguan (AD1) (5-Türer) SUV | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Tiguan (AD1) (5-Türer) SUV | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Tiguan (AD1) (5-Türer) SUV | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Tiguan (AD1) (5-Türer) SUV | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Tiguan (AD1) (5-Türer) SUV | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Tiguan Allspace 5-seater (BW2) (5-Türer) SUV | 2018-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Tiguan Allspace 5-seater (BW2) (5-Türer) SUV | 2018-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Tiguan Allspace 5-seater (BW2) (5-Türer) SUV | 2018-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Tiguan Allspace 5-seater (BW2) (5-Türer) SUV | 2018-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Tiguan Allspace 5-seater (BJ2) (5-Türer) SUV | 2022-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Tiguan Allspace 5-seater (BJ2) (5-Türer) SUV | 2022-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Tiguan Allspace 5-seater (BJ2) (5-Türer) SUV | 2022-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Tiguan Allspace 7-seater (BW2) (5-Türer) SUV | 2018-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Tiguan Allspace 7-seater (BW2) (5-Türer) SUV | 2018-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Tiguan Allspace 7-seater (BW2) (5-Türer) SUV | 2018-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Tiguan Allspace 7-seater (BW2) (5-Türer) SUV | 2018-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Tiguan Allspace 7-seater (BJ2) (5-Türer) SUV | 2022-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Tiguan Allspace 7-seater (BJ2) (5-Türer) SUV | 2022-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Tiguan Allspace 7-seater (BJ2) (5-Türer) SUV | 2022-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Touareg (7LA) (5-Türer) SUV | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Touareg (7LA) (5-Türer) SUV | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Touareg (7LA) (5-Türer) SUV | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Touareg (7LA) (5-Türer) SUV | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Touareg (7LA) (5-Türer) SUV | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Touareg (7L6) (5-Türer) SUV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Touareg (7L6) (5-Türer) SUV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Touareg (7L6) (5-Türer) SUV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Touareg (7L6) (5-Türer) SUV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Touareg (7P6) (5-Türer) SUV | 2015-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Touareg (7P6) (5-Türer) SUV | 2015-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Touareg (7P6) (5-Türer) SUV | 2015-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Touareg (7P6) (5-Türer) SUV | 2015-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Touareg (7P5) (5-Türer) SUV | 2011-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Touareg (7P5) (5-Türer) SUV | 2011-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Touareg (7P5) (5-Türer) SUV | 2011-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Touareg (7P5) (5-Türer) SUV | 2011-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "CrossTouran 5-seater (1T3) (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "CrossTouran 5-seater (1T3) (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "CrossTouran 5-seater (1T3) (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "CrossTouran 5-seater (1T3) (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "CrossTouran 5-seater (1T3) (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "CrossTouran 5-seater (1T2) (5-Türer) MPV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "CrossTouran 5-seater (1T2) (5-Türer) MPV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "CrossTouran 5-seater (1T2) (5-Türer) MPV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "CrossTouran 5-seater (1T2) (5-Türer) MPV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "CrossTouran 7-seater (1T3) (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "CrossTouran 7-seater (1T3) (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "CrossTouran 7-seater (1T3) (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "CrossTouran 7-seater (1T3) (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "CrossTouran 7-seater (1T3) (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "CrossTouran 7-seater (1T2) (5-Türer) MPV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "CrossTouran 7-seater (1T2) (5-Türer) MPV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "CrossTouran 7-seater (1T2) (5-Türer) MPV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "CrossTouran 7-seater (1T2) (5-Türer) MPV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Touran 5-seater (5T1) (5-Türer) MPV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Touran 5-seater (5T1) (5-Türer) MPV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Touran 5-seater (5T1) (5-Türer) MPV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Touran 5-seater (5T1) (5-Türer) MPV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Touran 5-seater (5T1) (5-Türer) MPV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Touran 5-seater (5T1) (5-Türer) MPV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Touran 5-seater (5T1) (5-Türer) MPV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Touran 5-seater (5T1) (5-Türer) MPV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Touran 5-seater (5T1) (5-Türer) MPV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Touran 5-seater (5T1) (5-Türer) MPV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Touran 5-seater (5T1) (5-Türer) MPV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Touran 5-seater (1T3) (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Touran 5-seater (1T3) (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Touran 5-seater (1T3) (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Touran 5-seater (1T3) (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Touran 5-seater (1T3) (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Touran 5-seater (1T2) (5-Türer) MPV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Touran 5-seater (1T2) (5-Türer) MPV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Touran 5-seater (1T2) (5-Türer) MPV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Touran 5-seater (1T2) (5-Türer) MPV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Touran 5-seater (1T1) (5-Türer) MPV | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Touran 5-seater (1T1) (5-Türer) MPV | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Touran 5-seater (1T1) (5-Türer) MPV | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Touran 5-seater (1T1) (5-Türer) MPV | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Touran 7-seater (1T3) (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Touran 7-seater (1T3) (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Touran 7-seater (1T3) (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Touran 7-seater (1T3) (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Touran 7-seater (1T3) (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Touran 7-seater (1T2) (5-Türer) MPV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Touran 7-seater (1T2) (5-Türer) MPV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Touran 7-seater (1T2) (5-Türer) MPV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Touran 7-seater (1T2) (5-Türer) MPV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Touran 7-seater (5T1) (5-Türer) MPV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Touran 7-seater (5T1) (5-Türer) MPV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Touran 7-seater (5T1) (5-Türer) MPV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Touran 7-seater (5T1) (5-Türer) MPV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Touran 7-seater (5T1) (5-Türer) MPV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Touran 7-seater (5T1) (5-Türer) MPV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Touran 7-seater (5T1) (5-Türer) MPV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Touran 7-seater (5T1) (5-Türer) MPV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Touran 7-seater (5T1) (5-Türer) MPV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Touran 7-seater (5T1) (5-Türer) MPV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Touran 7-seater (5T1) (5-Türer) MPV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Touran 7-seater (1T1) (5-Türer) MPV | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Touran 7-seater (1T1) (5-Türer) MPV | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Touran 7-seater (1T1) (5-Türer) MPV | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Touran 7-seater (1T1) (5-Türer) MPV | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Cross up! (122) (5-Türer) Crossover | 2017-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Cross up! (122) (5-Türer) Crossover | 2017-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Cross up! (122) (5-Türer) Crossover | 2017-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Cross up! (121) (5-Türer) Crossover | 2014-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Cross up! (121) (5-Türer) Crossover | 2014-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Cross up! (121) (5-Türer) Crossover | 2014-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1990,
    "Mo": "740 Station Wagon (P745 Facelift) (5-Türer) Kombi | 1990-1992",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1991,
    "Mo": "740 Station Wagon (P745 Facelift) (5-Türer) Kombi | 1990-1992",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1992,
    "Mo": "740 Station Wagon (P745 Facelift) (5-Türer) Kombi | 1990-1992",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1984,
    "Mo": "740 Station Wagon (P745) (5-Türer) Kombi | 1984-1989",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1985,
    "Mo": "740 Station Wagon (P745) (5-Türer) Kombi | 1984-1989",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1986,
    "Mo": "740 Station Wagon (P745) (5-Türer) Kombi | 1984-1989",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1987,
    "Mo": "740 Station Wagon (P745) (5-Türer) Kombi | 1984-1989",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1988,
    "Mo": "740 Station Wagon (P745) (5-Türer) Kombi | 1984-1989",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1989,
    "Mo": "740 Station Wagon (P745) (5-Türer) Kombi | 1984-1989",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1985,
    "Mo": "760 Station Wagon (P765) (5-Türer) Kombi | 1985-1987",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1986,
    "Mo": "760 Station Wagon (P765) (5-Türer) Kombi | 1985-1987",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1987,
    "Mo": "760 Station Wagon (P765) (5-Türer) Kombi | 1985-1987",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1988,
    "Mo": "760 Station Wagon (P765 Facelift) (5-Türer) Kombi | 1988-1990",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1989,
    "Mo": "760 Station Wagon (P765 Facelift) (5-Türer) Kombi | 1988-1990",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1990,
    "Mo": "760 Station Wagon (P765 Facelift) (5-Türer) Kombi | 1988-1990",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1994,
    "Mo": "850 Estate (855 Facelift) (5-Türer) Kombi | 1994-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1995,
    "Mo": "850 Estate (855 Facelift) (5-Türer) Kombi | 1994-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1996,
    "Mo": "850 Estate (855 Facelift) (5-Türer) Kombi | 1994-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1997,
    "Mo": "850 Estate (855 Facelift) (5-Türer) Kombi | 1994-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1993,
    "Mo": "850 Estate (855) (5-Türer) Kombi | 1993-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1994,
    "Mo": "850 Estate (855) (5-Türer) Kombi | 1993-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1991,
    "Mo": "940 Station Wagon (945) (5-Türer) Kombi | 1991-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1992,
    "Mo": "940 Station Wagon (945) (5-Türer) Kombi | 1991-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1993,
    "Mo": "940 Station Wagon (945) (5-Türer) Kombi | 1991-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1994,
    "Mo": "940 Station Wagon (945) (5-Türer) Kombi | 1991-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1995,
    "Mo": "940 Station Wagon (945) (5-Türer) Kombi | 1991-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1996,
    "Mo": "940 Station Wagon (945) (5-Türer) Kombi | 1991-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1997,
    "Mo": "940 Station Wagon (945) (5-Türer) Kombi | 1991-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1998,
    "Mo": "940 Station Wagon (945) (5-Türer) Kombi | 1991-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1991,
    "Mo": "960 Station Wagon (965) (5-Türer) Kombi | 1991-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1992,
    "Mo": "960 Station Wagon (965) (5-Türer) Kombi | 1991-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1993,
    "Mo": "960 Station Wagon (965) (5-Türer) Kombi | 1991-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1994,
    "Mo": "960 Station Wagon (965) (5-Türer) Kombi | 1991-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1995,
    "Mo": "960 Station Wagon (965 Facelift) (5-Türer) Kombi | 1995-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1996,
    "Mo": "960 Station Wagon (965 Facelift) (5-Türer) Kombi | 1995-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1997,
    "Mo": "960 Station Wagon (965 Facelift) (5-Türer) Kombi | 1995-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2000,
    "Mo": "V40 Estate (645) (5-Türer) Kombi V Phase II | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2001,
    "Mo": "V40 Estate (645) (5-Türer) Kombi | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2002,
    "Mo": "V40 Estate (645) (5-Türer) Kombi | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2003,
    "Mo": "V40 Estate (645) (5-Türer) Kombi | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2004,
    "Mo": "V40 Estate (645) (5-Türer) Kombi | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1996,
    "Mo": "V40 Estate (645) (5-Türer) Kombi | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1997,
    "Mo": "V40 Estate (645) (5-Türer) Kombi | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1998,
    "Mo": "V40 Estate (645) (5-Türer) Kombi | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1999,
    "Mo": "V40 Estate (645) (5-Türer) Kombi | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2000,
    "Mo": "V40 Estate (645) (5-Türer) Kombi V | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2008,
    "Mo": "V50 (545) (5-Türer) Kombi | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2009,
    "Mo": "V50 (545) (5-Türer) Kombi | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2010,
    "Mo": "V50 (545) (5-Türer) Kombi | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2011,
    "Mo": "V50 (545) (5-Türer) Kombi | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2012,
    "Mo": "V50 (545) (5-Türer) Kombi | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2004,
    "Mo": "V50 (545) (5-Türer) Kombi | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2005,
    "Mo": "V50 (545) (5-Türer) Kombi | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2006,
    "Mo": "V50 (545) (5-Türer) Kombi | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2007,
    "Mo": "V50 (545) (5-Türer) Kombi | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1999,
    "Mo": "V70 (875) (5-Türer) Kombi | 1999-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2000,
    "Mo": "V70 (875) (5-Türer) Kombi | 1999-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2011,
    "Mo": "V70 (135) (5-Türer) Kombi 24 1st Facelift | 2011-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2012,
    "Mo": "V70 (135) (5-Türer) Kombi | 2011-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2013,
    "Mo": "V70 (135) (5-Türer) Kombi | 2011-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2014,
    "Mo": "V70 (135) (5-Türer) Kombi | 2014-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2015,
    "Mo": "V70 (135) (5-Türer) Kombi | 2014-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2016,
    "Mo": "V70 (135) (5-Türer) Kombi | 2014-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2008,
    "Mo": "V70 (135) (5-Türer) Kombi | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2009,
    "Mo": "V70 (135) (5-Türer) Kombi | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2010,
    "Mo": "V70 (135) (5-Türer) Kombi | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2011,
    "Mo": "V70 (135) (5-Türer) Kombi 24 | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2000,
    "Mo": "V70 (285) (5-Türer) Kombi | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2001,
    "Mo": "V70 (285) (5-Türer) Kombi | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2002,
    "Mo": "V70 (285) (5-Türer) Kombi | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2003,
    "Mo": "V70 (285) (5-Türer) Kombi | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2004,
    "Mo": "V70 (285) (5-Türer) Kombi | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2005,
    "Mo": "V70 (285) (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2006,
    "Mo": "V70 (285) (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2007,
    "Mo": "V70 (285) (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2008,
    "Mo": "V70 (285) (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1997,
    "Mo": "V70 (875) (5-Türer) Kombi | 1997-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1998,
    "Mo": "V70 (875) (5-Türer) Kombi | 1997-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1997,
    "Mo": "V90 (965) (5-Türer) Kombi | 1997-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1998,
    "Mo": "V90 (965) (5-Türer) Kombi | 1997-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2014,
    "Mo": "XC70 (136) (5-Türer) Crossover | 2014-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2015,
    "Mo": "XC70 (136) (5-Türer) Crossover | 2014-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2016,
    "Mo": "XC70 (136) (5-Türer) Crossover | 2014-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2008,
    "Mo": "XC70 (136) (5-Türer) Crossover | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2009,
    "Mo": "XC70 (136) (5-Türer) Crossover | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2010,
    "Mo": "XC70 (136) (5-Türer) Crossover | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2011,
    "Mo": "XC70 (136) (5-Türer) Crossover | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2012,
    "Mo": "XC70 (136) (5-Türer) Crossover | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2013,
    "Mo": "XC70 (136) (5-Türer) Crossover | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2005,
    "Mo": "XC70 (295) (5-Türer) Crossover | 2005-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2006,
    "Mo": "XC70 (295) (5-Türer) Crossover | 2005-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2007,
    "Mo": "XC70 (295) (5-Türer) Crossover | 2005-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1998,
    "Mo": "XC70 (876) (5-Türer) Crossover | 1998-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1999,
    "Mo": "XC70 (876) (5-Türer) Crossover | 1999-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2000,
    "Mo": "XC70 (876) (5-Türer) Crossover | 1999-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2016,
    "Mo": "XC90 5-seater (256LC) (5-Türer) SUV | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2017,
    "Mo": "XC90 5-seater (256LC) (5-Türer) SUV | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2018,
    "Mo": "XC90 5-seater (256LC) (5-Türer) SUV | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2019,
    "Mo": "XC90 5-seater (256LC) (5-Türer) SUV | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2020,
    "Mo": "XC90 5-seater (256LC) (5-Türer) SUV | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2020,
    "Mo": "XC90 5-seater (256) (5-Türer) SUV | 2020-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2021,
    "Mo": "XC90 5-seater (256) (5-Türer) SUV | 2020-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2022,
    "Mo": "XC90 5-seater (256) (5-Türer) SUV | 2020-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2023,
    "Mo": "XC90 5-seater (256) (5-Türer) SUV | 2020-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2024,
    "Mo": "XC90 5-seater (256) (5-Türer) SUV | 2020-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2025,
    "Mo": "XC90 5-seater (256) (5-Türer) SUV | 2020-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2007,
    "Mo": "XC90 (275) (5-Türer) SUV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2008,
    "Mo": "XC90 (275) (5-Türer) SUV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2009,
    "Mo": "XC90 (275) (5-Türer) SUV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2010,
    "Mo": "XC90 (275) (5-Türer) SUV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2003,
    "Mo": "XC90 5-seater (275) (5-Türer) SUV | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2004,
    "Mo": "XC90 5-seater (275) (5-Türer) SUV | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2005,
    "Mo": "XC90 5-seater (275) (5-Türer) SUV | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2006,
    "Mo": "XC90 5-seater (275) (5-Türer) SUV | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2007,
    "Mo": "XC90 7-seater (5-Türer) SUV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2008,
    "Mo": "XC90 7-seater (5-Türer) SUV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2009,
    "Mo": "XC90 7-seater (5-Türer) SUV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2010,
    "Mo": "XC90 7-seater (5-Türer) SUV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2020,
    "Mo": "XC90 7-seater (5-Türer) SUV | 2020-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2021,
    "Mo": "XC90 7-seater (5-Türer) SUV | 2020-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2022,
    "Mo": "XC90 7-seater (5-Türer) SUV | 2020-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2023,
    "Mo": "XC90 7-seater (5-Türer) SUV | 2020-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2024,
    "Mo": "XC90 7-seater (5-Türer) SUV | 2020-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2025,
    "Mo": "XC90 7-seater (5-Türer) SUV | 2020-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2025,
    "Mo": "XC90 7-seater (256) (5-Türer) SUV | 2025-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2026,
    "Mo": "XC90 7-seater (256) (5-Türer) SUV | 2025-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Avensis Combi (5-Türer) Kombi T25 Facelift | 2006-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Avensis Combi (5-Türer) Kombi | 2006-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Avensis Combi (5-Türer) Kombi T25 Facelift | 2006-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Avensis Combi (5-Türer) Kombi T25 Facelift | 2006-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Avensis Combi (5-Türer) Kombi | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Avensis Combi (5-Türer) Kombi | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Avensis Combi (5-Türer) Kombi | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Avensis Combi (5-Türer) Kombi T25 | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2001,
    "Mo": "Avensis Verso (5-Türer) MPV | 2001-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "Avensis Verso (5-Türer) MPV | 2001-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Avensis Verso (5-Türer) MPV | 2001-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1997,
    "Mo": "Caldina Station Wagon (5-Türer) Kombi | 1997-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1998,
    "Mo": "Caldina Station Wagon (5-Türer) Kombi | 1997-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1999,
    "Mo": "Caldina Station Wagon (5-Türer) Kombi | 1997-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Caldina Station Wagon (5-Türer) Kombi | 2003-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Caldina Station Wagon (5-Türer) Kombi | 2003-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2000,
    "Mo": "Caldina Station Wagon (5-Türer) Kombi | 2000-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2001,
    "Mo": "Caldina Station Wagon (5-Türer) Kombi | 2000-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "Caldina Station Wagon (5-Türer) Kombi | 2000-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Caldina Station Wagon (5-Türer) Kombi | 2005-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Caldina Station Wagon (5-Türer) Kombi | 2005-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Caldina Station Wagon (5-Türer) Kombi | 2005-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1997,
    "Mo": "Camry Wagon (5-Türer) Kombi | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1998,
    "Mo": "Camry Wagon (5-Türer) Kombi | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1999,
    "Mo": "Camry Wagon (5-Türer) Kombi | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2000,
    "Mo": "Camry Wagon (5-Türer) Kombi | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2001,
    "Mo": "Camry Wagon (5-Türer) Kombi | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1988,
    "Mo": "Carina Wagon (5-Türer) Kombi | 1988-1992",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1989,
    "Mo": "Carina Wagon (5-Türer) Kombi | 1988-1992",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1990,
    "Mo": "Carina Wagon (5-Türer) Kombi | 1988-1992",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1991,
    "Mo": "Carina Wagon (5-Türer) Kombi | 1988-1992",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1992,
    "Mo": "Carina Wagon (5-Türer) Kombi | 1988-1992",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2001,
    "Mo": "Corolla Station Wagon (5-Türer) Kombi | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "Corolla Station Wagon (5-Türer) Kombi | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Corolla Station Wagon (5-Türer) Kombi | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Corolla Station Wagon (5-Türer) Kombi E120 | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Corolla Station Wagon (5-Türer) Kombi E120 Facelift | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Corolla Station Wagon (5-Türer) Kombi | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Corolla Station Wagon (5-Türer) Kombi | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Corolla Station Wagon (5-Türer) Kombi | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Highlander (5-Türer) Crossover | 2008-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Highlander (5-Türer) Crossover | 2008-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Highlander (5-Türer) Crossover | 2008-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Highlander (5-Türer) Crossover | 2011-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Highlander (5-Türer) Crossover | 2011-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Highlander (5-Türer) Crossover | 2011-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Land Cruiser (5-Türer) SUV J20 Facelift | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Land Cruiser (5-Türer) SUV | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Land Cruiser (5-Türer) SUV | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Land Cruiser (5-Türer) SUV J20 Facelift | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Land Cruiser (5-Türer) SUV J20 2nd Facelift | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Land Cruiser (5-Türer) SUV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Land Cruiser (5-Türer) SUV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Land Cruiser (5-Türer) SUV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Land Cruiser (5-Türer) SUV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Land Cruiser (5-Türer) SUV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Land Cruiser (5-Türer) SUV J20 2nd Facelift | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Land Cruiser (5-Türer) SUV J20 2nd Facelift | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Land Cruiser (5-Türer) SUV J20 | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Land Cruiser (5-Türer) SUV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Land Cruiser (5-Türer) SUV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Land Cruiser (5-Türer) SUV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Land Cruiser (5-Türer) SUV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Land Cruiser (5-Türer) SUV J20 | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Land Cruiser (5-Türer) SUV J30 | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Land Cruiser (5-Türer) SUV J30 | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Land Cruiser (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Land Cruiser (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Land Cruiser (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "Land Cruiser (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1998,
    "Mo": "Land Cruiser (5-Türer) SUV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1999,
    "Mo": "Land Cruiser (5-Türer) SUV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2000,
    "Mo": "Land Cruiser (5-Türer) SUV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2001,
    "Mo": "Land Cruiser (5-Türer) SUV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "Land Cruiser (5-Türer) SUV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Land Cruiser (5-Türer) SUV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Land Cruiser (5-Türer) SUV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Land Cruiser (5-Türer) SUV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Land Cruiser (5-Türer) SUV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Land Cruiser (5-Türer) SUV J10 | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "Land Cruiser Prado (5-Türer) SUV J120 | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Land Cruiser Prado (5-Türer) SUV J120 | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "Land Cruiser Prado (5-Türer) SUV J120 | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Land Cruiser Prado (5-Türer) SUV J120 | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Land Cruiser Prado (5-Türer) SUV J150 1st Facelift | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Land Cruiser Prado (5-Türer) SUV J150 | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Land Cruiser Prado (5-Türer) SUV J150 | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2018-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2018-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2018-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2018-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2018-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2018-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2026,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1996,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 1996-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1997,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 1996-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1998,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 1996-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1999,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 1996-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2000,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 1996-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2001,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 1996-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "Land Cruiser Prado (5-Türer) SUV J90 | 1996-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "Picnic (5-Türer) MPV | 2002-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Picnic (5-Türer) MPV | 2002-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1990,
    "Mo": "Previa (5-Türer) MPV | 1990-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1991,
    "Mo": "Previa (5-Türer) MPV | 1990-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1992,
    "Mo": "Previa (5-Türer) MPV | 1990-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1993,
    "Mo": "Previa (5-Türer) MPV | 1990-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1994,
    "Mo": "Previa (5-Türer) MPV | 1990-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1995,
    "Mo": "Previa (5-Türer) MPV | 1990-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1996,
    "Mo": "Previa (5-Türer) MPV | 1990-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1997,
    "Mo": "Previa (5-Türer) MPV | 1990-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1998,
    "Mo": "Previa (5-Türer) MPV | 1990-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1999,
    "Mo": "Previa (5-Türer) MPV | 1990-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2000,
    "Mo": "Previa (5-Türer) MPV | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2001,
    "Mo": "Previa (5-Türer) MPV | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "Previa (5-Türer) MPV | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Previa (5-Türer) MPV | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Previa (5-Türer) MPV | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Previa (5-Türer) MPV | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Previa (5-Türer) MPV XR30/XR40 | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Previa (5-Türer) MPV XR50 | 2006-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Previa (5-Türer) MPV | 2006-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Previa (5-Türer) MPV | 2006-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Previa (5-Türer) MPV | 2006-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Previa (5-Türer) MPV | 2006-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Previa (5-Türer) MPV | 2006-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Previa (5-Türer) MPV | 2006-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Previa (5-Türer) MPV | 2006-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Previa (5-Türer) MPV | 2006-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Previa (5-Türer) MPV | 2006-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Previa (5-Türer) MPV | 2006-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Previa (5-Türer) MPV | 2006-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Previa (5-Türer) MPV | 2006-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Previa (5-Türer) MPV | 2006-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Previa (5-Türer) MPV XR50 | 2006-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Previa (5-Türer) MPV | 2006-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Previa (5-Türer) MPV | 2006-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Previa (5-Türer) MPV | 2006-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Previa (5-Türer) MPV | 2006-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Previa (5-Türer) MPV | 2006-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Previa (5-Türer) MPV | 2006-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Previa (5-Türer) MPV | 2006-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Previa (5-Türer) MPV | 2006-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Previa (5-Türer) MPV | 2006-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Previa (5-Türer) MPV | 2006-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Previa (5-Türer) MPV | 2006-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Previa (5-Türer) MPV | 2006-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Previa (5-Türer) MPV | 2006-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2000,
    "Mo": "RAV4 (3-Türer) SUV | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2001,
    "Mo": "RAV4 (3-Türer) SUV | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "RAV4 (3-Türer) SUV | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "RAV4 (3-Türer) SUV | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "RAV4 (3-Türer) SUV | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "RAV4 (3-Türer) SUV | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "RAV4 (3-Türer) SUV | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "RAV4 (5-Türer) SUV | 2016-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "RAV4 (5-Türer) SUV | 2016-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "RAV4 (5-Türer) SUV | 2016-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "RAV4 (5-Türer) SUV XA40 Facelift | 2016-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "RAV4 (5-Türer) SUV XA40 | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "RAV4 (5-Türer) SUV XA40 | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "RAV4 (5-Türer) SUV | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "RAV4 (5-Türer) SUV | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "RAV4 (5-Türer) SUV | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "RAV4 (5-Türer) SUV | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "RAV4 (5-Türer) SUV | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "RAV4 (5-Türer) SUV XA30 | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "RAV4 (5-Türer) SUV XA30 | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "RAV4 (5-Türer) SUV XA30 1st Facelift | 2008-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "RAV4 (5-Türer) SUV XA30 1st Facelift | 2008-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "RAV4 (5-Türer) SUV XA30 1st Facelift | 2008-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "RAV4 (5-Türer) SUV XA30 2nd Facelift | 2010-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "RAV4 (5-Türer) SUV | 2010-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "RAV4 (5-Türer) SUV XA30 2nd Facelift | 2010-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "RAV4 (5-Türer) SUV XA30 2nd Facelift | 2010-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Verso (5-Türer) MPV | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Verso (5-Türer) MPV | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Verso (5-Türer) MPV | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Verso (5-Türer) MPV | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Verso (5-Türer) MPV AR20 | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Verso (5-Türer) MPV AR20 Facelift | 2013-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Verso (5-Türer) MPV | 2013-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Verso (5-Türer) MPV | 2013-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Verso (5-Türer) MPV | 2013-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Verso (5-Türer) MPV | 2013-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Verso (5-Türer) MPV | 2013-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Yaris (3-Türer) Schrägheck XP10 Facelift | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Yaris (3-Türer) Schrägheck | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Yaris (3-Türer) Schrägheck | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Yaris (3-Türer) Schrägheck | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1999,
    "Mo": "Yaris (3-Türer) Schrägheck | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2000,
    "Mo": "Yaris (3-Türer) Schrägheck | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2001,
    "Mo": "Yaris (3-Türer) Schrägheck | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "Yaris (3-Türer) Schrägheck | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Yaris (3-Türer) Schrägheck XP10 | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Yaris (5-Türer) Schrägheck XP10 Facelift | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Yaris (5-Türer) Schrägheck | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Yaris (5-Türer) Schrägheck | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Yaris (5-Türer) Schrägheck | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1999,
    "Mo": "Yaris (5-Türer) Schrägheck | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2000,
    "Mo": "Yaris (5-Türer) Schrägheck | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2001,
    "Mo": "Yaris (5-Türer) Schrägheck | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "Yaris (5-Türer) Schrägheck | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Yaris (5-Türer) Schrägheck XP10 | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1999,
    "Mo": "Yaris Verso (5-Türer) MPV | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2000,
    "Mo": "Yaris Verso (5-Türer) MPV | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2001,
    "Mo": "Yaris Verso (5-Türer) MPV | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "Yaris Verso (5-Türer) MPV | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Yaris Verso (5-Türer) MPV XP20 | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Yaris Verso (5-Türer) MPV XP20 Facelift | 2003-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Yaris Verso (5-Türer) MPV | 2003-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Yaris Verso (5-Türer) MPV | 2003-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Bronco Sport (4-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Bronco Sport (4-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Bronco Sport (4-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Bronco Sport (4-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Bronco Sport (4-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Bronco Sport (4-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Grand C-Max (5-Türer) MPV DXA Facelift | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Grand C-Max (5-Türer) MPV | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Grand C-Max (5-Türer) MPV | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Grand C-Max (5-Türer) MPV | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Grand C-Max (5-Türer) MPV | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Grand C-Max (5-Türer) MPV DXA | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Edge (5-Türer) SUV | 2011-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Edge (5-Türer) SUV | 2011-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Edge (5-Türer) SUV | 2011-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Edge (5-Türer) SUV | 2011-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "Edge (5-Türer) SUV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2008,
    "Mo": "Edge (5-Türer) SUV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "Edge (5-Türer) SUV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "Edge (5-Türer) SUV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2008,
    "Mo": "Escape (5-Türer) SUV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "Escape (5-Türer) SUV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "Escape (5-Türer) SUV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Escape (5-Türer) SUV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Escape (5-Türer) SUV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Escape (5-Türer) SUV | 2017-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Escape (5-Türer) SUV | 2017-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Escape (5-Türer) SUV | 2017-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1995,
    "Mo": "Escort Combi (ANL) (5-Türer) Kombi AxL 2nd Facelift | 1995-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1996,
    "Mo": "Escort Combi (ANL) (5-Türer) Kombi | 1995-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1997,
    "Mo": "Escort Combi (ANL) (5-Türer) Kombi | 1995-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1998,
    "Mo": "Escort Combi (ANL) (5-Türer) Kombi | 1995-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1999,
    "Mo": "Escort Combi (ANL) (5-Türer) Kombi | 1995-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2000,
    "Mo": "Escort Combi (ANL) (5-Türer) Kombi | 1995-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1993,
    "Mo": "Escort Combi (ANL) (5-Türer) Kombi AxL 1st Facelift | 1993-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1994,
    "Mo": "Escort Combi (ANL) (5-Türer) Kombi | 1993-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1995,
    "Mo": "Escort Combi (ANL) (5-Türer) Kombi AxL 1st Facelift | 1993-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1991,
    "Mo": "Escort Combi (ANL) (5-Türer) Kombi | 1991-1993",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1992,
    "Mo": "Escort Combi (ANL) (5-Türer) Kombi | 1991-1993",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1993,
    "Mo": "Escort Combi (ANL) (5-Türer) Kombi AxL | 1991-1993",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2002,
    "Mo": "Explorer (5-Türer) SUV | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2003,
    "Mo": "Explorer (5-Türer) SUV | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2004,
    "Mo": "Explorer (5-Türer) SUV | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2005,
    "Mo": "Explorer (5-Türer) SUV | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Explorer (5-Türer) SUV | 2025-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Explorer (5-Türer) SUV | 2025-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Explorer (5-Türer) SUV | 2020-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Explorer (5-Türer) SUV | 2020-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Explorer (5-Türer) SUV | 2020-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Explorer (5-Türer) SUV | 2020-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Explorer (5-Türer) SUV | 2020-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2005,
    "Mo": "Focus Combi (DA3) (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2006,
    "Mo": "Focus Combi (DA3) (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "Focus Combi (DA3) (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2008,
    "Mo": "Focus Combi (DA3) (5-Türer) Kombi DA3/DB3 | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1999,
    "Mo": "Focus Combi (DNW) (5-Türer) Kombi | 1999-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2000,
    "Mo": "Focus Combi (DNW) (5-Türer) Kombi | 1999-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2001,
    "Mo": "Focus Combi (DNW) (5-Türer) Kombi | 1999-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2002,
    "Mo": "Focus Combi (DNW) (5-Türer) Kombi DxW | 1999-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2002,
    "Mo": "Focus Combi (DNW) (5-Türer) Kombi DxW Facelift | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2003,
    "Mo": "Focus Combi (DNW) (5-Türer) Kombi | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2004,
    "Mo": "Focus Combi (DNW) (5-Türer) Kombi | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2005,
    "Mo": "Focus Combi (DNW) (5-Türer) Kombi | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2008,
    "Mo": "Focus Combi (DA3) (5-Türer) Kombi DA3/DB3 Facelift | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "Focus Combi (DA3) (5-Türer) Kombi | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "Focus Combi (DA3) (5-Türer) Kombi | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Focus Combi (DA3) (5-Türer) Kombi | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1995,
    "Mo": "Galaxy (5-Türer) MPV | 1995-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1996,
    "Mo": "Galaxy (5-Türer) MPV | 1995-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1997,
    "Mo": "Galaxy (5-Türer) MPV | 1995-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1998,
    "Mo": "Galaxy (5-Türer) MPV | 1995-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1999,
    "Mo": "Galaxy (5-Türer) MPV | 1995-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2000,
    "Mo": "Galaxy (5-Türer) MPV WGR | 1995-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2000,
    "Mo": "Galaxy (5-Türer) MPV WGR Facelift | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2001,
    "Mo": "Galaxy (5-Türer) MPV | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2002,
    "Mo": "Galaxy (5-Türer) MPV | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2003,
    "Mo": "Galaxy (5-Türer) MPV | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2004,
    "Mo": "Galaxy (5-Türer) MPV | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2005,
    "Mo": "Galaxy (5-Türer) MPV | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2006,
    "Mo": "Galaxy (5-Türer) MPV WGR Facelift | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Kuga (5-Türer) SUV MA Facelift | 2017-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Kuga (5-Türer) SUV | 2017-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Kuga (5-Türer) SUV | 2017-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Kuga (5-Türer) SUV MA Facelift | 2017-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Kuga (5-Türer) SUV MA | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Kuga (5-Türer) SUV | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Kuga (5-Türer) SUV | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Kuga (5-Türer) SUV | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Kuga (5-Türer) SUV MA | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Kuga (5-Türer) SUV DM2 Facelift | 2011-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Kuga (5-Türer) SUV | 2011-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Kuga (5-Türer) SUV DM2 Facelift | 2011-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2008,
    "Mo": "Kuga (5-Türer) SUV | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "Kuga (5-Türer) SUV | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "Kuga (5-Türer) SUV | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Kuga (5-Türer) SUV DM2 | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1997,
    "Mo": "Maverick (3-Türer) SUV UDS/UNS Facelfit | 1997-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1998,
    "Mo": "Maverick (3-Türer) SUV | 1997-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1993,
    "Mo": "Maverick (3-Türer) SUV | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1994,
    "Mo": "Maverick (3-Türer) SUV | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1995,
    "Mo": "Maverick (3-Türer) SUV | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1996,
    "Mo": "Maverick (3-Türer) SUV | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1997,
    "Mo": "Maverick (3-Türer) SUV UDS/UNS | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2005,
    "Mo": "Maverick (5-Türer) SUV | 2005-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2006,
    "Mo": "Maverick (5-Türer) SUV | 2005-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "Maverick (5-Türer) SUV | 2005-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1997,
    "Mo": "Maverick (5-Türer) SUV UDS/UNS Facelfit | 1997-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1998,
    "Mo": "Maverick (5-Türer) SUV | 1997-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1993,
    "Mo": "Maverick (5-Türer) SUV | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1994,
    "Mo": "Maverick (5-Türer) SUV | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1995,
    "Mo": "Maverick (5-Türer) SUV | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1996,
    "Mo": "Maverick (5-Türer) SUV | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1997,
    "Mo": "Maverick (5-Türer) SUV UDS/UNS | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2001,
    "Mo": "Maverick (5-Türer) SUV | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2002,
    "Mo": "Maverick (5-Türer) SUV | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2003,
    "Mo": "Maverick (5-Türer) SUV | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2004,
    "Mo": "Maverick (5-Türer) SUV | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Mondeo Combi (BG) (5-Türer) Kombi BD/BE/BG Facelift | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Mondeo Combi (BG) (5-Türer) Kombi | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Mondeo Combi (BG) (5-Türer) Kombi | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Mondeo Combi (BG) (5-Türer) Kombi | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Mondeo Combi (BG) (5-Türer) Kombi | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "Mondeo Combi (BG) (5-Türer) Kombi | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2008,
    "Mo": "Mondeo Combi (BG) (5-Türer) Kombi | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "Mondeo Combi (BG) (5-Türer) Kombi | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "Mondeo Combi (BG) (5-Türer) Kombi | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Mondeo Combi (BG) (5-Türer) Kombi BD/BE/BG | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2003,
    "Mo": "Mondeo Combi (BWY) (5-Türer) Kombi BxY 1st Facelift | 2003-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2004,
    "Mo": "Mondeo Combi (BWY) (5-Türer) Kombi | 2003-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2005,
    "Mo": "Mondeo Combi (BWY) (5-Türer) Kombi BxY 1st Facelift | 2003-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2001,
    "Mo": "Mondeo Combi (BWY) (5-Türer) Kombi | 2001-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2002,
    "Mo": "Mondeo Combi (BWY) (5-Türer) Kombi | 2001-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2003,
    "Mo": "Mondeo Combi (BWY) (5-Türer) Kombi BxY | 2001-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2005,
    "Mo": "Mondeo Combi (BWY) (5-Türer) Kombi BxY 2nd Facelift | 2005-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2006,
    "Mo": "Mondeo Combi (BWY) (5-Türer) Kombi | 2005-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "Mondeo Combi (BWY) (5-Türer) Kombi | 2005-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1997,
    "Mo": "Mondeo Combi (BNP) (5-Türer) Kombi BxP/GBP Facelift | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1998,
    "Mo": "Mondeo Combi (BNP) (5-Türer) Kombi | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1999,
    "Mo": "Mondeo Combi (BNP) (5-Türer) Kombi | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2000,
    "Mo": "Mondeo Combi (BNP) (5-Türer) Kombi | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2001,
    "Mo": "Mondeo Combi (BNP) (5-Türer) Kombi | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1993,
    "Mo": "Mondeo Combi (BNP) (5-Türer) Kombi | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1994,
    "Mo": "Mondeo Combi (BNP) (5-Türer) Kombi | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1995,
    "Mo": "Mondeo Combi (BNP) (5-Türer) Kombi | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1996,
    "Mo": "Mondeo Combi (BNP) (5-Türer) Kombi | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1997,
    "Mo": "Mondeo Combi (BNP) (5-Türer) Kombi BxP/GBP | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Ranger Double Cab (4-Türer) Pickup RA | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Ranger Double Cab (4-Türer) Pickup RA | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Ranger Double Cab (4-Türer) Pickup | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Ranger Double Cab (4-Türer) Pickup | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Ranger Double Cab (4-Türer) Pickup | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Ranger Double Cab (4-Türer) Pickup PX 2nd Facelift | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Ranger Double Cab (4-Türer) Pickup | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Ranger Double Cab (4-Türer) Pickup | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Ranger Double Cab (4-Türer) Pickup PX 2nd Facelift | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Ranger Double Cab (4-Türer) Pickup PX 2nd Facelift | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Ranger Double Cab (4-Türer) Pickup | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Ranger Double Cab (4-Türer) Pickup | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Ranger Double Cab (4-Türer) Pickup | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Ranger Double Cab (4-Türer) Pickup | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Ranger Double Cab (4-Türer) Pickup PX | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Ranger Double Cab (4-Türer) Pickup PX 1st Facelift | 2016-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Ranger Double Cab (4-Türer) Pickup | 2016-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Ranger Double Cab (4-Türer) Pickup | 2016-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Ranger Double Cab (4-Türer) Pickup PX 1st Facelift | 2016-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Ranger SuperCab (2-Türer) Pickup PX 2nd Facelift | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Ranger SuperCab (2-Türer) Pickup | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Ranger SuperCab (2-Türer) Pickup | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Ranger SuperCab (2-Türer) Pickup | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Ranger SuperCab (2-Türer) Pickup | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Ranger SuperCab (2-Türer) Pickup | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Ranger SuperCab (2-Türer) Pickup | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Ranger SuperCab (2-Türer) Pickup | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Ranger SuperCab (2-Türer) Pickup | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Ranger SuperCab (2-Türer) Pickup PX | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Ranger SuperCab (2-Türer) Pickup PX 1st Facelift | 2016-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Ranger SuperCab (2-Türer) Pickup | 2016-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Ranger SuperCab (2-Türer) Pickup | 2016-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Ranger SuperCab (2-Türer) Pickup PX 1st Facelift | 2016-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1998,
    "Mo": "Scorpio Combi (GNR) (5-Türer) Kombi GxR Facelift | 1998-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1995,
    "Mo": "Scorpio Combi (GNR) (5-Türer) Kombi | 1995-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1996,
    "Mo": "Scorpio Combi (GNR) (5-Türer) Kombi | 1995-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1997,
    "Mo": "Scorpio Combi (GNR) (5-Türer) Kombi | 1995-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1998,
    "Mo": "Scorpio Combi (GNR) (5-Türer) Kombi GxR | 1995-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1992,
    "Mo": "Scorpio Combi (GNM) (5-Türer) Kombi | 1992-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1993,
    "Mo": "Scorpio Combi (GNM) (5-Türer) Kombi | 1992-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1994,
    "Mo": "Scorpio Combi (GNM) (5-Türer) Kombi | 1992-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1995,
    "Mo": "Scorpio Combi (GNM) (5-Türer) Kombi | 1992-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1987,
    "Mo": "Sierra Combi (BNG) (5-Türer) Kombi | 1987-1990",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1988,
    "Mo": "Sierra Combi (BNG) (5-Türer) Kombi | 1987-1990",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1989,
    "Mo": "Sierra Combi (BNG) (5-Türer) Kombi | 1987-1990",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1990,
    "Mo": "Sierra Combi (BNG) (5-Türer) Kombi BxG/GBx | 1987-1990",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1990,
    "Mo": "Sierra Combi (BNG) (5-Türer) Kombi BxG/GBx Facelift | 1990-1993",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1991,
    "Mo": "Sierra Combi (BNG) (5-Türer) Kombi | 1990-1993",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1992,
    "Mo": "Sierra Combi (BNG) (5-Türer) Kombi | 1990-1993",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1993,
    "Mo": "Sierra Combi (BNG) (5-Türer) Kombi | 1990-1993",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1983,
    "Mo": "Sierra Combi (BNC) (5-Türer) Kombi | 1983-1987",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1984,
    "Mo": "Sierra Combi (BNC) (5-Türer) Kombi | 1983-1987",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1985,
    "Mo": "Sierra Combi (BNC) (5-Türer) Kombi | 1983-1987",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1986,
    "Mo": "Sierra Combi (BNC) (5-Türer) Kombi | 1983-1987",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1987,
    "Mo": "Sierra Combi (BNC) (5-Türer) Kombi | 1983-1987",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Grand Tourneo Connect (5-Türer) LCV 3rd Generation | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Grand Tourneo Connect (5-Türer) LCV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Grand Tourneo Connect (5-Türer) LCV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Grand Tourneo Connect (5-Türer) LCV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Grand Tourneo Connect (5-Türer) LCV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Tourneo Connect (5-Türer) LCV 3rd Generation | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Tourneo Connect (5-Türer) LCV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Tourneo Connect (5-Türer) LCV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Tourneo Connect (5-Türer) LCV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Tourneo Connect (5-Türer) LCV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Tourneo Courier (5-Türer) LCV | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Tourneo Courier (5-Türer) LCV | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Tourneo Courier (5-Türer) LCV | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Tourneo Courier (5-Türer) LCV | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Courier (4-Türer) LCV | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Courier (4-Türer) LCV | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Courier (4-Türer) LCV | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2026,
    "Mo": "Transit Courier (4-Türer) LCV | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1995,
    "Mo": "Windstar (4-Türer) MPV | 1995-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1996,
    "Mo": "Windstar (4-Türer) MPV | 1995-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "C-Class T-Modell (S204) (5-Türer) Kombi | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "C-Class T-Modell (S204) (5-Türer) Kombi | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "C-Class T-Modell (S204) (5-Türer) Kombi | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "C-Class T-Modell (S204) (5-Türer) Kombi W204 | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "C-Class T-Modell (S204) (5-Türer) Kombi W204 Facelift | 2011-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "C-Class T-Modell (S204) (5-Türer) Kombi | 2011-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "C-Class T-Modell (S204) (5-Türer) Kombi | 2011-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "C-Class T-Modell (S204) (5-Türer) Kombi | 2011-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2004,
    "Mo": "C-Class T-Modell (S203) (5-Türer) Kombi W203 Facelift | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2005,
    "Mo": "C-Class T-Modell (S203) (5-Türer) Kombi | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "C-Class T-Modell (S203) (5-Türer) Kombi | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "C-Class T-Modell (S203) (5-Türer) Kombi | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "C-Class T-Modell (S203) (5-Türer) Kombi | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1996,
    "Mo": "C-Class T-Modell (S202) (5-Türer) Kombi | 1996-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1997,
    "Mo": "C-Class T-Modell (S202) (5-Türer) Kombi W202 | 1996-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1997,
    "Mo": "C-Class T-Modell (S202) (5-Türer) Kombi W202 Facelift | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1998,
    "Mo": "C-Class T-Modell (S202) (5-Türer) Kombi | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1999,
    "Mo": "C-Class T-Modell (S202) (5-Türer) Kombi | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2000,
    "Mo": "C-Class T-Modell (S202) (5-Türer) Kombi | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2001,
    "Mo": "C-Class T-Modell (S202) (5-Türer) Kombi | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2001,
    "Mo": "C-Class T-Modell (S203) (5-Türer) Kombi | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2002,
    "Mo": "C-Class T-Modell (S203) (5-Türer) Kombi | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2003,
    "Mo": "C-Class T-Modell (S203) (5-Türer) Kombi | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2004,
    "Mo": "C-Class T-Modell (S203) (5-Türer) Kombi W203 | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2000,
    "Mo": "E-Class T-Modell (S210) (5-Türer) Kombi | 2000-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2001,
    "Mo": "E-Class T-Modell (S210) (5-Türer) Kombi | 2000-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2002,
    "Mo": "E-Class T-Modell (S210) (5-Türer) Kombi | 2000-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2003,
    "Mo": "E-Class T-Modell (S210) (5-Türer) Kombi | 2000-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1993,
    "Mo": "E-Class T-Modell (S124) (5-Türer) Kombi W124 2nd Facelift | 1993-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1994,
    "Mo": "E-Class T-Modell (S124) (5-Türer) Kombi | 1993-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1995,
    "Mo": "E-Class T-Modell (S124) (5-Türer) Kombi | 1993-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1996,
    "Mo": "E-Class T-Modell (S124) (5-Türer) Kombi | 1993-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1990,
    "Mo": "E-Class T-Modell (S124) (5-Türer) Kombi | 1990-1993",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1991,
    "Mo": "E-Class T-Modell (S124) (5-Türer) Kombi | 1990-1993",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1992,
    "Mo": "E-Class T-Modell (S124) (5-Türer) Kombi | 1990-1993",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1993,
    "Mo": "E-Class T-Modell (S124) (5-Türer) Kombi W124 1st Facelift | 1990-1993",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1985,
    "Mo": "E-Class T-Modell (S124) (5-Türer) Kombi | 1985-1989",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1986,
    "Mo": "E-Class T-Modell (S124) (5-Türer) Kombi | 1985-1989",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1987,
    "Mo": "E-Class T-Modell (S124) (5-Türer) Kombi | 1985-1989",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1988,
    "Mo": "E-Class T-Modell (S124) (5-Türer) Kombi | 1985-1989",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1989,
    "Mo": "E-Class T-Modell (S124) (5-Türer) Kombi | 1985-1989",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1996,
    "Mo": "E-Class T-Modell (S210) (5-Türer) Kombi | 1996-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1997,
    "Mo": "E-Class T-Modell (S210) (5-Türer) Kombi | 1996-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1998,
    "Mo": "E-Class T-Modell (S210) (5-Türer) Kombi | 1996-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1999,
    "Mo": "E-Class T-Modell (S210) (5-Türer) Kombi | 1996-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "E-Class T-Modell (S212) (5-Türer) Kombi | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "E-Class T-Modell (S212) (5-Türer) Kombi | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "E-Class T-Modell (S212) (5-Türer) Kombi | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "E-Class T-Modell (S212) (5-Türer) Kombi | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "E-Class T-Modell (S212) (5-Türer) Kombi W212 | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "E-Class T-Modell (S212) (5-Türer) Kombi W212 Facelift | 2014-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "E-Class T-Modell (S212) (5-Türer) Kombi | 2014-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "E-Class T-Modell (S212) (5-Türer) Kombi | 2014-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2003,
    "Mo": "E-Class T-Modell (S211) (5-Türer) Kombi | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2004,
    "Mo": "E-Class T-Modell (S211) (5-Türer) Kombi | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2005,
    "Mo": "E-Class T-Modell (S211) (5-Türer) Kombi | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "E-Class T-Modell (S211) (5-Türer) Kombi W211 | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "E-Class T-Modell (S211) (5-Türer) Kombi W211 Facelift | 2006-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "E-Class T-Modell (S211) (5-Türer) Kombi | 2006-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "E-Class T-Modell (S211) (5-Türer) Kombi | 2006-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "E-Class T-Modell (S211) (5-Türer) Kombi | 2006-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "EQB (5-Türer) SUV | 2022-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "EQB (5-Türer) SUV | 2022-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "EQB (5-Türer) SUV | 2022-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "EQV (5-Türer) LCV | 2020-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "EQV (5-Türer) LCV | 2020-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "EQV (5-Türer) LCV | 2020-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "EQV (5-Türer) LCV | 2020-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "EQV (5-Türer) LCV 1st Generation | 2020-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "EQV (5-Türer) LCV 1st Generation Facelift | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "EQV (5-Türer) LCV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "EQV (5-Türer) LCV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "GL-Class (X166) (5-Türer) SUV | 2013-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "GL-Class (X166) (5-Türer) SUV | 2013-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "GL-Class (X166) (5-Türer) SUV | 2013-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "GL-Class (X166) (5-Türer) SUV | 2013-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "GLB (5-Türer) SUV | 2026-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "GLB (X247) (5-Türer) SUV | 2020-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "GLB (X247) (5-Türer) SUV | 2020-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "GLB (X247) (5-Türer) SUV | 2020-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "GLB (X247) (5-Türer) SUV | 2020-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "GLB (X247 Facelift) (5-Türer) SUV | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "GLB (X247 Facelift) (5-Türer) SUV | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "GLB (X247 Facelift) (5-Türer) SUV | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "GLB (X247 Facelift) (5-Türer) SUV | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "GLE (W166) (5-Türer) SUV | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "GLE (W166) (5-Türer) SUV | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "GLE (W166) (5-Türer) SUV | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "GLE (W166) (5-Türer) SUV | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "GLE (W166) (5-Türer) SUV | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "GLE (V167) (5-Türer) SUV V167 1st Facelift | 2023-2026",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "GLE (V167) (5-Türer) SUV | 2023-2026",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "GLE (V167) (5-Türer) SUV | 2023-2026",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "GLE (V167) (5-Türer) SUV | 2023-2026",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "GLE (V167) (5-Türer) SUV | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "GLE (V167) (5-Türer) SUV | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "GLE (V167) (5-Türer) SUV | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "GLE (V167) (5-Türer) SUV | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "GLE (V167) (5-Türer) SUV V167 | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "GLK-Class (X204) (5-Türer) SUV | 2013-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "GLK-Class (X204) (5-Türer) SUV | 2013-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "GLK-Class (X204) (5-Türer) SUV | 2013-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "GLK-Class (X204) (5-Türer) SUV | 2009-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "GLK-Class (X204) (5-Türer) SUV | 2009-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "GLK-Class (X204) (5-Türer) SUV | 2009-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "GLK-Class (X204) (5-Türer) SUV | 2009-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "GLS (X166) (5-Türer) SUV | 2016-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "GLS (X166) (5-Türer) SUV | 2016-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "GLS (X166) (5-Türer) SUV | 2016-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "GLS (X166) (5-Türer) SUV | 2016-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "GLS (X167) (5-Türer) SUV | 2024-2026",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "GLS (X167) (5-Türer) SUV | 2024-2026",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "GLS (X167) (5-Türer) SUV | 2024-2026",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "M-Class (W166) (5-Türer) SUV | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "M-Class (W166) (5-Türer) SUV | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "M-Class (W166) (5-Türer) SUV | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "M-Class (W166) (5-Türer) SUV | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1997,
    "Mo": "M-Class (W163) (5-Türer) SUV | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1998,
    "Mo": "M-Class (W163) (5-Türer) SUV | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1999,
    "Mo": "M-Class (W163) (5-Türer) SUV | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2000,
    "Mo": "M-Class (W163) (5-Türer) SUV | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2001,
    "Mo": "M-Class (W163) (5-Türer) SUV W163 | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2001,
    "Mo": "M-Class (W163) (5-Türer) SUV W163 Facelift | 2001-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2002,
    "Mo": "M-Class (W163) (5-Türer) SUV | 2001-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2003,
    "Mo": "M-Class (W163) (5-Türer) SUV | 2001-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2004,
    "Mo": "M-Class (W163) (5-Türer) SUV | 2001-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2005,
    "Mo": "M-Class (W163) (5-Türer) SUV | 2001-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "M-Class (W163) (5-Türer) SUV | 2001-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "M-Class (W164) (5-Türer) SUV | 2009-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "M-Class (W164) (5-Türer) SUV | 2009-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "M-Class (W164) (5-Türer) SUV | 2009-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "M-Class (W164) (5-Türer) SUV | 2009-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "M-Class (W164) (5-Türer) SUV | 2006-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "M-Class (W164) (5-Türer) SUV | 2006-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "M-Class (W164) (5-Türer) SUV | 2006-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "V-Class 2.8t (5-Türer) MPV | 2014-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "V-Class 2.8t (5-Türer) MPV | 2014-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "V-Class 2.8t (5-Türer) MPV | 2014-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "V-Class 2.8t (5-Türer) MPV | 2014-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "V-Class 2.8t (5-Türer) MPV | 2014-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "V-Class 2.8t (5-Türer) MPV | 2014-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "V-Class 3.1t (5-Türer) MPV W447 1st Facelift | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "V-Class 3.1t (5-Türer) MPV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "V-Class 3.1t (5-Türer) MPV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "V-Class 3.1t (5-Türer) MPV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "V-Class 3.1t (5-Türer) MPV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "V-Class 3.1t (5-Türer) MPV W447 1st Facelift | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "V-Class 3.1t (5-Türer) MPV | 2014-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "V-Class 3.1t (5-Türer) MPV | 2014-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "V-Class 3.1t (5-Türer) MPV | 2014-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "V-Class 3.1t (5-Türer) MPV | 2014-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "V-Class 3.1t (5-Türer) MPV | 2014-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "V-Class 3.1t (5-Türer) MPV W447 | 2014-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "V-Class 3.1t (5-Türer) MPV W447 2nd Facelift | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "V-Class 3.1t (5-Türer) MPV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "V-Class 3.1t (5-Türer) MPV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "V-Class 3.2t (5-Türer) MPV W447 1st Facelift | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "V-Class 3.2t (5-Türer) MPV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "V-Class 3.2t (5-Türer) MPV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "V-Class 3.2t (5-Türer) MPV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "V-Class 3.2t (5-Türer) MPV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "V-Class 3.2t (5-Türer) MPV W447 1st Facelift | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "V-Class 3.2t (5-Türer) MPV | 2014-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "V-Class 3.2t (5-Türer) MPV | 2014-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "V-Class 3.2t (5-Türer) MPV | 2014-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "V-Class 3.2t (5-Türer) MPV | 2014-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "V-Class 3.2t (5-Türer) MPV | 2014-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "V-Class 3.2t (5-Türer) MPV W447 | 2014-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "V-Class 3.2t (5-Türer) MPV W447 2nd Facelift | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "V-Class 3.2t (5-Türer) MPV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "V-Class 3.2t (5-Türer) MPV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2002,
    "Mo": "Vaneo (5-Türer) MPV | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2003,
    "Mo": "Vaneo (5-Türer) MPV | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2004,
    "Mo": "Vaneo (5-Türer) MPV | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2005,
    "Mo": "Vaneo (5-Türer) MPV | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2003,
    "Mo": "Viano (W639) (5-Türer) LCV | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2004,
    "Mo": "Viano (W639) (5-Türer) LCV | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2005,
    "Mo": "Viano (W639) (5-Türer) LCV | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "Viano (W639) (5-Türer) LCV | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "Viano (W639) (5-Türer) LCV | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "Viano (W639) (5-Türer) LCV | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "Viano (W639) (5-Türer) LCV | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Viano (W639) (5-Türer) LCV | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Viano (W639) (5-Türer) LCV | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito 2.8t (5-Türer) LCV W447 2nd Facelift | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "Vito 2.8t (5-Türer) LCV W447 2nd Facelift | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "Vito 2.8t (5-Türer) LCV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Vito 2.8t (5-Türer) LCV W447 | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "Vito 2.8t (5-Türer) LCV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "Vito 2.8t (5-Türer) LCV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "Vito 2.8t (5-Türer) LCV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Vito 2.8t (5-Türer) LCV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito 2.8t (5-Türer) LCV W447 | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito 2.8t (5-Türer) LCV W447 | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito 2.8t (5-Türer) LCV W447 1st Facelift | 2019-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito 2.8t (5-Türer) LCV W447 1st Facelift | 2019-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "Vito 2.8t (5-Türer) LCV | 2019-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "Vito 2.8t (5-Türer) LCV | 2019-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "Vito 2.8t (5-Türer) LCV | 2019-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito 2.8t (5-Türer) LCV W447 1st Facelift | 2019-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "Vito 2.8t (5-Türer) LCV W447 1st Facelift | 2019-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito 3.0t (5-Türer) LCV W447 2nd Facelift | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "Vito 3.0t (5-Türer) LCV W447 2nd Facelift | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "Vito 3.0t (5-Türer) LCV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Vito 3.0t (5-Türer) LCV W447 | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "Vito 3.0t (5-Türer) LCV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "Vito 3.0t (5-Türer) LCV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "Vito 3.0t (5-Türer) LCV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Vito 3.0t (5-Türer) LCV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito 3.0t (5-Türer) LCV W447 | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito 3.0t (5-Türer) LCV W447 | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito 3.0t (5-Türer) LCV W447 1st Facelift | 2019-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito 3.0t (5-Türer) LCV W447 1st Facelift | 2019-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "Vito 3.0t (5-Türer) LCV | 2019-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "Vito 3.0t (5-Türer) LCV | 2019-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "Vito 3.0t (5-Türer) LCV | 2019-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito 3.0t (5-Türer) LCV W447 1st Facelift | 2019-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "Vito 3.0t (5-Türer) LCV W447 1st Facelift | 2019-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito 3.2t (5-Türer) LCV W447 2nd Facelift | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "Vito 3.2t (5-Türer) LCV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "Vito 3.2t (5-Türer) LCV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Vito 3.2t (5-Türer) LCV W447 | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "Vito 3.2t (5-Türer) LCV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "Vito 3.2t (5-Türer) LCV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "Vito 3.2t (5-Türer) LCV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Vito 3.2t (5-Türer) LCV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito 3.2t (5-Türer) LCV W447 | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito 3.2t (5-Türer) LCV W447 | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito 3.2t (5-Türer) LCV W447 1st Facelift | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito 3.2t (5-Türer) LCV W447 1st Facelift | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "Vito 3.2t (5-Türer) LCV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "Vito 3.2t (5-Türer) LCV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "Vito 3.2t (5-Türer) LCV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito 3.2t (5-Türer) LCV W447 1st Facelift | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV W447 2nd Facelift | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV W447 | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV W447 | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV W447 | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV W447 1st Facelift | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV W447 1st Facelift | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito Mixto 2.8t (4-Türer) LCV W447 1st Facelift | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV W447 2nd Facelift | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV W447 | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV W447 | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV W447 | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV W447 1st Facelift | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV W447 1st Facelift | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito Mixto 3.0t (4-Türer) LCV W447 1st Facelift | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV W447 | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV W447 | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV W447 | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV W447 2nd Facelift | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV W447 1st Facelift | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV W447 1st Facelift | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito Mixto 3.2t (4-Türer) LCV W447 1st Facelift | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Vito MPV 2.8t (5-Türer) LCV W639 Facelift | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Vito MPV 2.8t (5-Türer) LCV W639 Facelift | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "Vito MPV 2.8t (5-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "Vito MPV 2.8t (5-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Vito MPV 2.8t (5-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2003,
    "Mo": "Vito MPV 2.8t (5-Türer) LCV | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2004,
    "Mo": "Vito MPV 2.8t (5-Türer) LCV | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2005,
    "Mo": "Vito MPV 2.8t (5-Türer) LCV | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "Vito MPV 2.8t (5-Türer) LCV | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "Vito MPV 2.8t (5-Türer) LCV | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "Vito MPV 2.8t (5-Türer) LCV | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "Vito MPV 2.8t (5-Türer) LCV | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Vito MPV 2.8t (5-Türer) LCV W639 | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Vito MPV 2.8t (5-Türer) LCV W639 | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV W447 2nd Facelift | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV W447 | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV W447 | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV W447 | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV W447 1st Facelift | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV W447 1st Facelift | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV W447 1st Facelift | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV W639 Facelift | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV W639 Facelift | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV W639 Facelift | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2003,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2004,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2005,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV W639 | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Vito MPV 3.1t (5-Türer) LCV W639 | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito MPV 3.2t (5-Türer) LCV W447 2nd Facelift | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "Vito MPV 3.2t (5-Türer) LCV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "Vito MPV 3.2t (5-Türer) LCV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Vito MPV 3.2t (5-Türer) LCV W447 | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "Vito MPV 3.2t (5-Türer) LCV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "Vito MPV 3.2t (5-Türer) LCV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "Vito MPV 3.2t (5-Türer) LCV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Vito MPV 3.2t (5-Türer) LCV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito MPV 3.2t (5-Türer) LCV W447 | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito MPV 3.2t (5-Türer) LCV W447 | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito MPV 3.2t (5-Türer) LCV W447 1st Facelift | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito MPV 3.2t (5-Türer) LCV W447 1st Facelift | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "Vito MPV 3.2t (5-Türer) LCV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "Vito MPV 3.2t (5-Türer) LCV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "Vito MPV 3.2t (5-Türer) LCV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito MPV 3.2t (5-Türer) LCV W447 1st Facelift | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Vito MPV 3.2t (5-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Vito MPV 3.2t (5-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "Vito MPV 3.2t (5-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "Vito MPV 3.2t (5-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Vito MPV 3.2t (5-Türer) LCV W639 Facelift | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito MPV 3.5t (5-Türer) LCV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito MPV 3.5t (5-Türer) LCV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "Vito MPV 3.5t (5-Türer) LCV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "Vito MPV 3.5t (5-Türer) LCV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "Vito MPV 3.5t (5-Türer) LCV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito MPV 3.5t (5-Türer) LCV W447 1st Facelift | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito MPV 3.5t (5-Türer) LCV W447 2nd Facelift | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "Vito MPV 3.5t (5-Türer) LCV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "Vito MPV 3.5t (5-Türer) LCV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "X-Class (W470) (4-Türer) Pickup | 2018-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "X-Class (W470) (4-Türer) Pickup | 2018-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "X-Class (W470) (4-Türer) Pickup | 2018-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2000,
    "Mo": "Agila (5-Türer) Schrägheck | 2000-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2001,
    "Mo": "Agila (5-Türer) Schrägheck | 2000-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2002,
    "Mo": "Agila (5-Türer) Schrägheck | 2000-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2003,
    "Mo": "Agila (5-Türer) Schrägheck | 2000-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2004,
    "Mo": "Agila (5-Türer) Schrägheck | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2005,
    "Mo": "Agila (5-Türer) Schrägheck | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2006,
    "Mo": "Agila (5-Türer) Schrägheck | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2007,
    "Mo": "Agila (5-Türer) Schrägheck | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2008,
    "Mo": "Agila (5-Türer) Schrägheck | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2011,
    "Mo": "Antara (5-Türer) SUV A Facelift | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2012,
    "Mo": "Antara (5-Türer) SUV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2013,
    "Mo": "Antara (5-Türer) SUV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2014,
    "Mo": "Antara (5-Türer) SUV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2015,
    "Mo": "Antara (5-Türer) SUV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2006,
    "Mo": "Antara (5-Türer) SUV | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2007,
    "Mo": "Antara (5-Türer) SUV | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2008,
    "Mo": "Antara (5-Türer) SUV | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2009,
    "Mo": "Antara (5-Türer) SUV | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2010,
    "Mo": "Antara (5-Türer) SUV | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2011,
    "Mo": "Antara (5-Türer) SUV A | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1992,
    "Mo": "Astra Wagon (5-Türer) Kombi | 1992-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1993,
    "Mo": "Astra Wagon (5-Türer) Kombi | 1992-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1994,
    "Mo": "Astra Wagon (5-Türer) Kombi | 1992-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Combo (5-Türer) LCV E | 2018-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Combo (5-Türer) LCV | 2018-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Combo (5-Türer) LCV | 2018-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Combo (5-Türer) LCV | 2018-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Combo (5-Türer) LCV | 2018-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Combo (5-Türer) LCV | 2018-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Combo (5-Türer) LCV | 2018-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2002,
    "Mo": "Frontera (5-Türer) SUV | 2002-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2003,
    "Mo": "Frontera (5-Türer) SUV | 2002-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2004,
    "Mo": "Frontera (5-Türer) SUV | 2002-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1992,
    "Mo": "Frontera (5-Türer) SUV | 1992-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1993,
    "Mo": "Frontera (5-Türer) SUV | 1992-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1994,
    "Mo": "Frontera (5-Türer) SUV | 1992-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1995,
    "Mo": "Frontera (5-Türer) SUV | 1992-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1996,
    "Mo": "Frontera (5-Türer) SUV A | 1992-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1996,
    "Mo": "Frontera (5-Türer) SUV A Facelift | 1996-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1997,
    "Mo": "Frontera (5-Türer) SUV | 1996-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1998,
    "Mo": "Frontera (5-Türer) SUV | 1996-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1999,
    "Mo": "Frontera (5-Türer) SUV | 1999-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2000,
    "Mo": "Frontera (5-Türer) SUV | 1999-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2001,
    "Mo": "Frontera (5-Türer) SUV | 1999-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1985,
    "Mo": "Kadett Caravan (5-Türer) Kombi | 1985-1989",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1986,
    "Mo": "Kadett Caravan (5-Türer) Kombi | 1985-1989",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1987,
    "Mo": "Kadett Caravan (5-Türer) Kombi | 1985-1989",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1988,
    "Mo": "Kadett Caravan (5-Türer) Kombi | 1985-1989",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1989,
    "Mo": "Kadett Caravan (5-Türer) Kombi | 1985-1989",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Karl Rocks (5-Türer) Crossover | 2017-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Karl Rocks (5-Türer) Crossover 1st Generation | 2017-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Karl Rocks (5-Türer) Crossover 1st Generation Facelift | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Karl Rocks (5-Türer) Crossover | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Karl Rocks (5-Türer) Crossover | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Karl Rocks (5-Türer) Crossover | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Karl Rocks (5-Türer) Crossover | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Karl Rocks (5-Türer) Crossover | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Karl Rocks (5-Türer) Crossover | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Karl Rocks (5-Türer) Crossover | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2026,
    "Mo": "Karl Rocks (5-Türer) Crossover | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1995,
    "Mo": "Monterey (3-Türer) SUV | 1995-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1996,
    "Mo": "Monterey (3-Türer) SUV | 1995-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1997,
    "Mo": "Monterey (3-Türer) SUV | 1995-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1995,
    "Mo": "Monterey (5-Türer) SUV | 1995-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1996,
    "Mo": "Monterey (5-Türer) SUV | 1995-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1997,
    "Mo": "Monterey (5-Türer) SUV | 1995-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1991,
    "Mo": "Omega Caravan (5-Türer) Kombi A2 | 1991-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1992,
    "Mo": "Omega Caravan (5-Türer) Kombi | 1991-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1993,
    "Mo": "Omega Caravan (5-Türer) Kombi | 1991-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1994,
    "Mo": "Omega Caravan (5-Türer) Kombi A2 | 1991-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1994,
    "Mo": "Omega Caravan (5-Türer) Kombi B1 | 1994-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1995,
    "Mo": "Omega Caravan (5-Türer) Kombi | 1994-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1996,
    "Mo": "Omega Caravan (5-Türer) Kombi | 1994-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1997,
    "Mo": "Omega Caravan (5-Türer) Kombi | 1994-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1998,
    "Mo": "Omega Caravan (5-Türer) Kombi | 1994-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1999,
    "Mo": "Omega Caravan (5-Türer) Kombi | 1994-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2000,
    "Mo": "Omega Caravan (5-Türer) Kombi B1 | 1994-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2000,
    "Mo": "Omega Caravan (5-Türer) Kombi B2 | 2000-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2001,
    "Mo": "Omega Caravan (5-Türer) Kombi | 2000-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2002,
    "Mo": "Omega Caravan (5-Türer) Kombi | 2000-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2003,
    "Mo": "Omega Caravan (5-Türer) Kombi | 2000-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1987,
    "Mo": "Omega Caravan (5-Türer) Kombi | 1987-1991",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1988,
    "Mo": "Omega Caravan (5-Türer) Kombi | 1987-1991",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1989,
    "Mo": "Omega Caravan (5-Türer) Kombi | 1987-1991",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1990,
    "Mo": "Omega Caravan (5-Türer) Kombi | 1987-1991",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1991,
    "Mo": "Omega Caravan (5-Türer) Kombi A1 | 1987-1991",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1997,
    "Mo": "Sintra (4-Türer) MPV | 1997-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1998,
    "Mo": "Sintra (4-Türer) MPV | 1997-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1999,
    "Mo": "Sintra (4-Türer) MPV | 1997-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1997,
    "Mo": "Vectra Caravan (5-Türer) Kombi | 1997-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1998,
    "Mo": "Vectra Caravan (5-Türer) Kombi | 1997-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1999,
    "Mo": "Vectra Caravan (5-Türer) Kombi B | 1997-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1999,
    "Mo": "Vectra Caravan (5-Türer) Kombi B Facelift | 1999-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2000,
    "Mo": "Vectra Caravan (5-Türer) Kombi | 1999-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2001,
    "Mo": "Vectra Caravan (5-Türer) Kombi | 1999-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2002,
    "Mo": "Vectra Caravan (5-Türer) Kombi | 1999-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1999,
    "Mo": "Zafira (5-Türer) MPV | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2000,
    "Mo": "Zafira (5-Türer) MPV | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2001,
    "Mo": "Zafira (5-Türer) MPV | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2002,
    "Mo": "Zafira (5-Türer) MPV | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2003,
    "Mo": "Zafira (5-Türer) MPV A | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2003,
    "Mo": "Zafira (5-Türer) MPV A Facelift | 2003-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2004,
    "Mo": "Zafira (5-Türer) MPV | 2003-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2005,
    "Mo": "Zafira (5-Türer) MPV | 2003-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2005,
    "Mo": "1007 (3-Türer) MPV | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2006,
    "Mo": "1007 (3-Türer) MPV | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2007,
    "Mo": "1007 (3-Türer) MPV | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "1007 (3-Türer) MPV | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2009,
    "Mo": "1007 (3-Türer) MPV | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "2008 (5-Türer) Kombi | 2013-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "2008 (5-Türer) Kombi | 2013-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "2008 (5-Türer) Kombi | 2013-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "2008 (5-Türer) Kombi A94 | 2013-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "2008 (5-Türer) Kombi A94 Facelift | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "2008 (5-Türer) Kombi | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "2008 (5-Türer) Kombi | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "2008 (5-Türer) Kombi A94 Facelift | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "2008 (5-Türer) Kombi A94 Facelift | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2002,
    "Mo": "206 SW (2E) (5-Türer) Kombi | 2002-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2003,
    "Mo": "206 SW (2E) (5-Türer) Kombi 1st Generation | 2002-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2003,
    "Mo": "206 SW (2E) (5-Türer) Kombi 1st Generation Facelift | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2004,
    "Mo": "206 SW (2E) (5-Türer) Kombi | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2005,
    "Mo": "206 SW (2E) (5-Türer) Kombi | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2006,
    "Mo": "206 SW (2E) (5-Türer) Kombi | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2007,
    "Mo": "206 SW (2E) (5-Türer) Kombi | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "206 SW (2E) (5-Türer) Kombi | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2009,
    "Mo": "207 SW (WE Facelif) (5-Türer) Kombi | 2009-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2010,
    "Mo": "207 SW (WE Facelif) (5-Türer) Kombi | 2009-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "207 SW (WE Facelif) (5-Türer) Kombi | 2009-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "207 SW (WE Facelif) (5-Türer) Kombi | 2009-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "207 SW (WE Facelif) (5-Türer) Kombi | 2009-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "207 SW (WE Facelif) (5-Türer) Kombi | 2009-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "207 SW (WE Facelif) (5-Türer) Kombi | 2009-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2006,
    "Mo": "207 SW (WE) (5-Türer) Kombi | 2006-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2007,
    "Mo": "207 SW (WE) (5-Türer) Kombi | 2006-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "207 SW (WE) (5-Türer) Kombi | 2006-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2009,
    "Mo": "207 SW (WE) (5-Türer) Kombi | 2006-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 1997,
    "Mo": "306 Break (7E Phase I) (5-Türer) Kombi | 1997-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 1998,
    "Mo": "306 Break (7E Phase I) (5-Türer) Kombi | 1997-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 1999,
    "Mo": "306 Break (7E Phase I) (5-Türer) Kombi | 1997-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2002,
    "Mo": "307 SW (3H) (5-Türer) Kombi | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2003,
    "Mo": "307 SW (3H) (5-Türer) Kombi | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2004,
    "Mo": "307 SW (3H) (5-Türer) Kombi | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2005,
    "Mo": "307 SW (3H) (5-Türer) Kombi | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2005,
    "Mo": "307 SW (3H Facelif) (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2006,
    "Mo": "307 SW (3H Facelif) (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2007,
    "Mo": "307 SW (3H Facelif) (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "307 SW (3H Facelif) (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "308 SW (4E/H) (5-Türer) Kombi | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2009,
    "Mo": "308 SW (4E/H) (5-Türer) Kombi | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2010,
    "Mo": "308 SW (4E/H) (5-Türer) Kombi | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "308 SW (4E/H) (5-Türer) Kombi | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "308 SW (4E/H Facelift) (5-Türer) Kombi | 2011-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "308 SW (4E/H Facelift) (5-Türer) Kombi | 2011-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "308 SW (4E/H Facelift) (5-Türer) Kombi | 2011-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "308 SW (4E/H Facelift) (5-Türer) Kombi | 2011-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "4007 (5-Türer) SUV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2009,
    "Mo": "4007 (5-Türer) SUV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2010,
    "Mo": "4007 (5-Türer) SUV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "4007 (5-Türer) SUV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "4007 (5-Türer) SUV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 1993,
    "Mo": "405 Break (4E) (5-Türer) Kombi | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 1994,
    "Mo": "405 Break (4E) (5-Türer) Kombi | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 1995,
    "Mo": "405 Break (4E) (5-Türer) Kombi | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 1996,
    "Mo": "405 Break (4E) (5-Türer) Kombi | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 1997,
    "Mo": "405 Break (4E) (5-Türer) Kombi | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 1999,
    "Mo": "406 Break (8E/F Phase) (5-Türer) Kombi Phase II | 1999-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2000,
    "Mo": "406 Break (8E/F Phase) (5-Türer) Kombi | 1999-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2001,
    "Mo": "406 Break (8E/F Phase) (5-Türer) Kombi | 1999-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2002,
    "Mo": "406 Break (8E/F Phase) (5-Türer) Kombi | 1999-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 1997,
    "Mo": "406 Break (8E/F Phase) (5-Türer) Kombi | 1997-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 1998,
    "Mo": "406 Break (8E/F Phase) (5-Türer) Kombi | 1997-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 1999,
    "Mo": "406 Break (8E/F Phase) (5-Türer) Kombi Phase I | 1997-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2003,
    "Mo": "406 Break (8E/F Phase) (5-Türer) Kombi | 2003-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2004,
    "Mo": "406 Break (8E/F Phase) (5-Türer) Kombi | 2003-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "407 SW (6E 2nd Fac) (5-Türer) Kombi | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2009,
    "Mo": "407 SW (6E 2nd Fac) (5-Türer) Kombi | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2010,
    "Mo": "407 SW (6E 2nd Fac) (5-Türer) Kombi | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "407 SW (6E 2nd Fac) (5-Türer) Kombi | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2004,
    "Mo": "407 SW (6E) (5-Türer) Kombi | 2004-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2005,
    "Mo": "407 SW (6E) (5-Türer) Kombi | 2004-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2006,
    "Mo": "407 SW (6E) (5-Türer) Kombi | 2004-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2006,
    "Mo": "407 SW (6E 1st Fac) (5-Türer) Kombi | 2006-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2007,
    "Mo": "407 SW (6E 1st Fac) (5-Türer) Kombi | 2006-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "407 SW (6E 1st Fac) (5-Türer) Kombi | 2006-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "Bipper (3-Türer) LCV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2009,
    "Mo": "Bipper (3-Türer) LCV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2010,
    "Mo": "Bipper (3-Türer) LCV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "Bipper (3-Türer) LCV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "Bipper (3-Türer) LCV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "Bipper (3-Türer) LCV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "Bipper (3-Türer) LCV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "Bipper (3-Türer) LCV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "Bipper (3-Türer) LCV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "Bipper Tepee (3-Türer) LCV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2009,
    "Mo": "Bipper Tepee (3-Türer) LCV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2010,
    "Mo": "Bipper Tepee (3-Türer) LCV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "Bipper Tepee (3-Türer) LCV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "Bipper Tepee (3-Türer) LCV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "Bipper Tepee (3-Türer) LCV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "Bipper Tepee (3-Türer) LCV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "Bipper Tepee (3-Türer) LCV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "Bipper Tepee (3-Türer) LCV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "Rifter (5-Türer) MPV 1st Generation Facelift | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "Rifter (5-Türer) MPV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2026,
    "Mo": "Rifter (5-Türer) MPV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "Rifter (5-Türer) MPV | 2018-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "Rifter (5-Türer) MPV | 2018-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "Rifter (5-Türer) MPV | 2018-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "Rifter (5-Türer) MPV | 2018-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "Rifter (5-Türer) MPV | 2018-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "Rifter (5-Türer) MPV | 2018-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "Rifter (5-Türer) MPV 1st Generation | 2018-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2011,
    "Mo": "Murano (5-Türer) SUV Z51 Facelift | 2011-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2012,
    "Mo": "Murano (5-Türer) SUV | 2011-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "Murano (5-Türer) SUV | 2011-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "Murano (5-Türer) SUV | 2011-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "Murano (5-Türer) SUV | 2011-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "Murano (5-Türer) SUV | 2011-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2008,
    "Mo": "Murano (5-Türer) SUV Z51 | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2009,
    "Mo": "Murano (5-Türer) SUV | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2010,
    "Mo": "Murano (5-Türer) SUV | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2011,
    "Mo": "Murano (5-Türer) SUV Z51 | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2002,
    "Mo": "Murano (5-Türer) SUV | 2002-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2003,
    "Mo": "Murano (5-Türer) SUV | 2002-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2004,
    "Mo": "Murano (5-Türer) SUV | 2002-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2005,
    "Mo": "Murano (5-Türer) SUV | 2002-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2006,
    "Mo": "Murano (5-Türer) SUV | 2002-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2007,
    "Mo": "Murano (5-Türer) SUV | 2002-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2008,
    "Mo": "Murano (5-Türer) SUV Z50 | 2002-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "Navara Double Cab (4-Türer) Pickup D23 | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "Navara Double Cab (4-Türer) Pickup D23 | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "Navara Double Cab (4-Türer) Pickup | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "Navara Double Cab (4-Türer) Pickup | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "Navara Double Cab (4-Türer) Pickup | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "Navara Double Cab (4-Türer) Pickup | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "Navara Double Cab (4-Türer) Pickup | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Navara Double Cab (4-Türer) Pickup | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Navara Double Cab (4-Türer) Pickup | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Navara Double Cab (4-Türer) Pickup | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Navara Double Cab (4-Türer) Pickup | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2026,
    "Mo": "Navara Double Cab (4-Türer) Pickup | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1999,
    "Mo": "Pathfinder (5-Türer) SUV R50 Facelift | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2000,
    "Mo": "Pathfinder (5-Türer) SUV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2001,
    "Mo": "Pathfinder (5-Türer) SUV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2002,
    "Mo": "Pathfinder (5-Türer) SUV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2003,
    "Mo": "Pathfinder (5-Türer) SUV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2004,
    "Mo": "Pathfinder (5-Türer) SUV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1996,
    "Mo": "Pathfinder (5-Türer) SUV | 1996-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1997,
    "Mo": "Pathfinder (5-Türer) SUV | 1996-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1998,
    "Mo": "Pathfinder (5-Türer) SUV | 1996-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1999,
    "Mo": "Pathfinder (5-Türer) SUV R50 | 1996-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "Pathfinder (5-Türer) SUV | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "Pathfinder (5-Türer) SUV | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "Pathfinder (5-Türer) SUV | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "Pathfinder (5-Türer) SUV | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "Pathfinder (5-Türer) SUV | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "Patrol SUV (5-Türer) SUV | 2020-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "Patrol SUV (5-Türer) SUV | 2020-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Patrol SUV (5-Türer) SUV | 2020-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Patrol SUV (5-Türer) SUV | 2020-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Patrol SUV (5-Türer) SUV | 2020-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1998,
    "Mo": "Primera Traveller (5-Türer) Kombi P11 1st Facelift | 1998-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1999,
    "Mo": "Primera Traveller (5-Türer) Kombi | 1998-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1995,
    "Mo": "Primera Traveller (5-Türer) Kombi | 1995-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1996,
    "Mo": "Primera Traveller (5-Türer) Kombi | 1995-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1997,
    "Mo": "Primera Traveller (5-Türer) Kombi | 1995-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1998,
    "Mo": "Primera Traveller (5-Türer) Kombi P10 Facelift | 1995-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2000,
    "Mo": "Primera Traveller (5-Türer) Kombi | 2000-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2001,
    "Mo": "Primera Traveller (5-Türer) Kombi | 2000-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2002,
    "Mo": "Primera Traveller (5-Türer) Kombi P11 2nd Facelift | 2000-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2002,
    "Mo": "Primera Traveller (5-Türer) Kombi P12 | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2003,
    "Mo": "Primera Traveller (5-Türer) Kombi | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2004,
    "Mo": "Primera Traveller (5-Türer) Kombi | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2005,
    "Mo": "Primera Traveller (5-Türer) Kombi | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2006,
    "Mo": "Primera Traveller (5-Türer) Kombi | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2007,
    "Mo": "Primera Traveller (5-Türer) Kombi | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2007,
    "Mo": "Qashqai (5-Türer) SUV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2008,
    "Mo": "Qashqai (5-Türer) SUV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2009,
    "Mo": "Qashqai (5-Türer) SUV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2010,
    "Mo": "Qashqai (5-Türer) SUV J10 | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2010,
    "Mo": "Qashqai (5-Türer) SUV J10 Facelift | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2011,
    "Mo": "Qashqai (5-Türer) SUV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2012,
    "Mo": "Qashqai (5-Türer) SUV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "Qashqai (5-Türer) SUV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "Qashqai (5-Türer) SUV J10 Facelift | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "Qashqai (5-Türer) SUV J11 | 2014-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "Qashqai (5-Türer) SUV | 2014-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "Qashqai (5-Türer) SUV | 2014-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "Qashqai (5-Türer) SUV J11 | 2014-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "Qashqai (5-Türer) SUV J11 Facelift | 2017-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "Qashqai (5-Türer) SUV | 2017-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "Qashqai (5-Türer) SUV | 2017-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "Qashqai (5-Türer) SUV | 2017-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "Qashqai (5-Türer) SUV J11 Facelift | 2017-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2009,
    "Mo": "Qashqai+2 (5-Türer) SUV | 2009-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2010,
    "Mo": "Qashqai+2 (5-Türer) SUV J10 | 2009-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2010,
    "Mo": "Qashqai+2 (5-Türer) SUV J10 Facelift | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2011,
    "Mo": "Qashqai+2 (5-Türer) SUV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2012,
    "Mo": "Qashqai+2 (5-Türer) SUV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "Qashqai+2 (5-Türer) SUV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "Qashqai+2 (5-Türer) SUV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1996,
    "Mo": "Stagea (5-Türer) Kombi | 1996-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1997,
    "Mo": "Stagea (5-Türer) Kombi | 1996-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1998,
    "Mo": "Stagea (5-Türer) Kombi | 1996-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1999,
    "Mo": "Stagea (5-Türer) Kombi WC34 Series I | 1996-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1999,
    "Mo": "Stagea (5-Türer) Kombi WC34 Series II | 1999-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2000,
    "Mo": "Stagea (5-Türer) Kombi | 1999-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2001,
    "Mo": "Stagea (5-Türer) Kombi | 1999-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2002,
    "Mo": "Terrano II (3-Türer) SUV | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2003,
    "Mo": "Terrano II (3-Türer) SUV | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2004,
    "Mo": "Terrano II (3-Türer) SUV | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2005,
    "Mo": "Terrano II (3-Türer) SUV | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2006,
    "Mo": "Terrano II (3-Türer) SUV | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2007,
    "Mo": "Terrano II (3-Türer) SUV | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2002,
    "Mo": "Terrano II (5-Türer) SUV | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2003,
    "Mo": "Terrano II (5-Türer) SUV | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2004,
    "Mo": "Terrano II (5-Türer) SUV | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2005,
    "Mo": "Terrano II (5-Türer) SUV | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2006,
    "Mo": "Terrano II (5-Türer) SUV | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2007,
    "Mo": "Terrano II (5-Türer) SUV | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "X-Trail (5-Türer) SUV T32 Facelift | 2017-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "X-Trail (5-Türer) SUV | 2017-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "X-Trail (5-Türer) SUV | 2017-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "X-Trail (5-Türer) SUV | 2017-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "X-Trail (5-Türer) SUV T32 Facelift | 2017-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "X-Trail (5-Türer) SUV | 2014-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "X-Trail (5-Türer) SUV | 2014-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "X-Trail (5-Türer) SUV | 2014-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "X-Trail (5-Türer) SUV T32 | 2014-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2018,
    "Mo": "Fabia Combi (5-Türer) Kombi NJ Facelift | 2018-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2019,
    "Mo": "Fabia Combi (5-Türer) Kombi | 2018-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2020,
    "Mo": "Fabia Combi (5-Türer) Kombi | 2018-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2021,
    "Mo": "Fabia Combi (5-Türer) Kombi | 2018-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2022,
    "Mo": "Fabia Combi (5-Türer) Kombi | 2018-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2023,
    "Mo": "Fabia Combi (5-Türer) Kombi | 2018-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2015,
    "Mo": "Fabia Combi (5-Türer) Kombi | 2015-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2016,
    "Mo": "Fabia Combi (5-Türer) Kombi | 2015-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2017,
    "Mo": "Fabia Combi (5-Türer) Kombi | 2015-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2018,
    "Mo": "Fabia Combi (5-Türer) Kombi NJ | 2015-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2010,
    "Mo": "Fabia Combi (3T5 Facelift) (5-Türer) Kombi | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2011,
    "Mo": "Fabia Combi (3T5 Facelift) (5-Türer) Kombi | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2012,
    "Mo": "Fabia Combi (3T5 Facelift) (5-Türer) Kombi | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2013,
    "Mo": "Fabia Combi (3T5 Facelift) (5-Türer) Kombi | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2014,
    "Mo": "Fabia Combi (3T5 Facelift) (5-Türer) Kombi | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2015,
    "Mo": "Fabia Combi (3T5 Facelift) (5-Türer) Kombi | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2007,
    "Mo": "Fabia Combi (5-Türer) Kombi | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2008,
    "Mo": "Fabia Combi (5-Türer) Kombi | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2009,
    "Mo": "Fabia Combi (5-Türer) Kombi | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2010,
    "Mo": "Fabia Combi (5-Türer) Kombi | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2001,
    "Mo": "Fabia Combi (6Y5) (5-Türer) Kombi | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2002,
    "Mo": "Fabia Combi (6Y5) (5-Türer) Kombi | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2003,
    "Mo": "Fabia Combi (6Y5) (5-Türer) Kombi | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2004,
    "Mo": "Fabia Combi (6Y5) (5-Türer) Kombi | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2005,
    "Mo": "Fabia Combi (6Y5 Faceli) (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2006,
    "Mo": "Fabia Combi (6Y5 Faceli) (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2007,
    "Mo": "Fabia Combi (6Y5 Faceli) (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2008,
    "Mo": "Fabia Combi (6Y5 Faceli) (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2010,
    "Mo": "Fabia Scout (5-Türer) Kombi 5J Facelift | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2011,
    "Mo": "Fabia Scout (5-Türer) Kombi | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2012,
    "Mo": "Fabia Scout (5-Türer) Kombi | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2013,
    "Mo": "Fabia Scout (5-Türer) Kombi | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2014,
    "Mo": "Fabia Scout (5-Türer) Kombi | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2015,
    "Mo": "Fabia Scout (5-Türer) Kombi | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2007,
    "Mo": "Fabia Scout (5-Türer) Kombi | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2008,
    "Mo": "Fabia Scout (5-Türer) Kombi | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2009,
    "Mo": "Fabia Scout (5-Türer) Kombi | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2010,
    "Mo": "Fabia Scout (5-Türer) Kombi 5J | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2010,
    "Mo": "Fabia Scout (5-Türer) Kombi 5J Facelift | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2011,
    "Mo": "Fabia Scout (5-Türer) Kombi | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2012,
    "Mo": "Fabia Scout (5-Türer) Kombi | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2013,
    "Mo": "Fabia Scout (5-Türer) Kombi | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2014,
    "Mo": "Fabia Scout (5-Türer) Kombi | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2015,
    "Mo": "Fabia Scout (5-Türer) Kombi | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 1990,
    "Mo": "Forman (785) (5-Türer) Kombi | 1990-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 1991,
    "Mo": "Forman (785) (5-Türer) Kombi | 1990-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 1992,
    "Mo": "Forman (785) (5-Türer) Kombi | 1990-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 1993,
    "Mo": "Forman (785) (5-Türer) Kombi | 1990-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 1994,
    "Mo": "Forman (785) (5-Türer) Kombi | 1990-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 1995,
    "Mo": "Forman (785) (5-Türer) Kombi | 1990-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 1998,
    "Mo": "Felicia Combi (6U5 Facelift) (5-Türer) Kombi | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 1999,
    "Mo": "Felicia Combi (6U5 Facelift) (5-Türer) Kombi | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2000,
    "Mo": "Felicia Combi (6U5 Facelift) (5-Türer) Kombi | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2001,
    "Mo": "Felicia Combi (6U5 Facelift) (5-Türer) Kombi | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2019,
    "Mo": "Kamiq (5-Türer) SUV | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2020,
    "Mo": "Kamiq (5-Türer) SUV | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2021,
    "Mo": "Kamiq (5-Türer) SUV | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2022,
    "Mo": "Kamiq (5-Türer) SUV | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2023,
    "Mo": "Kamiq (5-Türer) SUV | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2024,
    "Mo": "Kamiq (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2025,
    "Mo": "Kamiq (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2026,
    "Mo": "Kamiq (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2022,
    "Mo": "Karoq (5-Türer) SUV 1st Generation Facelift | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2023,
    "Mo": "Karoq (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2024,
    "Mo": "Karoq (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2025,
    "Mo": "Karoq (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2026,
    "Mo": "Karoq (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2018,
    "Mo": "Karoq (5-Türer) SUV | 2018-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2019,
    "Mo": "Karoq (5-Türer) SUV | 2018-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2020,
    "Mo": "Karoq (5-Türer) SUV | 2018-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2021,
    "Mo": "Karoq (5-Türer) SUV | 2018-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2022,
    "Mo": "Karoq (5-Türer) SUV 1st Generation | 2018-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2017,
    "Mo": "Kodiaq (5-Türer) SUV | 2017-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2018,
    "Mo": "Kodiaq (5-Türer) SUV | 2017-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2019,
    "Mo": "Kodiaq (5-Türer) SUV | 2017-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2020,
    "Mo": "Kodiaq (5-Türer) SUV | 2017-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2021,
    "Mo": "Kodiaq (5-Türer) SUV 1st Generation | 2017-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2021,
    "Mo": "Kodiaq (5-Türer) SUV 1st Generation Facelift | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2022,
    "Mo": "Kodiaq (5-Türer) SUV | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2023,
    "Mo": "Kodiaq (5-Türer) SUV | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2024,
    "Mo": "Kodiaq (5-Türer) SUV 1st Generation Facelift | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2017,
    "Mo": "Kodiaq 7-Seater (5-Türer) SUV | 2017-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2018,
    "Mo": "Kodiaq 7-Seater (5-Türer) SUV | 2017-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2019,
    "Mo": "Kodiaq 7-Seater (5-Türer) SUV | 2017-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2020,
    "Mo": "Kodiaq 7-Seater (5-Türer) SUV | 2017-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2021,
    "Mo": "Kodiaq 7-Seater (5-Türer) SUV 1st Generation | 2017-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2021,
    "Mo": "Kodiaq 7-Seater (5-Türer) SUV 1st Generation Facelift | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2022,
    "Mo": "Kodiaq 7-Seater (5-Türer) SUV | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2023,
    "Mo": "Kodiaq 7-Seater (5-Türer) SUV | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2024,
    "Mo": "Kodiaq 7-Seater (5-Türer) SUV 1st Generation Facelift | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 1997,
    "Mo": "Octavia Combi (1U5) (5-Türer) Kombi | 1997-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 1998,
    "Mo": "Octavia Combi (1U5) (5-Türer) Kombi | 1997-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 1999,
    "Mo": "Octavia Combi (1U5) (5-Türer) Kombi | 1997-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2000,
    "Mo": "Octavia Combi (1U5) (5-Türer) Kombi | 1997-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2017,
    "Mo": "Octavia Combi (5E5 Facelift) (5-Türer) Kombi | 2017-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2018,
    "Mo": "Octavia Combi (5E5 Facelift) (5-Türer) Kombi | 2017-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2019,
    "Mo": "Octavia Combi (5E5 Facelift) (5-Türer) Kombi | 2017-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2020,
    "Mo": "Octavia Combi (5E5 Facelift) (5-Türer) Kombi | 2017-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2013,
    "Mo": "Octavia Combi (5E5) (5-Türer) Kombi | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2014,
    "Mo": "Octavia Combi (5E5) (5-Türer) Kombi | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2015,
    "Mo": "Octavia Combi (5E5) (5-Türer) Kombi | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2016,
    "Mo": "Octavia Combi (5E5) (5-Türer) Kombi | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2017,
    "Mo": "Octavia Combi (5E5) (5-Türer) Kombi | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2009,
    "Mo": "Octavia Combi (1Z5 Facelift) (5-Türer) Kombi | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2010,
    "Mo": "Octavia Combi (1Z5 Facelift) (5-Türer) Kombi | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2011,
    "Mo": "Octavia Combi (1Z5 Facelift) (5-Türer) Kombi | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2012,
    "Mo": "Octavia Combi (1Z5 Facelift) (5-Türer) Kombi | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2013,
    "Mo": "Octavia Combi (1Z5 Facelift) (5-Türer) Kombi | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2005,
    "Mo": "Octavia Combi (1Z5) (5-Türer) Kombi | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2006,
    "Mo": "Octavia Combi (1Z5) (5-Türer) Kombi | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2007,
    "Mo": "Octavia Combi (1Z5) (5-Türer) Kombi | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2008,
    "Mo": "Octavia Combi (1Z5) (5-Türer) Kombi | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2009,
    "Mo": "Octavia Combi (1Z5) (5-Türer) Kombi | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2017,
    "Mo": "Octavia Scout (5-Türer) Crossover 5E Facelift | 2017-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2018,
    "Mo": "Octavia Scout (5-Türer) Crossover | 2017-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2019,
    "Mo": "Octavia Scout (5-Türer) Crossover | 2017-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2020,
    "Mo": "Octavia Scout (5-Türer) Crossover | 2017-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2014,
    "Mo": "Octavia Scout (5-Türer) Crossover | 2014-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2015,
    "Mo": "Octavia Scout (5-Türer) Crossover | 2014-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2016,
    "Mo": "Octavia Scout (5-Türer) Crossover | 2014-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2017,
    "Mo": "Octavia Scout (5-Türer) Crossover 5E | 2014-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2009,
    "Mo": "Octavia Scout (5-Türer) Crossover 1Z Facelift | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2010,
    "Mo": "Octavia Scout (5-Türer) Crossover | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2011,
    "Mo": "Octavia Scout (5-Türer) Crossover | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2012,
    "Mo": "Octavia Scout (5-Türer) Crossover | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2013,
    "Mo": "Octavia Scout (5-Türer) Crossover | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2007,
    "Mo": "Octavia Scout (5-Türer) Crossover | 2007-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2008,
    "Mo": "Octavia Scout (5-Türer) Crossover | 2007-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2009,
    "Mo": "Octavia Scout (5-Türer) Crossover 1Z | 2007-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2010,
    "Mo": "Roomster (5-Türer) LCV 5J Facelift | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2011,
    "Mo": "Roomster (5-Türer) LCV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2012,
    "Mo": "Roomster (5-Türer) LCV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2013,
    "Mo": "Roomster (5-Türer) LCV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2014,
    "Mo": "Roomster (5-Türer) LCV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2015,
    "Mo": "Roomster (5-Türer) LCV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2006,
    "Mo": "Roomster (5-Türer) LCV | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2007,
    "Mo": "Roomster (5-Türer) LCV | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2008,
    "Mo": "Roomster (5-Türer) LCV | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2009,
    "Mo": "Roomster (5-Türer) LCV | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2010,
    "Mo": "Roomster (5-Türer) LCV 5J | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2007,
    "Mo": "Roomster Scout (5-Türer) LCV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2008,
    "Mo": "Roomster Scout (5-Türer) LCV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2009,
    "Mo": "Roomster Scout (5-Türer) LCV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2010,
    "Mo": "Roomster Scout (5-Türer) LCV 5J | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2010,
    "Mo": "Roomster Scout (5-Türer) LCV 5J Facelift | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2011,
    "Mo": "Roomster Scout (5-Türer) LCV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2012,
    "Mo": "Roomster Scout (5-Türer) LCV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2013,
    "Mo": "Roomster Scout (5-Türer) LCV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2014,
    "Mo": "Roomster Scout (5-Türer) LCV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2015,
    "Mo": "Roomster Scout (5-Türer) LCV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2020,
    "Mo": "Superb Combi (3V5 Facelift) (5-Türer) Kombi | 2020-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2021,
    "Mo": "Superb Combi (3V5 Facelift) (5-Türer) Kombi | 2020-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2022,
    "Mo": "Superb Combi (3V5 Facelift) (5-Türer) Kombi | 2020-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2023,
    "Mo": "Superb Combi (3V5 Facelift) (5-Türer) Kombi | 2020-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2024,
    "Mo": "Superb Combi (3V5 Facelift) (5-Türer) Kombi | 2020-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2015,
    "Mo": "Superb Combi (3V5) (5-Türer) Kombi | 2015-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2016,
    "Mo": "Superb Combi (3V5) (5-Türer) Kombi | 2015-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2017,
    "Mo": "Superb Combi (3V5) (5-Türer) Kombi | 2015-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2018,
    "Mo": "Superb Combi (3V5) (5-Türer) Kombi | 2015-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2019,
    "Mo": "Superb Combi (3V5) (5-Türer) Kombi | 2015-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2020,
    "Mo": "Superb Combi (3V5) (5-Türer) Kombi | 2015-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2014,
    "Mo": "Superb Combi (3T5 Facelift) (5-Türer) Kombi | 2014-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2015,
    "Mo": "Superb Combi (3T5 Facelift) (5-Türer) Kombi | 2014-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2009,
    "Mo": "Superb Combi (3T5) (5-Türer) Kombi | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2010,
    "Mo": "Superb Combi (3T5) (5-Türer) Kombi | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2011,
    "Mo": "Superb Combi (3T5) (5-Türer) Kombi | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2012,
    "Mo": "Superb Combi (3T5) (5-Türer) Kombi | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2013,
    "Mo": "Superb Combi (3T5) (5-Türer) Kombi | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2010,
    "Mo": "Yeti (5-Türer) SUV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2011,
    "Mo": "Yeti (5-Türer) SUV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2012,
    "Mo": "Yeti (5-Türer) SUV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2013,
    "Mo": "Yeti (5-Türer) SUV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2014,
    "Mo": "Yeti (5-Türer) SUV 5L | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2014,
    "Mo": "Yeti (5-Türer) SUV 5L Facelift | 2014-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2015,
    "Mo": "Yeti (5-Türer) SUV | 2014-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2016,
    "Mo": "Yeti (5-Türer) SUV | 2014-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2017,
    "Mo": "Yeti (5-Türer) SUV | 2014-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "4 E-Tech (5-Türer) SUV | 2025-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2026,
    "Mo": "4 E-Tech (5-Türer) SUV | 2025-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Alaskan (4-Türer) Pickup | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Alaskan (4-Türer) Pickup | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Alaskan (4-Türer) Pickup | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Alaskan (4-Türer) Pickup | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Alaskan (4-Türer) Pickup | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Alaskan (4-Türer) Pickup | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Alaskan (4-Türer) Pickup | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Alaskan (4-Türer) Pickup | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Alaskan (4-Türer) Pickup | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2026,
    "Mo": "Alaskan (4-Türer) Pickup | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Clio Sport Tourer (KH Phase II) (5-Türer) Kombi | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Clio Sport Tourer (KH Phase II) (5-Türer) Kombi | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Clio Sport Tourer (KH Phase II) (5-Türer) Kombi | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Clio Sport Tourer (KH Phase II) (5-Türer) Kombi | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Clio Sport Tourer (KH Phase II) (5-Türer) Kombi | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Clio Sport Tourer (KH) (5-Türer) Kombi | 2013-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Clio Sport Tourer (KH) (5-Türer) Kombi | 2013-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Clio Sport Tourer (KH) (5-Türer) Kombi | 2013-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Clio Sport Tourer (KH) (5-Türer) Kombi | 2013-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Koleos (5-Türer) SUV | 2014-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Koleos (5-Türer) SUV | 2014-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2008,
    "Mo": "Koleos (5-Türer) SUV | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2009,
    "Mo": "Koleos (5-Türer) SUV | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2010,
    "Mo": "Koleos (5-Türer) SUV | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2011,
    "Mo": "Koleos (5-Türer) SUV 1st Generation | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2011,
    "Mo": "Koleos (5-Türer) SUV 1st Generation 1st Facelift | 2011-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2012,
    "Mo": "Koleos (5-Türer) SUV | 2011-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Koleos (5-Türer) SUV | 2011-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2005,
    "Mo": "Laguna Grandtour (KG0 II) (5-Türer) Kombi | 2005-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2006,
    "Mo": "Laguna Grandtour (KG0 II) (5-Türer) Kombi | 2005-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2007,
    "Mo": "Laguna Grandtour (KG0 II) (5-Türer) Kombi | 2005-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 1998,
    "Mo": "Laguna Grandtour (K56 II) (5-Türer) Kombi | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 1999,
    "Mo": "Laguna Grandtour (K56 II) (5-Türer) Kombi | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2000,
    "Mo": "Laguna Grandtour (K56 II) (5-Türer) Kombi | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2001,
    "Mo": "Laguna Grandtour (K56 II) (5-Türer) Kombi | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2001,
    "Mo": "Laguna Grandtour (KG0 I) (5-Türer) Kombi | 2001-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2002,
    "Mo": "Laguna Grandtour (KG0 I) (5-Türer) Kombi | 2001-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2003,
    "Mo": "Laguna Grandtour (KG0 I) (5-Türer) Kombi | 2001-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2004,
    "Mo": "Laguna Grandtour (KG0 I) (5-Türer) Kombi | 2001-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2005,
    "Mo": "Laguna Grandtour (KG0 I) (5-Türer) Kombi | 2001-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2006,
    "Mo": "Mégane Grandtour (KM II) (5-Türer) Kombi | 2006-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2007,
    "Mo": "Mégane Grandtour (KM II) (5-Türer) Kombi | 2006-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2008,
    "Mo": "Mégane Grandtour (KM II) (5-Türer) Kombi | 2006-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2009,
    "Mo": "Mégane Grandtour (KM II) (5-Türer) Kombi | 2006-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2012,
    "Mo": "Mégane Grandtour (KZ II) (5-Türer) Kombi | 2012-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Mégane Grandtour (KZ II) (5-Türer) Kombi | 2012-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Mégane Grandtour (KZ II) (5-Türer) Kombi | 2012-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Mégane Grandtour (KZ III) (5-Türer) Kombi | 2013-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Mégane Grandtour (KZ III) (5-Türer) Kombi | 2013-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Mégane Grandtour (KZ III) (5-Türer) Kombi | 2013-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Mégane Grandtour (KZ III) (5-Türer) Kombi | 2013-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2009,
    "Mo": "Mégane Grandtour (KZ I) (5-Türer) Kombi | 2009-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2010,
    "Mo": "Mégane Grandtour (KZ I) (5-Türer) Kombi | 2009-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2011,
    "Mo": "Mégane Grandtour (KZ I) (5-Türer) Kombi | 2009-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2012,
    "Mo": "Mégane Grandtour (KZ I) (5-Türer) Kombi | 2009-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2004,
    "Mo": "Mégane Grandtour (KM I) (5-Türer) Kombi | 2004-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2005,
    "Mo": "Mégane Grandtour (KM I) (5-Türer) Kombi | 2004-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2006,
    "Mo": "Mégane Grandtour (KM I) (5-Türer) Kombi | 2004-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2009,
    "Mo": "Sandero Stepway (5-Türer) Crossover | 2009-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2010,
    "Mo": "Sandero Stepway (5-Türer) Crossover | 2009-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2011,
    "Mo": "Sandero Stepway (5-Türer) Crossover 1st Generation | 2009-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2011,
    "Mo": "Sandero Stepway (5-Türer) Crossover 1st Generation Facelift | 2011-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2012,
    "Mo": "Sandero Stepway (5-Türer) Crossover | 2011-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Sandero Stepway (5-Türer) Crossover | 2011-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2010,
    "Mo": "Grand Scénic (5-Türer) MPV | 2010-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2011,
    "Mo": "Grand Scénic (5-Türer) MPV | 2010-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2012,
    "Mo": "Grand Scénic (5-Türer) MPV | 2010-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Grand Scénic (5-Türer) MPV | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Grand Scénic (5-Türer) MPV | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Grand Scénic (5-Türer) MPV | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Grand Scénic (5-Türer) MPV | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Grand Scénic (5-Türer) MPV | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Scénic (5-Türer) MPV | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Scénic (5-Türer) MPV | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Scénic (5-Türer) MPV | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Scénic (5-Türer) MPV | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Scénic (5-Türer) MPV | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2010,
    "Mo": "Scénic (5-Türer) MPV | 2010-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2011,
    "Mo": "Scénic (5-Türer) MPV | 2010-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2012,
    "Mo": "Scénic (5-Türer) MPV | 2010-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Scénic Xmod (5-Türer) Crossover | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Scénic Xmod (5-Türer) Crossover | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Scénic Xmod (5-Türer) Crossover | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Scénic Xmod (5-Türer) Crossover | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Scénic Xmod (5-Türer) Crossover | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2005,
    "Mo": "5 (5-Türer) MPV | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2006,
    "Mo": "5 (5-Türer) MPV | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2007,
    "Mo": "5 (5-Türer) MPV | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2008,
    "Mo": "5 (5-Türer) MPV CR | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2008,
    "Mo": "5 (5-Türer) MPV CR Facelift | 2008-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2009,
    "Mo": "5 (5-Türer) MPV | 2008-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2010,
    "Mo": "5 (5-Türer) MPV | 2008-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2003,
    "Mo": "6 Wagon (5-Türer) Kombi | 2003-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2004,
    "Mo": "6 Wagon (5-Türer) Kombi | 2003-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2005,
    "Mo": "6 Wagon (5-Türer) Kombi | 2003-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2006,
    "Mo": "6 Wagon (5-Türer) Kombi | 2006-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2007,
    "Mo": "6 Wagon (5-Türer) Kombi | 2006-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2008,
    "Mo": "6 Wagon (5-Türer) Kombi | 2008-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2009,
    "Mo": "6 Wagon (5-Türer) Kombi | 2008-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2010,
    "Mo": "6 Wagon (5-Türer) Kombi GH | 2008-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2010,
    "Mo": "6 Wagon (5-Türer) Kombi GH Facelift | 2010-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2011,
    "Mo": "6 Wagon (5-Türer) Kombi | 2010-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2012,
    "Mo": "6 Wagon (5-Türer) Kombi | 2010-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2013,
    "Mo": "6 Wagon (5-Türer) Kombi GH Facelift | 2010-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2015,
    "Mo": "6 Wagon (5-Türer) Kombi GJ Facelift | 2015-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2016,
    "Mo": "6 Wagon (5-Türer) Kombi GJ Facelift | 2015-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2013,
    "Mo": "6 Wagon (5-Türer) Kombi GJ | 2013-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2014,
    "Mo": "6 Wagon (5-Türer) Kombi | 2013-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2015,
    "Mo": "6 Wagon (5-Türer) Kombi GJ | 2013-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2016,
    "Mo": "6 Wagon (5-Türer) Kombi GL | 2016-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2017,
    "Mo": "6 Wagon (5-Türer) Kombi | 2016-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2018,
    "Mo": "6 Wagon (5-Türer) Kombi GL | 2016-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2018,
    "Mo": "6 Wagon (5-Türer) Kombi GL Facelift | 2018-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2019,
    "Mo": "6 Wagon (5-Türer) Kombi | 2018-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2020,
    "Mo": "6 Wagon (5-Türer) Kombi | 2018-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2021,
    "Mo": "6 Wagon (5-Türer) Kombi | 2018-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "6 Wagon (5-Türer) Kombi | 2018-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2023,
    "Mo": "6 Wagon (5-Türer) Kombi | 2018-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "6 Wagon (5-Türer) Kombi | 2018-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "6 Wagon (5-Türer) Kombi | 2018-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1990,
    "Mo": "626 Wagon (GV) (5-Türer) Kombi | 1990-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1991,
    "Mo": "626 Wagon (GV) (5-Türer) Kombi | 1990-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1992,
    "Mo": "626 Wagon (GV) (5-Türer) Kombi | 1990-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1993,
    "Mo": "626 Wagon (GV) (5-Türer) Kombi | 1990-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1994,
    "Mo": "626 Wagon (GV) (5-Türer) Kombi | 1990-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1995,
    "Mo": "626 Wagon (GV) (5-Türer) Kombi | 1990-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1996,
    "Mo": "626 Wagon (GV) (5-Türer) Kombi | 1990-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1997,
    "Mo": "626 Wagon (GV) (5-Türer) Kombi | 1990-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1988,
    "Mo": "626 Wagon (5-Türer) Kombi | 1988-1990",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1989,
    "Mo": "626 Wagon (5-Türer) Kombi | 1988-1990",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1990,
    "Mo": "626 Wagon (5-Türer) Kombi | 1988-1990",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1997,
    "Mo": "626 Wagon (GW) (5-Türer) Kombi | 1997-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1998,
    "Mo": "626 Wagon (GW) (5-Türer) Kombi | 1997-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1999,
    "Mo": "626 Wagon (GW) (5-Türer) Kombi | 1997-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2000,
    "Mo": "626 Wagon (GW) (5-Türer) Kombi | 1997-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2001,
    "Mo": "626 Wagon (GW) (5-Türer) Kombi | 1997-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2002,
    "Mo": "626 Wagon (GW) (5-Türer) Kombi | 1997-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2002,
    "Mo": "MPV (4-Türer) MPV LW Facelift | 2002-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2003,
    "Mo": "MPV (4-Türer) MPV | 2002-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2004,
    "Mo": "MPV (4-Türer) MPV | 2002-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2005,
    "Mo": "MPV (4-Türer) MPV | 2002-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2006,
    "Mo": "MPV (4-Türer) MPV | 2002-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1999,
    "Mo": "MPV (4-Türer) MPV LW | 1999-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2000,
    "Mo": "MPV (4-Türer) MPV | 1999-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2001,
    "Mo": "MPV (4-Türer) MPV | 1999-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2002,
    "Mo": "MPV (4-Türer) MPV LW | 1999-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1996,
    "Mo": "MPV (4-Türer) MPV | 1996-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1997,
    "Mo": "MPV (4-Türer) MPV | 1996-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1998,
    "Mo": "MPV (4-Türer) MPV | 1996-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1999,
    "Mo": "MPV (4-Türer) MPV LV 2nd Facelift | 1996-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1999,
    "Mo": "Premacy (5-Türer) MPV | 1999-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2000,
    "Mo": "Premacy (5-Türer) MPV | 1999-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2001,
    "Mo": "Premacy (5-Türer) MPV | 1999-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2002,
    "Mo": "Premacy (5-Türer) MPV CP | 1999-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2002,
    "Mo": "Premacy (5-Türer) MPV CP Facelift | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2003,
    "Mo": "Premacy (5-Türer) MPV | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2004,
    "Mo": "Premacy (5-Türer) MPV | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2005,
    "Mo": "Premacy (5-Türer) MPV | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2003,
    "Mo": "Carens (5-Türer) MPV | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2004,
    "Mo": "Carens (5-Türer) MPV | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2005,
    "Mo": "Carens (5-Türer) MPV | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2006,
    "Mo": "Carens (5-Türer) MPV | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2006,
    "Mo": "Carnival (5-Türer) MPV VQ | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2007,
    "Mo": "Carnival (5-Türer) MPV | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2008,
    "Mo": "Carnival (5-Türer) MPV | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2009,
    "Mo": "Carnival (5-Türer) MPV | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2010,
    "Mo": "Carnival (5-Türer) MPV VQ | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2010,
    "Mo": "Carnival (5-Türer) MPV VQ Facelift | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2011,
    "Mo": "Carnival (5-Türer) MPV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2012,
    "Mo": "Carnival (5-Türer) MPV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2013,
    "Mo": "Carnival (5-Türer) MPV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2014,
    "Mo": "Carnival (5-Türer) MPV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2001,
    "Mo": "Carnival (5-Türer) MPV GQ (UP Facelift) | 2001-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2002,
    "Mo": "Carnival (5-Türer) MPV | 2001-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2003,
    "Mo": "Carnival (5-Türer) MPV | 2001-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2004,
    "Mo": "Carnival (5-Türer) MPV | 2001-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2005,
    "Mo": "Carnival (5-Türer) MPV | 2001-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2006,
    "Mo": "Carnival (5-Türer) MPV GQ (UP Facelift) | 2001-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 1998,
    "Mo": "Carnival (5-Türer) MPV | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 1999,
    "Mo": "Carnival (5-Türer) MPV | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2000,
    "Mo": "Carnival (5-Türer) MPV | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2001,
    "Mo": "Carnival (5-Türer) MPV UP | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2006,
    "Mo": "Carnival LWB (4-Türer) MPV | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2007,
    "Mo": "Carnival LWB (4-Türer) MPV | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2008,
    "Mo": "Carnival LWB (4-Türer) MPV | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2009,
    "Mo": "Carnival LWB (4-Türer) MPV | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2010,
    "Mo": "Carnival LWB (4-Türer) MPV VQ | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2010,
    "Mo": "Carnival LWB (4-Türer) MPV VQ Facelift | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2011,
    "Mo": "Carnival LWB (4-Türer) MPV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2012,
    "Mo": "Carnival LWB (4-Türer) MPV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2013,
    "Mo": "Carnival LWB (4-Türer) MPV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2014,
    "Mo": "Carnival LWB (4-Türer) MPV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2007,
    "Mo": "Ceed Sportswagon (5-Türer) Kombi | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2008,
    "Mo": "Ceed Sportswagon (5-Türer) Kombi | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2009,
    "Mo": "Ceed Sportswagon (5-Türer) Kombi | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2010,
    "Mo": "Ceed Sportswagon (5-Türer) Kombi ED | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2010,
    "Mo": "Ceed Sportswagon (5-Türer) Kombi ED Facelift | 2010-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2011,
    "Mo": "Ceed Sportswagon (5-Türer) Kombi | 2010-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2012,
    "Mo": "Ceed Sportswagon (5-Türer) Kombi ED Facelift | 2010-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 1998,
    "Mo": "Clarus Kombi (5-Türer) Kombi | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 1999,
    "Mo": "Clarus Kombi (5-Türer) Kombi | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2000,
    "Mo": "Clarus Kombi (5-Türer) Kombi | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2001,
    "Mo": "Clarus Kombi (5-Türer) Kombi | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "EV9 (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "EV9 (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2026,
    "Mo": "EV9 (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 1999,
    "Mo": "Joice (5-Türer) MPV | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2000,
    "Mo": "Joice (5-Türer) MPV | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2001,
    "Mo": "Joice (5-Türer) MPV | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2002,
    "Mo": "Joice (5-Türer) MPV | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2003,
    "Mo": "Joice (5-Türer) MPV | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2003,
    "Mo": "Rio Station Wagon (5-Türer) Kombi | 2003-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2004,
    "Mo": "Rio Station Wagon (5-Türer) Kombi | 2003-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2005,
    "Mo": "Rio Station Wagon (5-Türer) Kombi | 2003-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2003,
    "Mo": "Sorento (5-Türer) SUV | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2004,
    "Mo": "Sorento (5-Türer) SUV | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2005,
    "Mo": "Sorento (5-Türer) SUV | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2006,
    "Mo": "Sorento (5-Türer) SUV | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2007,
    "Mo": "Sorento (5-Türer) SUV JC | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2007,
    "Mo": "Sorento (5-Türer) SUV JC Facelift | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2008,
    "Mo": "Sorento (5-Türer) SUV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2009,
    "Mo": "Sorento (5-Türer) SUV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2010,
    "Mo": "Sorento (5-Türer) SUV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2013,
    "Mo": "Sorento (5-Türer) SUV | 2013-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2014,
    "Mo": "Sorento (5-Türer) SUV | 2013-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2015,
    "Mo": "Sorento (5-Türer) SUV XM Facelift | 2013-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2008,
    "Mo": "Sportage (5-Türer) Crossover | 2008-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2009,
    "Mo": "Sportage (5-Türer) Crossover | 2008-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2010,
    "Mo": "Sportage (5-Türer) Crossover | 2008-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2004,
    "Mo": "Sportage (5-Türer) Crossover | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2005,
    "Mo": "Sportage (5-Türer) Crossover | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2006,
    "Mo": "Sportage (5-Türer) Crossover | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2007,
    "Mo": "Sportage (5-Türer) Crossover | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "Sportage (5-Türer) Crossover | 2022-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "Sportage (5-Türer) Crossover | 2022-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "Sportage (5-Türer) Crossover | 2022-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Sportage (5-Türer) Crossover NQ5 | 2022-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Sportage (5-Türer) Crossover NQ5 Facelift | 2025-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2026,
    "Mo": "Sportage (5-Türer) Crossover | 2025-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Stonic (5-Türer) Crossover | 2021-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "Stonic (5-Türer) Crossover | 2021-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "Stonic (5-Türer) Crossover | 2021-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "Stonic (5-Türer) Crossover | 2021-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Stonic (5-Türer) Crossover | 2021-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2026,
    "Mo": "Stonic (5-Türer) Crossover | 2026-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Stonic (5-Türer) Crossover | 2018-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Stonic (5-Türer) Crossover | 2018-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Stonic (5-Türer) Crossover | 2018-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 1998,
    "Mo": "Atos (5-Türer) Schrägheck | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 1999,
    "Mo": "Atos (5-Türer) Schrägheck | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2000,
    "Mo": "Atos (5-Türer) Schrägheck | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2001,
    "Mo": "Atos (5-Türer) Schrägheck | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2002,
    "Mo": "Atos (5-Türer) Schrägheck | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2003,
    "Mo": "Atos (5-Türer) Schrägheck | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 1999,
    "Mo": "Elantra Touring (5-Türer) Kombi | 1999-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2000,
    "Mo": "Elantra Touring (5-Türer) Kombi | 1999-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 1996,
    "Mo": "Elantra Touring (5-Türer) Kombi | 1996-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 1997,
    "Mo": "Elantra Touring (5-Türer) Kombi | 1996-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 1998,
    "Mo": "Elantra Touring (5-Türer) Kombi | 1996-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2006,
    "Mo": "Getz (5-Türer) Schrägheck | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2007,
    "Mo": "Getz (5-Türer) Schrägheck | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2008,
    "Mo": "Getz (5-Türer) Schrägheck | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2009,
    "Mo": "Getz (5-Türer) Schrägheck | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2010,
    "Mo": "Getz (5-Türer) Schrägheck | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2006,
    "Mo": "Getz Cross (5-Türer) Schrägheck | 2006-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2007,
    "Mo": "Getz Cross (5-Türer) Schrägheck | 2006-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2008,
    "Mo": "Getz Cross (5-Türer) Schrägheck | 2006-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2009,
    "Mo": "Getz Cross (5-Türer) Schrägheck | 2006-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 1998,
    "Mo": "H-1 Cargo (4-Türer) LCV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 1999,
    "Mo": "H-1 Cargo (4-Türer) LCV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2000,
    "Mo": "H-1 Cargo (4-Türer) LCV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2001,
    "Mo": "H-1 Cargo (4-Türer) LCV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2002,
    "Mo": "H-1 Cargo (4-Türer) LCV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2003,
    "Mo": "H-1 Cargo (4-Türer) LCV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2004,
    "Mo": "H-1 Cargo (4-Türer) LCV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2005,
    "Mo": "H-1 Cargo (4-Türer) LCV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2006,
    "Mo": "H-1 Cargo (4-Türer) LCV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2007,
    "Mo": "H-1 Cargo (4-Türer) LCV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2008,
    "Mo": "H-1 Travel (5-Türer) LCV | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2009,
    "Mo": "H-1 Travel (5-Türer) LCV | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2010,
    "Mo": "H-1 Travel (5-Türer) LCV | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2011,
    "Mo": "H-1 Travel (5-Türer) LCV | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2012,
    "Mo": "H-1 Travel (5-Türer) LCV | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2013,
    "Mo": "H-1 Travel (5-Türer) LCV | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2014,
    "Mo": "H-1 Travel (5-Türer) LCV | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "H-1 Travel (5-Türer) LCV | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "H-1 Travel (5-Türer) LCV | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "H-1 Travel (5-Türer) LCV | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "H-1 Travel (5-Türer) LCV 2nd Generation | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "H-1 Travel (5-Türer) LCV 2nd Generation Facelift | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "H-1 Travel (5-Türer) LCV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "H-1 Travel (5-Türer) LCV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "H-1 Travel (5-Türer) LCV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "H-1 Travel (5-Türer) LCV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "H-1 Travel (5-Türer) LCV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "H-1 Travel (5-Türer) LCV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "H-1 Travel (5-Türer) LCV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2026,
    "Mo": "H-1 Travel (5-Türer) LCV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "i20 Active (5-Türer) Crossover | 2015-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "i20 Active (5-Türer) Crossover | 2015-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "i20 Active (5-Türer) Crossover | 2015-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "i20 Active (5-Türer) Crossover GB | 2015-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "i20 Active (5-Türer) Crossover GB Facelift | 2018-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "i20 Active (5-Türer) Crossover | 2018-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "i20 Active (5-Türer) Crossover | 2018-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2008,
    "Mo": "i30 Kombi (5-Türer) Kombi | 2008-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2009,
    "Mo": "i30 Kombi (5-Türer) Kombi | 2008-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2010,
    "Mo": "i30 Kombi (5-Türer) Kombi FD | 2008-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2010,
    "Mo": "i30 Kombi (5-Türer) Kombi FD Facelift | 2010-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2011,
    "Mo": "i30 Kombi (5-Türer) Kombi | 2010-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2012,
    "Mo": "i30 Kombi (5-Türer) Kombi FD Facelift | 2010-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "Inster (5-Türer) SUV | 2025-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2026,
    "Mo": "Inster (5-Türer) SUV | 2025-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2010,
    "Mo": "ix35 (5-Türer) SUV | 2010-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2011,
    "Mo": "ix35 (5-Türer) SUV | 2010-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2012,
    "Mo": "ix35 (5-Türer) SUV | 2010-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2013,
    "Mo": "ix35 (5-Türer) SUV | 2010-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2014,
    "Mo": "ix35 (5-Türer) SUV | 2014-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "ix35 (5-Türer) SUV | 2014-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "ix35 (5-Türer) SUV | 2014-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "ix35 (5-Türer) SUV | 2014-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2006,
    "Mo": "Matrix (5-Türer) MPV FC Facelift | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2007,
    "Mo": "Matrix (5-Türer) MPV | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2008,
    "Mo": "Matrix (5-Türer) MPV | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2009,
    "Mo": "Matrix (5-Türer) MPV | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2010,
    "Mo": "Matrix (5-Türer) MPV | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2011,
    "Mo": "Matrix (5-Türer) MPV | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2001,
    "Mo": "Matrix (5-Türer) MPV | 2001-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2002,
    "Mo": "Matrix (5-Türer) MPV | 2001-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2003,
    "Mo": "Matrix (5-Türer) MPV | 2001-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2004,
    "Mo": "Matrix (5-Türer) MPV | 2001-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2005,
    "Mo": "Matrix (5-Türer) MPV | 2001-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2006,
    "Mo": "Matrix (5-Türer) MPV FC | 2001-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2010,
    "Mo": "Santa Fe (5-Türer) SUV | 2010-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2011,
    "Mo": "Santa Fe (5-Türer) SUV | 2010-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2012,
    "Mo": "Santa Fe (5-Türer) SUV | 2010-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2001,
    "Mo": "Santa Fe (5-Türer) SUV | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2002,
    "Mo": "Santa Fe (5-Türer) SUV | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2003,
    "Mo": "Santa Fe (5-Türer) SUV | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2004,
    "Mo": "Santa Fe (5-Türer) SUV | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2001,
    "Mo": "Santa Fe (5-Türer) SUV | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2002,
    "Mo": "Santa Fe (5-Türer) SUV | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2003,
    "Mo": "Santa Fe (5-Türer) SUV | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2004,
    "Mo": "Santa Fe (5-Türer) SUV | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "Santa Fe (5-Türer) SUV MX5 | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "Santa Fe (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2026,
    "Mo": "Santa Fe (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2005,
    "Mo": "Santa Fe (5-Türer) SUV | 2005-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2006,
    "Mo": "Santa Fe (5-Türer) SUV | 2005-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 1998,
    "Mo": "Santamo (5-Türer) Kombi | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 1999,
    "Mo": "Santamo (5-Türer) Kombi | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2000,
    "Mo": "Santamo (5-Türer) Kombi | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2001,
    "Mo": "Santamo (5-Türer) Kombi | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2002,
    "Mo": "Santamo (5-Türer) Kombi | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2001,
    "Mo": "Terracan (5-Türer) SUV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2002,
    "Mo": "Terracan (5-Türer) SUV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2003,
    "Mo": "Terracan (5-Türer) SUV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2004,
    "Mo": "Terracan (5-Türer) SUV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2005,
    "Mo": "Terracan (5-Türer) SUV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2006,
    "Mo": "Terracan (5-Türer) SUV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2007,
    "Mo": "Terracan (5-Türer) SUV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2000,
    "Mo": "Trajet (5-Türer) MPV | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2001,
    "Mo": "Trajet (5-Türer) MPV | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2002,
    "Mo": "Trajet (5-Türer) MPV | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2003,
    "Mo": "Trajet (5-Türer) MPV | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2004,
    "Mo": "Trajet (5-Türer) MPV 1st Generation | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2004,
    "Mo": "Trajet (5-Türer) MPV 1st Generation Facelift | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2005,
    "Mo": "Trajet (5-Türer) MPV | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2006,
    "Mo": "Trajet (5-Türer) MPV | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2007,
    "Mo": "Trajet (5-Türer) MPV | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2008,
    "Mo": "Trajet (5-Türer) MPV | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2005,
    "Mo": "Tucson (5-Türer) Kombi | 2005-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2006,
    "Mo": "Tucson (5-Türer) Kombi | 2005-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2007,
    "Mo": "Tucson (5-Türer) Kombi | 2005-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2008,
    "Mo": "Tucson (5-Türer) Kombi | 2005-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2009,
    "Mo": "Tucson (5-Türer) Kombi | 2005-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2010,
    "Mo": "Tucson (5-Türer) Kombi | 2005-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 1996,
    "Mo": "Baleno Wagon (5-Türer) Kombi | 1996-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 1997,
    "Mo": "Baleno Wagon (5-Türer) Kombi | 1996-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 1998,
    "Mo": "Baleno Wagon (5-Türer) Kombi EG | 1996-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 1998,
    "Mo": "Baleno Wagon (5-Türer) Kombi EG 1st Facelift | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 1999,
    "Mo": "Baleno Wagon (5-Türer) Kombi | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2000,
    "Mo": "Baleno Wagon (5-Türer) Kombi | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2001,
    "Mo": "Baleno Wagon (5-Türer) Kombi EG 1st Facelift | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2001,
    "Mo": "Baleno Wagon (5-Türer) Kombi EG 2nd Facelift | 2001-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2002,
    "Mo": "Baleno Wagon (5-Türer) Kombi | 2001-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2001,
    "Mo": "Grand Vitara (5-Türer) SUV | 2001-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2002,
    "Mo": "Grand Vitara (5-Türer) SUV | 2001-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2003,
    "Mo": "Grand Vitara (5-Türer) SUV | 2001-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2004,
    "Mo": "Grand Vitara (5-Türer) SUV | 2001-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2005,
    "Mo": "Grand Vitara (5-Türer) SUV FT/GT 2nd Facelift | 2001-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2000,
    "Mo": "Ignis (5-Türer) Schrägheck | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2001,
    "Mo": "Ignis (5-Türer) Schrägheck | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2002,
    "Mo": "Ignis (5-Türer) Schrägheck | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2003,
    "Mo": "Ignis (5-Türer) Schrägheck FH | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2004,
    "Mo": "Ignis (5-Türer) Schrägheck FH | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2003,
    "Mo": "Ignis (5-Türer) Schrägheck MH | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2004,
    "Mo": "Ignis (5-Türer) Schrägheck MH | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2005,
    "Mo": "Ignis (5-Türer) Schrägheck | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2006,
    "Mo": "Ignis (5-Türer) Schrägheck | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2007,
    "Mo": "Ignis (5-Türer) Schrägheck | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2008,
    "Mo": "Ignis (5-Türer) Schrägheck | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2016,
    "Mo": "Ignis (5-Türer) Schrägheck | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2017,
    "Mo": "Ignis (5-Türer) Schrägheck | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2018,
    "Mo": "Ignis (5-Türer) Schrägheck | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2019,
    "Mo": "Ignis (5-Türer) Schrägheck | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2020,
    "Mo": "Ignis (5-Türer) Schrägheck | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2006,
    "Mo": "SX4 Streetline (5-Türer) Schrägheck | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2007,
    "Mo": "SX4 Streetline (5-Türer) Schrägheck | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2008,
    "Mo": "SX4 Streetline (5-Türer) Schrägheck | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2009,
    "Mo": "SX4 Streetline (5-Türer) Schrägheck | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2010,
    "Mo": "SX4 Streetline (5-Türer) Schrägheck EY/GY | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2010,
    "Mo": "SX4 Streetline (5-Türer) Schrägheck EY/GY Facelift | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2011,
    "Mo": "SX4 Streetline (5-Türer) Schrägheck | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2012,
    "Mo": "SX4 Streetline (5-Türer) Schrägheck | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2013,
    "Mo": "SX4 Streetline (5-Türer) Schrägheck | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2014,
    "Mo": "SX4 Streetline (5-Türer) Schrägheck | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2007,
    "Mo": "XL7 7-seater (5-Türer) SUV | 2007-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2008,
    "Mo": "XL7 7-seater (5-Türer) SUV | 2007-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2009,
    "Mo": "XL7 7-seater (5-Türer) SUV | 2007-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2001,
    "Mo": "XL7 7-seater (5-Türer) SUV | 2001-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2002,
    "Mo": "XL7 7-seater (5-Türer) SUV | 2001-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2019,
    "Mo": "eK X (B30W) (5-Türer) Schrägheck | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2020,
    "Mo": "eK X (B30W) (5-Türer) Schrägheck | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2021,
    "Mo": "eK X (B30W) (5-Türer) Schrägheck | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2022,
    "Mo": "eK X (B30W) (5-Türer) Schrägheck | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2023,
    "Mo": "eK X (B30W) (5-Türer) Schrägheck | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2024,
    "Mo": "eK X (B30W) (5-Türer) Schrägheck | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2025,
    "Mo": "eK X (B30W) (5-Türer) Schrägheck | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2026,
    "Mo": "eK X (B30W) (5-Türer) Schrägheck | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2004,
    "Mo": "Endeavor (5-Türer) SUV | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2005,
    "Mo": "Endeavor (5-Türer) SUV | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2006,
    "Mo": "Endeavor (5-Türer) SUV | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2007,
    "Mo": "Endeavor (5-Türer) SUV | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2008,
    "Mo": "Endeavor (5-Türer) SUV | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2009,
    "Mo": "Endeavor (5-Türer) SUV | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2010,
    "Mo": "Endeavor (5-Türer) SUV | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2011,
    "Mo": "Endeavor (5-Türer) SUV | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1999,
    "Mo": "Galant Wagon (EA0W) (5-Türer) Kombi | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2000,
    "Mo": "Galant Wagon (EA0W) (5-Türer) Kombi | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2001,
    "Mo": "Galant Wagon (EA0W) (5-Türer) Kombi | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2002,
    "Mo": "Galant Wagon (EA0W) (5-Türer) Kombi | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2003,
    "Mo": "Galant Wagon (EA0W) (5-Türer) Kombi | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1997,
    "Mo": "Galant Wagon (EA0W) (5-Türer) Kombi | 1997-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1998,
    "Mo": "Galant Wagon (EA0W) (5-Türer) Kombi | 1997-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2004,
    "Mo": "Grandis 7-seater (NA0W) (5-Türer) MPV | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2005,
    "Mo": "Grandis 7-seater (NA0W) (5-Türer) MPV | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2006,
    "Mo": "Grandis 7-seater (NA0W) (5-Türer) MPV | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2007,
    "Mo": "Grandis 7-seater (NA0W) (5-Türer) MPV | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2008,
    "Mo": "Grandis 7-seater (NA0W) (5-Türer) MPV | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2009,
    "Mo": "Grandis 7-seater (NA0W) (5-Türer) MPV | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2010,
    "Mo": "Grandis 7-seater (NA0W) (5-Türer) MPV | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1993,
    "Mo": "Lancer Station Wagon (CB0W/CD0W) (5-Türer) Kombi | 1993-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1994,
    "Mo": "Lancer Station Wagon (CB0W/CD0W) (5-Türer) Kombi | 1993-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1995,
    "Mo": "Lancer Station Wagon (CB0W/CD0W) (5-Türer) Kombi | 1993-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1996,
    "Mo": "Lancer Station Wagon (CB0W/CD0W) (5-Türer) Kombi | 1993-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2010,
    "Mo": "Outlander 5-seater (CW0W) (5-Türer) SUV | 2010-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2011,
    "Mo": "Outlander 5-seater (CW0W) (5-Türer) SUV | 2010-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2012,
    "Mo": "Outlander 5-seater (CW0W) (5-Türer) SUV | 2010-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2007,
    "Mo": "Outlander 5-seater (CW0W) (5-Türer) SUV | 2007-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2008,
    "Mo": "Outlander 5-seater (CW0W) (5-Türer) SUV | 2007-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2009,
    "Mo": "Outlander 5-seater (CW0W) (5-Türer) SUV | 2007-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2000,
    "Mo": "Pajero (3-Türer) SUV V60 | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2001,
    "Mo": "Pajero (3-Türer) SUV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2002,
    "Mo": "Pajero (3-Türer) SUV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2003,
    "Mo": "Pajero (3-Türer) SUV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2004,
    "Mo": "Pajero (3-Türer) SUV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2005,
    "Mo": "Pajero (3-Türer) SUV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2006,
    "Mo": "Pajero (3-Türer) SUV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2007,
    "Mo": "Pajero (3-Türer) SUV V60 | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1991,
    "Mo": "Pajero (3-Türer) SUV | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1992,
    "Mo": "Pajero (3-Türer) SUV | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1993,
    "Mo": "Pajero (3-Türer) SUV | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1994,
    "Mo": "Pajero (3-Türer) SUV | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1995,
    "Mo": "Pajero (3-Türer) SUV | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1996,
    "Mo": "Pajero (3-Türer) SUV | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1997,
    "Mo": "Pajero (3-Türer) SUV | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1998,
    "Mo": "Pajero (3-Türer) SUV | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1999,
    "Mo": "Pajero (3-Türer) SUV | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2000,
    "Mo": "Pajero (3-Türer) SUV V20 | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2000,
    "Mo": "Pajero (3-Türer) SUV V60 | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2001,
    "Mo": "Pajero (3-Türer) SUV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2002,
    "Mo": "Pajero (3-Türer) SUV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2003,
    "Mo": "Pajero (3-Türer) SUV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2004,
    "Mo": "Pajero (3-Türer) SUV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2005,
    "Mo": "Pajero (3-Türer) SUV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2006,
    "Mo": "Pajero (3-Türer) SUV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2007,
    "Mo": "Pajero (3-Türer) SUV V60 | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2012,
    "Mo": "Pajero (3-Türer) SUV V80 1st Facelift | 2012-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2013,
    "Mo": "Pajero (3-Türer) SUV | 2012-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2014,
    "Mo": "Pajero (3-Türer) SUV | 2012-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2007,
    "Mo": "Pajero (3-Türer) SUV V80 | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2008,
    "Mo": "Pajero (3-Türer) SUV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2009,
    "Mo": "Pajero (3-Türer) SUV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2010,
    "Mo": "Pajero (3-Türer) SUV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2011,
    "Mo": "Pajero (3-Türer) SUV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2012,
    "Mo": "Pajero (3-Türer) SUV V80 | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2015,
    "Mo": "Pajero (3-Türer) SUV | 2015-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2016,
    "Mo": "Pajero (3-Türer) SUV | 2015-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2017,
    "Mo": "Pajero (3-Türer) SUV | 2015-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2018,
    "Mo": "Pajero (3-Türer) SUV | 2015-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2019,
    "Mo": "Pajero (3-Türer) SUV | 2015-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2020,
    "Mo": "Pajero (3-Türer) SUV | 2015-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2021,
    "Mo": "Pajero (3-Türer) SUV | 2015-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2000,
    "Mo": "Pajero (5-Türer) SUV V60 | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2001,
    "Mo": "Pajero (5-Türer) SUV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2002,
    "Mo": "Pajero (5-Türer) SUV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2003,
    "Mo": "Pajero (5-Türer) SUV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2004,
    "Mo": "Pajero (5-Türer) SUV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2005,
    "Mo": "Pajero (5-Türer) SUV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2006,
    "Mo": "Pajero (5-Türer) SUV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2007,
    "Mo": "Pajero (5-Türer) SUV V60 | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1991,
    "Mo": "Pajero (5-Türer) SUV | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1992,
    "Mo": "Pajero (5-Türer) SUV | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1993,
    "Mo": "Pajero (5-Türer) SUV | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1994,
    "Mo": "Pajero (5-Türer) SUV | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1995,
    "Mo": "Pajero (5-Türer) SUV | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1996,
    "Mo": "Pajero (5-Türer) SUV | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1997,
    "Mo": "Pajero (5-Türer) SUV | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1998,
    "Mo": "Pajero (5-Türer) SUV | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1999,
    "Mo": "Pajero (5-Türer) SUV | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2000,
    "Mo": "Pajero (5-Türer) SUV V20 | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2000,
    "Mo": "Pajero (5-Türer) SUV V60 | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2001,
    "Mo": "Pajero (5-Türer) SUV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2002,
    "Mo": "Pajero (5-Türer) SUV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2003,
    "Mo": "Pajero (5-Türer) SUV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2004,
    "Mo": "Pajero (5-Türer) SUV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2005,
    "Mo": "Pajero (5-Türer) SUV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2006,
    "Mo": "Pajero (5-Türer) SUV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2007,
    "Mo": "Pajero (5-Türer) SUV V60 | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2015,
    "Mo": "Pajero (5-Türer) SUV | 2015-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2016,
    "Mo": "Pajero (5-Türer) SUV | 2015-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2017,
    "Mo": "Pajero (5-Türer) SUV | 2015-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2018,
    "Mo": "Pajero (5-Türer) SUV | 2015-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2019,
    "Mo": "Pajero (5-Türer) SUV | 2015-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2020,
    "Mo": "Pajero (5-Türer) SUV | 2015-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2021,
    "Mo": "Pajero (5-Türer) SUV | 2015-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2012,
    "Mo": "Pajero (5-Türer) SUV V80 1st Facelift | 2012-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2013,
    "Mo": "Pajero (5-Türer) SUV | 2012-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2014,
    "Mo": "Pajero (5-Türer) SUV | 2012-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2007,
    "Mo": "Pajero (5-Türer) SUV V80 | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2008,
    "Mo": "Pajero (5-Türer) SUV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2009,
    "Mo": "Pajero (5-Türer) SUV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2010,
    "Mo": "Pajero (5-Türer) SUV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2011,
    "Mo": "Pajero (5-Türer) SUV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2012,
    "Mo": "Pajero (5-Türer) SUV V80 | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2015,
    "Mo": "Pajero (5-Türer) SUV | 2015-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2016,
    "Mo": "Pajero (5-Türer) SUV | 2015-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2017,
    "Mo": "Pajero (5-Türer) SUV | 2015-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2018,
    "Mo": "Pajero (5-Türer) SUV | 2015-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2019,
    "Mo": "Pajero (5-Türer) SUV | 2015-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2020,
    "Mo": "Pajero (5-Türer) SUV | 2015-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2021,
    "Mo": "Pajero (5-Türer) SUV | 2015-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2012,
    "Mo": "Pajero (5-Türer) SUV V80 1st Facelift | 2012-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2013,
    "Mo": "Pajero (5-Türer) SUV | 2012-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2014,
    "Mo": "Pajero (5-Türer) SUV | 2012-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1998,
    "Mo": "Pajero Pinin (5-Türer) Kombi | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1999,
    "Mo": "Pajero Pinin (5-Türer) Kombi | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2000,
    "Mo": "Pajero Pinin (5-Türer) Kombi | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2001,
    "Mo": "Pajero Pinin (5-Türer) Kombi | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2002,
    "Mo": "Pajero Pinin (5-Türer) Kombi | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2003,
    "Mo": "Pajero Pinin (5-Türer) Kombi | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2004,
    "Mo": "Pajero Pinin (5-Türer) Kombi | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2005,
    "Mo": "Pajero Pinin (5-Türer) Kombi | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2006,
    "Mo": "Pajero Pinin (5-Türer) Kombi | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2007,
    "Mo": "Pajero Pinin (5-Türer) Kombi | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2000,
    "Mo": "Pajero Sport (K90W) (5-Türer) SUV | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2001,
    "Mo": "Pajero Sport (K90W) (5-Türer) SUV | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2002,
    "Mo": "Pajero Sport (K90W) (5-Türer) SUV | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2003,
    "Mo": "Pajero Sport (K90W) (5-Türer) SUV | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2004,
    "Mo": "Pajero Sport (K90W) (5-Türer) SUV | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1999,
    "Mo": "Pajero Sport (K90W) (5-Türer) SUV | 1999-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2008,
    "Mo": "Pajero Sport (KH0W) (5-Türer) SUV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2009,
    "Mo": "Pajero Sport (KH0W) (5-Türer) SUV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2010,
    "Mo": "Pajero Sport (KH0W) (5-Türer) SUV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2011,
    "Mo": "Pajero Sport (KH0W) (5-Türer) SUV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2012,
    "Mo": "Pajero Sport (KH0W) (5-Türer) SUV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2013,
    "Mo": "Pajero Sport (KH0W) (5-Türer) SUV | 2013-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2014,
    "Mo": "Pajero Sport (KH0W) (5-Türer) SUV | 2013-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2015,
    "Mo": "Pajero Sport (KH0W) (5-Türer) SUV | 2013-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1993,
    "Mo": "Sigma Kombi (5-Türer) Kombi | 1993-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1994,
    "Mo": "Sigma Kombi (5-Türer) Kombi | 1993-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1995,
    "Mo": "Sigma Kombi (5-Türer) Kombi | 1993-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1996,
    "Mo": "Sigma Kombi (5-Türer) Kombi | 1993-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1991,
    "Mo": "Space Runner (4-Türer) Kombi | 1991-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1992,
    "Mo": "Space Runner (4-Türer) Kombi | 1991-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1993,
    "Mo": "Space Runner (4-Türer) Kombi | 1991-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1994,
    "Mo": "Space Runner (4-Türer) Kombi | 1991-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1995,
    "Mo": "Space Runner (4-Türer) Kombi | 1991-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1996,
    "Mo": "Space Runner (4-Türer) Kombi | 1991-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1997,
    "Mo": "Space Runner (4-Türer) Kombi N1 | 1991-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1998,
    "Mo": "Space Runner (4-Türer) Kombi N1 | 1991-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1997,
    "Mo": "Space Runner (4-Türer) Kombi N6 | 1997-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1998,
    "Mo": "Space Runner (4-Türer) Kombi N6 | 1997-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1999,
    "Mo": "Space Runner (4-Türer) Kombi | 1997-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2000,
    "Mo": "Space Runner (4-Türer) Kombi | 1997-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2001,
    "Mo": "Space Runner (4-Türer) Kombi | 1997-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2002,
    "Mo": "Space Runner (4-Türer) Kombi | 1997-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1998,
    "Mo": "Space Star (5-Türer) Schrägheck | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1999,
    "Mo": "Space Star (5-Türer) Schrägheck | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2000,
    "Mo": "Space Star (5-Türer) Schrägheck | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2001,
    "Mo": "Space Star (5-Türer) Schrägheck | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2002,
    "Mo": "Space Star (5-Türer) Schrägheck | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2003,
    "Mo": "Space Star (5-Türer) Schrägheck | 2003-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2004,
    "Mo": "Space Star (5-Türer) Schrägheck | 2003-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2005,
    "Mo": "Space Star (5-Türer) Schrägheck | 2003-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1992,
    "Mo": "Space Wagon 7-seater (N30W/N40W) (5-Türer) MPV | 1992-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1993,
    "Mo": "Space Wagon 7-seater (N30W/N40W) (5-Türer) MPV | 1992-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1994,
    "Mo": "Space Wagon 7-seater (N30W/N40W) (5-Türer) MPV | 1992-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1995,
    "Mo": "Space Wagon 7-seater (N30W/N40W) (5-Türer) MPV | 1995-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1996,
    "Mo": "Space Wagon 7-seater (N30W/N40W) (5-Türer) MPV | 1995-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1997,
    "Mo": "Space Wagon 7-seater (N30W/N40W) (5-Türer) MPV | 1995-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1998,
    "Mo": "Space Wagon 7-seater (N30W/N40W) (5-Türer) MPV | 1995-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1999,
    "Mo": "Space Wagon 7-seater (N80W/N90W) (5-Türer) MPV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2000,
    "Mo": "Space Wagon 7-seater (N80W/N90W) (5-Türer) MPV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2001,
    "Mo": "Space Wagon 7-seater (N80W/N90W) (5-Türer) MPV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2002,
    "Mo": "Space Wagon 7-seater (N80W/N90W) (5-Türer) MPV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2003,
    "Mo": "Space Wagon 7-seater (N80W/N90W) (5-Türer) MPV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2004,
    "Mo": "Space Wagon 7-seater (N80W/N90W) (5-Türer) MPV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1994,
    "Mo": "Accord Wagon (5-Türer) Kombi | 1994-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1995,
    "Mo": "Accord Wagon (5-Türer) Kombi | 1994-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1996,
    "Mo": "Accord Wagon (5-Türer) Kombi | 1994-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1997,
    "Mo": "Accord Wagon (5-Türer) Kombi | 1994-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2009,
    "Mo": "Accord Wagon (5-Türer) Kombi | 2009-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2010,
    "Mo": "Accord Wagon (5-Türer) Kombi | 2009-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2011,
    "Mo": "Accord Wagon (5-Türer) Kombi | 2009-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2012,
    "Mo": "Accord Wagon (5-Türer) Kombi | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2013,
    "Mo": "Accord Wagon (5-Türer) Kombi | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2014,
    "Mo": "Accord Wagon (5-Türer) Kombi | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2015,
    "Mo": "Accord Wagon (5-Türer) Kombi | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2006,
    "Mo": "Accord Wagon (5-Türer) Kombi | 2006-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2007,
    "Mo": "Accord Wagon (5-Türer) Kombi | 2006-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2008,
    "Mo": "Accord Wagon (5-Türer) Kombi | 2006-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2003,
    "Mo": "Accord Wagon (5-Türer) Kombi | 2003-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2004,
    "Mo": "Accord Wagon (5-Türer) Kombi | 2003-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2005,
    "Mo": "Accord Wagon (5-Türer) Kombi | 2003-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1998,
    "Mo": "Civic Wagon (MB) (5-Türer) Kombi | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1999,
    "Mo": "Civic Wagon (MB) (5-Türer) Kombi | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2000,
    "Mo": "Civic Wagon (MB) (5-Türer) Kombi | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2001,
    "Mo": "Civic Wagon (MB) (5-Türer) Kombi | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1999,
    "Mo": "CR-V (5-Türer) SUV | 1999-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2000,
    "Mo": "CR-V (5-Türer) SUV | 1999-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2001,
    "Mo": "CR-V (5-Türer) SUV | 1999-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2005,
    "Mo": "FR-V (5-Türer) MPV | 2005-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2006,
    "Mo": "FR-V (5-Türer) MPV | 2005-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2007,
    "Mo": "FR-V (5-Türer) MPV BE | 2005-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2007,
    "Mo": "FR-V (5-Türer) MPV BE Facelift | 2007-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2008,
    "Mo": "FR-V (5-Türer) MPV | 2007-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2009,
    "Mo": "FR-V (5-Türer) MPV | 2007-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2025,
    "Mo": "HR-V (5-Türer) SUV | 2025-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2026,
    "Mo": "HR-V (5-Türer) SUV | 2025-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2021,
    "Mo": "HR-V (5-Türer) SUV 3rd Generation | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2022,
    "Mo": "HR-V (5-Türer) SUV 3rd Generation | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2023,
    "Mo": "HR-V (5-Türer) SUV | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2024,
    "Mo": "HR-V (5-Türer) SUV | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2020,
    "Mo": "Jazz Crosstar (5-Türer) Schrägheck | 2020-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2021,
    "Mo": "Jazz Crosstar (5-Türer) Schrägheck | 2020-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2022,
    "Mo": "Jazz Crosstar (5-Türer) Schrägheck | 2020-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2023,
    "Mo": "Jazz Crosstar (5-Türer) Schrägheck GR/GS | 2020-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2023,
    "Mo": "Jazz Crosstar (5-Türer) Schrägheck GR/GS Facelift | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2024,
    "Mo": "Jazz Crosstar (5-Türer) Schrägheck | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2025,
    "Mo": "Jazz Crosstar (5-Türer) Schrägheck | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2026,
    "Mo": "Jazz Crosstar (5-Türer) Schrägheck | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2004,
    "Mo": "Odyssey (5-Türer) MPV | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2005,
    "Mo": "Odyssey (5-Türer) MPV | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2006,
    "Mo": "Odyssey (5-Türer) MPV | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2007,
    "Mo": "Odyssey (5-Türer) MPV | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2008,
    "Mo": "Odyssey (5-Türer) MPV | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1995,
    "Mo": "Odyssey (5-Türer) MPV | 1995-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1996,
    "Mo": "Odyssey (5-Türer) MPV | 1995-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1997,
    "Mo": "Odyssey (5-Türer) MPV | 1995-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1998,
    "Mo": "Odyssey (5-Türer) MPV | 1995-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1999,
    "Mo": "Odyssey (5-Türer) MPV | 1995-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2006,
    "Mo": "Pilot (5-Türer) SUV | 2006-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2007,
    "Mo": "Pilot (5-Türer) SUV | 2006-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2008,
    "Mo": "Pilot (5-Türer) SUV | 2006-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2003,
    "Mo": "Pilot (5-Türer) SUV | 2003-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2004,
    "Mo": "Pilot (5-Türer) SUV | 2003-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2005,
    "Mo": "Pilot (5-Türer) SUV | 2003-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2009,
    "Mo": "Pilot (5-Türer) SUV | 2009-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2010,
    "Mo": "Pilot (5-Türer) SUV | 2009-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2011,
    "Mo": "Pilot (5-Türer) SUV | 2009-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2012,
    "Mo": "Pilot (5-Türer) SUV | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2013,
    "Mo": "Pilot (5-Türer) SUV | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2014,
    "Mo": "Pilot (5-Türer) SUV | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2015,
    "Mo": "Pilot (5-Türer) SUV | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2005,
    "Mo": "Croma (5-Türer) Schrägheck | 2005-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2006,
    "Mo": "Croma (5-Türer) Schrägheck | 2005-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2007,
    "Mo": "Croma (5-Türer) Schrägheck | 2005-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2008,
    "Mo": "Croma (5-Türer) Schrägheck | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2009,
    "Mo": "Croma (5-Türer) Schrägheck | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Croma (5-Türer) Schrägheck | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Croma (5-Türer) Schrägheck | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Doblò Combi (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Doblò Combi (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Doblò Combi (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Doblò Combi (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Doblò Combi (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Doblò Combi (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Doblò Combi (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Doblò Combi (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Doblò Combi (4-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Doblò Combi (4-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Doblò Combi (4-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Doblò Combi (4-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Doblò Combi (4-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Doblò Combi (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Doblò Combi (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Doblò Combi (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Doblò Combi (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Doblò Combi (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Doblò Combi (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Doblò Combi (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Doblò Combi (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Doblò Combi (4-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Doblò Combi (4-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Doblò Combi (4-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Doblò Combi (4-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Doblò Combi (4-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Doblò Combi Maxi (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Doblò Combi Maxi (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Doblò Combi Maxi (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Doblò Combi Maxi (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Doblò Combi Maxi (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Doblò Combi Maxi (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Doblò Combi Maxi (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Doblò Combi Maxi (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV Typ 263 Facelift | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV Typ 263 Facelift | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Doblò Van 0.7 t (4-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Doblò Van 0.9 t (4-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Doblò Van Maxi (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Doblò Van Maxi (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Doblò Van Maxi (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Doblò Van Maxi (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Doblò Van Maxi (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Doblò Van Maxi (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Doblò Van Maxi (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Doblò Van Maxi (4-Türer) LCV | 2015-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Doblò Van Maxi (4-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Doblò Van Maxi (4-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Doblò Van Maxi (4-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Doblò Van Maxi (4-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Doblò Van Maxi (4-Türer) LCV | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2008,
    "Mo": "Fiorino (3-Türer) LCV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2009,
    "Mo": "Fiorino (3-Türer) LCV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Fiorino (3-Türer) LCV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Fiorino (3-Türer) LCV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Fiorino (3-Türer) LCV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Fiorino (3-Türer) LCV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Fiorino (3-Türer) LCV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Fiorino (3-Türer) LCV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Fiorino (3-Türer) LCV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Fiorino (3-Türer) LCV | 2017-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Fiorino (3-Türer) LCV | 2017-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Fiorino (3-Türer) LCV | 2017-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Fiorino (3-Türer) LCV | 2017-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Fiorino (3-Türer) LCV | 2017-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Fiorino (3-Türer) LCV | 2017-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "Fiorino (3-Türer) LCV | 2017-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Fiorino (3-Türer) LCV | 2017-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2008,
    "Mo": "Qubo (5-Türer) LCV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2009,
    "Mo": "Qubo (5-Türer) LCV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Qubo (5-Türer) LCV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Qubo (5-Türer) LCV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Qubo (5-Türer) LCV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Qubo (5-Türer) LCV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Qubo (5-Türer) LCV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Qubo (5-Türer) LCV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Qubo (5-Türer) LCV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Freemont (5-Türer) SUV | 2011-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Freemont (5-Türer) SUV | 2011-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Freemont (5-Türer) SUV | 2011-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Freemont (5-Türer) SUV | 2011-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Freemont (5-Türer) SUV | 2011-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Freemont (5-Türer) SUV | 2011-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Freemont (5-Türer) SUV | 2011-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Freemont (5-Türer) SUV | 2011-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Freemont (5-Türer) SUV | 2011-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Freemont (5-Türer) SUV | 2011-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Freemont (5-Türer) SUV | 2011-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Freemont (5-Türer) SUV | 2011-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "Freemont (5-Türer) SUV | 2011-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Freemont (5-Türer) SUV | 2011-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Freemont (5-Türer) SUV | 2011-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2026,
    "Mo": "Freemont (5-Türer) SUV | 2011-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Grande Panda (5-Türer) Schrägheck | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Grande Panda (5-Türer) Schrägheck | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2026,
    "Mo": "Grande Panda (5-Türer) Schrägheck | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2004,
    "Mo": "Idea (5-Türer) MPV | 2004-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2005,
    "Mo": "Idea (5-Türer) MPV | 2004-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2006,
    "Mo": "Idea (5-Türer) MPV | 2006-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2007,
    "Mo": "Idea (5-Türer) MPV | 2006-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2008,
    "Mo": "Idea (5-Türer) MPV | 2006-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2009,
    "Mo": "Idea (5-Türer) MPV | 2006-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Idea (5-Türer) MPV | 2006-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Idea (5-Türer) MPV | 2006-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Idea (5-Türer) MPV | 2006-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1997,
    "Mo": "Marea Weekend (5-Türer) Kombi | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1998,
    "Mo": "Marea Weekend (5-Türer) Kombi | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1999,
    "Mo": "Marea Weekend (5-Türer) Kombi | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2000,
    "Mo": "Marea Weekend (5-Türer) Kombi | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2001,
    "Mo": "Marea Weekend (5-Türer) Kombi | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2002,
    "Mo": "Marea Weekend (5-Türer) Kombi | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2003,
    "Mo": "Marea Weekend (5-Türer) Kombi | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2007,
    "Mo": "Palio Weekend (5-Türer) Kombi 178 3rd Facelift | 2007-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2008,
    "Mo": "Palio Weekend (5-Türer) Kombi | 2007-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2009,
    "Mo": "Palio Weekend (5-Türer) Kombi | 2007-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Palio Weekend (5-Türer) Kombi | 2007-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Palio Weekend (5-Türer) Kombi | 2007-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Palio Weekend (5-Türer) Kombi | 2007-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Palio Weekend (5-Türer) Kombi | 2007-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Palio Weekend (5-Türer) Kombi | 2007-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Palio Weekend (5-Türer) Kombi | 2007-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Palio Weekend (5-Türer) Kombi | 2007-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Palio Weekend (5-Türer) Kombi | 2007-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Palio Weekend (5-Türer) Kombi | 2007-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Palio Weekend (5-Türer) Kombi | 2007-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Palio Weekend (5-Türer) Kombi | 2007-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2004,
    "Mo": "Palio Weekend (5-Türer) Kombi 178 2nd Facelift | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2005,
    "Mo": "Palio Weekend (5-Türer) Kombi | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2006,
    "Mo": "Palio Weekend (5-Türer) Kombi | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2007,
    "Mo": "Palio Weekend (5-Türer) Kombi 178 2nd Facelift | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2001,
    "Mo": "Palio Weekend (5-Türer) Kombi 178 1st Facelift | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2002,
    "Mo": "Palio Weekend (5-Türer) Kombi | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2003,
    "Mo": "Palio Weekend (5-Türer) Kombi | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2004,
    "Mo": "Palio Weekend (5-Türer) Kombi 178 1st Facelift | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1997,
    "Mo": "Palio Weekend (5-Türer) Kombi | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1998,
    "Mo": "Palio Weekend (5-Türer) Kombi | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1999,
    "Mo": "Palio Weekend (5-Türer) Kombi | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2000,
    "Mo": "Palio Weekend (5-Türer) Kombi | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2001,
    "Mo": "Palio Weekend (5-Türer) Kombi 178 | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1992,
    "Mo": "Panda (3-Türer) Schrägheck | 1992-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1993,
    "Mo": "Panda (3-Türer) Schrägheck | 1992-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1994,
    "Mo": "Panda (3-Türer) Schrägheck | 1992-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1995,
    "Mo": "Panda (3-Türer) Schrägheck | 1992-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1996,
    "Mo": "Panda (3-Türer) Schrägheck | 1992-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1997,
    "Mo": "Panda (3-Türer) Schrägheck | 1992-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1998,
    "Mo": "Panda (3-Türer) Schrägheck | 1992-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1999,
    "Mo": "Panda (3-Türer) Schrägheck | 1992-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2000,
    "Mo": "Panda (3-Türer) Schrägheck | 1992-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2001,
    "Mo": "Panda (3-Türer) Schrägheck | 1992-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2002,
    "Mo": "Panda (3-Türer) Schrägheck | 1992-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2003,
    "Mo": "Panda (3-Türer) Schrägheck | 1992-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1986,
    "Mo": "Panda (3-Türer) Schrägheck | 1986-1991",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1987,
    "Mo": "Panda (3-Türer) Schrägheck | 1986-1991",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1988,
    "Mo": "Panda (3-Türer) Schrägheck | 1986-1991",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1989,
    "Mo": "Panda (3-Türer) Schrägheck | 1986-1991",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1990,
    "Mo": "Panda (3-Türer) Schrägheck | 1986-1991",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1991,
    "Mo": "Panda (3-Türer) Schrägheck | 1986-1991",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2004,
    "Mo": "Panda (5-Türer) Schrägheck | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2005,
    "Mo": "Panda (5-Türer) Schrägheck | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2006,
    "Mo": "Panda (5-Türer) Schrägheck | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2007,
    "Mo": "Panda (5-Türer) Schrägheck | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2008,
    "Mo": "Panda (5-Türer) Schrägheck | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2009,
    "Mo": "Panda (5-Türer) Schrägheck | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Panda (5-Türer) Schrägheck | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Panda (5-Türer) Schrägheck | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Panda (5-Türer) Schrägheck 169 | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Panda Cross (5-Türer) Crossover | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Panda Cross (5-Türer) Crossover | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Panda Cross (5-Türer) Crossover | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Panda Cross (5-Türer) Crossover | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Panda Cross (5-Türer) Crossover | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Panda Cross (5-Türer) Crossover | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Panda Cross (5-Türer) Crossover | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Panda Cross (5-Türer) Crossover | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Panda Cross (5-Türer) Crossover | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "Panda Cross (5-Türer) Crossover | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Panda Cross (5-Türer) Crossover | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Panda Cross (5-Türer) Crossover | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2026,
    "Mo": "Panda Cross (5-Türer) Crossover | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2002,
    "Mo": "Stilo MultiWagon (5-Türer) Kombi | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2003,
    "Mo": "Stilo MultiWagon (5-Türer) Kombi | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2004,
    "Mo": "Stilo MultiWagon (5-Türer) Kombi | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2005,
    "Mo": "Stilo MultiWagon (5-Türer) Kombi 192 | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2005,
    "Mo": "Stilo MultiWagon (5-Türer) Kombi 192 Facelift | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2006,
    "Mo": "Stilo MultiWagon (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2007,
    "Mo": "Stilo MultiWagon (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2008,
    "Mo": "Stilo MultiWagon (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2005,
    "Mo": "Stilo Uproad (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2006,
    "Mo": "Stilo Uproad (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2007,
    "Mo": "Stilo Uproad (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2008,
    "Mo": "Stilo Uproad (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Strada Adventure (2-Türer) Pickup | 2014-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Strada Adventure (2-Türer) Pickup | 2014-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Strada Adventure (2-Türer) Pickup | 2014-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Strada Adventure (2-Türer) Pickup | 2014-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Strada Adventure (2-Türer) Pickup | 2014-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Strada Adventure (2-Türer) Pickup | 2014-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Strada Adventure (2-Türer) Pickup | 2014-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Strada Adventure (2-Türer) Pickup | 2014-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2004,
    "Mo": "Strada Extended Cab (2-Türer) Pickup | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2005,
    "Mo": "Strada Extended Cab (2-Türer) Pickup | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2006,
    "Mo": "Strada Extended Cab (2-Türer) Pickup | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2007,
    "Mo": "Strada Extended Cab (2-Türer) Pickup | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2008,
    "Mo": "Strada Extended Cab (2-Türer) Pickup | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2009,
    "Mo": "Strada Extended Cab (2-Türer) Pickup | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Strada Extended Cab (2-Türer) Pickup | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Strada Extended Cab (2-Türer) Pickup | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Strada Extended Cab (2-Türer) Pickup | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Strada Extended Cab (2-Türer) Pickup | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Strada Extended Cab (2-Türer) Pickup | 2014-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Strada Extended Cab (2-Türer) Pickup | 2014-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Strada Extended Cab (2-Türer) Pickup | 2014-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Strada Extended Cab (2-Türer) Pickup | 2014-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Strada Extended Cab (2-Türer) Pickup | 2014-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Strada Extended Cab (2-Türer) Pickup | 2014-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Strada Extended Cab (2-Türer) Pickup | 2014-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Strada Extended Cab (2-Türer) Pickup | 2014-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1991,
    "Mo": "Tempra SW (5-Türer) Kombi | 1991-1992",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1992,
    "Mo": "Tempra SW (5-Türer) Kombi | 1991-1992",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1993,
    "Mo": "Tempra SW (5-Türer) Kombi | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1994,
    "Mo": "Tempra SW (5-Türer) Kombi | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1995,
    "Mo": "Tempra SW (5-Türer) Kombi | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1996,
    "Mo": "Tempra SW (5-Türer) Kombi | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1997,
    "Mo": "Tempra SW (5-Türer) Kombi | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2008,
    "Mo": "9-3 SportCombi (5-Türer) Kombi | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2009,
    "Mo": "9-3 SportCombi (5-Türer) Kombi | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2010,
    "Mo": "9-3 SportCombi (5-Türer) Kombi | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2011,
    "Mo": "9-3 SportCombi (5-Türer) Kombi | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2012,
    "Mo": "9-3 SportCombi (5-Türer) Kombi | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2005,
    "Mo": "9-3 SportCombi (5-Türer) Kombi | 2005-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2006,
    "Mo": "9-3 SportCombi (5-Türer) Kombi | 2005-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2007,
    "Mo": "9-3 SportCombi (5-Türer) Kombi | 2005-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2011,
    "Mo": "9-4X (4-Türer) Crossover | 2011-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2012,
    "Mo": "9-4X (4-Türer) Crossover | 2011-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2006,
    "Mo": "9-5 SportCombi (5-Türer) Kombi | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2007,
    "Mo": "9-5 SportCombi (5-Türer) Kombi | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2008,
    "Mo": "9-5 SportCombi (5-Türer) Kombi | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2009,
    "Mo": "9-5 SportCombi (5-Türer) Kombi | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2010,
    "Mo": "9-5 SportCombi (5-Türer) Kombi | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 1998,
    "Mo": "9-5 SportCombi (5-Türer) Kombi | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 1999,
    "Mo": "9-5 SportCombi (5-Türer) Kombi | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2000,
    "Mo": "9-5 SportCombi (5-Türer) Kombi | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2001,
    "Mo": "9-5 SportCombi (5-Türer) Kombi | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2002,
    "Mo": "9-5 SportCombi (5-Türer) Kombi | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2003,
    "Mo": "9-5 SportCombi (5-Türer) Kombi | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2004,
    "Mo": "9-5 SportCombi (5-Türer) Kombi | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2005,
    "Mo": "9-5 SportCombi (5-Türer) Kombi | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2005,
    "Mo": "9-7X (4-Türer) SUV | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2006,
    "Mo": "9-7X (4-Türer) SUV | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2007,
    "Mo": "9-7X (4-Türer) SUV | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2008,
    "Mo": "9-7X (4-Türer) SUV | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2009,
    "Mo": "9-7X (4-Türer) SUV | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2001,
    "Mo": "Alhambra (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2002,
    "Mo": "Alhambra (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2003,
    "Mo": "Alhambra (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2004,
    "Mo": "Alhambra (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2005,
    "Mo": "Alhambra (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2006,
    "Mo": "Alhambra (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2007,
    "Mo": "Alhambra (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2008,
    "Mo": "Alhambra (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2009,
    "Mo": "Alhambra (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2010,
    "Mo": "Alhambra (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 1996,
    "Mo": "Alhambra (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 1997,
    "Mo": "Alhambra (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 1998,
    "Mo": "Alhambra (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 1999,
    "Mo": "Alhambra (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2000,
    "Mo": "Alhambra (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2016,
    "Mo": "Alhambra (5-Türer) MPV | 2016-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2017,
    "Mo": "Alhambra (5-Türer) MPV | 2016-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2018,
    "Mo": "Alhambra (5-Türer) MPV | 2016-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2019,
    "Mo": "Alhambra (5-Türer) MPV | 2016-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2020,
    "Mo": "Alhambra (5-Türer) MPV | 2016-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2021,
    "Mo": "Alhambra (5-Türer) MPV | 2016-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2022,
    "Mo": "Alhambra (5-Türer) MPV | 2016-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2011,
    "Mo": "Alhambra (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2012,
    "Mo": "Alhambra (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2013,
    "Mo": "Alhambra (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2014,
    "Mo": "Alhambra (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2015,
    "Mo": "Alhambra (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2001,
    "Mo": "Alhambra 7-Seater (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2002,
    "Mo": "Alhambra 7-Seater (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2003,
    "Mo": "Alhambra 7-Seater (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2004,
    "Mo": "Alhambra 7-Seater (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2005,
    "Mo": "Alhambra 7-Seater (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2006,
    "Mo": "Alhambra 7-Seater (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2007,
    "Mo": "Alhambra 7-Seater (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2008,
    "Mo": "Alhambra 7-Seater (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2009,
    "Mo": "Alhambra 7-Seater (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2010,
    "Mo": "Alhambra 7-Seater (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 1996,
    "Mo": "Alhambra 7-Seater (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 1997,
    "Mo": "Alhambra 7-Seater (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 1998,
    "Mo": "Alhambra 7-Seater (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 1999,
    "Mo": "Alhambra 7-Seater (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2000,
    "Mo": "Alhambra 7-Seater (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2016,
    "Mo": "Alhambra 7-Seater (5-Türer) MPV | 2016-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2017,
    "Mo": "Alhambra 7-Seater (5-Türer) MPV | 2016-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2018,
    "Mo": "Alhambra 7-Seater (5-Türer) MPV | 2016-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2019,
    "Mo": "Alhambra 7-Seater (5-Türer) MPV | 2016-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2020,
    "Mo": "Alhambra 7-Seater (5-Türer) MPV | 2016-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2021,
    "Mo": "Alhambra 7-Seater (5-Türer) MPV | 2016-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2022,
    "Mo": "Alhambra 7-Seater (5-Türer) MPV | 2016-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2011,
    "Mo": "Alhambra 7-Seater (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2012,
    "Mo": "Alhambra 7-Seater (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2013,
    "Mo": "Alhambra 7-Seater (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2014,
    "Mo": "Alhambra 7-Seater (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2015,
    "Mo": "Alhambra 7-Seater (5-Türer) MPV | 2011-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2021,
    "Mo": "Ateca (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2022,
    "Mo": "Ateca (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2023,
    "Mo": "Ateca (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2024,
    "Mo": "Ateca (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2025,
    "Mo": "Ateca (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2026,
    "Mo": "Ateca (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2016,
    "Mo": "Ateca (5-Türer) SUV | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2017,
    "Mo": "Ateca (5-Türer) SUV | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2018,
    "Mo": "Ateca (5-Türer) SUV | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2019,
    "Mo": "Ateca (5-Türer) SUV | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2020,
    "Mo": "Ateca (5-Türer) SUV | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2010,
    "Mo": "Exeo ST (5-Türer) Kombi | 2010-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2011,
    "Mo": "Exeo ST (5-Türer) Kombi | 2010-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2012,
    "Mo": "Exeo ST (5-Türer) Kombi 3R | 2010-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2012,
    "Mo": "Exeo ST (5-Türer) Kombi 3R Facelift | 2012-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2013,
    "Mo": "Exeo ST (5-Türer) Kombi | 2012-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2019,
    "Mo": "Tarraco 5-seater (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2020,
    "Mo": "Tarraco 5-seater (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2021,
    "Mo": "Tarraco 5-seater (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2022,
    "Mo": "Tarraco 5-seater (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2023,
    "Mo": "Tarraco 5-seater (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2024,
    "Mo": "Tarraco 5-seater (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2025,
    "Mo": "Tarraco 5-seater (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2026,
    "Mo": "Tarraco 5-seater (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2019,
    "Mo": "Tarraco 7-seater (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2020,
    "Mo": "Tarraco 7-seater (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2021,
    "Mo": "Tarraco 7-seater (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2022,
    "Mo": "Tarraco 7-seater (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2023,
    "Mo": "Tarraco 7-seater (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2024,
    "Mo": "Tarraco 7-seater (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2025,
    "Mo": "Tarraco 7-seater (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Y": 2026,
    "Mo": "Tarraco 7-seater (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2024,
    "Mo": "Crosstrek (5-Türer) Crossover | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2025,
    "Mo": "Crosstrek (5-Türer) Crossover | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2026,
    "Mo": "Crosstrek (5-Türer) Crossover | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2013,
    "Mo": "Crosstrek (5-Türer) Crossover | 2013-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2014,
    "Mo": "Crosstrek (5-Türer) Crossover | 2013-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2015,
    "Mo": "Crosstrek (5-Türer) Crossover | 2013-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2016,
    "Mo": "Crosstrek (5-Türer) Crossover | 2016-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2017,
    "Mo": "Crosstrek (5-Türer) Crossover | 2016-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2011,
    "Mo": "Forester (5-Türer) SUV | 2011-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2012,
    "Mo": "Forester (5-Türer) SUV | 2011-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2013,
    "Mo": "Forester (5-Türer) SUV SH Facelift | 2011-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2019,
    "Mo": "Forester (5-Türer) SUV SK | 2019-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2020,
    "Mo": "Forester (5-Türer) SUV | 2019-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2021,
    "Mo": "Forester (5-Türer) SUV | 2021-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2022,
    "Mo": "Forester (5-Türer) SUV | 2021-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2023,
    "Mo": "Forester (5-Türer) SUV | 2021-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2024,
    "Mo": "Forester (5-Türer) SUV | 2021-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2025,
    "Mo": "Forester (5-Türer) SUV SK Facelift | 2021-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2008,
    "Mo": "Forester (5-Türer) SUV SH | 2008-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2009,
    "Mo": "Forester (5-Türer) SUV | 2008-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2010,
    "Mo": "Forester (5-Türer) SUV | 2008-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2016,
    "Mo": "Forester (5-Türer) SUV SJ Facelift | 2016-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2017,
    "Mo": "Forester (5-Türer) SUV | 2016-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2018,
    "Mo": "Forester (5-Türer) SUV | 2016-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2019,
    "Mo": "Forester (5-Türer) SUV SJ Facelift | 2016-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2025,
    "Mo": "Forester (5-Türer) SUV SL | 2025-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2026,
    "Mo": "Forester (5-Türer) SUV | 2025-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2013,
    "Mo": "Forester (5-Türer) SUV SJ | 2013-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2014,
    "Mo": "Forester (5-Türer) SUV | 2013-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2015,
    "Mo": "Forester (5-Türer) SUV | 2013-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2016,
    "Mo": "Forester (5-Türer) SUV SJ | 2013-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1993,
    "Mo": "Impreza Kombi (GF) (5-Türer) Kombi | 1993-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1994,
    "Mo": "Impreza Kombi (GF) (5-Türer) Kombi | 1993-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1995,
    "Mo": "Impreza Kombi (GF) (5-Türer) Kombi | 1993-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1996,
    "Mo": "Impreza Kombi (GF) (5-Türer) Kombi | 1993-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1997,
    "Mo": "Impreza Kombi (GF) (5-Türer) Kombi | 1993-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1998,
    "Mo": "Impreza Kombi (GF) (5-Türer) Kombi | 1993-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1999,
    "Mo": "Impreza Kombi (GF) (5-Türer) Kombi | 1993-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2000,
    "Mo": "Impreza Kombi (GF) (5-Türer) Kombi | 1993-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2001,
    "Mo": "Impreza Kombi (GF) (5-Türer) Kombi | 1993-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2006,
    "Mo": "Impreza Kombi (5-Türer) Kombi | 2006-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2007,
    "Mo": "Impreza Kombi (5-Türer) Kombi | 2006-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2001,
    "Mo": "Impreza Kombi (5-Türer) Kombi | 2001-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2002,
    "Mo": "Impreza Kombi (5-Türer) Kombi | 2001-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2004,
    "Mo": "Justy (5-Türer) Schrägheck | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2005,
    "Mo": "Justy (5-Türer) Schrägheck | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2006,
    "Mo": "Justy (5-Türer) Schrägheck | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2007,
    "Mo": "Justy (5-Türer) Schrägheck | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1995,
    "Mo": "Legacy Outback (5-Türer) Kombi | 1995-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1996,
    "Mo": "Legacy Outback (5-Türer) Kombi | 1995-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1997,
    "Mo": "Legacy Outback (5-Türer) Kombi | 1995-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1998,
    "Mo": "Legacy Outback (5-Türer) Kombi | 1995-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1999,
    "Mo": "Legacy Outback (5-Türer) Kombi | 1995-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1999,
    "Mo": "Outback (5-Türer) Kombi | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2000,
    "Mo": "Outback (5-Türer) Kombi | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2001,
    "Mo": "Outback (5-Türer) Kombi | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2002,
    "Mo": "Outback (5-Türer) Kombi | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2003,
    "Mo": "Outback (5-Türer) Kombi | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2004,
    "Mo": "Outback (5-Türer) Kombi BH | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2022,
    "Mo": "Outback (5-Türer) Kombi BT Facelift | 2022-2026",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2023,
    "Mo": "Outback (5-Türer) Kombi BT Facelift | 2022-2026",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2024,
    "Mo": "Outback (5-Türer) Kombi BT Facelift | 2022-2026",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2025,
    "Mo": "Outback (5-Türer) Kombi BT Facelift | 2022-2026",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2026,
    "Mo": "Outback (5-Türer) Kombi | 2022-2026",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2020,
    "Mo": "Outback (5-Türer) Kombi BT | 2020-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2021,
    "Mo": "Outback (5-Türer) Kombi | 2020-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2022,
    "Mo": "Outback (5-Türer) Kombi BT | 2020-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2023,
    "Mo": "Outback (5-Türer) Kombi BT | 2020-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2024,
    "Mo": "Outback (5-Türer) Kombi BT | 2020-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2025,
    "Mo": "Outback (5-Türer) Kombi BT | 2020-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2008,
    "Mo": "Tribeca (5-Türer) SUV | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2009,
    "Mo": "Tribeca (5-Türer) SUV | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2010,
    "Mo": "Tribeca (5-Türer) SUV | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2011,
    "Mo": "Tribeca (5-Türer) SUV | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2012,
    "Mo": "Tribeca (5-Türer) SUV | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2013,
    "Mo": "Tribeca (5-Türer) SUV | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2014,
    "Mo": "Tribeca (5-Türer) SUV | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2012,
    "Mo": "XV (5-Türer) Kombi | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2013,
    "Mo": "XV (5-Türer) Kombi | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2014,
    "Mo": "XV (5-Türer) Kombi | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2015,
    "Mo": "XV (5-Türer) Kombi | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2018,
    "Mo": "XV (5-Türer) Kombi | 2018-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2019,
    "Mo": "XV (5-Türer) Kombi | 2018-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2020,
    "Mo": "XV (5-Türer) Kombi | 2018-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2021,
    "Mo": "XV (5-Türer) Kombi | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2022,
    "Mo": "XV (5-Türer) Kombi | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2023,
    "Mo": "XV (5-Türer) Kombi | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2024,
    "Mo": "XV (5-Türer) Kombi | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2011,
    "Mo": "Cayenne (92A) (5-Türer) SUV | 2011-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2012,
    "Mo": "Cayenne (92A) (5-Türer) SUV | 2011-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2013,
    "Mo": "Cayenne (92A) (5-Türer) SUV | 2011-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2014,
    "Mo": "Cayenne (92A) (5-Türer) SUV | 2011-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2015,
    "Mo": "Cayenne (92A) (5-Türer) SUV | 2015-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2016,
    "Mo": "Cayenne (92A) (5-Türer) SUV | 2015-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2017,
    "Mo": "Cayenne (92A) (5-Türer) SUV | 2015-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2018,
    "Mo": "Cayenne (92A) (5-Türer) SUV | 2015-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2008,
    "Mo": "Cayenne (9PA) (5-Türer) SUV | 2008-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2009,
    "Mo": "Cayenne (9PA) (5-Türer) SUV | 2008-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2010,
    "Mo": "Cayenne (9PA) (5-Türer) SUV | 2008-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2003,
    "Mo": "Cayenne (9PA) (5-Türer) SUV | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2004,
    "Mo": "Cayenne (9PA) (5-Türer) SUV | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2005,
    "Mo": "Cayenne (9PA) (5-Türer) SUV | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2006,
    "Mo": "Cayenne (9PA) (5-Türer) SUV | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2007,
    "Mo": "Cayenne (9PA) (5-Türer) SUV | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2006,
    "Mo": "Clubman (R55) (5-Türer) Kombi | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2007,
    "Mo": "Clubman (R55) (5-Türer) Kombi | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2008,
    "Mo": "Clubman (R55) (5-Türer) Kombi | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2009,
    "Mo": "Clubman (R55) (5-Türer) Kombi | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2010,
    "Mo": "Clubman (R55) (5-Türer) Kombi | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2011,
    "Mo": "Clubman (R55 LCI) (5-Türer) Kombi | 2011-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2012,
    "Mo": "Clubman (R55 LCI) (5-Türer) Kombi | 2011-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2013,
    "Mo": "Clubman (R55 LCI) (5-Türer) Kombi | 2011-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2014,
    "Mo": "Clubman (R55 LCI) (5-Türer) Kombi | 2011-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2013,
    "Mo": "Clubvan (R55 LCI) (3-Türer) LCV | 2013-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2014,
    "Mo": "Clubvan (R55 LCI) (3-Türer) LCV | 2013-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2017,
    "Mo": "Countryman (5-Türer) Crossover | 2017-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2018,
    "Mo": "Countryman (5-Türer) Crossover | 2017-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2019,
    "Mo": "Countryman (5-Türer) Crossover | 2017-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2020,
    "Mo": "Countryman (5-Türer) Crossover | 2017-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2021,
    "Mo": "Countryman (5-Türer) Crossover | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2022,
    "Mo": "Countryman (5-Türer) Crossover | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2023,
    "Mo": "Countryman (5-Türer) Crossover | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Y": 2024,
    "Mo": "Countryman (5-Türer) Crossover F60 LCI | 2021-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 1999,
    "Mo": "Discovery (5-Türer) SUV | 1999-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2000,
    "Mo": "Discovery (5-Türer) SUV | 1999-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2001,
    "Mo": "Discovery (5-Türer) SUV | 1999-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2002,
    "Mo": "Discovery (5-Türer) SUV | 1999-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2003,
    "Mo": "Discovery (5-Türer) SUV | 2003-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2004,
    "Mo": "Discovery (5-Türer) SUV | 2003-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2005,
    "Mo": "Discovery (5-Türer) SUV L318 (Type LT) Facelift | 2003-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2015,
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2016,
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2017,
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2018,
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2019,
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2024,
    "Mo": "Discovery Sport (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2025,
    "Mo": "Discovery Sport (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2026,
    "Mo": "Discovery Sport (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2020,
    "Mo": "Discovery Sport (5-Türer) SUV | 2020-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2021,
    "Mo": "Discovery Sport (5-Türer) SUV | 2020-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2022,
    "Mo": "Discovery Sport (5-Türer) SUV | 2020-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2023,
    "Mo": "Discovery Sport (5-Türer) SUV | 2020-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2013,
    "Mo": "Freelander (5-Türer) SUV L359 (Type LF) 2nd Facelift | 2013-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2014,
    "Mo": "Freelander (5-Türer) SUV | 2013-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2015,
    "Mo": "Freelander (5-Türer) SUV | 2013-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2007,
    "Mo": "Freelander (5-Türer) SUV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2008,
    "Mo": "Freelander (5-Türer) SUV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2009,
    "Mo": "Freelander (5-Türer) SUV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2010,
    "Mo": "Freelander (5-Türer) SUV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2011,
    "Mo": "Freelander (5-Türer) SUV | 2011-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2012,
    "Mo": "Freelander (5-Türer) SUV | 2011-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2013,
    "Mo": "Freelander (5-Türer) SUV L359 (Type LF) 1st Facelift | 2011-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2004,
    "Mo": "Freelander (5-Türer) SUV | 2004-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2005,
    "Mo": "Freelander (5-Türer) SUV | 2004-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2006,
    "Mo": "Freelander (5-Türer) SUV | 2004-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 1998,
    "Mo": "Freelander (5-Türer) SUV | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 1999,
    "Mo": "Freelander (5-Türer) SUV | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2000,
    "Mo": "Freelander (5-Türer) SUV | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2001,
    "Mo": "Freelander (5-Türer) SUV | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2002,
    "Mo": "Freelander (5-Türer) SUV | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2003,
    "Mo": "Freelander (5-Türer) SUV | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 1999,
    "Mo": "Range Rover (5-Türer) SUV | 1999-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2000,
    "Mo": "Range Rover (5-Türer) SUV | 1999-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2001,
    "Mo": "Range Rover (5-Türer) SUV | 1999-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2002,
    "Mo": "Range Rover (5-Türer) SUV | 1999-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2022,
    "Mo": "5 SW EV (5-Türer) Kombi | 2022-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2023,
    "Mo": "5 SW EV (5-Türer) Kombi | 2022-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2024,
    "Mo": "5 SW EV (5-Türer) Kombi | 2022-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2020,
    "Mo": "5 SW EV (5-Türer) Kombi | 2020-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2021,
    "Mo": "5 SW EV (5-Türer) Kombi | 2020-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2015,
    "Mo": "GS (AS21) (5-Türer) SUV | 2015-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2016,
    "Mo": "GS (AS21) (5-Türer) SUV | 2015-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2017,
    "Mo": "GS (AS21) (5-Türer) SUV | 2015-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2018,
    "Mo": "GS (AS21) (5-Türer) SUV | 2015-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2001,
    "Mo": "ZT-T (5-Türer) Kombi | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2002,
    "Mo": "ZT-T (5-Türer) Kombi | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2003,
    "Mo": "ZT-T (5-Türer) Kombi | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2004,
    "Mo": "ZT-T (5-Türer) Kombi | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2005,
    "Mo": "ZT-T (5-Türer) Kombi | 2005-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2013,
    "Mo": "RX (5-Türer) SUV | 2013-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2014,
    "Mo": "RX (5-Türer) SUV | 2013-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2015,
    "Mo": "RX (5-Türer) SUV | 2013-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2003,
    "Mo": "RX (5-Türer) SUV | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2004,
    "Mo": "RX (5-Türer) SUV | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2005,
    "Mo": "RX (5-Türer) SUV | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2006,
    "Mo": "RX (5-Türer) SUV | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2007,
    "Mo": "RX (5-Türer) SUV | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2008,
    "Mo": "RX (5-Türer) SUV | 2008-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2009,
    "Mo": "RX (5-Türer) SUV XU30 Facelift | 2008-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2009,
    "Mo": "RX (5-Türer) SUV AL10 | 2009-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2010,
    "Mo": "RX (5-Türer) SUV | 2009-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2011,
    "Mo": "RX (5-Türer) SUV | 2009-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2012,
    "Mo": "RX (5-Türer) SUV | 2009-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2002,
    "Mo": "Cherokee (5-Türer) SUV | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2003,
    "Mo": "Cherokee (5-Türer) SUV | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2004,
    "Mo": "Cherokee (5-Türer) SUV | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2005,
    "Mo": "Cherokee (5-Türer) SUV | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2006,
    "Mo": "Cherokee (5-Türer) SUV | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2007,
    "Mo": "Cherokee (5-Türer) SUV | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2008,
    "Mo": "Cherokee (5-Türer) SUV | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2009,
    "Mo": "Cherokee (5-Türer) SUV | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2010,
    "Mo": "Cherokee (5-Türer) SUV | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2011,
    "Mo": "Cherokee (5-Türer) SUV | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2012,
    "Mo": "Cherokee (5-Türer) SUV | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2013,
    "Mo": "Cherokee (5-Türer) SUV | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 1993,
    "Mo": "Grand Cherokee (5-Türer) SUV | 1993-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 1994,
    "Mo": "Grand Cherokee (5-Türer) SUV | 1993-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 1995,
    "Mo": "Grand Cherokee (5-Türer) SUV | 1993-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 1996,
    "Mo": "Grand Cherokee (5-Türer) SUV | 1993-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 1997,
    "Mo": "Grand Cherokee (5-Türer) SUV | 1993-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 1998,
    "Mo": "Grand Cherokee (5-Türer) SUV | 1993-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2007,
    "Mo": "Patriot (5-Türer) SUV | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2008,
    "Mo": "Patriot (5-Türer) SUV | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2009,
    "Mo": "Patriot (5-Türer) SUV | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2010,
    "Mo": "Patriot (5-Türer) SUV | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2011,
    "Mo": "Patriot (5-Türer) SUV 1st Generation | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2011,
    "Mo": "Patriot (5-Türer) SUV 1st Generation Facelift | 2011-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2012,
    "Mo": "Patriot (5-Türer) SUV | 2011-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2013,
    "Mo": "Patriot (5-Türer) SUV | 2011-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2014,
    "Mo": "Patriot (5-Türer) SUV | 2011-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2015,
    "Mo": "Patriot (5-Türer) SUV | 2011-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2016,
    "Mo": "Patriot (5-Türer) SUV | 2011-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2017,
    "Mo": "Patriot (5-Türer) SUV | 2011-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2015,
    "Mo": "Renegade (5-Türer) SUV | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2016,
    "Mo": "Renegade (5-Türer) SUV | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2017,
    "Mo": "Renegade (5-Türer) SUV | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2018,
    "Mo": "Renegade (5-Türer) SUV | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2019,
    "Mo": "Renegade (5-Türer) SUV BU | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2019,
    "Mo": "Renegade (5-Türer) SUV BU Facelift | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2020,
    "Mo": "Renegade (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2021,
    "Mo": "Renegade (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2022,
    "Mo": "Renegade (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2023,
    "Mo": "Renegade (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2024,
    "Mo": "Renegade (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2025,
    "Mo": "Renegade (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2026,
    "Mo": "Renegade (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1997,
    "Mo": "111 (5-Türer) Kombi | 1997-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1998,
    "Mo": "111 (5-Türer) Kombi | 1997-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1999,
    "Mo": "111 (5-Türer) Kombi | 1997-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2000,
    "Mo": "111 (5-Türer) Kombi | 1997-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2001,
    "Mo": "111 (5-Türer) Kombi | 1997-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2002,
    "Mo": "111 (5-Türer) Kombi | 1997-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2003,
    "Mo": "111 (5-Türer) Kombi | 1997-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2004,
    "Mo": "111 (5-Türer) Kombi | 1997-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2005,
    "Mo": "111 (5-Türer) Kombi | 1997-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2006,
    "Mo": "111 (5-Türer) Kombi | 1997-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2007,
    "Mo": "111 (5-Türer) Kombi | 1997-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2008,
    "Mo": "111 (5-Türer) Kombi | 1997-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2009,
    "Mo": "111 (5-Türer) Kombi | 1997-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1984,
    "Mo": "2104 (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1985,
    "Mo": "2104 (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1986,
    "Mo": "2104 (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1987,
    "Mo": "2104 (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1988,
    "Mo": "2104 (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1989,
    "Mo": "2104 (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1990,
    "Mo": "2104 (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1991,
    "Mo": "2104 (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1992,
    "Mo": "2104 (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1993,
    "Mo": "2104 (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1994,
    "Mo": "2104 (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1995,
    "Mo": "2104 (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1996,
    "Mo": "2104 (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1997,
    "Mo": "2104 (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1998,
    "Mo": "2104 (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1999,
    "Mo": "2104 (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2000,
    "Mo": "2104 (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2001,
    "Mo": "2104 (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2002,
    "Mo": "2104 (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2003,
    "Mo": "2104 (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2004,
    "Mo": "2104 (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2005,
    "Mo": "2104 (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2006,
    "Mo": "2104 (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2007,
    "Mo": "2104 (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2008,
    "Mo": "2104 (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2009,
    "Mo": "2104 (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2010,
    "Mo": "2104 (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2011,
    "Mo": "2104 (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2012,
    "Mo": "2104 (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2003,
    "Mo": "X-Type Estate (5-Türer) Kombi | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2004,
    "Mo": "X-Type Estate (5-Türer) Kombi | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2005,
    "Mo": "X-Type Estate (5-Türer) Kombi | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2006,
    "Mo": "X-Type Estate (5-Türer) Kombi | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2007,
    "Mo": "X-Type Estate (5-Türer) Kombi | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2008,
    "Mo": "X-Type Estate (5-Türer) Kombi X400 | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2008,
    "Mo": "X-Type Estate (5-Türer) Kombi X400 Facelift | 2008-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2009,
    "Mo": "X-Type Estate (5-Türer) Kombi | 2008-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2010,
    "Mo": "X-Type Estate (5-Türer) Kombi | 2008-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2001,
    "Mo": "Caravan (4-Türer) MPV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2002,
    "Mo": "Caravan (4-Türer) MPV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2003,
    "Mo": "Caravan (4-Türer) MPV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2004,
    "Mo": "Caravan (4-Türer) MPV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2005,
    "Mo": "Caravan (4-Türer) MPV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2006,
    "Mo": "Caravan (4-Türer) MPV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2007,
    "Mo": "Caravan (4-Türer) MPV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2001,
    "Mo": "Grand Caravan (5-Türer) MPV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2002,
    "Mo": "Grand Caravan (5-Türer) MPV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2003,
    "Mo": "Grand Caravan (5-Türer) MPV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2004,
    "Mo": "Grand Caravan (5-Türer) MPV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2005,
    "Mo": "Grand Caravan (5-Türer) MPV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2006,
    "Mo": "Grand Caravan (5-Türer) MPV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2007,
    "Mo": "Grand Caravan (5-Türer) MPV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 1996,
    "Mo": "Grand Caravan (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 1997,
    "Mo": "Grand Caravan (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 1998,
    "Mo": "Grand Caravan (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 1999,
    "Mo": "Grand Caravan (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2000,
    "Mo": "Grand Caravan (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2014,
    "Mo": "Durango (5-Türer) SUV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2015,
    "Mo": "Durango (5-Türer) SUV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2016,
    "Mo": "Durango (5-Türer) SUV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2017,
    "Mo": "Durango (5-Türer) SUV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2018,
    "Mo": "Durango (5-Türer) SUV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2019,
    "Mo": "Durango (5-Türer) SUV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2020,
    "Mo": "Durango (5-Türer) SUV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2021,
    "Mo": "Durango (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2022,
    "Mo": "Durango (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2023,
    "Mo": "Durango (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2024,
    "Mo": "Durango (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2025,
    "Mo": "Durango (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2026,
    "Mo": "Durango (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2011,
    "Mo": "Journey (5-Türer) SUV | 2011-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2012,
    "Mo": "Journey (5-Türer) SUV | 2011-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2013,
    "Mo": "Journey (5-Türer) SUV | 2011-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2014,
    "Mo": "Journey (5-Türer) SUV | 2011-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2015,
    "Mo": "Journey (5-Türer) SUV | 2011-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2016,
    "Mo": "Journey (5-Türer) SUV | 2011-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2017,
    "Mo": "Journey (5-Türer) SUV | 2011-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2018,
    "Mo": "Journey (5-Türer) SUV | 2011-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2019,
    "Mo": "Journey (5-Türer) SUV | 2011-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2020,
    "Mo": "Journey (5-Türer) SUV | 2011-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2009,
    "Mo": "Journey (5-Türer) SUV | 2009-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2010,
    "Mo": "Journey (5-Türer) SUV | 2009-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daihatsu",
    "Y": 2009,
    "Mo": "Terios (5-Türer) MPV J200 Facelift | 2009-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daihatsu",
    "Y": 2010,
    "Mo": "Terios (5-Türer) MPV | 2009-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daihatsu",
    "Y": 2011,
    "Mo": "Terios (5-Türer) MPV | 2009-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daihatsu",
    "Y": 2012,
    "Mo": "Terios (5-Türer) MPV | 2009-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daihatsu",
    "Y": 2013,
    "Mo": "Terios (5-Türer) MPV | 2009-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daihatsu",
    "Y": 2014,
    "Mo": "Terios (5-Türer) MPV | 2009-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daihatsu",
    "Y": 2006,
    "Mo": "Terios (5-Türer) MPV | 2006-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daihatsu",
    "Y": 2007,
    "Mo": "Terios (5-Türer) MPV | 2006-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daihatsu",
    "Y": 2008,
    "Mo": "Terios (5-Türer) MPV | 2006-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daihatsu",
    "Y": 2009,
    "Mo": "Terios (5-Türer) MPV J200 | 2006-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Rover",
    "Y": 2001,
    "Mo": "75 Tourer (5-Türer) Kombi | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Rover",
    "Y": 2002,
    "Mo": "75 Tourer (5-Türer) Kombi | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Rover",
    "Y": 2003,
    "Mo": "75 Tourer (5-Türer) Kombi | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Rover",
    "Y": 2004,
    "Mo": "75 Tourer (5-Türer) Kombi | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Rover",
    "Y": 2005,
    "Mo": "75 Tourer (5-Türer) Kombi | 2005-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Rover",
    "Y": 2004,
    "Mo": "Streetwise (3-Türer) Schrägheck | 2004-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Rover",
    "Y": 2005,
    "Mo": "Streetwise (3-Türer) Schrägheck | 2004-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Rover",
    "Y": 2004,
    "Mo": "Streetwise (5-Türer) Schrägheck | 2004-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Rover",
    "Y": 2005,
    "Mo": "Streetwise (5-Türer) Schrägheck | 2004-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 1996,
    "Mo": "Korando (3-Türer) SUV | 1996-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 1997,
    "Mo": "Korando (3-Türer) SUV | 1996-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 1998,
    "Mo": "Korando (3-Türer) SUV | 1996-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 1999,
    "Mo": "Korando (3-Türer) SUV | 1996-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2000,
    "Mo": "Korando (3-Türer) SUV | 1996-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2001,
    "Mo": "Korando (3-Türer) SUV | 1996-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2002,
    "Mo": "Korando (3-Türer) SUV | 1996-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2003,
    "Mo": "Korando (3-Türer) SUV | 1996-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2004,
    "Mo": "Korando (3-Türer) SUV | 1996-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2005,
    "Mo": "Korando (3-Türer) SUV | 1996-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2006,
    "Mo": "Korando (3-Türer) SUV | 1996-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2011,
    "Mo": "Korando (5-Türer) SUV | 2011-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2012,
    "Mo": "Korando (5-Türer) SUV | 2011-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2013,
    "Mo": "Korando (5-Türer) SUV | 2011-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2014,
    "Mo": "Korando (5-Türer) SUV | 2011-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2015,
    "Mo": "Korando (5-Türer) SUV | 2011-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2016,
    "Mo": "Korando (5-Türer) SUV | 2011-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2017,
    "Mo": "Korando (5-Türer) SUV C200 | 2011-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2017,
    "Mo": "Korando (5-Türer) SUV C200 Facelift | 2017-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2018,
    "Mo": "Korando (5-Türer) SUV | 2017-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2019,
    "Mo": "Korando (5-Türer) SUV C200 Facelift | 2017-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2019,
    "Mo": "Korando (5-Türer) SUV C300 | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2020,
    "Mo": "Korando (5-Türer) SUV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2021,
    "Mo": "Korando (5-Türer) SUV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2022,
    "Mo": "Korando (5-Türer) SUV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2023,
    "Mo": "Korando (5-Türer) SUV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2024,
    "Mo": "Korando (5-Türer) SUV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2005,
    "Mo": "Kyron (5-Türer) Kombi | 2005-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2006,
    "Mo": "Kyron (5-Türer) Kombi | 2005-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2007,
    "Mo": "Kyron (5-Türer) Kombi | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2008,
    "Mo": "Kyron (5-Türer) Kombi | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2009,
    "Mo": "Kyron (5-Türer) Kombi | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2010,
    "Mo": "Kyron (5-Türer) Kombi | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2011,
    "Mo": "Kyron (5-Türer) Kombi | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2012,
    "Mo": "Kyron (5-Türer) Kombi | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2013,
    "Mo": "Kyron (5-Türer) Kombi | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2014,
    "Mo": "Kyron (5-Türer) Kombi | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 1998,
    "Mo": "Musso (4-Türer) Kombi | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 1999,
    "Mo": "Musso (4-Türer) Kombi | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2000,
    "Mo": "Musso (4-Türer) Kombi | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2001,
    "Mo": "Musso (4-Türer) Kombi | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2002,
    "Mo": "Musso (4-Türer) Kombi | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2003,
    "Mo": "Musso (4-Türer) Kombi | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2004,
    "Mo": "Musso (4-Türer) Kombi | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2005,
    "Mo": "Musso (4-Türer) Kombi | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2013,
    "Mo": "Rexton (5-Türer) SUV | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2014,
    "Mo": "Rexton (5-Türer) SUV | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2015,
    "Mo": "Rexton (5-Türer) SUV | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2016,
    "Mo": "Rexton (5-Türer) SUV | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2017,
    "Mo": "Rexton (5-Türer) SUV | 2013-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2003,
    "Mo": "Rexton (5-Türer) SUV | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2004,
    "Mo": "Rexton (5-Türer) SUV | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2005,
    "Mo": "Rexton (5-Türer) SUV | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2006,
    "Mo": "Rexton (5-Türer) SUV | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2007,
    "Mo": "Rexton (5-Türer) SUV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2008,
    "Mo": "Rexton (5-Türer) SUV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2009,
    "Mo": "Rexton (5-Türer) SUV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2010,
    "Mo": "Rexton (5-Türer) SUV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2011,
    "Mo": "Rexton (5-Türer) SUV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2012,
    "Mo": "Rexton (5-Türer) SUV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2018,
    "Mo": "Rexton (5-Türer) SUV | 2018-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2019,
    "Mo": "Rexton (5-Türer) SUV | 2018-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2020,
    "Mo": "Rexton (5-Türer) SUV | 2018-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2021,
    "Mo": "Rexton (5-Türer) SUV | 2018-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2018,
    "Mo": "Rexton Sports (4-Türer) Pickup | 2018-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2019,
    "Mo": "Rexton Sports (4-Türer) Pickup | 2018-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2020,
    "Mo": "Rexton Sports (4-Türer) Pickup | 2018-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2021,
    "Mo": "Rexton Sports (4-Türer) Pickup | 2018-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2016,
    "Mo": "Tivoli XLV (5-Türer) Schrägheck | 2016-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2017,
    "Mo": "Tivoli XLV (5-Türer) Schrägheck | 2016-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2018,
    "Mo": "Tivoli XLV (5-Türer) Schrägheck | 2016-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SsangYong",
    "Y": 2019,
    "Mo": "Tivoli XLV (5-Türer) Schrägheck | 2016-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2006,
    "Mo": "Antara (5-Türer) SUV | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2007,
    "Mo": "Antara (5-Türer) SUV | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2008,
    "Mo": "Antara (5-Türer) SUV | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2009,
    "Mo": "Antara (5-Türer) SUV | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2010,
    "Mo": "Antara (5-Türer) SUV | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2011,
    "Mo": "Antara (5-Türer) SUV | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1998,
    "Mo": "Astra Caravan (5-Türer) Kombi | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1999,
    "Mo": "Astra Caravan (5-Türer) Kombi | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2000,
    "Mo": "Astra Caravan (5-Türer) Kombi | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2001,
    "Mo": "Astra Caravan (5-Türer) Kombi | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2002,
    "Mo": "Astra Caravan (5-Türer) Kombi | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2003,
    "Mo": "Astra Caravan (5-Türer) Kombi | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2004,
    "Mo": "Astra Caravan (5-Türer) Kombi G | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2005,
    "Mo": "Astra Caravan (5-Türer) Kombi G | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2006,
    "Mo": "Astra Caravan (5-Türer) Kombi G | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1999,
    "Mo": "Frontera (5-Türer) SUV | 1999-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2000,
    "Mo": "Frontera (5-Türer) SUV | 1999-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2001,
    "Mo": "Frontera (5-Türer) SUV | 1999-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1992,
    "Mo": "Frontera Sport (2-Türer) SUV | 1992-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1993,
    "Mo": "Frontera Sport (2-Türer) SUV | 1992-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1994,
    "Mo": "Frontera Sport (2-Türer) SUV | 1992-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1995,
    "Mo": "Frontera Sport (2-Türer) SUV | 1992-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1996,
    "Mo": "Frontera Sport (2-Türer) SUV | 1992-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1994,
    "Mo": "Omega Caravan (5-Türer) Kombi | 1994-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1995,
    "Mo": "Omega Caravan (5-Türer) Kombi | 1994-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1996,
    "Mo": "Omega Caravan (5-Türer) Kombi | 1994-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1997,
    "Mo": "Omega Caravan (5-Türer) Kombi | 1994-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1998,
    "Mo": "Omega Caravan (5-Türer) Kombi | 1994-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1999,
    "Mo": "Omega Caravan (5-Türer) Kombi | 1994-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2000,
    "Mo": "Omega Caravan (5-Türer) Kombi | 1994-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2003,
    "Mo": "Zafira (5-Türer) MPV A Facelift | 2003-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2004,
    "Mo": "Zafira (5-Türer) MPV | 2003-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2005,
    "Mo": "Zafira (5-Türer) MPV | 2003-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1999,
    "Mo": "Zafira (5-Türer) MPV | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2000,
    "Mo": "Zafira (5-Türer) MPV | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2001,
    "Mo": "Zafira (5-Türer) MPV | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2002,
    "Mo": "Zafira (5-Türer) MPV | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2003,
    "Mo": "Zafira (5-Türer) MPV A | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercury",
    "Y": 2006,
    "Mo": "Mountaineer (5-Türer) SUV | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercury",
    "Y": 2007,
    "Mo": "Mountaineer (5-Türer) SUV | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercury",
    "Y": 2008,
    "Mo": "Mountaineer (5-Türer) SUV | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercury",
    "Y": 2009,
    "Mo": "Mountaineer (5-Türer) SUV | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercury",
    "Y": 2010,
    "Mo": "Mountaineer (5-Türer) SUV | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercury",
    "Y": 2002,
    "Mo": "Mountaineer (5-Türer) SUV | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercury",
    "Y": 2003,
    "Mo": "Mountaineer (5-Türer) SUV | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercury",
    "Y": 2004,
    "Mo": "Mountaineer (5-Türer) SUV | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercury",
    "Y": 2005,
    "Mo": "Mountaineer (5-Türer) SUV | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2022,
    "Mo": "e-JS4 (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2023,
    "Mo": "e-JS4 (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2024,
    "Mo": "e-JS4 (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2025,
    "Mo": "e-JS4 (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2026,
    "Mo": "e-JS4 (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2013,
    "Mo": "J6 (5-Türer) MPV | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2014,
    "Mo": "J6 (5-Türer) MPV | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2015,
    "Mo": "J6 (5-Türer) MPV | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2016,
    "Mo": "J6 (5-Türer) MPV | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2017,
    "Mo": "J6 (5-Türer) MPV | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2018,
    "Mo": "J6 (5-Türer) MPV | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2019,
    "Mo": "J6 (5-Türer) MPV | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2020,
    "Mo": "J6 (5-Türer) MPV | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2021,
    "Mo": "J6 (5-Türer) MPV | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2022,
    "Mo": "J6 (5-Türer) MPV | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2023,
    "Mo": "J6 (5-Türer) MPV | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2024,
    "Mo": "J6 (5-Türer) MPV | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2025,
    "Mo": "J6 (5-Türer) MPV | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2026,
    "Mo": "J6 (5-Türer) MPV | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2008,
    "Mo": "EX (5-Türer) Schrägheck | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2009,
    "Mo": "EX (5-Türer) Schrägheck | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2010,
    "Mo": "EX (5-Türer) Schrägheck | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2011,
    "Mo": "EX (5-Türer) Schrägheck | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2012,
    "Mo": "EX (5-Türer) Schrägheck | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2013,
    "Mo": "EX (5-Türer) Schrägheck | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2015,
    "Mo": "QX50 (5-Türer) SUV J50 Facelift | 2015-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2016,
    "Mo": "QX50 (5-Türer) SUV | 2015-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2017,
    "Mo": "QX50 (5-Türer) SUV | 2015-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2018,
    "Mo": "QX50 (5-Türer) SUV | 2015-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2014,
    "Mo": "QX50 (5-Türer) SUV | 2014-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2015,
    "Mo": "QX50 (5-Türer) SUV J50 | 2014-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2014,
    "Mo": "QX70 (5-Türer) SUV | 2014-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2015,
    "Mo": "QX70 (5-Türer) SUV | 2014-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2016,
    "Mo": "QX70 (5-Türer) SUV | 2014-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2017,
    "Mo": "QX70 (5-Türer) SUV | 2014-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mahindra",
    "Y": 2002,
    "Mo": "Scorpio (5-Türer) SUV | 2002-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mahindra",
    "Y": 2003,
    "Mo": "Scorpio (5-Türer) SUV | 2002-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mahindra",
    "Y": 2004,
    "Mo": "Scorpio (5-Türer) SUV | 2002-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mahindra",
    "Y": 2005,
    "Mo": "Scorpio (5-Türer) SUV | 2002-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mahindra",
    "Y": 2006,
    "Mo": "Scorpio (5-Türer) SUV | 2002-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mahindra",
    "Y": 2007,
    "Mo": "Scorpio (5-Türer) SUV | 2002-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mahindra",
    "Y": 2008,
    "Mo": "Scorpio (5-Türer) SUV | 2002-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mahindra",
    "Y": 2009,
    "Mo": "Scorpio (5-Türer) SUV | 2002-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mahindra",
    "Y": 2010,
    "Mo": "Scorpio (5-Türer) SUV | 2002-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mahindra",
    "Y": 2011,
    "Mo": "Scorpio (5-Türer) SUV | 2002-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mahindra",
    "Y": 2012,
    "Mo": "Scorpio (5-Türer) SUV | 2002-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mahindra",
    "Y": 2013,
    "Mo": "Scorpio (5-Türer) SUV | 2002-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2007,
    "Mo": "Xenon Double Cab (4-Türer) Pickup | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2008,
    "Mo": "Xenon Double Cab (4-Türer) Pickup | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2009,
    "Mo": "Xenon Double Cab (4-Türer) Pickup | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2010,
    "Mo": "Xenon Double Cab (4-Türer) Pickup | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2011,
    "Mo": "Xenon Double Cab (4-Türer) Pickup | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2012,
    "Mo": "Xenon Double Cab (4-Türer) Pickup | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2013,
    "Mo": "Xenon Double Cab (4-Türer) Pickup | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2014,
    "Mo": "Xenon Double Cab (4-Türer) Pickup | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2015,
    "Mo": "Xenon Double Cab (4-Türer) Pickup | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2016,
    "Mo": "Xenon Double Cab (4-Türer) Pickup | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2017,
    "Mo": "Xenon Double Cab (4-Türer) Pickup | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2018,
    "Mo": "Xenon Double Cab (4-Türer) Pickup | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2019,
    "Mo": "Xenon Double Cab (4-Türer) Pickup | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2020,
    "Mo": "Xenon Double Cab (4-Türer) Pickup | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2021,
    "Mo": "Xenon Double Cab (4-Türer) Pickup | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2022,
    "Mo": "Xenon Double Cab (4-Türer) Pickup | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2023,
    "Mo": "Xenon Double Cab (4-Türer) Pickup | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2024,
    "Mo": "Xenon Double Cab (4-Türer) Pickup | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2025,
    "Mo": "Xenon Double Cab (4-Türer) Pickup | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2026,
    "Mo": "Xenon Double Cab (4-Türer) Pickup | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lancia",
    "Y": 1999,
    "Mo": "Lybra SW (839BX) (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lancia",
    "Y": 2000,
    "Mo": "Lybra SW (839BX) (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lancia",
    "Y": 2001,
    "Mo": "Lybra SW (839BX) (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lancia",
    "Y": 2002,
    "Mo": "Lybra SW (839BX) (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lancia",
    "Y": 2003,
    "Mo": "Lybra SW (839BX) (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lancia",
    "Y": 2004,
    "Mo": "Lybra SW (839BX) (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lancia",
    "Y": 2005,
    "Mo": "Lybra SW (839BX) (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lancia",
    "Y": 2004,
    "Mo": "Musa (5-Türer) MPV | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lancia",
    "Y": 2005,
    "Mo": "Musa (5-Türer) MPV | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lancia",
    "Y": 2006,
    "Mo": "Musa (5-Türer) MPV | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lancia",
    "Y": 2007,
    "Mo": "Musa (5-Türer) MPV | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lancia",
    "Y": 2008,
    "Mo": "Musa (5-Türer) MPV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lancia",
    "Y": 2009,
    "Mo": "Musa (5-Türer) MPV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lancia",
    "Y": 2010,
    "Mo": "Musa (5-Türer) MPV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lancia",
    "Y": 2011,
    "Mo": "Musa (5-Türer) MPV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lancia",
    "Y": 2012,
    "Mo": "Musa (5-Türer) MPV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Amarok DoubleCab 3.3t (4-Türer) Pickup | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Amarok DoubleCab 3.3t (4-Türer) Pickup | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Amarok DoubleCab 3.3t (4-Türer) Pickup | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2026,
    "Mo": "Amarok DoubleCab 3.3t (4-Türer) Pickup | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2005,
    "Mo": "Uplander Cargo Van (4-Türer) LCV | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2006,
    "Mo": "Uplander Cargo Van (4-Türer) LCV | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2007,
    "Mo": "Uplander Cargo Van (4-Türer) LCV | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2008,
    "Mo": "Uplander Cargo Van (4-Türer) LCV | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2009,
    "Mo": "Uplander Cargo Van (4-Türer) LCV | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2005,
    "Mo": "Uplander RWB (4-Türer) MPV | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2006,
    "Mo": "Uplander RWB (4-Türer) MPV | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2007,
    "Mo": "Uplander RWB (4-Türer) MPV | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2008,
    "Mo": "Uplander RWB (4-Türer) MPV | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2009,
    "Mo": "Uplander RWB (4-Türer) MPV | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2005,
    "Mo": "Uplander EWB (4-Türer) MPV | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2006,
    "Mo": "Uplander EWB (4-Türer) MPV | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2007,
    "Mo": "Uplander EWB (4-Türer) MPV | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2008,
    "Mo": "Uplander EWB (4-Türer) MPV | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2009,
    "Mo": "Uplander EWB (4-Türer) MPV | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2015,
    "Mo": "Berlingo Multispace (4-Türer) LCV B9 2nd Facelift | 2015-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "Berlingo Multispace (4-Türer) LCV B9 2nd Facelift | 2015-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2017,
    "Mo": "Berlingo Multispace (4-Türer) LCV | 2015-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2018,
    "Mo": "Berlingo Multispace (4-Türer) LCV | 2015-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2019,
    "Mo": "Berlingo Multispace (4-Türer) LCV | 2015-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2020,
    "Mo": "Berlingo Multispace (4-Türer) LCV | 2015-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "Berlingo Multispace (4-Türer) LCV | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "Berlingo Multispace (4-Türer) LCV | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "Berlingo Multispace (4-Türer) LCV | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2015,
    "Mo": "Berlingo Multispace (4-Türer) LCV B9 1st Facelift | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "Berlingo Multispace (4-Türer) LCV B9 1st Facelift | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2002,
    "Mo": "Berlingo Combi (4-Türer) LCV | 2002-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2003,
    "Mo": "Berlingo Combi (4-Türer) LCV | 2002-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2004,
    "Mo": "Berlingo Combi (4-Türer) LCV | 2002-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2005,
    "Mo": "Berlingo Combi (4-Türer) LCV | 2002-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2006,
    "Mo": "Berlingo Combi (4-Türer) LCV | 2002-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2007,
    "Mo": "Berlingo Combi (4-Türer) LCV | 2002-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2008,
    "Mo": "Berlingo Combi (4-Türer) LCV | 2002-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "Land Cruiser Prado (3-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Land Cruiser Prado (3-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Land Cruiser Prado (3-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Land Cruiser Prado (3-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Land Cruiser Prado (3-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Land Cruiser Prado (3-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Land Cruiser Prado (3-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Land Cruiser Prado (3-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2017,
    "Mo": "ZS SUV (ZS11) (5-Türer) SUV | 2017-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2018,
    "Mo": "ZS SUV (ZS11) (5-Türer) SUV | 2017-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2019,
    "Mo": "ZS SUV (ZS11) (5-Türer) SUV | 2017-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2020,
    "Mo": "ZS SUV (ZS11) (5-Türer) SUV 1st Generation | 2017-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2021,
    "Mo": "ZS SUV (ZS11) (5-Türer) SUV 1st Generation | 2017-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2020,
    "Mo": "ZS SUV (ZS11) (5-Türer) SUV 1st Generation Facelift | 2020-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2021,
    "Mo": "ZS SUV (ZS11) (5-Türer) SUV 1st Generation Facelift | 2020-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2022,
    "Mo": "ZS SUV (ZS11) (5-Türer) SUV | 2020-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2023,
    "Mo": "ZS SUV (ZS11) (5-Türer) SUV | 2020-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2024,
    "Mo": "ZS SUV (ZS11) (5-Türer) SUV | 2020-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2025,
    "Mo": "ZS SUV (ZS11) (5-Türer) SUV | 2020-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2023,
    "Mo": "Avenger (5-Türer) SUV | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2024,
    "Mo": "Avenger (5-Türer) SUV | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2025,
    "Mo": "Avenger (5-Türer) SUV | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2026,
    "Mo": "Avenger (5-Türer) SUV | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2024,
    "Mo": "Duster (5-Türer) SUV P1310 | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2025,
    "Mo": "Duster (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2026,
    "Mo": "Duster (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "T-Class (5-Türer) MPV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "T-Class (5-Türer) MPV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "T-Class (5-Türer) MPV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "T-Class (5-Türer) MPV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2026,
    "Mo": "T-Class (5-Türer) MPV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "Partner Van (4-Türer) LCV S2 1st Facelift | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "Partner Van (4-Türer) LCV | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "Partner Van (4-Türer) LCV | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "Partner Van (4-Türer) LCV S2 1st Facelift | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "Partner Van (4-Türer) LCV S2 2nd Facelift | 2015-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "Partner Van (4-Türer) LCV | 2015-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "Partner Van (4-Türer) LCV | 2015-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "Partner Van (4-Türer) LCV S2 2nd Facelift | 2015-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "Partner Van (4-Türer) LCV S2 2nd Facelift | 2015-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "Partner Van (4-Türer) LCV S2 2nd Facelift | 2015-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "Partner Van (4-Türer) LCV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2009,
    "Mo": "Partner Van (4-Türer) LCV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2010,
    "Mo": "Partner Van (4-Türer) LCV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "Partner Van (4-Türer) LCV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "Partner Van (4-Türer) LCV S2 | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "Partner (5-Türer) LCV S2 2nd Facelift | 2015-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "Partner (5-Türer) LCV | 2015-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "Partner (5-Türer) LCV | 2015-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "Partner (5-Türer) LCV | 2015-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "Partner (5-Türer) LCV | 2015-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "Partner (5-Türer) LCV | 2015-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "Partner (5-Türer) LCV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2009,
    "Mo": "Partner (5-Türer) LCV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2010,
    "Mo": "Partner (5-Türer) LCV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "Partner (5-Türer) LCV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "Partner (5-Türer) LCV S2 | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "Partner (5-Türer) LCV S2 1st Facelift | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "Partner (5-Türer) LCV | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "Partner (5-Türer) LCV | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "Partner (5-Türer) LCV S2 1st Facelift | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1996,
    "Mo": "Vito MPV (W638) (5-Türer) LCV | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1997,
    "Mo": "Vito MPV (W638) (5-Türer) LCV | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1998,
    "Mo": "Vito MPV (W638) (5-Türer) LCV | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1999,
    "Mo": "Vito MPV (W638) (5-Türer) LCV | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2000,
    "Mo": "Vito MPV (W638) (5-Türer) LCV | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2001,
    "Mo": "Vito MPV (W638) (5-Türer) LCV | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2002,
    "Mo": "Vito MPV (W638) (5-Türer) LCV | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2003,
    "Mo": "Vito MPV (W638) (5-Türer) LCV | 1996-2003",
    "c": "a",
    "T": "Yes"
  }
];
